[
  {
    "codigoTse": "00019",
    "ibgeCodigo": 1100106,
    "uf": "RO",
    "nome": "Guajar�-Mirim"
  },
  {
    "codigoTse": "00035",
    "ibgeCodigo": 1100205,
    "uf": "RO",
    "nome": "Porto Velho"
  },
  {
    "codigoTse": "00051",
    "ibgeCodigo": 1100122,
    "uf": "RO",
    "nome": "Ji-Paran�"
  },
  {
    "codigoTse": "00078",
    "ibgeCodigo": 1100023,
    "uf": "RO",
    "nome": "Ariquemes"
  },
  {
    "codigoTse": "00094",
    "ibgeCodigo": 1100049,
    "uf": "RO",
    "nome": "Cacoal"
  },
  {
    "codigoTse": "00116",
    "ibgeCodigo": 1100189,
    "uf": "RO",
    "nome": "Pimenta Bueno"
  },
  {
    "codigoTse": "00132",
    "ibgeCodigo": 1100304,
    "uf": "RO",
    "nome": "Vilhena"
  },
  {
    "codigoTse": "00159",
    "ibgeCodigo": 1100114,
    "uf": "RO",
    "nome": "Jaru"
  },
  {
    "codigoTse": "00175",
    "ibgeCodigo": 1100155,
    "uf": "RO",
    "nome": "Ouro Preto Do Oeste"
  },
  {
    "codigoTse": "00191",
    "ibgeCodigo": 1100254,
    "uf": "RO",
    "nome": "Presidente M�dici"
  },
  {
    "codigoTse": "00213",
    "ibgeCodigo": 1100080,
    "uf": "RO",
    "nome": "Costa Marques"
  },
  {
    "codigoTse": "00230",
    "ibgeCodigo": 1100064,
    "uf": "RO",
    "nome": "Colorado Do Oeste"
  },
  {
    "codigoTse": "00256",
    "ibgeCodigo": 1100098,
    "uf": "RO",
    "nome": "Espig�o D'Oeste"
  },
  {
    "codigoTse": "00272",
    "ibgeCodigo": 1100056,
    "uf": "RO",
    "nome": "Cerejeiras"
  },
  {
    "codigoTse": "00299",
    "ibgeCodigo": 1100288,
    "uf": "RO",
    "nome": "Rolim De Moura"
  },
  {
    "codigoTse": "00310",
    "ibgeCodigo": 1100015,
    "uf": "RO",
    "nome": "Alta Floresta D'Oeste"
  },
  {
    "codigoTse": "00337",
    "ibgeCodigo": 1100346,
    "uf": "RO",
    "nome": "Alvorada D'Oeste"
  },
  {
    "codigoTse": "00353",
    "ibgeCodigo": 1100296,
    "uf": "RO",
    "nome": "Santa Luzia D'Oeste"
  },
  {
    "codigoTse": "00370",
    "ibgeCodigo": 1100148,
    "uf": "RO",
    "nome": "Nova Brasil�ndia D'Oeste"
  },
  {
    "codigoTse": "00396",
    "ibgeCodigo": 1100130,
    "uf": "RO",
    "nome": "Machadinho D'Oeste"
  },
  {
    "codigoTse": "00418",
    "ibgeCodigo": 1100320,
    "uf": "RO",
    "nome": "S�o Miguel Do Guapor�"
  },
  {
    "codigoTse": "00434",
    "ibgeCodigo": 1100338,
    "uf": "RO",
    "nome": "Nova Mamor�"
  },
  {
    "codigoTse": "00450",
    "ibgeCodigo": 1100031,
    "uf": "RO",
    "nome": "Cabixi"
  },
  {
    "codigoTse": "00477",
    "ibgeCodigo": 1100809,
    "uf": "RO",
    "nome": "Candeias Do Jamari"
  },
  {
    "codigoTse": "00493",
    "ibgeCodigo": 1101104,
    "uf": "RO",
    "nome": "Itapu� Do Oeste"
  },
  {
    "codigoTse": "00515",
    "ibgeCodigo": 1100502,
    "uf": "RO",
    "nome": "Novo Horizonte Do Oeste"
  },
  {
    "codigoTse": "00531",
    "ibgeCodigo": 1100908,
    "uf": "RO",
    "nome": "Castanheiras"
  },
  {
    "codigoTse": "00558",
    "ibgeCodigo": 1101807,
    "uf": "RO",
    "nome": "Vale Do Para�so"
  },
  {
    "codigoTse": "00566",
    "ibgeCodigo": 1101708,
    "uf": "RO",
    "nome": "Urup�"
  },
  {
    "codigoTse": "00574",
    "ibgeCodigo": 1101302,
    "uf": "RO",
    "nome": "Mirante Da Serra"
  },
  {
    "codigoTse": "00582",
    "ibgeCodigo": 1101500,
    "uf": "RO",
    "nome": "Seringueiras"
  },
  {
    "codigoTse": "00590",
    "ibgeCodigo": 1101609,
    "uf": "RO",
    "nome": "Theobroma"
  },
  {
    "codigoTse": "00604",
    "ibgeCodigo": 1101203,
    "uf": "RO",
    "nome": "Ministro Andreazza"
  },
  {
    "codigoTse": "00612",
    "ibgeCodigo": 1101005,
    "uf": "RO",
    "nome": "Governador Jorge Teixeira"
  },
  {
    "codigoTse": "00620",
    "ibgeCodigo": 1100601,
    "uf": "RO",
    "nome": "Cacaul�ndia"
  },
  {
    "codigoTse": "00639",
    "ibgeCodigo": 1100403,
    "uf": "RO",
    "nome": "Alto Para�so"
  },
  {
    "codigoTse": "00647",
    "ibgeCodigo": 1100262,
    "uf": "RO",
    "nome": "Rio Crespo"
  },
  {
    "codigoTse": "00655",
    "ibgeCodigo": 1100072,
    "uf": "RO",
    "nome": "Corumbiara"
  },
  {
    "codigoTse": "00663",
    "ibgeCodigo": 1101401,
    "uf": "RO",
    "nome": "Monte Negro"
  },
  {
    "codigoTse": "00671",
    "ibgeCodigo": 1100700,
    "uf": "RO",
    "nome": "Campo Novo De Rond�nia"
  },
  {
    "codigoTse": "00680",
    "ibgeCodigo": 1100940,
    "uf": "RO",
    "nome": "Cujubim"
  },
  {
    "codigoTse": "00698",
    "ibgeCodigo": 1101757,
    "uf": "RO",
    "nome": "Vale Do Anari"
  },
  {
    "codigoTse": "00701",
    "ibgeCodigo": 1101450,
    "uf": "RO",
    "nome": "Parecis"
  },
  {
    "codigoTse": "00710",
    "ibgeCodigo": 1101484,
    "uf": "RO",
    "nome": "S�o Felipe D'Oeste"
  },
  {
    "codigoTse": "00728",
    "ibgeCodigo": 1101476,
    "uf": "RO",
    "nome": "Primavera De Rond�nia"
  },
  {
    "codigoTse": "00736",
    "ibgeCodigo": 1100379,
    "uf": "RO",
    "nome": "Alto Alegre Dos Parecis"
  },
  {
    "codigoTse": "00744",
    "ibgeCodigo": 1101435,
    "uf": "RO",
    "nome": "Nova Uni�o"
  },
  {
    "codigoTse": "00752",
    "ibgeCodigo": 1101559,
    "uf": "RO",
    "nome": "Teixeir�polis"
  },
  {
    "codigoTse": "00779",
    "ibgeCodigo": 1100452,
    "uf": "RO",
    "nome": "Buritis"
  },
  {
    "codigoTse": "00787",
    "ibgeCodigo": 1101468,
    "uf": "RO",
    "nome": "Pimenteiras Do Oeste"
  },
  {
    "codigoTse": "00795",
    "ibgeCodigo": 1101492,
    "uf": "RO",
    "nome": "S�o Francisco Do Guapor�"
  },
  {
    "codigoTse": "00809",
    "ibgeCodigo": 1100924,
    "uf": "RO",
    "nome": "Chupinguaia"
  },
  {
    "codigoTse": "01007",
    "ibgeCodigo": 1200138,
    "uf": "AC",
    "nome": "Bujari"
  },
  {
    "codigoTse": "01015",
    "ibgeCodigo": 1200179,
    "uf": "AC",
    "nome": "Capixaba"
  },
  {
    "codigoTse": "01023",
    "ibgeCodigo": 1200807,
    "uf": "AC",
    "nome": "Porto Acre"
  },
  {
    "codigoTse": "01031",
    "ibgeCodigo": 1200435,
    "uf": "AC",
    "nome": "Santa Rosa Do Purus"
  },
  {
    "codigoTse": "01040",
    "ibgeCodigo": 1200351,
    "uf": "AC",
    "nome": "Marechal Thaumaturgo"
  },
  {
    "codigoTse": "01058",
    "ibgeCodigo": 1200104,
    "uf": "AC",
    "nome": "Brasil�ia"
  },
  {
    "codigoTse": "01066",
    "ibgeCodigo": 1200393,
    "uf": "AC",
    "nome": "Porto Walter"
  },
  {
    "codigoTse": "01074",
    "ibgeCodigo": 1200203,
    "uf": "AC",
    "nome": "Cruzeiro Do Sul"
  },
  {
    "codigoTse": "01082",
    "ibgeCodigo": 1200427,
    "uf": "AC",
    "nome": "Rodrigues Alves"
  },
  {
    "codigoTse": "01090",
    "ibgeCodigo": 1200336,
    "uf": "AC",
    "nome": "M�ncio Lima"
  },
  {
    "codigoTse": "01104",
    "ibgeCodigo": 1200328,
    "uf": "AC",
    "nome": "Jord�o"
  },
  {
    "codigoTse": "01112",
    "ibgeCodigo": 1200252,
    "uf": "AC",
    "nome": "Epitaciol�ndia"
  },
  {
    "codigoTse": "01120",
    "ibgeCodigo": 1200013,
    "uf": "AC",
    "nome": "Acrel�ndia"
  },
  {
    "codigoTse": "01139",
    "ibgeCodigo": 1200302,
    "uf": "AC",
    "nome": "Feij�"
  },
  {
    "codigoTse": "01392",
    "ibgeCodigo": 1200401,
    "uf": "AC",
    "nome": "Rio Branco"
  },
  {
    "codigoTse": "01457",
    "ibgeCodigo": 1200500,
    "uf": "AC",
    "nome": "Sena Madureira"
  },
  {
    "codigoTse": "01473",
    "ibgeCodigo": 1200609,
    "uf": "AC",
    "nome": "Tarauac�"
  },
  {
    "codigoTse": "01490",
    "ibgeCodigo": 1200708,
    "uf": "AC",
    "nome": "Xapuri"
  },
  {
    "codigoTse": "01511",
    "ibgeCodigo": 1200385,
    "uf": "AC",
    "nome": "Pl�cido De Castro"
  },
  {
    "codigoTse": "01538",
    "ibgeCodigo": 1200450,
    "uf": "AC",
    "nome": "Senador Guiomard"
  },
  {
    "codigoTse": "01554",
    "ibgeCodigo": 1200344,
    "uf": "AC",
    "nome": "Manoel Urbano"
  },
  {
    "codigoTse": "01570",
    "ibgeCodigo": 1200054,
    "uf": "AC",
    "nome": "Assis Brasil"
  },
  {
    "codigoTse": "02003",
    "ibgeCodigo": 1300144,
    "uf": "AM",
    "nome": "Apu�"
  },
  {
    "codigoTse": "02011",
    "ibgeCodigo": 1303205,
    "uf": "AM",
    "nome": "Novo Air�o"
  },
  {
    "codigoTse": "02020",
    "ibgeCodigo": 1301654,
    "uf": "AM",
    "nome": "Guajar�"
  },
  {
    "codigoTse": "02038",
    "ibgeCodigo": 1300102,
    "uf": "AM",
    "nome": "Anori"
  },
  {
    "codigoTse": "02046",
    "ibgeCodigo": 1301159,
    "uf": "AM",
    "nome": "Careiro Da V�rzea"
  },
  {
    "codigoTse": "02054",
    "ibgeCodigo": 1300201,
    "uf": "AM",
    "nome": "Atalaia Do Norte"
  },
  {
    "codigoTse": "02070",
    "ibgeCodigo": 1300300,
    "uf": "AM",
    "nome": "Autazes"
  },
  {
    "codigoTse": "02097",
    "ibgeCodigo": 1300409,
    "uf": "AM",
    "nome": "Barcelos"
  },
  {
    "codigoTse": "02119",
    "ibgeCodigo": 1300508,
    "uf": "AM",
    "nome": "Barreirinha"
  },
  {
    "codigoTse": "02135",
    "ibgeCodigo": 1300607,
    "uf": "AM",
    "nome": "Benjamin Constant"
  },
  {
    "codigoTse": "02151",
    "ibgeCodigo": 1300706,
    "uf": "AM",
    "nome": "Boca Do Acre"
  },
  {
    "codigoTse": "02178",
    "ibgeCodigo": 1300805,
    "uf": "AM",
    "nome": "Borba"
  },
  {
    "codigoTse": "02194",
    "ibgeCodigo": 1300904,
    "uf": "AM",
    "nome": "Canutama"
  },
  {
    "codigoTse": "02216",
    "ibgeCodigo": 1301001,
    "uf": "AM",
    "nome": "Carauari"
  },
  {
    "codigoTse": "02232",
    "ibgeCodigo": 1301100,
    "uf": "AM",
    "nome": "Careiro"
  },
  {
    "codigoTse": "02259",
    "ibgeCodigo": 1301209,
    "uf": "AM",
    "nome": "Coari"
  },
  {
    "codigoTse": "02275",
    "ibgeCodigo": 1301308,
    "uf": "AM",
    "nome": "Codaj�s"
  },
  {
    "codigoTse": "02291",
    "ibgeCodigo": 1301407,
    "uf": "AM",
    "nome": "Eirunep�"
  },
  {
    "codigoTse": "02313",
    "ibgeCodigo": 1301506,
    "uf": "AM",
    "nome": "Envira"
  },
  {
    "codigoTse": "02330",
    "ibgeCodigo": 1301605,
    "uf": "AM",
    "nome": "Fonte Boa"
  },
  {
    "codigoTse": "02356",
    "ibgeCodigo": 1301704,
    "uf": "AM",
    "nome": "Humait�"
  },
  {
    "codigoTse": "02372",
    "ibgeCodigo": 1303601,
    "uf": "AM",
    "nome": "Santa Isabel Do Rio Negro"
  },
  {
    "codigoTse": "02399",
    "ibgeCodigo": 1301803,
    "uf": "AM",
    "nome": "Ipixuna"
  },
  {
    "codigoTse": "02410",
    "ibgeCodigo": 1301902,
    "uf": "AM",
    "nome": "Itacoatiara"
  },
  {
    "codigoTse": "02437",
    "ibgeCodigo": 1302009,
    "uf": "AM",
    "nome": "Itapiranga"
  },
  {
    "codigoTse": "02453",
    "ibgeCodigo": 1302108,
    "uf": "AM",
    "nome": "Japur�"
  },
  {
    "codigoTse": "02470",
    "ibgeCodigo": 1302207,
    "uf": "AM",
    "nome": "Juru�"
  },
  {
    "codigoTse": "02496",
    "ibgeCodigo": 1302306,
    "uf": "AM",
    "nome": "Juta�"
  },
  {
    "codigoTse": "02518",
    "ibgeCodigo": 1302405,
    "uf": "AM",
    "nome": "L�brea"
  },
  {
    "codigoTse": "02534",
    "ibgeCodigo": 1302504,
    "uf": "AM",
    "nome": "Manacapuru"
  },
  {
    "codigoTse": "02550",
    "ibgeCodigo": 1302603,
    "uf": "AM",
    "nome": "Manaus"
  },
  {
    "codigoTse": "02577",
    "ibgeCodigo": 1302702,
    "uf": "AM",
    "nome": "Manicor�"
  },
  {
    "codigoTse": "02593",
    "ibgeCodigo": 1302801,
    "uf": "AM",
    "nome": "Mara�"
  },
  {
    "codigoTse": "02615",
    "ibgeCodigo": 1302900,
    "uf": "AM",
    "nome": "Mau�s"
  },
  {
    "codigoTse": "02631",
    "ibgeCodigo": 1303007,
    "uf": "AM",
    "nome": "Nhamund�"
  },
  {
    "codigoTse": "02658",
    "ibgeCodigo": 1303106,
    "uf": "AM",
    "nome": "Nova Olinda Do Norte"
  },
  {
    "codigoTse": "02674",
    "ibgeCodigo": 1303304,
    "uf": "AM",
    "nome": "Novo Aripuan�"
  },
  {
    "codigoTse": "02690",
    "ibgeCodigo": 1303403,
    "uf": "AM",
    "nome": "Parintins"
  },
  {
    "codigoTse": "02712",
    "ibgeCodigo": 1303502,
    "uf": "AM",
    "nome": "Pauini"
  },
  {
    "codigoTse": "02739",
    "ibgeCodigo": 1303700,
    "uf": "AM",
    "nome": "Santo Ant�nio Do I��"
  },
  {
    "codigoTse": "02755",
    "ibgeCodigo": 1303908,
    "uf": "AM",
    "nome": "S�o Paulo De Oliven�a"
  },
  {
    "codigoTse": "02771",
    "ibgeCodigo": 1304005,
    "uf": "AM",
    "nome": "Silves"
  },
  {
    "codigoTse": "02798",
    "ibgeCodigo": 1304104,
    "uf": "AM",
    "nome": "Tapau�"
  },
  {
    "codigoTse": "02810",
    "ibgeCodigo": 1304203,
    "uf": "AM",
    "nome": "Tef�"
  },
  {
    "codigoTse": "02836",
    "ibgeCodigo": 1303809,
    "uf": "AM",
    "nome": "S�o Gabriel Da Cachoeira"
  },
  {
    "codigoTse": "02852",
    "ibgeCodigo": 1304302,
    "uf": "AM",
    "nome": "Urucar�"
  },
  {
    "codigoTse": "02879",
    "ibgeCodigo": 1304401,
    "uf": "AM",
    "nome": "Urucurituba"
  },
  {
    "codigoTse": "02895",
    "ibgeCodigo": 1300029,
    "uf": "AM",
    "nome": "Alvar�es"
  },
  {
    "codigoTse": "02917",
    "ibgeCodigo": 1300060,
    "uf": "AM",
    "nome": "Amatur�"
  },
  {
    "codigoTse": "02933",
    "ibgeCodigo": 1300086,
    "uf": "AM",
    "nome": "Anam�"
  },
  {
    "codigoTse": "02950",
    "ibgeCodigo": 1300631,
    "uf": "AM",
    "nome": "Beruri"
  },
  {
    "codigoTse": "02976",
    "ibgeCodigo": 1300680,
    "uf": "AM",
    "nome": "Boa Vista Do Ramos"
  },
  {
    "codigoTse": "02992",
    "ibgeCodigo": 1300839,
    "uf": "AM",
    "nome": "Caapiranga"
  },
  {
    "codigoTse": "03000",
    "ibgeCodigo": 1400233,
    "uf": "RR",
    "nome": "Caroebe"
  },
  {
    "codigoTse": "03018",
    "ibgeCodigo": 1400100,
    "uf": "RR",
    "nome": "Boa Vista"
  },
  {
    "codigoTse": "03026",
    "ibgeCodigo": 1400282,
    "uf": "RR",
    "nome": "Iracema"
  },
  {
    "codigoTse": "03034",
    "ibgeCodigo": 1400209,
    "uf": "RR",
    "nome": "Caracara�"
  },
  {
    "codigoTse": "03042",
    "ibgeCodigo": 1400027,
    "uf": "RR",
    "nome": "Amajari"
  },
  {
    "codigoTse": "03050",
    "ibgeCodigo": 1400050,
    "uf": "RR",
    "nome": "Alto Alegre"
  },
  {
    "codigoTse": "03069",
    "ibgeCodigo": 1400175,
    "uf": "RR",
    "nome": "Cant�"
  },
  {
    "codigoTse": "03077",
    "ibgeCodigo": 1400159,
    "uf": "RR",
    "nome": "Bonfim"
  },
  {
    "codigoTse": "03085",
    "ibgeCodigo": 1400472,
    "uf": "RR",
    "nome": "Rorain�polis"
  },
  {
    "codigoTse": "03093",
    "ibgeCodigo": 1400308,
    "uf": "RR",
    "nome": "Mucaja�"
  },
  {
    "codigoTse": "03107",
    "ibgeCodigo": 1400704,
    "uf": "RR",
    "nome": "Uiramut�"
  },
  {
    "codigoTse": "03115",
    "ibgeCodigo": 1400407,
    "uf": "RR",
    "nome": "Normandia"
  },
  {
    "codigoTse": "03123",
    "ibgeCodigo": 1400456,
    "uf": "RR",
    "nome": "Pacaraima"
  },
  {
    "codigoTse": "03131",
    "ibgeCodigo": 1400506,
    "uf": "RR",
    "nome": "S�o Jo�o Da Baliza"
  },
  {
    "codigoTse": "03158",
    "ibgeCodigo": 1400605,
    "uf": "RR",
    "nome": "S�o Luiz"
  },
  {
    "codigoTse": "04006",
    "ibgeCodigo": 1503093,
    "uf": "PA",
    "nome": "Goian�sia Do Par�"
  },
  {
    "codigoTse": "04014",
    "ibgeCodigo": 1500107,
    "uf": "PA",
    "nome": "Abaetetuba"
  },
  {
    "codigoTse": "04022",
    "ibgeCodigo": 1507953,
    "uf": "PA",
    "nome": "Tail�ndia"
  },
  {
    "codigoTse": "04030",
    "ibgeCodigo": 1500206,
    "uf": "PA",
    "nome": "Acar�"
  },
  {
    "codigoTse": "04049",
    "ibgeCodigo": 1501576,
    "uf": "PA",
    "nome": "Bom Jesus Do Tocantins"
  },
  {
    "codigoTse": "04057",
    "ibgeCodigo": 1500305,
    "uf": "PA",
    "nome": "Afu�"
  },
  {
    "codigoTse": "04065",
    "ibgeCodigo": 1507474,
    "uf": "PA",
    "nome": "S�o Jo�o De Pirabas"
  },
  {
    "codigoTse": "04073",
    "ibgeCodigo": 1500404,
    "uf": "PA",
    "nome": "Alenquer"
  },
  {
    "codigoTse": "04081",
    "ibgeCodigo": 1508084,
    "uf": "PA",
    "nome": "Tucum�"
  },
  {
    "codigoTse": "04090",
    "ibgeCodigo": 1500503,
    "uf": "PA",
    "nome": "Almeirim"
  },
  {
    "codigoTse": "04103",
    "ibgeCodigo": 1504059,
    "uf": "PA",
    "nome": "M�e Do Rio"
  },
  {
    "codigoTse": "04111",
    "ibgeCodigo": 1500602,
    "uf": "PA",
    "nome": "Altamira"
  },
  {
    "codigoTse": "04120",
    "ibgeCodigo": 1502954,
    "uf": "PA",
    "nome": "Eldorado Dos Caraj�s"
  },
  {
    "codigoTse": "04138",
    "ibgeCodigo": 1500701,
    "uf": "PA",
    "nome": "Anaj�s"
  },
  {
    "codigoTse": "04146",
    "ibgeCodigo": 1506559,
    "uf": "PA",
    "nome": "Santa Luzia Do Par�"
  },
  {
    "codigoTse": "04154",
    "ibgeCodigo": 1500800,
    "uf": "PA",
    "nome": "Ananindeua"
  },
  {
    "codigoTse": "04162",
    "ibgeCodigo": 1505494,
    "uf": "PA",
    "nome": "Palestina Do Par�"
  },
  {
    "codigoTse": "04170",
    "ibgeCodigo": 1500909,
    "uf": "PA",
    "nome": "Augusto Corr�a"
  },
  {
    "codigoTse": "04189",
    "ibgeCodigo": 1503457,
    "uf": "PA",
    "nome": "Ipixuna Do Par�"
  },
  {
    "codigoTse": "04197",
    "ibgeCodigo": 1501006,
    "uf": "PA",
    "nome": "Aveiro"
  },
  {
    "codigoTse": "04200",
    "ibgeCodigo": 1503754,
    "uf": "PA",
    "nome": "Jacareacanga"
  },
  {
    "codigoTse": "04219",
    "ibgeCodigo": 1501105,
    "uf": "PA",
    "nome": "Bagre"
  },
  {
    "codigoTse": "04227",
    "ibgeCodigo": 1501725,
    "uf": "PA",
    "nome": "Brasil Novo"
  },
  {
    "codigoTse": "04235",
    "ibgeCodigo": 1501204,
    "uf": "PA",
    "nome": "Bai�o"
  },
  {
    "codigoTse": "04243",
    "ibgeCodigo": 1506351,
    "uf": "PA",
    "nome": "Santa B�rbara Do Par�"
  },
  {
    "codigoTse": "04251",
    "ibgeCodigo": 1501303,
    "uf": "PA",
    "nome": "Barcarena"
  },
  {
    "codigoTse": "04260",
    "ibgeCodigo": 1500347,
    "uf": "PA",
    "nome": "�gua Azul Do Norte"
  },
  {
    "codigoTse": "04278",
    "ibgeCodigo": 1501402,
    "uf": "PA",
    "nome": "Bel�m"
  },
  {
    "codigoTse": "04286",
    "ibgeCodigo": 1508050,
    "uf": "PA",
    "nome": "Trair�o"
  },
  {
    "codigoTse": "04294",
    "ibgeCodigo": 1501501,
    "uf": "PA",
    "nome": "Benevides"
  },
  {
    "codigoTse": "04308",
    "ibgeCodigo": 1505551,
    "uf": "PA",
    "nome": "Pau D'Arco"
  },
  {
    "codigoTse": "04316",
    "ibgeCodigo": 1501600,
    "uf": "PA",
    "nome": "Bonito"
  },
  {
    "codigoTse": "04324",
    "ibgeCodigo": 1508126,
    "uf": "PA",
    "nome": "Ulian�polis"
  },
  {
    "codigoTse": "04332",
    "ibgeCodigo": 1501709,
    "uf": "PA",
    "nome": "Bragan�a"
  },
  {
    "codigoTse": "04340",
    "ibgeCodigo": 1500958,
    "uf": "PA",
    "nome": "Aurora Do Par�"
  },
  {
    "codigoTse": "04359",
    "ibgeCodigo": 1501808,
    "uf": "PA",
    "nome": "Breves"
  },
  {
    "codigoTse": "04367",
    "ibgeCodigo": 1507979,
    "uf": "PA",
    "nome": "Terra Santa"
  },
  {
    "codigoTse": "04375",
    "ibgeCodigo": 1501907,
    "uf": "PA",
    "nome": "Bujaru"
  },
  {
    "codigoTse": "04383",
    "ibgeCodigo": 1505031,
    "uf": "PA",
    "nome": "Novo Progresso"
  },
  {
    "codigoTse": "04391",
    "ibgeCodigo": 1502004,
    "uf": "PA",
    "nome": "Cachoeira Do Arari"
  },
  {
    "codigoTse": "04405",
    "ibgeCodigo": 1508357,
    "uf": "PA",
    "nome": "Vit�ria Do Xingu"
  },
  {
    "codigoTse": "04413",
    "ibgeCodigo": 1502103,
    "uf": "PA",
    "nome": "Camet�"
  },
  {
    "codigoTse": "04421",
    "ibgeCodigo": 1505064,
    "uf": "PA",
    "nome": "Novo Repartimento"
  },
  {
    "codigoTse": "04430",
    "ibgeCodigo": 1502202,
    "uf": "PA",
    "nome": "Capanema"
  },
  {
    "codigoTse": "04448",
    "ibgeCodigo": 1501782,
    "uf": "PA",
    "nome": "Breu Branco"
  },
  {
    "codigoTse": "04456",
    "ibgeCodigo": 1502301,
    "uf": "PA",
    "nome": "Capit�o Po�o"
  },
  {
    "codigoTse": "04464",
    "ibgeCodigo": 1507151,
    "uf": "PA",
    "nome": "S�o Domingos Do Araguaia"
  },
  {
    "codigoTse": "04472",
    "ibgeCodigo": 1502400,
    "uf": "PA",
    "nome": "Castanhal"
  },
  {
    "codigoTse": "04480",
    "ibgeCodigo": 1504950,
    "uf": "PA",
    "nome": "Nova Esperan�a Do Piri�"
  },
  {
    "codigoTse": "04499",
    "ibgeCodigo": 1502509,
    "uf": "PA",
    "nome": "Chaves"
  },
  {
    "codigoTse": "04502",
    "ibgeCodigo": 1500131,
    "uf": "PA",
    "nome": "Abel Figueiredo"
  },
  {
    "codigoTse": "04510",
    "ibgeCodigo": 1502608,
    "uf": "PA",
    "nome": "Colares"
  },
  {
    "codigoTse": "04529",
    "ibgeCodigo": 1502764,
    "uf": "PA",
    "nome": "Cumaru Do Norte"
  },
  {
    "codigoTse": "04537",
    "ibgeCodigo": 1502707,
    "uf": "PA",
    "nome": "Concei��o Do Araguaia"
  },
  {
    "codigoTse": "04545",
    "ibgeCodigo": 1507961,
    "uf": "PA",
    "nome": "Terra Alta"
  },
  {
    "codigoTse": "04553",
    "ibgeCodigo": 1502806,
    "uf": "PA",
    "nome": "Curralinho"
  },
  {
    "codigoTse": "04561",
    "ibgeCodigo": 1503044,
    "uf": "PA",
    "nome": "Floresta Do Araguaia"
  },
  {
    "codigoTse": "04570",
    "ibgeCodigo": 1502905,
    "uf": "PA",
    "nome": "Curu��"
  },
  {
    "codigoTse": "04588",
    "ibgeCodigo": 1501253,
    "uf": "PA",
    "nome": "Bannach"
  },
  {
    "codigoTse": "04596",
    "ibgeCodigo": 1503002,
    "uf": "PA",
    "nome": "Faro"
  },
  {
    "codigoTse": "04600",
    "ibgeCodigo": 1504976,
    "uf": "PA",
    "nome": "Nova Ipixuna"
  },
  {
    "codigoTse": "04618",
    "ibgeCodigo": 1503101,
    "uf": "PA",
    "nome": "Gurup�"
  },
  {
    "codigoTse": "04626",
    "ibgeCodigo": 1505650,
    "uf": "PA",
    "nome": "Placas"
  },
  {
    "codigoTse": "04634",
    "ibgeCodigo": 1503200,
    "uf": "PA",
    "nome": "Igarap�-A�u"
  },
  {
    "codigoTse": "04642",
    "ibgeCodigo": 1504422,
    "uf": "PA",
    "nome": "Marituba"
  },
  {
    "codigoTse": "04650",
    "ibgeCodigo": 1503309,
    "uf": "PA",
    "nome": "Igarap�-Miri"
  },
  {
    "codigoTse": "04669",
    "ibgeCodigo": 1508035,
    "uf": "PA",
    "nome": "Tracuateua"
  },
  {
    "codigoTse": "04677",
    "ibgeCodigo": 1503408,
    "uf": "PA",
    "nome": "Inhangapi"
  },
  {
    "codigoTse": "04685",
    "ibgeCodigo": 1506112,
    "uf": "PA",
    "nome": "Quatipuru"
  },
  {
    "codigoTse": "04693",
    "ibgeCodigo": 1503507,
    "uf": "PA",
    "nome": "Irituia"
  },
  {
    "codigoTse": "04707",
    "ibgeCodigo": 1502152,
    "uf": "PA",
    "nome": "Cana� Dos Caraj�s"
  },
  {
    "codigoTse": "04715",
    "ibgeCodigo": 1503606,
    "uf": "PA",
    "nome": "Itaituba"
  },
  {
    "codigoTse": "04723",
    "ibgeCodigo": 1500859,
    "uf": "PA",
    "nome": "Anapu"
  },
  {
    "codigoTse": "04731",
    "ibgeCodigo": 1503705,
    "uf": "PA",
    "nome": "Itupiranga"
  },
  {
    "codigoTse": "04740",
    "ibgeCodigo": 1502855,
    "uf": "PA",
    "nome": "Curu�"
  },
  {
    "codigoTse": "04758",
    "ibgeCodigo": 1503804,
    "uf": "PA",
    "nome": "Jacund�"
  },
  {
    "codigoTse": "04766",
    "ibgeCodigo": 1501956,
    "uf": "PA",
    "nome": "Cachoeira Do Piri�"
  },
  {
    "codigoTse": "04774",
    "ibgeCodigo": 1503903,
    "uf": "PA",
    "nome": "Juruti"
  },
  {
    "codigoTse": "04782",
    "ibgeCodigo": 1505635,
    "uf": "PA",
    "nome": "Pi�arra"
  },
  {
    "codigoTse": "04790",
    "ibgeCodigo": 1504000,
    "uf": "PA",
    "nome": "Limoeiro Do Ajuru"
  },
  {
    "codigoTse": "04804",
    "ibgeCodigo": 1501451,
    "uf": "PA",
    "nome": "Belterra"
  },
  {
    "codigoTse": "04812",
    "ibgeCodigo": 1504109,
    "uf": "PA",
    "nome": "Magalh�es Barata"
  },
  {
    "codigoTse": "04820",
    "ibgeCodigo": 1507466,
    "uf": "PA",
    "nome": "S�o Jo�o Da Ponta"
  },
  {
    "codigoTse": "04839",
    "ibgeCodigo": 1504208,
    "uf": "PA",
    "nome": "Marab�"
  },
  {
    "codigoTse": "04847",
    "ibgeCodigo": 1507755,
    "uf": "PA",
    "nome": "Sapucaia"
  },
  {
    "codigoTse": "04855",
    "ibgeCodigo": 1504307,
    "uf": "PA",
    "nome": "Maracan�"
  },
  {
    "codigoTse": "04863",
    "ibgeCodigo": 1504752,
    "uf": "PA",
    "nome": "Moju� Dos Campos"
  },
  {
    "codigoTse": "04871",
    "ibgeCodigo": 1504406,
    "uf": "PA",
    "nome": "Marapanim"
  },
  {
    "codigoTse": "04898",
    "ibgeCodigo": 1504505,
    "uf": "PA",
    "nome": "Melga�o"
  },
  {
    "codigoTse": "04910",
    "ibgeCodigo": 1504604,
    "uf": "PA",
    "nome": "Mocajuba"
  },
  {
    "codigoTse": "04936",
    "ibgeCodigo": 1504703,
    "uf": "PA",
    "nome": "Moju"
  },
  {
    "codigoTse": "04952",
    "ibgeCodigo": 1504802,
    "uf": "PA",
    "nome": "Monte Alegre"
  },
  {
    "codigoTse": "04979",
    "ibgeCodigo": 1504901,
    "uf": "PA",
    "nome": "Muan�"
  },
  {
    "codigoTse": "04995",
    "ibgeCodigo": 1505007,
    "uf": "PA",
    "nome": "Nova Timboteua"
  },
  {
    "codigoTse": "05010",
    "ibgeCodigo": 1505106,
    "uf": "PA",
    "nome": "�bidos"
  },
  {
    "codigoTse": "05037",
    "ibgeCodigo": 1505205,
    "uf": "PA",
    "nome": "Oeiras Do Par�"
  },
  {
    "codigoTse": "05053",
    "ibgeCodigo": 1505304,
    "uf": "PA",
    "nome": "Oriximin�"
  },
  {
    "codigoTse": "05070",
    "ibgeCodigo": 1505403,
    "uf": "PA",
    "nome": "Our�m"
  },
  {
    "codigoTse": "05096",
    "ibgeCodigo": 1505502,
    "uf": "PA",
    "nome": "Paragominas"
  },
  {
    "codigoTse": "05118",
    "ibgeCodigo": 1505601,
    "uf": "PA",
    "nome": "Peixe-Boi"
  },
  {
    "codigoTse": "05134",
    "ibgeCodigo": 1505700,
    "uf": "PA",
    "nome": "Ponta De Pedras"
  },
  {
    "codigoTse": "05150",
    "ibgeCodigo": 1505809,
    "uf": "PA",
    "nome": "Portel"
  },
  {
    "codigoTse": "05177",
    "ibgeCodigo": 1505908,
    "uf": "PA",
    "nome": "Porto De Moz"
  },
  {
    "codigoTse": "05193",
    "ibgeCodigo": 1506005,
    "uf": "PA",
    "nome": "Prainha"
  },
  {
    "codigoTse": "05215",
    "ibgeCodigo": 1506104,
    "uf": "PA",
    "nome": "Primavera"
  },
  {
    "codigoTse": "05231",
    "ibgeCodigo": 1506203,
    "uf": "PA",
    "nome": "Salin�polis"
  },
  {
    "codigoTse": "05258",
    "ibgeCodigo": 1506302,
    "uf": "PA",
    "nome": "Salvaterra"
  },
  {
    "codigoTse": "05274",
    "ibgeCodigo": 1506401,
    "uf": "PA",
    "nome": "Santa Cruz Do Arari"
  },
  {
    "codigoTse": "05290",
    "ibgeCodigo": 1506500,
    "uf": "PA",
    "nome": "Santa Izabel Do Par�"
  },
  {
    "codigoTse": "05312",
    "ibgeCodigo": 1506609,
    "uf": "PA",
    "nome": "Santa Maria Do Par�"
  },
  {
    "codigoTse": "05339",
    "ibgeCodigo": 1506708,
    "uf": "PA",
    "nome": "Santana Do Araguaia"
  },
  {
    "codigoTse": "05355",
    "ibgeCodigo": 1506807,
    "uf": "PA",
    "nome": "Santar�m"
  },
  {
    "codigoTse": "05371",
    "ibgeCodigo": 1506906,
    "uf": "PA",
    "nome": "Santar�m Novo"
  },
  {
    "codigoTse": "05398",
    "ibgeCodigo": 1507003,
    "uf": "PA",
    "nome": "Santo Ant�nio Do Tau�"
  },
  {
    "codigoTse": "05410",
    "ibgeCodigo": 1507102,
    "uf": "PA",
    "nome": "S�o Caetano De Odivelas"
  },
  {
    "codigoTse": "05436",
    "ibgeCodigo": 1507201,
    "uf": "PA",
    "nome": "S�o Domingos Do Capim"
  },
  {
    "codigoTse": "05452",
    "ibgeCodigo": 1507300,
    "uf": "PA",
    "nome": "S�o F�lix Do Xingu"
  },
  {
    "codigoTse": "05479",
    "ibgeCodigo": 1507409,
    "uf": "PA",
    "nome": "S�o Francisco Do Par�"
  },
  {
    "codigoTse": "05495",
    "ibgeCodigo": 1507508,
    "uf": "PA",
    "nome": "S�o Jo�o Do Araguaia"
  },
  {
    "codigoTse": "05517",
    "ibgeCodigo": 1507607,
    "uf": "PA",
    "nome": "S�o Miguel Do Guam�"
  },
  {
    "codigoTse": "05533",
    "ibgeCodigo": 1507706,
    "uf": "PA",
    "nome": "S�o Sebasti�o Da Boa Vista"
  },
  {
    "codigoTse": "05550",
    "ibgeCodigo": 1507805,
    "uf": "PA",
    "nome": "Senador Jos� Porf�rio"
  },
  {
    "codigoTse": "05576",
    "ibgeCodigo": 1507904,
    "uf": "PA",
    "nome": "Soure"
  },
  {
    "codigoTse": "05592",
    "ibgeCodigo": 1508001,
    "uf": "PA",
    "nome": "Tom�-A�u"
  },
  {
    "codigoTse": "05614",
    "ibgeCodigo": 1508100,
    "uf": "PA",
    "nome": "Tucuru�"
  },
  {
    "codigoTse": "05630",
    "ibgeCodigo": 1508209,
    "uf": "PA",
    "nome": "Vigia"
  },
  {
    "codigoTse": "05657",
    "ibgeCodigo": 1508308,
    "uf": "PA",
    "nome": "Viseu"
  },
  {
    "codigoTse": "05673",
    "ibgeCodigo": 1506138,
    "uf": "PA",
    "nome": "Reden��o"
  },
  {
    "codigoTse": "05690",
    "ibgeCodigo": 1506161,
    "uf": "PA",
    "nome": "Rio Maria"
  },
  {
    "codigoTse": "05711",
    "ibgeCodigo": 1508407,
    "uf": "PA",
    "nome": "Xinguara"
  },
  {
    "codigoTse": "05738",
    "ibgeCodigo": 1506187,
    "uf": "PA",
    "nome": "Rondon Do Par�"
  },
  {
    "codigoTse": "05754",
    "ibgeCodigo": 1508159,
    "uf": "PA",
    "nome": "Uruar�"
  },
  {
    "codigoTse": "05770",
    "ibgeCodigo": 1504455,
    "uf": "PA",
    "nome": "Medicil�ndia"
  },
  {
    "codigoTse": "05797",
    "ibgeCodigo": 1507458,
    "uf": "PA",
    "nome": "S�o Geraldo Do Araguaia"
  },
  {
    "codigoTse": "05819",
    "ibgeCodigo": 1502756,
    "uf": "PA",
    "nome": "Conc�rdia Do Par�"
  },
  {
    "codigoTse": "05835",
    "ibgeCodigo": 1505536,
    "uf": "PA",
    "nome": "Parauapebas"
  },
  {
    "codigoTse": "05851",
    "ibgeCodigo": 1502772,
    "uf": "PA",
    "nome": "Curion�polis"
  },
  {
    "codigoTse": "05878",
    "ibgeCodigo": 1503077,
    "uf": "PA",
    "nome": "Garraf�o Do Norte"
  },
  {
    "codigoTse": "05894",
    "ibgeCodigo": 1506195,
    "uf": "PA",
    "nome": "Rur�polis"
  },
  {
    "codigoTse": "05916",
    "ibgeCodigo": 1505486,
    "uf": "PA",
    "nome": "Pacaj�"
  },
  {
    "codigoTse": "05932",
    "ibgeCodigo": 1501758,
    "uf": "PA",
    "nome": "Brejo Grande Do Araguaia"
  },
  {
    "codigoTse": "05959",
    "ibgeCodigo": 1505437,
    "uf": "PA",
    "nome": "Ouril�ndia Do Norte"
  },
  {
    "codigoTse": "05975",
    "ibgeCodigo": 1502939,
    "uf": "PA",
    "nome": "Dom Eliseu"
  },
  {
    "codigoTse": "05991",
    "ibgeCodigo": 1506583,
    "uf": "PA",
    "nome": "Santa Maria Das Barreiras"
  },
  {
    "codigoTse": "06009",
    "ibgeCodigo": 1600550,
    "uf": "AP",
    "nome": "Pracu�ba"
  },
  {
    "codigoTse": "06017",
    "ibgeCodigo": 1600105,
    "uf": "AP",
    "nome": "Amap�"
  },
  {
    "codigoTse": "06025",
    "ibgeCodigo": 1600535,
    "uf": "AP",
    "nome": "Porto Grande"
  },
  {
    "codigoTse": "06033",
    "ibgeCodigo": 1600204,
    "uf": "AP",
    "nome": "Cal�oene"
  },
  {
    "codigoTse": "06041",
    "ibgeCodigo": 1600253,
    "uf": "AP",
    "nome": "Itaubal"
  },
  {
    "codigoTse": "06050",
    "ibgeCodigo": 1600303,
    "uf": "AP",
    "nome": "Macap�"
  },
  {
    "codigoTse": "06068",
    "ibgeCodigo": 1600212,
    "uf": "AP",
    "nome": "Cutias"
  },
  {
    "codigoTse": "06076",
    "ibgeCodigo": 1600402,
    "uf": "AP",
    "nome": "Mazag�o"
  },
  {
    "codigoTse": "06084",
    "ibgeCodigo": 1600154,
    "uf": "AP",
    "nome": "Pedra Branca Do Amapari"
  },
  {
    "codigoTse": "06092",
    "ibgeCodigo": 1600501,
    "uf": "AP",
    "nome": "Oiapoque"
  },
  {
    "codigoTse": "06106",
    "ibgeCodigo": 1600055,
    "uf": "AP",
    "nome": "Serra Do Navio"
  },
  {
    "codigoTse": "06114",
    "ibgeCodigo": 1600238,
    "uf": "AP",
    "nome": "Ferreira Gomes"
  },
  {
    "codigoTse": "06122",
    "ibgeCodigo": 1600808,
    "uf": "AP",
    "nome": "Vit�ria Do Jari"
  },
  {
    "codigoTse": "06130",
    "ibgeCodigo": 1600279,
    "uf": "AP",
    "nome": "Laranjal Do Jari"
  },
  {
    "codigoTse": "06157",
    "ibgeCodigo": 1600600,
    "uf": "AP",
    "nome": "Santana"
  },
  {
    "codigoTse": "06173",
    "ibgeCodigo": 1600709,
    "uf": "AP",
    "nome": "Tartarugalzinho"
  },
  {
    "codigoTse": "07005",
    "ibgeCodigo": 2100154,
    "uf": "MA",
    "nome": "�gua Doce Do Maranh�o"
  },
  {
    "codigoTse": "07013",
    "ibgeCodigo": 2100105,
    "uf": "MA",
    "nome": "Afonso Cunha"
  },
  {
    "codigoTse": "07021",
    "ibgeCodigo": 2100436,
    "uf": "MA",
    "nome": "Alto Alegre Do Maranh�o"
  },
  {
    "codigoTse": "07030",
    "ibgeCodigo": 2100204,
    "uf": "MA",
    "nome": "Alc�ntara"
  },
  {
    "codigoTse": "07048",
    "ibgeCodigo": 2100477,
    "uf": "MA",
    "nome": "Alto Alegre Do Pindar�"
  },
  {
    "codigoTse": "07056",
    "ibgeCodigo": 2100303,
    "uf": "MA",
    "nome": "Aldeias Altas"
  },
  {
    "codigoTse": "07064",
    "ibgeCodigo": 2100832,
    "uf": "MA",
    "nome": "Apicum-A�u"
  },
  {
    "codigoTse": "07072",
    "ibgeCodigo": 2100402,
    "uf": "MA",
    "nome": "Altamira Do Maranh�o"
  },
  {
    "codigoTse": "07080",
    "ibgeCodigo": 2100550,
    "uf": "MA",
    "nome": "Amap� Do Maranh�o"
  },
  {
    "codigoTse": "07099",
    "ibgeCodigo": 2100501,
    "uf": "MA",
    "nome": "Alto Parna�ba"
  },
  {
    "codigoTse": "07102",
    "ibgeCodigo": 2100873,
    "uf": "MA",
    "nome": "Araguan�"
  },
  {
    "codigoTse": "07110",
    "ibgeCodigo": 2100600,
    "uf": "MA",
    "nome": "Amarante Do Maranh�o"
  },
  {
    "codigoTse": "07129",
    "ibgeCodigo": 2101251,
    "uf": "MA",
    "nome": "Bacabeira"
  },
  {
    "codigoTse": "07137",
    "ibgeCodigo": 2100709,
    "uf": "MA",
    "nome": "Anajatuba"
  },
  {
    "codigoTse": "07145",
    "ibgeCodigo": 2101350,
    "uf": "MA",
    "nome": "Bacurituba"
  },
  {
    "codigoTse": "07153",
    "ibgeCodigo": 2100808,
    "uf": "MA",
    "nome": "Anapurus"
  },
  {
    "codigoTse": "07161",
    "ibgeCodigo": 2101731,
    "uf": "MA",
    "nome": "Bel�gua"
  },
  {
    "codigoTse": "07170",
    "ibgeCodigo": 2100907,
    "uf": "MA",
    "nome": "Araioses"
  },
  {
    "codigoTse": "07188",
    "ibgeCodigo": 2101772,
    "uf": "MA",
    "nome": "Bela Vista Do Maranh�o"
  },
  {
    "codigoTse": "07196",
    "ibgeCodigo": 2101004,
    "uf": "MA",
    "nome": "Arari"
  },
  {
    "codigoTse": "07200",
    "ibgeCodigo": 2101939,
    "uf": "MA",
    "nome": "Bernardo Do Mearim"
  },
  {
    "codigoTse": "07218",
    "ibgeCodigo": 2101103,
    "uf": "MA",
    "nome": "Axix�"
  },
  {
    "codigoTse": "07226",
    "ibgeCodigo": 2102374,
    "uf": "MA",
    "nome": "Cachoeira Grande"
  },
  {
    "codigoTse": "07234",
    "ibgeCodigo": 2101202,
    "uf": "MA",
    "nome": "Bacabal"
  },
  {
    "codigoTse": "07242",
    "ibgeCodigo": 2103752,
    "uf": "MA",
    "nome": "Davin�polis"
  },
  {
    "codigoTse": "07250",
    "ibgeCodigo": 2101301,
    "uf": "MA",
    "nome": "Bacuri"
  },
  {
    "codigoTse": "07269",
    "ibgeCodigo": 2102036,
    "uf": "MA",
    "nome": "Bom Jesus Das Selvas"
  },
  {
    "codigoTse": "07277",
    "ibgeCodigo": 2101400,
    "uf": "MA",
    "nome": "Balsas"
  },
  {
    "codigoTse": "07285",
    "ibgeCodigo": 2102077,
    "uf": "MA",
    "nome": "Bom Lugar"
  },
  {
    "codigoTse": "07293",
    "ibgeCodigo": 2101509,
    "uf": "MA",
    "nome": "Bar�o De Graja�"
  },
  {
    "codigoTse": "07307",
    "ibgeCodigo": 2102150,
    "uf": "MA",
    "nome": "Brejo De Areia"
  },
  {
    "codigoTse": "07315",
    "ibgeCodigo": 2101608,
    "uf": "MA",
    "nome": "Barra Do Corda"
  },
  {
    "codigoTse": "07323",
    "ibgeCodigo": 2101970,
    "uf": "MA",
    "nome": "Boa Vista Do Gurupi"
  },
  {
    "codigoTse": "07331",
    "ibgeCodigo": 2101707,
    "uf": "MA",
    "nome": "Barreirinhas"
  },
  {
    "codigoTse": "07340",
    "ibgeCodigo": 2102325,
    "uf": "MA",
    "nome": "Buriticupu"
  },
  {
    "codigoTse": "07358",
    "ibgeCodigo": 2101806,
    "uf": "MA",
    "nome": "Benedito Leite"
  },
  {
    "codigoTse": "07366",
    "ibgeCodigo": 2102358,
    "uf": "MA",
    "nome": "Buritirana"
  },
  {
    "codigoTse": "07374",
    "ibgeCodigo": 2101905,
    "uf": "MA",
    "nome": "Bequim�o"
  },
  {
    "codigoTse": "07382",
    "ibgeCodigo": 2102556,
    "uf": "MA",
    "nome": "Campestre Do Maranh�o"
  },
  {
    "codigoTse": "07390",
    "ibgeCodigo": 2102101,
    "uf": "MA",
    "nome": "Brejo"
  },
  {
    "codigoTse": "07404",
    "ibgeCodigo": 2102754,
    "uf": "MA",
    "nome": "Capinzal Do Norte"
  },
  {
    "codigoTse": "07412",
    "ibgeCodigo": 2102200,
    "uf": "MA",
    "nome": "Buriti"
  },
  {
    "codigoTse": "07420",
    "ibgeCodigo": 2103125,
    "uf": "MA",
    "nome": "Central Do Maranh�o"
  },
  {
    "codigoTse": "07439",
    "ibgeCodigo": 2102309,
    "uf": "MA",
    "nome": "Buriti Bravo"
  },
  {
    "codigoTse": "07447",
    "ibgeCodigo": 2103158,
    "uf": "MA",
    "nome": "Centro Do Guilherme"
  },
  {
    "codigoTse": "07455",
    "ibgeCodigo": 2102408,
    "uf": "MA",
    "nome": "Cajapi�"
  },
  {
    "codigoTse": "07463",
    "ibgeCodigo": 2103174,
    "uf": "MA",
    "nome": "Centro Novo Do Maranh�o"
  },
  {
    "codigoTse": "07471",
    "ibgeCodigo": 2102507,
    "uf": "MA",
    "nome": "Cajari"
  },
  {
    "codigoTse": "07480",
    "ibgeCodigo": 2103257,
    "uf": "MA",
    "nome": "Cidel�ndia"
  },
  {
    "codigoTse": "07498",
    "ibgeCodigo": 2102606,
    "uf": "MA",
    "nome": "C�ndido Mendes"
  },
  {
    "codigoTse": "07501",
    "ibgeCodigo": 2103554,
    "uf": "MA",
    "nome": "Concei��o Do Lago-A�u"
  },
  {
    "codigoTse": "07510",
    "ibgeCodigo": 2102705,
    "uf": "MA",
    "nome": "Cantanhede"
  },
  {
    "codigoTse": "07528",
    "ibgeCodigo": 2104073,
    "uf": "MA",
    "nome": "Feira Nova Do Maranh�o"
  },
  {
    "codigoTse": "07536",
    "ibgeCodigo": 2102804,
    "uf": "MA",
    "nome": "Carolina"
  },
  {
    "codigoTse": "07544",
    "ibgeCodigo": 2104081,
    "uf": "MA",
    "nome": "Fernando Falc�o"
  },
  {
    "codigoTse": "07552",
    "ibgeCodigo": 2102903,
    "uf": "MA",
    "nome": "Carutapera"
  },
  {
    "codigoTse": "07560",
    "ibgeCodigo": 2104099,
    "uf": "MA",
    "nome": "Formosa Da Serra Negra"
  },
  {
    "codigoTse": "07579",
    "ibgeCodigo": 2103000,
    "uf": "MA",
    "nome": "Caxias"
  },
  {
    "codigoTse": "07595",
    "ibgeCodigo": 2103109,
    "uf": "MA",
    "nome": "Cedral"
  },
  {
    "codigoTse": "07609",
    "ibgeCodigo": 2104552,
    "uf": "MA",
    "nome": "Governador Edison Lob�o"
  },
  {
    "codigoTse": "07617",
    "ibgeCodigo": 2103208,
    "uf": "MA",
    "nome": "Chapadinha"
  },
  {
    "codigoTse": "07625",
    "ibgeCodigo": 2104628,
    "uf": "MA",
    "nome": "Governador Luiz Rocha"
  },
  {
    "codigoTse": "07633",
    "ibgeCodigo": 2103307,
    "uf": "MA",
    "nome": "Cod�"
  },
  {
    "codigoTse": "07641",
    "ibgeCodigo": 2104651,
    "uf": "MA",
    "nome": "Governador Newton Bello"
  },
  {
    "codigoTse": "07650",
    "ibgeCodigo": 2103406,
    "uf": "MA",
    "nome": "Coelho Neto"
  },
  {
    "codigoTse": "07668",
    "ibgeCodigo": 2104677,
    "uf": "MA",
    "nome": "Governador Nunes Freire"
  },
  {
    "codigoTse": "07676",
    "ibgeCodigo": 2103505,
    "uf": "MA",
    "nome": "Colinas"
  },
  {
    "codigoTse": "07684",
    "ibgeCodigo": 2105153,
    "uf": "MA",
    "nome": "Igarap� Do Meio"
  },
  {
    "codigoTse": "07692",
    "ibgeCodigo": 2103604,
    "uf": "MA",
    "nome": "Coroat�"
  },
  {
    "codigoTse": "07706",
    "ibgeCodigo": 2105351,
    "uf": "MA",
    "nome": "Itaipava Do Graja�"
  },
  {
    "codigoTse": "07714",
    "ibgeCodigo": 2103703,
    "uf": "MA",
    "nome": "Cururupu"
  },
  {
    "codigoTse": "07722",
    "ibgeCodigo": 2105427,
    "uf": "MA",
    "nome": "Itinga Do Maranh�o"
  },
  {
    "codigoTse": "07730",
    "ibgeCodigo": 2103802,
    "uf": "MA",
    "nome": "Dom Pedro"
  },
  {
    "codigoTse": "07749",
    "ibgeCodigo": 2105450,
    "uf": "MA",
    "nome": "Jatob�"
  },
  {
    "codigoTse": "07757",
    "ibgeCodigo": 2103901,
    "uf": "MA",
    "nome": "Duque Bacelar"
  },
  {
    "codigoTse": "07765",
    "ibgeCodigo": 2105476,
    "uf": "MA",
    "nome": "Jenipapo Dos Vieiras"
  },
  {
    "codigoTse": "07773",
    "ibgeCodigo": 2104008,
    "uf": "MA",
    "nome": "Esperantin�polis"
  },
  {
    "codigoTse": "07781",
    "ibgeCodigo": 2105658,
    "uf": "MA",
    "nome": "Junco Do Maranh�o"
  },
  {
    "codigoTse": "07790",
    "ibgeCodigo": 2104107,
    "uf": "MA",
    "nome": "Fortaleza Dos Nogueiras"
  },
  {
    "codigoTse": "07803",
    "ibgeCodigo": 2105948,
    "uf": "MA",
    "nome": "Lago Dos Rodrigues"
  },
  {
    "codigoTse": "07811",
    "ibgeCodigo": 2104206,
    "uf": "MA",
    "nome": "Fortuna"
  },
  {
    "codigoTse": "07820",
    "ibgeCodigo": 2105922,
    "uf": "MA",
    "nome": "Lagoa Do Mato"
  },
  {
    "codigoTse": "07838",
    "ibgeCodigo": 2104305,
    "uf": "MA",
    "nome": "Godofredo Viana"
  },
  {
    "codigoTse": "07846",
    "ibgeCodigo": 2105963,
    "uf": "MA",
    "nome": "Lagoa Grande Do Maranh�o"
  },
  {
    "codigoTse": "07854",
    "ibgeCodigo": 2104404,
    "uf": "MA",
    "nome": "Gon�alves Dias"
  },
  {
    "codigoTse": "07862",
    "ibgeCodigo": 2105989,
    "uf": "MA",
    "nome": "Lajeado Novo"
  },
  {
    "codigoTse": "07870",
    "ibgeCodigo": 2104503,
    "uf": "MA",
    "nome": "Governador Archer"
  },
  {
    "codigoTse": "07889",
    "ibgeCodigo": 2106326,
    "uf": "MA",
    "nome": "Maraca�um�"
  },
  {
    "codigoTse": "07897",
    "ibgeCodigo": 2104602,
    "uf": "MA",
    "nome": "Governador Eug�nio Barros"
  },
  {
    "codigoTse": "07900",
    "ibgeCodigo": 2106359,
    "uf": "MA",
    "nome": "Maraj� Do Sena"
  },
  {
    "codigoTse": "07919",
    "ibgeCodigo": 2104701,
    "uf": "MA",
    "nome": "Gra�a Aranha"
  },
  {
    "codigoTse": "07927",
    "ibgeCodigo": 2106375,
    "uf": "MA",
    "nome": "Maranh�ozinho"
  },
  {
    "codigoTse": "07935",
    "ibgeCodigo": 2104800,
    "uf": "MA",
    "nome": "Graja�"
  },
  {
    "codigoTse": "07943",
    "ibgeCodigo": 2106631,
    "uf": "MA",
    "nome": "Mat�es Do Norte"
  },
  {
    "codigoTse": "07951",
    "ibgeCodigo": 2104909,
    "uf": "MA",
    "nome": "Guimar�es"
  },
  {
    "codigoTse": "07960",
    "ibgeCodigo": 2106672,
    "uf": "MA",
    "nome": "Milagres Do Maranh�o"
  },
  {
    "codigoTse": "07978",
    "ibgeCodigo": 2105005,
    "uf": "MA",
    "nome": "Humberto De Campos"
  },
  {
    "codigoTse": "07986",
    "ibgeCodigo": 2107258,
    "uf": "MA",
    "nome": "Nova Colinas"
  },
  {
    "codigoTse": "07994",
    "ibgeCodigo": 2105104,
    "uf": "MA",
    "nome": "Icatu"
  },
  {
    "codigoTse": "08001",
    "ibgeCodigo": 2107357,
    "uf": "MA",
    "nome": "Nova Olinda Do Maranh�o"
  },
  {
    "codigoTse": "08010",
    "ibgeCodigo": 2105203,
    "uf": "MA",
    "nome": "Igarap� Grande"
  },
  {
    "codigoTse": "08028",
    "ibgeCodigo": 2107456,
    "uf": "MA",
    "nome": "Olinda Nova Do Maranh�o"
  },
  {
    "codigoTse": "08036",
    "ibgeCodigo": 2105302,
    "uf": "MA",
    "nome": "Imperatriz"
  },
  {
    "codigoTse": "08044",
    "ibgeCodigo": 2108058,
    "uf": "MA",
    "nome": "Paulino Neves"
  },
  {
    "codigoTse": "08052",
    "ibgeCodigo": 2111409,
    "uf": "MA",
    "nome": "S�o Lu�s Gonzaga Do Maranh�o"
  },
  {
    "codigoTse": "08060",
    "ibgeCodigo": 2108256,
    "uf": "MA",
    "nome": "Pedro Do Ros�rio"
  },
  {
    "codigoTse": "08079",
    "ibgeCodigo": 2105401,
    "uf": "MA",
    "nome": "Itapecuru Mirim"
  },
  {
    "codigoTse": "08087",
    "ibgeCodigo": 2108454,
    "uf": "MA",
    "nome": "Peritor�"
  },
  {
    "codigoTse": "08095",
    "ibgeCodigo": 2105500,
    "uf": "MA",
    "nome": "Jo�o Lisboa"
  },
  {
    "codigoTse": "08109",
    "ibgeCodigo": 2109056,
    "uf": "MA",
    "nome": "Porto Rico Do Maranh�o"
  },
  {
    "codigoTse": "08117",
    "ibgeCodigo": 2105609,
    "uf": "MA",
    "nome": "Josel�ndia"
  },
  {
    "codigoTse": "08125",
    "ibgeCodigo": 2109239,
    "uf": "MA",
    "nome": "Presidente M�dici"
  },
  {
    "codigoTse": "08133",
    "ibgeCodigo": 2105708,
    "uf": "MA",
    "nome": "Lago Da Pedra"
  },
  {
    "codigoTse": "08141",
    "ibgeCodigo": 2109270,
    "uf": "MA",
    "nome": "Presidente Sarney"
  },
  {
    "codigoTse": "08150",
    "ibgeCodigo": 2105807,
    "uf": "MA",
    "nome": "Lago Do Junco"
  },
  {
    "codigoTse": "08168",
    "ibgeCodigo": 2109452,
    "uf": "MA",
    "nome": "Raposa"
  },
  {
    "codigoTse": "08176",
    "ibgeCodigo": 2105906,
    "uf": "MA",
    "nome": "Lago Verde"
  },
  {
    "codigoTse": "08184",
    "ibgeCodigo": 2109551,
    "uf": "MA",
    "nome": "Ribamar Fiquene"
  },
  {
    "codigoTse": "08192",
    "ibgeCodigo": 2106003,
    "uf": "MA",
    "nome": "Lima Campos"
  },
  {
    "codigoTse": "08206",
    "ibgeCodigo": 2109759,
    "uf": "MA",
    "nome": "Santa Filomena Do Maranh�o"
  },
  {
    "codigoTse": "08214",
    "ibgeCodigo": 2106102,
    "uf": "MA",
    "nome": "Loreto"
  },
  {
    "codigoTse": "08222",
    "ibgeCodigo": 2110237,
    "uf": "MA",
    "nome": "Santana Do Maranh�o"
  },
  {
    "codigoTse": "08230",
    "ibgeCodigo": 2106201,
    "uf": "MA",
    "nome": "Lu�s Domingues"
  },
  {
    "codigoTse": "08249",
    "ibgeCodigo": 2110278,
    "uf": "MA",
    "nome": "Santo Amaro Do Maranh�o"
  },
  {
    "codigoTse": "08257",
    "ibgeCodigo": 2106300,
    "uf": "MA",
    "nome": "Magalh�es De Almeida"
  },
  {
    "codigoTse": "08265",
    "ibgeCodigo": 2110658,
    "uf": "MA",
    "nome": "S�o Domingos Do Azeit�o"
  },
  {
    "codigoTse": "08273",
    "ibgeCodigo": 2106409,
    "uf": "MA",
    "nome": "Mata Roma"
  },
  {
    "codigoTse": "08281",
    "ibgeCodigo": 2110856,
    "uf": "MA",
    "nome": "S�o Francisco Do Brej�o"
  },
  {
    "codigoTse": "08290",
    "ibgeCodigo": 2106508,
    "uf": "MA",
    "nome": "Matinha"
  },
  {
    "codigoTse": "08303",
    "ibgeCodigo": 2111029,
    "uf": "MA",
    "nome": "S�o Jo�o Do Car�"
  },
  {
    "codigoTse": "08311",
    "ibgeCodigo": 2106607,
    "uf": "MA",
    "nome": "Mat�es"
  },
  {
    "codigoTse": "08320",
    "ibgeCodigo": 2111052,
    "uf": "MA",
    "nome": "S�o Jo�o Do Para�so"
  },
  {
    "codigoTse": "08338",
    "ibgeCodigo": 2106706,
    "uf": "MA",
    "nome": "Mirador"
  },
  {
    "codigoTse": "08346",
    "ibgeCodigo": 2111078,
    "uf": "MA",
    "nome": "S�o Jo�o Do Soter"
  },
  {
    "codigoTse": "08354",
    "ibgeCodigo": 2106805,
    "uf": "MA",
    "nome": "Mirinzal"
  },
  {
    "codigoTse": "08362",
    "ibgeCodigo": 2111250,
    "uf": "MA",
    "nome": "S�o Jos� Dos Bas�lios"
  },
  {
    "codigoTse": "08370",
    "ibgeCodigo": 2106904,
    "uf": "MA",
    "nome": "Mon��o"
  },
  {
    "codigoTse": "08389",
    "ibgeCodigo": 2111532,
    "uf": "MA",
    "nome": "S�o Pedro Da �gua Branca"
  },
  {
    "codigoTse": "08397",
    "ibgeCodigo": 2107001,
    "uf": "MA",
    "nome": "Montes Altos"
  },
  {
    "codigoTse": "08400",
    "ibgeCodigo": 2111573,
    "uf": "MA",
    "nome": "S�o Pedro Dos Crentes"
  },
  {
    "codigoTse": "08419",
    "ibgeCodigo": 2107100,
    "uf": "MA",
    "nome": "Morros"
  },
  {
    "codigoTse": "08427",
    "ibgeCodigo": 2111631,
    "uf": "MA",
    "nome": "S�o Raimundo Do Doca Bezerra"
  },
  {
    "codigoTse": "08435",
    "ibgeCodigo": 2107209,
    "uf": "MA",
    "nome": "Nina Rodrigues"
  },
  {
    "codigoTse": "08443",
    "ibgeCodigo": 2111672,
    "uf": "MA",
    "nome": "S�o Roberto"
  },
  {
    "codigoTse": "08451",
    "ibgeCodigo": 2107308,
    "uf": "MA",
    "nome": "Nova Iorque"
  },
  {
    "codigoTse": "08460",
    "ibgeCodigo": 2111722,
    "uf": "MA",
    "nome": "Satubinha"
  },
  {
    "codigoTse": "08478",
    "ibgeCodigo": 2107407,
    "uf": "MA",
    "nome": "Olho D'�gua Das Cunh�s"
  },
  {
    "codigoTse": "08486",
    "ibgeCodigo": 2111748,
    "uf": "MA",
    "nome": "Senador Alexandre Costa"
  },
  {
    "codigoTse": "08494",
    "ibgeCodigo": 2107506,
    "uf": "MA",
    "nome": "Pa�o Do Lumiar"
  },
  {
    "codigoTse": "08508",
    "ibgeCodigo": 2111763,
    "uf": "MA",
    "nome": "Senador La Rocque"
  },
  {
    "codigoTse": "08516",
    "ibgeCodigo": 2107605,
    "uf": "MA",
    "nome": "Palmeir�ndia"
  },
  {
    "codigoTse": "08524",
    "ibgeCodigo": 2111789,
    "uf": "MA",
    "nome": "Serrano Do Maranh�o"
  },
  {
    "codigoTse": "08532",
    "ibgeCodigo": 2107704,
    "uf": "MA",
    "nome": "Paraibano"
  },
  {
    "codigoTse": "08540",
    "ibgeCodigo": 2111953,
    "uf": "MA",
    "nome": "Sucupira Do Riach�o"
  },
  {
    "codigoTse": "08559",
    "ibgeCodigo": 2107803,
    "uf": "MA",
    "nome": "Parnarama"
  },
  {
    "codigoTse": "08567",
    "ibgeCodigo": 2112233,
    "uf": "MA",
    "nome": "Trizidela Do Vale"
  },
  {
    "codigoTse": "08575",
    "ibgeCodigo": 2107902,
    "uf": "MA",
    "nome": "Passagem Franca"
  },
  {
    "codigoTse": "08583",
    "ibgeCodigo": 2112274,
    "uf": "MA",
    "nome": "Tufil�ndia"
  },
  {
    "codigoTse": "08591",
    "ibgeCodigo": 2108009,
    "uf": "MA",
    "nome": "Pastos Bons"
  },
  {
    "codigoTse": "08605",
    "ibgeCodigo": 2112456,
    "uf": "MA",
    "nome": "Turil�ndia"
  },
  {
    "codigoTse": "08613",
    "ibgeCodigo": 2108207,
    "uf": "MA",
    "nome": "Pedreiras"
  },
  {
    "codigoTse": "08621",
    "ibgeCodigo": 2112852,
    "uf": "MA",
    "nome": "Vila Nova Dos Mart�rios"
  },
  {
    "codigoTse": "08630",
    "ibgeCodigo": 2108306,
    "uf": "MA",
    "nome": "Penalva"
  },
  {
    "codigoTse": "08656",
    "ibgeCodigo": 2108405,
    "uf": "MA",
    "nome": "Peri Mirim"
  },
  {
    "codigoTse": "08672",
    "ibgeCodigo": 2108504,
    "uf": "MA",
    "nome": "Pindar�-Mirim"
  },
  {
    "codigoTse": "08699",
    "ibgeCodigo": 2108603,
    "uf": "MA",
    "nome": "Pinheiro"
  },
  {
    "codigoTse": "08710",
    "ibgeCodigo": 2108702,
    "uf": "MA",
    "nome": "Pio Xii"
  },
  {
    "codigoTse": "08737",
    "ibgeCodigo": 2108801,
    "uf": "MA",
    "nome": "Pirapemas"
  },
  {
    "codigoTse": "08753",
    "ibgeCodigo": 2108900,
    "uf": "MA",
    "nome": "Po��o De Pedras"
  },
  {
    "codigoTse": "08770",
    "ibgeCodigo": 2109007,
    "uf": "MA",
    "nome": "Porto Franco"
  },
  {
    "codigoTse": "08796",
    "ibgeCodigo": 2109106,
    "uf": "MA",
    "nome": "Presidente Dutra"
  },
  {
    "codigoTse": "08818",
    "ibgeCodigo": 2109205,
    "uf": "MA",
    "nome": "Presidente Juscelino"
  },
  {
    "codigoTse": "08834",
    "ibgeCodigo": 2109304,
    "uf": "MA",
    "nome": "Presidente Vargas"
  },
  {
    "codigoTse": "08850",
    "ibgeCodigo": 2109403,
    "uf": "MA",
    "nome": "Primeira Cruz"
  },
  {
    "codigoTse": "08877",
    "ibgeCodigo": 2109502,
    "uf": "MA",
    "nome": "Riach�o"
  },
  {
    "codigoTse": "08893",
    "ibgeCodigo": 2111201,
    "uf": "MA",
    "nome": "S�o Jos� De Ribamar"
  },
  {
    "codigoTse": "08915",
    "ibgeCodigo": 2109601,
    "uf": "MA",
    "nome": "Ros�rio"
  },
  {
    "codigoTse": "08931",
    "ibgeCodigo": 2109700,
    "uf": "MA",
    "nome": "Samba�ba"
  },
  {
    "codigoTse": "08958",
    "ibgeCodigo": 2109809,
    "uf": "MA",
    "nome": "Santa Helena"
  },
  {
    "codigoTse": "08974",
    "ibgeCodigo": 2110005,
    "uf": "MA",
    "nome": "Santa Luzia"
  },
  {
    "codigoTse": "08990",
    "ibgeCodigo": 2110104,
    "uf": "MA",
    "nome": "Santa Quit�ria Do Maranh�o"
  },
  {
    "codigoTse": "09016",
    "ibgeCodigo": 2110203,
    "uf": "MA",
    "nome": "Santa Rita"
  },
  {
    "codigoTse": "09032",
    "ibgeCodigo": 2110302,
    "uf": "MA",
    "nome": "Santo Ant�nio Dos Lopes"
  },
  {
    "codigoTse": "09059",
    "ibgeCodigo": 2110401,
    "uf": "MA",
    "nome": "S�o Benedito Do Rio Preto"
  },
  {
    "codigoTse": "09075",
    "ibgeCodigo": 2110500,
    "uf": "MA",
    "nome": "S�o Bento"
  },
  {
    "codigoTse": "09091",
    "ibgeCodigo": 2110609,
    "uf": "MA",
    "nome": "S�o Bernardo"
  },
  {
    "codigoTse": "09113",
    "ibgeCodigo": 2110708,
    "uf": "MA",
    "nome": "S�o Domingos Do Maranh�o"
  },
  {
    "codigoTse": "09130",
    "ibgeCodigo": 2110807,
    "uf": "MA",
    "nome": "S�o F�lix De Balsas"
  },
  {
    "codigoTse": "09156",
    "ibgeCodigo": 2110906,
    "uf": "MA",
    "nome": "S�o Francisco Do Maranh�o"
  },
  {
    "codigoTse": "09172",
    "ibgeCodigo": 2111003,
    "uf": "MA",
    "nome": "S�o Jo�o Batista"
  },
  {
    "codigoTse": "09199",
    "ibgeCodigo": 2111102,
    "uf": "MA",
    "nome": "S�o Jo�o Dos Patos"
  },
  {
    "codigoTse": "09210",
    "ibgeCodigo": 2111300,
    "uf": "MA",
    "nome": "S�o Lu�s"
  },
  {
    "codigoTse": "09237",
    "ibgeCodigo": 2111508,
    "uf": "MA",
    "nome": "S�o Mateus Do Maranh�o"
  },
  {
    "codigoTse": "09253",
    "ibgeCodigo": 2111607,
    "uf": "MA",
    "nome": "S�o Raimundo Das Mangabeiras"
  },
  {
    "codigoTse": "09270",
    "ibgeCodigo": 2111706,
    "uf": "MA",
    "nome": "S�o Vicente Ferrer"
  },
  {
    "codigoTse": "09296",
    "ibgeCodigo": 2111805,
    "uf": "MA",
    "nome": "S�tio Novo"
  },
  {
    "codigoTse": "09318",
    "ibgeCodigo": 2111904,
    "uf": "MA",
    "nome": "Sucupira Do Norte"
  },
  {
    "codigoTse": "09334",
    "ibgeCodigo": 2112001,
    "uf": "MA",
    "nome": "Tasso Fragoso"
  },
  {
    "codigoTse": "09350",
    "ibgeCodigo": 2112100,
    "uf": "MA",
    "nome": "Timbiras"
  },
  {
    "codigoTse": "09377",
    "ibgeCodigo": 2112209,
    "uf": "MA",
    "nome": "Timon"
  },
  {
    "codigoTse": "09393",
    "ibgeCodigo": 2112308,
    "uf": "MA",
    "nome": "Tuntum"
  },
  {
    "codigoTse": "09415",
    "ibgeCodigo": 2112407,
    "uf": "MA",
    "nome": "Turia�u"
  },
  {
    "codigoTse": "09431",
    "ibgeCodigo": 2112506,
    "uf": "MA",
    "nome": "Tut�ia"
  },
  {
    "codigoTse": "09458",
    "ibgeCodigo": 2112605,
    "uf": "MA",
    "nome": "Urbano Santos"
  },
  {
    "codigoTse": "09474",
    "ibgeCodigo": 2112704,
    "uf": "MA",
    "nome": "Vargem Grande"
  },
  {
    "codigoTse": "09490",
    "ibgeCodigo": 2112803,
    "uf": "MA",
    "nome": "Viana"
  },
  {
    "codigoTse": "09512",
    "ibgeCodigo": 2112902,
    "uf": "MA",
    "nome": "Vit�ria Do Mearim"
  },
  {
    "codigoTse": "09539",
    "ibgeCodigo": 2113009,
    "uf": "MA",
    "nome": "Vitorino Freire"
  },
  {
    "codigoTse": "09555",
    "ibgeCodigo": 2102002,
    "uf": "MA",
    "nome": "Bom Jardim"
  },
  {
    "codigoTse": "09571",
    "ibgeCodigo": 2109908,
    "uf": "MA",
    "nome": "Santa In�s"
  },
  {
    "codigoTse": "09598",
    "ibgeCodigo": 2108108,
    "uf": "MA",
    "nome": "Paulo Ramos"
  },
  {
    "codigoTse": "09610",
    "ibgeCodigo": 2100055,
    "uf": "MA",
    "nome": "A�ail�ndia"
  },
  {
    "codigoTse": "09636",
    "ibgeCodigo": 2104057,
    "uf": "MA",
    "nome": "Estreito"
  },
  {
    "codigoTse": "09652",
    "ibgeCodigo": 2110039,
    "uf": "MA",
    "nome": "Santa Luzia Do Paru�"
  },
  {
    "codigoTse": "09679",
    "ibgeCodigo": 2100956,
    "uf": "MA",
    "nome": "Arame"
  },
  {
    "codigoTse": "09695",
    "ibgeCodigo": 2106755,
    "uf": "MA",
    "nome": "Miranda Do Norte"
  },
  {
    "codigoTse": "09717",
    "ibgeCodigo": 2114007,
    "uf": "MA",
    "nome": "Z� Doca"
  },
  {
    "codigoTse": "10006",
    "ibgeCodigo": 2201960,
    "uf": "PI",
    "nome": "Brasileira"
  },
  {
    "codigoTse": "10014",
    "ibgeCodigo": 2200103,
    "uf": "PI",
    "nome": "Agricol�ndia"
  },
  {
    "codigoTse": "10022",
    "ibgeCodigo": 2200277,
    "uf": "PI",
    "nome": "Alegrete Do Piau�"
  },
  {
    "codigoTse": "10030",
    "ibgeCodigo": 2200202,
    "uf": "PI",
    "nome": "�gua Branca"
  },
  {
    "codigoTse": "10049",
    "ibgeCodigo": 2201150,
    "uf": "PI",
    "nome": "Baixa Grande Do Ribeiro"
  },
  {
    "codigoTse": "10057",
    "ibgeCodigo": 2200301,
    "uf": "PI",
    "nome": "Alto Long�"
  },
  {
    "codigoTse": "10065",
    "ibgeCodigo": 2201919,
    "uf": "PI",
    "nome": "Bom Princ�pio Do Piau�"
  },
  {
    "codigoTse": "10073",
    "ibgeCodigo": 2200400,
    "uf": "PI",
    "nome": "Altos"
  },
  {
    "codigoTse": "10081",
    "ibgeCodigo": 2201929,
    "uf": "PI",
    "nome": "Bonfim Do Piau�"
  },
  {
    "codigoTse": "10090",
    "ibgeCodigo": 2200509,
    "uf": "PI",
    "nome": "Amarante"
  },
  {
    "codigoTse": "10103",
    "ibgeCodigo": 2202026,
    "uf": "PI",
    "nome": "Buriti Dos Montes"
  },
  {
    "codigoTse": "10111",
    "ibgeCodigo": 2200608,
    "uf": "PI",
    "nome": "Angical Do Piau�"
  },
  {
    "codigoTse": "10120",
    "ibgeCodigo": 2202059,
    "uf": "PI",
    "nome": "Cabeceiras Do Piau�"
  },
  {
    "codigoTse": "10138",
    "ibgeCodigo": 2200707,
    "uf": "PI",
    "nome": "An�sio De Abreu"
  },
  {
    "codigoTse": "10146",
    "ibgeCodigo": 2202091,
    "uf": "PI",
    "nome": "Caldeir�o Grande Do Piau�"
  },
  {
    "codigoTse": "10154",
    "ibgeCodigo": 2200806,
    "uf": "PI",
    "nome": "Ant�nio Almeida"
  },
  {
    "codigoTse": "10162",
    "ibgeCodigo": 2202251,
    "uf": "PI",
    "nome": "Canavieira"
  },
  {
    "codigoTse": "10170",
    "ibgeCodigo": 2200905,
    "uf": "PI",
    "nome": "Aroazes"
  },
  {
    "codigoTse": "10189",
    "ibgeCodigo": 2202737,
    "uf": "PI",
    "nome": "Coivaras"
  },
  {
    "codigoTse": "10197",
    "ibgeCodigo": 2201002,
    "uf": "PI",
    "nome": "Arraial"
  },
  {
    "codigoTse": "10200",
    "ibgeCodigo": 2202752,
    "uf": "PI",
    "nome": "Col�nia Do Gurgu�ia"
  },
  {
    "codigoTse": "10219",
    "ibgeCodigo": 2201101,
    "uf": "PI",
    "nome": "Avelino Lopes"
  },
  {
    "codigoTse": "10227",
    "ibgeCodigo": 2202778,
    "uf": "PI",
    "nome": "Col�nia Do Piau�"
  },
  {
    "codigoTse": "10235",
    "ibgeCodigo": 2201200,
    "uf": "PI",
    "nome": "Barras"
  },
  {
    "codigoTse": "10243",
    "ibgeCodigo": 2202851,
    "uf": "PI",
    "nome": "Coronel Jos� Dias"
  },
  {
    "codigoTse": "10251",
    "ibgeCodigo": 2201309,
    "uf": "PI",
    "nome": "Barreiras Do Piau�"
  },
  {
    "codigoTse": "10260",
    "ibgeCodigo": 2203750,
    "uf": "PI",
    "nome": "Fartura Do Piau�"
  },
  {
    "codigoTse": "10278",
    "ibgeCodigo": 2201408,
    "uf": "PI",
    "nome": "Barro Duro"
  },
  {
    "codigoTse": "10286",
    "ibgeCodigo": 2205151,
    "uf": "PI",
    "nome": "Jacobina Do Piau�"
  },
  {
    "codigoTse": "10294",
    "ibgeCodigo": 2201507,
    "uf": "PI",
    "nome": "Batalha"
  },
  {
    "codigoTse": "10308",
    "ibgeCodigo": 2205250,
    "uf": "PI",
    "nome": "Jardim Do Mulato"
  },
  {
    "codigoTse": "10316",
    "ibgeCodigo": 2201606,
    "uf": "PI",
    "nome": "Beneditinos"
  },
  {
    "codigoTse": "10324",
    "ibgeCodigo": 2205557,
    "uf": "PI",
    "nome": "Lagoa Alegre"
  },
  {
    "codigoTse": "10332",
    "ibgeCodigo": 2201705,
    "uf": "PI",
    "nome": "Bertol�nia"
  },
  {
    "codigoTse": "10340",
    "ibgeCodigo": 2205565,
    "uf": "PI",
    "nome": "Lagoa Do Barro Do Piau�"
  },
  {
    "codigoTse": "10359",
    "ibgeCodigo": 2201804,
    "uf": "PI",
    "nome": "Bocaina"
  },
  {
    "codigoTse": "10367",
    "ibgeCodigo": 2205953,
    "uf": "PI",
    "nome": "Marcol�ndia"
  },
  {
    "codigoTse": "10375",
    "ibgeCodigo": 2201903,
    "uf": "PI",
    "nome": "Bom Jesus"
  },
  {
    "codigoTse": "10383",
    "ibgeCodigo": 2207777,
    "uf": "PI",
    "nome": "Patos Do Piau�"
  },
  {
    "codigoTse": "10391",
    "ibgeCodigo": 2202000,
    "uf": "PI",
    "nome": "Buriti Dos Lopes"
  },
  {
    "codigoTse": "10405",
    "ibgeCodigo": 2207751,
    "uf": "PI",
    "nome": "Passagem Franca Do Piau�"
  },
  {
    "codigoTse": "10413",
    "ibgeCodigo": 2202109,
    "uf": "PI",
    "nome": "Campinas Do Piau�"
  },
  {
    "codigoTse": "10421",
    "ibgeCodigo": 2208650,
    "uf": "PI",
    "nome": "Queimada Nova"
  },
  {
    "codigoTse": "10430",
    "ibgeCodigo": 2202208,
    "uf": "PI",
    "nome": "Campo Maior"
  },
  {
    "codigoTse": "10448",
    "ibgeCodigo": 2209153,
    "uf": "PI",
    "nome": "Santa Cruz Dos Milagres"
  },
  {
    "codigoTse": "10456",
    "ibgeCodigo": 2202307,
    "uf": "PI",
    "nome": "Canto Do Buriti"
  },
  {
    "codigoTse": "10464",
    "ibgeCodigo": 2209377,
    "uf": "PI",
    "nome": "Santa Rosa Do Piau�"
  },
  {
    "codigoTse": "10472",
    "ibgeCodigo": 2202406,
    "uf": "PI",
    "nome": "Capit�o De Campos"
  },
  {
    "codigoTse": "10480",
    "ibgeCodigo": 2209351,
    "uf": "PI",
    "nome": "Santana Do Piau�"
  },
  {
    "codigoTse": "10499",
    "ibgeCodigo": 2202505,
    "uf": "PI",
    "nome": "Caracol"
  },
  {
    "codigoTse": "10502",
    "ibgeCodigo": 2209559,
    "uf": "PI",
    "nome": "S�o Braz Do Piau�"
  },
  {
    "codigoTse": "10510",
    "ibgeCodigo": 2202604,
    "uf": "PI",
    "nome": "Castelo Do Piau�"
  },
  {
    "codigoTse": "10529",
    "ibgeCodigo": 2210052,
    "uf": "PI",
    "nome": "S�o Jos� Do Divino"
  },
  {
    "codigoTse": "10537",
    "ibgeCodigo": 2202703,
    "uf": "PI",
    "nome": "Cocal"
  },
  {
    "codigoTse": "10545",
    "ibgeCodigo": 2210656,
    "uf": "PI",
    "nome": "Sigefredo Pacheco"
  },
  {
    "codigoTse": "10553",
    "ibgeCodigo": 2202802,
    "uf": "PI",
    "nome": "Concei��o Do Canind�"
  },
  {
    "codigoTse": "10561",
    "ibgeCodigo": 2210359,
    "uf": "PI",
    "nome": "S�o Louren�o Do Piau�"
  },
  {
    "codigoTse": "10570",
    "ibgeCodigo": 2202901,
    "uf": "PI",
    "nome": "Corrente"
  },
  {
    "codigoTse": "10588",
    "ibgeCodigo": 2211357,
    "uf": "PI",
    "nome": "V�rzea Branca"
  },
  {
    "codigoTse": "10596",
    "ibgeCodigo": 2203008,
    "uf": "PI",
    "nome": "Cristal�ndia Do Piau�"
  },
  {
    "codigoTse": "10600",
    "ibgeCodigo": 2201176,
    "uf": "PI",
    "nome": "Barra D'Alc�ntara"
  },
  {
    "codigoTse": "10618",
    "ibgeCodigo": 2203107,
    "uf": "PI",
    "nome": "Cristino Castro"
  },
  {
    "codigoTse": "10626",
    "ibgeCodigo": 2201556,
    "uf": "PI",
    "nome": "Bela Vista Do Piau�"
  },
  {
    "codigoTse": "10634",
    "ibgeCodigo": 2203206,
    "uf": "PI",
    "nome": "Curimat�"
  },
  {
    "codigoTse": "10642",
    "ibgeCodigo": 2201988,
    "uf": "PI",
    "nome": "Brejo Do Piau�"
  },
  {
    "codigoTse": "10650",
    "ibgeCodigo": 2203305,
    "uf": "PI",
    "nome": "Demerval Lob�o"
  },
  {
    "codigoTse": "10669",
    "ibgeCodigo": 2201770,
    "uf": "PI",
    "nome": "Boa Hora"
  },
  {
    "codigoTse": "10677",
    "ibgeCodigo": 2203404,
    "uf": "PI",
    "nome": "Dom Expedito Lopes"
  },
  {
    "codigoTse": "10685",
    "ibgeCodigo": 2203453,
    "uf": "PI",
    "nome": "Dom Inoc�ncio"
  },
  {
    "codigoTse": "10693",
    "ibgeCodigo": 2203503,
    "uf": "PI",
    "nome": "Elesb�o Veloso"
  },
  {
    "codigoTse": "10707",
    "ibgeCodigo": 2202455,
    "uf": "PI",
    "nome": "Capit�o Gerv�sio Oliveira"
  },
  {
    "codigoTse": "10715",
    "ibgeCodigo": 2203602,
    "uf": "PI",
    "nome": "Eliseu Martins"
  },
  {
    "codigoTse": "10723",
    "ibgeCodigo": 2202133,
    "uf": "PI",
    "nome": "Campo Grande Do Piau�"
  },
  {
    "codigoTse": "10731",
    "ibgeCodigo": 2203701,
    "uf": "PI",
    "nome": "Esperantina"
  },
  {
    "codigoTse": "10740",
    "ibgeCodigo": 2202174,
    "uf": "PI",
    "nome": "Campo Largo Do Piau�"
  },
  {
    "codigoTse": "10758",
    "ibgeCodigo": 2203800,
    "uf": "PI",
    "nome": "Flores Do Piau�"
  },
  {
    "codigoTse": "10766",
    "ibgeCodigo": 2203230,
    "uf": "PI",
    "nome": "Currais"
  },
  {
    "codigoTse": "10774",
    "ibgeCodigo": 2203909,
    "uf": "PI",
    "nome": "Floriano"
  },
  {
    "codigoTse": "10782",
    "ibgeCodigo": 2204352,
    "uf": "PI",
    "nome": "Geminiano"
  },
  {
    "codigoTse": "10790",
    "ibgeCodigo": 2204006,
    "uf": "PI",
    "nome": "Francin�polis"
  },
  {
    "codigoTse": "10804",
    "ibgeCodigo": 2204550,
    "uf": "PI",
    "nome": "Guaribas"
  },
  {
    "codigoTse": "10812",
    "ibgeCodigo": 2204105,
    "uf": "PI",
    "nome": "Francisco Ayres"
  },
  {
    "codigoTse": "10820",
    "ibgeCodigo": 2204659,
    "uf": "PI",
    "nome": "Ilha Grande"
  },
  {
    "codigoTse": "10839",
    "ibgeCodigo": 2204204,
    "uf": "PI",
    "nome": "Francisco Santos"
  },
  {
    "codigoTse": "10847",
    "ibgeCodigo": 2205532,
    "uf": "PI",
    "nome": "Jurema"
  },
  {
    "codigoTse": "10855",
    "ibgeCodigo": 2204303,
    "uf": "PI",
    "nome": "Fronteiras"
  },
  {
    "codigoTse": "10863",
    "ibgeCodigo": 2205573,
    "uf": "PI",
    "nome": "Lagoa De S�o Francisco"
  },
  {
    "codigoTse": "10871",
    "ibgeCodigo": 2204402,
    "uf": "PI",
    "nome": "Gilbu�s"
  },
  {
    "codigoTse": "10880",
    "ibgeCodigo": 2206654,
    "uf": "PI",
    "nome": "Morro Cabe�a No Tempo"
  },
  {
    "codigoTse": "10898",
    "ibgeCodigo": 2204501,
    "uf": "PI",
    "nome": "Guadalupe"
  },
  {
    "codigoTse": "10901",
    "ibgeCodigo": 2206951,
    "uf": "PI",
    "nome": "Novo Santo Ant�nio"
  },
  {
    "codigoTse": "10910",
    "ibgeCodigo": 2204600,
    "uf": "PI",
    "nome": "Hugo Napole�o"
  },
  {
    "codigoTse": "10928",
    "ibgeCodigo": 2206753,
    "uf": "PI",
    "nome": "Nossa Senhora De Nazar�"
  },
  {
    "codigoTse": "10936",
    "ibgeCodigo": 2204709,
    "uf": "PI",
    "nome": "Inhuma"
  },
  {
    "codigoTse": "10944",
    "ibgeCodigo": 2207553,
    "uf": "PI",
    "nome": "Paquet�"
  },
  {
    "codigoTse": "10952",
    "ibgeCodigo": 2204808,
    "uf": "PI",
    "nome": "Ipiranga Do Piau�"
  },
  {
    "codigoTse": "10960",
    "ibgeCodigo": 2207959,
    "uf": "PI",
    "nome": "Nova Santa Rita"
  },
  {
    "codigoTse": "10979",
    "ibgeCodigo": 2204907,
    "uf": "PI",
    "nome": "Isa�as Coelho"
  },
  {
    "codigoTse": "10987",
    "ibgeCodigo": 2209971,
    "uf": "PI",
    "nome": "S�o Jo�o Do Arraial"
  },
  {
    "codigoTse": "10995",
    "ibgeCodigo": 2205003,
    "uf": "PI",
    "nome": "Itain�polis"
  },
  {
    "codigoTse": "11010",
    "ibgeCodigo": 2205102,
    "uf": "PI",
    "nome": "Itaueira"
  },
  {
    "codigoTse": "11037",
    "ibgeCodigo": 2205201,
    "uf": "PI",
    "nome": "Jaic�s"
  },
  {
    "codigoTse": "11053",
    "ibgeCodigo": 2205300,
    "uf": "PI",
    "nome": "Jerumenha"
  },
  {
    "codigoTse": "11070",
    "ibgeCodigo": 2205409,
    "uf": "PI",
    "nome": "Joaquim Pires"
  },
  {
    "codigoTse": "11088",
    "ibgeCodigo": 2209856,
    "uf": "PI",
    "nome": "S�o Jo�o Da Canabrava"
  },
  {
    "codigoTse": "11096",
    "ibgeCodigo": 2205508,
    "uf": "PI",
    "nome": "Jos� De Freitas"
  },
  {
    "codigoTse": "11118",
    "ibgeCodigo": 2205607,
    "uf": "PI",
    "nome": "Landri Sales"
  },
  {
    "codigoTse": "11134",
    "ibgeCodigo": 2205706,
    "uf": "PI",
    "nome": "Lu�s Correia"
  },
  {
    "codigoTse": "11150",
    "ibgeCodigo": 2205805,
    "uf": "PI",
    "nome": "Luzil�ndia"
  },
  {
    "codigoTse": "11177",
    "ibgeCodigo": 2205904,
    "uf": "PI",
    "nome": "Manoel Em�dio"
  },
  {
    "codigoTse": "11193",
    "ibgeCodigo": 2206001,
    "uf": "PI",
    "nome": "Marcos Parente"
  },
  {
    "codigoTse": "11215",
    "ibgeCodigo": 2206100,
    "uf": "PI",
    "nome": "Matias Ol�mpio"
  },
  {
    "codigoTse": "11231",
    "ibgeCodigo": 2206209,
    "uf": "PI",
    "nome": "Miguel Alves"
  },
  {
    "codigoTse": "11258",
    "ibgeCodigo": 2206308,
    "uf": "PI",
    "nome": "Miguel Le�o"
  },
  {
    "codigoTse": "11274",
    "ibgeCodigo": 2206407,
    "uf": "PI",
    "nome": "Monsenhor Gil"
  },
  {
    "codigoTse": "11290",
    "ibgeCodigo": 2206506,
    "uf": "PI",
    "nome": "Monsenhor Hip�lito"
  },
  {
    "codigoTse": "11312",
    "ibgeCodigo": 2206605,
    "uf": "PI",
    "nome": "Monte Alegre Do Piau�"
  },
  {
    "codigoTse": "11339",
    "ibgeCodigo": 2206704,
    "uf": "PI",
    "nome": "Nazar� Do Piau�"
  },
  {
    "codigoTse": "11355",
    "ibgeCodigo": 2206803,
    "uf": "PI",
    "nome": "Nossa Senhora Dos Rem�dios"
  },
  {
    "codigoTse": "11371",
    "ibgeCodigo": 2206902,
    "uf": "PI",
    "nome": "Novo Oriente Do Piau�"
  },
  {
    "codigoTse": "11398",
    "ibgeCodigo": 2207009,
    "uf": "PI",
    "nome": "Oeiras"
  },
  {
    "codigoTse": "11410",
    "ibgeCodigo": 2203420,
    "uf": "PI",
    "nome": "Domingos Mour�o"
  },
  {
    "codigoTse": "11436",
    "ibgeCodigo": 2207207,
    "uf": "PI",
    "nome": "Padre Marcos"
  },
  {
    "codigoTse": "11452",
    "ibgeCodigo": 2207306,
    "uf": "PI",
    "nome": "Paes Landim"
  },
  {
    "codigoTse": "11479",
    "ibgeCodigo": 2207405,
    "uf": "PI",
    "nome": "Palmeira Do Piau�"
  },
  {
    "codigoTse": "11495",
    "ibgeCodigo": 2207504,
    "uf": "PI",
    "nome": "Palmeirais"
  },
  {
    "codigoTse": "11517",
    "ibgeCodigo": 2207603,
    "uf": "PI",
    "nome": "Parnagu�"
  },
  {
    "codigoTse": "11533",
    "ibgeCodigo": 2207702,
    "uf": "PI",
    "nome": "Parna�ba"
  },
  {
    "codigoTse": "11550",
    "ibgeCodigo": 2207801,
    "uf": "PI",
    "nome": "Paulistana"
  },
  {
    "codigoTse": "11576",
    "ibgeCodigo": 2207900,
    "uf": "PI",
    "nome": "Pedro Ii"
  },
  {
    "codigoTse": "11592",
    "ibgeCodigo": 2208007,
    "uf": "PI",
    "nome": "Picos"
  },
  {
    "codigoTse": "11614",
    "ibgeCodigo": 2208106,
    "uf": "PI",
    "nome": "Pimenteiras"
  },
  {
    "codigoTse": "11630",
    "ibgeCodigo": 2208205,
    "uf": "PI",
    "nome": "Pio Ix"
  },
  {
    "codigoTse": "11657",
    "ibgeCodigo": 2208304,
    "uf": "PI",
    "nome": "Piracuruca"
  },
  {
    "codigoTse": "11673",
    "ibgeCodigo": 2208403,
    "uf": "PI",
    "nome": "Piripiri"
  },
  {
    "codigoTse": "11690",
    "ibgeCodigo": 2208502,
    "uf": "PI",
    "nome": "Porto"
  },
  {
    "codigoTse": "11711",
    "ibgeCodigo": 2208601,
    "uf": "PI",
    "nome": "Prata Do Piau�"
  },
  {
    "codigoTse": "11738",
    "ibgeCodigo": 2208700,
    "uf": "PI",
    "nome": "Reden��o Do Gurgu�ia"
  },
  {
    "codigoTse": "11754",
    "ibgeCodigo": 2208809,
    "uf": "PI",
    "nome": "Regenera��o"
  },
  {
    "codigoTse": "11770",
    "ibgeCodigo": 2208908,
    "uf": "PI",
    "nome": "Ribeiro Gon�alves"
  },
  {
    "codigoTse": "11797",
    "ibgeCodigo": 2209005,
    "uf": "PI",
    "nome": "Rio Grande Do Piau�"
  },
  {
    "codigoTse": "11819",
    "ibgeCodigo": 2209104,
    "uf": "PI",
    "nome": "Santa Cruz Do Piau�"
  },
  {
    "codigoTse": "11835",
    "ibgeCodigo": 2209203,
    "uf": "PI",
    "nome": "Santa Filomena"
  },
  {
    "codigoTse": "11851",
    "ibgeCodigo": 2209302,
    "uf": "PI",
    "nome": "Santa Luz"
  },
  {
    "codigoTse": "11878",
    "ibgeCodigo": 2209401,
    "uf": "PI",
    "nome": "Santo Ant�nio De Lisboa"
  },
  {
    "codigoTse": "11894",
    "ibgeCodigo": 2209500,
    "uf": "PI",
    "nome": "Santo In�cio Do Piau�"
  },
  {
    "codigoTse": "11916",
    "ibgeCodigo": 2209609,
    "uf": "PI",
    "nome": "S�o F�lix Do Piau�"
  },
  {
    "codigoTse": "11932",
    "ibgeCodigo": 2209708,
    "uf": "PI",
    "nome": "S�o Francisco Do Piau�"
  },
  {
    "codigoTse": "11959",
    "ibgeCodigo": 2209807,
    "uf": "PI",
    "nome": "S�o Gon�alo Do Piau�"
  },
  {
    "codigoTse": "11975",
    "ibgeCodigo": 2209906,
    "uf": "PI",
    "nome": "S�o Jo�o Da Serra"
  },
  {
    "codigoTse": "11991",
    "ibgeCodigo": 2210003,
    "uf": "PI",
    "nome": "S�o Jo�o Do Piau�"
  },
  {
    "codigoTse": "12009",
    "ibgeCodigo": 2209872,
    "uf": "PI",
    "nome": "S�o Jo�o Da Fronteira"
  },
  {
    "codigoTse": "12017",
    "ibgeCodigo": 2210102,
    "uf": "PI",
    "nome": "S�o Jos� Do Peixe"
  },
  {
    "codigoTse": "12025",
    "ibgeCodigo": 2209955,
    "uf": "PI",
    "nome": "S�o Jo�o Da Varjota"
  },
  {
    "codigoTse": "12033",
    "ibgeCodigo": 2210201,
    "uf": "PI",
    "nome": "S�o Jos� Do Piau�"
  },
  {
    "codigoTse": "12041",
    "ibgeCodigo": 2210623,
    "uf": "PI",
    "nome": "Sebasti�o Barros"
  },
  {
    "codigoTse": "12050",
    "ibgeCodigo": 2210300,
    "uf": "PI",
    "nome": "S�o Juli�o"
  },
  {
    "codigoTse": "12068",
    "ibgeCodigo": 2210631,
    "uf": "PI",
    "nome": "Sebasti�o Leal"
  },
  {
    "codigoTse": "12076",
    "ibgeCodigo": 2210409,
    "uf": "PI",
    "nome": "S�o Miguel Do Tapuio"
  },
  {
    "codigoTse": "12084",
    "ibgeCodigo": 2200459,
    "uf": "PI",
    "nome": "Alvorada Do Gurgu�ia"
  },
  {
    "codigoTse": "12092",
    "ibgeCodigo": 2210508,
    "uf": "PI",
    "nome": "S�o Pedro Do Piau�"
  },
  {
    "codigoTse": "12106",
    "ibgeCodigo": 2201051,
    "uf": "PI",
    "nome": "Assun��o Do Piau�"
  },
  {
    "codigoTse": "12114",
    "ibgeCodigo": 2210607,
    "uf": "PI",
    "nome": "S�o Raimundo Nonato"
  },
  {
    "codigoTse": "12122",
    "ibgeCodigo": 2201739,
    "uf": "PI",
    "nome": "Bet�nia Do Piau�"
  },
  {
    "codigoTse": "12130",
    "ibgeCodigo": 2210706,
    "uf": "PI",
    "nome": "Sim�es"
  },
  {
    "codigoTse": "12149",
    "ibgeCodigo": 2201945,
    "uf": "PI",
    "nome": "Boqueir�o Do Piau�"
  },
  {
    "codigoTse": "12157",
    "ibgeCodigo": 2210805,
    "uf": "PI",
    "nome": "Simpl�cio Mendes"
  },
  {
    "codigoTse": "12165",
    "ibgeCodigo": 2202554,
    "uf": "PI",
    "nome": "Caridade Do Piau�"
  },
  {
    "codigoTse": "12173",
    "ibgeCodigo": 2210904,
    "uf": "PI",
    "nome": "Socorro Do Piau�"
  },
  {
    "codigoTse": "12181",
    "ibgeCodigo": 2203271,
    "uf": "PI",
    "nome": "Curral Novo Do Piau�"
  },
  {
    "codigoTse": "12190",
    "ibgeCodigo": 2211001,
    "uf": "PI",
    "nome": "Teresina"
  },
  {
    "codigoTse": "12203",
    "ibgeCodigo": 2205524,
    "uf": "PI",
    "nome": "J�lio Borges"
  },
  {
    "codigoTse": "12211",
    "ibgeCodigo": 2211100,
    "uf": "PI",
    "nome": "Uni�o"
  },
  {
    "codigoTse": "12220",
    "ibgeCodigo": 2205599,
    "uf": "PI",
    "nome": "Lagoa Do S�tio"
  },
  {
    "codigoTse": "12238",
    "ibgeCodigo": 2211209,
    "uf": "PI",
    "nome": "Uru�u�"
  },
  {
    "codigoTse": "12246",
    "ibgeCodigo": 2206357,
    "uf": "PI",
    "nome": "Milton Brand�o"
  },
  {
    "codigoTse": "12254",
    "ibgeCodigo": 2211308,
    "uf": "PI",
    "nome": "Valen�a Do Piau�"
  },
  {
    "codigoTse": "12262",
    "ibgeCodigo": 2207355,
    "uf": "PI",
    "nome": "Paje� Do Piau�"
  },
  {
    "codigoTse": "12270",
    "ibgeCodigo": 2211407,
    "uf": "PI",
    "nome": "V�rzea Grande"
  },
  {
    "codigoTse": "12289",
    "ibgeCodigo": 2207850,
    "uf": "PI",
    "nome": "Pavussu"
  },
  {
    "codigoTse": "12297",
    "ibgeCodigo": 2203354,
    "uf": "PI",
    "nome": "Dirceu Arcoverde"
  },
  {
    "codigoTse": "12300",
    "ibgeCodigo": 2208858,
    "uf": "PI",
    "nome": "Riacho Frio"
  },
  {
    "codigoTse": "12319",
    "ibgeCodigo": 2200251,
    "uf": "PI",
    "nome": "Alagoinha Do Piau�"
  },
  {
    "codigoTse": "12327",
    "ibgeCodigo": 2200053,
    "uf": "PI",
    "nome": "Acau�"
  },
  {
    "codigoTse": "12335",
    "ibgeCodigo": 2201572,
    "uf": "PI",
    "nome": "Bel�m Do Piau�"
  },
  {
    "codigoTse": "12343",
    "ibgeCodigo": 2202075,
    "uf": "PI",
    "nome": "Cajazeiras Do Piau�"
  },
  {
    "codigoTse": "12351",
    "ibgeCodigo": 2202117,
    "uf": "PI",
    "nome": "Campo Alegre Do Fidalgo"
  },
  {
    "codigoTse": "12360",
    "ibgeCodigo": 2202711,
    "uf": "PI",
    "nome": "Cocal De Telha"
  },
  {
    "codigoTse": "12378",
    "ibgeCodigo": 2204154,
    "uf": "PI",
    "nome": "Francisco Macedo"
  },
  {
    "codigoTse": "12386",
    "ibgeCodigo": 2205359,
    "uf": "PI",
    "nome": "Jo�o Costa"
  },
  {
    "codigoTse": "12394",
    "ibgeCodigo": 2205276,
    "uf": "PI",
    "nome": "Jatob� Do Piau�"
  },
  {
    "codigoTse": "12408",
    "ibgeCodigo": 2205458,
    "uf": "PI",
    "nome": "Joca Marques"
  },
  {
    "codigoTse": "12416",
    "ibgeCodigo": 2205516,
    "uf": "PI",
    "nome": "Juazeiro Do Piau�"
  },
  {
    "codigoTse": "12424",
    "ibgeCodigo": 2205581,
    "uf": "PI",
    "nome": "Lagoa Do Piau�"
  },
  {
    "codigoTse": "12432",
    "ibgeCodigo": 2205540,
    "uf": "PI",
    "nome": "Lagoinha Do Piau�"
  },
  {
    "codigoTse": "12440",
    "ibgeCodigo": 2205854,
    "uf": "PI",
    "nome": "Madeiro"
  },
  {
    "codigoTse": "12459",
    "ibgeCodigo": 2206670,
    "uf": "PI",
    "nome": "Morro Do Chap�u Do Piau�"
  },
  {
    "codigoTse": "12467",
    "ibgeCodigo": 2206050,
    "uf": "PI",
    "nome": "Massap� Do Piau�"
  },
  {
    "codigoTse": "12475",
    "ibgeCodigo": 2206696,
    "uf": "PI",
    "nome": "Murici Dos Portelas"
  },
  {
    "codigoTse": "12483",
    "ibgeCodigo": 2207108,
    "uf": "PI",
    "nome": "Olho D'�gua Do Piau�"
  },
  {
    "codigoTse": "12491",
    "ibgeCodigo": 2207934,
    "uf": "PI",
    "nome": "Pedro Laurentino"
  },
  {
    "codigoTse": "12505",
    "ibgeCodigo": 2209658,
    "uf": "PI",
    "nome": "S�o Francisco De Assis Do Piau�"
  },
  {
    "codigoTse": "12513",
    "ibgeCodigo": 2210938,
    "uf": "PI",
    "nome": "Sussuapara"
  },
  {
    "codigoTse": "12521",
    "ibgeCodigo": 2210979,
    "uf": "PI",
    "nome": "Tanque Do Piau�"
  },
  {
    "codigoTse": "12530",
    "ibgeCodigo": 2210953,
    "uf": "PI",
    "nome": "Tamboril Do Piau�"
  },
  {
    "codigoTse": "12548",
    "ibgeCodigo": 2211605,
    "uf": "PI",
    "nome": "Vila Nova Do Piau�"
  },
  {
    "codigoTse": "12556",
    "ibgeCodigo": 2211506,
    "uf": "PI",
    "nome": "Vera Mendes"
  },
  {
    "codigoTse": "12564",
    "ibgeCodigo": 2211704,
    "uf": "PI",
    "nome": "Wall Ferraz"
  },
  {
    "codigoTse": "12572",
    "ibgeCodigo": 2202083,
    "uf": "PI",
    "nome": "Cajueiro Da Praia"
  },
  {
    "codigoTse": "12580",
    "ibgeCodigo": 2203255,
    "uf": "PI",
    "nome": "Curralinhos"
  },
  {
    "codigoTse": "12599",
    "ibgeCodigo": 2208551,
    "uf": "PI",
    "nome": "Porto Alegre Do Piau�"
  },
  {
    "codigoTse": "12602",
    "ibgeCodigo": 2208874,
    "uf": "PI",
    "nome": "Ribeira Do Piau�"
  },
  {
    "codigoTse": "12610",
    "ibgeCodigo": 2209757,
    "uf": "PI",
    "nome": "S�o Gon�alo Do Gurgu�ia"
  },
  {
    "codigoTse": "12629",
    "ibgeCodigo": 2210375,
    "uf": "PI",
    "nome": "S�o Luis Do Piau�"
  },
  {
    "codigoTse": "12637",
    "ibgeCodigo": 2203859,
    "uf": "PI",
    "nome": "Floresta Do Piau�"
  },
  {
    "codigoTse": "12653",
    "ibgeCodigo": 2209450,
    "uf": "PI",
    "nome": "Santo Ant�nio Dos Milagres"
  },
  {
    "codigoTse": "12661",
    "ibgeCodigo": 2210383,
    "uf": "PI",
    "nome": "S�o Miguel Da Baixa Grande"
  },
  {
    "codigoTse": "12670",
    "ibgeCodigo": 2202539,
    "uf": "PI",
    "nome": "Cara�bas Do Piau�"
  },
  {
    "codigoTse": "12688",
    "ibgeCodigo": 2202653,
    "uf": "PI",
    "nome": "Caxing�"
  },
  {
    "codigoTse": "12696",
    "ibgeCodigo": 2202729,
    "uf": "PI",
    "nome": "Cocal Dos Alves"
  },
  {
    "codigoTse": "12700",
    "ibgeCodigo": 2210391,
    "uf": "PI",
    "nome": "S�o Miguel Do Fidalgo"
  },
  {
    "codigoTse": "12718",
    "ibgeCodigo": 2207793,
    "uf": "PI",
    "nome": "Pau D'Arco Do Piau�"
  },
  {
    "codigoTse": "12726",
    "ibgeCodigo": 2206720,
    "uf": "PI",
    "nome": "Naz�ria"
  },
  {
    "codigoTse": "12734",
    "ibgeCodigo": 2200954,
    "uf": "PI",
    "nome": "Aroeiras Do Itaim"
  },
  {
    "codigoTse": "13005",
    "ibgeCodigo": 2307254,
    "uf": "CE",
    "nome": "Jijoca De Jericoacoara"
  },
  {
    "codigoTse": "13013",
    "ibgeCodigo": 2300101,
    "uf": "CE",
    "nome": "Abaiara"
  },
  {
    "codigoTse": "13021",
    "ibgeCodigo": 2307635,
    "uf": "CE",
    "nome": "Madalena"
  },
  {
    "codigoTse": "13030",
    "ibgeCodigo": 2300200,
    "uf": "CE",
    "nome": "Acara�"
  },
  {
    "codigoTse": "13048",
    "ibgeCodigo": 2310951,
    "uf": "CE",
    "nome": "Pires Ferreira"
  },
  {
    "codigoTse": "13056",
    "ibgeCodigo": 2300309,
    "uf": "CE",
    "nome": "Acopiara"
  },
  {
    "codigoTse": "13064",
    "ibgeCodigo": 2304657,
    "uf": "CE",
    "nome": "Gra�a"
  },
  {
    "codigoTse": "13072",
    "ibgeCodigo": 2300408,
    "uf": "CE",
    "nome": "Aiuaba"
  },
  {
    "codigoTse": "13080",
    "ibgeCodigo": 2313559,
    "uf": "CE",
    "nome": "Tururu"
  },
  {
    "codigoTse": "13099",
    "ibgeCodigo": 2300507,
    "uf": "CE",
    "nome": "Alc�ntaras"
  },
  {
    "codigoTse": "13102",
    "ibgeCodigo": 2311264,
    "uf": "CE",
    "nome": "Quiterian�polis"
  },
  {
    "codigoTse": "13110",
    "ibgeCodigo": 2300606,
    "uf": "CE",
    "nome": "Altaneira"
  },
  {
    "codigoTse": "13129",
    "ibgeCodigo": 2301950,
    "uf": "CE",
    "nome": "Barreira"
  },
  {
    "codigoTse": "13137",
    "ibgeCodigo": 2300705,
    "uf": "CE",
    "nome": "Alto Santo"
  },
  {
    "codigoTse": "13145",
    "ibgeCodigo": 2300150,
    "uf": "CE",
    "nome": "Acarape"
  },
  {
    "codigoTse": "13153",
    "ibgeCodigo": 2300804,
    "uf": "CE",
    "nome": "Antonina Do Norte"
  },
  {
    "codigoTse": "13161",
    "ibgeCodigo": 2303956,
    "uf": "CE",
    "nome": "Chorozinho"
  },
  {
    "codigoTse": "13170",
    "ibgeCodigo": 2300903,
    "uf": "CE",
    "nome": "Apuiar�s"
  },
  {
    "codigoTse": "13188",
    "ibgeCodigo": 2305233,
    "uf": "CE",
    "nome": "Horizonte"
  },
  {
    "codigoTse": "13196",
    "ibgeCodigo": 2301000,
    "uf": "CE",
    "nome": "Aquiraz"
  },
  {
    "codigoTse": "13200",
    "ibgeCodigo": 2304277,
    "uf": "CE",
    "nome": "Erer�"
  },
  {
    "codigoTse": "13218",
    "ibgeCodigo": 2301109,
    "uf": "CE",
    "nome": "Aracati"
  },
  {
    "codigoTse": "13226",
    "ibgeCodigo": 2304285,
    "uf": "CE",
    "nome": "Eus�bio"
  },
  {
    "codigoTse": "13234",
    "ibgeCodigo": 2301208,
    "uf": "CE",
    "nome": "Aracoiaba"
  },
  {
    "codigoTse": "13242",
    "ibgeCodigo": 2304954,
    "uf": "CE",
    "nome": "Guai�ba"
  },
  {
    "codigoTse": "13250",
    "ibgeCodigo": 2301307,
    "uf": "CE",
    "nome": "Araripe"
  },
  {
    "codigoTse": "13269",
    "ibgeCodigo": 2311231,
    "uf": "CE",
    "nome": "Potiretama"
  },
  {
    "codigoTse": "13277",
    "ibgeCodigo": 2301406,
    "uf": "CE",
    "nome": "Aratuba"
  },
  {
    "codigoTse": "13285",
    "ibgeCodigo": 2310852,
    "uf": "CE",
    "nome": "Pindoretama"
  },
  {
    "codigoTse": "13293",
    "ibgeCodigo": 2301505,
    "uf": "CE",
    "nome": "Arneiroz"
  },
  {
    "codigoTse": "13307",
    "ibgeCodigo": 2309458,
    "uf": "CE",
    "nome": "Ocara"
  },
  {
    "codigoTse": "13315",
    "ibgeCodigo": 2301604,
    "uf": "CE",
    "nome": "Assar�"
  },
  {
    "codigoTse": "13323",
    "ibgeCodigo": 2313351,
    "uf": "CE",
    "nome": "Teju�uoca"
  },
  {
    "codigoTse": "13331",
    "ibgeCodigo": 2301703,
    "uf": "CE",
    "nome": "Aurora"
  },
  {
    "codigoTse": "13340",
    "ibgeCodigo": 2305654,
    "uf": "CE",
    "nome": "Ipaporanga"
  },
  {
    "codigoTse": "13358",
    "ibgeCodigo": 2301802,
    "uf": "CE",
    "nome": "Baixio"
  },
  {
    "codigoTse": "13366",
    "ibgeCodigo": 2313252,
    "uf": "CE",
    "nome": "Tarrafas"
  },
  {
    "codigoTse": "13374",
    "ibgeCodigo": 2301901,
    "uf": "CE",
    "nome": "Barbalha"
  },
  {
    "codigoTse": "13382",
    "ibgeCodigo": 2301851,
    "uf": "CE",
    "nome": "Banabui�"
  },
  {
    "codigoTse": "13390",
    "ibgeCodigo": 2302008,
    "uf": "CE",
    "nome": "Barro"
  },
  {
    "codigoTse": "13404",
    "ibgeCodigo": 2302057,
    "uf": "CE",
    "nome": "Barroquinha"
  },
  {
    "codigoTse": "13412",
    "ibgeCodigo": 2302107,
    "uf": "CE",
    "nome": "Baturit�"
  },
  {
    "codigoTse": "13420",
    "ibgeCodigo": 2301257,
    "uf": "CE",
    "nome": "Ararend�"
  },
  {
    "codigoTse": "13439",
    "ibgeCodigo": 2302206,
    "uf": "CE",
    "nome": "Beberibe"
  },
  {
    "codigoTse": "13447",
    "ibgeCodigo": 2303659,
    "uf": "CE",
    "nome": "Catunda"
  },
  {
    "codigoTse": "13455",
    "ibgeCodigo": 2302305,
    "uf": "CE",
    "nome": "Bela Cruz"
  },
  {
    "codigoTse": "13463",
    "ibgeCodigo": 2303931,
    "uf": "CE",
    "nome": "Chor�"
  },
  {
    "codigoTse": "13471",
    "ibgeCodigo": 2302404,
    "uf": "CE",
    "nome": "Boa Viagem"
  },
  {
    "codigoTse": "13480",
    "ibgeCodigo": 2306256,
    "uf": "CE",
    "nome": "Itaitinga"
  },
  {
    "codigoTse": "13498",
    "ibgeCodigo": 2302503,
    "uf": "CE",
    "nome": "Brejo Santo"
  },
  {
    "codigoTse": "13501",
    "ibgeCodigo": 2304459,
    "uf": "CE",
    "nome": "Fortim"
  },
  {
    "codigoTse": "13510",
    "ibgeCodigo": 2302602,
    "uf": "CE",
    "nome": "Camocim"
  },
  {
    "codigoTse": "13536",
    "ibgeCodigo": 2302701,
    "uf": "CE",
    "nome": "Campos Sales"
  },
  {
    "codigoTse": "13552",
    "ibgeCodigo": 2302800,
    "uf": "CE",
    "nome": "Canind�"
  },
  {
    "codigoTse": "13579",
    "ibgeCodigo": 2302909,
    "uf": "CE",
    "nome": "Capistrano"
  },
  {
    "codigoTse": "13595",
    "ibgeCodigo": 2303006,
    "uf": "CE",
    "nome": "Caridade"
  },
  {
    "codigoTse": "13617",
    "ibgeCodigo": 2303105,
    "uf": "CE",
    "nome": "Carir�"
  },
  {
    "codigoTse": "13633",
    "ibgeCodigo": 2303204,
    "uf": "CE",
    "nome": "Cariria�u"
  },
  {
    "codigoTse": "13650",
    "ibgeCodigo": 2303303,
    "uf": "CE",
    "nome": "Cari�s"
  },
  {
    "codigoTse": "13676",
    "ibgeCodigo": 2303402,
    "uf": "CE",
    "nome": "Carnaubal"
  },
  {
    "codigoTse": "13692",
    "ibgeCodigo": 2303501,
    "uf": "CE",
    "nome": "Cascavel"
  },
  {
    "codigoTse": "13714",
    "ibgeCodigo": 2303600,
    "uf": "CE",
    "nome": "Catarina"
  },
  {
    "codigoTse": "13730",
    "ibgeCodigo": 2303709,
    "uf": "CE",
    "nome": "Caucaia"
  },
  {
    "codigoTse": "13757",
    "ibgeCodigo": 2303808,
    "uf": "CE",
    "nome": "Cedro"
  },
  {
    "codigoTse": "13773",
    "ibgeCodigo": 2303907,
    "uf": "CE",
    "nome": "Chaval"
  },
  {
    "codigoTse": "13811",
    "ibgeCodigo": 2304004,
    "uf": "CE",
    "nome": "Corea�"
  },
  {
    "codigoTse": "13838",
    "ibgeCodigo": 2304103,
    "uf": "CE",
    "nome": "Crate�s"
  },
  {
    "codigoTse": "13854",
    "ibgeCodigo": 2304202,
    "uf": "CE",
    "nome": "Crato"
  },
  {
    "codigoTse": "13870",
    "ibgeCodigo": 2304301,
    "uf": "CE",
    "nome": "Farias Brito"
  },
  {
    "codigoTse": "13897",
    "ibgeCodigo": 2304400,
    "uf": "CE",
    "nome": "Fortaleza"
  },
  {
    "codigoTse": "13919",
    "ibgeCodigo": 2304509,
    "uf": "CE",
    "nome": "Frecheirinha"
  },
  {
    "codigoTse": "13935",
    "ibgeCodigo": 2304608,
    "uf": "CE",
    "nome": "General Sampaio"
  },
  {
    "codigoTse": "13951",
    "ibgeCodigo": 2304707,
    "uf": "CE",
    "nome": "Granja"
  },
  {
    "codigoTse": "13978",
    "ibgeCodigo": 2304806,
    "uf": "CE",
    "nome": "Granjeiro"
  },
  {
    "codigoTse": "13994",
    "ibgeCodigo": 2304905,
    "uf": "CE",
    "nome": "Groa�ras"
  },
  {
    "codigoTse": "14010",
    "ibgeCodigo": 2305001,
    "uf": "CE",
    "nome": "Guaraciaba Do Norte"
  },
  {
    "codigoTse": "14036",
    "ibgeCodigo": 2305100,
    "uf": "CE",
    "nome": "Guaramiranga"
  },
  {
    "codigoTse": "14052",
    "ibgeCodigo": 2305209,
    "uf": "CE",
    "nome": "Hidrol�ndia"
  },
  {
    "codigoTse": "14060",
    "ibgeCodigo": 2305266,
    "uf": "CE",
    "nome": "Ibaretama"
  },
  {
    "codigoTse": "14079",
    "ibgeCodigo": 2305308,
    "uf": "CE",
    "nome": "Ibiapina"
  },
  {
    "codigoTse": "14095",
    "ibgeCodigo": 2305407,
    "uf": "CE",
    "nome": "Ic�"
  },
  {
    "codigoTse": "14117",
    "ibgeCodigo": 2305506,
    "uf": "CE",
    "nome": "Iguatu"
  },
  {
    "codigoTse": "14133",
    "ibgeCodigo": 2305605,
    "uf": "CE",
    "nome": "Independ�ncia"
  },
  {
    "codigoTse": "14150",
    "ibgeCodigo": 2305704,
    "uf": "CE",
    "nome": "Ipaumirim"
  },
  {
    "codigoTse": "14176",
    "ibgeCodigo": 2305803,
    "uf": "CE",
    "nome": "Ipu"
  },
  {
    "codigoTse": "14192",
    "ibgeCodigo": 2305902,
    "uf": "CE",
    "nome": "Ipueiras"
  },
  {
    "codigoTse": "14214",
    "ibgeCodigo": 2306009,
    "uf": "CE",
    "nome": "Iracema"
  },
  {
    "codigoTse": "14230",
    "ibgeCodigo": 2306108,
    "uf": "CE",
    "nome": "Irau�uba"
  },
  {
    "codigoTse": "14257",
    "ibgeCodigo": 2306207,
    "uf": "CE",
    "nome": "Itai�aba"
  },
  {
    "codigoTse": "14273",
    "ibgeCodigo": 2306306,
    "uf": "CE",
    "nome": "Itapaj�"
  },
  {
    "codigoTse": "14290",
    "ibgeCodigo": 2306405,
    "uf": "CE",
    "nome": "Itapipoca"
  },
  {
    "codigoTse": "14311",
    "ibgeCodigo": 2306504,
    "uf": "CE",
    "nome": "Itapi�na"
  },
  {
    "codigoTse": "14338",
    "ibgeCodigo": 2306603,
    "uf": "CE",
    "nome": "Itatira"
  },
  {
    "codigoTse": "14354",
    "ibgeCodigo": 2306702,
    "uf": "CE",
    "nome": "Jaguaretama"
  },
  {
    "codigoTse": "14370",
    "ibgeCodigo": 2306801,
    "uf": "CE",
    "nome": "Jaguaribara"
  },
  {
    "codigoTse": "14397",
    "ibgeCodigo": 2306900,
    "uf": "CE",
    "nome": "Jaguaribe"
  },
  {
    "codigoTse": "14419",
    "ibgeCodigo": 2307007,
    "uf": "CE",
    "nome": "Jaguaruana"
  },
  {
    "codigoTse": "14435",
    "ibgeCodigo": 2307106,
    "uf": "CE",
    "nome": "Jardim"
  },
  {
    "codigoTse": "14451",
    "ibgeCodigo": 2307205,
    "uf": "CE",
    "nome": "Jati"
  },
  {
    "codigoTse": "14478",
    "ibgeCodigo": 2307304,
    "uf": "CE",
    "nome": "Juazeiro Do Norte"
  },
  {
    "codigoTse": "14494",
    "ibgeCodigo": 2307403,
    "uf": "CE",
    "nome": "Juc�s"
  },
  {
    "codigoTse": "14516",
    "ibgeCodigo": 2307502,
    "uf": "CE",
    "nome": "Lavras Da Mangabeira"
  },
  {
    "codigoTse": "14532",
    "ibgeCodigo": 2307601,
    "uf": "CE",
    "nome": "Limoeiro Do Norte"
  },
  {
    "codigoTse": "14559",
    "ibgeCodigo": 2307700,
    "uf": "CE",
    "nome": "Maranguape"
  },
  {
    "codigoTse": "14575",
    "ibgeCodigo": 2307809,
    "uf": "CE",
    "nome": "Marco"
  },
  {
    "codigoTse": "14591",
    "ibgeCodigo": 2307908,
    "uf": "CE",
    "nome": "Martin�pole"
  },
  {
    "codigoTse": "14613",
    "ibgeCodigo": 2308005,
    "uf": "CE",
    "nome": "Massap�"
  },
  {
    "codigoTse": "14630",
    "ibgeCodigo": 2308104,
    "uf": "CE",
    "nome": "Mauriti"
  },
  {
    "codigoTse": "14656",
    "ibgeCodigo": 2308203,
    "uf": "CE",
    "nome": "Meruoca"
  },
  {
    "codigoTse": "14672",
    "ibgeCodigo": 2308302,
    "uf": "CE",
    "nome": "Milagres"
  },
  {
    "codigoTse": "14680",
    "ibgeCodigo": 2308377,
    "uf": "CE",
    "nome": "Mira�ma"
  },
  {
    "codigoTse": "14699",
    "ibgeCodigo": 2308401,
    "uf": "CE",
    "nome": "Miss�o Velha"
  },
  {
    "codigoTse": "14710",
    "ibgeCodigo": 2308500,
    "uf": "CE",
    "nome": "Momba�a"
  },
  {
    "codigoTse": "14737",
    "ibgeCodigo": 2308609,
    "uf": "CE",
    "nome": "Monsenhor Tabosa"
  },
  {
    "codigoTse": "14753",
    "ibgeCodigo": 2308708,
    "uf": "CE",
    "nome": "Morada Nova"
  },
  {
    "codigoTse": "14770",
    "ibgeCodigo": 2308807,
    "uf": "CE",
    "nome": "Mora�jo"
  },
  {
    "codigoTse": "14796",
    "ibgeCodigo": 2308906,
    "uf": "CE",
    "nome": "Morrinhos"
  },
  {
    "codigoTse": "14818",
    "ibgeCodigo": 2309003,
    "uf": "CE",
    "nome": "Mucambo"
  },
  {
    "codigoTse": "14834",
    "ibgeCodigo": 2309102,
    "uf": "CE",
    "nome": "Mulungu"
  },
  {
    "codigoTse": "14850",
    "ibgeCodigo": 2309201,
    "uf": "CE",
    "nome": "Nova Olinda"
  },
  {
    "codigoTse": "14877",
    "ibgeCodigo": 2309300,
    "uf": "CE",
    "nome": "Nova Russas"
  },
  {
    "codigoTse": "14893",
    "ibgeCodigo": 2309409,
    "uf": "CE",
    "nome": "Novo Oriente"
  },
  {
    "codigoTse": "14915",
    "ibgeCodigo": 2309508,
    "uf": "CE",
    "nome": "Or�s"
  },
  {
    "codigoTse": "14931",
    "ibgeCodigo": 2309607,
    "uf": "CE",
    "nome": "Pacajus"
  },
  {
    "codigoTse": "14958",
    "ibgeCodigo": 2309706,
    "uf": "CE",
    "nome": "Pacatuba"
  },
  {
    "codigoTse": "14974",
    "ibgeCodigo": 2309805,
    "uf": "CE",
    "nome": "Pacoti"
  },
  {
    "codigoTse": "14990",
    "ibgeCodigo": 2309904,
    "uf": "CE",
    "nome": "Pacuj�"
  },
  {
    "codigoTse": "15016",
    "ibgeCodigo": 2310001,
    "uf": "CE",
    "nome": "Palhano"
  },
  {
    "codigoTse": "15032",
    "ibgeCodigo": 2310100,
    "uf": "CE",
    "nome": "Palm�cia"
  },
  {
    "codigoTse": "15059",
    "ibgeCodigo": 2310209,
    "uf": "CE",
    "nome": "Paracuru"
  },
  {
    "codigoTse": "15075",
    "ibgeCodigo": 2310308,
    "uf": "CE",
    "nome": "Parambu"
  },
  {
    "codigoTse": "15091",
    "ibgeCodigo": 2310407,
    "uf": "CE",
    "nome": "Paramoti"
  },
  {
    "codigoTse": "15113",
    "ibgeCodigo": 2310506,
    "uf": "CE",
    "nome": "Pedra Branca"
  },
  {
    "codigoTse": "15130",
    "ibgeCodigo": 2310605,
    "uf": "CE",
    "nome": "Penaforte"
  },
  {
    "codigoTse": "15156",
    "ibgeCodigo": 2310704,
    "uf": "CE",
    "nome": "Pentecoste"
  },
  {
    "codigoTse": "15172",
    "ibgeCodigo": 2310803,
    "uf": "CE",
    "nome": "Pereiro"
  },
  {
    "codigoTse": "15199",
    "ibgeCodigo": 2310902,
    "uf": "CE",
    "nome": "Piquet Carneiro"
  },
  {
    "codigoTse": "15210",
    "ibgeCodigo": 2311009,
    "uf": "CE",
    "nome": "Poranga"
  },
  {
    "codigoTse": "15237",
    "ibgeCodigo": 2311108,
    "uf": "CE",
    "nome": "Porteiras"
  },
  {
    "codigoTse": "15253",
    "ibgeCodigo": 2311207,
    "uf": "CE",
    "nome": "Potengi"
  },
  {
    "codigoTse": "15270",
    "ibgeCodigo": 2311306,
    "uf": "CE",
    "nome": "Quixad�"
  },
  {
    "codigoTse": "15296",
    "ibgeCodigo": 2311405,
    "uf": "CE",
    "nome": "Quixeramobim"
  },
  {
    "codigoTse": "15318",
    "ibgeCodigo": 2311504,
    "uf": "CE",
    "nome": "Quixer�"
  },
  {
    "codigoTse": "15334",
    "ibgeCodigo": 2311603,
    "uf": "CE",
    "nome": "Reden��o"
  },
  {
    "codigoTse": "15350",
    "ibgeCodigo": 2311702,
    "uf": "CE",
    "nome": "Reriutaba"
  },
  {
    "codigoTse": "15377",
    "ibgeCodigo": 2311801,
    "uf": "CE",
    "nome": "Russas"
  },
  {
    "codigoTse": "15393",
    "ibgeCodigo": 2311900,
    "uf": "CE",
    "nome": "Saboeiro"
  },
  {
    "codigoTse": "15415",
    "ibgeCodigo": 2312007,
    "uf": "CE",
    "nome": "Santana Do Acara�"
  },
  {
    "codigoTse": "15431",
    "ibgeCodigo": 2312106,
    "uf": "CE",
    "nome": "Santana Do Cariri"
  },
  {
    "codigoTse": "15440",
    "ibgeCodigo": 2311959,
    "uf": "CE",
    "nome": "Salitre"
  },
  {
    "codigoTse": "15458",
    "ibgeCodigo": 2312205,
    "uf": "CE",
    "nome": "Santa Quit�ria"
  },
  {
    "codigoTse": "15474",
    "ibgeCodigo": 2312304,
    "uf": "CE",
    "nome": "S�o Benedito"
  },
  {
    "codigoTse": "15490",
    "ibgeCodigo": 2312403,
    "uf": "CE",
    "nome": "S�o Gon�alo Do Amarante"
  },
  {
    "codigoTse": "15512",
    "ibgeCodigo": 2312502,
    "uf": "CE",
    "nome": "S�o Jo�o Do Jaguaribe"
  },
  {
    "codigoTse": "15539",
    "ibgeCodigo": 2312601,
    "uf": "CE",
    "nome": "S�o Lu�s Do Curu"
  },
  {
    "codigoTse": "15555",
    "ibgeCodigo": 2312700,
    "uf": "CE",
    "nome": "Senador Pompeu"
  },
  {
    "codigoTse": "15571",
    "ibgeCodigo": 2312809,
    "uf": "CE",
    "nome": "Senador S�"
  },
  {
    "codigoTse": "15598",
    "ibgeCodigo": 2312908,
    "uf": "CE",
    "nome": "Sobral"
  },
  {
    "codigoTse": "15610",
    "ibgeCodigo": 2313005,
    "uf": "CE",
    "nome": "Solon�pole"
  },
  {
    "codigoTse": "15636",
    "ibgeCodigo": 2313104,
    "uf": "CE",
    "nome": "Tabuleiro Do Norte"
  },
  {
    "codigoTse": "15652",
    "ibgeCodigo": 2313203,
    "uf": "CE",
    "nome": "Tamboril"
  },
  {
    "codigoTse": "15679",
    "ibgeCodigo": 2313302,
    "uf": "CE",
    "nome": "Tau�"
  },
  {
    "codigoTse": "15695",
    "ibgeCodigo": 2313401,
    "uf": "CE",
    "nome": "Tiangu�"
  },
  {
    "codigoTse": "15717",
    "ibgeCodigo": 2313500,
    "uf": "CE",
    "nome": "Trairi"
  },
  {
    "codigoTse": "15733",
    "ibgeCodigo": 2313609,
    "uf": "CE",
    "nome": "Ubajara"
  },
  {
    "codigoTse": "15750",
    "ibgeCodigo": 2313708,
    "uf": "CE",
    "nome": "Umari"
  },
  {
    "codigoTse": "15776",
    "ibgeCodigo": 2313807,
    "uf": "CE",
    "nome": "Uruburetama"
  },
  {
    "codigoTse": "15792",
    "ibgeCodigo": 2313906,
    "uf": "CE",
    "nome": "Uruoca"
  },
  {
    "codigoTse": "15814",
    "ibgeCodigo": 2314003,
    "uf": "CE",
    "nome": "V�rzea Alegre"
  },
  {
    "codigoTse": "15830",
    "ibgeCodigo": 2314102,
    "uf": "CE",
    "nome": "Vi�osa Do Cear�"
  },
  {
    "codigoTse": "15857",
    "ibgeCodigo": 2307650,
    "uf": "CE",
    "nome": "Maracana�"
  },
  {
    "codigoTse": "15873",
    "ibgeCodigo": 2300754,
    "uf": "CE",
    "nome": "Amontada"
  },
  {
    "codigoTse": "15881",
    "ibgeCodigo": 2304236,
    "uf": "CE",
    "nome": "Croat�"
  },
  {
    "codigoTse": "15890",
    "ibgeCodigo": 2304251,
    "uf": "CE",
    "nome": "Cruz"
  },
  {
    "codigoTse": "15911",
    "ibgeCodigo": 2304350,
    "uf": "CE",
    "nome": "Forquilha"
  },
  {
    "codigoTse": "15920",
    "ibgeCodigo": 2305332,
    "uf": "CE",
    "nome": "Ibicuitinga"
  },
  {
    "codigoTse": "15938",
    "ibgeCodigo": 2305357,
    "uf": "CE",
    "nome": "Icapu�"
  },
  {
    "codigoTse": "15954",
    "ibgeCodigo": 2306553,
    "uf": "CE",
    "nome": "Itarema"
  },
  {
    "codigoTse": "15970",
    "ibgeCodigo": 2308351,
    "uf": "CE",
    "nome": "Milh�"
  },
  {
    "codigoTse": "15989",
    "ibgeCodigo": 2304269,
    "uf": "CE",
    "nome": "Deputado Irapuan Pinheiro"
  },
  {
    "codigoTse": "15997",
    "ibgeCodigo": 2310258,
    "uf": "CE",
    "nome": "Paraipaba"
  },
  {
    "codigoTse": "16004",
    "ibgeCodigo": 2414159,
    "uf": "RN",
    "nome": "Tenente Laurentino Cruz"
  },
  {
    "codigoTse": "16012",
    "ibgeCodigo": 2400109,
    "uf": "RN",
    "nome": "Acari"
  },
  {
    "codigoTse": "16020",
    "ibgeCodigo": 2413359,
    "uf": "RN",
    "nome": "Serra Do Mel"
  },
  {
    "codigoTse": "16039",
    "ibgeCodigo": 2400208,
    "uf": "RN",
    "nome": "A�u"
  },
  {
    "codigoTse": "16047",
    "ibgeCodigo": 2401859,
    "uf": "RN",
    "nome": "Cai�ara Do Norte"
  },
  {
    "codigoTse": "16055",
    "ibgeCodigo": 2400307,
    "uf": "RN",
    "nome": "Afonso Bezerra"
  },
  {
    "codigoTse": "16063",
    "ibgeCodigo": 2412559,
    "uf": "RN",
    "nome": "S�o Miguel Do Gostoso"
  },
  {
    "codigoTse": "16071",
    "ibgeCodigo": 2400406,
    "uf": "RN",
    "nome": "�gua Nova"
  },
  {
    "codigoTse": "16080",
    "ibgeCodigo": 2404853,
    "uf": "RN",
    "nome": "Itaj�"
  },
  {
    "codigoTse": "16098",
    "ibgeCodigo": 2400505,
    "uf": "RN",
    "nome": "Alexandria"
  },
  {
    "codigoTse": "16101",
    "ibgeCodigo": 2401651,
    "uf": "RN",
    "nome": "Bod�"
  },
  {
    "codigoTse": "16110",
    "ibgeCodigo": 2400604,
    "uf": "RN",
    "nome": "Almino Afonso"
  },
  {
    "codigoTse": "16128",
    "ibgeCodigo": 2414456,
    "uf": "RN",
    "nome": "Triunfo Potiguar"
  },
  {
    "codigoTse": "16136",
    "ibgeCodigo": 2400703,
    "uf": "RN",
    "nome": "Alto Do Rodrigues"
  },
  {
    "codigoTse": "16144",
    "ibgeCodigo": 2403756,
    "uf": "RN",
    "nome": "Fernando Pedroza"
  },
  {
    "codigoTse": "16152",
    "ibgeCodigo": 2400802,
    "uf": "RN",
    "nome": "Angicos"
  },
  {
    "codigoTse": "16160",
    "ibgeCodigo": 2407252,
    "uf": "RN",
    "nome": "Major Sales"
  },
  {
    "codigoTse": "16179",
    "ibgeCodigo": 2400901,
    "uf": "RN",
    "nome": "Ant�nio Martins"
  },
  {
    "codigoTse": "16187",
    "ibgeCodigo": 2414753,
    "uf": "RN",
    "nome": "Venha-Ver"
  },
  {
    "codigoTse": "16195",
    "ibgeCodigo": 2401008,
    "uf": "RN",
    "nome": "Apodi"
  },
  {
    "codigoTse": "16209",
    "ibgeCodigo": 2413557,
    "uf": "RN",
    "nome": "Serrinha Dos Pintos"
  },
  {
    "codigoTse": "16217",
    "ibgeCodigo": 2401107,
    "uf": "RN",
    "nome": "Areia Branca"
  },
  {
    "codigoTse": "16225",
    "ibgeCodigo": 2411056,
    "uf": "RN",
    "nome": "Tibau"
  },
  {
    "codigoTse": "16233",
    "ibgeCodigo": 2401206,
    "uf": "RN",
    "nome": "Ar�s"
  },
  {
    "codigoTse": "16241",
    "ibgeCodigo": 2409332,
    "uf": "RN",
    "nome": "Santa Maria"
  },
  {
    "codigoTse": "16250",
    "ibgeCodigo": 2401305,
    "uf": "RN",
    "nome": "Augusto Severo"
  },
  {
    "codigoTse": "16268",
    "ibgeCodigo": 2408953,
    "uf": "RN",
    "nome": "Rio Do Fogo"
  },
  {
    "codigoTse": "16276",
    "ibgeCodigo": 2401404,
    "uf": "RN",
    "nome": "Ba�a Formosa"
  },
  {
    "codigoTse": "16284",
    "ibgeCodigo": 2410256,
    "uf": "RN",
    "nome": "Porto Do Mangue"
  },
  {
    "codigoTse": "16292",
    "ibgeCodigo": 2401503,
    "uf": "RN",
    "nome": "Barcelona"
  },
  {
    "codigoTse": "16306",
    "ibgeCodigo": 2406155,
    "uf": "RN",
    "nome": "Jundi�"
  },
  {
    "codigoTse": "16314",
    "ibgeCodigo": 2401602,
    "uf": "RN",
    "nome": "Bento Fernandes"
  },
  {
    "codigoTse": "16330",
    "ibgeCodigo": 2401701,
    "uf": "RN",
    "nome": "Bom Jesus"
  },
  {
    "codigoTse": "16357",
    "ibgeCodigo": 2401800,
    "uf": "RN",
    "nome": "Brejinho"
  },
  {
    "codigoTse": "16373",
    "ibgeCodigo": 2401909,
    "uf": "RN",
    "nome": "Cai�ara Do Rio Do Vento"
  },
  {
    "codigoTse": "16390",
    "ibgeCodigo": 2402006,
    "uf": "RN",
    "nome": "Caic�"
  },
  {
    "codigoTse": "16411",
    "ibgeCodigo": 2402105,
    "uf": "RN",
    "nome": "Campo Redondo"
  },
  {
    "codigoTse": "16438",
    "ibgeCodigo": 2402204,
    "uf": "RN",
    "nome": "Canguaretama"
  },
  {
    "codigoTse": "16454",
    "ibgeCodigo": 2402303,
    "uf": "RN",
    "nome": "Cara�bas"
  },
  {
    "codigoTse": "16470",
    "ibgeCodigo": 2402402,
    "uf": "RN",
    "nome": "Carna�ba Dos Dantas"
  },
  {
    "codigoTse": "16497",
    "ibgeCodigo": 2402501,
    "uf": "RN",
    "nome": "Carnaubais"
  },
  {
    "codigoTse": "16519",
    "ibgeCodigo": 2402600,
    "uf": "RN",
    "nome": "Cear�-Mirim"
  },
  {
    "codigoTse": "16535",
    "ibgeCodigo": 2402709,
    "uf": "RN",
    "nome": "Cerro Cor�"
  },
  {
    "codigoTse": "16551",
    "ibgeCodigo": 2402808,
    "uf": "RN",
    "nome": "Coronel Ezequiel"
  },
  {
    "codigoTse": "16578",
    "ibgeCodigo": 2402907,
    "uf": "RN",
    "nome": "Coronel Jo�o Pessoa"
  },
  {
    "codigoTse": "16594",
    "ibgeCodigo": 2403004,
    "uf": "RN",
    "nome": "Cruzeta"
  },
  {
    "codigoTse": "16616",
    "ibgeCodigo": 2403103,
    "uf": "RN",
    "nome": "Currais Novos"
  },
  {
    "codigoTse": "16632",
    "ibgeCodigo": 2403202,
    "uf": "RN",
    "nome": "Doutor Severiano"
  },
  {
    "codigoTse": "16659",
    "ibgeCodigo": 2403301,
    "uf": "RN",
    "nome": "Encanto"
  },
  {
    "codigoTse": "16675",
    "ibgeCodigo": 2403400,
    "uf": "RN",
    "nome": "Equador"
  },
  {
    "codigoTse": "16691",
    "ibgeCodigo": 2403509,
    "uf": "RN",
    "nome": "Esp�rito Santo"
  },
  {
    "codigoTse": "16713",
    "ibgeCodigo": 2403608,
    "uf": "RN",
    "nome": "Extremoz"
  },
  {
    "codigoTse": "16730",
    "ibgeCodigo": 2403707,
    "uf": "RN",
    "nome": "Felipe Guerra"
  },
  {
    "codigoTse": "16756",
    "ibgeCodigo": 2403806,
    "uf": "RN",
    "nome": "Flor�nia"
  },
  {
    "codigoTse": "16772",
    "ibgeCodigo": 2403905,
    "uf": "RN",
    "nome": "Francisco Dantas"
  },
  {
    "codigoTse": "16799",
    "ibgeCodigo": 2404101,
    "uf": "RN",
    "nome": "Galinhos"
  },
  {
    "codigoTse": "16810",
    "ibgeCodigo": 2404200,
    "uf": "RN",
    "nome": "Goianinha"
  },
  {
    "codigoTse": "16837",
    "ibgeCodigo": 2404309,
    "uf": "RN",
    "nome": "Governador Dix-Sept Rosado"
  },
  {
    "codigoTse": "16853",
    "ibgeCodigo": 2404408,
    "uf": "RN",
    "nome": "Grossos"
  },
  {
    "codigoTse": "16870",
    "ibgeCodigo": 2404507,
    "uf": "RN",
    "nome": "Guamar�"
  },
  {
    "codigoTse": "16896",
    "ibgeCodigo": 2404606,
    "uf": "RN",
    "nome": "Ielmo Marinho"
  },
  {
    "codigoTse": "16918",
    "ibgeCodigo": 2404705,
    "uf": "RN",
    "nome": "Ipangua�u"
  },
  {
    "codigoTse": "16934",
    "ibgeCodigo": 2404804,
    "uf": "RN",
    "nome": "Ipueira"
  },
  {
    "codigoTse": "16950",
    "ibgeCodigo": 2404903,
    "uf": "RN",
    "nome": "Ita�"
  },
  {
    "codigoTse": "16977",
    "ibgeCodigo": 2405009,
    "uf": "RN",
    "nome": "Ja�an�"
  },
  {
    "codigoTse": "16993",
    "ibgeCodigo": 2405108,
    "uf": "RN",
    "nome": "Janda�ra"
  },
  {
    "codigoTse": "17019",
    "ibgeCodigo": 2405207,
    "uf": "RN",
    "nome": "Jandu�s"
  },
  {
    "codigoTse": "17035",
    "ibgeCodigo": 2405306,
    "uf": "RN",
    "nome": "Janu�rio Cicco"
  },
  {
    "codigoTse": "17051",
    "ibgeCodigo": 2405405,
    "uf": "RN",
    "nome": "Japi"
  },
  {
    "codigoTse": "17078",
    "ibgeCodigo": 2405504,
    "uf": "RN",
    "nome": "Jardim De Angicos"
  },
  {
    "codigoTse": "17094",
    "ibgeCodigo": 2405603,
    "uf": "RN",
    "nome": "Jardim De Piranhas"
  },
  {
    "codigoTse": "17116",
    "ibgeCodigo": 2405702,
    "uf": "RN",
    "nome": "Jardim Do Serid�"
  },
  {
    "codigoTse": "17132",
    "ibgeCodigo": 2405801,
    "uf": "RN",
    "nome": "Jo�o C�mara"
  },
  {
    "codigoTse": "17159",
    "ibgeCodigo": 2405900,
    "uf": "RN",
    "nome": "Jo�o Dias"
  },
  {
    "codigoTse": "17175",
    "ibgeCodigo": 2406007,
    "uf": "RN",
    "nome": "Jos� Da Penha"
  },
  {
    "codigoTse": "17191",
    "ibgeCodigo": 2406106,
    "uf": "RN",
    "nome": "Jucurutu"
  },
  {
    "codigoTse": "17213",
    "ibgeCodigo": 2407609,
    "uf": "RN",
    "nome": "Messias Targino"
  },
  {
    "codigoTse": "17230",
    "ibgeCodigo": 2406205,
    "uf": "RN",
    "nome": "Lagoa D'Anta"
  },
  {
    "codigoTse": "17256",
    "ibgeCodigo": 2406304,
    "uf": "RN",
    "nome": "Lagoa De Pedras"
  },
  {
    "codigoTse": "17272",
    "ibgeCodigo": 2406403,
    "uf": "RN",
    "nome": "Lagoa De Velhos"
  },
  {
    "codigoTse": "17299",
    "ibgeCodigo": 2406502,
    "uf": "RN",
    "nome": "Lagoa Nova"
  },
  {
    "codigoTse": "17310",
    "ibgeCodigo": 2406601,
    "uf": "RN",
    "nome": "Lagoa Salgada"
  },
  {
    "codigoTse": "17337",
    "ibgeCodigo": 2406700,
    "uf": "RN",
    "nome": "Lajes"
  },
  {
    "codigoTse": "17353",
    "ibgeCodigo": 2406809,
    "uf": "RN",
    "nome": "Lajes Pintadas"
  },
  {
    "codigoTse": "17370",
    "ibgeCodigo": 2406908,
    "uf": "RN",
    "nome": "Lucr�cia"
  },
  {
    "codigoTse": "17396",
    "ibgeCodigo": 2407005,
    "uf": "RN",
    "nome": "Lu�s Gomes"
  },
  {
    "codigoTse": "17418",
    "ibgeCodigo": 2407104,
    "uf": "RN",
    "nome": "Maca�ba"
  },
  {
    "codigoTse": "17434",
    "ibgeCodigo": 2407203,
    "uf": "RN",
    "nome": "Macau"
  },
  {
    "codigoTse": "17450",
    "ibgeCodigo": 2407302,
    "uf": "RN",
    "nome": "Marcelino Vieira"
  },
  {
    "codigoTse": "17477",
    "ibgeCodigo": 2407401,
    "uf": "RN",
    "nome": "Martins"
  },
  {
    "codigoTse": "17493",
    "ibgeCodigo": 2407500,
    "uf": "RN",
    "nome": "Maxaranguape"
  },
  {
    "codigoTse": "17515",
    "ibgeCodigo": 2404002,
    "uf": "RN",
    "nome": "Frutuoso Gomes"
  },
  {
    "codigoTse": "17531",
    "ibgeCodigo": 2407708,
    "uf": "RN",
    "nome": "Montanhas"
  },
  {
    "codigoTse": "17558",
    "ibgeCodigo": 2407807,
    "uf": "RN",
    "nome": "Monte Alegre"
  },
  {
    "codigoTse": "17574",
    "ibgeCodigo": 2407906,
    "uf": "RN",
    "nome": "Monte Das Gameleiras"
  },
  {
    "codigoTse": "17590",
    "ibgeCodigo": 2408003,
    "uf": "RN",
    "nome": "Mossor�"
  },
  {
    "codigoTse": "17612",
    "ibgeCodigo": 2408102,
    "uf": "RN",
    "nome": "Natal"
  },
  {
    "codigoTse": "17639",
    "ibgeCodigo": 2408201,
    "uf": "RN",
    "nome": "N�sia Floresta"
  },
  {
    "codigoTse": "17655",
    "ibgeCodigo": 2408300,
    "uf": "RN",
    "nome": "Nova Cruz"
  },
  {
    "codigoTse": "17671",
    "ibgeCodigo": 2408409,
    "uf": "RN",
    "nome": "Olho-D'�gua Do Borges"
  },
  {
    "codigoTse": "17698",
    "ibgeCodigo": 2408508,
    "uf": "RN",
    "nome": "Ouro Branco"
  },
  {
    "codigoTse": "17710",
    "ibgeCodigo": 2408607,
    "uf": "RN",
    "nome": "Paran�"
  },
  {
    "codigoTse": "17736",
    "ibgeCodigo": 2408706,
    "uf": "RN",
    "nome": "Para�"
  },
  {
    "codigoTse": "17752",
    "ibgeCodigo": 2408805,
    "uf": "RN",
    "nome": "Parazinho"
  },
  {
    "codigoTse": "17779",
    "ibgeCodigo": 2408904,
    "uf": "RN",
    "nome": "Parelhas"
  },
  {
    "codigoTse": "17795",
    "ibgeCodigo": 2403251,
    "uf": "RN",
    "nome": "Parnamirim"
  },
  {
    "codigoTse": "17817",
    "ibgeCodigo": 2409100,
    "uf": "RN",
    "nome": "Passa E Fica"
  },
  {
    "codigoTse": "17833",
    "ibgeCodigo": 2409209,
    "uf": "RN",
    "nome": "Passagem"
  },
  {
    "codigoTse": "17850",
    "ibgeCodigo": 2409308,
    "uf": "RN",
    "nome": "Patu"
  },
  {
    "codigoTse": "17876",
    "ibgeCodigo": 2409407,
    "uf": "RN",
    "nome": "Pau Dos Ferros"
  },
  {
    "codigoTse": "17892",
    "ibgeCodigo": 2409506,
    "uf": "RN",
    "nome": "Pedra Grande"
  },
  {
    "codigoTse": "17914",
    "ibgeCodigo": 2409605,
    "uf": "RN",
    "nome": "Pedra Preta"
  },
  {
    "codigoTse": "17930",
    "ibgeCodigo": 2409704,
    "uf": "RN",
    "nome": "Pedro Avelino"
  },
  {
    "codigoTse": "17957",
    "ibgeCodigo": 2409803,
    "uf": "RN",
    "nome": "Pedro Velho"
  },
  {
    "codigoTse": "17973",
    "ibgeCodigo": 2409902,
    "uf": "RN",
    "nome": "Pend�ncias"
  },
  {
    "codigoTse": "17990",
    "ibgeCodigo": 2410009,
    "uf": "RN",
    "nome": "Pil�es"
  },
  {
    "codigoTse": "18015",
    "ibgeCodigo": 2410108,
    "uf": "RN",
    "nome": "Po�o Branco"
  },
  {
    "codigoTse": "18031",
    "ibgeCodigo": 2410207,
    "uf": "RN",
    "nome": "Portalegre"
  },
  {
    "codigoTse": "18058",
    "ibgeCodigo": 2410306,
    "uf": "RN",
    "nome": "Presidente Juscelino"
  },
  {
    "codigoTse": "18074",
    "ibgeCodigo": 2410405,
    "uf": "RN",
    "nome": "Pureza"
  },
  {
    "codigoTse": "18090",
    "ibgeCodigo": 2410504,
    "uf": "RN",
    "nome": "Rafael Fernandes"
  },
  {
    "codigoTse": "18112",
    "ibgeCodigo": 2410702,
    "uf": "RN",
    "nome": "Riacho Da Cruz"
  },
  {
    "codigoTse": "18139",
    "ibgeCodigo": 2410801,
    "uf": "RN",
    "nome": "Riacho De Santana"
  },
  {
    "codigoTse": "18155",
    "ibgeCodigo": 2410900,
    "uf": "RN",
    "nome": "Riachuelo"
  },
  {
    "codigoTse": "18171",
    "ibgeCodigo": 2411007,
    "uf": "RN",
    "nome": "Rodolfo Fernandes"
  },
  {
    "codigoTse": "18198",
    "ibgeCodigo": 2411106,
    "uf": "RN",
    "nome": "Ruy Barbosa"
  },
  {
    "codigoTse": "18210",
    "ibgeCodigo": 2411908,
    "uf": "RN",
    "nome": "S�o Francisco Do Oeste"
  },
  {
    "codigoTse": "18236",
    "ibgeCodigo": 2411205,
    "uf": "RN",
    "nome": "Santa Cruz"
  },
  {
    "codigoTse": "18252",
    "ibgeCodigo": 2411429,
    "uf": "RN",
    "nome": "Santana Do Serid�"
  },
  {
    "codigoTse": "18279",
    "ibgeCodigo": 2411403,
    "uf": "RN",
    "nome": "Santana Do Matos"
  },
  {
    "codigoTse": "18295",
    "ibgeCodigo": 2411502,
    "uf": "RN",
    "nome": "Santo Ant�nio"
  },
  {
    "codigoTse": "18317",
    "ibgeCodigo": 2411601,
    "uf": "RN",
    "nome": "S�o Bento Do Norte"
  },
  {
    "codigoTse": "18333",
    "ibgeCodigo": 2411700,
    "uf": "RN",
    "nome": "S�o Bento Do Trair�"
  },
  {
    "codigoTse": "18350",
    "ibgeCodigo": 2411809,
    "uf": "RN",
    "nome": "S�o Fernando"
  },
  {
    "codigoTse": "18376",
    "ibgeCodigo": 2412005,
    "uf": "RN",
    "nome": "S�o Gon�alo Do Amarante"
  },
  {
    "codigoTse": "18392",
    "ibgeCodigo": 2412104,
    "uf": "RN",
    "nome": "S�o Jo�o Do Sabugi"
  },
  {
    "codigoTse": "18414",
    "ibgeCodigo": 2412203,
    "uf": "RN",
    "nome": "S�o Jos� De Mipibu"
  },
  {
    "codigoTse": "18430",
    "ibgeCodigo": 2412302,
    "uf": "RN",
    "nome": "S�o Jos� Do Campestre"
  },
  {
    "codigoTse": "18457",
    "ibgeCodigo": 2412401,
    "uf": "RN",
    "nome": "S�o Jos� Do Serid�"
  },
  {
    "codigoTse": "18473",
    "ibgeCodigo": 2412500,
    "uf": "RN",
    "nome": "S�o Miguel"
  },
  {
    "codigoTse": "18490",
    "ibgeCodigo": 2412609,
    "uf": "RN",
    "nome": "S�o Paulo Do Potengi"
  },
  {
    "codigoTse": "18511",
    "ibgeCodigo": 2412708,
    "uf": "RN",
    "nome": "S�o Pedro"
  },
  {
    "codigoTse": "18538",
    "ibgeCodigo": 2412807,
    "uf": "RN",
    "nome": "S�o Rafael"
  },
  {
    "codigoTse": "18554",
    "ibgeCodigo": 2412906,
    "uf": "RN",
    "nome": "S�o Tom�"
  },
  {
    "codigoTse": "18570",
    "ibgeCodigo": 2413003,
    "uf": "RN",
    "nome": "S�o Vicente"
  },
  {
    "codigoTse": "18597",
    "ibgeCodigo": 2413102,
    "uf": "RN",
    "nome": "Senador El�i De Souza"
  },
  {
    "codigoTse": "18619",
    "ibgeCodigo": 2413201,
    "uf": "RN",
    "nome": "Senador Georgino Avelino"
  },
  {
    "codigoTse": "18635",
    "ibgeCodigo": 2413300,
    "uf": "RN",
    "nome": "Serra De S�o Bento"
  },
  {
    "codigoTse": "18651",
    "ibgeCodigo": 2413409,
    "uf": "RN",
    "nome": "Serra Negra Do Norte"
  },
  {
    "codigoTse": "18678",
    "ibgeCodigo": 2413508,
    "uf": "RN",
    "nome": "Serrinha"
  },
  {
    "codigoTse": "18694",
    "ibgeCodigo": 2413607,
    "uf": "RN",
    "nome": "Severiano Melo"
  },
  {
    "codigoTse": "18716",
    "ibgeCodigo": 2413706,
    "uf": "RN",
    "nome": "S�tio Novo"
  },
  {
    "codigoTse": "18732",
    "ibgeCodigo": 2413805,
    "uf": "RN",
    "nome": "Taboleiro Grande"
  },
  {
    "codigoTse": "18759",
    "ibgeCodigo": 2413904,
    "uf": "RN",
    "nome": "Taipu"
  },
  {
    "codigoTse": "18775",
    "ibgeCodigo": 2414001,
    "uf": "RN",
    "nome": "Tangar�"
  },
  {
    "codigoTse": "18791",
    "ibgeCodigo": 2414100,
    "uf": "RN",
    "nome": "Tenente Ananias"
  },
  {
    "codigoTse": "18813",
    "ibgeCodigo": 2414209,
    "uf": "RN",
    "nome": "Tibau Do Sul"
  },
  {
    "codigoTse": "18830",
    "ibgeCodigo": 2414308,
    "uf": "RN",
    "nome": "Timba�ba Dos Batistas"
  },
  {
    "codigoTse": "18856",
    "ibgeCodigo": 2414407,
    "uf": "RN",
    "nome": "Touros"
  },
  {
    "codigoTse": "18872",
    "ibgeCodigo": 2414506,
    "uf": "RN",
    "nome": "Umarizal"
  },
  {
    "codigoTse": "18899",
    "ibgeCodigo": 2414605,
    "uf": "RN",
    "nome": "Upanema"
  },
  {
    "codigoTse": "18910",
    "ibgeCodigo": 2414704,
    "uf": "RN",
    "nome": "V�rzea"
  },
  {
    "codigoTse": "18937",
    "ibgeCodigo": 2410603,
    "uf": "RN",
    "nome": "Rafael Godeiro"
  },
  {
    "codigoTse": "18953",
    "ibgeCodigo": 2414803,
    "uf": "RN",
    "nome": "Vera Cruz"
  },
  {
    "codigoTse": "18970",
    "ibgeCodigo": 2414902,
    "uf": "RN",
    "nome": "Vi�osa"
  },
  {
    "codigoTse": "18996",
    "ibgeCodigo": 2415008,
    "uf": "RN",
    "nome": "Vila Flor"
  },
  {
    "codigoTse": "19003",
    "ibgeCodigo": 2512762,
    "uf": "PB",
    "nome": "Riach�o Do Po�o"
  },
  {
    "codigoTse": "19011",
    "ibgeCodigo": 2500106,
    "uf": "PB",
    "nome": "�gua Branca"
  },
  {
    "codigoTse": "19020",
    "ibgeCodigo": 2515971,
    "uf": "PB",
    "nome": "Sobrado"
  },
  {
    "codigoTse": "19038",
    "ibgeCodigo": 2500205,
    "uf": "PB",
    "nome": "Aguiar"
  },
  {
    "codigoTse": "19046",
    "ibgeCodigo": 2514453,
    "uf": "PB",
    "nome": "S�o Jos� Dos Ramos"
  },
  {
    "codigoTse": "19054",
    "ibgeCodigo": 2500304,
    "uf": "PB",
    "nome": "Alagoa Grande"
  },
  {
    "codigoTse": "19062",
    "ibgeCodigo": 2504033,
    "uf": "PB",
    "nome": "Capim"
  },
  {
    "codigoTse": "19070",
    "ibgeCodigo": 2500403,
    "uf": "PB",
    "nome": "Alagoa Nova"
  },
  {
    "codigoTse": "19089",
    "ibgeCodigo": 2505238,
    "uf": "PB",
    "nome": "Cuit� De Mamanguape"
  },
  {
    "codigoTse": "19097",
    "ibgeCodigo": 2500502,
    "uf": "PB",
    "nome": "Alagoinha"
  },
  {
    "codigoTse": "19100",
    "ibgeCodigo": 2505279,
    "uf": "PB",
    "nome": "Curral De Cima"
  },
  {
    "codigoTse": "19119",
    "ibgeCodigo": 2500601,
    "uf": "PB",
    "nome": "Alhandra"
  },
  {
    "codigoTse": "19127",
    "ibgeCodigo": 2512754,
    "uf": "PB",
    "nome": "Riach�o Do Bacamarte"
  },
  {
    "codigoTse": "19135",
    "ibgeCodigo": 2500700,
    "uf": "PB",
    "nome": "S�o Jo�o Do Rio Do Peixe"
  },
  {
    "codigoTse": "19143",
    "ibgeCodigo": 2509339,
    "uf": "PB",
    "nome": "Matinhas"
  },
  {
    "codigoTse": "19151",
    "ibgeCodigo": 2500809,
    "uf": "PB",
    "nome": "Ara�agi"
  },
  {
    "codigoTse": "19160",
    "ibgeCodigo": 2508554,
    "uf": "PB",
    "nome": "Logradouro"
  },
  {
    "codigoTse": "19178",
    "ibgeCodigo": 2500908,
    "uf": "PB",
    "nome": "Arara"
  },
  {
    "codigoTse": "19186",
    "ibgeCodigo": 2515930,
    "uf": "PB",
    "nome": "Sert�ozinho"
  },
  {
    "codigoTse": "19194",
    "ibgeCodigo": 2501005,
    "uf": "PB",
    "nome": "Araruna"
  },
  {
    "codigoTse": "19208",
    "ibgeCodigo": 2512747,
    "uf": "PB",
    "nome": "Riach�o"
  },
  {
    "codigoTse": "19216",
    "ibgeCodigo": 2501104,
    "uf": "PB",
    "nome": "Areia"
  },
  {
    "codigoTse": "19224",
    "ibgeCodigo": 2513943,
    "uf": "PB",
    "nome": "S�o Domingos Do Cariri"
  },
  {
    "codigoTse": "19232",
    "ibgeCodigo": 2501203,
    "uf": "PB",
    "nome": "Areial"
  },
  {
    "codigoTse": "19240",
    "ibgeCodigo": 2504074,
    "uf": "PB",
    "nome": "Cara�bas"
  },
  {
    "codigoTse": "19259",
    "ibgeCodigo": 2501302,
    "uf": "PB",
    "nome": "Aroeiras"
  },
  {
    "codigoTse": "19267",
    "ibgeCodigo": 2513851,
    "uf": "PB",
    "nome": "Santo Andr�"
  },
  {
    "codigoTse": "19275",
    "ibgeCodigo": 2505352,
    "uf": "PB",
    "nome": "Dami�o"
  },
  {
    "codigoTse": "19283",
    "ibgeCodigo": 2516151,
    "uf": "PB",
    "nome": "Soss�go"
  },
  {
    "codigoTse": "19291",
    "ibgeCodigo": 2501401,
    "uf": "PB",
    "nome": "Ba�a Da Trai��o"
  },
  {
    "codigoTse": "19305",
    "ibgeCodigo": 2501534,
    "uf": "PB",
    "nome": "Bara�na"
  },
  {
    "codigoTse": "19313",
    "ibgeCodigo": 2501500,
    "uf": "PB",
    "nome": "Bananeiras"
  },
  {
    "codigoTse": "19321",
    "ibgeCodigo": 2501351,
    "uf": "PB",
    "nome": "Assun��o"
  },
  {
    "codigoTse": "19330",
    "ibgeCodigo": 2501609,
    "uf": "PB",
    "nome": "Barra De Santa Rosa"
  },
  {
    "codigoTse": "19348",
    "ibgeCodigo": 2517407,
    "uf": "PB",
    "nome": "Zabel�"
  },
  {
    "codigoTse": "19356",
    "ibgeCodigo": 2501708,
    "uf": "PB",
    "nome": "Barra De S�o Miguel"
  },
  {
    "codigoTse": "19364",
    "ibgeCodigo": 2503555,
    "uf": "PB",
    "nome": "Cacimbas"
  },
  {
    "codigoTse": "19372",
    "ibgeCodigo": 2501807,
    "uf": "PB",
    "nome": "Bayeux"
  },
  {
    "codigoTse": "19380",
    "ibgeCodigo": 2503753,
    "uf": "PB",
    "nome": "Cajazeirinhas"
  },
  {
    "codigoTse": "19399",
    "ibgeCodigo": 2501906,
    "uf": "PB",
    "nome": "Bel�m"
  },
  {
    "codigoTse": "19402",
    "ibgeCodigo": 2513927,
    "uf": "PB",
    "nome": "S�o Bentinho"
  },
  {
    "codigoTse": "19410",
    "ibgeCodigo": 2502003,
    "uf": "PB",
    "nome": "Bel�m Do Brejo Do Cruz"
  },
  {
    "codigoTse": "19429",
    "ibgeCodigo": 2513968,
    "uf": "PB",
    "nome": "S�o Domingos"
  },
  {
    "codigoTse": "19437",
    "ibgeCodigo": 2502102,
    "uf": "PB",
    "nome": "Boa Ventura"
  },
  {
    "codigoTse": "19445",
    "ibgeCodigo": 2514552,
    "uf": "PB",
    "nome": "S�o Jos� De Princesa"
  },
  {
    "codigoTse": "19453",
    "ibgeCodigo": 2502201,
    "uf": "PB",
    "nome": "Bom Jesus"
  },
  {
    "codigoTse": "19461",
    "ibgeCodigo": 2509156,
    "uf": "PB",
    "nome": "Mariz�polis"
  },
  {
    "codigoTse": "19470",
    "ibgeCodigo": 2502300,
    "uf": "PB",
    "nome": "Bom Sucesso"
  },
  {
    "codigoTse": "19488",
    "ibgeCodigo": 2509370,
    "uf": "PB",
    "nome": "Mato Grosso"
  },
  {
    "codigoTse": "19496",
    "ibgeCodigo": 2502409,
    "uf": "PB",
    "nome": "Bonito De Santa F�"
  },
  {
    "codigoTse": "19500",
    "ibgeCodigo": 2502052,
    "uf": "PB",
    "nome": "Bernardino Batista"
  },
  {
    "codigoTse": "19518",
    "ibgeCodigo": 2502508,
    "uf": "PB",
    "nome": "Boqueir�o"
  },
  {
    "codigoTse": "19526",
    "ibgeCodigo": 2512077,
    "uf": "PB",
    "nome": "Po�o De Jos� De Moura"
  },
  {
    "codigoTse": "19534",
    "ibgeCodigo": 2502607,
    "uf": "PB",
    "nome": "Igaracy"
  },
  {
    "codigoTse": "19542",
    "ibgeCodigo": 2514651,
    "uf": "PB",
    "nome": "S�o Jos� Do Brejo Do Cruz"
  },
  {
    "codigoTse": "19550",
    "ibgeCodigo": 2502706,
    "uf": "PB",
    "nome": "Borborema"
  },
  {
    "codigoTse": "19569",
    "ibgeCodigo": 2513356,
    "uf": "PB",
    "nome": "Santa In�s"
  },
  {
    "codigoTse": "19577",
    "ibgeCodigo": 2502805,
    "uf": "PB",
    "nome": "Brejo Do Cruz"
  },
  {
    "codigoTse": "19585",
    "ibgeCodigo": 2500734,
    "uf": "PB",
    "nome": "Amparo"
  },
  {
    "codigoTse": "19593",
    "ibgeCodigo": 2502904,
    "uf": "PB",
    "nome": "Brejo Dos Santos"
  },
  {
    "codigoTse": "19607",
    "ibgeCodigo": 2504157,
    "uf": "PB",
    "nome": "Casserengue"
  },
  {
    "codigoTse": "19615",
    "ibgeCodigo": 2503001,
    "uf": "PB",
    "nome": "Caapor�"
  },
  {
    "codigoTse": "19623",
    "ibgeCodigo": 2506251,
    "uf": "PB",
    "nome": "Gado Bravo"
  },
  {
    "codigoTse": "19631",
    "ibgeCodigo": 2503100,
    "uf": "PB",
    "nome": "Cabaceiras"
  },
  {
    "codigoTse": "19640",
    "ibgeCodigo": 2512036,
    "uf": "PB",
    "nome": "Po�o Dantas"
  },
  {
    "codigoTse": "19658",
    "ibgeCodigo": 2503209,
    "uf": "PB",
    "nome": "Cabedelo"
  },
  {
    "codigoTse": "19666",
    "ibgeCodigo": 2513653,
    "uf": "PB",
    "nome": "Joca Claudino"
  },
  {
    "codigoTse": "19674",
    "ibgeCodigo": 2503308,
    "uf": "PB",
    "nome": "Cachoeira Dos �ndios"
  },
  {
    "codigoTse": "19682",
    "ibgeCodigo": 2516755,
    "uf": "PB",
    "nome": "Ten�rio"
  },
  {
    "codigoTse": "19690",
    "ibgeCodigo": 2503407,
    "uf": "PB",
    "nome": "Cacimba De Areia"
  },
  {
    "codigoTse": "19704",
    "ibgeCodigo": 2504850,
    "uf": "PB",
    "nome": "Coxixola"
  },
  {
    "codigoTse": "19712",
    "ibgeCodigo": 2503506,
    "uf": "PB",
    "nome": "Cacimba De Dentro"
  },
  {
    "codigoTse": "19720",
    "ibgeCodigo": 2510659,
    "uf": "PB",
    "nome": "Parari"
  },
  {
    "codigoTse": "19739",
    "ibgeCodigo": 2503605,
    "uf": "PB",
    "nome": "Cai�ara"
  },
  {
    "codigoTse": "19747",
    "ibgeCodigo": 2512721,
    "uf": "PB",
    "nome": "Pedro R�gis"
  },
  {
    "codigoTse": "19755",
    "ibgeCodigo": 2503704,
    "uf": "PB",
    "nome": "Cajazeiras"
  },
  {
    "codigoTse": "19763",
    "ibgeCodigo": 2500536,
    "uf": "PB",
    "nome": "Alcantil"
  },
  {
    "codigoTse": "19771",
    "ibgeCodigo": 2503803,
    "uf": "PB",
    "nome": "Caldas Brand�o"
  },
  {
    "codigoTse": "19780",
    "ibgeCodigo": 2501575,
    "uf": "PB",
    "nome": "Barra De Santana"
  },
  {
    "codigoTse": "19798",
    "ibgeCodigo": 2503902,
    "uf": "PB",
    "nome": "Camala�"
  },
  {
    "codigoTse": "19801",
    "ibgeCodigo": 2504355,
    "uf": "PB",
    "nome": "Caturit�"
  },
  {
    "codigoTse": "19810",
    "ibgeCodigo": 2504009,
    "uf": "PB",
    "nome": "Campina Grande"
  },
  {
    "codigoTse": "19828",
    "ibgeCodigo": 2512788,
    "uf": "PB",
    "nome": "Riacho De Santo Ant�nio"
  },
  {
    "codigoTse": "19836",
    "ibgeCodigo": 2504108,
    "uf": "PB",
    "nome": "Carrapateira"
  },
  {
    "codigoTse": "19844",
    "ibgeCodigo": 2500775,
    "uf": "PB",
    "nome": "Aparecida"
  },
  {
    "codigoTse": "19852",
    "ibgeCodigo": 2504207,
    "uf": "PB",
    "nome": "Catingueira"
  },
  {
    "codigoTse": "19860",
    "ibgeCodigo": 2513984,
    "uf": "PB",
    "nome": "S�o Francisco"
  },
  {
    "codigoTse": "19879",
    "ibgeCodigo": 2504306,
    "uf": "PB",
    "nome": "Catol� Do Rocha"
  },
  {
    "codigoTse": "19887",
    "ibgeCodigo": 2517209,
    "uf": "PB",
    "nome": "Vieir�polis"
  },
  {
    "codigoTse": "19895",
    "ibgeCodigo": 2504405,
    "uf": "PB",
    "nome": "Concei��o"
  },
  {
    "codigoTse": "19909",
    "ibgeCodigo": 2501153,
    "uf": "PB",
    "nome": "Areia De Bara�nas"
  },
  {
    "codigoTse": "19917",
    "ibgeCodigo": 2504504,
    "uf": "PB",
    "nome": "Condado"
  },
  {
    "codigoTse": "19925",
    "ibgeCodigo": 2500577,
    "uf": "PB",
    "nome": "Algod�o De Janda�ra"
  },
  {
    "codigoTse": "19933",
    "ibgeCodigo": 2504603,
    "uf": "PB",
    "nome": "Conde"
  },
  {
    "codigoTse": "19941",
    "ibgeCodigo": 2502151,
    "uf": "PB",
    "nome": "Boa Vista"
  },
  {
    "codigoTse": "19950",
    "ibgeCodigo": 2504702,
    "uf": "PB",
    "nome": "Congo"
  },
  {
    "codigoTse": "19968",
    "ibgeCodigo": 2509057,
    "uf": "PB",
    "nome": "Marca��o"
  },
  {
    "codigoTse": "19976",
    "ibgeCodigo": 2504801,
    "uf": "PB",
    "nome": "Coremas"
  },
  {
    "codigoTse": "19984",
    "ibgeCodigo": 2509396,
    "uf": "PB",
    "nome": "Matur�ia"
  },
  {
    "codigoTse": "19992",
    "ibgeCodigo": 2504900,
    "uf": "PB",
    "nome": "Cruz Do Esp�rito Santo"
  },
  {
    "codigoTse": "20001",
    "ibgeCodigo": 2513158,
    "uf": "PB",
    "nome": "Santa Cec�lia"
  },
  {
    "codigoTse": "20010",
    "ibgeCodigo": 2505006,
    "uf": "PB",
    "nome": "Cubati"
  },
  {
    "codigoTse": "20036",
    "ibgeCodigo": 2505105,
    "uf": "PB",
    "nome": "Cuit�"
  },
  {
    "codigoTse": "20052",
    "ibgeCodigo": 2505204,
    "uf": "PB",
    "nome": "Cuitegi"
  },
  {
    "codigoTse": "20079",
    "ibgeCodigo": 2505303,
    "uf": "PB",
    "nome": "Curral Velho"
  },
  {
    "codigoTse": "20095",
    "ibgeCodigo": 2505402,
    "uf": "PB",
    "nome": "Desterro"
  },
  {
    "codigoTse": "20117",
    "ibgeCodigo": 2505501,
    "uf": "PB",
    "nome": "Vista Serrana"
  },
  {
    "codigoTse": "20133",
    "ibgeCodigo": 2505600,
    "uf": "PB",
    "nome": "Diamante"
  },
  {
    "codigoTse": "20150",
    "ibgeCodigo": 2505709,
    "uf": "PB",
    "nome": "Dona In�s"
  },
  {
    "codigoTse": "20176",
    "ibgeCodigo": 2505808,
    "uf": "PB",
    "nome": "Duas Estradas"
  },
  {
    "codigoTse": "20192",
    "ibgeCodigo": 2505907,
    "uf": "PB",
    "nome": "Emas"
  },
  {
    "codigoTse": "20214",
    "ibgeCodigo": 2506004,
    "uf": "PB",
    "nome": "Esperan�a"
  },
  {
    "codigoTse": "20230",
    "ibgeCodigo": 2506103,
    "uf": "PB",
    "nome": "Fagundes"
  },
  {
    "codigoTse": "20257",
    "ibgeCodigo": 2506202,
    "uf": "PB",
    "nome": "Frei Martinho"
  },
  {
    "codigoTse": "20273",
    "ibgeCodigo": 2506301,
    "uf": "PB",
    "nome": "Guarabira"
  },
  {
    "codigoTse": "20290",
    "ibgeCodigo": 2506400,
    "uf": "PB",
    "nome": "Gurinh�m"
  },
  {
    "codigoTse": "20311",
    "ibgeCodigo": 2506509,
    "uf": "PB",
    "nome": "Gurj�o"
  },
  {
    "codigoTse": "20338",
    "ibgeCodigo": 2506608,
    "uf": "PB",
    "nome": "Ibiara"
  },
  {
    "codigoTse": "20354",
    "ibgeCodigo": 2506707,
    "uf": "PB",
    "nome": "Imaculada"
  },
  {
    "codigoTse": "20370",
    "ibgeCodigo": 2506806,
    "uf": "PB",
    "nome": "Ing�"
  },
  {
    "codigoTse": "20397",
    "ibgeCodigo": 2506905,
    "uf": "PB",
    "nome": "Itabaiana"
  },
  {
    "codigoTse": "20419",
    "ibgeCodigo": 2507002,
    "uf": "PB",
    "nome": "Itaporanga"
  },
  {
    "codigoTse": "20435",
    "ibgeCodigo": 2507101,
    "uf": "PB",
    "nome": "Itapororoca"
  },
  {
    "codigoTse": "20451",
    "ibgeCodigo": 2507200,
    "uf": "PB",
    "nome": "Itatuba"
  },
  {
    "codigoTse": "20478",
    "ibgeCodigo": 2507309,
    "uf": "PB",
    "nome": "Jacara�"
  },
  {
    "codigoTse": "20494",
    "ibgeCodigo": 2507408,
    "uf": "PB",
    "nome": "Jeric�"
  },
  {
    "codigoTse": "20516",
    "ibgeCodigo": 2507507,
    "uf": "PB",
    "nome": "Jo�o Pessoa"
  },
  {
    "codigoTse": "20532",
    "ibgeCodigo": 2507606,
    "uf": "PB",
    "nome": "Juarez T�vora"
  },
  {
    "codigoTse": "20559",
    "ibgeCodigo": 2507705,
    "uf": "PB",
    "nome": "Juazeirinho"
  },
  {
    "codigoTse": "20575",
    "ibgeCodigo": 2507804,
    "uf": "PB",
    "nome": "Junco Do Serid�"
  },
  {
    "codigoTse": "20591",
    "ibgeCodigo": 2507903,
    "uf": "PB",
    "nome": "Juripiranga"
  },
  {
    "codigoTse": "20613",
    "ibgeCodigo": 2508000,
    "uf": "PB",
    "nome": "Juru"
  },
  {
    "codigoTse": "20630",
    "ibgeCodigo": 2508109,
    "uf": "PB",
    "nome": "Lagoa"
  },
  {
    "codigoTse": "20656",
    "ibgeCodigo": 2508208,
    "uf": "PB",
    "nome": "Lagoa De Dentro"
  },
  {
    "codigoTse": "20672",
    "ibgeCodigo": 2508307,
    "uf": "PB",
    "nome": "Lagoa Seca"
  },
  {
    "codigoTse": "20699",
    "ibgeCodigo": 2508406,
    "uf": "PB",
    "nome": "Lastro"
  },
  {
    "codigoTse": "20710",
    "ibgeCodigo": 2508505,
    "uf": "PB",
    "nome": "Livramento"
  },
  {
    "codigoTse": "20737",
    "ibgeCodigo": 2508604,
    "uf": "PB",
    "nome": "Lucena"
  },
  {
    "codigoTse": "20753",
    "ibgeCodigo": 2508703,
    "uf": "PB",
    "nome": "M�e D'�gua"
  },
  {
    "codigoTse": "20770",
    "ibgeCodigo": 2508802,
    "uf": "PB",
    "nome": "Malta"
  },
  {
    "codigoTse": "20796",
    "ibgeCodigo": 2508901,
    "uf": "PB",
    "nome": "Mamanguape"
  },
  {
    "codigoTse": "20818",
    "ibgeCodigo": 2509008,
    "uf": "PB",
    "nome": "Mana�ra"
  },
  {
    "codigoTse": "20834",
    "ibgeCodigo": 2509107,
    "uf": "PB",
    "nome": "Mari"
  },
  {
    "codigoTse": "20850",
    "ibgeCodigo": 2509206,
    "uf": "PB",
    "nome": "Massaranduba"
  },
  {
    "codigoTse": "20877",
    "ibgeCodigo": 2509305,
    "uf": "PB",
    "nome": "Mataraca"
  },
  {
    "codigoTse": "20893",
    "ibgeCodigo": 2509404,
    "uf": "PB",
    "nome": "Mogeiro"
  },
  {
    "codigoTse": "20915",
    "ibgeCodigo": 2509503,
    "uf": "PB",
    "nome": "Montadas"
  },
  {
    "codigoTse": "20931",
    "ibgeCodigo": 2509602,
    "uf": "PB",
    "nome": "Monte Horebe"
  },
  {
    "codigoTse": "20958",
    "ibgeCodigo": 2509701,
    "uf": "PB",
    "nome": "Monteiro"
  },
  {
    "codigoTse": "20974",
    "ibgeCodigo": 2509800,
    "uf": "PB",
    "nome": "Mulungu"
  },
  {
    "codigoTse": "20990",
    "ibgeCodigo": 2509909,
    "uf": "PB",
    "nome": "Natuba"
  },
  {
    "codigoTse": "21016",
    "ibgeCodigo": 2510006,
    "uf": "PB",
    "nome": "Nazarezinho"
  },
  {
    "codigoTse": "21032",
    "ibgeCodigo": 2510105,
    "uf": "PB",
    "nome": "Nova Floresta"
  },
  {
    "codigoTse": "21059",
    "ibgeCodigo": 2510204,
    "uf": "PB",
    "nome": "Nova Olinda"
  },
  {
    "codigoTse": "21075",
    "ibgeCodigo": 2510303,
    "uf": "PB",
    "nome": "Nova Palmeira"
  },
  {
    "codigoTse": "21091",
    "ibgeCodigo": 2510402,
    "uf": "PB",
    "nome": "Olho D'�gua"
  },
  {
    "codigoTse": "21113",
    "ibgeCodigo": 2510501,
    "uf": "PB",
    "nome": "Olivedos"
  },
  {
    "codigoTse": "21130",
    "ibgeCodigo": 2510600,
    "uf": "PB",
    "nome": "Ouro Velho"
  },
  {
    "codigoTse": "21156",
    "ibgeCodigo": 2510709,
    "uf": "PB",
    "nome": "Passagem"
  },
  {
    "codigoTse": "21172",
    "ibgeCodigo": 2510808,
    "uf": "PB",
    "nome": "Patos"
  },
  {
    "codigoTse": "21199",
    "ibgeCodigo": 2510907,
    "uf": "PB",
    "nome": "Paulista"
  },
  {
    "codigoTse": "21210",
    "ibgeCodigo": 2511004,
    "uf": "PB",
    "nome": "Pedra Branca"
  },
  {
    "codigoTse": "21237",
    "ibgeCodigo": 2511103,
    "uf": "PB",
    "nome": "Pedra Lavrada"
  },
  {
    "codigoTse": "21253",
    "ibgeCodigo": 2511202,
    "uf": "PB",
    "nome": "Pedras De Fogo"
  },
  {
    "codigoTse": "21270",
    "ibgeCodigo": 2511301,
    "uf": "PB",
    "nome": "Pianc�"
  },
  {
    "codigoTse": "21296",
    "ibgeCodigo": 2511400,
    "uf": "PB",
    "nome": "Picu�"
  },
  {
    "codigoTse": "21318",
    "ibgeCodigo": 2511509,
    "uf": "PB",
    "nome": "Pilar"
  },
  {
    "codigoTse": "21334",
    "ibgeCodigo": 2511608,
    "uf": "PB",
    "nome": "Pil�es"
  },
  {
    "codigoTse": "21350",
    "ibgeCodigo": 2511707,
    "uf": "PB",
    "nome": "Pil�ezinhos"
  },
  {
    "codigoTse": "21377",
    "ibgeCodigo": 2511806,
    "uf": "PB",
    "nome": "Pirpirituba"
  },
  {
    "codigoTse": "21393",
    "ibgeCodigo": 2511905,
    "uf": "PB",
    "nome": "Pitimbu"
  },
  {
    "codigoTse": "21415",
    "ibgeCodigo": 2512002,
    "uf": "PB",
    "nome": "Pocinhos"
  },
  {
    "codigoTse": "21431",
    "ibgeCodigo": 2512101,
    "uf": "PB",
    "nome": "Pombal"
  },
  {
    "codigoTse": "21458",
    "ibgeCodigo": 2512200,
    "uf": "PB",
    "nome": "Prata"
  },
  {
    "codigoTse": "21474",
    "ibgeCodigo": 2512309,
    "uf": "PB",
    "nome": "Princesa Isabel"
  },
  {
    "codigoTse": "21490",
    "ibgeCodigo": 2512408,
    "uf": "PB",
    "nome": "Puxinan�"
  },
  {
    "codigoTse": "21512",
    "ibgeCodigo": 2512507,
    "uf": "PB",
    "nome": "Queimadas"
  },
  {
    "codigoTse": "21539",
    "ibgeCodigo": 2512606,
    "uf": "PB",
    "nome": "Quixab�"
  },
  {
    "codigoTse": "21555",
    "ibgeCodigo": 2512705,
    "uf": "PB",
    "nome": "Rem�gio"
  },
  {
    "codigoTse": "21571",
    "ibgeCodigo": 2512804,
    "uf": "PB",
    "nome": "Riacho Dos Cavalos"
  },
  {
    "codigoTse": "21598",
    "ibgeCodigo": 2512903,
    "uf": "PB",
    "nome": "Rio Tinto"
  },
  {
    "codigoTse": "21610",
    "ibgeCodigo": 2513000,
    "uf": "PB",
    "nome": "Salgadinho"
  },
  {
    "codigoTse": "21636",
    "ibgeCodigo": 2513109,
    "uf": "PB",
    "nome": "Salgado De S�o F�lix"
  },
  {
    "codigoTse": "21652",
    "ibgeCodigo": 2513208,
    "uf": "PB",
    "nome": "Santa Cruz"
  },
  {
    "codigoTse": "21679",
    "ibgeCodigo": 2513307,
    "uf": "PB",
    "nome": "Santa Helena"
  },
  {
    "codigoTse": "21695",
    "ibgeCodigo": 2513406,
    "uf": "PB",
    "nome": "Santa Luzia"
  },
  {
    "codigoTse": "21717",
    "ibgeCodigo": 2513505,
    "uf": "PB",
    "nome": "Santana De Mangueira"
  },
  {
    "codigoTse": "21733",
    "ibgeCodigo": 2513604,
    "uf": "PB",
    "nome": "Santana Dos Garrotes"
  },
  {
    "codigoTse": "21750",
    "ibgeCodigo": 2513703,
    "uf": "PB",
    "nome": "Santa Rita"
  },
  {
    "codigoTse": "21776",
    "ibgeCodigo": 2513802,
    "uf": "PB",
    "nome": "Santa Teresinha"
  },
  {
    "codigoTse": "21792",
    "ibgeCodigo": 2513901,
    "uf": "PB",
    "nome": "S�o Bento"
  },
  {
    "codigoTse": "21814",
    "ibgeCodigo": 2514008,
    "uf": "PB",
    "nome": "S�o Jo�o Do Cariri"
  },
  {
    "codigoTse": "21830",
    "ibgeCodigo": 2514107,
    "uf": "PB",
    "nome": "S�o Jo�o Do Tigre"
  },
  {
    "codigoTse": "21857",
    "ibgeCodigo": 2514206,
    "uf": "PB",
    "nome": "S�o Jos� Da Lagoa Tapada"
  },
  {
    "codigoTse": "21873",
    "ibgeCodigo": 2514305,
    "uf": "PB",
    "nome": "S�o Jos� De Caiana"
  },
  {
    "codigoTse": "21890",
    "ibgeCodigo": 2514404,
    "uf": "PB",
    "nome": "S�o Jos� De Espinharas"
  },
  {
    "codigoTse": "21911",
    "ibgeCodigo": 2514503,
    "uf": "PB",
    "nome": "S�o Jos� De Piranhas"
  },
  {
    "codigoTse": "21938",
    "ibgeCodigo": 2514602,
    "uf": "PB",
    "nome": "S�o Jos� Do Bonfim"
  },
  {
    "codigoTse": "21954",
    "ibgeCodigo": 2514701,
    "uf": "PB",
    "nome": "S�o Jos� Do Sabugi"
  },
  {
    "codigoTse": "21970",
    "ibgeCodigo": 2514800,
    "uf": "PB",
    "nome": "S�o Jos� Dos Cordeiros"
  },
  {
    "codigoTse": "21997",
    "ibgeCodigo": 2514909,
    "uf": "PB",
    "nome": "S�o Mamede"
  },
  {
    "codigoTse": "22012",
    "ibgeCodigo": 2515005,
    "uf": "PB",
    "nome": "S�o Miguel De Taipu"
  },
  {
    "codigoTse": "22039",
    "ibgeCodigo": 2515104,
    "uf": "PB",
    "nome": "S�o Sebasti�o De Lagoa De Ro�a"
  },
  {
    "codigoTse": "22055",
    "ibgeCodigo": 2515203,
    "uf": "PB",
    "nome": "S�o Sebasti�o Do Umbuzeiro"
  },
  {
    "codigoTse": "22071",
    "ibgeCodigo": 2515302,
    "uf": "PB",
    "nome": "Sap�"
  },
  {
    "codigoTse": "22098",
    "ibgeCodigo": 2515401,
    "uf": "PB",
    "nome": "Serid�"
  },
  {
    "codigoTse": "22110",
    "ibgeCodigo": 2515500,
    "uf": "PB",
    "nome": "Serra Branca"
  },
  {
    "codigoTse": "22136",
    "ibgeCodigo": 2515609,
    "uf": "PB",
    "nome": "Serra Da Raiz"
  },
  {
    "codigoTse": "22152",
    "ibgeCodigo": 2515708,
    "uf": "PB",
    "nome": "Serra Grande"
  },
  {
    "codigoTse": "22179",
    "ibgeCodigo": 2515807,
    "uf": "PB",
    "nome": "Serra Redonda"
  },
  {
    "codigoTse": "22195",
    "ibgeCodigo": 2515906,
    "uf": "PB",
    "nome": "Serraria"
  },
  {
    "codigoTse": "22217",
    "ibgeCodigo": 2516003,
    "uf": "PB",
    "nome": "Sol�nea"
  },
  {
    "codigoTse": "22233",
    "ibgeCodigo": 2516102,
    "uf": "PB",
    "nome": "Soledade"
  },
  {
    "codigoTse": "22250",
    "ibgeCodigo": 2516201,
    "uf": "PB",
    "nome": "Sousa"
  },
  {
    "codigoTse": "22276",
    "ibgeCodigo": 2516300,
    "uf": "PB",
    "nome": "Sum�"
  },
  {
    "codigoTse": "22292",
    "ibgeCodigo": 2516409,
    "uf": "PB",
    "nome": "Campo De Santana"
  },
  {
    "codigoTse": "22314",
    "ibgeCodigo": 2516508,
    "uf": "PB",
    "nome": "Tapero�"
  },
  {
    "codigoTse": "22330",
    "ibgeCodigo": 2516607,
    "uf": "PB",
    "nome": "Tavares"
  },
  {
    "codigoTse": "22357",
    "ibgeCodigo": 2516706,
    "uf": "PB",
    "nome": "Teixeira"
  },
  {
    "codigoTse": "22373",
    "ibgeCodigo": 2516805,
    "uf": "PB",
    "nome": "Triunfo"
  },
  {
    "codigoTse": "22390",
    "ibgeCodigo": 2516904,
    "uf": "PB",
    "nome": "Uira�na"
  },
  {
    "codigoTse": "22411",
    "ibgeCodigo": 2517001,
    "uf": "PB",
    "nome": "Umbuzeiro"
  },
  {
    "codigoTse": "22438",
    "ibgeCodigo": 2517100,
    "uf": "PB",
    "nome": "V�rzea"
  },
  {
    "codigoTse": "23000",
    "ibgeCodigo": 2611533,
    "uf": "PE",
    "nome": "Quixaba"
  },
  {
    "codigoTse": "23019",
    "ibgeCodigo": 2600104,
    "uf": "PE",
    "nome": "Afogados Da Ingazeira"
  },
  {
    "codigoTse": "23027",
    "ibgeCodigo": 2608453,
    "uf": "PE",
    "nome": "Lagoa Do Carro"
  },
  {
    "codigoTse": "23035",
    "ibgeCodigo": 2600203,
    "uf": "PE",
    "nome": "Afr�nio"
  },
  {
    "codigoTse": "23043",
    "ibgeCodigo": 2612471,
    "uf": "PE",
    "nome": "Santa Cruz Da Baixa Verde"
  },
  {
    "codigoTse": "23051",
    "ibgeCodigo": 2600302,
    "uf": "PE",
    "nome": "Agrestina"
  },
  {
    "codigoTse": "23060",
    "ibgeCodigo": 2616506,
    "uf": "PE",
    "nome": "Xex�u"
  },
  {
    "codigoTse": "23078",
    "ibgeCodigo": 2600401,
    "uf": "PE",
    "nome": "�gua Preta"
  },
  {
    "codigoTse": "23086",
    "ibgeCodigo": 2616183,
    "uf": "PE",
    "nome": "Vertente Do L�rio"
  },
  {
    "codigoTse": "23094",
    "ibgeCodigo": 2600500,
    "uf": "PE",
    "nome": "�guas Belas"
  },
  {
    "codigoTse": "23108",
    "ibgeCodigo": 2612455,
    "uf": "PE",
    "nome": "Santa Cruz"
  },
  {
    "codigoTse": "23116",
    "ibgeCodigo": 2600609,
    "uf": "PE",
    "nome": "Alagoinha"
  },
  {
    "codigoTse": "23124",
    "ibgeCodigo": 2608255,
    "uf": "PE",
    "nome": "Jucati"
  },
  {
    "codigoTse": "23132",
    "ibgeCodigo": 2600708,
    "uf": "PE",
    "nome": "Alian�a"
  },
  {
    "codigoTse": "23140",
    "ibgeCodigo": 2605152,
    "uf": "PE",
    "nome": "Dormentes"
  },
  {
    "codigoTse": "23159",
    "ibgeCodigo": 2600807,
    "uf": "PE",
    "nome": "Altinho"
  },
  {
    "codigoTse": "23167",
    "ibgeCodigo": 2603926,
    "uf": "PE",
    "nome": "Carnaubeira Da Penha"
  },
  {
    "codigoTse": "23175",
    "ibgeCodigo": 2600906,
    "uf": "PE",
    "nome": "Amaraji"
  },
  {
    "codigoTse": "23183",
    "ibgeCodigo": 2608750,
    "uf": "PE",
    "nome": "Lagoa Grande"
  },
  {
    "codigoTse": "23191",
    "ibgeCodigo": 2601003,
    "uf": "PE",
    "nome": "Angelim"
  },
  {
    "codigoTse": "23205",
    "ibgeCodigo": 2601052,
    "uf": "PE",
    "nome": "Ara�oiaba"
  },
  {
    "codigoTse": "23213",
    "ibgeCodigo": 2601102,
    "uf": "PE",
    "nome": "Araripina"
  },
  {
    "codigoTse": "23221",
    "ibgeCodigo": 2604155,
    "uf": "PE",
    "nome": "Casinhas"
  },
  {
    "codigoTse": "23230",
    "ibgeCodigo": 2601201,
    "uf": "PE",
    "nome": "Arcoverde"
  },
  {
    "codigoTse": "23248",
    "ibgeCodigo": 2609154,
    "uf": "PE",
    "nome": "Manari"
  },
  {
    "codigoTse": "23256",
    "ibgeCodigo": 2601300,
    "uf": "PE",
    "nome": "Barra De Guabiraba"
  },
  {
    "codigoTse": "23264",
    "ibgeCodigo": 2608057,
    "uf": "PE",
    "nome": "Jatob�"
  },
  {
    "codigoTse": "23272",
    "ibgeCodigo": 2601409,
    "uf": "PE",
    "nome": "Barreiros"
  },
  {
    "codigoTse": "23280",
    "ibgeCodigo": 2614857,
    "uf": "PE",
    "nome": "Tamandar�"
  },
  {
    "codigoTse": "23299",
    "ibgeCodigo": 2601508,
    "uf": "PE",
    "nome": "Bel�m De Maria"
  },
  {
    "codigoTse": "23302",
    "ibgeCodigo": 2607950,
    "uf": "PE",
    "nome": "Jaqueira"
  },
  {
    "codigoTse": "23310",
    "ibgeCodigo": 2601607,
    "uf": "PE",
    "nome": "Bel�m Do S�o Francisco"
  },
  {
    "codigoTse": "23329",
    "ibgeCodigo": 2612554,
    "uf": "PE",
    "nome": "Santa Filomena"
  },
  {
    "codigoTse": "23337",
    "ibgeCodigo": 2601706,
    "uf": "PE",
    "nome": "Belo Jardim"
  },
  {
    "codigoTse": "23353",
    "ibgeCodigo": 2601805,
    "uf": "PE",
    "nome": "Bet�nia"
  },
  {
    "codigoTse": "23370",
    "ibgeCodigo": 2601904,
    "uf": "PE",
    "nome": "Bezerros"
  },
  {
    "codigoTse": "23396",
    "ibgeCodigo": 2602001,
    "uf": "PE",
    "nome": "Bodoc�"
  },
  {
    "codigoTse": "23418",
    "ibgeCodigo": 2602100,
    "uf": "PE",
    "nome": "Bom Conselho"
  },
  {
    "codigoTse": "23434",
    "ibgeCodigo": 2602209,
    "uf": "PE",
    "nome": "Bom Jardim"
  },
  {
    "codigoTse": "23450",
    "ibgeCodigo": 2602308,
    "uf": "PE",
    "nome": "Bonito"
  },
  {
    "codigoTse": "23477",
    "ibgeCodigo": 2602407,
    "uf": "PE",
    "nome": "Brej�o"
  },
  {
    "codigoTse": "23493",
    "ibgeCodigo": 2602506,
    "uf": "PE",
    "nome": "Brejinho"
  },
  {
    "codigoTse": "23515",
    "ibgeCodigo": 2602605,
    "uf": "PE",
    "nome": "Brejo Da Madre De Deus"
  },
  {
    "codigoTse": "23531",
    "ibgeCodigo": 2602704,
    "uf": "PE",
    "nome": "Buenos Aires"
  },
  {
    "codigoTse": "23558",
    "ibgeCodigo": 2602803,
    "uf": "PE",
    "nome": "Bu�que"
  },
  {
    "codigoTse": "23574",
    "ibgeCodigo": 2602902,
    "uf": "PE",
    "nome": "Cabo De Santo Agostinho"
  },
  {
    "codigoTse": "23590",
    "ibgeCodigo": 2603009,
    "uf": "PE",
    "nome": "Cabrob�"
  },
  {
    "codigoTse": "23612",
    "ibgeCodigo": 2603108,
    "uf": "PE",
    "nome": "Cachoeirinha"
  },
  {
    "codigoTse": "23639",
    "ibgeCodigo": 2603207,
    "uf": "PE",
    "nome": "Caet�s"
  },
  {
    "codigoTse": "23655",
    "ibgeCodigo": 2603306,
    "uf": "PE",
    "nome": "Cal�ado"
  },
  {
    "codigoTse": "23671",
    "ibgeCodigo": 2603405,
    "uf": "PE",
    "nome": "Calumbi"
  },
  {
    "codigoTse": "23698",
    "ibgeCodigo": 2603504,
    "uf": "PE",
    "nome": "Camocim De S�o F�lix"
  },
  {
    "codigoTse": "23710",
    "ibgeCodigo": 2603603,
    "uf": "PE",
    "nome": "Camutanga"
  },
  {
    "codigoTse": "23736",
    "ibgeCodigo": 2603702,
    "uf": "PE",
    "nome": "Canhotinho"
  },
  {
    "codigoTse": "23752",
    "ibgeCodigo": 2603801,
    "uf": "PE",
    "nome": "Capoeiras"
  },
  {
    "codigoTse": "23779",
    "ibgeCodigo": 2603900,
    "uf": "PE",
    "nome": "Carna�ba"
  },
  {
    "codigoTse": "23795",
    "ibgeCodigo": 2604007,
    "uf": "PE",
    "nome": "Carpina"
  },
  {
    "codigoTse": "23817",
    "ibgeCodigo": 2604106,
    "uf": "PE",
    "nome": "Caruaru"
  },
  {
    "codigoTse": "23833",
    "ibgeCodigo": 2604205,
    "uf": "PE",
    "nome": "Catende"
  },
  {
    "codigoTse": "23850",
    "ibgeCodigo": 2604304,
    "uf": "PE",
    "nome": "Cedro"
  },
  {
    "codigoTse": "23876",
    "ibgeCodigo": 2604403,
    "uf": "PE",
    "nome": "Ch� De Alegria"
  },
  {
    "codigoTse": "23892",
    "ibgeCodigo": 2604502,
    "uf": "PE",
    "nome": "Ch� Grande"
  },
  {
    "codigoTse": "23914",
    "ibgeCodigo": 2604601,
    "uf": "PE",
    "nome": "Condado"
  },
  {
    "codigoTse": "23930",
    "ibgeCodigo": 2604700,
    "uf": "PE",
    "nome": "Correntes"
  },
  {
    "codigoTse": "23957",
    "ibgeCodigo": 2604809,
    "uf": "PE",
    "nome": "Cort�s"
  },
  {
    "codigoTse": "23973",
    "ibgeCodigo": 2604908,
    "uf": "PE",
    "nome": "Cumaru"
  },
  {
    "codigoTse": "23990",
    "ibgeCodigo": 2605004,
    "uf": "PE",
    "nome": "Cupira"
  },
  {
    "codigoTse": "24015",
    "ibgeCodigo": 2605103,
    "uf": "PE",
    "nome": "Cust�dia"
  },
  {
    "codigoTse": "24031",
    "ibgeCodigo": 2605202,
    "uf": "PE",
    "nome": "Escada"
  },
  {
    "codigoTse": "24058",
    "ibgeCodigo": 2605301,
    "uf": "PE",
    "nome": "Exu"
  },
  {
    "codigoTse": "24074",
    "ibgeCodigo": 2605400,
    "uf": "PE",
    "nome": "Feira Nova"
  },
  {
    "codigoTse": "24090",
    "ibgeCodigo": 2605509,
    "uf": "PE",
    "nome": "Ferreiros"
  },
  {
    "codigoTse": "24112",
    "ibgeCodigo": 2605608,
    "uf": "PE",
    "nome": "Flores"
  },
  {
    "codigoTse": "24139",
    "ibgeCodigo": 2605707,
    "uf": "PE",
    "nome": "Floresta"
  },
  {
    "codigoTse": "24155",
    "ibgeCodigo": 2605806,
    "uf": "PE",
    "nome": "Frei Miguelinho"
  },
  {
    "codigoTse": "24171",
    "ibgeCodigo": 2605905,
    "uf": "PE",
    "nome": "Gameleira"
  },
  {
    "codigoTse": "24198",
    "ibgeCodigo": 2606002,
    "uf": "PE",
    "nome": "Garanhuns"
  },
  {
    "codigoTse": "24210",
    "ibgeCodigo": 2606101,
    "uf": "PE",
    "nome": "Gl�ria Do Goit�"
  },
  {
    "codigoTse": "24236",
    "ibgeCodigo": 2606200,
    "uf": "PE",
    "nome": "Goiana"
  },
  {
    "codigoTse": "24252",
    "ibgeCodigo": 2606309,
    "uf": "PE",
    "nome": "Granito"
  },
  {
    "codigoTse": "24279",
    "ibgeCodigo": 2606408,
    "uf": "PE",
    "nome": "Gravat�"
  },
  {
    "codigoTse": "24295",
    "ibgeCodigo": 2606507,
    "uf": "PE",
    "nome": "Iati"
  },
  {
    "codigoTse": "24317",
    "ibgeCodigo": 2606606,
    "uf": "PE",
    "nome": "Ibimirim"
  },
  {
    "codigoTse": "24333",
    "ibgeCodigo": 2606705,
    "uf": "PE",
    "nome": "Ibirajuba"
  },
  {
    "codigoTse": "24350",
    "ibgeCodigo": 2606804,
    "uf": "PE",
    "nome": "Igarassu"
  },
  {
    "codigoTse": "24376",
    "ibgeCodigo": 2606903,
    "uf": "PE",
    "nome": "Iguaracy"
  },
  {
    "codigoTse": "24392",
    "ibgeCodigo": 2607000,
    "uf": "PE",
    "nome": "Inaj�"
  },
  {
    "codigoTse": "24414",
    "ibgeCodigo": 2607109,
    "uf": "PE",
    "nome": "Ingazeira"
  },
  {
    "codigoTse": "24430",
    "ibgeCodigo": 2607208,
    "uf": "PE",
    "nome": "Ipojuca"
  },
  {
    "codigoTse": "24457",
    "ibgeCodigo": 2607307,
    "uf": "PE",
    "nome": "Ipubi"
  },
  {
    "codigoTse": "24473",
    "ibgeCodigo": 2607406,
    "uf": "PE",
    "nome": "Itacuruba"
  },
  {
    "codigoTse": "24490",
    "ibgeCodigo": 2607505,
    "uf": "PE",
    "nome": "Ita�ba"
  },
  {
    "codigoTse": "24511",
    "ibgeCodigo": 2607604,
    "uf": "PE",
    "nome": "Ilha De Itamarac�"
  },
  {
    "codigoTse": "24538",
    "ibgeCodigo": 2607703,
    "uf": "PE",
    "nome": "Itapetim"
  },
  {
    "codigoTse": "24554",
    "ibgeCodigo": 2607802,
    "uf": "PE",
    "nome": "Itaquitinga"
  },
  {
    "codigoTse": "24570",
    "ibgeCodigo": 2607901,
    "uf": "PE",
    "nome": "Jaboat�o Dos Guararapes"
  },
  {
    "codigoTse": "24597",
    "ibgeCodigo": 2608008,
    "uf": "PE",
    "nome": "Jata�ba"
  },
  {
    "codigoTse": "24619",
    "ibgeCodigo": 2608107,
    "uf": "PE",
    "nome": "Jo�o Alfredo"
  },
  {
    "codigoTse": "24635",
    "ibgeCodigo": 2608206,
    "uf": "PE",
    "nome": "Joaquim Nabuco"
  },
  {
    "codigoTse": "24651",
    "ibgeCodigo": 2608305,
    "uf": "PE",
    "nome": "Jupi"
  },
  {
    "codigoTse": "24678",
    "ibgeCodigo": 2608404,
    "uf": "PE",
    "nome": "Jurema"
  },
  {
    "codigoTse": "24694",
    "ibgeCodigo": 2608503,
    "uf": "PE",
    "nome": "Lagoa Do Itaenga"
  },
  {
    "codigoTse": "24716",
    "ibgeCodigo": 2608602,
    "uf": "PE",
    "nome": "Lagoa Do Ouro"
  },
  {
    "codigoTse": "24732",
    "ibgeCodigo": 2608701,
    "uf": "PE",
    "nome": "Lagoa Dos Gatos"
  },
  {
    "codigoTse": "24759",
    "ibgeCodigo": 2608800,
    "uf": "PE",
    "nome": "Lajedo"
  },
  {
    "codigoTse": "24775",
    "ibgeCodigo": 2608909,
    "uf": "PE",
    "nome": "Limoeiro"
  },
  {
    "codigoTse": "24791",
    "ibgeCodigo": 2609006,
    "uf": "PE",
    "nome": "Macaparana"
  },
  {
    "codigoTse": "24813",
    "ibgeCodigo": 2609105,
    "uf": "PE",
    "nome": "Machados"
  },
  {
    "codigoTse": "24830",
    "ibgeCodigo": 2609204,
    "uf": "PE",
    "nome": "Maraial"
  },
  {
    "codigoTse": "24856",
    "ibgeCodigo": 2609303,
    "uf": "PE",
    "nome": "Mirandiba"
  },
  {
    "codigoTse": "24872",
    "ibgeCodigo": 2609402,
    "uf": "PE",
    "nome": "Moreno"
  },
  {
    "codigoTse": "24899",
    "ibgeCodigo": 2609501,
    "uf": "PE",
    "nome": "Nazar� Da Mata"
  },
  {
    "codigoTse": "24910",
    "ibgeCodigo": 2609600,
    "uf": "PE",
    "nome": "Olinda"
  },
  {
    "codigoTse": "24937",
    "ibgeCodigo": 2609709,
    "uf": "PE",
    "nome": "Orob�"
  },
  {
    "codigoTse": "24953",
    "ibgeCodigo": 2609808,
    "uf": "PE",
    "nome": "Oroc�"
  },
  {
    "codigoTse": "24970",
    "ibgeCodigo": 2609907,
    "uf": "PE",
    "nome": "Ouricuri"
  },
  {
    "codigoTse": "24996",
    "ibgeCodigo": 2610004,
    "uf": "PE",
    "nome": "Palmares"
  },
  {
    "codigoTse": "25011",
    "ibgeCodigo": 2610103,
    "uf": "PE",
    "nome": "Palmeirina"
  },
  {
    "codigoTse": "25038",
    "ibgeCodigo": 2610202,
    "uf": "PE",
    "nome": "Panelas"
  },
  {
    "codigoTse": "25054",
    "ibgeCodigo": 2610301,
    "uf": "PE",
    "nome": "Paranatama"
  },
  {
    "codigoTse": "25070",
    "ibgeCodigo": 2610400,
    "uf": "PE",
    "nome": "Parnamirim"
  },
  {
    "codigoTse": "25097",
    "ibgeCodigo": 2610509,
    "uf": "PE",
    "nome": "Passira"
  },
  {
    "codigoTse": "25119",
    "ibgeCodigo": 2610608,
    "uf": "PE",
    "nome": "Paudalho"
  },
  {
    "codigoTse": "25135",
    "ibgeCodigo": 2610707,
    "uf": "PE",
    "nome": "Paulista"
  },
  {
    "codigoTse": "25151",
    "ibgeCodigo": 2610806,
    "uf": "PE",
    "nome": "Pedra"
  },
  {
    "codigoTse": "25178",
    "ibgeCodigo": 2610905,
    "uf": "PE",
    "nome": "Pesqueira"
  },
  {
    "codigoTse": "25194",
    "ibgeCodigo": 2611002,
    "uf": "PE",
    "nome": "Petrol�ndia"
  },
  {
    "codigoTse": "25216",
    "ibgeCodigo": 2611101,
    "uf": "PE",
    "nome": "Petrolina"
  },
  {
    "codigoTse": "25232",
    "ibgeCodigo": 2611200,
    "uf": "PE",
    "nome": "Po��o"
  },
  {
    "codigoTse": "25259",
    "ibgeCodigo": 2611309,
    "uf": "PE",
    "nome": "Pombos"
  },
  {
    "codigoTse": "25275",
    "ibgeCodigo": 2611408,
    "uf": "PE",
    "nome": "Primavera"
  },
  {
    "codigoTse": "25291",
    "ibgeCodigo": 2611507,
    "uf": "PE",
    "nome": "Quipap�"
  },
  {
    "codigoTse": "25313",
    "ibgeCodigo": 2611606,
    "uf": "PE",
    "nome": "Recife"
  },
  {
    "codigoTse": "25330",
    "ibgeCodigo": 2611705,
    "uf": "PE",
    "nome": "Riacho Das Almas"
  },
  {
    "codigoTse": "25356",
    "ibgeCodigo": 2611804,
    "uf": "PE",
    "nome": "Ribeir�o"
  },
  {
    "codigoTse": "25372",
    "ibgeCodigo": 2611903,
    "uf": "PE",
    "nome": "Rio Formoso"
  },
  {
    "codigoTse": "25399",
    "ibgeCodigo": 2612000,
    "uf": "PE",
    "nome": "Sair�"
  },
  {
    "codigoTse": "25410",
    "ibgeCodigo": 2612109,
    "uf": "PE",
    "nome": "Salgadinho"
  },
  {
    "codigoTse": "25437",
    "ibgeCodigo": 2612208,
    "uf": "PE",
    "nome": "Salgueiro"
  },
  {
    "codigoTse": "25453",
    "ibgeCodigo": 2612307,
    "uf": "PE",
    "nome": "Salo�"
  },
  {
    "codigoTse": "25470",
    "ibgeCodigo": 2612406,
    "uf": "PE",
    "nome": "Sanhar�"
  },
  {
    "codigoTse": "25496",
    "ibgeCodigo": 2612505,
    "uf": "PE",
    "nome": "Santa Cruz Do Capibaribe"
  },
  {
    "codigoTse": "25518",
    "ibgeCodigo": 2612604,
    "uf": "PE",
    "nome": "Santa Maria Da Boa Vista"
  },
  {
    "codigoTse": "25534",
    "ibgeCodigo": 2612703,
    "uf": "PE",
    "nome": "Santa Maria Do Cambuc�"
  },
  {
    "codigoTse": "25550",
    "ibgeCodigo": 2612802,
    "uf": "PE",
    "nome": "Santa Terezinha"
  },
  {
    "codigoTse": "25577",
    "ibgeCodigo": 2612901,
    "uf": "PE",
    "nome": "S�o Benedito Do Sul"
  },
  {
    "codigoTse": "25593",
    "ibgeCodigo": 2613008,
    "uf": "PE",
    "nome": "S�o Bento Do Una"
  },
  {
    "codigoTse": "25615",
    "ibgeCodigo": 2613107,
    "uf": "PE",
    "nome": "S�o Caitano"
  },
  {
    "codigoTse": "25631",
    "ibgeCodigo": 2613206,
    "uf": "PE",
    "nome": "S�o Jo�o"
  },
  {
    "codigoTse": "25658",
    "ibgeCodigo": 2613305,
    "uf": "PE",
    "nome": "S�o Joaquim Do Monte"
  },
  {
    "codigoTse": "25674",
    "ibgeCodigo": 2613404,
    "uf": "PE",
    "nome": "S�o Jos� Da Coroa Grande"
  },
  {
    "codigoTse": "25690",
    "ibgeCodigo": 2613503,
    "uf": "PE",
    "nome": "S�o Jos� Do Belmonte"
  },
  {
    "codigoTse": "25712",
    "ibgeCodigo": 2613602,
    "uf": "PE",
    "nome": "S�o Jos� Do Egito"
  },
  {
    "codigoTse": "25739",
    "ibgeCodigo": 2613701,
    "uf": "PE",
    "nome": "S�o Louren�o Da Mata"
  },
  {
    "codigoTse": "25755",
    "ibgeCodigo": 2613800,
    "uf": "PE",
    "nome": "S�o Vicente Ferrer"
  },
  {
    "codigoTse": "25771",
    "ibgeCodigo": 2613909,
    "uf": "PE",
    "nome": "Serra Talhada"
  },
  {
    "codigoTse": "25798",
    "ibgeCodigo": 2614006,
    "uf": "PE",
    "nome": "Serrita"
  },
  {
    "codigoTse": "25810",
    "ibgeCodigo": 2614105,
    "uf": "PE",
    "nome": "Sert�nia"
  },
  {
    "codigoTse": "25836",
    "ibgeCodigo": 2614204,
    "uf": "PE",
    "nome": "Sirinha�m"
  },
  {
    "codigoTse": "25852",
    "ibgeCodigo": 2614303,
    "uf": "PE",
    "nome": "Moreil�ndia"
  },
  {
    "codigoTse": "25879",
    "ibgeCodigo": 2614402,
    "uf": "PE",
    "nome": "Solid�o"
  },
  {
    "codigoTse": "25895",
    "ibgeCodigo": 2614501,
    "uf": "PE",
    "nome": "Surubim"
  },
  {
    "codigoTse": "25917",
    "ibgeCodigo": 2614600,
    "uf": "PE",
    "nome": "Tabira"
  },
  {
    "codigoTse": "25933",
    "ibgeCodigo": 2614709,
    "uf": "PE",
    "nome": "Tacaimb�"
  },
  {
    "codigoTse": "25950",
    "ibgeCodigo": 2614808,
    "uf": "PE",
    "nome": "Tacaratu"
  },
  {
    "codigoTse": "25976",
    "ibgeCodigo": 2607653,
    "uf": "PE",
    "nome": "Itamb�"
  },
  {
    "codigoTse": "25992",
    "ibgeCodigo": 2615003,
    "uf": "PE",
    "nome": "Taquaritinga Do Norte"
  },
  {
    "codigoTse": "26018",
    "ibgeCodigo": 2615102,
    "uf": "PE",
    "nome": "Terezinha"
  },
  {
    "codigoTse": "26034",
    "ibgeCodigo": 2615201,
    "uf": "PE",
    "nome": "Terra Nova"
  },
  {
    "codigoTse": "26050",
    "ibgeCodigo": 2615300,
    "uf": "PE",
    "nome": "Timba�ba"
  },
  {
    "codigoTse": "26077",
    "ibgeCodigo": 2615409,
    "uf": "PE",
    "nome": "Toritama"
  },
  {
    "codigoTse": "26093",
    "ibgeCodigo": 2615508,
    "uf": "PE",
    "nome": "Tracunha�m"
  },
  {
    "codigoTse": "26115",
    "ibgeCodigo": 2615607,
    "uf": "PE",
    "nome": "Trindade"
  },
  {
    "codigoTse": "26131",
    "ibgeCodigo": 2615706,
    "uf": "PE",
    "nome": "Triunfo"
  },
  {
    "codigoTse": "26158",
    "ibgeCodigo": 2615805,
    "uf": "PE",
    "nome": "Tupanatinga"
  },
  {
    "codigoTse": "26174",
    "ibgeCodigo": 2615904,
    "uf": "PE",
    "nome": "Tuparetama"
  },
  {
    "codigoTse": "26190",
    "ibgeCodigo": 2616001,
    "uf": "PE",
    "nome": "Venturosa"
  },
  {
    "codigoTse": "26212",
    "ibgeCodigo": 2616100,
    "uf": "PE",
    "nome": "Verdejante"
  },
  {
    "codigoTse": "26239",
    "ibgeCodigo": 2616209,
    "uf": "PE",
    "nome": "Vertentes"
  },
  {
    "codigoTse": "26255",
    "ibgeCodigo": 2616308,
    "uf": "PE",
    "nome": "Vic�ncia"
  },
  {
    "codigoTse": "26271",
    "ibgeCodigo": 2616407,
    "uf": "PE",
    "nome": "Vit�ria De Santo Ant�o"
  },
  {
    "codigoTse": "26298",
    "ibgeCodigo": 2603454,
    "uf": "PE",
    "nome": "Camaragibe"
  },
  {
    "codigoTse": "26310",
    "ibgeCodigo": 2600054,
    "uf": "PE",
    "nome": "Abreu E Lima"
  },
  {
    "codigoTse": "26336",
    "ibgeCodigo": 2607752,
    "uf": "PE",
    "nome": "Itapissuma"
  },
  {
    "codigoTse": "27006",
    "ibgeCodigo": 2706448,
    "uf": "AL",
    "nome": "Paripueira"
  },
  {
    "codigoTse": "27014",
    "ibgeCodigo": 2700102,
    "uf": "AL",
    "nome": "�gua Branca"
  },
  {
    "codigoTse": "27022",
    "ibgeCodigo": 2706422,
    "uf": "AL",
    "nome": "Pariconha"
  },
  {
    "codigoTse": "27030",
    "ibgeCodigo": 2700201,
    "uf": "AL",
    "nome": "Anadia"
  },
  {
    "codigoTse": "27049",
    "ibgeCodigo": 2702553,
    "uf": "AL",
    "nome": "Estrela De Alagoas"
  },
  {
    "codigoTse": "27057",
    "ibgeCodigo": 2700300,
    "uf": "AL",
    "nome": "Arapiraca"
  },
  {
    "codigoTse": "27065",
    "ibgeCodigo": 2703759,
    "uf": "AL",
    "nome": "Jequi� Da Praia"
  },
  {
    "codigoTse": "27073",
    "ibgeCodigo": 2700409,
    "uf": "AL",
    "nome": "Atalaia"
  },
  {
    "codigoTse": "27081",
    "ibgeCodigo": 2701357,
    "uf": "AL",
    "nome": "Campestre"
  },
  {
    "codigoTse": "27090",
    "ibgeCodigo": 2700508,
    "uf": "AL",
    "nome": "Barra De Santo Ant�nio"
  },
  {
    "codigoTse": "27111",
    "ibgeCodigo": 2700607,
    "uf": "AL",
    "nome": "Barra De S�o Miguel"
  },
  {
    "codigoTse": "27138",
    "ibgeCodigo": 2700706,
    "uf": "AL",
    "nome": "Batalha"
  },
  {
    "codigoTse": "27154",
    "ibgeCodigo": 2700805,
    "uf": "AL",
    "nome": "Bel�m"
  },
  {
    "codigoTse": "27170",
    "ibgeCodigo": 2700904,
    "uf": "AL",
    "nome": "Belo Monte"
  },
  {
    "codigoTse": "27197",
    "ibgeCodigo": 2701001,
    "uf": "AL",
    "nome": "Boca Da Mata"
  },
  {
    "codigoTse": "27219",
    "ibgeCodigo": 2701100,
    "uf": "AL",
    "nome": "Branquinha"
  },
  {
    "codigoTse": "27235",
    "ibgeCodigo": 2701209,
    "uf": "AL",
    "nome": "Cacimbinhas"
  },
  {
    "codigoTse": "27251",
    "ibgeCodigo": 2701308,
    "uf": "AL",
    "nome": "Cajueiro"
  },
  {
    "codigoTse": "27278",
    "ibgeCodigo": 2701407,
    "uf": "AL",
    "nome": "Campo Alegre"
  },
  {
    "codigoTse": "27294",
    "ibgeCodigo": 2701506,
    "uf": "AL",
    "nome": "Campo Grande"
  },
  {
    "codigoTse": "27316",
    "ibgeCodigo": 2701605,
    "uf": "AL",
    "nome": "Canapi"
  },
  {
    "codigoTse": "27332",
    "ibgeCodigo": 2701704,
    "uf": "AL",
    "nome": "Capela"
  },
  {
    "codigoTse": "27359",
    "ibgeCodigo": 2701803,
    "uf": "AL",
    "nome": "Carneiros"
  },
  {
    "codigoTse": "27375",
    "ibgeCodigo": 2701902,
    "uf": "AL",
    "nome": "Ch� Preta"
  },
  {
    "codigoTse": "27391",
    "ibgeCodigo": 2702009,
    "uf": "AL",
    "nome": "Coit� Do N�ia"
  },
  {
    "codigoTse": "27413",
    "ibgeCodigo": 2702108,
    "uf": "AL",
    "nome": "Col�nia Leopoldina"
  },
  {
    "codigoTse": "27430",
    "ibgeCodigo": 2702207,
    "uf": "AL",
    "nome": "Coqueiro Seco"
  },
  {
    "codigoTse": "27456",
    "ibgeCodigo": 2702306,
    "uf": "AL",
    "nome": "Coruripe"
  },
  {
    "codigoTse": "27472",
    "ibgeCodigo": 2702405,
    "uf": "AL",
    "nome": "Delmiro Gouveia"
  },
  {
    "codigoTse": "27499",
    "ibgeCodigo": 2702504,
    "uf": "AL",
    "nome": "Dois Riachos"
  },
  {
    "codigoTse": "27510",
    "ibgeCodigo": 2702603,
    "uf": "AL",
    "nome": "Feira Grande"
  },
  {
    "codigoTse": "27537",
    "ibgeCodigo": 2702702,
    "uf": "AL",
    "nome": "Feliz Deserto"
  },
  {
    "codigoTse": "27553",
    "ibgeCodigo": 2702801,
    "uf": "AL",
    "nome": "Flexeiras"
  },
  {
    "codigoTse": "27570",
    "ibgeCodigo": 2702900,
    "uf": "AL",
    "nome": "Girau Do Ponciano"
  },
  {
    "codigoTse": "27596",
    "ibgeCodigo": 2703007,
    "uf": "AL",
    "nome": "Ibateguara"
  },
  {
    "codigoTse": "27618",
    "ibgeCodigo": 2703106,
    "uf": "AL",
    "nome": "Igaci"
  },
  {
    "codigoTse": "27634",
    "ibgeCodigo": 2703205,
    "uf": "AL",
    "nome": "Igreja Nova"
  },
  {
    "codigoTse": "27650",
    "ibgeCodigo": 2703304,
    "uf": "AL",
    "nome": "Inhapi"
  },
  {
    "codigoTse": "27677",
    "ibgeCodigo": 2703403,
    "uf": "AL",
    "nome": "Jacar� Dos Homens"
  },
  {
    "codigoTse": "27693",
    "ibgeCodigo": 2703502,
    "uf": "AL",
    "nome": "Jacu�pe"
  },
  {
    "codigoTse": "27715",
    "ibgeCodigo": 2703601,
    "uf": "AL",
    "nome": "Japaratinga"
  },
  {
    "codigoTse": "27731",
    "ibgeCodigo": 2703700,
    "uf": "AL",
    "nome": "Jaramataia"
  },
  {
    "codigoTse": "27758",
    "ibgeCodigo": 2703809,
    "uf": "AL",
    "nome": "Joaquim Gomes"
  },
  {
    "codigoTse": "27774",
    "ibgeCodigo": 2703908,
    "uf": "AL",
    "nome": "Jundi�"
  },
  {
    "codigoTse": "27790",
    "ibgeCodigo": 2704005,
    "uf": "AL",
    "nome": "Junqueiro"
  },
  {
    "codigoTse": "27812",
    "ibgeCodigo": 2704104,
    "uf": "AL",
    "nome": "Lagoa Da Canoa"
  },
  {
    "codigoTse": "27839",
    "ibgeCodigo": 2704203,
    "uf": "AL",
    "nome": "Limoeiro De Anadia"
  },
  {
    "codigoTse": "27855",
    "ibgeCodigo": 2704302,
    "uf": "AL",
    "nome": "Macei�"
  },
  {
    "codigoTse": "27871",
    "ibgeCodigo": 2704401,
    "uf": "AL",
    "nome": "Major Isidoro"
  },
  {
    "codigoTse": "27898",
    "ibgeCodigo": 2704500,
    "uf": "AL",
    "nome": "Maragogi"
  },
  {
    "codigoTse": "27910",
    "ibgeCodigo": 2704609,
    "uf": "AL",
    "nome": "Maravilha"
  },
  {
    "codigoTse": "27936",
    "ibgeCodigo": 2704708,
    "uf": "AL",
    "nome": "Marechal Deodoro"
  },
  {
    "codigoTse": "27952",
    "ibgeCodigo": 2704807,
    "uf": "AL",
    "nome": "Maribondo"
  },
  {
    "codigoTse": "27979",
    "ibgeCodigo": 2704906,
    "uf": "AL",
    "nome": "Mar Vermelho"
  },
  {
    "codigoTse": "27995",
    "ibgeCodigo": 2705002,
    "uf": "AL",
    "nome": "Mata Grande"
  },
  {
    "codigoTse": "28010",
    "ibgeCodigo": 2705101,
    "uf": "AL",
    "nome": "Matriz De Camaragibe"
  },
  {
    "codigoTse": "28037",
    "ibgeCodigo": 2705200,
    "uf": "AL",
    "nome": "Messias"
  },
  {
    "codigoTse": "28053",
    "ibgeCodigo": 2705309,
    "uf": "AL",
    "nome": "Minador Do Negr�o"
  },
  {
    "codigoTse": "28070",
    "ibgeCodigo": 2705408,
    "uf": "AL",
    "nome": "Monteir�polis"
  },
  {
    "codigoTse": "28096",
    "ibgeCodigo": 2705507,
    "uf": "AL",
    "nome": "Murici"
  },
  {
    "codigoTse": "28118",
    "ibgeCodigo": 2705606,
    "uf": "AL",
    "nome": "Novo Lino"
  },
  {
    "codigoTse": "28134",
    "ibgeCodigo": 2705705,
    "uf": "AL",
    "nome": "Olho D'�gua Das Flores"
  },
  {
    "codigoTse": "28150",
    "ibgeCodigo": 2705804,
    "uf": "AL",
    "nome": "Olho D'�gua Do Casado"
  },
  {
    "codigoTse": "28177",
    "ibgeCodigo": 2705903,
    "uf": "AL",
    "nome": "Olho D'�gua Grande"
  },
  {
    "codigoTse": "28193",
    "ibgeCodigo": 2706000,
    "uf": "AL",
    "nome": "Oliven�a"
  },
  {
    "codigoTse": "28215",
    "ibgeCodigo": 2706109,
    "uf": "AL",
    "nome": "Ouro Branco"
  },
  {
    "codigoTse": "28231",
    "ibgeCodigo": 2706208,
    "uf": "AL",
    "nome": "Palestina"
  },
  {
    "codigoTse": "28258",
    "ibgeCodigo": 2706307,
    "uf": "AL",
    "nome": "Palmeira Dos �ndios"
  },
  {
    "codigoTse": "28274",
    "ibgeCodigo": 2706406,
    "uf": "AL",
    "nome": "P�o De A��car"
  },
  {
    "codigoTse": "28290",
    "ibgeCodigo": 2706505,
    "uf": "AL",
    "nome": "Passo De Camaragibe"
  },
  {
    "codigoTse": "28312",
    "ibgeCodigo": 2706604,
    "uf": "AL",
    "nome": "Paulo Jacinto"
  },
  {
    "codigoTse": "28339",
    "ibgeCodigo": 2706703,
    "uf": "AL",
    "nome": "Penedo"
  },
  {
    "codigoTse": "28355",
    "ibgeCodigo": 2706802,
    "uf": "AL",
    "nome": "Pia�abu�u"
  },
  {
    "codigoTse": "28371",
    "ibgeCodigo": 2706901,
    "uf": "AL",
    "nome": "Pilar"
  },
  {
    "codigoTse": "28398",
    "ibgeCodigo": 2707008,
    "uf": "AL",
    "nome": "Pindoba"
  },
  {
    "codigoTse": "28410",
    "ibgeCodigo": 2707107,
    "uf": "AL",
    "nome": "Piranhas"
  },
  {
    "codigoTse": "28436",
    "ibgeCodigo": 2707206,
    "uf": "AL",
    "nome": "Po�o Das Trincheiras"
  },
  {
    "codigoTse": "28452",
    "ibgeCodigo": 2707305,
    "uf": "AL",
    "nome": "Porto Calvo"
  },
  {
    "codigoTse": "28479",
    "ibgeCodigo": 2707404,
    "uf": "AL",
    "nome": "Porto De Pedras"
  },
  {
    "codigoTse": "28495",
    "ibgeCodigo": 2707503,
    "uf": "AL",
    "nome": "Porto Real Do Col�gio"
  },
  {
    "codigoTse": "28517",
    "ibgeCodigo": 2707602,
    "uf": "AL",
    "nome": "Quebrangulo"
  },
  {
    "codigoTse": "28533",
    "ibgeCodigo": 2707701,
    "uf": "AL",
    "nome": "Rio Largo"
  },
  {
    "codigoTse": "28550",
    "ibgeCodigo": 2707800,
    "uf": "AL",
    "nome": "Roteiro"
  },
  {
    "codigoTse": "28576",
    "ibgeCodigo": 2707909,
    "uf": "AL",
    "nome": "Santa Luzia Do Norte"
  },
  {
    "codigoTse": "28592",
    "ibgeCodigo": 2708006,
    "uf": "AL",
    "nome": "Santana Do Ipanema"
  },
  {
    "codigoTse": "28614",
    "ibgeCodigo": 2708105,
    "uf": "AL",
    "nome": "Santana Do Munda�"
  },
  {
    "codigoTse": "28630",
    "ibgeCodigo": 2708204,
    "uf": "AL",
    "nome": "S�o Br�s"
  },
  {
    "codigoTse": "28657",
    "ibgeCodigo": 2708303,
    "uf": "AL",
    "nome": "S�o Jos� Da Laje"
  },
  {
    "codigoTse": "28673",
    "ibgeCodigo": 2708402,
    "uf": "AL",
    "nome": "S�o Jos� Da Tapera"
  },
  {
    "codigoTse": "28690",
    "ibgeCodigo": 2708501,
    "uf": "AL",
    "nome": "S�o Lu�s Do Quitunde"
  },
  {
    "codigoTse": "28711",
    "ibgeCodigo": 2708600,
    "uf": "AL",
    "nome": "S�o Miguel Dos Campos"
  },
  {
    "codigoTse": "28738",
    "ibgeCodigo": 2708709,
    "uf": "AL",
    "nome": "S�o Miguel Dos Milagres"
  },
  {
    "codigoTse": "28754",
    "ibgeCodigo": 2708808,
    "uf": "AL",
    "nome": "S�o Sebasti�o"
  },
  {
    "codigoTse": "28770",
    "ibgeCodigo": 2708907,
    "uf": "AL",
    "nome": "Satuba"
  },
  {
    "codigoTse": "28797",
    "ibgeCodigo": 2709004,
    "uf": "AL",
    "nome": "Tanque D'Arca"
  },
  {
    "codigoTse": "28819",
    "ibgeCodigo": 2709103,
    "uf": "AL",
    "nome": "Taquarana"
  },
  {
    "codigoTse": "28835",
    "ibgeCodigo": 2709202,
    "uf": "AL",
    "nome": "Traipu"
  },
  {
    "codigoTse": "28851",
    "ibgeCodigo": 2709301,
    "uf": "AL",
    "nome": "Uni�o Dos Palmares"
  },
  {
    "codigoTse": "28878",
    "ibgeCodigo": 2709400,
    "uf": "AL",
    "nome": "Vi�osa"
  },
  {
    "codigoTse": "28894",
    "ibgeCodigo": 2702355,
    "uf": "AL",
    "nome": "Cra�bas"
  },
  {
    "codigoTse": "28916",
    "ibgeCodigo": 2708956,
    "uf": "AL",
    "nome": "Senador Rui Palmeira"
  },
  {
    "codigoTse": "28932",
    "ibgeCodigo": 2709152,
    "uf": "AL",
    "nome": "Teot�nio Vilela"
  },
  {
    "codigoTse": "30007",
    "ibgeCodigo": 2919553,
    "uf": "BA",
    "nome": "Lu�s Eduardo Magalh�es"
  },
  {
    "codigoTse": "30015",
    "ibgeCodigo": 2605459,
    "uf": "PE",
    "nome": "Fernando De Noronha"
  },
  {
    "codigoTse": "30031",
    "ibgeCodigo": 2401453,
    "uf": "RN",
    "nome": "Bara�na"
  },
  {
    "codigoTse": "30058",
    "ibgeCodigo": 2910727,
    "uf": "BA",
    "nome": "Eun�polis"
  },
  {
    "codigoTse": "30660",
    "ibgeCodigo": 2917334,
    "uf": "BA",
    "nome": "Iui�"
  },
  {
    "codigoTse": "30678",
    "ibgeCodigo": 2917359,
    "uf": "BA",
    "nome": "Jaborandi"
  },
  {
    "codigoTse": "30694",
    "ibgeCodigo": 2918555,
    "uf": "BA",
    "nome": "Jussari"
  },
  {
    "codigoTse": "30716",
    "ibgeCodigo": 2901155,
    "uf": "BA",
    "nome": "Am�rica Dourada"
  },
  {
    "codigoTse": "30732",
    "ibgeCodigo": 2902252,
    "uf": "BA",
    "nome": "Arataca"
  },
  {
    "codigoTse": "30759",
    "ibgeCodigo": 2903235,
    "uf": "BA",
    "nome": "Barro Alto"
  },
  {
    "codigoTse": "30775",
    "ibgeCodigo": 2903276,
    "uf": "BA",
    "nome": "Barrocas"
  },
  {
    "codigoTse": "30791",
    "ibgeCodigo": 2904753,
    "uf": "BA",
    "nome": "Buritirama"
  },
  {
    "codigoTse": "30813",
    "ibgeCodigo": 2906857,
    "uf": "BA",
    "nome": "Capela Do Alto Alegre"
  },
  {
    "codigoTse": "30830",
    "ibgeCodigo": 2906873,
    "uf": "BA",
    "nome": "Capim Grosso"
  },
  {
    "codigoTse": "30856",
    "ibgeCodigo": 2906824,
    "uf": "BA",
    "nome": "Canudos"
  },
  {
    "codigoTse": "30872",
    "ibgeCodigo": 2910057,
    "uf": "BA",
    "nome": "Dias D'�vila"
  },
  {
    "codigoTse": "30899",
    "ibgeCodigo": 2910750,
    "uf": "BA",
    "nome": "F�tima"
  },
  {
    "codigoTse": "30910",
    "ibgeCodigo": 2910859,
    "uf": "BA",
    "nome": "Filad�lfia"
  },
  {
    "codigoTse": "30937",
    "ibgeCodigo": 2911253,
    "uf": "BA",
    "nome": "Gavi�o"
  },
  {
    "codigoTse": "30953",
    "ibgeCodigo": 2911659,
    "uf": "BA",
    "nome": "Guajeru"
  },
  {
    "codigoTse": "30970",
    "ibgeCodigo": 2911857,
    "uf": "BA",
    "nome": "Heli�polis"
  },
  {
    "codigoTse": "30996",
    "ibgeCodigo": 2918357,
    "uf": "BA",
    "nome": "Jo�o Dourado"
  },
  {
    "codigoTse": "31003",
    "ibgeCodigo": 2806404,
    "uf": "SE",
    "nome": "Santana Do S�o Francisco"
  },
  {
    "codigoTse": "31011",
    "ibgeCodigo": 2800100,
    "uf": "SE",
    "nome": "Amparo De S�o Francisco"
  },
  {
    "codigoTse": "31038",
    "ibgeCodigo": 2800209,
    "uf": "SE",
    "nome": "Aquidab�"
  },
  {
    "codigoTse": "31054",
    "ibgeCodigo": 2800308,
    "uf": "SE",
    "nome": "Aracaju"
  },
  {
    "codigoTse": "31070",
    "ibgeCodigo": 2800407,
    "uf": "SE",
    "nome": "Arau�"
  },
  {
    "codigoTse": "31097",
    "ibgeCodigo": 2800506,
    "uf": "SE",
    "nome": "Areia Branca"
  },
  {
    "codigoTse": "31119",
    "ibgeCodigo": 2800605,
    "uf": "SE",
    "nome": "Barra Dos Coqueiros"
  },
  {
    "codigoTse": "31135",
    "ibgeCodigo": 2800704,
    "uf": "SE",
    "nome": "Brejo Grande"
  },
  {
    "codigoTse": "31151",
    "ibgeCodigo": 2800670,
    "uf": "SE",
    "nome": "Boquim"
  },
  {
    "codigoTse": "31194",
    "ibgeCodigo": 2801009,
    "uf": "SE",
    "nome": "Campo Do Brito"
  },
  {
    "codigoTse": "31216",
    "ibgeCodigo": 2801108,
    "uf": "SE",
    "nome": "Canhoba"
  },
  {
    "codigoTse": "31232",
    "ibgeCodigo": 2801207,
    "uf": "SE",
    "nome": "Canind� De S�o Francisco"
  },
  {
    "codigoTse": "31259",
    "ibgeCodigo": 2801306,
    "uf": "SE",
    "nome": "Capela"
  },
  {
    "codigoTse": "31275",
    "ibgeCodigo": 2801405,
    "uf": "SE",
    "nome": "Carira"
  },
  {
    "codigoTse": "31291",
    "ibgeCodigo": 2801504,
    "uf": "SE",
    "nome": "Carm�polis"
  },
  {
    "codigoTse": "31313",
    "ibgeCodigo": 2801603,
    "uf": "SE",
    "nome": "Cedro De S�o Jo�o"
  },
  {
    "codigoTse": "31330",
    "ibgeCodigo": 2801702,
    "uf": "SE",
    "nome": "Cristin�polis"
  },
  {
    "codigoTse": "31356",
    "ibgeCodigo": 2804458,
    "uf": "SE",
    "nome": "Nossa Senhora Aparecida"
  },
  {
    "codigoTse": "31372",
    "ibgeCodigo": 2801900,
    "uf": "SE",
    "nome": "Cumbe"
  },
  {
    "codigoTse": "31399",
    "ibgeCodigo": 2802007,
    "uf": "SE",
    "nome": "Divina Pastora"
  },
  {
    "codigoTse": "31410",
    "ibgeCodigo": 2802106,
    "uf": "SE",
    "nome": "Est�ncia"
  },
  {
    "codigoTse": "31437",
    "ibgeCodigo": 2802205,
    "uf": "SE",
    "nome": "Feira Nova"
  },
  {
    "codigoTse": "31453",
    "ibgeCodigo": 2802304,
    "uf": "SE",
    "nome": "Frei Paulo"
  },
  {
    "codigoTse": "31470",
    "ibgeCodigo": 2802502,
    "uf": "SE",
    "nome": "General Maynard"
  },
  {
    "codigoTse": "31496",
    "ibgeCodigo": 2802403,
    "uf": "SE",
    "nome": "Gararu"
  },
  {
    "codigoTse": "31518",
    "ibgeCodigo": 2802601,
    "uf": "SE",
    "nome": "Gracho Cardoso"
  },
  {
    "codigoTse": "31534",
    "ibgeCodigo": 2802700,
    "uf": "SE",
    "nome": "Ilha Das Flores"
  },
  {
    "codigoTse": "31550",
    "ibgeCodigo": 2802809,
    "uf": "SE",
    "nome": "Indiaroba"
  },
  {
    "codigoTse": "31577",
    "ibgeCodigo": 2802908,
    "uf": "SE",
    "nome": "Itabaiana"
  },
  {
    "codigoTse": "31593",
    "ibgeCodigo": 2803005,
    "uf": "SE",
    "nome": "Itabaianinha"
  },
  {
    "codigoTse": "31615",
    "ibgeCodigo": 2803104,
    "uf": "SE",
    "nome": "Itabi"
  },
  {
    "codigoTse": "31631",
    "ibgeCodigo": 2803203,
    "uf": "SE",
    "nome": "Itaporanga D'Ajuda"
  },
  {
    "codigoTse": "31658",
    "ibgeCodigo": 2803302,
    "uf": "SE",
    "nome": "Japaratuba"
  },
  {
    "codigoTse": "31674",
    "ibgeCodigo": 2803401,
    "uf": "SE",
    "nome": "Japoat�"
  },
  {
    "codigoTse": "31690",
    "ibgeCodigo": 2803500,
    "uf": "SE",
    "nome": "Lagarto"
  },
  {
    "codigoTse": "31712",
    "ibgeCodigo": 2803609,
    "uf": "SE",
    "nome": "Laranjeiras"
  },
  {
    "codigoTse": "31739",
    "ibgeCodigo": 2803708,
    "uf": "SE",
    "nome": "Macambira"
  },
  {
    "codigoTse": "31755",
    "ibgeCodigo": 2803807,
    "uf": "SE",
    "nome": "Malhada Dos Bois"
  },
  {
    "codigoTse": "31771",
    "ibgeCodigo": 2803906,
    "uf": "SE",
    "nome": "Malhador"
  },
  {
    "codigoTse": "31798",
    "ibgeCodigo": 2804003,
    "uf": "SE",
    "nome": "Maruim"
  },
  {
    "codigoTse": "31810",
    "ibgeCodigo": 2804102,
    "uf": "SE",
    "nome": "Moita Bonita"
  },
  {
    "codigoTse": "31836",
    "ibgeCodigo": 2804201,
    "uf": "SE",
    "nome": "Monte Alegre De Sergipe"
  },
  {
    "codigoTse": "31852",
    "ibgeCodigo": 2804300,
    "uf": "SE",
    "nome": "Muribeca"
  },
  {
    "codigoTse": "31879",
    "ibgeCodigo": 2804409,
    "uf": "SE",
    "nome": "Ne�polis"
  },
  {
    "codigoTse": "31895",
    "ibgeCodigo": 2804508,
    "uf": "SE",
    "nome": "Nossa Senhora Da Gl�ria"
  },
  {
    "codigoTse": "31917",
    "ibgeCodigo": 2804607,
    "uf": "SE",
    "nome": "Nossa Senhora Das Dores"
  },
  {
    "codigoTse": "31933",
    "ibgeCodigo": 2804706,
    "uf": "SE",
    "nome": "Nossa Senhora De Lourdes"
  },
  {
    "codigoTse": "31950",
    "ibgeCodigo": 2804805,
    "uf": "SE",
    "nome": "Nossa Senhora Do Socorro"
  },
  {
    "codigoTse": "31976",
    "ibgeCodigo": 2804904,
    "uf": "SE",
    "nome": "Pacatuba"
  },
  {
    "codigoTse": "31992",
    "ibgeCodigo": 2805000,
    "uf": "SE",
    "nome": "Pedra Mole"
  },
  {
    "codigoTse": "32018",
    "ibgeCodigo": 2805109,
    "uf": "SE",
    "nome": "Pedrinhas"
  },
  {
    "codigoTse": "32034",
    "ibgeCodigo": 2805208,
    "uf": "SE",
    "nome": "Pinh�o"
  },
  {
    "codigoTse": "32050",
    "ibgeCodigo": 2805307,
    "uf": "SE",
    "nome": "Pirambu"
  },
  {
    "codigoTse": "32077",
    "ibgeCodigo": 2805406,
    "uf": "SE",
    "nome": "Po�o Redondo"
  },
  {
    "codigoTse": "32093",
    "ibgeCodigo": 2805505,
    "uf": "SE",
    "nome": "Po�o Verde"
  },
  {
    "codigoTse": "32115",
    "ibgeCodigo": 2805604,
    "uf": "SE",
    "nome": "Porto Da Folha"
  },
  {
    "codigoTse": "32131",
    "ibgeCodigo": 2805703,
    "uf": "SE",
    "nome": "Propri�"
  },
  {
    "codigoTse": "32158",
    "ibgeCodigo": 2805802,
    "uf": "SE",
    "nome": "Riach�o Do Dantas"
  },
  {
    "codigoTse": "32174",
    "ibgeCodigo": 2805901,
    "uf": "SE",
    "nome": "Riachuelo"
  },
  {
    "codigoTse": "32190",
    "ibgeCodigo": 2806008,
    "uf": "SE",
    "nome": "Ribeir�polis"
  },
  {
    "codigoTse": "32212",
    "ibgeCodigo": 2806107,
    "uf": "SE",
    "nome": "Ros�rio Do Catete"
  },
  {
    "codigoTse": "32239",
    "ibgeCodigo": 2806206,
    "uf": "SE",
    "nome": "Salgado"
  },
  {
    "codigoTse": "32255",
    "ibgeCodigo": 2806305,
    "uf": "SE",
    "nome": "Santa Luzia Do Itanhy"
  },
  {
    "codigoTse": "32298",
    "ibgeCodigo": 2806503,
    "uf": "SE",
    "nome": "Santa Rosa De Lima"
  },
  {
    "codigoTse": "32310",
    "ibgeCodigo": 2806602,
    "uf": "SE",
    "nome": "Santo Amaro Das Brotas"
  },
  {
    "codigoTse": "32336",
    "ibgeCodigo": 2806701,
    "uf": "SE",
    "nome": "S�o Crist�v�o"
  },
  {
    "codigoTse": "32352",
    "ibgeCodigo": 2806800,
    "uf": "SE",
    "nome": "S�o Domingos"
  },
  {
    "codigoTse": "32379",
    "ibgeCodigo": 2806909,
    "uf": "SE",
    "nome": "S�o Francisco"
  },
  {
    "codigoTse": "32395",
    "ibgeCodigo": 2807006,
    "uf": "SE",
    "nome": "S�o Miguel Do Aleixo"
  },
  {
    "codigoTse": "32417",
    "ibgeCodigo": 2807105,
    "uf": "SE",
    "nome": "Sim�o Dias"
  },
  {
    "codigoTse": "32433",
    "ibgeCodigo": 2807204,
    "uf": "SE",
    "nome": "Siriri"
  },
  {
    "codigoTse": "32450",
    "ibgeCodigo": 2807303,
    "uf": "SE",
    "nome": "Telha"
  },
  {
    "codigoTse": "32476",
    "ibgeCodigo": 2807402,
    "uf": "SE",
    "nome": "Tobias Barreto"
  },
  {
    "codigoTse": "32492",
    "ibgeCodigo": 2807501,
    "uf": "SE",
    "nome": "Tomar Do Geru"
  },
  {
    "codigoTse": "32514",
    "ibgeCodigo": 2807600,
    "uf": "SE",
    "nome": "Umba�ba"
  },
  {
    "codigoTse": "33014",
    "ibgeCodigo": 2900108,
    "uf": "BA",
    "nome": "Aba�ra"
  },
  {
    "codigoTse": "33030",
    "ibgeCodigo": 2900207,
    "uf": "BA",
    "nome": "Abar�"
  },
  {
    "codigoTse": "33057",
    "ibgeCodigo": 2900306,
    "uf": "BA",
    "nome": "Acajutiba"
  },
  {
    "codigoTse": "33065",
    "ibgeCodigo": 2900355,
    "uf": "BA",
    "nome": "Adustina"
  },
  {
    "codigoTse": "33073",
    "ibgeCodigo": 2900405,
    "uf": "BA",
    "nome": "�gua Fria"
  },
  {
    "codigoTse": "33090",
    "ibgeCodigo": 2900504,
    "uf": "BA",
    "nome": "�rico Cardoso"
  },
  {
    "codigoTse": "33111",
    "ibgeCodigo": 2900603,
    "uf": "BA",
    "nome": "Aiquara"
  },
  {
    "codigoTse": "33138",
    "ibgeCodigo": 2900702,
    "uf": "BA",
    "nome": "Alagoinhas"
  },
  {
    "codigoTse": "33154",
    "ibgeCodigo": 2900801,
    "uf": "BA",
    "nome": "Alcoba�a"
  },
  {
    "codigoTse": "33170",
    "ibgeCodigo": 2900900,
    "uf": "BA",
    "nome": "Almadina"
  },
  {
    "codigoTse": "33197",
    "ibgeCodigo": 2901007,
    "uf": "BA",
    "nome": "Amargosa"
  },
  {
    "codigoTse": "33219",
    "ibgeCodigo": 2901106,
    "uf": "BA",
    "nome": "Am�lia Rodrigues"
  },
  {
    "codigoTse": "33235",
    "ibgeCodigo": 2901205,
    "uf": "BA",
    "nome": "Anag�"
  },
  {
    "codigoTse": "33251",
    "ibgeCodigo": 2901304,
    "uf": "BA",
    "nome": "Andara�"
  },
  {
    "codigoTse": "33260",
    "ibgeCodigo": 2901353,
    "uf": "BA",
    "nome": "Andorinha"
  },
  {
    "codigoTse": "33278",
    "ibgeCodigo": 2901403,
    "uf": "BA",
    "nome": "Angical"
  },
  {
    "codigoTse": "33294",
    "ibgeCodigo": 2901502,
    "uf": "BA",
    "nome": "Anguera"
  },
  {
    "codigoTse": "33316",
    "ibgeCodigo": 2901601,
    "uf": "BA",
    "nome": "Antas"
  },
  {
    "codigoTse": "33332",
    "ibgeCodigo": 2901700,
    "uf": "BA",
    "nome": "Ant�nio Cardoso"
  },
  {
    "codigoTse": "33359",
    "ibgeCodigo": 2901809,
    "uf": "BA",
    "nome": "Ant�nio Gon�alves"
  },
  {
    "codigoTse": "33375",
    "ibgeCodigo": 2901908,
    "uf": "BA",
    "nome": "Apor�"
  },
  {
    "codigoTse": "33383",
    "ibgeCodigo": 2902054,
    "uf": "BA",
    "nome": "Ara�as"
  },
  {
    "codigoTse": "33391",
    "ibgeCodigo": 2902005,
    "uf": "BA",
    "nome": "Aracatu"
  },
  {
    "codigoTse": "33405",
    "ibgeCodigo": 2901957,
    "uf": "BA",
    "nome": "Apuarema"
  },
  {
    "codigoTse": "33413",
    "ibgeCodigo": 2902104,
    "uf": "BA",
    "nome": "Araci"
  },
  {
    "codigoTse": "33430",
    "ibgeCodigo": 2902203,
    "uf": "BA",
    "nome": "Aramari"
  },
  {
    "codigoTse": "33456",
    "ibgeCodigo": 2902302,
    "uf": "BA",
    "nome": "Aratu�pe"
  },
  {
    "codigoTse": "33472",
    "ibgeCodigo": 2902401,
    "uf": "BA",
    "nome": "Aurelino Leal"
  },
  {
    "codigoTse": "33499",
    "ibgeCodigo": 2902500,
    "uf": "BA",
    "nome": "Baian�polis"
  },
  {
    "codigoTse": "33510",
    "ibgeCodigo": 2902609,
    "uf": "BA",
    "nome": "Baixa Grande"
  },
  {
    "codigoTse": "33529",
    "ibgeCodigo": 2902658,
    "uf": "BA",
    "nome": "Banza�"
  },
  {
    "codigoTse": "33537",
    "ibgeCodigo": 2902708,
    "uf": "BA",
    "nome": "Barra"
  },
  {
    "codigoTse": "33553",
    "ibgeCodigo": 2902807,
    "uf": "BA",
    "nome": "Barra Da Estiva"
  },
  {
    "codigoTse": "33570",
    "ibgeCodigo": 2902906,
    "uf": "BA",
    "nome": "Barra Do Cho�a"
  },
  {
    "codigoTse": "33596",
    "ibgeCodigo": 2903003,
    "uf": "BA",
    "nome": "Barra Do Mendes"
  },
  {
    "codigoTse": "33618",
    "ibgeCodigo": 2903102,
    "uf": "BA",
    "nome": "Barra Do Rocha"
  },
  {
    "codigoTse": "33634",
    "ibgeCodigo": 2903201,
    "uf": "BA",
    "nome": "Barreiras"
  },
  {
    "codigoTse": "33650",
    "ibgeCodigo": 2903300,
    "uf": "BA",
    "nome": "Barro Preto"
  },
  {
    "codigoTse": "33677",
    "ibgeCodigo": 2903409,
    "uf": "BA",
    "nome": "Belmonte"
  },
  {
    "codigoTse": "33693",
    "ibgeCodigo": 2903508,
    "uf": "BA",
    "nome": "Belo Campo"
  },
  {
    "codigoTse": "33715",
    "ibgeCodigo": 2903607,
    "uf": "BA",
    "nome": "Biritinga"
  },
  {
    "codigoTse": "33731",
    "ibgeCodigo": 2903706,
    "uf": "BA",
    "nome": "Boa Nova"
  },
  {
    "codigoTse": "33758",
    "ibgeCodigo": 2903805,
    "uf": "BA",
    "nome": "Boa Vista Do Tupim"
  },
  {
    "codigoTse": "33774",
    "ibgeCodigo": 2903904,
    "uf": "BA",
    "nome": "Bom Jesus Da Lapa"
  },
  {
    "codigoTse": "33782",
    "ibgeCodigo": 2903953,
    "uf": "BA",
    "nome": "Bom Jesus Da Serra"
  },
  {
    "codigoTse": "33790",
    "ibgeCodigo": 2904001,
    "uf": "BA",
    "nome": "Boninal"
  },
  {
    "codigoTse": "33804",
    "ibgeCodigo": 2904050,
    "uf": "BA",
    "nome": "Bonito"
  },
  {
    "codigoTse": "33812",
    "ibgeCodigo": 2904100,
    "uf": "BA",
    "nome": "Boquira"
  },
  {
    "codigoTse": "33839",
    "ibgeCodigo": 2904209,
    "uf": "BA",
    "nome": "Botupor�"
  },
  {
    "codigoTse": "33855",
    "ibgeCodigo": 2904308,
    "uf": "BA",
    "nome": "Brej�es"
  },
  {
    "codigoTse": "33871",
    "ibgeCodigo": 2904407,
    "uf": "BA",
    "nome": "Brejol�ndia"
  },
  {
    "codigoTse": "33898",
    "ibgeCodigo": 2904506,
    "uf": "BA",
    "nome": "Brotas De Maca�bas"
  },
  {
    "codigoTse": "33910",
    "ibgeCodigo": 2904605,
    "uf": "BA",
    "nome": "Brumado"
  },
  {
    "codigoTse": "33936",
    "ibgeCodigo": 2904704,
    "uf": "BA",
    "nome": "Buerarema"
  },
  {
    "codigoTse": "33952",
    "ibgeCodigo": 2904803,
    "uf": "BA",
    "nome": "Caatiba"
  },
  {
    "codigoTse": "33960",
    "ibgeCodigo": 2904852,
    "uf": "BA",
    "nome": "Cabaceiras Do Paragua�u"
  },
  {
    "codigoTse": "33979",
    "ibgeCodigo": 2904902,
    "uf": "BA",
    "nome": "Cachoeira"
  },
  {
    "codigoTse": "33995",
    "ibgeCodigo": 2905008,
    "uf": "BA",
    "nome": "Cacul�"
  },
  {
    "codigoTse": "34010",
    "ibgeCodigo": 2905107,
    "uf": "BA",
    "nome": "Ca�m"
  },
  {
    "codigoTse": "34029",
    "ibgeCodigo": 2905156,
    "uf": "BA",
    "nome": "Caetanos"
  },
  {
    "codigoTse": "34037",
    "ibgeCodigo": 2905206,
    "uf": "BA",
    "nome": "Caetit�"
  },
  {
    "codigoTse": "34053",
    "ibgeCodigo": 2905305,
    "uf": "BA",
    "nome": "Cafarnaum"
  },
  {
    "codigoTse": "34070",
    "ibgeCodigo": 2905404,
    "uf": "BA",
    "nome": "Cairu"
  },
  {
    "codigoTse": "34096",
    "ibgeCodigo": 2905503,
    "uf": "BA",
    "nome": "Caldeir�o Grande"
  },
  {
    "codigoTse": "34118",
    "ibgeCodigo": 2905602,
    "uf": "BA",
    "nome": "Camacan"
  },
  {
    "codigoTse": "34134",
    "ibgeCodigo": 2905701,
    "uf": "BA",
    "nome": "Cama�ari"
  },
  {
    "codigoTse": "34150",
    "ibgeCodigo": 2905800,
    "uf": "BA",
    "nome": "Camamu"
  },
  {
    "codigoTse": "34177",
    "ibgeCodigo": 2905909,
    "uf": "BA",
    "nome": "Campo Alegre De Lourdes"
  },
  {
    "codigoTse": "34193",
    "ibgeCodigo": 2906006,
    "uf": "BA",
    "nome": "Campo Formoso"
  },
  {
    "codigoTse": "34215",
    "ibgeCodigo": 2906105,
    "uf": "BA",
    "nome": "Can�polis"
  },
  {
    "codigoTse": "34231",
    "ibgeCodigo": 2906204,
    "uf": "BA",
    "nome": "Canarana"
  },
  {
    "codigoTse": "34258",
    "ibgeCodigo": 2906303,
    "uf": "BA",
    "nome": "Canavieiras"
  },
  {
    "codigoTse": "34274",
    "ibgeCodigo": 2906402,
    "uf": "BA",
    "nome": "Candeal"
  },
  {
    "codigoTse": "34290",
    "ibgeCodigo": 2906501,
    "uf": "BA",
    "nome": "Candeias"
  },
  {
    "codigoTse": "34312",
    "ibgeCodigo": 2906600,
    "uf": "BA",
    "nome": "Candiba"
  },
  {
    "codigoTse": "34339",
    "ibgeCodigo": 2906709,
    "uf": "BA",
    "nome": "C�ndido Sales"
  },
  {
    "codigoTse": "34355",
    "ibgeCodigo": 2906808,
    "uf": "BA",
    "nome": "Cansan��o"
  },
  {
    "codigoTse": "34363",
    "ibgeCodigo": 2906899,
    "uf": "BA",
    "nome": "Cara�bas"
  },
  {
    "codigoTse": "34371",
    "ibgeCodigo": 2906907,
    "uf": "BA",
    "nome": "Caravelas"
  },
  {
    "codigoTse": "34398",
    "ibgeCodigo": 2907004,
    "uf": "BA",
    "nome": "Cardeal Da Silva"
  },
  {
    "codigoTse": "34410",
    "ibgeCodigo": 2907103,
    "uf": "BA",
    "nome": "Carinhanha"
  },
  {
    "codigoTse": "34436",
    "ibgeCodigo": 2907202,
    "uf": "BA",
    "nome": "Casa Nova"
  },
  {
    "codigoTse": "34452",
    "ibgeCodigo": 2907301,
    "uf": "BA",
    "nome": "Castro Alves"
  },
  {
    "codigoTse": "34479",
    "ibgeCodigo": 2907400,
    "uf": "BA",
    "nome": "Catol�ndia"
  },
  {
    "codigoTse": "34495",
    "ibgeCodigo": 2907509,
    "uf": "BA",
    "nome": "Catu"
  },
  {
    "codigoTse": "34509",
    "ibgeCodigo": 2907558,
    "uf": "BA",
    "nome": "Caturama"
  },
  {
    "codigoTse": "34517",
    "ibgeCodigo": 2907608,
    "uf": "BA",
    "nome": "Central"
  },
  {
    "codigoTse": "34533",
    "ibgeCodigo": 2907707,
    "uf": "BA",
    "nome": "Chorroch�"
  },
  {
    "codigoTse": "34550",
    "ibgeCodigo": 2907806,
    "uf": "BA",
    "nome": "C�cero Dantas"
  },
  {
    "codigoTse": "34576",
    "ibgeCodigo": 2907905,
    "uf": "BA",
    "nome": "Cip�"
  },
  {
    "codigoTse": "34592",
    "ibgeCodigo": 2908002,
    "uf": "BA",
    "nome": "Coaraci"
  },
  {
    "codigoTse": "34614",
    "ibgeCodigo": 2908101,
    "uf": "BA",
    "nome": "Cocos"
  },
  {
    "codigoTse": "34630",
    "ibgeCodigo": 2908200,
    "uf": "BA",
    "nome": "Concei��o Da Feira"
  },
  {
    "codigoTse": "34657",
    "ibgeCodigo": 2908309,
    "uf": "BA",
    "nome": "Concei��o Do Almeida"
  },
  {
    "codigoTse": "34673",
    "ibgeCodigo": 2908408,
    "uf": "BA",
    "nome": "Concei��o Do Coit�"
  },
  {
    "codigoTse": "34690",
    "ibgeCodigo": 2908507,
    "uf": "BA",
    "nome": "Concei��o Do Jacu�pe"
  },
  {
    "codigoTse": "34711",
    "ibgeCodigo": 2908606,
    "uf": "BA",
    "nome": "Conde"
  },
  {
    "codigoTse": "34738",
    "ibgeCodigo": 2908705,
    "uf": "BA",
    "nome": "Conde�ba"
  },
  {
    "codigoTse": "34754",
    "ibgeCodigo": 2908804,
    "uf": "BA",
    "nome": "Contendas Do Sincor�"
  },
  {
    "codigoTse": "34770",
    "ibgeCodigo": 2908903,
    "uf": "BA",
    "nome": "Cora��o De Maria"
  },
  {
    "codigoTse": "34797",
    "ibgeCodigo": 2909000,
    "uf": "BA",
    "nome": "Cordeiros"
  },
  {
    "codigoTse": "34819",
    "ibgeCodigo": 2909109,
    "uf": "BA",
    "nome": "Coribe"
  },
  {
    "codigoTse": "34835",
    "ibgeCodigo": 2909208,
    "uf": "BA",
    "nome": "Coronel Jo�o S�"
  },
  {
    "codigoTse": "34851",
    "ibgeCodigo": 2909307,
    "uf": "BA",
    "nome": "Correntina"
  },
  {
    "codigoTse": "34878",
    "ibgeCodigo": 2909406,
    "uf": "BA",
    "nome": "Cotegipe"
  },
  {
    "codigoTse": "34894",
    "ibgeCodigo": 2909505,
    "uf": "BA",
    "nome": "Cravol�ndia"
  },
  {
    "codigoTse": "34916",
    "ibgeCodigo": 2909604,
    "uf": "BA",
    "nome": "Cris�polis"
  },
  {
    "codigoTse": "34932",
    "ibgeCodigo": 2909703,
    "uf": "BA",
    "nome": "Crist�polis"
  },
  {
    "codigoTse": "34959",
    "ibgeCodigo": 2909802,
    "uf": "BA",
    "nome": "Cruz Das Almas"
  },
  {
    "codigoTse": "34975",
    "ibgeCodigo": 2909901,
    "uf": "BA",
    "nome": "Cura��"
  },
  {
    "codigoTse": "34991",
    "ibgeCodigo": 2910008,
    "uf": "BA",
    "nome": "D�rio Meira"
  },
  {
    "codigoTse": "35017",
    "ibgeCodigo": 2910107,
    "uf": "BA",
    "nome": "Dom Bas�lio"
  },
  {
    "codigoTse": "35033",
    "ibgeCodigo": 2910206,
    "uf": "BA",
    "nome": "Dom Macedo Costa"
  },
  {
    "codigoTse": "35050",
    "ibgeCodigo": 2910305,
    "uf": "BA",
    "nome": "El�sio Medrado"
  },
  {
    "codigoTse": "35076",
    "ibgeCodigo": 2910404,
    "uf": "BA",
    "nome": "Encruzilhada"
  },
  {
    "codigoTse": "35092",
    "ibgeCodigo": 2910503,
    "uf": "BA",
    "nome": "Entre Rios"
  },
  {
    "codigoTse": "35114",
    "ibgeCodigo": 2910602,
    "uf": "BA",
    "nome": "Esplanada"
  },
  {
    "codigoTse": "35130",
    "ibgeCodigo": 2910701,
    "uf": "BA",
    "nome": "Euclides Da Cunha"
  },
  {
    "codigoTse": "35149",
    "ibgeCodigo": 2910776,
    "uf": "BA",
    "nome": "Feira Da Mata"
  },
  {
    "codigoTse": "35157",
    "ibgeCodigo": 2910800,
    "uf": "BA",
    "nome": "Feira De Santana"
  },
  {
    "codigoTse": "35173",
    "ibgeCodigo": 2910909,
    "uf": "BA",
    "nome": "Firmino Alves"
  },
  {
    "codigoTse": "35190",
    "ibgeCodigo": 2911006,
    "uf": "BA",
    "nome": "Floresta Azul"
  },
  {
    "codigoTse": "35211",
    "ibgeCodigo": 2911105,
    "uf": "BA",
    "nome": "Formosa Do Rio Preto"
  },
  {
    "codigoTse": "35238",
    "ibgeCodigo": 2911204,
    "uf": "BA",
    "nome": "Gandu"
  },
  {
    "codigoTse": "35254",
    "ibgeCodigo": 2911303,
    "uf": "BA",
    "nome": "Gentio Do Ouro"
  },
  {
    "codigoTse": "35270",
    "ibgeCodigo": 2911402,
    "uf": "BA",
    "nome": "Gl�ria"
  },
  {
    "codigoTse": "35297",
    "ibgeCodigo": 2911501,
    "uf": "BA",
    "nome": "Gongogi"
  },
  {
    "codigoTse": "35319",
    "ibgeCodigo": 2911600,
    "uf": "BA",
    "nome": "Governador Mangabeira"
  },
  {
    "codigoTse": "35335",
    "ibgeCodigo": 2911709,
    "uf": "BA",
    "nome": "Guanambi"
  },
  {
    "codigoTse": "35351",
    "ibgeCodigo": 2911808,
    "uf": "BA",
    "nome": "Guaratinga"
  },
  {
    "codigoTse": "35378",
    "ibgeCodigo": 2911907,
    "uf": "BA",
    "nome": "Ia�u"
  },
  {
    "codigoTse": "35394",
    "ibgeCodigo": 2912004,
    "uf": "BA",
    "nome": "Ibiassuc�"
  },
  {
    "codigoTse": "35416",
    "ibgeCodigo": 2912103,
    "uf": "BA",
    "nome": "Ibicara�"
  },
  {
    "codigoTse": "35432",
    "ibgeCodigo": 2912202,
    "uf": "BA",
    "nome": "Ibicoara"
  },
  {
    "codigoTse": "35459",
    "ibgeCodigo": 2912301,
    "uf": "BA",
    "nome": "Ibicu�"
  },
  {
    "codigoTse": "35475",
    "ibgeCodigo": 2912400,
    "uf": "BA",
    "nome": "Ibipeba"
  },
  {
    "codigoTse": "35491",
    "ibgeCodigo": 2928406,
    "uf": "BA",
    "nome": "Santa Rita De C�ssia"
  },
  {
    "codigoTse": "35513",
    "ibgeCodigo": 2912509,
    "uf": "BA",
    "nome": "Ibipitanga"
  },
  {
    "codigoTse": "35530",
    "ibgeCodigo": 2912608,
    "uf": "BA",
    "nome": "Ibiquera"
  },
  {
    "codigoTse": "35556",
    "ibgeCodigo": 2912707,
    "uf": "BA",
    "nome": "Ibirapitanga"
  },
  {
    "codigoTse": "35572",
    "ibgeCodigo": 2912806,
    "uf": "BA",
    "nome": "Ibirapu�"
  },
  {
    "codigoTse": "35599",
    "ibgeCodigo": 2912905,
    "uf": "BA",
    "nome": "Ibirataia"
  },
  {
    "codigoTse": "35610",
    "ibgeCodigo": 2913002,
    "uf": "BA",
    "nome": "Ibitiara"
  },
  {
    "codigoTse": "35637",
    "ibgeCodigo": 2913101,
    "uf": "BA",
    "nome": "Ibitit�"
  },
  {
    "codigoTse": "35653",
    "ibgeCodigo": 2913200,
    "uf": "BA",
    "nome": "Ibotirama"
  },
  {
    "codigoTse": "35670",
    "ibgeCodigo": 2913309,
    "uf": "BA",
    "nome": "Ichu"
  },
  {
    "codigoTse": "35696",
    "ibgeCodigo": 2913408,
    "uf": "BA",
    "nome": "Igapor�"
  },
  {
    "codigoTse": "35700",
    "ibgeCodigo": 2913457,
    "uf": "BA",
    "nome": "Igrapi�na"
  },
  {
    "codigoTse": "35718",
    "ibgeCodigo": 2913507,
    "uf": "BA",
    "nome": "Igua�"
  },
  {
    "codigoTse": "35734",
    "ibgeCodigo": 2913606,
    "uf": "BA",
    "nome": "Ilh�us"
  },
  {
    "codigoTse": "35750",
    "ibgeCodigo": 2913705,
    "uf": "BA",
    "nome": "Inhambupe"
  },
  {
    "codigoTse": "35777",
    "ibgeCodigo": 2913804,
    "uf": "BA",
    "nome": "Ipecaet�"
  },
  {
    "codigoTse": "35793",
    "ibgeCodigo": 2913903,
    "uf": "BA",
    "nome": "Ipia�"
  },
  {
    "codigoTse": "35815",
    "ibgeCodigo": 2914000,
    "uf": "BA",
    "nome": "Ipir�"
  },
  {
    "codigoTse": "35831",
    "ibgeCodigo": 2914109,
    "uf": "BA",
    "nome": "Ipupiara"
  },
  {
    "codigoTse": "35858",
    "ibgeCodigo": 2914208,
    "uf": "BA",
    "nome": "Irajuba"
  },
  {
    "codigoTse": "35874",
    "ibgeCodigo": 2914307,
    "uf": "BA",
    "nome": "Iramaia"
  },
  {
    "codigoTse": "35890",
    "ibgeCodigo": 2914406,
    "uf": "BA",
    "nome": "Iraquara"
  },
  {
    "codigoTse": "35912",
    "ibgeCodigo": 2914505,
    "uf": "BA",
    "nome": "Irar�"
  },
  {
    "codigoTse": "35939",
    "ibgeCodigo": 2914604,
    "uf": "BA",
    "nome": "Irec�"
  },
  {
    "codigoTse": "35947",
    "ibgeCodigo": 2914653,
    "uf": "BA",
    "nome": "Itabela"
  },
  {
    "codigoTse": "35955",
    "ibgeCodigo": 2914703,
    "uf": "BA",
    "nome": "Itaberaba"
  },
  {
    "codigoTse": "35971",
    "ibgeCodigo": 2914802,
    "uf": "BA",
    "nome": "Itabuna"
  },
  {
    "codigoTse": "35998",
    "ibgeCodigo": 2914901,
    "uf": "BA",
    "nome": "Itacar�"
  },
  {
    "codigoTse": "36013",
    "ibgeCodigo": 2915007,
    "uf": "BA",
    "nome": "Itaet�"
  },
  {
    "codigoTse": "36030",
    "ibgeCodigo": 2915106,
    "uf": "BA",
    "nome": "Itagi"
  },
  {
    "codigoTse": "36056",
    "ibgeCodigo": 2915205,
    "uf": "BA",
    "nome": "Itagib�"
  },
  {
    "codigoTse": "36072",
    "ibgeCodigo": 2915304,
    "uf": "BA",
    "nome": "Itagimirim"
  },
  {
    "codigoTse": "36080",
    "ibgeCodigo": 2915353,
    "uf": "BA",
    "nome": "Itagua�u Da Bahia"
  },
  {
    "codigoTse": "36099",
    "ibgeCodigo": 2915403,
    "uf": "BA",
    "nome": "Itaju Do Col�nia"
  },
  {
    "codigoTse": "36110",
    "ibgeCodigo": 2915502,
    "uf": "BA",
    "nome": "Itaju�pe"
  },
  {
    "codigoTse": "36137",
    "ibgeCodigo": 2915601,
    "uf": "BA",
    "nome": "Itamaraju"
  },
  {
    "codigoTse": "36153",
    "ibgeCodigo": 2915700,
    "uf": "BA",
    "nome": "Itamari"
  },
  {
    "codigoTse": "36170",
    "ibgeCodigo": 2915809,
    "uf": "BA",
    "nome": "Itamb�"
  },
  {
    "codigoTse": "36196",
    "ibgeCodigo": 2915908,
    "uf": "BA",
    "nome": "Itanagra"
  },
  {
    "codigoTse": "36218",
    "ibgeCodigo": 2916005,
    "uf": "BA",
    "nome": "Itanh�m"
  },
  {
    "codigoTse": "36234",
    "ibgeCodigo": 2916104,
    "uf": "BA",
    "nome": "Itaparica"
  },
  {
    "codigoTse": "36250",
    "ibgeCodigo": 2916203,
    "uf": "BA",
    "nome": "Itap�"
  },
  {
    "codigoTse": "36277",
    "ibgeCodigo": 2916302,
    "uf": "BA",
    "nome": "Itapebi"
  },
  {
    "codigoTse": "36293",
    "ibgeCodigo": 2916401,
    "uf": "BA",
    "nome": "Itapetinga"
  },
  {
    "codigoTse": "36315",
    "ibgeCodigo": 2916500,
    "uf": "BA",
    "nome": "Itapicuru"
  },
  {
    "codigoTse": "36331",
    "ibgeCodigo": 2916609,
    "uf": "BA",
    "nome": "Itapitanga"
  },
  {
    "codigoTse": "36358",
    "ibgeCodigo": 2916708,
    "uf": "BA",
    "nome": "Itaquara"
  },
  {
    "codigoTse": "36374",
    "ibgeCodigo": 2916807,
    "uf": "BA",
    "nome": "Itarantim"
  },
  {
    "codigoTse": "36382",
    "ibgeCodigo": 2916856,
    "uf": "BA",
    "nome": "Itatim"
  },
  {
    "codigoTse": "36390",
    "ibgeCodigo": 2916906,
    "uf": "BA",
    "nome": "Itiru�u"
  },
  {
    "codigoTse": "36412",
    "ibgeCodigo": 2917003,
    "uf": "BA",
    "nome": "Iti�ba"
  },
  {
    "codigoTse": "36439",
    "ibgeCodigo": 2917102,
    "uf": "BA",
    "nome": "Itoror�"
  },
  {
    "codigoTse": "36455",
    "ibgeCodigo": 2917201,
    "uf": "BA",
    "nome": "Itua�u"
  },
  {
    "codigoTse": "36471",
    "ibgeCodigo": 2917300,
    "uf": "BA",
    "nome": "Ituber�"
  },
  {
    "codigoTse": "36498",
    "ibgeCodigo": 2917409,
    "uf": "BA",
    "nome": "Jacaraci"
  },
  {
    "codigoTse": "36510",
    "ibgeCodigo": 2917508,
    "uf": "BA",
    "nome": "Jacobina"
  },
  {
    "codigoTse": "36536",
    "ibgeCodigo": 2917607,
    "uf": "BA",
    "nome": "Jaguaquara"
  },
  {
    "codigoTse": "36552",
    "ibgeCodigo": 2917706,
    "uf": "BA",
    "nome": "Jaguarari"
  },
  {
    "codigoTse": "36579",
    "ibgeCodigo": 2917805,
    "uf": "BA",
    "nome": "Jaguaripe"
  },
  {
    "codigoTse": "36595",
    "ibgeCodigo": 2917904,
    "uf": "BA",
    "nome": "Janda�ra"
  },
  {
    "codigoTse": "36617",
    "ibgeCodigo": 2918001,
    "uf": "BA",
    "nome": "Jequi�"
  },
  {
    "codigoTse": "36633",
    "ibgeCodigo": 2918100,
    "uf": "BA",
    "nome": "Jeremoabo"
  },
  {
    "codigoTse": "36650",
    "ibgeCodigo": 2918209,
    "uf": "BA",
    "nome": "Jiquiri��"
  },
  {
    "codigoTse": "36676",
    "ibgeCodigo": 2918308,
    "uf": "BA",
    "nome": "Jita�na"
  },
  {
    "codigoTse": "36692",
    "ibgeCodigo": 2918407,
    "uf": "BA",
    "nome": "Juazeiro"
  },
  {
    "codigoTse": "36706",
    "ibgeCodigo": 2918456,
    "uf": "BA",
    "nome": "Jucuru�u"
  },
  {
    "codigoTse": "36714",
    "ibgeCodigo": 2918506,
    "uf": "BA",
    "nome": "Jussara"
  },
  {
    "codigoTse": "36730",
    "ibgeCodigo": 2918605,
    "uf": "BA",
    "nome": "Jussiape"
  },
  {
    "codigoTse": "36757",
    "ibgeCodigo": 2918704,
    "uf": "BA",
    "nome": "Lafaiete Coutinho"
  },
  {
    "codigoTse": "36765",
    "ibgeCodigo": 2918753,
    "uf": "BA",
    "nome": "Lagoa Real"
  },
  {
    "codigoTse": "36773",
    "ibgeCodigo": 2918803,
    "uf": "BA",
    "nome": "Laje"
  },
  {
    "codigoTse": "36790",
    "ibgeCodigo": 2918902,
    "uf": "BA",
    "nome": "Lajed�o"
  },
  {
    "codigoTse": "36811",
    "ibgeCodigo": 2919009,
    "uf": "BA",
    "nome": "Lajedinho"
  },
  {
    "codigoTse": "36820",
    "ibgeCodigo": 2919058,
    "uf": "BA",
    "nome": "Lajedo Do Tabocal"
  },
  {
    "codigoTse": "36838",
    "ibgeCodigo": 2919108,
    "uf": "BA",
    "nome": "Lamar�o"
  },
  {
    "codigoTse": "36854",
    "ibgeCodigo": 2919207,
    "uf": "BA",
    "nome": "Lauro De Freitas"
  },
  {
    "codigoTse": "36870",
    "ibgeCodigo": 2919306,
    "uf": "BA",
    "nome": "Len��is"
  },
  {
    "codigoTse": "36897",
    "ibgeCodigo": 2919405,
    "uf": "BA",
    "nome": "Lic�nio De Almeida"
  },
  {
    "codigoTse": "36919",
    "ibgeCodigo": 2919504,
    "uf": "BA",
    "nome": "Livramento De Nossa Senhora"
  },
  {
    "codigoTse": "36935",
    "ibgeCodigo": 2919603,
    "uf": "BA",
    "nome": "Macajuba"
  },
  {
    "codigoTse": "36951",
    "ibgeCodigo": 2919702,
    "uf": "BA",
    "nome": "Macarani"
  },
  {
    "codigoTse": "36978",
    "ibgeCodigo": 2919801,
    "uf": "BA",
    "nome": "Maca�bas"
  },
  {
    "codigoTse": "36994",
    "ibgeCodigo": 2919900,
    "uf": "BA",
    "nome": "Macurur�"
  },
  {
    "codigoTse": "37010",
    "ibgeCodigo": 2920007,
    "uf": "BA",
    "nome": "Maiquinique"
  },
  {
    "codigoTse": "37036",
    "ibgeCodigo": 2920106,
    "uf": "BA",
    "nome": "Mairi"
  },
  {
    "codigoTse": "37052",
    "ibgeCodigo": 2920205,
    "uf": "BA",
    "nome": "Malhada"
  },
  {
    "codigoTse": "37079",
    "ibgeCodigo": 2920304,
    "uf": "BA",
    "nome": "Malhada De Pedras"
  },
  {
    "codigoTse": "37095",
    "ibgeCodigo": 2920403,
    "uf": "BA",
    "nome": "Manoel Vitorino"
  },
  {
    "codigoTse": "37117",
    "ibgeCodigo": 2920502,
    "uf": "BA",
    "nome": "Marac�s"
  },
  {
    "codigoTse": "37133",
    "ibgeCodigo": 2920601,
    "uf": "BA",
    "nome": "Maragogipe"
  },
  {
    "codigoTse": "37150",
    "ibgeCodigo": 2920700,
    "uf": "BA",
    "nome": "Mara�"
  },
  {
    "codigoTse": "37176",
    "ibgeCodigo": 2920809,
    "uf": "BA",
    "nome": "Marcion�lio Souza"
  },
  {
    "codigoTse": "37192",
    "ibgeCodigo": 2920908,
    "uf": "BA",
    "nome": "Mascote"
  },
  {
    "codigoTse": "37214",
    "ibgeCodigo": 2921005,
    "uf": "BA",
    "nome": "Mata De S�o Jo�o"
  },
  {
    "codigoTse": "37222",
    "ibgeCodigo": 2921054,
    "uf": "BA",
    "nome": "Matina"
  },
  {
    "codigoTse": "37230",
    "ibgeCodigo": 2921104,
    "uf": "BA",
    "nome": "Medeiros Neto"
  },
  {
    "codigoTse": "37257",
    "ibgeCodigo": 2921203,
    "uf": "BA",
    "nome": "Miguel Calmon"
  },
  {
    "codigoTse": "37273",
    "ibgeCodigo": 2921302,
    "uf": "BA",
    "nome": "Milagres"
  },
  {
    "codigoTse": "37290",
    "ibgeCodigo": 2921401,
    "uf": "BA",
    "nome": "Mirangaba"
  },
  {
    "codigoTse": "37303",
    "ibgeCodigo": 2921450,
    "uf": "BA",
    "nome": "Mirante"
  },
  {
    "codigoTse": "37311",
    "ibgeCodigo": 2921500,
    "uf": "BA",
    "nome": "Monte Santo"
  },
  {
    "codigoTse": "37338",
    "ibgeCodigo": 2921609,
    "uf": "BA",
    "nome": "Morpar�"
  },
  {
    "codigoTse": "37354",
    "ibgeCodigo": 2921708,
    "uf": "BA",
    "nome": "Morro Do Chap�u"
  },
  {
    "codigoTse": "37370",
    "ibgeCodigo": 2921807,
    "uf": "BA",
    "nome": "Mortugaba"
  },
  {
    "codigoTse": "37397",
    "ibgeCodigo": 2921906,
    "uf": "BA",
    "nome": "Mucug�"
  },
  {
    "codigoTse": "37419",
    "ibgeCodigo": 2922003,
    "uf": "BA",
    "nome": "Mucuri"
  },
  {
    "codigoTse": "37427",
    "ibgeCodigo": 2922052,
    "uf": "BA",
    "nome": "Mulungu Do Morro"
  },
  {
    "codigoTse": "37435",
    "ibgeCodigo": 2922102,
    "uf": "BA",
    "nome": "Mundo Novo"
  },
  {
    "codigoTse": "37451",
    "ibgeCodigo": 2922201,
    "uf": "BA",
    "nome": "Muniz Ferreira"
  },
  {
    "codigoTse": "37460",
    "ibgeCodigo": 2922250,
    "uf": "BA",
    "nome": "Muqu�m De S�o Francisco"
  },
  {
    "codigoTse": "37478",
    "ibgeCodigo": 2922300,
    "uf": "BA",
    "nome": "Muritiba"
  },
  {
    "codigoTse": "37494",
    "ibgeCodigo": 2922409,
    "uf": "BA",
    "nome": "Mutu�pe"
  },
  {
    "codigoTse": "37516",
    "ibgeCodigo": 2922508,
    "uf": "BA",
    "nome": "Nazar�"
  },
  {
    "codigoTse": "37532",
    "ibgeCodigo": 2922607,
    "uf": "BA",
    "nome": "Nilo Pe�anha"
  },
  {
    "codigoTse": "37559",
    "ibgeCodigo": 2922706,
    "uf": "BA",
    "nome": "Nova Cana�"
  },
  {
    "codigoTse": "37567",
    "ibgeCodigo": 2922730,
    "uf": "BA",
    "nome": "Nova F�tima"
  },
  {
    "codigoTse": "37575",
    "ibgeCodigo": 2922805,
    "uf": "BA",
    "nome": "Nova Itarana"
  },
  {
    "codigoTse": "37583",
    "ibgeCodigo": 2922854,
    "uf": "BA",
    "nome": "Nova Reden��o"
  },
  {
    "codigoTse": "37591",
    "ibgeCodigo": 2922904,
    "uf": "BA",
    "nome": "Nova Soure"
  },
  {
    "codigoTse": "37613",
    "ibgeCodigo": 2923001,
    "uf": "BA",
    "nome": "Nova Vi�osa"
  },
  {
    "codigoTse": "37621",
    "ibgeCodigo": 2923050,
    "uf": "BA",
    "nome": "Novo Triunfo"
  },
  {
    "codigoTse": "37630",
    "ibgeCodigo": 2923100,
    "uf": "BA",
    "nome": "Olindina"
  },
  {
    "codigoTse": "37656",
    "ibgeCodigo": 2923209,
    "uf": "BA",
    "nome": "Oliveira Dos Brejinhos"
  },
  {
    "codigoTse": "37672",
    "ibgeCodigo": 2923308,
    "uf": "BA",
    "nome": "Ouri�angas"
  },
  {
    "codigoTse": "37680",
    "ibgeCodigo": 2923357,
    "uf": "BA",
    "nome": "Ourol�ndia"
  },
  {
    "codigoTse": "37699",
    "ibgeCodigo": 2923407,
    "uf": "BA",
    "nome": "Palmas De Monte Alto"
  },
  {
    "codigoTse": "37710",
    "ibgeCodigo": 2923506,
    "uf": "BA",
    "nome": "Palmeiras"
  },
  {
    "codigoTse": "37737",
    "ibgeCodigo": 2923605,
    "uf": "BA",
    "nome": "Paramirim"
  },
  {
    "codigoTse": "37753",
    "ibgeCodigo": 2923704,
    "uf": "BA",
    "nome": "Paratinga"
  },
  {
    "codigoTse": "37770",
    "ibgeCodigo": 2923803,
    "uf": "BA",
    "nome": "Paripiranga"
  },
  {
    "codigoTse": "37796",
    "ibgeCodigo": 2923902,
    "uf": "BA",
    "nome": "Pau Brasil"
  },
  {
    "codigoTse": "37818",
    "ibgeCodigo": 2924009,
    "uf": "BA",
    "nome": "Paulo Afonso"
  },
  {
    "codigoTse": "37834",
    "ibgeCodigo": 2924108,
    "uf": "BA",
    "nome": "Pedr�o"
  },
  {
    "codigoTse": "37850",
    "ibgeCodigo": 2924207,
    "uf": "BA",
    "nome": "Pedro Alexandre"
  },
  {
    "codigoTse": "37877",
    "ibgeCodigo": 2924306,
    "uf": "BA",
    "nome": "Piat�"
  },
  {
    "codigoTse": "37893",
    "ibgeCodigo": 2924405,
    "uf": "BA",
    "nome": "Pil�o Arcado"
  },
  {
    "codigoTse": "37915",
    "ibgeCodigo": 2924504,
    "uf": "BA",
    "nome": "Pinda�"
  },
  {
    "codigoTse": "37931",
    "ibgeCodigo": 2924603,
    "uf": "BA",
    "nome": "Pindoba�u"
  },
  {
    "codigoTse": "37940",
    "ibgeCodigo": 2924678,
    "uf": "BA",
    "nome": "Pira� Do Norte"
  },
  {
    "codigoTse": "37958",
    "ibgeCodigo": 2924702,
    "uf": "BA",
    "nome": "Pirip�"
  },
  {
    "codigoTse": "37974",
    "ibgeCodigo": 2924801,
    "uf": "BA",
    "nome": "Piritiba"
  },
  {
    "codigoTse": "37990",
    "ibgeCodigo": 2924900,
    "uf": "BA",
    "nome": "Planaltino"
  },
  {
    "codigoTse": "38016",
    "ibgeCodigo": 2925006,
    "uf": "BA",
    "nome": "Planalto"
  },
  {
    "codigoTse": "38032",
    "ibgeCodigo": 2925105,
    "uf": "BA",
    "nome": "Po��es"
  },
  {
    "codigoTse": "38059",
    "ibgeCodigo": 2925204,
    "uf": "BA",
    "nome": "Pojuca"
  },
  {
    "codigoTse": "38067",
    "ibgeCodigo": 2925253,
    "uf": "BA",
    "nome": "Ponto Novo"
  },
  {
    "codigoTse": "38075",
    "ibgeCodigo": 2925303,
    "uf": "BA",
    "nome": "Porto Seguro"
  },
  {
    "codigoTse": "38091",
    "ibgeCodigo": 2925402,
    "uf": "BA",
    "nome": "Potiragu�"
  },
  {
    "codigoTse": "38113",
    "ibgeCodigo": 2925501,
    "uf": "BA",
    "nome": "Prado"
  },
  {
    "codigoTse": "38130",
    "ibgeCodigo": 2925600,
    "uf": "BA",
    "nome": "Presidente Dutra"
  },
  {
    "codigoTse": "38156",
    "ibgeCodigo": 2925709,
    "uf": "BA",
    "nome": "Presidente J�nio Quadros"
  },
  {
    "codigoTse": "38164",
    "ibgeCodigo": 2925758,
    "uf": "BA",
    "nome": "Presidente Tancredo Neves"
  },
  {
    "codigoTse": "38172",
    "ibgeCodigo": 2925808,
    "uf": "BA",
    "nome": "Queimadas"
  },
  {
    "codigoTse": "38199",
    "ibgeCodigo": 2925907,
    "uf": "BA",
    "nome": "Quijingue"
  },
  {
    "codigoTse": "38210",
    "ibgeCodigo": 2926004,
    "uf": "BA",
    "nome": "Remanso"
  },
  {
    "codigoTse": "38237",
    "ibgeCodigo": 2926103,
    "uf": "BA",
    "nome": "Retirol�ndia"
  },
  {
    "codigoTse": "38253",
    "ibgeCodigo": 2926202,
    "uf": "BA",
    "nome": "Riach�o Das Neves"
  },
  {
    "codigoTse": "38270",
    "ibgeCodigo": 2926301,
    "uf": "BA",
    "nome": "Riach�o Do Jacu�pe"
  },
  {
    "codigoTse": "38296",
    "ibgeCodigo": 2926400,
    "uf": "BA",
    "nome": "Riacho De Santana"
  },
  {
    "codigoTse": "38318",
    "ibgeCodigo": 2926509,
    "uf": "BA",
    "nome": "Ribeira Do Amparo"
  },
  {
    "codigoTse": "38334",
    "ibgeCodigo": 2926608,
    "uf": "BA",
    "nome": "Ribeira Do Pombal"
  },
  {
    "codigoTse": "38342",
    "ibgeCodigo": 2926657,
    "uf": "BA",
    "nome": "Ribeir�o Do Largo"
  },
  {
    "codigoTse": "38350",
    "ibgeCodigo": 2926707,
    "uf": "BA",
    "nome": "Rio De Contas"
  },
  {
    "codigoTse": "38377",
    "ibgeCodigo": 2926806,
    "uf": "BA",
    "nome": "Rio Do Ant�nio"
  },
  {
    "codigoTse": "38393",
    "ibgeCodigo": 2926905,
    "uf": "BA",
    "nome": "Rio Do Pires"
  },
  {
    "codigoTse": "38415",
    "ibgeCodigo": 2927002,
    "uf": "BA",
    "nome": "Rio Real"
  },
  {
    "codigoTse": "38431",
    "ibgeCodigo": 2927101,
    "uf": "BA",
    "nome": "Rodelas"
  },
  {
    "codigoTse": "38458",
    "ibgeCodigo": 2927200,
    "uf": "BA",
    "nome": "Ruy Barbosa"
  },
  {
    "codigoTse": "38474",
    "ibgeCodigo": 2927309,
    "uf": "BA",
    "nome": "Salinas Da Margarida"
  },
  {
    "codigoTse": "38490",
    "ibgeCodigo": 2927408,
    "uf": "BA",
    "nome": "Salvador"
  },
  {
    "codigoTse": "38512",
    "ibgeCodigo": 2927507,
    "uf": "BA",
    "nome": "Santa B�rbara"
  },
  {
    "codigoTse": "38539",
    "ibgeCodigo": 2927606,
    "uf": "BA",
    "nome": "Santa Br�gida"
  },
  {
    "codigoTse": "38555",
    "ibgeCodigo": 2927705,
    "uf": "BA",
    "nome": "Santa Cruz Cabr�lia"
  },
  {
    "codigoTse": "38571",
    "ibgeCodigo": 2927804,
    "uf": "BA",
    "nome": "Santa Cruz Da Vit�ria"
  },
  {
    "codigoTse": "38598",
    "ibgeCodigo": 2927903,
    "uf": "BA",
    "nome": "Santa In�s"
  },
  {
    "codigoTse": "38610",
    "ibgeCodigo": 2928000,
    "uf": "BA",
    "nome": "Santaluz"
  },
  {
    "codigoTse": "38636",
    "ibgeCodigo": 2928109,
    "uf": "BA",
    "nome": "Santa Maria Da Vit�ria"
  },
  {
    "codigoTse": "38652",
    "ibgeCodigo": 2928208,
    "uf": "BA",
    "nome": "Santana"
  },
  {
    "codigoTse": "38679",
    "ibgeCodigo": 2928307,
    "uf": "BA",
    "nome": "Santan�polis"
  },
  {
    "codigoTse": "38695",
    "ibgeCodigo": 2928505,
    "uf": "BA",
    "nome": "Santa Teresinha"
  },
  {
    "codigoTse": "38717",
    "ibgeCodigo": 2928604,
    "uf": "BA",
    "nome": "Santo Amaro"
  },
  {
    "codigoTse": "38733",
    "ibgeCodigo": 2928703,
    "uf": "BA",
    "nome": "Santo Ant�nio De Jesus"
  },
  {
    "codigoTse": "38750",
    "ibgeCodigo": 2928802,
    "uf": "BA",
    "nome": "Santo Est�v�o"
  },
  {
    "codigoTse": "38776",
    "ibgeCodigo": 2928901,
    "uf": "BA",
    "nome": "S�o Desid�rio"
  },
  {
    "codigoTse": "38792",
    "ibgeCodigo": 2929008,
    "uf": "BA",
    "nome": "S�o F�lix"
  },
  {
    "codigoTse": "38806",
    "ibgeCodigo": 2928950,
    "uf": "BA",
    "nome": "S�o Domingos"
  },
  {
    "codigoTse": "38814",
    "ibgeCodigo": 2929107,
    "uf": "BA",
    "nome": "S�o Felipe"
  },
  {
    "codigoTse": "38822",
    "ibgeCodigo": 2929057,
    "uf": "BA",
    "nome": "S�o F�lix Do Coribe"
  },
  {
    "codigoTse": "38830",
    "ibgeCodigo": 2929206,
    "uf": "BA",
    "nome": "S�o Francisco Do Conde"
  },
  {
    "codigoTse": "38857",
    "ibgeCodigo": 2929305,
    "uf": "BA",
    "nome": "S�o Gon�alo Dos Campos"
  },
  {
    "codigoTse": "38865",
    "ibgeCodigo": 2929370,
    "uf": "BA",
    "nome": "S�o Jos� Do Jacu�pe"
  },
  {
    "codigoTse": "38873",
    "ibgeCodigo": 2929404,
    "uf": "BA",
    "nome": "S�o Miguel Das Matas"
  },
  {
    "codigoTse": "38890",
    "ibgeCodigo": 2929503,
    "uf": "BA",
    "nome": "S�o Sebasti�o Do Pass�"
  },
  {
    "codigoTse": "38911",
    "ibgeCodigo": 2929602,
    "uf": "BA",
    "nome": "Sapea�u"
  },
  {
    "codigoTse": "38938",
    "ibgeCodigo": 2929701,
    "uf": "BA",
    "nome": "S�tiro Dias"
  },
  {
    "codigoTse": "38946",
    "ibgeCodigo": 2929750,
    "uf": "BA",
    "nome": "Saubara"
  },
  {
    "codigoTse": "38954",
    "ibgeCodigo": 2929800,
    "uf": "BA",
    "nome": "Sa�de"
  },
  {
    "codigoTse": "38970",
    "ibgeCodigo": 2929909,
    "uf": "BA",
    "nome": "Seabra"
  },
  {
    "codigoTse": "38997",
    "ibgeCodigo": 2930006,
    "uf": "BA",
    "nome": "Sebasti�o Laranjeiras"
  },
  {
    "codigoTse": "39012",
    "ibgeCodigo": 2930105,
    "uf": "BA",
    "nome": "Senhor Do Bonfim"
  },
  {
    "codigoTse": "39039",
    "ibgeCodigo": 2930204,
    "uf": "BA",
    "nome": "Sento S�"
  },
  {
    "codigoTse": "39047",
    "ibgeCodigo": 2930154,
    "uf": "BA",
    "nome": "Serra Do Ramalho"
  },
  {
    "codigoTse": "39055",
    "ibgeCodigo": 2930303,
    "uf": "BA",
    "nome": "Serra Dourada"
  },
  {
    "codigoTse": "39071",
    "ibgeCodigo": 2930402,
    "uf": "BA",
    "nome": "Serra Preta"
  },
  {
    "codigoTse": "39098",
    "ibgeCodigo": 2930501,
    "uf": "BA",
    "nome": "Serrinha"
  },
  {
    "codigoTse": "39110",
    "ibgeCodigo": 2930600,
    "uf": "BA",
    "nome": "Serrol�ndia"
  },
  {
    "codigoTse": "39136",
    "ibgeCodigo": 2930709,
    "uf": "BA",
    "nome": "Sim�es Filho"
  },
  {
    "codigoTse": "39144",
    "ibgeCodigo": 2930758,
    "uf": "BA",
    "nome": "S�tio Do Mato"
  },
  {
    "codigoTse": "39152",
    "ibgeCodigo": 2930808,
    "uf": "BA",
    "nome": "Souto Soares"
  },
  {
    "codigoTse": "39179",
    "ibgeCodigo": 2930907,
    "uf": "BA",
    "nome": "Tabocas Do Brejo Velho"
  },
  {
    "codigoTse": "39195",
    "ibgeCodigo": 2931004,
    "uf": "BA",
    "nome": "Tanha�u"
  },
  {
    "codigoTse": "39217",
    "ibgeCodigo": 2931103,
    "uf": "BA",
    "nome": "Tanquinho"
  },
  {
    "codigoTse": "39233",
    "ibgeCodigo": 2931202,
    "uf": "BA",
    "nome": "Tapero�"
  },
  {
    "codigoTse": "39250",
    "ibgeCodigo": 2931301,
    "uf": "BA",
    "nome": "Tapiramut�"
  },
  {
    "codigoTse": "39276",
    "ibgeCodigo": 2931400,
    "uf": "BA",
    "nome": "Teodoro Sampaio"
  },
  {
    "codigoTse": "39292",
    "ibgeCodigo": 2931509,
    "uf": "BA",
    "nome": "Teofil�ndia"
  },
  {
    "codigoTse": "39314",
    "ibgeCodigo": 2931608,
    "uf": "BA",
    "nome": "Teol�ndia"
  },
  {
    "codigoTse": "39330",
    "ibgeCodigo": 2931707,
    "uf": "BA",
    "nome": "Terra Nova"
  },
  {
    "codigoTse": "39357",
    "ibgeCodigo": 2931806,
    "uf": "BA",
    "nome": "Tremedal"
  },
  {
    "codigoTse": "39373",
    "ibgeCodigo": 2931905,
    "uf": "BA",
    "nome": "Tucano"
  },
  {
    "codigoTse": "39390",
    "ibgeCodigo": 2932002,
    "uf": "BA",
    "nome": "Uau�"
  },
  {
    "codigoTse": "39411",
    "ibgeCodigo": 2932101,
    "uf": "BA",
    "nome": "Uba�ra"
  },
  {
    "codigoTse": "39438",
    "ibgeCodigo": 2932200,
    "uf": "BA",
    "nome": "Ubaitaba"
  },
  {
    "codigoTse": "39454",
    "ibgeCodigo": 2932309,
    "uf": "BA",
    "nome": "Ubat�"
  },
  {
    "codigoTse": "39470",
    "ibgeCodigo": 2932408,
    "uf": "BA",
    "nome": "Uiba�"
  },
  {
    "codigoTse": "39489",
    "ibgeCodigo": 2932457,
    "uf": "BA",
    "nome": "Umburanas"
  },
  {
    "codigoTse": "39497",
    "ibgeCodigo": 2932507,
    "uf": "BA",
    "nome": "Una"
  },
  {
    "codigoTse": "39519",
    "ibgeCodigo": 2932606,
    "uf": "BA",
    "nome": "Urandi"
  },
  {
    "codigoTse": "39535",
    "ibgeCodigo": 2932705,
    "uf": "BA",
    "nome": "Uru�uca"
  },
  {
    "codigoTse": "39551",
    "ibgeCodigo": 2932804,
    "uf": "BA",
    "nome": "Utinga"
  },
  {
    "codigoTse": "39578",
    "ibgeCodigo": 2932903,
    "uf": "BA",
    "nome": "Valen�a"
  },
  {
    "codigoTse": "39594",
    "ibgeCodigo": 2933000,
    "uf": "BA",
    "nome": "Valente"
  },
  {
    "codigoTse": "39616",
    "ibgeCodigo": 2933109,
    "uf": "BA",
    "nome": "V�rzea Do Po�o"
  },
  {
    "codigoTse": "39624",
    "ibgeCodigo": 2933174,
    "uf": "BA",
    "nome": "Varzedo"
  },
  {
    "codigoTse": "39632",
    "ibgeCodigo": 2933208,
    "uf": "BA",
    "nome": "Vera Cruz"
  },
  {
    "codigoTse": "39640",
    "ibgeCodigo": 2933257,
    "uf": "BA",
    "nome": "Vereda"
  },
  {
    "codigoTse": "39659",
    "ibgeCodigo": 2933307,
    "uf": "BA",
    "nome": "Vit�ria Da Conquista"
  },
  {
    "codigoTse": "39675",
    "ibgeCodigo": 2933406,
    "uf": "BA",
    "nome": "Wagner"
  },
  {
    "codigoTse": "39691",
    "ibgeCodigo": 2933505,
    "uf": "BA",
    "nome": "Wenceslau Guimar�es"
  },
  {
    "codigoTse": "39713",
    "ibgeCodigo": 2933604,
    "uf": "BA",
    "nome": "Xique-Xique"
  },
  {
    "codigoTse": "39730",
    "ibgeCodigo": 2919157,
    "uf": "BA",
    "nome": "Lap�o"
  },
  {
    "codigoTse": "39748",
    "ibgeCodigo": 2919926,
    "uf": "BA",
    "nome": "Madre De Deus"
  },
  {
    "codigoTse": "39756",
    "ibgeCodigo": 2919959,
    "uf": "BA",
    "nome": "Maetinga"
  },
  {
    "codigoTse": "39772",
    "ibgeCodigo": 2920452,
    "uf": "BA",
    "nome": "Mansid�o"
  },
  {
    "codigoTse": "39799",
    "ibgeCodigo": 2922656,
    "uf": "BA",
    "nome": "Nordestina"
  },
  {
    "codigoTse": "39810",
    "ibgeCodigo": 2924058,
    "uf": "BA",
    "nome": "P� De Serra"
  },
  {
    "codigoTse": "39837",
    "ibgeCodigo": 2924652,
    "uf": "BA",
    "nome": "Pintadas"
  },
  {
    "codigoTse": "39845",
    "ibgeCodigo": 2925931,
    "uf": "BA",
    "nome": "Quixabeira"
  },
  {
    "codigoTse": "39853",
    "ibgeCodigo": 2925956,
    "uf": "BA",
    "nome": "Rafael Jambeiro"
  },
  {
    "codigoTse": "39870",
    "ibgeCodigo": 2928059,
    "uf": "BA",
    "nome": "Santa Luzia"
  },
  {
    "codigoTse": "39896",
    "ibgeCodigo": 2929255,
    "uf": "BA",
    "nome": "S�o Gabriel"
  },
  {
    "codigoTse": "39900",
    "ibgeCodigo": 2930766,
    "uf": "BA",
    "nome": "S�tio Do Quinto"
  },
  {
    "codigoTse": "39918",
    "ibgeCodigo": 2931053,
    "uf": "BA",
    "nome": "Tanque Novo"
  },
  {
    "codigoTse": "39926",
    "ibgeCodigo": 2929354,
    "uf": "BA",
    "nome": "S�o Jos� Da Vit�ria"
  },
  {
    "codigoTse": "39934",
    "ibgeCodigo": 2931350,
    "uf": "BA",
    "nome": "Teixeira De Freitas"
  },
  {
    "codigoTse": "39942",
    "ibgeCodigo": 2923035,
    "uf": "BA",
    "nome": "Novo Horizonte"
  },
  {
    "codigoTse": "39950",
    "ibgeCodigo": 2933158,
    "uf": "BA",
    "nome": "V�rzea Nova"
  },
  {
    "codigoTse": "39969",
    "ibgeCodigo": 2922755,
    "uf": "BA",
    "nome": "Nova Ibi�"
  },
  {
    "codigoTse": "39977",
    "ibgeCodigo": 2933059,
    "uf": "BA",
    "nome": "V�rzea Da Ro�a"
  },
  {
    "codigoTse": "39985",
    "ibgeCodigo": 2930774,
    "uf": "BA",
    "nome": "Sobradinho"
  },
  {
    "codigoTse": "39993",
    "ibgeCodigo": 2933455,
    "uf": "BA",
    "nome": "Wanderley"
  },
  {
    "codigoTse": "40002",
    "ibgeCodigo": 3101631,
    "uf": "MG",
    "nome": "Alfredo Vasconcelos"
  },
  {
    "codigoTse": "40010",
    "ibgeCodigo": 3100104,
    "uf": "MG",
    "nome": "Abadia Dos Dourados"
  },
  {
    "codigoTse": "40029",
    "ibgeCodigo": 3103751,
    "uf": "MG",
    "nome": "Arapor�"
  },
  {
    "codigoTse": "40037",
    "ibgeCodigo": 3100203,
    "uf": "MG",
    "nome": "Abaet�"
  },
  {
    "codigoTse": "40045",
    "ibgeCodigo": 3108552,
    "uf": "MG",
    "nome": "Brasil�ndia De Minas"
  },
  {
    "codigoTse": "40053",
    "ibgeCodigo": 3100302,
    "uf": "MG",
    "nome": "Abre Campo"
  },
  {
    "codigoTse": "40061",
    "ibgeCodigo": 3112653,
    "uf": "MG",
    "nome": "Capit�o Andrade"
  },
  {
    "codigoTse": "40070",
    "ibgeCodigo": 3100401,
    "uf": "MG",
    "nome": "Acaiaca"
  },
  {
    "codigoTse": "40088",
    "ibgeCodigo": 3114550,
    "uf": "MG",
    "nome": "Carneirinho"
  },
  {
    "codigoTse": "40096",
    "ibgeCodigo": 3100500,
    "uf": "MG",
    "nome": "A�ucena"
  },
  {
    "codigoTse": "40100",
    "ibgeCodigo": 3115458,
    "uf": "MG",
    "nome": "Catuji"
  },
  {
    "codigoTse": "40118",
    "ibgeCodigo": 3100609,
    "uf": "MG",
    "nome": "�gua Boa"
  },
  {
    "codigoTse": "40126",
    "ibgeCodigo": 3122355,
    "uf": "MG",
    "nome": "Divisa Alegre"
  },
  {
    "codigoTse": "40134",
    "ibgeCodigo": 3100708,
    "uf": "MG",
    "nome": "�gua Comprida"
  },
  {
    "codigoTse": "40142",
    "ibgeCodigo": 3122454,
    "uf": "MG",
    "nome": "Divis�polis"
  },
  {
    "codigoTse": "40150",
    "ibgeCodigo": 3100807,
    "uf": "MG",
    "nome": "Aguanil"
  },
  {
    "codigoTse": "40169",
    "ibgeCodigo": 3123528,
    "uf": "MG",
    "nome": "Durand�"
  },
  {
    "codigoTse": "40177",
    "ibgeCodigo": 3100906,
    "uf": "MG",
    "nome": "�guas Formosas"
  },
  {
    "codigoTse": "40185",
    "ibgeCodigo": 3123858,
    "uf": "MG",
    "nome": "Entre Folhas"
  },
  {
    "codigoTse": "40193",
    "ibgeCodigo": 3101003,
    "uf": "MG",
    "nome": "�guas Vermelhas"
  },
  {
    "codigoTse": "40207",
    "ibgeCodigo": 3125952,
    "uf": "MG",
    "nome": "Fervedouro"
  },
  {
    "codigoTse": "40215",
    "ibgeCodigo": 3101102,
    "uf": "MG",
    "nome": "Aimor�s"
  },
  {
    "codigoTse": "40223",
    "ibgeCodigo": 3126752,
    "uf": "MG",
    "nome": "Francisc�polis"
  },
  {
    "codigoTse": "40231",
    "ibgeCodigo": 3101201,
    "uf": "MG",
    "nome": "Aiuruoca"
  },
  {
    "codigoTse": "40240",
    "ibgeCodigo": 3130051,
    "uf": "MG",
    "nome": "Icara� De Minas"
  },
  {
    "codigoTse": "40258",
    "ibgeCodigo": 3101300,
    "uf": "MG",
    "nome": "Alagoa"
  },
  {
    "codigoTse": "40266",
    "ibgeCodigo": 3131158,
    "uf": "MG",
    "nome": "Ipaba"
  },
  {
    "codigoTse": "40274",
    "ibgeCodigo": 3101409,
    "uf": "MG",
    "nome": "Albertina"
  },
  {
    "codigoTse": "40282",
    "ibgeCodigo": 3135050,
    "uf": "MG",
    "nome": "Ja�ba"
  },
  {
    "codigoTse": "40290",
    "ibgeCodigo": 3101508,
    "uf": "MG",
    "nome": "Al�m Para�ba"
  },
  {
    "codigoTse": "40304",
    "ibgeCodigo": 3135076,
    "uf": "MG",
    "nome": "Jampruca"
  },
  {
    "codigoTse": "40312",
    "ibgeCodigo": 3101607,
    "uf": "MG",
    "nome": "Alfenas"
  },
  {
    "codigoTse": "40320",
    "ibgeCodigo": 3136652,
    "uf": "MG",
    "nome": "Juatuba"
  },
  {
    "codigoTse": "40339",
    "ibgeCodigo": 3101706,
    "uf": "MG",
    "nome": "Almenara"
  },
  {
    "codigoTse": "40347",
    "ibgeCodigo": 3137536,
    "uf": "MG",
    "nome": "Lagoa Grande"
  },
  {
    "codigoTse": "40355",
    "ibgeCodigo": 3101805,
    "uf": "MG",
    "nome": "Alpercata"
  },
  {
    "codigoTse": "40363",
    "ibgeCodigo": 3138625,
    "uf": "MG",
    "nome": "Limeira Do Oeste"
  },
  {
    "codigoTse": "40371",
    "ibgeCodigo": 3101904,
    "uf": "MG",
    "nome": "Alpin�polis"
  },
  {
    "codigoTse": "40380",
    "ibgeCodigo": 3138658,
    "uf": "MG",
    "nome": "Lontra"
  },
  {
    "codigoTse": "40398",
    "ibgeCodigo": 3102001,
    "uf": "MG",
    "nome": "Alterosa"
  },
  {
    "codigoTse": "40401",
    "ibgeCodigo": 3139250,
    "uf": "MG",
    "nome": "Mamonas"
  },
  {
    "codigoTse": "40410",
    "ibgeCodigo": 3102100,
    "uf": "MG",
    "nome": "Alto Rio Doce"
  },
  {
    "codigoTse": "40428",
    "ibgeCodigo": 3140555,
    "uf": "MG",
    "nome": "Mata Verde"
  },
  {
    "codigoTse": "40436",
    "ibgeCodigo": 3102209,
    "uf": "MG",
    "nome": "Alvarenga"
  },
  {
    "codigoTse": "40444",
    "ibgeCodigo": 3140852,
    "uf": "MG",
    "nome": "Matias Cardoso"
  },
  {
    "codigoTse": "40452",
    "ibgeCodigo": 3102308,
    "uf": "MG",
    "nome": "Alvin�polis"
  },
  {
    "codigoTse": "40460",
    "ibgeCodigo": 3143450,
    "uf": "MG",
    "nome": "Montezuma"
  },
  {
    "codigoTse": "40479",
    "ibgeCodigo": 3102407,
    "uf": "MG",
    "nome": "Alvorada De Minas"
  },
  {
    "codigoTse": "40487",
    "ibgeCodigo": 3144359,
    "uf": "MG",
    "nome": "Naque"
  },
  {
    "codigoTse": "40495",
    "ibgeCodigo": 3102506,
    "uf": "MG",
    "nome": "Amparo Do Serra"
  },
  {
    "codigoTse": "40509",
    "ibgeCodigo": 3145356,
    "uf": "MG",
    "nome": "Novo Oriente De Minas"
  },
  {
    "codigoTse": "40517",
    "ibgeCodigo": 3102605,
    "uf": "MG",
    "nome": "Andradas"
  },
  {
    "codigoTse": "40525",
    "ibgeCodigo": 3146750,
    "uf": "MG",
    "nome": "Palm�polis"
  },
  {
    "codigoTse": "40533",
    "ibgeCodigo": 3102704,
    "uf": "MG",
    "nome": "Cachoeira De Paje�"
  },
  {
    "codigoTse": "40541",
    "ibgeCodigo": 3149150,
    "uf": "MG",
    "nome": "Pedras De Maria Da Cruz"
  },
  {
    "codigoTse": "40550",
    "ibgeCodigo": 3102803,
    "uf": "MG",
    "nome": "Andrel�ndia"
  },
  {
    "codigoTse": "40568",
    "ibgeCodigo": 3149952,
    "uf": "MG",
    "nome": "Periquito"
  },
  {
    "codigoTse": "40576",
    "ibgeCodigo": 3102902,
    "uf": "MG",
    "nome": "Ant�nio Carlos"
  },
  {
    "codigoTse": "40584",
    "ibgeCodigo": 3152170,
    "uf": "MG",
    "nome": "Ponto Dos Volantes"
  },
  {
    "codigoTse": "40592",
    "ibgeCodigo": 3103009,
    "uf": "MG",
    "nome": "Ant�nio Dias"
  },
  {
    "codigoTse": "40606",
    "ibgeCodigo": 3154457,
    "uf": "MG",
    "nome": "Riachinho"
  },
  {
    "codigoTse": "40614",
    "ibgeCodigo": 3103108,
    "uf": "MG",
    "nome": "Ant�nio Prado De Minas"
  },
  {
    "codigoTse": "40622",
    "ibgeCodigo": 3156452,
    "uf": "MG",
    "nome": "Ros�rio Da Limeira"
  },
  {
    "codigoTse": "40630",
    "ibgeCodigo": 3103207,
    "uf": "MG",
    "nome": "Ara�a�"
  },
  {
    "codigoTse": "40649",
    "ibgeCodigo": 3157252,
    "uf": "MG",
    "nome": "Santa B�rbara Do Leste"
  },
  {
    "codigoTse": "40657",
    "ibgeCodigo": 3103306,
    "uf": "MG",
    "nome": "Aracitaba"
  },
  {
    "codigoTse": "40665",
    "ibgeCodigo": 3159357,
    "uf": "MG",
    "nome": "Santa Rita De Minas"
  },
  {
    "codigoTse": "40673",
    "ibgeCodigo": 3103405,
    "uf": "MG",
    "nome": "Ara�ua�"
  },
  {
    "codigoTse": "40681",
    "ibgeCodigo": 3158953,
    "uf": "MG",
    "nome": "Santana Do Para�so"
  },
  {
    "codigoTse": "40690",
    "ibgeCodigo": 3103504,
    "uf": "MG",
    "nome": "Araguari"
  },
  {
    "codigoTse": "40703",
    "ibgeCodigo": 3162252,
    "uf": "MG",
    "nome": "S�o Jo�o Da Lagoa"
  },
  {
    "codigoTse": "40711",
    "ibgeCodigo": 3103603,
    "uf": "MG",
    "nome": "Arantina"
  },
  {
    "codigoTse": "40720",
    "ibgeCodigo": 3162559,
    "uf": "MG",
    "nome": "S�o Jo�o Do Manhua�u"
  },
  {
    "codigoTse": "40738",
    "ibgeCodigo": 3103702,
    "uf": "MG",
    "nome": "Araponga"
  },
  {
    "codigoTse": "40746",
    "ibgeCodigo": 3162575,
    "uf": "MG",
    "nome": "S�o Jo�o Do Manteninha"
  },
  {
    "codigoTse": "40754",
    "ibgeCodigo": 3103801,
    "uf": "MG",
    "nome": "Arapu�"
  },
  {
    "codigoTse": "40762",
    "ibgeCodigo": 3162658,
    "uf": "MG",
    "nome": "S�o Jo�o Do Pacu�"
  },
  {
    "codigoTse": "40770",
    "ibgeCodigo": 3103900,
    "uf": "MG",
    "nome": "Ara�jos"
  },
  {
    "codigoTse": "40789",
    "ibgeCodigo": 3162955,
    "uf": "MG",
    "nome": "S�o Jos� Da Lapa"
  },
  {
    "codigoTse": "40797",
    "ibgeCodigo": 3104007,
    "uf": "MG",
    "nome": "Arax�"
  },
  {
    "codigoTse": "40800",
    "ibgeCodigo": 3165537,
    "uf": "MG",
    "nome": "Sarzedo"
  },
  {
    "codigoTse": "40819",
    "ibgeCodigo": 3104106,
    "uf": "MG",
    "nome": "Arceburgo"
  },
  {
    "codigoTse": "40827",
    "ibgeCodigo": 3165560,
    "uf": "MG",
    "nome": "Sem-Peixe"
  },
  {
    "codigoTse": "40835",
    "ibgeCodigo": 3104205,
    "uf": "MG",
    "nome": "Arcos"
  },
  {
    "codigoTse": "40843",
    "ibgeCodigo": 3165578,
    "uf": "MG",
    "nome": "Senador Amaral"
  },
  {
    "codigoTse": "40851",
    "ibgeCodigo": 3104304,
    "uf": "MG",
    "nome": "Areado"
  },
  {
    "codigoTse": "40860",
    "ibgeCodigo": 3170057,
    "uf": "MG",
    "nome": "Ubaporanga"
  },
  {
    "codigoTse": "40878",
    "ibgeCodigo": 3104403,
    "uf": "MG",
    "nome": "Argirita"
  },
  {
    "codigoTse": "40886",
    "ibgeCodigo": 3170529,
    "uf": "MG",
    "nome": "Urucuia"
  },
  {
    "codigoTse": "40894",
    "ibgeCodigo": 3104502,
    "uf": "MG",
    "nome": "Arinos"
  },
  {
    "codigoTse": "40908",
    "ibgeCodigo": 3170578,
    "uf": "MG",
    "nome": "Vargem Alegre"
  },
  {
    "codigoTse": "40916",
    "ibgeCodigo": 3104601,
    "uf": "MG",
    "nome": "Astolfo Dutra"
  },
  {
    "codigoTse": "40924",
    "ibgeCodigo": 3136579,
    "uf": "MG",
    "nome": "Josen�polis"
  },
  {
    "codigoTse": "40932",
    "ibgeCodigo": 3104700,
    "uf": "MG",
    "nome": "Atal�ia"
  },
  {
    "codigoTse": "40940",
    "ibgeCodigo": 3136959,
    "uf": "MG",
    "nome": "Juven�lia"
  },
  {
    "codigoTse": "40959",
    "ibgeCodigo": 3104809,
    "uf": "MG",
    "nome": "Augusto De Lima"
  },
  {
    "codigoTse": "40967",
    "ibgeCodigo": 3138351,
    "uf": "MG",
    "nome": "Leme Do Prado"
  },
  {
    "codigoTse": "40975",
    "ibgeCodigo": 3104908,
    "uf": "MG",
    "nome": "Baependi"
  },
  {
    "codigoTse": "40983",
    "ibgeCodigo": 3138674,
    "uf": "MG",
    "nome": "Luisburgo"
  },
  {
    "codigoTse": "40991",
    "ibgeCodigo": 3105004,
    "uf": "MG",
    "nome": "Baldim"
  },
  {
    "codigoTse": "41009",
    "ibgeCodigo": 3138682,
    "uf": "MG",
    "nome": "Luisl�ndia"
  },
  {
    "codigoTse": "41017",
    "ibgeCodigo": 3105103,
    "uf": "MG",
    "nome": "Bambu�"
  },
  {
    "codigoTse": "41025",
    "ibgeCodigo": 3140159,
    "uf": "MG",
    "nome": "M�rio Campos"
  },
  {
    "codigoTse": "41033",
    "ibgeCodigo": 3105202,
    "uf": "MG",
    "nome": "Bandeira"
  },
  {
    "codigoTse": "41041",
    "ibgeCodigo": 3140530,
    "uf": "MG",
    "nome": "Martins Soares"
  },
  {
    "codigoTse": "41050",
    "ibgeCodigo": 3105301,
    "uf": "MG",
    "nome": "Bandeira Do Sul"
  },
  {
    "codigoTse": "41068",
    "ibgeCodigo": 3142254,
    "uf": "MG",
    "nome": "Mirav�nia"
  },
  {
    "codigoTse": "41076",
    "ibgeCodigo": 3105400,
    "uf": "MG",
    "nome": "Bar�o De Cocais"
  },
  {
    "codigoTse": "41084",
    "ibgeCodigo": 3143153,
    "uf": "MG",
    "nome": "Monte Formoso"
  },
  {
    "codigoTse": "41092",
    "ibgeCodigo": 3105509,
    "uf": "MG",
    "nome": "Bar�o De Monte Alto"
  },
  {
    "codigoTse": "41106",
    "ibgeCodigo": 3144375,
    "uf": "MG",
    "nome": "Natal�ndia"
  },
  {
    "codigoTse": "41114",
    "ibgeCodigo": 3105608,
    "uf": "MG",
    "nome": "Barbacena"
  },
  {
    "codigoTse": "41122",
    "ibgeCodigo": 3144656,
    "uf": "MG",
    "nome": "Ninheira"
  },
  {
    "codigoTse": "41130",
    "ibgeCodigo": 3105707,
    "uf": "MG",
    "nome": "Barra Longa"
  },
  {
    "codigoTse": "41149",
    "ibgeCodigo": 3144672,
    "uf": "MG",
    "nome": "Nova Bel�m"
  },
  {
    "codigoTse": "41157",
    "ibgeCodigo": 3169356,
    "uf": "MG",
    "nome": "Tr�s Marias"
  },
  {
    "codigoTse": "41165",
    "ibgeCodigo": 3145059,
    "uf": "MG",
    "nome": "Nova Porteirinha"
  },
  {
    "codigoTse": "41173",
    "ibgeCodigo": 3105905,
    "uf": "MG",
    "nome": "Barroso"
  },
  {
    "codigoTse": "41181",
    "ibgeCodigo": 3145372,
    "uf": "MG",
    "nome": "Novorizonte"
  },
  {
    "codigoTse": "41190",
    "ibgeCodigo": 3106002,
    "uf": "MG",
    "nome": "Bela Vista De Minas"
  },
  {
    "codigoTse": "41203",
    "ibgeCodigo": 3145455,
    "uf": "MG",
    "nome": "Olhos-D'�gua"
  },
  {
    "codigoTse": "41211",
    "ibgeCodigo": 3106101,
    "uf": "MG",
    "nome": "Belmiro Braga"
  },
  {
    "codigoTse": "41220",
    "ibgeCodigo": 3145851,
    "uf": "MG",
    "nome": "Orat�rios"
  },
  {
    "codigoTse": "41238",
    "ibgeCodigo": 3106200,
    "uf": "MG",
    "nome": "Belo Horizonte"
  },
  {
    "codigoTse": "41246",
    "ibgeCodigo": 3145877,
    "uf": "MG",
    "nome": "Oriz�nia"
  },
  {
    "codigoTse": "41254",
    "ibgeCodigo": 3106309,
    "uf": "MG",
    "nome": "Belo Oriente"
  },
  {
    "codigoTse": "41262",
    "ibgeCodigo": 3146255,
    "uf": "MG",
    "nome": "Padre Carvalho"
  },
  {
    "codigoTse": "41270",
    "ibgeCodigo": 3106408,
    "uf": "MG",
    "nome": "Belo Vale"
  },
  {
    "codigoTse": "41289",
    "ibgeCodigo": 3146552,
    "uf": "MG",
    "nome": "Pai Pedro"
  },
  {
    "codigoTse": "41297",
    "ibgeCodigo": 3106507,
    "uf": "MG",
    "nome": "Berilo"
  },
  {
    "codigoTse": "41300",
    "ibgeCodigo": 3147956,
    "uf": "MG",
    "nome": "Patis"
  },
  {
    "codigoTse": "41319",
    "ibgeCodigo": 3106606,
    "uf": "MG",
    "nome": "Bert�polis"
  },
  {
    "codigoTse": "41327",
    "ibgeCodigo": 3148756,
    "uf": "MG",
    "nome": "Pedra Bonita"
  },
  {
    "codigoTse": "41335",
    "ibgeCodigo": 3106705,
    "uf": "MG",
    "nome": "Betim"
  },
  {
    "codigoTse": "41343",
    "ibgeCodigo": 3150158,
    "uf": "MG",
    "nome": "Piedade De Caratinga"
  },
  {
    "codigoTse": "41351",
    "ibgeCodigo": 3106804,
    "uf": "MG",
    "nome": "Bias Fortes"
  },
  {
    "codigoTse": "41360",
    "ibgeCodigo": 3150539,
    "uf": "MG",
    "nome": "Pingo-D'�gua"
  },
  {
    "codigoTse": "41378",
    "ibgeCodigo": 3106903,
    "uf": "MG",
    "nome": "Bicas"
  },
  {
    "codigoTse": "41386",
    "ibgeCodigo": 3150570,
    "uf": "MG",
    "nome": "Pint�polis"
  },
  {
    "codigoTse": "41394",
    "ibgeCodigo": 3107000,
    "uf": "MG",
    "nome": "Biquinhas"
  },
  {
    "codigoTse": "41408",
    "ibgeCodigo": 3152131,
    "uf": "MG",
    "nome": "Ponto Chique"
  },
  {
    "codigoTse": "41416",
    "ibgeCodigo": 3107109,
    "uf": "MG",
    "nome": "Boa Esperan�a"
  },
  {
    "codigoTse": "41424",
    "ibgeCodigo": 3154150,
    "uf": "MG",
    "nome": "Reduto"
  },
  {
    "codigoTse": "41432",
    "ibgeCodigo": 3107208,
    "uf": "MG",
    "nome": "Bocaina De Minas"
  },
  {
    "codigoTse": "41440",
    "ibgeCodigo": 3157278,
    "uf": "MG",
    "nome": "Santa B�rbara Do Monte Verde"
  },
  {
    "codigoTse": "41459",
    "ibgeCodigo": 3107307,
    "uf": "MG",
    "nome": "Bocai�va"
  },
  {
    "codigoTse": "41467",
    "ibgeCodigo": 3157336,
    "uf": "MG",
    "nome": "Santa Cruz De Minas"
  },
  {
    "codigoTse": "41475",
    "ibgeCodigo": 3107406,
    "uf": "MG",
    "nome": "Bom Despacho"
  },
  {
    "codigoTse": "41483",
    "ibgeCodigo": 3157377,
    "uf": "MG",
    "nome": "Santa Cruz De Salinas"
  },
  {
    "codigoTse": "41491",
    "ibgeCodigo": 3107505,
    "uf": "MG",
    "nome": "Bom Jardim De Minas"
  },
  {
    "codigoTse": "41505",
    "ibgeCodigo": 3157658,
    "uf": "MG",
    "nome": "Santa Helena De Minas"
  },
  {
    "codigoTse": "41513",
    "ibgeCodigo": 3107604,
    "uf": "MG",
    "nome": "Bom Jesus Da Penha"
  },
  {
    "codigoTse": "41521",
    "ibgeCodigo": 3160454,
    "uf": "MG",
    "nome": "Santo Ant�nio Do Retiro"
  },
  {
    "codigoTse": "41530",
    "ibgeCodigo": 3107703,
    "uf": "MG",
    "nome": "Bom Jesus Do Amparo"
  },
  {
    "codigoTse": "41548",
    "ibgeCodigo": 3160959,
    "uf": "MG",
    "nome": "S�o Domingos Das Dores"
  },
  {
    "codigoTse": "41556",
    "ibgeCodigo": 3107802,
    "uf": "MG",
    "nome": "Bom Jesus Do Galho"
  },
  {
    "codigoTse": "41564",
    "ibgeCodigo": 3161056,
    "uf": "MG",
    "nome": "S�o F�lix De Minas"
  },
  {
    "codigoTse": "41572",
    "ibgeCodigo": 3107901,
    "uf": "MG",
    "nome": "Bom Repouso"
  },
  {
    "codigoTse": "41580",
    "ibgeCodigo": 3161650,
    "uf": "MG",
    "nome": "S�o Geraldo Do Baixio"
  },
  {
    "codigoTse": "41599",
    "ibgeCodigo": 3108008,
    "uf": "MG",
    "nome": "Bom Sucesso"
  },
  {
    "codigoTse": "41602",
    "ibgeCodigo": 3162450,
    "uf": "MG",
    "nome": "S�o Jo�o Das Miss�es"
  },
  {
    "codigoTse": "41610",
    "ibgeCodigo": 3108107,
    "uf": "MG",
    "nome": "Bonfim"
  },
  {
    "codigoTse": "41629",
    "ibgeCodigo": 3162922,
    "uf": "MG",
    "nome": "S�o Joaquim De Bicas"
  },
  {
    "codigoTse": "41637",
    "ibgeCodigo": 3108206,
    "uf": "MG",
    "nome": "Bonfin�polis De Minas"
  },
  {
    "codigoTse": "41645",
    "ibgeCodigo": 3162948,
    "uf": "MG",
    "nome": "S�o Jos� Da Barra"
  },
  {
    "codigoTse": "41653",
    "ibgeCodigo": 3108305,
    "uf": "MG",
    "nome": "Borda Da Mata"
  },
  {
    "codigoTse": "41661",
    "ibgeCodigo": 3102050,
    "uf": "MG",
    "nome": "Alto Capara�"
  },
  {
    "codigoTse": "41670",
    "ibgeCodigo": 3108404,
    "uf": "MG",
    "nome": "Botelhos"
  },
  {
    "codigoTse": "41688",
    "ibgeCodigo": 3102852,
    "uf": "MG",
    "nome": "Angel�ndia"
  },
  {
    "codigoTse": "41696",
    "ibgeCodigo": 3108503,
    "uf": "MG",
    "nome": "Botumirim"
  },
  {
    "codigoTse": "41700",
    "ibgeCodigo": 3104452,
    "uf": "MG",
    "nome": "Aricanduva"
  },
  {
    "codigoTse": "41718",
    "ibgeCodigo": 3108602,
    "uf": "MG",
    "nome": "Bras�lia De Minas"
  },
  {
    "codigoTse": "41726",
    "ibgeCodigo": 3106655,
    "uf": "MG",
    "nome": "Berizal"
  },
  {
    "codigoTse": "41734",
    "ibgeCodigo": 3108701,
    "uf": "MG",
    "nome": "Br�s Pires"
  },
  {
    "codigoTse": "41742",
    "ibgeCodigo": 3108255,
    "uf": "MG",
    "nome": "Bonito De Minas"
  },
  {
    "codigoTse": "41750",
    "ibgeCodigo": 3108800,
    "uf": "MG",
    "nome": "Bra�nas"
  },
  {
    "codigoTse": "41769",
    "ibgeCodigo": 3109253,
    "uf": "MG",
    "nome": "Bugre"
  },
  {
    "codigoTse": "41777",
    "ibgeCodigo": 3108909,
    "uf": "MG",
    "nome": "Bras�polis"
  },
  {
    "codigoTse": "41785",
    "ibgeCodigo": 3109451,
    "uf": "MG",
    "nome": "Cabeceira Grande"
  },
  {
    "codigoTse": "41793",
    "ibgeCodigo": 3109006,
    "uf": "MG",
    "nome": "Brumadinho"
  },
  {
    "codigoTse": "41807",
    "ibgeCodigo": 3111150,
    "uf": "MG",
    "nome": "Campo Azul"
  },
  {
    "codigoTse": "41815",
    "ibgeCodigo": 3109105,
    "uf": "MG",
    "nome": "Bueno Brand�o"
  },
  {
    "codigoTse": "41823",
    "ibgeCodigo": 3112059,
    "uf": "MG",
    "nome": "Cantagalo"
  },
  {
    "codigoTse": "41831",
    "ibgeCodigo": 3109204,
    "uf": "MG",
    "nome": "Buen�polis"
  },
  {
    "codigoTse": "41840",
    "ibgeCodigo": 3115359,
    "uf": "MG",
    "nome": "Catas Altas"
  },
  {
    "codigoTse": "41858",
    "ibgeCodigo": 3109303,
    "uf": "MG",
    "nome": "Buritis"
  },
  {
    "codigoTse": "41866",
    "ibgeCodigo": 3115474,
    "uf": "MG",
    "nome": "Catuti"
  },
  {
    "codigoTse": "41874",
    "ibgeCodigo": 3109402,
    "uf": "MG",
    "nome": "Buritizeiro"
  },
  {
    "codigoTse": "41882",
    "ibgeCodigo": 3116159,
    "uf": "MG",
    "nome": "Chapada Ga�cha"
  },
  {
    "codigoTse": "41890",
    "ibgeCodigo": 3109501,
    "uf": "MG",
    "nome": "Cabo Verde"
  },
  {
    "codigoTse": "41904",
    "ibgeCodigo": 3117836,
    "uf": "MG",
    "nome": "C�nego Marinho"
  },
  {
    "codigoTse": "41912",
    "ibgeCodigo": 3109600,
    "uf": "MG",
    "nome": "Cachoeira Da Prata"
  },
  {
    "codigoTse": "41920",
    "ibgeCodigo": 3117876,
    "uf": "MG",
    "nome": "Confins"
  },
  {
    "codigoTse": "41939",
    "ibgeCodigo": 3109709,
    "uf": "MG",
    "nome": "Cachoeira De Minas"
  },
  {
    "codigoTse": "41947",
    "ibgeCodigo": 3119955,
    "uf": "MG",
    "nome": "C�rrego Fundo"
  },
  {
    "codigoTse": "41955",
    "ibgeCodigo": 3109808,
    "uf": "MG",
    "nome": "Cachoeira Dourada"
  },
  {
    "codigoTse": "41963",
    "ibgeCodigo": 3120151,
    "uf": "MG",
    "nome": "Cris�lita"
  },
  {
    "codigoTse": "41971",
    "ibgeCodigo": 3109907,
    "uf": "MG",
    "nome": "Caetan�polis"
  },
  {
    "codigoTse": "41980",
    "ibgeCodigo": 3120839,
    "uf": "MG",
    "nome": "Cuparaque"
  },
  {
    "codigoTse": "41998",
    "ibgeCodigo": 3110004,
    "uf": "MG",
    "nome": "Caet�"
  },
  {
    "codigoTse": "42005",
    "ibgeCodigo": 3120870,
    "uf": "MG",
    "nome": "Curral De Dentro"
  },
  {
    "codigoTse": "42013",
    "ibgeCodigo": 3110103,
    "uf": "MG",
    "nome": "Caiana"
  },
  {
    "codigoTse": "42021",
    "ibgeCodigo": 3121258,
    "uf": "MG",
    "nome": "Delta"
  },
  {
    "codigoTse": "42030",
    "ibgeCodigo": 3110202,
    "uf": "MG",
    "nome": "Cajuri"
  },
  {
    "codigoTse": "42048",
    "ibgeCodigo": 3122470,
    "uf": "MG",
    "nome": "Dom Bosco"
  },
  {
    "codigoTse": "42056",
    "ibgeCodigo": 3110301,
    "uf": "MG",
    "nome": "Caldas"
  },
  {
    "codigoTse": "42064",
    "ibgeCodigo": 3126950,
    "uf": "MG",
    "nome": "Frei Lagonegro"
  },
  {
    "codigoTse": "42072",
    "ibgeCodigo": 3110400,
    "uf": "MG",
    "nome": "Camacho"
  },
  {
    "codigoTse": "42080",
    "ibgeCodigo": 3127073,
    "uf": "MG",
    "nome": "Fruta De Leite"
  },
  {
    "codigoTse": "42099",
    "ibgeCodigo": 3110509,
    "uf": "MG",
    "nome": "Camanducaia"
  },
  {
    "codigoTse": "42102",
    "ibgeCodigo": 3127339,
    "uf": "MG",
    "nome": "Gameleiras"
  },
  {
    "codigoTse": "42110",
    "ibgeCodigo": 3110608,
    "uf": "MG",
    "nome": "Cambu�"
  },
  {
    "codigoTse": "42129",
    "ibgeCodigo": 3127354,
    "uf": "MG",
    "nome": "Glaucil�ndia"
  },
  {
    "codigoTse": "42137",
    "ibgeCodigo": 3110707,
    "uf": "MG",
    "nome": "Cambuquira"
  },
  {
    "codigoTse": "42145",
    "ibgeCodigo": 3127370,
    "uf": "MG",
    "nome": "Goiabeira"
  },
  {
    "codigoTse": "42153",
    "ibgeCodigo": 3110806,
    "uf": "MG",
    "nome": "Campan�rio"
  },
  {
    "codigoTse": "42161",
    "ibgeCodigo": 3127388,
    "uf": "MG",
    "nome": "Goian�"
  },
  {
    "codigoTse": "42170",
    "ibgeCodigo": 3110905,
    "uf": "MG",
    "nome": "Campanha"
  },
  {
    "codigoTse": "42188",
    "ibgeCodigo": 3128253,
    "uf": "MG",
    "nome": "Guaraciama"
  },
  {
    "codigoTse": "42196",
    "ibgeCodigo": 3111002,
    "uf": "MG",
    "nome": "Campestre"
  },
  {
    "codigoTse": "42200",
    "ibgeCodigo": 3129657,
    "uf": "MG",
    "nome": "Ibiracatu"
  },
  {
    "codigoTse": "42218",
    "ibgeCodigo": 3111101,
    "uf": "MG",
    "nome": "Campina Verde"
  },
  {
    "codigoTse": "42226",
    "ibgeCodigo": 3130556,
    "uf": "MG",
    "nome": "Imb� De Minas"
  },
  {
    "codigoTse": "42234",
    "ibgeCodigo": 3111200,
    "uf": "MG",
    "nome": "Campo Belo"
  },
  {
    "codigoTse": "42242",
    "ibgeCodigo": 3130655,
    "uf": "MG",
    "nome": "Indaiabira"
  },
  {
    "codigoTse": "42250",
    "ibgeCodigo": 3111309,
    "uf": "MG",
    "nome": "Campo Do Meio"
  },
  {
    "codigoTse": "42269",
    "ibgeCodigo": 3135357,
    "uf": "MG",
    "nome": "Japonvar"
  },
  {
    "codigoTse": "42277",
    "ibgeCodigo": 3111408,
    "uf": "MG",
    "nome": "Campo Florido"
  },
  {
    "codigoTse": "42285",
    "ibgeCodigo": 3135456,
    "uf": "MG",
    "nome": "Jenipapo De Minas"
  },
  {
    "codigoTse": "42293",
    "ibgeCodigo": 3111507,
    "uf": "MG",
    "nome": "Campos Altos"
  },
  {
    "codigoTse": "42307",
    "ibgeCodigo": 3136520,
    "uf": "MG",
    "nome": "Jos� Gon�alves De Minas"
  },
  {
    "codigoTse": "42315",
    "ibgeCodigo": 3111606,
    "uf": "MG",
    "nome": "Campos Gerais"
  },
  {
    "codigoTse": "42323",
    "ibgeCodigo": 3136553,
    "uf": "MG",
    "nome": "Jos� Raydan"
  },
  {
    "codigoTse": "42331",
    "ibgeCodigo": 3111705,
    "uf": "MG",
    "nome": "Cana�"
  },
  {
    "codigoTse": "42340",
    "ibgeCodigo": 3164431,
    "uf": "MG",
    "nome": "S�o Sebasti�o Da Vargem Alegre"
  },
  {
    "codigoTse": "42358",
    "ibgeCodigo": 3111804,
    "uf": "MG",
    "nome": "Can�polis"
  },
  {
    "codigoTse": "42366",
    "ibgeCodigo": 3164472,
    "uf": "MG",
    "nome": "S�o Sebasti�o Do Anta"
  },
  {
    "codigoTse": "42374",
    "ibgeCodigo": 3111903,
    "uf": "MG",
    "nome": "Cana Verde"
  },
  {
    "codigoTse": "42382",
    "ibgeCodigo": 3166956,
    "uf": "MG",
    "nome": "Serran�polis De Minas"
  },
  {
    "codigoTse": "42390",
    "ibgeCodigo": 3112000,
    "uf": "MG",
    "nome": "Candeias"
  },
  {
    "codigoTse": "42404",
    "ibgeCodigo": 3165552,
    "uf": "MG",
    "nome": "Setubinha"
  },
  {
    "codigoTse": "42412",
    "ibgeCodigo": 3112109,
    "uf": "MG",
    "nome": "Capara�"
  },
  {
    "codigoTse": "42420",
    "ibgeCodigo": 3168051,
    "uf": "MG",
    "nome": "Taparuba"
  },
  {
    "codigoTse": "42439",
    "ibgeCodigo": 3112208,
    "uf": "MG",
    "nome": "Capela Nova"
  },
  {
    "codigoTse": "42447",
    "ibgeCodigo": 3170438,
    "uf": "MG",
    "nome": "Uni�o De Minas"
  },
  {
    "codigoTse": "42455",
    "ibgeCodigo": 3112307,
    "uf": "MG",
    "nome": "Capelinha"
  },
  {
    "codigoTse": "42463",
    "ibgeCodigo": 3170479,
    "uf": "MG",
    "nome": "Uruana De Minas"
  },
  {
    "codigoTse": "42471",
    "ibgeCodigo": 3112406,
    "uf": "MG",
    "nome": "Capetinga"
  },
  {
    "codigoTse": "42480",
    "ibgeCodigo": 3170651,
    "uf": "MG",
    "nome": "Vargem Grande Do Rio Pardo"
  },
  {
    "codigoTse": "42498",
    "ibgeCodigo": 3112505,
    "uf": "MG",
    "nome": "Capim Branco"
  },
  {
    "codigoTse": "42501",
    "ibgeCodigo": 3170750,
    "uf": "MG",
    "nome": "Varj�o De Minas"
  },
  {
    "codigoTse": "42510",
    "ibgeCodigo": 3112604,
    "uf": "MG",
    "nome": "Capin�polis"
  },
  {
    "codigoTse": "42528",
    "ibgeCodigo": 3171030,
    "uf": "MG",
    "nome": "Verdel�ndia"
  },
  {
    "codigoTse": "42536",
    "ibgeCodigo": 3112703,
    "uf": "MG",
    "nome": "Capit�o En�as"
  },
  {
    "codigoTse": "42544",
    "ibgeCodigo": 3171071,
    "uf": "MG",
    "nome": "Veredinha"
  },
  {
    "codigoTse": "42552",
    "ibgeCodigo": 3112802,
    "uf": "MG",
    "nome": "Capit�lio"
  },
  {
    "codigoTse": "42560",
    "ibgeCodigo": 3171154,
    "uf": "MG",
    "nome": "Vermelho Novo"
  },
  {
    "codigoTse": "42579",
    "ibgeCodigo": 3112901,
    "uf": "MG",
    "nome": "Caputira"
  },
  {
    "codigoTse": "42587",
    "ibgeCodigo": 3169059,
    "uf": "MG",
    "nome": "Tocos Do Moji"
  },
  {
    "codigoTse": "42595",
    "ibgeCodigo": 3113008,
    "uf": "MG",
    "nome": "Cara�"
  },
  {
    "codigoTse": "42617",
    "ibgeCodigo": 3113107,
    "uf": "MG",
    "nome": "Carana�ba"
  },
  {
    "codigoTse": "42633",
    "ibgeCodigo": 3113206,
    "uf": "MG",
    "nome": "Caranda�"
  },
  {
    "codigoTse": "42650",
    "ibgeCodigo": 3113305,
    "uf": "MG",
    "nome": "Carangola"
  },
  {
    "codigoTse": "42676",
    "ibgeCodigo": 3113404,
    "uf": "MG",
    "nome": "Caratinga"
  },
  {
    "codigoTse": "42692",
    "ibgeCodigo": 3113503,
    "uf": "MG",
    "nome": "Carbonita"
  },
  {
    "codigoTse": "42714",
    "ibgeCodigo": 3113602,
    "uf": "MG",
    "nome": "Carea�u"
  },
  {
    "codigoTse": "42730",
    "ibgeCodigo": 3113701,
    "uf": "MG",
    "nome": "Carlos Chagas"
  },
  {
    "codigoTse": "42757",
    "ibgeCodigo": 3113800,
    "uf": "MG",
    "nome": "Carm�sia"
  },
  {
    "codigoTse": "42773",
    "ibgeCodigo": 3113909,
    "uf": "MG",
    "nome": "Carmo Da Cachoeira"
  },
  {
    "codigoTse": "42790",
    "ibgeCodigo": 3114006,
    "uf": "MG",
    "nome": "Carmo Da Mata"
  },
  {
    "codigoTse": "42811",
    "ibgeCodigo": 3114105,
    "uf": "MG",
    "nome": "Carmo De Minas"
  },
  {
    "codigoTse": "42838",
    "ibgeCodigo": 3114204,
    "uf": "MG",
    "nome": "Carmo Do Cajuru"
  },
  {
    "codigoTse": "42854",
    "ibgeCodigo": 3114303,
    "uf": "MG",
    "nome": "Carmo Do Parana�ba"
  },
  {
    "codigoTse": "42870",
    "ibgeCodigo": 3114402,
    "uf": "MG",
    "nome": "Carmo Do Rio Claro"
  },
  {
    "codigoTse": "42897",
    "ibgeCodigo": 3114501,
    "uf": "MG",
    "nome": "Carm�polis De Minas"
  },
  {
    "codigoTse": "42919",
    "ibgeCodigo": 3114600,
    "uf": "MG",
    "nome": "Carrancas"
  },
  {
    "codigoTse": "42935",
    "ibgeCodigo": 3114709,
    "uf": "MG",
    "nome": "Carvalh�polis"
  },
  {
    "codigoTse": "42951",
    "ibgeCodigo": 3114808,
    "uf": "MG",
    "nome": "Carvalhos"
  },
  {
    "codigoTse": "42978",
    "ibgeCodigo": 3114907,
    "uf": "MG",
    "nome": "Casa Grande"
  },
  {
    "codigoTse": "42994",
    "ibgeCodigo": 3115003,
    "uf": "MG",
    "nome": "Cascalho Rico"
  },
  {
    "codigoTse": "43010",
    "ibgeCodigo": 3115102,
    "uf": "MG",
    "nome": "C�ssia"
  },
  {
    "codigoTse": "43036",
    "ibgeCodigo": 3115201,
    "uf": "MG",
    "nome": "Concei��o Da Barra De Minas"
  },
  {
    "codigoTse": "43052",
    "ibgeCodigo": 3115300,
    "uf": "MG",
    "nome": "Cataguases"
  },
  {
    "codigoTse": "43079",
    "ibgeCodigo": 3115409,
    "uf": "MG",
    "nome": "Catas Altas Da Noruega"
  },
  {
    "codigoTse": "43095",
    "ibgeCodigo": 3115508,
    "uf": "MG",
    "nome": "Caxambu"
  },
  {
    "codigoTse": "43117",
    "ibgeCodigo": 3115607,
    "uf": "MG",
    "nome": "Cedro Do Abaet�"
  },
  {
    "codigoTse": "43133",
    "ibgeCodigo": 3115706,
    "uf": "MG",
    "nome": "Central De Minas"
  },
  {
    "codigoTse": "43150",
    "ibgeCodigo": 3115805,
    "uf": "MG",
    "nome": "Centralina"
  },
  {
    "codigoTse": "43176",
    "ibgeCodigo": 3115904,
    "uf": "MG",
    "nome": "Ch�cara"
  },
  {
    "codigoTse": "43192",
    "ibgeCodigo": 3116001,
    "uf": "MG",
    "nome": "Chal�"
  },
  {
    "codigoTse": "43214",
    "ibgeCodigo": 3116100,
    "uf": "MG",
    "nome": "Chapada Do Norte"
  },
  {
    "codigoTse": "43230",
    "ibgeCodigo": 3116209,
    "uf": "MG",
    "nome": "Chiador"
  },
  {
    "codigoTse": "43257",
    "ibgeCodigo": 3116308,
    "uf": "MG",
    "nome": "Cipot�nea"
  },
  {
    "codigoTse": "43273",
    "ibgeCodigo": 3116407,
    "uf": "MG",
    "nome": "Claraval"
  },
  {
    "codigoTse": "43290",
    "ibgeCodigo": 3116506,
    "uf": "MG",
    "nome": "Claro Dos Po��es"
  },
  {
    "codigoTse": "43311",
    "ibgeCodigo": 3116605,
    "uf": "MG",
    "nome": "Cl�udio"
  },
  {
    "codigoTse": "43338",
    "ibgeCodigo": 3116704,
    "uf": "MG",
    "nome": "Coimbra"
  },
  {
    "codigoTse": "43354",
    "ibgeCodigo": 3116803,
    "uf": "MG",
    "nome": "Coluna"
  },
  {
    "codigoTse": "43370",
    "ibgeCodigo": 3116902,
    "uf": "MG",
    "nome": "Comendador Gomes"
  },
  {
    "codigoTse": "43397",
    "ibgeCodigo": 3117009,
    "uf": "MG",
    "nome": "Comercinho"
  },
  {
    "codigoTse": "43419",
    "ibgeCodigo": 3117108,
    "uf": "MG",
    "nome": "Concei��o Da Aparecida"
  },
  {
    "codigoTse": "43435",
    "ibgeCodigo": 3117207,
    "uf": "MG",
    "nome": "Concei��o Das Pedras"
  },
  {
    "codigoTse": "43451",
    "ibgeCodigo": 3117306,
    "uf": "MG",
    "nome": "Concei��o Das Alagoas"
  },
  {
    "codigoTse": "43478",
    "ibgeCodigo": 3117405,
    "uf": "MG",
    "nome": "Concei��o De Ipanema"
  },
  {
    "codigoTse": "43494",
    "ibgeCodigo": 3117504,
    "uf": "MG",
    "nome": "Concei��o Do Mato Dentro"
  },
  {
    "codigoTse": "43516",
    "ibgeCodigo": 3117603,
    "uf": "MG",
    "nome": "Concei��o Do Par�"
  },
  {
    "codigoTse": "43532",
    "ibgeCodigo": 3117702,
    "uf": "MG",
    "nome": "Concei��o Do Rio Verde"
  },
  {
    "codigoTse": "43559",
    "ibgeCodigo": 3117801,
    "uf": "MG",
    "nome": "Concei��o Dos Ouros"
  },
  {
    "codigoTse": "43575",
    "ibgeCodigo": 3117900,
    "uf": "MG",
    "nome": "Congonhal"
  },
  {
    "codigoTse": "43591",
    "ibgeCodigo": 3118007,
    "uf": "MG",
    "nome": "Congonhas"
  },
  {
    "codigoTse": "43613",
    "ibgeCodigo": 3118106,
    "uf": "MG",
    "nome": "Congonhas Do Norte"
  },
  {
    "codigoTse": "43630",
    "ibgeCodigo": 3118205,
    "uf": "MG",
    "nome": "Conquista"
  },
  {
    "codigoTse": "43656",
    "ibgeCodigo": 3118304,
    "uf": "MG",
    "nome": "Conselheiro Lafaiete"
  },
  {
    "codigoTse": "43672",
    "ibgeCodigo": 3118403,
    "uf": "MG",
    "nome": "Conselheiro Pena"
  },
  {
    "codigoTse": "43699",
    "ibgeCodigo": 3118502,
    "uf": "MG",
    "nome": "Consola��o"
  },
  {
    "codigoTse": "43710",
    "ibgeCodigo": 3118601,
    "uf": "MG",
    "nome": "Contagem"
  },
  {
    "codigoTse": "43737",
    "ibgeCodigo": 3118700,
    "uf": "MG",
    "nome": "Coqueiral"
  },
  {
    "codigoTse": "43753",
    "ibgeCodigo": 3118809,
    "uf": "MG",
    "nome": "Cora��o De Jesus"
  },
  {
    "codigoTse": "43770",
    "ibgeCodigo": 3118908,
    "uf": "MG",
    "nome": "Cordisburgo"
  },
  {
    "codigoTse": "43796",
    "ibgeCodigo": 3119005,
    "uf": "MG",
    "nome": "Cordisl�ndia"
  },
  {
    "codigoTse": "43818",
    "ibgeCodigo": 3119104,
    "uf": "MG",
    "nome": "Corinto"
  },
  {
    "codigoTse": "43834",
    "ibgeCodigo": 3119203,
    "uf": "MG",
    "nome": "Coroaci"
  },
  {
    "codigoTse": "43850",
    "ibgeCodigo": 3119302,
    "uf": "MG",
    "nome": "Coromandel"
  },
  {
    "codigoTse": "43877",
    "ibgeCodigo": 3119401,
    "uf": "MG",
    "nome": "Coronel Fabriciano"
  },
  {
    "codigoTse": "43893",
    "ibgeCodigo": 3119500,
    "uf": "MG",
    "nome": "Coronel Murta"
  },
  {
    "codigoTse": "43915",
    "ibgeCodigo": 3119609,
    "uf": "MG",
    "nome": "Coronel Pacheco"
  },
  {
    "codigoTse": "43931",
    "ibgeCodigo": 3119708,
    "uf": "MG",
    "nome": "Coronel Xavier Chaves"
  },
  {
    "codigoTse": "43958",
    "ibgeCodigo": 3119807,
    "uf": "MG",
    "nome": "C�rrego Danta"
  },
  {
    "codigoTse": "43974",
    "ibgeCodigo": 3119906,
    "uf": "MG",
    "nome": "C�rrego Do Bom Jesus"
  },
  {
    "codigoTse": "43990",
    "ibgeCodigo": 3120003,
    "uf": "MG",
    "nome": "C�rrego Novo"
  },
  {
    "codigoTse": "44016",
    "ibgeCodigo": 3120102,
    "uf": "MG",
    "nome": "Couto De Magalh�es De Minas"
  },
  {
    "codigoTse": "44032",
    "ibgeCodigo": 3120201,
    "uf": "MG",
    "nome": "Cristais"
  },
  {
    "codigoTse": "44059",
    "ibgeCodigo": 3120300,
    "uf": "MG",
    "nome": "Crist�lia"
  },
  {
    "codigoTse": "44075",
    "ibgeCodigo": 3120409,
    "uf": "MG",
    "nome": "Cristiano Otoni"
  },
  {
    "codigoTse": "44091",
    "ibgeCodigo": 3120508,
    "uf": "MG",
    "nome": "Cristina"
  },
  {
    "codigoTse": "44113",
    "ibgeCodigo": 3120607,
    "uf": "MG",
    "nome": "Crucil�ndia"
  },
  {
    "codigoTse": "44130",
    "ibgeCodigo": 3120706,
    "uf": "MG",
    "nome": "Cruzeiro Da Fortaleza"
  },
  {
    "codigoTse": "44156",
    "ibgeCodigo": 3120805,
    "uf": "MG",
    "nome": "Cruz�lia"
  },
  {
    "codigoTse": "44172",
    "ibgeCodigo": 3120904,
    "uf": "MG",
    "nome": "Curvelo"
  },
  {
    "codigoTse": "44199",
    "ibgeCodigo": 3121001,
    "uf": "MG",
    "nome": "Datas"
  },
  {
    "codigoTse": "44210",
    "ibgeCodigo": 3121100,
    "uf": "MG",
    "nome": "Delfim Moreira"
  },
  {
    "codigoTse": "44237",
    "ibgeCodigo": 3121209,
    "uf": "MG",
    "nome": "Delfin�polis"
  },
  {
    "codigoTse": "44253",
    "ibgeCodigo": 3121308,
    "uf": "MG",
    "nome": "Descoberto"
  },
  {
    "codigoTse": "44270",
    "ibgeCodigo": 3121407,
    "uf": "MG",
    "nome": "Desterro De Entre Rios"
  },
  {
    "codigoTse": "44296",
    "ibgeCodigo": 3121506,
    "uf": "MG",
    "nome": "Desterro Do Melo"
  },
  {
    "codigoTse": "44318",
    "ibgeCodigo": 3121605,
    "uf": "MG",
    "nome": "Diamantina"
  },
  {
    "codigoTse": "44334",
    "ibgeCodigo": 3121704,
    "uf": "MG",
    "nome": "Diogo De Vasconcelos"
  },
  {
    "codigoTse": "44350",
    "ibgeCodigo": 3121803,
    "uf": "MG",
    "nome": "Dion�sio"
  },
  {
    "codigoTse": "44377",
    "ibgeCodigo": 3121902,
    "uf": "MG",
    "nome": "Divin�sia"
  },
  {
    "codigoTse": "44393",
    "ibgeCodigo": 3122009,
    "uf": "MG",
    "nome": "Divino"
  },
  {
    "codigoTse": "44415",
    "ibgeCodigo": 3122108,
    "uf": "MG",
    "nome": "Divino Das Laranjeiras"
  },
  {
    "codigoTse": "44431",
    "ibgeCodigo": 3122207,
    "uf": "MG",
    "nome": "Divinol�ndia De Minas"
  },
  {
    "codigoTse": "44458",
    "ibgeCodigo": 3122306,
    "uf": "MG",
    "nome": "Divin�polis"
  },
  {
    "codigoTse": "44474",
    "ibgeCodigo": 3122405,
    "uf": "MG",
    "nome": "Divisa Nova"
  },
  {
    "codigoTse": "44490",
    "ibgeCodigo": 3122504,
    "uf": "MG",
    "nome": "Dom Cavati"
  },
  {
    "codigoTse": "44512",
    "ibgeCodigo": 3122603,
    "uf": "MG",
    "nome": "Dom Joaquim"
  },
  {
    "codigoTse": "44539",
    "ibgeCodigo": 3122702,
    "uf": "MG",
    "nome": "Dom Silv�rio"
  },
  {
    "codigoTse": "44555",
    "ibgeCodigo": 3122801,
    "uf": "MG",
    "nome": "Dom Vi�oso"
  },
  {
    "codigoTse": "44571",
    "ibgeCodigo": 3122900,
    "uf": "MG",
    "nome": "Dona Eus�bia"
  },
  {
    "codigoTse": "44598",
    "ibgeCodigo": 3123007,
    "uf": "MG",
    "nome": "Dores De Campos"
  },
  {
    "codigoTse": "44610",
    "ibgeCodigo": 3123106,
    "uf": "MG",
    "nome": "Dores De Guanh�es"
  },
  {
    "codigoTse": "44636",
    "ibgeCodigo": 3123205,
    "uf": "MG",
    "nome": "Dores Do Indai�"
  },
  {
    "codigoTse": "44652",
    "ibgeCodigo": 3123304,
    "uf": "MG",
    "nome": "Dores Do Turvo"
  },
  {
    "codigoTse": "44679",
    "ibgeCodigo": 3123403,
    "uf": "MG",
    "nome": "Dores�polis"
  },
  {
    "codigoTse": "44695",
    "ibgeCodigo": 3123502,
    "uf": "MG",
    "nome": "Douradoquara"
  },
  {
    "codigoTse": "44717",
    "ibgeCodigo": 3123601,
    "uf": "MG",
    "nome": "El�i Mendes"
  },
  {
    "codigoTse": "44733",
    "ibgeCodigo": 3123700,
    "uf": "MG",
    "nome": "Engenheiro Caldas"
  },
  {
    "codigoTse": "44750",
    "ibgeCodigo": 3123809,
    "uf": "MG",
    "nome": "Engenheiro Navarro"
  },
  {
    "codigoTse": "44776",
    "ibgeCodigo": 3123908,
    "uf": "MG",
    "nome": "Entre Rios De Minas"
  },
  {
    "codigoTse": "44792",
    "ibgeCodigo": 3124005,
    "uf": "MG",
    "nome": "Erv�lia"
  },
  {
    "codigoTse": "44814",
    "ibgeCodigo": 3124104,
    "uf": "MG",
    "nome": "Esmeraldas"
  },
  {
    "codigoTse": "44830",
    "ibgeCodigo": 3124203,
    "uf": "MG",
    "nome": "Espera Feliz"
  },
  {
    "codigoTse": "44857",
    "ibgeCodigo": 3124302,
    "uf": "MG",
    "nome": "Espinosa"
  },
  {
    "codigoTse": "44873",
    "ibgeCodigo": 3124401,
    "uf": "MG",
    "nome": "Esp�rito Santo Do Dourado"
  },
  {
    "codigoTse": "44890",
    "ibgeCodigo": 3124500,
    "uf": "MG",
    "nome": "Estiva"
  },
  {
    "codigoTse": "44911",
    "ibgeCodigo": 3124609,
    "uf": "MG",
    "nome": "Estrela Dalva"
  },
  {
    "codigoTse": "44938",
    "ibgeCodigo": 3124708,
    "uf": "MG",
    "nome": "Estrela Do Indai�"
  },
  {
    "codigoTse": "44954",
    "ibgeCodigo": 3124807,
    "uf": "MG",
    "nome": "Estrela Do Sul"
  },
  {
    "codigoTse": "44970",
    "ibgeCodigo": 3124906,
    "uf": "MG",
    "nome": "Eugen�polis"
  },
  {
    "codigoTse": "44997",
    "ibgeCodigo": 3125002,
    "uf": "MG",
    "nome": "Ewbank Da C�mara"
  },
  {
    "codigoTse": "45012",
    "ibgeCodigo": 3125101,
    "uf": "MG",
    "nome": "Extrema"
  },
  {
    "codigoTse": "45039",
    "ibgeCodigo": 3125200,
    "uf": "MG",
    "nome": "Fama"
  },
  {
    "codigoTse": "45055",
    "ibgeCodigo": 3125309,
    "uf": "MG",
    "nome": "Faria Lemos"
  },
  {
    "codigoTse": "45071",
    "ibgeCodigo": 3125408,
    "uf": "MG",
    "nome": "Fel�cio Dos Santos"
  },
  {
    "codigoTse": "45098",
    "ibgeCodigo": 3125507,
    "uf": "MG",
    "nome": "S�o Gon�alo Do Rio Preto"
  },
  {
    "codigoTse": "45110",
    "ibgeCodigo": 3125606,
    "uf": "MG",
    "nome": "Felisburgo"
  },
  {
    "codigoTse": "45136",
    "ibgeCodigo": 3125705,
    "uf": "MG",
    "nome": "Felixl�ndia"
  },
  {
    "codigoTse": "45152",
    "ibgeCodigo": 3125804,
    "uf": "MG",
    "nome": "Fernandes Tourinho"
  },
  {
    "codigoTse": "45179",
    "ibgeCodigo": 3125903,
    "uf": "MG",
    "nome": "Ferros"
  },
  {
    "codigoTse": "45195",
    "ibgeCodigo": 3126000,
    "uf": "MG",
    "nome": "Florestal"
  },
  {
    "codigoTse": "45217",
    "ibgeCodigo": 3126109,
    "uf": "MG",
    "nome": "Formiga"
  },
  {
    "codigoTse": "45233",
    "ibgeCodigo": 3126208,
    "uf": "MG",
    "nome": "Formoso"
  },
  {
    "codigoTse": "45250",
    "ibgeCodigo": 3126307,
    "uf": "MG",
    "nome": "Fortaleza De Minas"
  },
  {
    "codigoTse": "45276",
    "ibgeCodigo": 3126406,
    "uf": "MG",
    "nome": "Fortuna De Minas"
  },
  {
    "codigoTse": "45292",
    "ibgeCodigo": 3126505,
    "uf": "MG",
    "nome": "Francisco Badar�"
  },
  {
    "codigoTse": "45314",
    "ibgeCodigo": 3126604,
    "uf": "MG",
    "nome": "Francisco Dumont"
  },
  {
    "codigoTse": "45330",
    "ibgeCodigo": 3126703,
    "uf": "MG",
    "nome": "Francisco S�"
  },
  {
    "codigoTse": "45357",
    "ibgeCodigo": 3126802,
    "uf": "MG",
    "nome": "Frei Gaspar"
  },
  {
    "codigoTse": "45373",
    "ibgeCodigo": 3126901,
    "uf": "MG",
    "nome": "Frei Inoc�ncio"
  },
  {
    "codigoTse": "45390",
    "ibgeCodigo": 3127008,
    "uf": "MG",
    "nome": "Fronteira"
  },
  {
    "codigoTse": "45411",
    "ibgeCodigo": 3127107,
    "uf": "MG",
    "nome": "Frutal"
  },
  {
    "codigoTse": "45438",
    "ibgeCodigo": 3127206,
    "uf": "MG",
    "nome": "Funil�ndia"
  },
  {
    "codigoTse": "45454",
    "ibgeCodigo": 3127305,
    "uf": "MG",
    "nome": "Galil�ia"
  },
  {
    "codigoTse": "45470",
    "ibgeCodigo": 3127404,
    "uf": "MG",
    "nome": "Gon�alves"
  },
  {
    "codigoTse": "45497",
    "ibgeCodigo": 3127503,
    "uf": "MG",
    "nome": "Gonzaga"
  },
  {
    "codigoTse": "45519",
    "ibgeCodigo": 3127602,
    "uf": "MG",
    "nome": "Gouveia"
  },
  {
    "codigoTse": "45535",
    "ibgeCodigo": 3127701,
    "uf": "MG",
    "nome": "Governador Valadares"
  },
  {
    "codigoTse": "45551",
    "ibgeCodigo": 3127800,
    "uf": "MG",
    "nome": "Gr�o Mogol"
  },
  {
    "codigoTse": "45578",
    "ibgeCodigo": 3127909,
    "uf": "MG",
    "nome": "Grupiara"
  },
  {
    "codigoTse": "45594",
    "ibgeCodigo": 3128006,
    "uf": "MG",
    "nome": "Guanh�es"
  },
  {
    "codigoTse": "45616",
    "ibgeCodigo": 3128105,
    "uf": "MG",
    "nome": "Guap�"
  },
  {
    "codigoTse": "45632",
    "ibgeCodigo": 3128204,
    "uf": "MG",
    "nome": "Guaraciaba"
  },
  {
    "codigoTse": "45659",
    "ibgeCodigo": 3128303,
    "uf": "MG",
    "nome": "Guaran�sia"
  },
  {
    "codigoTse": "45675",
    "ibgeCodigo": 3128402,
    "uf": "MG",
    "nome": "Guarani"
  },
  {
    "codigoTse": "45691",
    "ibgeCodigo": 3128501,
    "uf": "MG",
    "nome": "Guarar�"
  },
  {
    "codigoTse": "45713",
    "ibgeCodigo": 3128600,
    "uf": "MG",
    "nome": "Guarda-Mor"
  },
  {
    "codigoTse": "45730",
    "ibgeCodigo": 3128709,
    "uf": "MG",
    "nome": "Guaxup�"
  },
  {
    "codigoTse": "45756",
    "ibgeCodigo": 3128808,
    "uf": "MG",
    "nome": "Guidoval"
  },
  {
    "codigoTse": "45772",
    "ibgeCodigo": 3128907,
    "uf": "MG",
    "nome": "Guimar�nia"
  },
  {
    "codigoTse": "45799",
    "ibgeCodigo": 3129004,
    "uf": "MG",
    "nome": "Guiricema"
  },
  {
    "codigoTse": "45810",
    "ibgeCodigo": 3129103,
    "uf": "MG",
    "nome": "Gurinhat�"
  },
  {
    "codigoTse": "45837",
    "ibgeCodigo": 3129202,
    "uf": "MG",
    "nome": "Heliodora"
  },
  {
    "codigoTse": "45853",
    "ibgeCodigo": 3129301,
    "uf": "MG",
    "nome": "Iapu"
  },
  {
    "codigoTse": "45870",
    "ibgeCodigo": 3129400,
    "uf": "MG",
    "nome": "Ibertioga"
  },
  {
    "codigoTse": "45896",
    "ibgeCodigo": 3129509,
    "uf": "MG",
    "nome": "Ibi�"
  },
  {
    "codigoTse": "45918",
    "ibgeCodigo": 3129608,
    "uf": "MG",
    "nome": "Ibia�"
  },
  {
    "codigoTse": "45934",
    "ibgeCodigo": 3129707,
    "uf": "MG",
    "nome": "Ibiraci"
  },
  {
    "codigoTse": "45950",
    "ibgeCodigo": 3129806,
    "uf": "MG",
    "nome": "Ibirit�"
  },
  {
    "codigoTse": "45977",
    "ibgeCodigo": 3129905,
    "uf": "MG",
    "nome": "Ibiti�ra De Minas"
  },
  {
    "codigoTse": "45993",
    "ibgeCodigo": 3130002,
    "uf": "MG",
    "nome": "Ibituruna"
  },
  {
    "codigoTse": "46019",
    "ibgeCodigo": 3130101,
    "uf": "MG",
    "nome": "Igarap�"
  },
  {
    "codigoTse": "46035",
    "ibgeCodigo": 3130200,
    "uf": "MG",
    "nome": "Igaratinga"
  },
  {
    "codigoTse": "46051",
    "ibgeCodigo": 3130309,
    "uf": "MG",
    "nome": "Iguatama"
  },
  {
    "codigoTse": "46078",
    "ibgeCodigo": 3130408,
    "uf": "MG",
    "nome": "Ijaci"
  },
  {
    "codigoTse": "46094",
    "ibgeCodigo": 3130507,
    "uf": "MG",
    "nome": "Ilic�nea"
  },
  {
    "codigoTse": "46116",
    "ibgeCodigo": 3130606,
    "uf": "MG",
    "nome": "Inconfidentes"
  },
  {
    "codigoTse": "46132",
    "ibgeCodigo": 3130705,
    "uf": "MG",
    "nome": "Indian�polis"
  },
  {
    "codigoTse": "46159",
    "ibgeCodigo": 3130804,
    "uf": "MG",
    "nome": "Inga�"
  },
  {
    "codigoTse": "46175",
    "ibgeCodigo": 3130903,
    "uf": "MG",
    "nome": "Inhapim"
  },
  {
    "codigoTse": "46191",
    "ibgeCodigo": 3131000,
    "uf": "MG",
    "nome": "Inha�ma"
  },
  {
    "codigoTse": "46213",
    "ibgeCodigo": 3131109,
    "uf": "MG",
    "nome": "Inimutaba"
  },
  {
    "codigoTse": "46230",
    "ibgeCodigo": 3131208,
    "uf": "MG",
    "nome": "Ipanema"
  },
  {
    "codigoTse": "46256",
    "ibgeCodigo": 3131307,
    "uf": "MG",
    "nome": "Ipatinga"
  },
  {
    "codigoTse": "46272",
    "ibgeCodigo": 3131406,
    "uf": "MG",
    "nome": "Ipia�u"
  },
  {
    "codigoTse": "46299",
    "ibgeCodigo": 3131505,
    "uf": "MG",
    "nome": "Ipui�na"
  },
  {
    "codigoTse": "46310",
    "ibgeCodigo": 3131604,
    "uf": "MG",
    "nome": "Ira� De Minas"
  },
  {
    "codigoTse": "46337",
    "ibgeCodigo": 3131703,
    "uf": "MG",
    "nome": "Itabira"
  },
  {
    "codigoTse": "46353",
    "ibgeCodigo": 3131802,
    "uf": "MG",
    "nome": "Itabirinha"
  },
  {
    "codigoTse": "46370",
    "ibgeCodigo": 3131901,
    "uf": "MG",
    "nome": "Itabirito"
  },
  {
    "codigoTse": "46396",
    "ibgeCodigo": 3132008,
    "uf": "MG",
    "nome": "Itacambira"
  },
  {
    "codigoTse": "46418",
    "ibgeCodigo": 3132107,
    "uf": "MG",
    "nome": "Itacarambi"
  },
  {
    "codigoTse": "46434",
    "ibgeCodigo": 3132206,
    "uf": "MG",
    "nome": "Itaguara"
  },
  {
    "codigoTse": "46450",
    "ibgeCodigo": 3132305,
    "uf": "MG",
    "nome": "Itaip�"
  },
  {
    "codigoTse": "46477",
    "ibgeCodigo": 3132404,
    "uf": "MG",
    "nome": "Itajub�"
  },
  {
    "codigoTse": "46493",
    "ibgeCodigo": 3132503,
    "uf": "MG",
    "nome": "Itamarandiba"
  },
  {
    "codigoTse": "46515",
    "ibgeCodigo": 3132602,
    "uf": "MG",
    "nome": "Itamarati De Minas"
  },
  {
    "codigoTse": "46531",
    "ibgeCodigo": 3132701,
    "uf": "MG",
    "nome": "Itambacuri"
  },
  {
    "codigoTse": "46558",
    "ibgeCodigo": 3132800,
    "uf": "MG",
    "nome": "Itamb� Do Mato Dentro"
  },
  {
    "codigoTse": "46574",
    "ibgeCodigo": 3132909,
    "uf": "MG",
    "nome": "Itamogi"
  },
  {
    "codigoTse": "46590",
    "ibgeCodigo": 3133006,
    "uf": "MG",
    "nome": "Itamonte"
  },
  {
    "codigoTse": "46612",
    "ibgeCodigo": 3133105,
    "uf": "MG",
    "nome": "Itanhandu"
  },
  {
    "codigoTse": "46639",
    "ibgeCodigo": 3133204,
    "uf": "MG",
    "nome": "Itanhomi"
  },
  {
    "codigoTse": "46655",
    "ibgeCodigo": 3133303,
    "uf": "MG",
    "nome": "Itaobim"
  },
  {
    "codigoTse": "46671",
    "ibgeCodigo": 3133402,
    "uf": "MG",
    "nome": "Itapagipe"
  },
  {
    "codigoTse": "46698",
    "ibgeCodigo": 3133501,
    "uf": "MG",
    "nome": "Itapecerica"
  },
  {
    "codigoTse": "46710",
    "ibgeCodigo": 3133600,
    "uf": "MG",
    "nome": "Itapeva"
  },
  {
    "codigoTse": "46736",
    "ibgeCodigo": 3133709,
    "uf": "MG",
    "nome": "Itatiaiu�u"
  },
  {
    "codigoTse": "46752",
    "ibgeCodigo": 3133808,
    "uf": "MG",
    "nome": "Ita�na"
  },
  {
    "codigoTse": "46779",
    "ibgeCodigo": 3133907,
    "uf": "MG",
    "nome": "Itaverava"
  },
  {
    "codigoTse": "46795",
    "ibgeCodigo": 3134004,
    "uf": "MG",
    "nome": "Itinga"
  },
  {
    "codigoTse": "46817",
    "ibgeCodigo": 3134103,
    "uf": "MG",
    "nome": "Itueta"
  },
  {
    "codigoTse": "46833",
    "ibgeCodigo": 3134202,
    "uf": "MG",
    "nome": "Ituiutaba"
  },
  {
    "codigoTse": "46850",
    "ibgeCodigo": 3134301,
    "uf": "MG",
    "nome": "Itumirim"
  },
  {
    "codigoTse": "46876",
    "ibgeCodigo": 3134400,
    "uf": "MG",
    "nome": "Iturama"
  },
  {
    "codigoTse": "46892",
    "ibgeCodigo": 3134509,
    "uf": "MG",
    "nome": "Itutinga"
  },
  {
    "codigoTse": "46914",
    "ibgeCodigo": 3134608,
    "uf": "MG",
    "nome": "Jaboticatubas"
  },
  {
    "codigoTse": "46930",
    "ibgeCodigo": 3134707,
    "uf": "MG",
    "nome": "Jacinto"
  },
  {
    "codigoTse": "46957",
    "ibgeCodigo": 3134806,
    "uf": "MG",
    "nome": "Jacu�"
  },
  {
    "codigoTse": "46973",
    "ibgeCodigo": 3134905,
    "uf": "MG",
    "nome": "Jacutinga"
  },
  {
    "codigoTse": "46990",
    "ibgeCodigo": 3135001,
    "uf": "MG",
    "nome": "Jaguara�u"
  },
  {
    "codigoTse": "47015",
    "ibgeCodigo": 3135100,
    "uf": "MG",
    "nome": "Jana�ba"
  },
  {
    "codigoTse": "47031",
    "ibgeCodigo": 3135209,
    "uf": "MG",
    "nome": "Janu�ria"
  },
  {
    "codigoTse": "47058",
    "ibgeCodigo": 3135308,
    "uf": "MG",
    "nome": "Japara�ba"
  },
  {
    "codigoTse": "47074",
    "ibgeCodigo": 3135407,
    "uf": "MG",
    "nome": "Jeceaba"
  },
  {
    "codigoTse": "47090",
    "ibgeCodigo": 3135506,
    "uf": "MG",
    "nome": "Jequeri"
  },
  {
    "codigoTse": "47112",
    "ibgeCodigo": 3135605,
    "uf": "MG",
    "nome": "Jequita�"
  },
  {
    "codigoTse": "47139",
    "ibgeCodigo": 3135704,
    "uf": "MG",
    "nome": "Jequitib�"
  },
  {
    "codigoTse": "47155",
    "ibgeCodigo": 3135803,
    "uf": "MG",
    "nome": "Jequitinhonha"
  },
  {
    "codigoTse": "47171",
    "ibgeCodigo": 3135902,
    "uf": "MG",
    "nome": "Jesu�nia"
  },
  {
    "codigoTse": "47198",
    "ibgeCodigo": 3136009,
    "uf": "MG",
    "nome": "Joa�ma"
  },
  {
    "codigoTse": "47210",
    "ibgeCodigo": 3136108,
    "uf": "MG",
    "nome": "Joan�sia"
  },
  {
    "codigoTse": "47236",
    "ibgeCodigo": 3136207,
    "uf": "MG",
    "nome": "Jo�o Monlevade"
  },
  {
    "codigoTse": "47252",
    "ibgeCodigo": 3136306,
    "uf": "MG",
    "nome": "Jo�o Pinheiro"
  },
  {
    "codigoTse": "47279",
    "ibgeCodigo": 3136405,
    "uf": "MG",
    "nome": "Joaquim Fel�cio"
  },
  {
    "codigoTse": "47295",
    "ibgeCodigo": 3136504,
    "uf": "MG",
    "nome": "Jord�nia"
  },
  {
    "codigoTse": "47317",
    "ibgeCodigo": 3136603,
    "uf": "MG",
    "nome": "Nova Uni�o"
  },
  {
    "codigoTse": "47333",
    "ibgeCodigo": 3136702,
    "uf": "MG",
    "nome": "Juiz De Fora"
  },
  {
    "codigoTse": "47350",
    "ibgeCodigo": 3136801,
    "uf": "MG",
    "nome": "Juramento"
  },
  {
    "codigoTse": "47376",
    "ibgeCodigo": 3136900,
    "uf": "MG",
    "nome": "Juruaia"
  },
  {
    "codigoTse": "47392",
    "ibgeCodigo": 3137007,
    "uf": "MG",
    "nome": "Ladainha"
  },
  {
    "codigoTse": "47414",
    "ibgeCodigo": 3137106,
    "uf": "MG",
    "nome": "Lagamar"
  },
  {
    "codigoTse": "47430",
    "ibgeCodigo": 3137205,
    "uf": "MG",
    "nome": "Lagoa Da Prata"
  },
  {
    "codigoTse": "47457",
    "ibgeCodigo": 3137304,
    "uf": "MG",
    "nome": "Lagoa Dos Patos"
  },
  {
    "codigoTse": "47473",
    "ibgeCodigo": 3137403,
    "uf": "MG",
    "nome": "Lagoa Dourada"
  },
  {
    "codigoTse": "47490",
    "ibgeCodigo": 3137502,
    "uf": "MG",
    "nome": "Lagoa Formosa"
  },
  {
    "codigoTse": "47511",
    "ibgeCodigo": 3137601,
    "uf": "MG",
    "nome": "Lagoa Santa"
  },
  {
    "codigoTse": "47538",
    "ibgeCodigo": 3137700,
    "uf": "MG",
    "nome": "Lajinha"
  },
  {
    "codigoTse": "47554",
    "ibgeCodigo": 3137809,
    "uf": "MG",
    "nome": "Lambari"
  },
  {
    "codigoTse": "47570",
    "ibgeCodigo": 3137908,
    "uf": "MG",
    "nome": "Lamim"
  },
  {
    "codigoTse": "47597",
    "ibgeCodigo": 3138005,
    "uf": "MG",
    "nome": "Laranjal"
  },
  {
    "codigoTse": "47619",
    "ibgeCodigo": 3138104,
    "uf": "MG",
    "nome": "Lassance"
  },
  {
    "codigoTse": "47635",
    "ibgeCodigo": 3138203,
    "uf": "MG",
    "nome": "Lavras"
  },
  {
    "codigoTse": "47651",
    "ibgeCodigo": 3138302,
    "uf": "MG",
    "nome": "Leandro Ferreira"
  },
  {
    "codigoTse": "47678",
    "ibgeCodigo": 3138401,
    "uf": "MG",
    "nome": "Leopoldina"
  },
  {
    "codigoTse": "47694",
    "ibgeCodigo": 3138500,
    "uf": "MG",
    "nome": "Liberdade"
  },
  {
    "codigoTse": "47716",
    "ibgeCodigo": 3138609,
    "uf": "MG",
    "nome": "Lima Duarte"
  },
  {
    "codigoTse": "47732",
    "ibgeCodigo": 3138708,
    "uf": "MG",
    "nome": "Lumin�rias"
  },
  {
    "codigoTse": "47759",
    "ibgeCodigo": 3138807,
    "uf": "MG",
    "nome": "Luz"
  },
  {
    "codigoTse": "47775",
    "ibgeCodigo": 3138906,
    "uf": "MG",
    "nome": "Machacalis"
  },
  {
    "codigoTse": "47791",
    "ibgeCodigo": 3139003,
    "uf": "MG",
    "nome": "Machado"
  },
  {
    "codigoTse": "47813",
    "ibgeCodigo": 3139102,
    "uf": "MG",
    "nome": "Madre De Deus De Minas"
  },
  {
    "codigoTse": "47830",
    "ibgeCodigo": 3139201,
    "uf": "MG",
    "nome": "Malacacheta"
  },
  {
    "codigoTse": "47856",
    "ibgeCodigo": 3139300,
    "uf": "MG",
    "nome": "Manga"
  },
  {
    "codigoTse": "47872",
    "ibgeCodigo": 3139409,
    "uf": "MG",
    "nome": "Manhua�u"
  },
  {
    "codigoTse": "47899",
    "ibgeCodigo": 3139508,
    "uf": "MG",
    "nome": "Manhumirim"
  },
  {
    "codigoTse": "47910",
    "ibgeCodigo": 3139607,
    "uf": "MG",
    "nome": "Mantena"
  },
  {
    "codigoTse": "47937",
    "ibgeCodigo": 3139706,
    "uf": "MG",
    "nome": "Maravilhas"
  },
  {
    "codigoTse": "47953",
    "ibgeCodigo": 3139805,
    "uf": "MG",
    "nome": "Mar De Espanha"
  },
  {
    "codigoTse": "47970",
    "ibgeCodigo": 3139904,
    "uf": "MG",
    "nome": "Maria Da F�"
  },
  {
    "codigoTse": "47996",
    "ibgeCodigo": 3140001,
    "uf": "MG",
    "nome": "Mariana"
  },
  {
    "codigoTse": "48011",
    "ibgeCodigo": 3140100,
    "uf": "MG",
    "nome": "Marilac"
  },
  {
    "codigoTse": "48038",
    "ibgeCodigo": 3140209,
    "uf": "MG",
    "nome": "Marip� De Minas"
  },
  {
    "codigoTse": "48054",
    "ibgeCodigo": 3140308,
    "uf": "MG",
    "nome": "Marli�ria"
  },
  {
    "codigoTse": "48070",
    "ibgeCodigo": 3140407,
    "uf": "MG",
    "nome": "Marmel�polis"
  },
  {
    "codigoTse": "48097",
    "ibgeCodigo": 3140506,
    "uf": "MG",
    "nome": "Martinho Campos"
  },
  {
    "codigoTse": "48119",
    "ibgeCodigo": 3140605,
    "uf": "MG",
    "nome": "Materl�ndia"
  },
  {
    "codigoTse": "48135",
    "ibgeCodigo": 3140704,
    "uf": "MG",
    "nome": "Mateus Leme"
  },
  {
    "codigoTse": "48151",
    "ibgeCodigo": 3140803,
    "uf": "MG",
    "nome": "Matias Barbosa"
  },
  {
    "codigoTse": "48178",
    "ibgeCodigo": 3140902,
    "uf": "MG",
    "nome": "Matip�"
  },
  {
    "codigoTse": "48194",
    "ibgeCodigo": 3141009,
    "uf": "MG",
    "nome": "Mato Verde"
  },
  {
    "codigoTse": "48216",
    "ibgeCodigo": 3141108,
    "uf": "MG",
    "nome": "Matozinhos"
  },
  {
    "codigoTse": "48232",
    "ibgeCodigo": 3141207,
    "uf": "MG",
    "nome": "Matutina"
  },
  {
    "codigoTse": "48259",
    "ibgeCodigo": 3141306,
    "uf": "MG",
    "nome": "Medeiros"
  },
  {
    "codigoTse": "48275",
    "ibgeCodigo": 3141405,
    "uf": "MG",
    "nome": "Medina"
  },
  {
    "codigoTse": "48291",
    "ibgeCodigo": 3141504,
    "uf": "MG",
    "nome": "Mendes Pimentel"
  },
  {
    "codigoTse": "48313",
    "ibgeCodigo": 3141603,
    "uf": "MG",
    "nome": "Merc�s"
  },
  {
    "codigoTse": "48330",
    "ibgeCodigo": 3141702,
    "uf": "MG",
    "nome": "Mesquita"
  },
  {
    "codigoTse": "48356",
    "ibgeCodigo": 3141801,
    "uf": "MG",
    "nome": "Minas Novas"
  },
  {
    "codigoTse": "48372",
    "ibgeCodigo": 3141900,
    "uf": "MG",
    "nome": "Minduri"
  },
  {
    "codigoTse": "48399",
    "ibgeCodigo": 3142007,
    "uf": "MG",
    "nome": "Mirabela"
  },
  {
    "codigoTse": "48410",
    "ibgeCodigo": 3142106,
    "uf": "MG",
    "nome": "Miradouro"
  },
  {
    "codigoTse": "48437",
    "ibgeCodigo": 3142205,
    "uf": "MG",
    "nome": "Mira�"
  },
  {
    "codigoTse": "48453",
    "ibgeCodigo": 3142304,
    "uf": "MG",
    "nome": "Moeda"
  },
  {
    "codigoTse": "48470",
    "ibgeCodigo": 3142403,
    "uf": "MG",
    "nome": "Moema"
  },
  {
    "codigoTse": "48496",
    "ibgeCodigo": 3142502,
    "uf": "MG",
    "nome": "Monjolos"
  },
  {
    "codigoTse": "48518",
    "ibgeCodigo": 3142601,
    "uf": "MG",
    "nome": "Monsenhor Paulo"
  },
  {
    "codigoTse": "48534",
    "ibgeCodigo": 3142700,
    "uf": "MG",
    "nome": "Montalv�nia"
  },
  {
    "codigoTse": "48550",
    "ibgeCodigo": 3142809,
    "uf": "MG",
    "nome": "Monte Alegre De Minas"
  },
  {
    "codigoTse": "48577",
    "ibgeCodigo": 3142908,
    "uf": "MG",
    "nome": "Monte Azul"
  },
  {
    "codigoTse": "48593",
    "ibgeCodigo": 3143005,
    "uf": "MG",
    "nome": "Monte Belo"
  },
  {
    "codigoTse": "48615",
    "ibgeCodigo": 3143104,
    "uf": "MG",
    "nome": "Monte Carmelo"
  },
  {
    "codigoTse": "48631",
    "ibgeCodigo": 3143203,
    "uf": "MG",
    "nome": "Monte Santo De Minas"
  },
  {
    "codigoTse": "48658",
    "ibgeCodigo": 3143302,
    "uf": "MG",
    "nome": "Montes Claros"
  },
  {
    "codigoTse": "48674",
    "ibgeCodigo": 3143401,
    "uf": "MG",
    "nome": "Monte Si�o"
  },
  {
    "codigoTse": "48690",
    "ibgeCodigo": 3143500,
    "uf": "MG",
    "nome": "Morada Nova De Minas"
  },
  {
    "codigoTse": "48712",
    "ibgeCodigo": 3143609,
    "uf": "MG",
    "nome": "Morro Da Gar�a"
  },
  {
    "codigoTse": "48739",
    "ibgeCodigo": 3143708,
    "uf": "MG",
    "nome": "Morro Do Pilar"
  },
  {
    "codigoTse": "48755",
    "ibgeCodigo": 3143807,
    "uf": "MG",
    "nome": "Munhoz"
  },
  {
    "codigoTse": "48771",
    "ibgeCodigo": 3143906,
    "uf": "MG",
    "nome": "Muria�"
  },
  {
    "codigoTse": "48798",
    "ibgeCodigo": 3144003,
    "uf": "MG",
    "nome": "Mutum"
  },
  {
    "codigoTse": "48810",
    "ibgeCodigo": 3144102,
    "uf": "MG",
    "nome": "Muzambinho"
  },
  {
    "codigoTse": "48836",
    "ibgeCodigo": 3144201,
    "uf": "MG",
    "nome": "Nacip Raydan"
  },
  {
    "codigoTse": "48852",
    "ibgeCodigo": 3144300,
    "uf": "MG",
    "nome": "Nanuque"
  },
  {
    "codigoTse": "48879",
    "ibgeCodigo": 3144409,
    "uf": "MG",
    "nome": "Nat�rcia"
  },
  {
    "codigoTse": "48895",
    "ibgeCodigo": 3144508,
    "uf": "MG",
    "nome": "Nazareno"
  },
  {
    "codigoTse": "48917",
    "ibgeCodigo": 3144607,
    "uf": "MG",
    "nome": "Nepomuceno"
  },
  {
    "codigoTse": "48933",
    "ibgeCodigo": 3144706,
    "uf": "MG",
    "nome": "Nova Era"
  },
  {
    "codigoTse": "48950",
    "ibgeCodigo": 3144805,
    "uf": "MG",
    "nome": "Nova Lima"
  },
  {
    "codigoTse": "48976",
    "ibgeCodigo": 3144904,
    "uf": "MG",
    "nome": "Nova M�dica"
  },
  {
    "codigoTse": "48992",
    "ibgeCodigo": 3145000,
    "uf": "MG",
    "nome": "Nova Ponte"
  },
  {
    "codigoTse": "49018",
    "ibgeCodigo": 3145109,
    "uf": "MG",
    "nome": "Nova Resende"
  },
  {
    "codigoTse": "49034",
    "ibgeCodigo": 3145208,
    "uf": "MG",
    "nome": "Nova Serrana"
  },
  {
    "codigoTse": "49050",
    "ibgeCodigo": 3145307,
    "uf": "MG",
    "nome": "Novo Cruzeiro"
  },
  {
    "codigoTse": "49077",
    "ibgeCodigo": 3145406,
    "uf": "MG",
    "nome": "Olaria"
  },
  {
    "codigoTse": "49093",
    "ibgeCodigo": 3145505,
    "uf": "MG",
    "nome": "Ol�mpio Noronha"
  },
  {
    "codigoTse": "49115",
    "ibgeCodigo": 3145604,
    "uf": "MG",
    "nome": "Oliveira"
  },
  {
    "codigoTse": "49131",
    "ibgeCodigo": 3145703,
    "uf": "MG",
    "nome": "Oliveira Fortes"
  },
  {
    "codigoTse": "49158",
    "ibgeCodigo": 3145802,
    "uf": "MG",
    "nome": "On�a De Pitangui"
  },
  {
    "codigoTse": "49174",
    "ibgeCodigo": 3145901,
    "uf": "MG",
    "nome": "Ouro Branco"
  },
  {
    "codigoTse": "49190",
    "ibgeCodigo": 3146008,
    "uf": "MG",
    "nome": "Ouro Fino"
  },
  {
    "codigoTse": "49212",
    "ibgeCodigo": 3146107,
    "uf": "MG",
    "nome": "Ouro Preto"
  },
  {
    "codigoTse": "49239",
    "ibgeCodigo": 3146206,
    "uf": "MG",
    "nome": "Ouro Verde De Minas"
  },
  {
    "codigoTse": "49255",
    "ibgeCodigo": 3146305,
    "uf": "MG",
    "nome": "Padre Para�so"
  },
  {
    "codigoTse": "49271",
    "ibgeCodigo": 3146404,
    "uf": "MG",
    "nome": "Paineiras"
  },
  {
    "codigoTse": "49298",
    "ibgeCodigo": 3146503,
    "uf": "MG",
    "nome": "Pains"
  },
  {
    "codigoTse": "49310",
    "ibgeCodigo": 3146602,
    "uf": "MG",
    "nome": "Paiva"
  },
  {
    "codigoTse": "49336",
    "ibgeCodigo": 3146701,
    "uf": "MG",
    "nome": "Palma"
  },
  {
    "codigoTse": "49352",
    "ibgeCodigo": 3127057,
    "uf": "MG",
    "nome": "Fronteira Dos Vales"
  },
  {
    "codigoTse": "49379",
    "ibgeCodigo": 3146909,
    "uf": "MG",
    "nome": "Papagaios"
  },
  {
    "codigoTse": "49395",
    "ibgeCodigo": 3147006,
    "uf": "MG",
    "nome": "Paracatu"
  },
  {
    "codigoTse": "49417",
    "ibgeCodigo": 3147105,
    "uf": "MG",
    "nome": "Par� De Minas"
  },
  {
    "codigoTse": "49433",
    "ibgeCodigo": 3147204,
    "uf": "MG",
    "nome": "Paragua�u"
  },
  {
    "codigoTse": "49450",
    "ibgeCodigo": 3147303,
    "uf": "MG",
    "nome": "Parais�polis"
  },
  {
    "codigoTse": "49476",
    "ibgeCodigo": 3147402,
    "uf": "MG",
    "nome": "Paraopeba"
  },
  {
    "codigoTse": "49492",
    "ibgeCodigo": 3147501,
    "uf": "MG",
    "nome": "Passab�m"
  },
  {
    "codigoTse": "49514",
    "ibgeCodigo": 3147600,
    "uf": "MG",
    "nome": "Passa Quatro"
  },
  {
    "codigoTse": "49530",
    "ibgeCodigo": 3147709,
    "uf": "MG",
    "nome": "Passa Tempo"
  },
  {
    "codigoTse": "49557",
    "ibgeCodigo": 3147808,
    "uf": "MG",
    "nome": "Passa-Vinte"
  },
  {
    "codigoTse": "49573",
    "ibgeCodigo": 3147907,
    "uf": "MG",
    "nome": "Passos"
  },
  {
    "codigoTse": "49590",
    "ibgeCodigo": 3148004,
    "uf": "MG",
    "nome": "Patos De Minas"
  },
  {
    "codigoTse": "49611",
    "ibgeCodigo": 3148103,
    "uf": "MG",
    "nome": "Patroc�nio"
  },
  {
    "codigoTse": "49638",
    "ibgeCodigo": 3148202,
    "uf": "MG",
    "nome": "Patroc�nio Do Muria�"
  },
  {
    "codigoTse": "49654",
    "ibgeCodigo": 3148301,
    "uf": "MG",
    "nome": "Paula C�ndido"
  },
  {
    "codigoTse": "49670",
    "ibgeCodigo": 3148400,
    "uf": "MG",
    "nome": "Paulistas"
  },
  {
    "codigoTse": "49697",
    "ibgeCodigo": 3148509,
    "uf": "MG",
    "nome": "Pav�o"
  },
  {
    "codigoTse": "49719",
    "ibgeCodigo": 3148608,
    "uf": "MG",
    "nome": "Pe�anha"
  },
  {
    "codigoTse": "49735",
    "ibgeCodigo": 3148707,
    "uf": "MG",
    "nome": "Pedra Azul"
  },
  {
    "codigoTse": "49751",
    "ibgeCodigo": 3148806,
    "uf": "MG",
    "nome": "Pedra Do Anta"
  },
  {
    "codigoTse": "49778",
    "ibgeCodigo": 3148905,
    "uf": "MG",
    "nome": "Pedra Do Indai�"
  },
  {
    "codigoTse": "49794",
    "ibgeCodigo": 3149002,
    "uf": "MG",
    "nome": "Pedra Dourada"
  },
  {
    "codigoTse": "49816",
    "ibgeCodigo": 3149101,
    "uf": "MG",
    "nome": "Pedralva"
  },
  {
    "codigoTse": "49832",
    "ibgeCodigo": 3149200,
    "uf": "MG",
    "nome": "Pedrin�polis"
  },
  {
    "codigoTse": "49859",
    "ibgeCodigo": 3149309,
    "uf": "MG",
    "nome": "Pedro Leopoldo"
  },
  {
    "codigoTse": "49875",
    "ibgeCodigo": 3149408,
    "uf": "MG",
    "nome": "Pedro Teixeira"
  },
  {
    "codigoTse": "49891",
    "ibgeCodigo": 3149507,
    "uf": "MG",
    "nome": "Pequeri"
  },
  {
    "codigoTse": "49913",
    "ibgeCodigo": 3149606,
    "uf": "MG",
    "nome": "Pequi"
  },
  {
    "codigoTse": "49930",
    "ibgeCodigo": 3149705,
    "uf": "MG",
    "nome": "Perdig�o"
  },
  {
    "codigoTse": "49956",
    "ibgeCodigo": 3149804,
    "uf": "MG",
    "nome": "Perdizes"
  },
  {
    "codigoTse": "49972",
    "ibgeCodigo": 3149903,
    "uf": "MG",
    "nome": "Perd�es"
  },
  {
    "codigoTse": "49999",
    "ibgeCodigo": 3150000,
    "uf": "MG",
    "nome": "Pescador"
  },
  {
    "codigoTse": "50016",
    "ibgeCodigo": 3150109,
    "uf": "MG",
    "nome": "Piau"
  },
  {
    "codigoTse": "50032",
    "ibgeCodigo": 3150208,
    "uf": "MG",
    "nome": "Piedade De Ponte Nova"
  },
  {
    "codigoTse": "50059",
    "ibgeCodigo": 3150307,
    "uf": "MG",
    "nome": "Piedade Do Rio Grande"
  },
  {
    "codigoTse": "50075",
    "ibgeCodigo": 3150406,
    "uf": "MG",
    "nome": "Piedade Dos Gerais"
  },
  {
    "codigoTse": "50091",
    "ibgeCodigo": 3150505,
    "uf": "MG",
    "nome": "Pimenta"
  },
  {
    "codigoTse": "50113",
    "ibgeCodigo": 3150604,
    "uf": "MG",
    "nome": "Piracema"
  },
  {
    "codigoTse": "50130",
    "ibgeCodigo": 3150703,
    "uf": "MG",
    "nome": "Pirajuba"
  },
  {
    "codigoTse": "50156",
    "ibgeCodigo": 3150802,
    "uf": "MG",
    "nome": "Piranga"
  },
  {
    "codigoTse": "50172",
    "ibgeCodigo": 3150901,
    "uf": "MG",
    "nome": "Pirangu�u"
  },
  {
    "codigoTse": "50199",
    "ibgeCodigo": 3151008,
    "uf": "MG",
    "nome": "Piranguinho"
  },
  {
    "codigoTse": "50210",
    "ibgeCodigo": 3151107,
    "uf": "MG",
    "nome": "Pirapetinga"
  },
  {
    "codigoTse": "50237",
    "ibgeCodigo": 3151206,
    "uf": "MG",
    "nome": "Pirapora"
  },
  {
    "codigoTse": "50253",
    "ibgeCodigo": 3151305,
    "uf": "MG",
    "nome": "Pira�ba"
  },
  {
    "codigoTse": "50270",
    "ibgeCodigo": 3151404,
    "uf": "MG",
    "nome": "Pitangui"
  },
  {
    "codigoTse": "50296",
    "ibgeCodigo": 3151503,
    "uf": "MG",
    "nome": "Piumhi"
  },
  {
    "codigoTse": "50318",
    "ibgeCodigo": 3151602,
    "uf": "MG",
    "nome": "Planura"
  },
  {
    "codigoTse": "50334",
    "ibgeCodigo": 3151701,
    "uf": "MG",
    "nome": "Po�o Fundo"
  },
  {
    "codigoTse": "50350",
    "ibgeCodigo": 3151800,
    "uf": "MG",
    "nome": "Po�os De Caldas"
  },
  {
    "codigoTse": "50377",
    "ibgeCodigo": 3151909,
    "uf": "MG",
    "nome": "Pocrane"
  },
  {
    "codigoTse": "50393",
    "ibgeCodigo": 3152006,
    "uf": "MG",
    "nome": "Pomp�u"
  },
  {
    "codigoTse": "50415",
    "ibgeCodigo": 3152105,
    "uf": "MG",
    "nome": "Ponte Nova"
  },
  {
    "codigoTse": "50431",
    "ibgeCodigo": 3152204,
    "uf": "MG",
    "nome": "Porteirinha"
  },
  {
    "codigoTse": "50458",
    "ibgeCodigo": 3152303,
    "uf": "MG",
    "nome": "Porto Firme"
  },
  {
    "codigoTse": "50474",
    "ibgeCodigo": 3152402,
    "uf": "MG",
    "nome": "Pot�"
  },
  {
    "codigoTse": "50490",
    "ibgeCodigo": 3152501,
    "uf": "MG",
    "nome": "Pouso Alegre"
  },
  {
    "codigoTse": "50512",
    "ibgeCodigo": 3152600,
    "uf": "MG",
    "nome": "Pouso Alto"
  },
  {
    "codigoTse": "50539",
    "ibgeCodigo": 3152709,
    "uf": "MG",
    "nome": "Prados"
  },
  {
    "codigoTse": "50555",
    "ibgeCodigo": 3152808,
    "uf": "MG",
    "nome": "Prata"
  },
  {
    "codigoTse": "50571",
    "ibgeCodigo": 3152907,
    "uf": "MG",
    "nome": "Prat�polis"
  },
  {
    "codigoTse": "50598",
    "ibgeCodigo": 3153004,
    "uf": "MG",
    "nome": "Pratinha"
  },
  {
    "codigoTse": "50610",
    "ibgeCodigo": 3153103,
    "uf": "MG",
    "nome": "Presidente Bernardes"
  },
  {
    "codigoTse": "50636",
    "ibgeCodigo": 3153202,
    "uf": "MG",
    "nome": "Presidente Juscelino"
  },
  {
    "codigoTse": "50652",
    "ibgeCodigo": 3153301,
    "uf": "MG",
    "nome": "Presidente Kubitschek"
  },
  {
    "codigoTse": "50679",
    "ibgeCodigo": 3153400,
    "uf": "MG",
    "nome": "Presidente Oleg�rio"
  },
  {
    "codigoTse": "50695",
    "ibgeCodigo": 3153509,
    "uf": "MG",
    "nome": "Alto Jequitib�"
  },
  {
    "codigoTse": "50717",
    "ibgeCodigo": 3153608,
    "uf": "MG",
    "nome": "Prudente De Morais"
  },
  {
    "codigoTse": "50733",
    "ibgeCodigo": 3153707,
    "uf": "MG",
    "nome": "Quartel Geral"
  },
  {
    "codigoTse": "50750",
    "ibgeCodigo": 3153806,
    "uf": "MG",
    "nome": "Queluzito"
  },
  {
    "codigoTse": "50776",
    "ibgeCodigo": 3153905,
    "uf": "MG",
    "nome": "Raposos"
  },
  {
    "codigoTse": "50792",
    "ibgeCodigo": 3154002,
    "uf": "MG",
    "nome": "Raul Soares"
  },
  {
    "codigoTse": "50814",
    "ibgeCodigo": 3154101,
    "uf": "MG",
    "nome": "Recreio"
  },
  {
    "codigoTse": "50830",
    "ibgeCodigo": 3154200,
    "uf": "MG",
    "nome": "Resende Costa"
  },
  {
    "codigoTse": "50857",
    "ibgeCodigo": 3154309,
    "uf": "MG",
    "nome": "Resplendor"
  },
  {
    "codigoTse": "50873",
    "ibgeCodigo": 3154408,
    "uf": "MG",
    "nome": "Ressaquinha"
  },
  {
    "codigoTse": "50890",
    "ibgeCodigo": 3154507,
    "uf": "MG",
    "nome": "Riacho Dos Machados"
  },
  {
    "codigoTse": "50911",
    "ibgeCodigo": 3154606,
    "uf": "MG",
    "nome": "Ribeir�o Das Neves"
  },
  {
    "codigoTse": "50938",
    "ibgeCodigo": 3154705,
    "uf": "MG",
    "nome": "Ribeir�o Vermelho"
  },
  {
    "codigoTse": "50954",
    "ibgeCodigo": 3154804,
    "uf": "MG",
    "nome": "Rio Acima"
  },
  {
    "codigoTse": "50970",
    "ibgeCodigo": 3154903,
    "uf": "MG",
    "nome": "Rio Casca"
  },
  {
    "codigoTse": "50997",
    "ibgeCodigo": 3155009,
    "uf": "MG",
    "nome": "Rio Doce"
  },
  {
    "codigoTse": "51012",
    "ibgeCodigo": 3155108,
    "uf": "MG",
    "nome": "Rio Do Prado"
  },
  {
    "codigoTse": "51039",
    "ibgeCodigo": 3155207,
    "uf": "MG",
    "nome": "Rio Espera"
  },
  {
    "codigoTse": "51055",
    "ibgeCodigo": 3155306,
    "uf": "MG",
    "nome": "Rio Manso"
  },
  {
    "codigoTse": "51071",
    "ibgeCodigo": 3155405,
    "uf": "MG",
    "nome": "Rio Novo"
  },
  {
    "codigoTse": "51098",
    "ibgeCodigo": 3155504,
    "uf": "MG",
    "nome": "Rio Parana�ba"
  },
  {
    "codigoTse": "51110",
    "ibgeCodigo": 3155603,
    "uf": "MG",
    "nome": "Rio Pardo De Minas"
  },
  {
    "codigoTse": "51136",
    "ibgeCodigo": 3155702,
    "uf": "MG",
    "nome": "Rio Piracicaba"
  },
  {
    "codigoTse": "51152",
    "ibgeCodigo": 3155801,
    "uf": "MG",
    "nome": "Rio Pomba"
  },
  {
    "codigoTse": "51179",
    "ibgeCodigo": 3155900,
    "uf": "MG",
    "nome": "Rio Preto"
  },
  {
    "codigoTse": "51195",
    "ibgeCodigo": 3156007,
    "uf": "MG",
    "nome": "Rio Vermelho"
  },
  {
    "codigoTse": "51217",
    "ibgeCodigo": 3156106,
    "uf": "MG",
    "nome": "Rit�polis"
  },
  {
    "codigoTse": "51233",
    "ibgeCodigo": 3156205,
    "uf": "MG",
    "nome": "Rochedo De Minas"
  },
  {
    "codigoTse": "51250",
    "ibgeCodigo": 3156304,
    "uf": "MG",
    "nome": "Rodeiro"
  },
  {
    "codigoTse": "51276",
    "ibgeCodigo": 3156403,
    "uf": "MG",
    "nome": "Romaria"
  },
  {
    "codigoTse": "51292",
    "ibgeCodigo": 3156502,
    "uf": "MG",
    "nome": "Rubelita"
  },
  {
    "codigoTse": "51314",
    "ibgeCodigo": 3156601,
    "uf": "MG",
    "nome": "Rubim"
  },
  {
    "codigoTse": "51330",
    "ibgeCodigo": 3156700,
    "uf": "MG",
    "nome": "Sabar�"
  },
  {
    "codigoTse": "51357",
    "ibgeCodigo": 3156809,
    "uf": "MG",
    "nome": "Sabin�polis"
  },
  {
    "codigoTse": "51373",
    "ibgeCodigo": 3156908,
    "uf": "MG",
    "nome": "Sacramento"
  },
  {
    "codigoTse": "51390",
    "ibgeCodigo": 3157005,
    "uf": "MG",
    "nome": "Salinas"
  },
  {
    "codigoTse": "51411",
    "ibgeCodigo": 3157104,
    "uf": "MG",
    "nome": "Salto Da Divisa"
  },
  {
    "codigoTse": "51438",
    "ibgeCodigo": 3157203,
    "uf": "MG",
    "nome": "Santa B�rbara"
  },
  {
    "codigoTse": "51454",
    "ibgeCodigo": 3157302,
    "uf": "MG",
    "nome": "Santa B�rbara Do Tug�rio"
  },
  {
    "codigoTse": "51470",
    "ibgeCodigo": 3157401,
    "uf": "MG",
    "nome": "Santa Cruz Do Escalvado"
  },
  {
    "codigoTse": "51497",
    "ibgeCodigo": 3157500,
    "uf": "MG",
    "nome": "Santa Efig�nia De Minas"
  },
  {
    "codigoTse": "51519",
    "ibgeCodigo": 3157609,
    "uf": "MG",
    "nome": "Santa F� De Minas"
  },
  {
    "codigoTse": "51535",
    "ibgeCodigo": 3157708,
    "uf": "MG",
    "nome": "Santa Juliana"
  },
  {
    "codigoTse": "51551",
    "ibgeCodigo": 3157807,
    "uf": "MG",
    "nome": "Santa Luzia"
  },
  {
    "codigoTse": "51578",
    "ibgeCodigo": 3157906,
    "uf": "MG",
    "nome": "Santa Margarida"
  },
  {
    "codigoTse": "51594",
    "ibgeCodigo": 3158003,
    "uf": "MG",
    "nome": "Santa Maria De Itabira"
  },
  {
    "codigoTse": "51616",
    "ibgeCodigo": 3158102,
    "uf": "MG",
    "nome": "Santa Maria Do Salto"
  },
  {
    "codigoTse": "51632",
    "ibgeCodigo": 3158201,
    "uf": "MG",
    "nome": "Santa Maria Do Sua�u�"
  },
  {
    "codigoTse": "51659",
    "ibgeCodigo": 3158300,
    "uf": "MG",
    "nome": "Santana Da Vargem"
  },
  {
    "codigoTse": "51675",
    "ibgeCodigo": 3158409,
    "uf": "MG",
    "nome": "Santana De Cataguases"
  },
  {
    "codigoTse": "51691",
    "ibgeCodigo": 3158508,
    "uf": "MG",
    "nome": "Santana De Pirapama"
  },
  {
    "codigoTse": "51713",
    "ibgeCodigo": 3158607,
    "uf": "MG",
    "nome": "Santana Do Deserto"
  },
  {
    "codigoTse": "51730",
    "ibgeCodigo": 3158706,
    "uf": "MG",
    "nome": "Santana Do Garamb�u"
  },
  {
    "codigoTse": "51756",
    "ibgeCodigo": 3158805,
    "uf": "MG",
    "nome": "Santana Do Jacar�"
  },
  {
    "codigoTse": "51772",
    "ibgeCodigo": 3158904,
    "uf": "MG",
    "nome": "Santana Do Manhua�u"
  },
  {
    "codigoTse": "51799",
    "ibgeCodigo": 3159001,
    "uf": "MG",
    "nome": "Santana Do Riacho"
  },
  {
    "codigoTse": "51810",
    "ibgeCodigo": 3159100,
    "uf": "MG",
    "nome": "Santana Dos Montes"
  },
  {
    "codigoTse": "51837",
    "ibgeCodigo": 3159209,
    "uf": "MG",
    "nome": "Santa Rita De Caldas"
  },
  {
    "codigoTse": "51853",
    "ibgeCodigo": 3159308,
    "uf": "MG",
    "nome": "Santa Rita De Jacutinga"
  },
  {
    "codigoTse": "51870",
    "ibgeCodigo": 3159407,
    "uf": "MG",
    "nome": "Santa Rita De Ibitipoca"
  },
  {
    "codigoTse": "51896",
    "ibgeCodigo": 3159506,
    "uf": "MG",
    "nome": "Santa Rita Do Itueto"
  },
  {
    "codigoTse": "51918",
    "ibgeCodigo": 3159605,
    "uf": "MG",
    "nome": "Santa Rita Do Sapuca�"
  },
  {
    "codigoTse": "51934",
    "ibgeCodigo": 3159704,
    "uf": "MG",
    "nome": "Santa Rosa Da Serra"
  },
  {
    "codigoTse": "51950",
    "ibgeCodigo": 3159803,
    "uf": "MG",
    "nome": "Santa Vit�ria"
  },
  {
    "codigoTse": "51977",
    "ibgeCodigo": 3159902,
    "uf": "MG",
    "nome": "Santo Ant�nio Do Amparo"
  },
  {
    "codigoTse": "51993",
    "ibgeCodigo": 3160009,
    "uf": "MG",
    "nome": "Santo Ant�nio Do Aventureiro"
  },
  {
    "codigoTse": "52019",
    "ibgeCodigo": 3160108,
    "uf": "MG",
    "nome": "Santo Ant�nio Do Grama"
  },
  {
    "codigoTse": "52035",
    "ibgeCodigo": 3160207,
    "uf": "MG",
    "nome": "Santo Ant�nio Do Itamb�"
  },
  {
    "codigoTse": "52051",
    "ibgeCodigo": 3160306,
    "uf": "MG",
    "nome": "Santo Ant�nio Do Jacinto"
  },
  {
    "codigoTse": "52078",
    "ibgeCodigo": 3160405,
    "uf": "MG",
    "nome": "Santo Ant�nio Do Monte"
  },
  {
    "codigoTse": "52094",
    "ibgeCodigo": 3160504,
    "uf": "MG",
    "nome": "Santo Ant�nio Do Rio Abaixo"
  },
  {
    "codigoTse": "52116",
    "ibgeCodigo": 3160603,
    "uf": "MG",
    "nome": "Santo Hip�lito"
  },
  {
    "codigoTse": "52132",
    "ibgeCodigo": 3160702,
    "uf": "MG",
    "nome": "Santos Dumont"
  },
  {
    "codigoTse": "52159",
    "ibgeCodigo": 3160801,
    "uf": "MG",
    "nome": "S�o Bento Abade"
  },
  {
    "codigoTse": "52175",
    "ibgeCodigo": 3160900,
    "uf": "MG",
    "nome": "S�o Br�s Do Sua�u�"
  },
  {
    "codigoTse": "52191",
    "ibgeCodigo": 3161007,
    "uf": "MG",
    "nome": "S�o Domingos Do Prata"
  },
  {
    "codigoTse": "52213",
    "ibgeCodigo": 3161106,
    "uf": "MG",
    "nome": "S�o Francisco"
  },
  {
    "codigoTse": "52230",
    "ibgeCodigo": 3161205,
    "uf": "MG",
    "nome": "S�o Francisco De Paula"
  },
  {
    "codigoTse": "52256",
    "ibgeCodigo": 3161304,
    "uf": "MG",
    "nome": "S�o Francisco De Sales"
  },
  {
    "codigoTse": "52272",
    "ibgeCodigo": 3161403,
    "uf": "MG",
    "nome": "S�o Francisco Do Gl�ria"
  },
  {
    "codigoTse": "52299",
    "ibgeCodigo": 3161502,
    "uf": "MG",
    "nome": "S�o Geraldo"
  },
  {
    "codigoTse": "52310",
    "ibgeCodigo": 3161601,
    "uf": "MG",
    "nome": "S�o Geraldo Da Piedade"
  },
  {
    "codigoTse": "52337",
    "ibgeCodigo": 3161700,
    "uf": "MG",
    "nome": "S�o Gon�alo Do Abaet�"
  },
  {
    "codigoTse": "52353",
    "ibgeCodigo": 3161809,
    "uf": "MG",
    "nome": "S�o Gon�alo Do Par�"
  },
  {
    "codigoTse": "52370",
    "ibgeCodigo": 3161908,
    "uf": "MG",
    "nome": "S�o Gon�alo Do Rio Abaixo"
  },
  {
    "codigoTse": "52396",
    "ibgeCodigo": 3162005,
    "uf": "MG",
    "nome": "S�o Gon�alo Do Sapuca�"
  },
  {
    "codigoTse": "52418",
    "ibgeCodigo": 3162104,
    "uf": "MG",
    "nome": "S�o Gotardo"
  },
  {
    "codigoTse": "52434",
    "ibgeCodigo": 3162203,
    "uf": "MG",
    "nome": "S�o Jo�o Batista Do Gl�ria"
  },
  {
    "codigoTse": "52450",
    "ibgeCodigo": 3162302,
    "uf": "MG",
    "nome": "S�o Jo�o Da Mata"
  },
  {
    "codigoTse": "52477",
    "ibgeCodigo": 3162401,
    "uf": "MG",
    "nome": "S�o Jo�o Da Ponte"
  },
  {
    "codigoTse": "52493",
    "ibgeCodigo": 3162500,
    "uf": "MG",
    "nome": "S�o Jo�o Del Rei"
  },
  {
    "codigoTse": "52515",
    "ibgeCodigo": 3162609,
    "uf": "MG",
    "nome": "S�o Jo�o Do Oriente"
  },
  {
    "codigoTse": "52531",
    "ibgeCodigo": 3162708,
    "uf": "MG",
    "nome": "S�o Jo�o Do Para�so"
  },
  {
    "codigoTse": "52558",
    "ibgeCodigo": 3162807,
    "uf": "MG",
    "nome": "S�o Jo�o Evangelista"
  },
  {
    "codigoTse": "52574",
    "ibgeCodigo": 3162906,
    "uf": "MG",
    "nome": "S�o Jo�o Nepomuceno"
  },
  {
    "codigoTse": "52590",
    "ibgeCodigo": 3163003,
    "uf": "MG",
    "nome": "S�o Jos� Da Safira"
  },
  {
    "codigoTse": "52612",
    "ibgeCodigo": 3163102,
    "uf": "MG",
    "nome": "S�o Jos� Da Varginha"
  },
  {
    "codigoTse": "52639",
    "ibgeCodigo": 3163201,
    "uf": "MG",
    "nome": "S�o Jos� Do Alegre"
  },
  {
    "codigoTse": "52655",
    "ibgeCodigo": 3163300,
    "uf": "MG",
    "nome": "S�o Jos� Do Divino"
  },
  {
    "codigoTse": "52671",
    "ibgeCodigo": 3163409,
    "uf": "MG",
    "nome": "S�o Jos� Do Goiabal"
  },
  {
    "codigoTse": "52698",
    "ibgeCodigo": 3163508,
    "uf": "MG",
    "nome": "S�o Jos� Do Jacuri"
  },
  {
    "codigoTse": "52710",
    "ibgeCodigo": 3163607,
    "uf": "MG",
    "nome": "S�o Jos� Do Mantimento"
  },
  {
    "codigoTse": "52736",
    "ibgeCodigo": 3163706,
    "uf": "MG",
    "nome": "S�o Louren�o"
  },
  {
    "codigoTse": "52752",
    "ibgeCodigo": 3163805,
    "uf": "MG",
    "nome": "S�o Miguel Do Anta"
  },
  {
    "codigoTse": "52779",
    "ibgeCodigo": 3163904,
    "uf": "MG",
    "nome": "S�o Pedro Da Uni�o"
  },
  {
    "codigoTse": "52795",
    "ibgeCodigo": 3164001,
    "uf": "MG",
    "nome": "S�o Pedro Dos Ferros"
  },
  {
    "codigoTse": "52817",
    "ibgeCodigo": 3164100,
    "uf": "MG",
    "nome": "S�o Pedro Do Sua�u�"
  },
  {
    "codigoTse": "52833",
    "ibgeCodigo": 3164209,
    "uf": "MG",
    "nome": "S�o Rom�o"
  },
  {
    "codigoTse": "52850",
    "ibgeCodigo": 3164308,
    "uf": "MG",
    "nome": "S�o Roque De Minas"
  },
  {
    "codigoTse": "52876",
    "ibgeCodigo": 3164407,
    "uf": "MG",
    "nome": "S�o Sebasti�o Da Bela Vista"
  },
  {
    "codigoTse": "52892",
    "ibgeCodigo": 3164506,
    "uf": "MG",
    "nome": "S�o Sebasti�o Do Maranh�o"
  },
  {
    "codigoTse": "52914",
    "ibgeCodigo": 3164605,
    "uf": "MG",
    "nome": "S�o Sebasti�o Do Oeste"
  },
  {
    "codigoTse": "52930",
    "ibgeCodigo": 3164704,
    "uf": "MG",
    "nome": "S�o Sebasti�o Do Para�so"
  },
  {
    "codigoTse": "52957",
    "ibgeCodigo": 3164803,
    "uf": "MG",
    "nome": "S�o Sebasti�o Do Rio Preto"
  },
  {
    "codigoTse": "52973",
    "ibgeCodigo": 3164902,
    "uf": "MG",
    "nome": "S�o Sebasti�o Do Rio Verde"
  },
  {
    "codigoTse": "52990",
    "ibgeCodigo": 3165008,
    "uf": "MG",
    "nome": "S�o Tiago"
  },
  {
    "codigoTse": "53015",
    "ibgeCodigo": 3165107,
    "uf": "MG",
    "nome": "S�o Tom�s De Aquino"
  },
  {
    "codigoTse": "53031",
    "ibgeCodigo": 3165206,
    "uf": "MG",
    "nome": "S�o Thom� Das Letras"
  },
  {
    "codigoTse": "53058",
    "ibgeCodigo": 3165305,
    "uf": "MG",
    "nome": "S�o Vicente De Minas"
  },
  {
    "codigoTse": "53074",
    "ibgeCodigo": 3165404,
    "uf": "MG",
    "nome": "Sapuca�-Mirim"
  },
  {
    "codigoTse": "53090",
    "ibgeCodigo": 3165503,
    "uf": "MG",
    "nome": "Sardo�"
  },
  {
    "codigoTse": "53112",
    "ibgeCodigo": 3165602,
    "uf": "MG",
    "nome": "Senador Cortes"
  },
  {
    "codigoTse": "53139",
    "ibgeCodigo": 3165701,
    "uf": "MG",
    "nome": "Senador Firmino"
  },
  {
    "codigoTse": "53155",
    "ibgeCodigo": 3165800,
    "uf": "MG",
    "nome": "Senador Jos� Bento"
  },
  {
    "codigoTse": "53171",
    "ibgeCodigo": 3165909,
    "uf": "MG",
    "nome": "Senador Modestino Gon�alves"
  },
  {
    "codigoTse": "53198",
    "ibgeCodigo": 3166006,
    "uf": "MG",
    "nome": "Senhora De Oliveira"
  },
  {
    "codigoTse": "53210",
    "ibgeCodigo": 3166105,
    "uf": "MG",
    "nome": "Senhora Do Porto"
  },
  {
    "codigoTse": "53236",
    "ibgeCodigo": 3166204,
    "uf": "MG",
    "nome": "Senhora Dos Rem�dios"
  },
  {
    "codigoTse": "53252",
    "ibgeCodigo": 3166303,
    "uf": "MG",
    "nome": "Sericita"
  },
  {
    "codigoTse": "53279",
    "ibgeCodigo": 3166402,
    "uf": "MG",
    "nome": "Seritinga"
  },
  {
    "codigoTse": "53295",
    "ibgeCodigo": 3166501,
    "uf": "MG",
    "nome": "Serra Azul De Minas"
  },
  {
    "codigoTse": "53317",
    "ibgeCodigo": 3166600,
    "uf": "MG",
    "nome": "Serra Da Saudade"
  },
  {
    "codigoTse": "53333",
    "ibgeCodigo": 3166709,
    "uf": "MG",
    "nome": "Serra Dos Aimor�s"
  },
  {
    "codigoTse": "53350",
    "ibgeCodigo": 3166808,
    "uf": "MG",
    "nome": "Serra Do Salitre"
  },
  {
    "codigoTse": "53376",
    "ibgeCodigo": 3166907,
    "uf": "MG",
    "nome": "Serrania"
  },
  {
    "codigoTse": "53392",
    "ibgeCodigo": 3167004,
    "uf": "MG",
    "nome": "Serranos"
  },
  {
    "codigoTse": "53414",
    "ibgeCodigo": 3167103,
    "uf": "MG",
    "nome": "Serro"
  },
  {
    "codigoTse": "53430",
    "ibgeCodigo": 3167202,
    "uf": "MG",
    "nome": "Sete Lagoas"
  },
  {
    "codigoTse": "53457",
    "ibgeCodigo": 3167301,
    "uf": "MG",
    "nome": "Silveir�nia"
  },
  {
    "codigoTse": "53473",
    "ibgeCodigo": 3167400,
    "uf": "MG",
    "nome": "Silvian�polis"
  },
  {
    "codigoTse": "53490",
    "ibgeCodigo": 3167509,
    "uf": "MG",
    "nome": "Sim�o Pereira"
  },
  {
    "codigoTse": "53511",
    "ibgeCodigo": 3167608,
    "uf": "MG",
    "nome": "Simon�sia"
  },
  {
    "codigoTse": "53538",
    "ibgeCodigo": 3167707,
    "uf": "MG",
    "nome": "Sobr�lia"
  },
  {
    "codigoTse": "53554",
    "ibgeCodigo": 3167806,
    "uf": "MG",
    "nome": "Soledade De Minas"
  },
  {
    "codigoTse": "53570",
    "ibgeCodigo": 3167905,
    "uf": "MG",
    "nome": "Tabuleiro"
  },
  {
    "codigoTse": "53597",
    "ibgeCodigo": 3168002,
    "uf": "MG",
    "nome": "Taiobeiras"
  },
  {
    "codigoTse": "53619",
    "ibgeCodigo": 3168101,
    "uf": "MG",
    "nome": "Tapira"
  },
  {
    "codigoTse": "53635",
    "ibgeCodigo": 3168200,
    "uf": "MG",
    "nome": "Tapira�"
  },
  {
    "codigoTse": "53651",
    "ibgeCodigo": 3168309,
    "uf": "MG",
    "nome": "Taquara�u De Minas"
  },
  {
    "codigoTse": "53678",
    "ibgeCodigo": 3168408,
    "uf": "MG",
    "nome": "Tarumirim"
  },
  {
    "codigoTse": "53694",
    "ibgeCodigo": 3168507,
    "uf": "MG",
    "nome": "Teixeiras"
  },
  {
    "codigoTse": "53716",
    "ibgeCodigo": 3168606,
    "uf": "MG",
    "nome": "Te�filo Otoni"
  },
  {
    "codigoTse": "53732",
    "ibgeCodigo": 3168705,
    "uf": "MG",
    "nome": "Tim�teo"
  },
  {
    "codigoTse": "53759",
    "ibgeCodigo": 3168804,
    "uf": "MG",
    "nome": "Tiradentes"
  },
  {
    "codigoTse": "53775",
    "ibgeCodigo": 3168903,
    "uf": "MG",
    "nome": "Tiros"
  },
  {
    "codigoTse": "53791",
    "ibgeCodigo": 3169000,
    "uf": "MG",
    "nome": "Tocantins"
  },
  {
    "codigoTse": "53813",
    "ibgeCodigo": 3169109,
    "uf": "MG",
    "nome": "Toledo"
  },
  {
    "codigoTse": "53830",
    "ibgeCodigo": 3169208,
    "uf": "MG",
    "nome": "Tombos"
  },
  {
    "codigoTse": "53856",
    "ibgeCodigo": 3169307,
    "uf": "MG",
    "nome": "Tr�s Cora��es"
  },
  {
    "codigoTse": "53872",
    "ibgeCodigo": 3169406,
    "uf": "MG",
    "nome": "Tr�s Pontas"
  },
  {
    "codigoTse": "53899",
    "ibgeCodigo": 3169505,
    "uf": "MG",
    "nome": "Tumiritinga"
  },
  {
    "codigoTse": "53910",
    "ibgeCodigo": 3169604,
    "uf": "MG",
    "nome": "Tupaciguara"
  },
  {
    "codigoTse": "53937",
    "ibgeCodigo": 3169703,
    "uf": "MG",
    "nome": "Turmalina"
  },
  {
    "codigoTse": "53953",
    "ibgeCodigo": 3169802,
    "uf": "MG",
    "nome": "Turvol�ndia"
  },
  {
    "codigoTse": "53970",
    "ibgeCodigo": 3169901,
    "uf": "MG",
    "nome": "Ub�"
  },
  {
    "codigoTse": "53996",
    "ibgeCodigo": 3170008,
    "uf": "MG",
    "nome": "Uba�"
  },
  {
    "codigoTse": "54011",
    "ibgeCodigo": 3170107,
    "uf": "MG",
    "nome": "Uberaba"
  },
  {
    "codigoTse": "54038",
    "ibgeCodigo": 3170206,
    "uf": "MG",
    "nome": "Uberl�ndia"
  },
  {
    "codigoTse": "54054",
    "ibgeCodigo": 3170305,
    "uf": "MG",
    "nome": "Umburatiba"
  },
  {
    "codigoTse": "54070",
    "ibgeCodigo": 3170404,
    "uf": "MG",
    "nome": "Una�"
  },
  {
    "codigoTse": "54097",
    "ibgeCodigo": 3170503,
    "uf": "MG",
    "nome": "Uruc�nia"
  },
  {
    "codigoTse": "54119",
    "ibgeCodigo": 3170602,
    "uf": "MG",
    "nome": "Vargem Bonita"
  },
  {
    "codigoTse": "54135",
    "ibgeCodigo": 3170701,
    "uf": "MG",
    "nome": "Varginha"
  },
  {
    "codigoTse": "54151",
    "ibgeCodigo": 3170800,
    "uf": "MG",
    "nome": "V�rzea Da Palma"
  },
  {
    "codigoTse": "54178",
    "ibgeCodigo": 3170909,
    "uf": "MG",
    "nome": "Varzel�ndia"
  },
  {
    "codigoTse": "54194",
    "ibgeCodigo": 3171006,
    "uf": "MG",
    "nome": "Vazante"
  },
  {
    "codigoTse": "54216",
    "ibgeCodigo": 3172202,
    "uf": "MG",
    "nome": "Wenceslau Braz"
  },
  {
    "codigoTse": "54232",
    "ibgeCodigo": 3171105,
    "uf": "MG",
    "nome": "Ver�ssimo"
  },
  {
    "codigoTse": "54259",
    "ibgeCodigo": 3171204,
    "uf": "MG",
    "nome": "Vespasiano"
  },
  {
    "codigoTse": "54275",
    "ibgeCodigo": 3171303,
    "uf": "MG",
    "nome": "Vi�osa"
  },
  {
    "codigoTse": "54291",
    "ibgeCodigo": 3171402,
    "uf": "MG",
    "nome": "Vieiras"
  },
  {
    "codigoTse": "54313",
    "ibgeCodigo": 3171501,
    "uf": "MG",
    "nome": "Mathias Lobato"
  },
  {
    "codigoTse": "54330",
    "ibgeCodigo": 3171600,
    "uf": "MG",
    "nome": "Virgem Da Lapa"
  },
  {
    "codigoTse": "54356",
    "ibgeCodigo": 3171709,
    "uf": "MG",
    "nome": "Virg�nia"
  },
  {
    "codigoTse": "54372",
    "ibgeCodigo": 3171808,
    "uf": "MG",
    "nome": "Virgin�polis"
  },
  {
    "codigoTse": "54399",
    "ibgeCodigo": 3171907,
    "uf": "MG",
    "nome": "Virgol�ndia"
  },
  {
    "codigoTse": "54410",
    "ibgeCodigo": 3172004,
    "uf": "MG",
    "nome": "Visconde Do Rio Branco"
  },
  {
    "codigoTse": "54437",
    "ibgeCodigo": 3172103,
    "uf": "MG",
    "nome": "Volta Grande"
  },
  {
    "codigoTse": "54453",
    "ibgeCodigo": 3133758,
    "uf": "MG",
    "nome": "Ita� De Minas"
  },
  {
    "codigoTse": "55000",
    "ibgeCodigo": 5006002,
    "uf": "MS",
    "nome": "Nova Alvorada Do Sul"
  },
  {
    "codigoTse": "55018",
    "ibgeCodigo": 5000252,
    "uf": "MS",
    "nome": "Alcin�polis"
  },
  {
    "codigoTse": "55026",
    "ibgeCodigo": 5005251,
    "uf": "MS",
    "nome": "Laguna Carap�"
  },
  {
    "codigoTse": "55034",
    "ibgeCodigo": 5004809,
    "uf": "MS",
    "nome": "Japor�"
  },
  {
    "codigoTse": "55042",
    "ibgeCodigo": 5006259,
    "uf": "MS",
    "nome": "Novo Horizonte Do Sul"
  },
  {
    "codigoTse": "55050",
    "ibgeCodigo": 5006275,
    "uf": "MS",
    "nome": "Para�so Das �guas"
  },
  {
    "codigoTse": "55069",
    "ibgeCodigo": 5003900,
    "uf": "MS",
    "nome": "Figueir�o"
  },
  {
    "codigoTse": "56006",
    "ibgeCodigo": 3204658,
    "uf": "ES",
    "nome": "S�o Domingos Do Norte"
  },
  {
    "codigoTse": "56014",
    "ibgeCodigo": 3200102,
    "uf": "ES",
    "nome": "Afonso Cl�udio"
  },
  {
    "codigoTse": "56022",
    "ibgeCodigo": 3200169,
    "uf": "ES",
    "nome": "�gua Doce Do Norte"
  },
  {
    "codigoTse": "56030",
    "ibgeCodigo": 3200201,
    "uf": "ES",
    "nome": "Alegre"
  },
  {
    "codigoTse": "56049",
    "ibgeCodigo": 3202652,
    "uf": "ES",
    "nome": "Irupi"
  },
  {
    "codigoTse": "56057",
    "ibgeCodigo": 3200300,
    "uf": "ES",
    "nome": "Alfredo Chaves"
  },
  {
    "codigoTse": "56065",
    "ibgeCodigo": 3200359,
    "uf": "ES",
    "nome": "Alto Rio Novo"
  },
  {
    "codigoTse": "56073",
    "ibgeCodigo": 3200409,
    "uf": "ES",
    "nome": "Anchieta"
  },
  {
    "codigoTse": "56081",
    "ibgeCodigo": 3205150,
    "uf": "ES",
    "nome": "Vila Pav�o"
  },
  {
    "codigoTse": "56090",
    "ibgeCodigo": 3200508,
    "uf": "ES",
    "nome": "Apiac�"
  },
  {
    "codigoTse": "56103",
    "ibgeCodigo": 3203346,
    "uf": "ES",
    "nome": "Marechal Floriano"
  },
  {
    "codigoTse": "56111",
    "ibgeCodigo": 3200607,
    "uf": "ES",
    "nome": "Aracruz"
  },
  {
    "codigoTse": "56120",
    "ibgeCodigo": 3203320,
    "uf": "ES",
    "nome": "Marata�zes"
  },
  {
    "codigoTse": "56138",
    "ibgeCodigo": 3200706,
    "uf": "ES",
    "nome": "Atilio Vivacqua"
  },
  {
    "codigoTse": "56146",
    "ibgeCodigo": 3201159,
    "uf": "ES",
    "nome": "Brejetuba"
  },
  {
    "codigoTse": "56154",
    "ibgeCodigo": 3200805,
    "uf": "ES",
    "nome": "Baixo Guandu"
  },
  {
    "codigoTse": "56162",
    "ibgeCodigo": 3204955,
    "uf": "ES",
    "nome": "S�o Roque Do Cana�"
  },
  {
    "codigoTse": "56170",
    "ibgeCodigo": 3200904,
    "uf": "ES",
    "nome": "Barra De S�o Francisco"
  },
  {
    "codigoTse": "56189",
    "ibgeCodigo": 3205010,
    "uf": "ES",
    "nome": "Sooretama"
  },
  {
    "codigoTse": "56197",
    "ibgeCodigo": 3201001,
    "uf": "ES",
    "nome": "Boa Esperan�a"
  },
  {
    "codigoTse": "56200",
    "ibgeCodigo": 3204252,
    "uf": "ES",
    "nome": "Ponto Belo"
  },
  {
    "codigoTse": "56219",
    "ibgeCodigo": 3201100,
    "uf": "ES",
    "nome": "Bom Jesus Do Norte"
  },
  {
    "codigoTse": "56227",
    "ibgeCodigo": 3205176,
    "uf": "ES",
    "nome": "Vila Val�rio"
  },
  {
    "codigoTse": "56235",
    "ibgeCodigo": 3201209,
    "uf": "ES",
    "nome": "Cachoeiro De Itapemirim"
  },
  {
    "codigoTse": "56251",
    "ibgeCodigo": 3201308,
    "uf": "ES",
    "nome": "Cariacica"
  },
  {
    "codigoTse": "56278",
    "ibgeCodigo": 3201407,
    "uf": "ES",
    "nome": "Castelo"
  },
  {
    "codigoTse": "56294",
    "ibgeCodigo": 3201506,
    "uf": "ES",
    "nome": "Colatina"
  },
  {
    "codigoTse": "56308",
    "ibgeCodigo": 3202256,
    "uf": "ES",
    "nome": "Governador Lindenberg"
  },
  {
    "codigoTse": "56316",
    "ibgeCodigo": 3201605,
    "uf": "ES",
    "nome": "Concei��o Da Barra"
  },
  {
    "codigoTse": "56332",
    "ibgeCodigo": 3201704,
    "uf": "ES",
    "nome": "Concei��o Do Castelo"
  },
  {
    "codigoTse": "56359",
    "ibgeCodigo": 3201803,
    "uf": "ES",
    "nome": "Divino De S�o Louren�o"
  },
  {
    "codigoTse": "56375",
    "ibgeCodigo": 3201902,
    "uf": "ES",
    "nome": "Domingos Martins"
  },
  {
    "codigoTse": "56391",
    "ibgeCodigo": 3202009,
    "uf": "ES",
    "nome": "Dores Do Rio Preto"
  },
  {
    "codigoTse": "56413",
    "ibgeCodigo": 3202108,
    "uf": "ES",
    "nome": "Ecoporanga"
  },
  {
    "codigoTse": "56430",
    "ibgeCodigo": 3202207,
    "uf": "ES",
    "nome": "Fund�o"
  },
  {
    "codigoTse": "56456",
    "ibgeCodigo": 3202306,
    "uf": "ES",
    "nome": "Gua�u�"
  },
  {
    "codigoTse": "56472",
    "ibgeCodigo": 3202405,
    "uf": "ES",
    "nome": "Guarapari"
  },
  {
    "codigoTse": "56499",
    "ibgeCodigo": 3202504,
    "uf": "ES",
    "nome": "Ibira�u"
  },
  {
    "codigoTse": "56502",
    "ibgeCodigo": 3202553,
    "uf": "ES",
    "nome": "Ibitirama"
  },
  {
    "codigoTse": "56510",
    "ibgeCodigo": 3202603,
    "uf": "ES",
    "nome": "Iconha"
  },
  {
    "codigoTse": "56537",
    "ibgeCodigo": 3202702,
    "uf": "ES",
    "nome": "Itagua�u"
  },
  {
    "codigoTse": "56553",
    "ibgeCodigo": 3202801,
    "uf": "ES",
    "nome": "Itapemirim"
  },
  {
    "codigoTse": "56570",
    "ibgeCodigo": 3202900,
    "uf": "ES",
    "nome": "Itarana"
  },
  {
    "codigoTse": "56596",
    "ibgeCodigo": 3203007,
    "uf": "ES",
    "nome": "I�na"
  },
  {
    "codigoTse": "56618",
    "ibgeCodigo": 3203106,
    "uf": "ES",
    "nome": "Jer�nimo Monteiro"
  },
  {
    "codigoTse": "56626",
    "ibgeCodigo": 3203130,
    "uf": "ES",
    "nome": "Jo�o Neiva"
  },
  {
    "codigoTse": "56634",
    "ibgeCodigo": 3203205,
    "uf": "ES",
    "nome": "Linhares"
  },
  {
    "codigoTse": "56650",
    "ibgeCodigo": 3203304,
    "uf": "ES",
    "nome": "Manten�polis"
  },
  {
    "codigoTse": "56677",
    "ibgeCodigo": 3203403,
    "uf": "ES",
    "nome": "Mimoso Do Sul"
  },
  {
    "codigoTse": "56693",
    "ibgeCodigo": 3203502,
    "uf": "ES",
    "nome": "Montanha"
  },
  {
    "codigoTse": "56715",
    "ibgeCodigo": 3203601,
    "uf": "ES",
    "nome": "Mucurici"
  },
  {
    "codigoTse": "56731",
    "ibgeCodigo": 3203700,
    "uf": "ES",
    "nome": "Muniz Freire"
  },
  {
    "codigoTse": "56758",
    "ibgeCodigo": 3203809,
    "uf": "ES",
    "nome": "Muqui"
  },
  {
    "codigoTse": "56774",
    "ibgeCodigo": 3203908,
    "uf": "ES",
    "nome": "Nova Ven�cia"
  },
  {
    "codigoTse": "56790",
    "ibgeCodigo": 3204005,
    "uf": "ES",
    "nome": "Pancas"
  },
  {
    "codigoTse": "56812",
    "ibgeCodigo": 3204104,
    "uf": "ES",
    "nome": "Pinheiros"
  },
  {
    "codigoTse": "56839",
    "ibgeCodigo": 3204203,
    "uf": "ES",
    "nome": "Pi�ma"
  },
  {
    "codigoTse": "56855",
    "ibgeCodigo": 3204302,
    "uf": "ES",
    "nome": "Presidente Kennedy"
  },
  {
    "codigoTse": "56871",
    "ibgeCodigo": 3204401,
    "uf": "ES",
    "nome": "Rio Novo Do Sul"
  },
  {
    "codigoTse": "56898",
    "ibgeCodigo": 3204500,
    "uf": "ES",
    "nome": "Santa Leopoldina"
  },
  {
    "codigoTse": "56910",
    "ibgeCodigo": 3204609,
    "uf": "ES",
    "nome": "Santa Teresa"
  },
  {
    "codigoTse": "56936",
    "ibgeCodigo": 3204708,
    "uf": "ES",
    "nome": "S�o Gabriel Da Palha"
  },
  {
    "codigoTse": "56952",
    "ibgeCodigo": 3204807,
    "uf": "ES",
    "nome": "S�o Jos� Do Cal�ado"
  },
  {
    "codigoTse": "56979",
    "ibgeCodigo": 3204906,
    "uf": "ES",
    "nome": "S�o Mateus"
  },
  {
    "codigoTse": "56995",
    "ibgeCodigo": 3205002,
    "uf": "ES",
    "nome": "Serra"
  },
  {
    "codigoTse": "57010",
    "ibgeCodigo": 3205101,
    "uf": "ES",
    "nome": "Viana"
  },
  {
    "codigoTse": "57037",
    "ibgeCodigo": 3205200,
    "uf": "ES",
    "nome": "Vila Velha"
  },
  {
    "codigoTse": "57053",
    "ibgeCodigo": 3205309,
    "uf": "ES",
    "nome": "Vit�ria"
  },
  {
    "codigoTse": "57070",
    "ibgeCodigo": 3203353,
    "uf": "ES",
    "nome": "Maril�ndia"
  },
  {
    "codigoTse": "57096",
    "ibgeCodigo": 3202454,
    "uf": "ES",
    "nome": "Ibatiba"
  },
  {
    "codigoTse": "57118",
    "ibgeCodigo": 3204351,
    "uf": "ES",
    "nome": "Rio Bananal"
  },
  {
    "codigoTse": "57134",
    "ibgeCodigo": 3203056,
    "uf": "ES",
    "nome": "Jaguar�"
  },
  {
    "codigoTse": "57150",
    "ibgeCodigo": 3204054,
    "uf": "ES",
    "nome": "Pedro Can�rio"
  },
  {
    "codigoTse": "57916",
    "ibgeCodigo": 3203163,
    "uf": "ES",
    "nome": "Laranja Da Terra"
  },
  {
    "codigoTse": "57932",
    "ibgeCodigo": 3204559,
    "uf": "ES",
    "nome": "Santa Maria De Jetib�"
  },
  {
    "codigoTse": "57959",
    "ibgeCodigo": 3205036,
    "uf": "ES",
    "nome": "Vargem Alta"
  },
  {
    "codigoTse": "57975",
    "ibgeCodigo": 3205069,
    "uf": "ES",
    "nome": "Venda Nova Do Imigrante"
  },
  {
    "codigoTse": "57991",
    "ibgeCodigo": 3200136,
    "uf": "ES",
    "nome": "�guia Branca"
  },
  {
    "codigoTse": "58009",
    "ibgeCodigo": 3304151,
    "uf": "RJ",
    "nome": "Quissam�"
  },
  {
    "codigoTse": "58017",
    "ibgeCodigo": 3300100,
    "uf": "RJ",
    "nome": "Angra Dos Reis"
  },
  {
    "codigoTse": "58025",
    "ibgeCodigo": 3304128,
    "uf": "RJ",
    "nome": "Quatis"
  },
  {
    "codigoTse": "58033",
    "ibgeCodigo": 3300209,
    "uf": "RJ",
    "nome": "Araruama"
  },
  {
    "codigoTse": "58041",
    "ibgeCodigo": 3300456,
    "uf": "RJ",
    "nome": "Belford Roxo"
  },
  {
    "codigoTse": "58050",
    "ibgeCodigo": 3300308,
    "uf": "RJ",
    "nome": "Barra Do Pira�"
  },
  {
    "codigoTse": "58068",
    "ibgeCodigo": 3301157,
    "uf": "RJ",
    "nome": "Cardoso Moreira"
  },
  {
    "codigoTse": "58076",
    "ibgeCodigo": 3300407,
    "uf": "RJ",
    "nome": "Barra Mansa"
  },
  {
    "codigoTse": "58084",
    "ibgeCodigo": 3306156,
    "uf": "RJ",
    "nome": "Varre-Sai"
  },
  {
    "codigoTse": "58092",
    "ibgeCodigo": 3300506,
    "uf": "RJ",
    "nome": "Bom Jardim"
  },
  {
    "codigoTse": "58106",
    "ibgeCodigo": 3301850,
    "uf": "RJ",
    "nome": "Guapimirim"
  },
  {
    "codigoTse": "58114",
    "ibgeCodigo": 3300605,
    "uf": "RJ",
    "nome": "Bom Jesus Do Itabapoana"
  },
  {
    "codigoTse": "58122",
    "ibgeCodigo": 3304144,
    "uf": "RJ",
    "nome": "Queimados"
  },
  {
    "codigoTse": "58130",
    "ibgeCodigo": 3300704,
    "uf": "RJ",
    "nome": "Cabo Frio"
  },
  {
    "codigoTse": "58149",
    "ibgeCodigo": 3302270,
    "uf": "RJ",
    "nome": "Japeri"
  },
  {
    "codigoTse": "58157",
    "ibgeCodigo": 3300803,
    "uf": "RJ",
    "nome": "Cachoeiras De Macacu"
  },
  {
    "codigoTse": "58165",
    "ibgeCodigo": 3300951,
    "uf": "RJ",
    "nome": "Comendador Levy Gasparian"
  },
  {
    "codigoTse": "58173",
    "ibgeCodigo": 3300902,
    "uf": "RJ",
    "nome": "Cambuci"
  },
  {
    "codigoTse": "58181",
    "ibgeCodigo": 3300159,
    "uf": "RJ",
    "nome": "Aperib�"
  },
  {
    "codigoTse": "58190",
    "ibgeCodigo": 3301009,
    "uf": "RJ",
    "nome": "Campos Dos Goytacazes"
  },
  {
    "codigoTse": "58203",
    "ibgeCodigo": 3304524,
    "uf": "RJ",
    "nome": "Rio Das Ostras"
  },
  {
    "codigoTse": "58211",
    "ibgeCodigo": 3301108,
    "uf": "RJ",
    "nome": "Cantagalo"
  },
  {
    "codigoTse": "58220",
    "ibgeCodigo": 3300225,
    "uf": "RJ",
    "nome": "Areal"
  },
  {
    "codigoTse": "58238",
    "ibgeCodigo": 3301207,
    "uf": "RJ",
    "nome": "Carmo"
  },
  {
    "codigoTse": "58246",
    "ibgeCodigo": 3303955,
    "uf": "RJ",
    "nome": "Pinheiral"
  },
  {
    "codigoTse": "58254",
    "ibgeCodigo": 3301306,
    "uf": "RJ",
    "nome": "Casimiro De Abreu"
  },
  {
    "codigoTse": "58262",
    "ibgeCodigo": 3301876,
    "uf": "RJ",
    "nome": "Iguaba Grande"
  },
  {
    "codigoTse": "58270",
    "ibgeCodigo": 3301405,
    "uf": "RJ",
    "nome": "Concei��o De Macabu"
  },
  {
    "codigoTse": "58289",
    "ibgeCodigo": 3304755,
    "uf": "RJ",
    "nome": "S�o Francisco De Itabapoana"
  },
  {
    "codigoTse": "58297",
    "ibgeCodigo": 3301504,
    "uf": "RJ",
    "nome": "Cordeiro"
  },
  {
    "codigoTse": "58300",
    "ibgeCodigo": 3300936,
    "uf": "RJ",
    "nome": "Carapebus"
  },
  {
    "codigoTse": "58319",
    "ibgeCodigo": 3301603,
    "uf": "RJ",
    "nome": "Duas Barras"
  },
  {
    "codigoTse": "58327",
    "ibgeCodigo": 3304110,
    "uf": "RJ",
    "nome": "Porto Real"
  },
  {
    "codigoTse": "58335",
    "ibgeCodigo": 3301702,
    "uf": "RJ",
    "nome": "Duque De Caxias"
  },
  {
    "codigoTse": "58343",
    "ibgeCodigo": 3305133,
    "uf": "RJ",
    "nome": "S�o Jos� De Ub�"
  },
  {
    "codigoTse": "58351",
    "ibgeCodigo": 3301801,
    "uf": "RJ",
    "nome": "Engenheiro Paulo De Frontin"
  },
  {
    "codigoTse": "58360",
    "ibgeCodigo": 3305752,
    "uf": "RJ",
    "nome": "Tangu�"
  },
  {
    "codigoTse": "58378",
    "ibgeCodigo": 3301900,
    "uf": "RJ",
    "nome": "Itabora�"
  },
  {
    "codigoTse": "58386",
    "ibgeCodigo": 3302452,
    "uf": "RJ",
    "nome": "Macuco"
  },
  {
    "codigoTse": "58394",
    "ibgeCodigo": 3302007,
    "uf": "RJ",
    "nome": "Itagua�"
  },
  {
    "codigoTse": "58408",
    "ibgeCodigo": 3300233,
    "uf": "RJ",
    "nome": "Arma��o Dos B�zios"
  },
  {
    "codigoTse": "58416",
    "ibgeCodigo": 3302106,
    "uf": "RJ",
    "nome": "Itaocara"
  },
  {
    "codigoTse": "58424",
    "ibgeCodigo": 3305554,
    "uf": "RJ",
    "nome": "Serop�dica"
  },
  {
    "codigoTse": "58432",
    "ibgeCodigo": 3302205,
    "uf": "RJ",
    "nome": "Itaperuna"
  },
  {
    "codigoTse": "58440",
    "ibgeCodigo": 3302254,
    "uf": "RJ",
    "nome": "Itatiaia"
  },
  {
    "codigoTse": "58459",
    "ibgeCodigo": 3302304,
    "uf": "RJ",
    "nome": "Laje Do Muria�"
  },
  {
    "codigoTse": "58467",
    "ibgeCodigo": 3302858,
    "uf": "RJ",
    "nome": "Mesquita"
  },
  {
    "codigoTse": "58475",
    "ibgeCodigo": 3302403,
    "uf": "RJ",
    "nome": "Maca�"
  },
  {
    "codigoTse": "58491",
    "ibgeCodigo": 3302502,
    "uf": "RJ",
    "nome": "Mag�"
  },
  {
    "codigoTse": "58513",
    "ibgeCodigo": 3302601,
    "uf": "RJ",
    "nome": "Mangaratiba"
  },
  {
    "codigoTse": "58530",
    "ibgeCodigo": 3302700,
    "uf": "RJ",
    "nome": "Maric�"
  },
  {
    "codigoTse": "58556",
    "ibgeCodigo": 3302809,
    "uf": "RJ",
    "nome": "Mendes"
  },
  {
    "codigoTse": "58572",
    "ibgeCodigo": 3302908,
    "uf": "RJ",
    "nome": "Miguel Pereira"
  },
  {
    "codigoTse": "58599",
    "ibgeCodigo": 3303005,
    "uf": "RJ",
    "nome": "Miracema"
  },
  {
    "codigoTse": "58610",
    "ibgeCodigo": 3303104,
    "uf": "RJ",
    "nome": "Natividade"
  },
  {
    "codigoTse": "58637",
    "ibgeCodigo": 3303203,
    "uf": "RJ",
    "nome": "Nil�polis"
  },
  {
    "codigoTse": "58653",
    "ibgeCodigo": 3303302,
    "uf": "RJ",
    "nome": "Niter�i"
  },
  {
    "codigoTse": "58670",
    "ibgeCodigo": 3303401,
    "uf": "RJ",
    "nome": "Nova Friburgo"
  },
  {
    "codigoTse": "58696",
    "ibgeCodigo": 3303500,
    "uf": "RJ",
    "nome": "Nova Igua�u"
  },
  {
    "codigoTse": "58718",
    "ibgeCodigo": 3303609,
    "uf": "RJ",
    "nome": "Paracambi"
  },
  {
    "codigoTse": "58734",
    "ibgeCodigo": 3303708,
    "uf": "RJ",
    "nome": "Para�ba Do Sul"
  },
  {
    "codigoTse": "58750",
    "ibgeCodigo": 3303807,
    "uf": "RJ",
    "nome": "Parati"
  },
  {
    "codigoTse": "58777",
    "ibgeCodigo": 3303906,
    "uf": "RJ",
    "nome": "Petr�polis"
  },
  {
    "codigoTse": "58793",
    "ibgeCodigo": 3304003,
    "uf": "RJ",
    "nome": "Pira�"
  },
  {
    "codigoTse": "58815",
    "ibgeCodigo": 3304102,
    "uf": "RJ",
    "nome": "Porci�ncula"
  },
  {
    "codigoTse": "58831",
    "ibgeCodigo": 3304201,
    "uf": "RJ",
    "nome": "Resende"
  },
  {
    "codigoTse": "58858",
    "ibgeCodigo": 3304300,
    "uf": "RJ",
    "nome": "Rio Bonito"
  },
  {
    "codigoTse": "58874",
    "ibgeCodigo": 3304409,
    "uf": "RJ",
    "nome": "Rio Claro"
  },
  {
    "codigoTse": "58890",
    "ibgeCodigo": 3304508,
    "uf": "RJ",
    "nome": "Rio Das Flores"
  },
  {
    "codigoTse": "58912",
    "ibgeCodigo": 3304607,
    "uf": "RJ",
    "nome": "Santa Maria Madalena"
  },
  {
    "codigoTse": "58939",
    "ibgeCodigo": 3304706,
    "uf": "RJ",
    "nome": "Santo Ant�nio De P�dua"
  },
  {
    "codigoTse": "58955",
    "ibgeCodigo": 3304805,
    "uf": "RJ",
    "nome": "S�o Fid�lis"
  },
  {
    "codigoTse": "58971",
    "ibgeCodigo": 3304904,
    "uf": "RJ",
    "nome": "S�o Gon�alo"
  },
  {
    "codigoTse": "58998",
    "ibgeCodigo": 3305000,
    "uf": "RJ",
    "nome": "S�o Jo�o Da Barra"
  },
  {
    "codigoTse": "59013",
    "ibgeCodigo": 3305109,
    "uf": "RJ",
    "nome": "S�o Jo�o De Meriti"
  },
  {
    "codigoTse": "59030",
    "ibgeCodigo": 3305208,
    "uf": "RJ",
    "nome": "S�o Pedro Da Aldeia"
  },
  {
    "codigoTse": "59056",
    "ibgeCodigo": 3305307,
    "uf": "RJ",
    "nome": "S�o Sebasti�o Do Alto"
  },
  {
    "codigoTse": "59072",
    "ibgeCodigo": 3305406,
    "uf": "RJ",
    "nome": "Sapucaia"
  },
  {
    "codigoTse": "59099",
    "ibgeCodigo": 3305505,
    "uf": "RJ",
    "nome": "Saquarema"
  },
  {
    "codigoTse": "59110",
    "ibgeCodigo": 3305604,
    "uf": "RJ",
    "nome": "Silva Jardim"
  },
  {
    "codigoTse": "59137",
    "ibgeCodigo": 3305703,
    "uf": "RJ",
    "nome": "Sumidouro"
  },
  {
    "codigoTse": "59153",
    "ibgeCodigo": 3305802,
    "uf": "RJ",
    "nome": "Teres�polis"
  },
  {
    "codigoTse": "59170",
    "ibgeCodigo": 3305901,
    "uf": "RJ",
    "nome": "Trajano De Moraes"
  },
  {
    "codigoTse": "59196",
    "ibgeCodigo": 3306008,
    "uf": "RJ",
    "nome": "Tr�s Rios"
  },
  {
    "codigoTse": "59218",
    "ibgeCodigo": 3306107,
    "uf": "RJ",
    "nome": "Valen�a"
  },
  {
    "codigoTse": "59234",
    "ibgeCodigo": 3306206,
    "uf": "RJ",
    "nome": "Vassouras"
  },
  {
    "codigoTse": "59250",
    "ibgeCodigo": 3306305,
    "uf": "RJ",
    "nome": "Volta Redonda"
  },
  {
    "codigoTse": "59277",
    "ibgeCodigo": 3300258,
    "uf": "RJ",
    "nome": "Arraial Do Cabo"
  },
  {
    "codigoTse": "59293",
    "ibgeCodigo": 3302056,
    "uf": "RJ",
    "nome": "Italva"
  },
  {
    "codigoTse": "59315",
    "ibgeCodigo": 3303856,
    "uf": "RJ",
    "nome": "Paty Do Alferes"
  },
  {
    "codigoTse": "59331",
    "ibgeCodigo": 3305158,
    "uf": "RJ",
    "nome": "S�o Jos� Do Vale Do Rio Preto"
  },
  {
    "codigoTse": "60011",
    "ibgeCodigo": 3304557,
    "uf": "RJ",
    "nome": "Rio De Janeiro"
  },
  {
    "codigoTse": "61000",
    "ibgeCodigo": 3515350,
    "uf": "SP",
    "nome": "Euclides Da Cunha Paulista"
  },
  {
    "codigoTse": "61018",
    "ibgeCodigo": 3500105,
    "uf": "SP",
    "nome": "Adamantina"
  },
  {
    "codigoTse": "61026",
    "ibgeCodigo": 3507456,
    "uf": "SP",
    "nome": "Borebi"
  },
  {
    "codigoTse": "61034",
    "ibgeCodigo": 3500204,
    "uf": "SP",
    "nome": "Adolfo"
  },
  {
    "codigoTse": "61042",
    "ibgeCodigo": 3553955,
    "uf": "SP",
    "nome": "Tarum�"
  },
  {
    "codigoTse": "61050",
    "ibgeCodigo": 3500303,
    "uf": "SP",
    "nome": "Agua�"
  },
  {
    "codigoTse": "61069",
    "ibgeCodigo": 3532058,
    "uf": "SP",
    "nome": "Motuca"
  },
  {
    "codigoTse": "61077",
    "ibgeCodigo": 3500402,
    "uf": "SP",
    "nome": "�guas Da Prata"
  },
  {
    "codigoTse": "61085",
    "ibgeCodigo": 3519253,
    "uf": "SP",
    "nome": "Iaras"
  },
  {
    "codigoTse": "61093",
    "ibgeCodigo": 3500501,
    "uf": "SP",
    "nome": "�guas De Lind�ia"
  },
  {
    "codigoTse": "61107",
    "ibgeCodigo": 3518859,
    "uf": "SP",
    "nome": "Guatapar�"
  },
  {
    "codigoTse": "61115",
    "ibgeCodigo": 3500600,
    "uf": "SP",
    "nome": "�guas De S�o Pedro"
  },
  {
    "codigoTse": "61123",
    "ibgeCodigo": 3513850,
    "uf": "SP",
    "nome": "Dirce Reis"
  },
  {
    "codigoTse": "61131",
    "ibgeCodigo": 3500709,
    "uf": "SP",
    "nome": "Agudos"
  },
  {
    "codigoTse": "61140",
    "ibgeCodigo": 3515194,
    "uf": "SP",
    "nome": "Esp�rito Santo Do Turvo"
  },
  {
    "codigoTse": "61158",
    "ibgeCodigo": 3500808,
    "uf": "SP",
    "nome": "Alfredo Marcondes"
  },
  {
    "codigoTse": "61166",
    "ibgeCodigo": 3544251,
    "uf": "SP",
    "nome": "Rosana"
  },
  {
    "codigoTse": "61174",
    "ibgeCodigo": 3500907,
    "uf": "SP",
    "nome": "Altair"
  },
  {
    "codigoTse": "61182",
    "ibgeCodigo": 3514957,
    "uf": "SP",
    "nome": "Emba�ba"
  },
  {
    "codigoTse": "61190",
    "ibgeCodigo": 3501004,
    "uf": "SP",
    "nome": "Altin�polis"
  },
  {
    "codigoTse": "61204",
    "ibgeCodigo": 3520442,
    "uf": "SP",
    "nome": "Ilha Solteira"
  },
  {
    "codigoTse": "61212",
    "ibgeCodigo": 3501103,
    "uf": "SP",
    "nome": "Alto Alegre"
  },
  {
    "codigoTse": "61220",
    "ibgeCodigo": 3501152,
    "uf": "SP",
    "nome": "Alum�nio"
  },
  {
    "codigoTse": "61239",
    "ibgeCodigo": 3501202,
    "uf": "SP",
    "nome": "�lvares Florence"
  },
  {
    "codigoTse": "61247",
    "ibgeCodigo": 3537156,
    "uf": "SP",
    "nome": "Pedrinhas Paulista"
  },
  {
    "codigoTse": "61255",
    "ibgeCodigo": 3501301,
    "uf": "SP",
    "nome": "�lvares Machado"
  },
  {
    "codigoTse": "61263",
    "ibgeCodigo": 3502754,
    "uf": "SP",
    "nome": "Ara�ariguama"
  },
  {
    "codigoTse": "61271",
    "ibgeCodigo": 3501400,
    "uf": "SP",
    "nome": "�lvaro De Carvalho"
  },
  {
    "codigoTse": "61280",
    "ibgeCodigo": 3506359,
    "uf": "SP",
    "nome": "Bertioga"
  },
  {
    "codigoTse": "61298",
    "ibgeCodigo": 3501509,
    "uf": "SP",
    "nome": "Alvinl�ndia"
  },
  {
    "codigoTse": "61301",
    "ibgeCodigo": 3552551,
    "uf": "SP",
    "nome": "Suzan�polis"
  },
  {
    "codigoTse": "61310",
    "ibgeCodigo": 3501608,
    "uf": "SP",
    "nome": "Americana"
  },
  {
    "codigoTse": "61328",
    "ibgeCodigo": 3548054,
    "uf": "SP",
    "nome": "Santo Ant�nio Do Aracangu�"
  },
  {
    "codigoTse": "61336",
    "ibgeCodigo": 3501707,
    "uf": "SP",
    "nome": "Am�rico Brasiliense"
  },
  {
    "codigoTse": "61344",
    "ibgeCodigo": 3510153,
    "uf": "SP",
    "nome": "Canitar"
  },
  {
    "codigoTse": "61352",
    "ibgeCodigo": 3501806,
    "uf": "SP",
    "nome": "Am�rico De Campos"
  },
  {
    "codigoTse": "61360",
    "ibgeCodigo": 3505351,
    "uf": "SP",
    "nome": "Barra Do Chap�u"
  },
  {
    "codigoTse": "61379",
    "ibgeCodigo": 3501905,
    "uf": "SP",
    "nome": "Amparo"
  },
  {
    "codigoTse": "61387",
    "ibgeCodigo": 3515129,
    "uf": "SP",
    "nome": "Emilian�polis"
  },
  {
    "codigoTse": "61395",
    "ibgeCodigo": 3502002,
    "uf": "SP",
    "nome": "Anal�ndia"
  },
  {
    "codigoTse": "61409",
    "ibgeCodigo": 3533254,
    "uf": "SP",
    "nome": "Novais"
  },
  {
    "codigoTse": "61417",
    "ibgeCodigo": 3502101,
    "uf": "SP",
    "nome": "Andradina"
  },
  {
    "codigoTse": "61425",
    "ibgeCodigo": 3532843,
    "uf": "SP",
    "nome": "Nova Cana� Paulista"
  },
  {
    "codigoTse": "61433",
    "ibgeCodigo": 3502200,
    "uf": "SP",
    "nome": "Angatuba"
  },
  {
    "codigoTse": "61441",
    "ibgeCodigo": 3545159,
    "uf": "SP",
    "nome": "Saltinho"
  },
  {
    "codigoTse": "61450",
    "ibgeCodigo": 3502309,
    "uf": "SP",
    "nome": "Anhembi"
  },
  {
    "codigoTse": "61468",
    "ibgeCodigo": 3555356,
    "uf": "SP",
    "nome": "Ubarana"
  },
  {
    "codigoTse": "61476",
    "ibgeCodigo": 3502408,
    "uf": "SP",
    "nome": "Anhumas"
  },
  {
    "codigoTse": "61484",
    "ibgeCodigo": 3509254,
    "uf": "SP",
    "nome": "Cajati"
  },
  {
    "codigoTse": "61492",
    "ibgeCodigo": 3502507,
    "uf": "SP",
    "nome": "Aparecida"
  },
  {
    "codigoTse": "61506",
    "ibgeCodigo": 3509452,
    "uf": "SP",
    "nome": "Campina Do Monte Alegre"
  },
  {
    "codigoTse": "61514",
    "ibgeCodigo": 3502606,
    "uf": "SP",
    "nome": "Aparecida D'Oeste"
  },
  {
    "codigoTse": "61522",
    "ibgeCodigo": 3503950,
    "uf": "SP",
    "nome": "Asp�sia"
  },
  {
    "codigoTse": "61530",
    "ibgeCodigo": 3502705,
    "uf": "SP",
    "nome": "Apia�"
  },
  {
    "codigoTse": "61549",
    "ibgeCodigo": 3556354,
    "uf": "SP",
    "nome": "Vargem"
  },
  {
    "codigoTse": "61557",
    "ibgeCodigo": 3502804,
    "uf": "SP",
    "nome": "Ara�atuba"
  },
  {
    "codigoTse": "61565",
    "ibgeCodigo": 3540754,
    "uf": "SP",
    "nome": "Potim"
  },
  {
    "codigoTse": "61573",
    "ibgeCodigo": 3502903,
    "uf": "SP",
    "nome": "Ara�oiaba Da Serra"
  },
  {
    "codigoTse": "61581",
    "ibgeCodigo": 3500758,
    "uf": "SP",
    "nome": "Alambari"
  },
  {
    "codigoTse": "61590",
    "ibgeCodigo": 3503000,
    "uf": "SP",
    "nome": "Aramina"
  },
  {
    "codigoTse": "61603",
    "ibgeCodigo": 3522158,
    "uf": "SP",
    "nome": "Ita�ca"
  },
  {
    "codigoTse": "61611",
    "ibgeCodigo": 3503109,
    "uf": "SP",
    "nome": "Arandu"
  },
  {
    "codigoTse": "61620",
    "ibgeCodigo": 3554953,
    "uf": "SP",
    "nome": "Tuiuti"
  },
  {
    "codigoTse": "61638",
    "ibgeCodigo": 3503208,
    "uf": "SP",
    "nome": "Araraquara"
  },
  {
    "codigoTse": "61646",
    "ibgeCodigo": 3503158,
    "uf": "SP",
    "nome": "Arape�"
  },
  {
    "codigoTse": "61654",
    "ibgeCodigo": 3503307,
    "uf": "SP",
    "nome": "Araras"
  },
  {
    "codigoTse": "61662",
    "ibgeCodigo": 3557303,
    "uf": "SP",
    "nome": "Estiva Gerbi"
  },
  {
    "codigoTse": "61670",
    "ibgeCodigo": 3503406,
    "uf": "SP",
    "nome": "Arealva"
  },
  {
    "codigoTse": "61689",
    "ibgeCodigo": 3515152,
    "uf": "SP",
    "nome": "Engenheiro Coelho"
  },
  {
    "codigoTse": "61697",
    "ibgeCodigo": 3503505,
    "uf": "SP",
    "nome": "Areias"
  },
  {
    "codigoTse": "61700",
    "ibgeCodigo": 3543253,
    "uf": "SP",
    "nome": "Ribeir�o Grande"
  },
  {
    "codigoTse": "61719",
    "ibgeCodigo": 3503604,
    "uf": "SP",
    "nome": "Arei�polis"
  },
  {
    "codigoTse": "61727",
    "ibgeCodigo": 3519071,
    "uf": "SP",
    "nome": "Hortol�ndia"
  },
  {
    "codigoTse": "61735",
    "ibgeCodigo": 3503703,
    "uf": "SP",
    "nome": "Ariranha"
  },
  {
    "codigoTse": "61743",
    "ibgeCodigo": 3519055,
    "uf": "SP",
    "nome": "Holambra"
  },
  {
    "codigoTse": "61751",
    "ibgeCodigo": 3503802,
    "uf": "SP",
    "nome": "Artur Nogueira"
  },
  {
    "codigoTse": "61760",
    "ibgeCodigo": 3514924,
    "uf": "SP",
    "nome": "Elisi�rio"
  },
  {
    "codigoTse": "61778",
    "ibgeCodigo": 3503901,
    "uf": "SP",
    "nome": "Aruj�"
  },
  {
    "codigoTse": "61786",
    "ibgeCodigo": 3507159,
    "uf": "SP",
    "nome": "Bom Sucesso De Itarar�"
  },
  {
    "codigoTse": "61794",
    "ibgeCodigo": 3504008,
    "uf": "SP",
    "nome": "Assis"
  },
  {
    "codigoTse": "61808",
    "ibgeCodigo": 3540259,
    "uf": "SP",
    "nome": "Pontalinda"
  },
  {
    "codigoTse": "61816",
    "ibgeCodigo": 3504107,
    "uf": "SP",
    "nome": "Atibaia"
  },
  {
    "codigoTse": "61824",
    "ibgeCodigo": 3536257,
    "uf": "SP",
    "nome": "Parisi"
  },
  {
    "codigoTse": "61832",
    "ibgeCodigo": 3504206,
    "uf": "SP",
    "nome": "Auriflama"
  },
  {
    "codigoTse": "61840",
    "ibgeCodigo": 3553856,
    "uf": "SP",
    "nome": "Taquariva�"
  },
  {
    "codigoTse": "61859",
    "ibgeCodigo": 3504305,
    "uf": "SP",
    "nome": "Ava�"
  },
  {
    "codigoTse": "61867",
    "ibgeCodigo": 3528858,
    "uf": "SP",
    "nome": "Marapoama"
  },
  {
    "codigoTse": "61875",
    "ibgeCodigo": 3504404,
    "uf": "SP",
    "nome": "Avanhandava"
  },
  {
    "codigoTse": "61883",
    "ibgeCodigo": 3549250,
    "uf": "SP",
    "nome": "S�o Jo�o De Iracema"
  },
  {
    "codigoTse": "61891",
    "ibgeCodigo": 3504503,
    "uf": "SP",
    "nome": "Avar�"
  },
  {
    "codigoTse": "61905",
    "ibgeCodigo": 3549953,
    "uf": "SP",
    "nome": "S�o Louren�o Da Serra"
  },
  {
    "codigoTse": "61913",
    "ibgeCodigo": 3504602,
    "uf": "SP",
    "nome": "Bady Bassitt"
  },
  {
    "codigoTse": "61921",
    "ibgeCodigo": 3557154,
    "uf": "SP",
    "nome": "Zacarias"
  },
  {
    "codigoTse": "61930",
    "ibgeCodigo": 3504701,
    "uf": "SP",
    "nome": "Balbinos"
  },
  {
    "codigoTse": "61948",
    "ibgeCodigo": 3522653,
    "uf": "SP",
    "nome": "Itapirapu� Paulista"
  },
  {
    "codigoTse": "61956",
    "ibgeCodigo": 3504800,
    "uf": "SP",
    "nome": "B�lsamo"
  },
  {
    "codigoTse": "61964",
    "ibgeCodigo": 3529658,
    "uf": "SP",
    "nome": "Mes�polis"
  },
  {
    "codigoTse": "61972",
    "ibgeCodigo": 3504909,
    "uf": "SP",
    "nome": "Bananal"
  },
  {
    "codigoTse": "61980",
    "ibgeCodigo": 3532827,
    "uf": "SP",
    "nome": "Nova Campina"
  },
  {
    "codigoTse": "61999",
    "ibgeCodigo": 3505104,
    "uf": "SP",
    "nome": "Barbosa"
  },
  {
    "codigoTse": "62006",
    "ibgeCodigo": 3520426,
    "uf": "SP",
    "nome": "Ilha Comprida"
  },
  {
    "codigoTse": "62014",
    "ibgeCodigo": 3505005,
    "uf": "SP",
    "nome": "Bar�o De Antonina"
  },
  {
    "codigoTse": "62022",
    "ibgeCodigo": 3527256,
    "uf": "SP",
    "nome": "Lourdes"
  },
  {
    "codigoTse": "62030",
    "ibgeCodigo": 3505203,
    "uf": "SP",
    "nome": "Bariri"
  },
  {
    "codigoTse": "62049",
    "ibgeCodigo": 3554656,
    "uf": "SP",
    "nome": "Torre De Pedra"
  },
  {
    "codigoTse": "62057",
    "ibgeCodigo": 3505302,
    "uf": "SP",
    "nome": "Barra Bonita"
  },
  {
    "codigoTse": "62065",
    "ibgeCodigo": 3503356,
    "uf": "SP",
    "nome": "Arco-�ris"
  },
  {
    "codigoTse": "62073",
    "ibgeCodigo": 3505401,
    "uf": "SP",
    "nome": "Barra Do Turvo"
  },
  {
    "codigoTse": "62081",
    "ibgeCodigo": 3507753,
    "uf": "SP",
    "nome": "Brejo Alegre"
  },
  {
    "codigoTse": "62090",
    "ibgeCodigo": 3505500,
    "uf": "SP",
    "nome": "Barretos"
  },
  {
    "codigoTse": "62103",
    "ibgeCodigo": 3509957,
    "uf": "SP",
    "nome": "Canas"
  },
  {
    "codigoTse": "62111",
    "ibgeCodigo": 3505609,
    "uf": "SP",
    "nome": "Barrinha"
  },
  {
    "codigoTse": "62120",
    "ibgeCodigo": 3540853,
    "uf": "SP",
    "nome": "Pracinha"
  },
  {
    "codigoTse": "62138",
    "ibgeCodigo": 3505708,
    "uf": "SP",
    "nome": "Barueri"
  },
  {
    "codigoTse": "62146",
    "ibgeCodigo": 3541059,
    "uf": "SP",
    "nome": "Prat�nia"
  },
  {
    "codigoTse": "62154",
    "ibgeCodigo": 3505807,
    "uf": "SP",
    "nome": "Bastos"
  },
  {
    "codigoTse": "62162",
    "ibgeCodigo": 3541653,
    "uf": "SP",
    "nome": "Quadra"
  },
  {
    "codigoTse": "62170",
    "ibgeCodigo": 3505906,
    "uf": "SP",
    "nome": "Batatais"
  },
  {
    "codigoTse": "62189",
    "ibgeCodigo": 3546256,
    "uf": "SP",
    "nome": "Santa Cruz Da Esperan�a"
  },
  {
    "codigoTse": "62197",
    "ibgeCodigo": 3506003,
    "uf": "SP",
    "nome": "Bauru"
  },
  {
    "codigoTse": "62200",
    "ibgeCodigo": 3547650,
    "uf": "SP",
    "nome": "Santa Salete"
  },
  {
    "codigoTse": "62219",
    "ibgeCodigo": 3506102,
    "uf": "SP",
    "nome": "Bebedouro"
  },
  {
    "codigoTse": "62227",
    "ibgeCodigo": 3556958,
    "uf": "SP",
    "nome": "Vit�ria Brasil"
  },
  {
    "codigoTse": "62235",
    "ibgeCodigo": 3506201,
    "uf": "SP",
    "nome": "Bento De Abreu"
  },
  {
    "codigoTse": "62243",
    "ibgeCodigo": 3521150,
    "uf": "SP",
    "nome": "Ipigu�"
  },
  {
    "codigoTse": "62251",
    "ibgeCodigo": 3506300,
    "uf": "SP",
    "nome": "Bernardino De Campos"
  },
  {
    "codigoTse": "62260",
    "ibgeCodigo": 3553658,
    "uf": "SP",
    "nome": "Taquaral"
  },
  {
    "codigoTse": "62278",
    "ibgeCodigo": 3506409,
    "uf": "SP",
    "nome": "Bilac"
  },
  {
    "codigoTse": "62286",
    "ibgeCodigo": 3515657,
    "uf": "SP",
    "nome": "Fern�o"
  },
  {
    "codigoTse": "62294",
    "ibgeCodigo": 3506508,
    "uf": "SP",
    "nome": "Birigui"
  },
  {
    "codigoTse": "62308",
    "ibgeCodigo": 3516853,
    "uf": "SP",
    "nome": "Gavi�o Peixoto"
  },
  {
    "codigoTse": "62316",
    "ibgeCodigo": 3506607,
    "uf": "SP",
    "nome": "Biritiba-Mirim"
  },
  {
    "codigoTse": "62324",
    "ibgeCodigo": 3525854,
    "uf": "SP",
    "nome": "Jumirim"
  },
  {
    "codigoTse": "62332",
    "ibgeCodigo": 3506706,
    "uf": "SP",
    "nome": "Boa Esperan�a Do Sul"
  },
  {
    "codigoTse": "62340",
    "ibgeCodigo": 3532157,
    "uf": "SP",
    "nome": "Nantes"
  },
  {
    "codigoTse": "62359",
    "ibgeCodigo": 3506805,
    "uf": "SP",
    "nome": "Bocaina"
  },
  {
    "codigoTse": "62367",
    "ibgeCodigo": 3532868,
    "uf": "SP",
    "nome": "Nova Castilho"
  },
  {
    "codigoTse": "62375",
    "ibgeCodigo": 3506904,
    "uf": "SP",
    "nome": "Bofete"
  },
  {
    "codigoTse": "62383",
    "ibgeCodigo": 3534757,
    "uf": "SP",
    "nome": "Ouroeste"
  },
  {
    "codigoTse": "62391",
    "ibgeCodigo": 3507001,
    "uf": "SP",
    "nome": "Boituva"
  },
  {
    "codigoTse": "62405",
    "ibgeCodigo": 3536570,
    "uf": "SP",
    "nome": "Paulist�nia"
  },
  {
    "codigoTse": "62413",
    "ibgeCodigo": 3507100,
    "uf": "SP",
    "nome": "Bom Jesus Dos Perd�es"
  },
  {
    "codigoTse": "62421",
    "ibgeCodigo": 3543238,
    "uf": "SP",
    "nome": "Ribeir�o Dos �ndios"
  },
  {
    "codigoTse": "62430",
    "ibgeCodigo": 3507209,
    "uf": "SP",
    "nome": "Bor�"
  },
  {
    "codigoTse": "62448",
    "ibgeCodigo": 3554755,
    "uf": "SP",
    "nome": "Trabiju"
  },
  {
    "codigoTse": "62456",
    "ibgeCodigo": 3507308,
    "uf": "SP",
    "nome": "Borac�ia"
  },
  {
    "codigoTse": "62472",
    "ibgeCodigo": 3507407,
    "uf": "SP",
    "nome": "Borborema"
  },
  {
    "codigoTse": "62499",
    "ibgeCodigo": 3507506,
    "uf": "SP",
    "nome": "Botucatu"
  },
  {
    "codigoTse": "62510",
    "ibgeCodigo": 3507605,
    "uf": "SP",
    "nome": "Bragan�a Paulista"
  },
  {
    "codigoTse": "62553",
    "ibgeCodigo": 3507704,
    "uf": "SP",
    "nome": "Bra�na"
  },
  {
    "codigoTse": "62570",
    "ibgeCodigo": 3507803,
    "uf": "SP",
    "nome": "Brodowski"
  },
  {
    "codigoTse": "62596",
    "ibgeCodigo": 3507902,
    "uf": "SP",
    "nome": "Brotas"
  },
  {
    "codigoTse": "62618",
    "ibgeCodigo": 3508009,
    "uf": "SP",
    "nome": "Buri"
  },
  {
    "codigoTse": "62634",
    "ibgeCodigo": 3508108,
    "uf": "SP",
    "nome": "Buritama"
  },
  {
    "codigoTse": "62650",
    "ibgeCodigo": 3508207,
    "uf": "SP",
    "nome": "Buritizal"
  },
  {
    "codigoTse": "62677",
    "ibgeCodigo": 3508306,
    "uf": "SP",
    "nome": "Cabr�lia Paulista"
  },
  {
    "codigoTse": "62693",
    "ibgeCodigo": 3508405,
    "uf": "SP",
    "nome": "Cabre�va"
  },
  {
    "codigoTse": "62715",
    "ibgeCodigo": 3508504,
    "uf": "SP",
    "nome": "Ca�apava"
  },
  {
    "codigoTse": "62731",
    "ibgeCodigo": 3508603,
    "uf": "SP",
    "nome": "Cachoeira Paulista"
  },
  {
    "codigoTse": "62758",
    "ibgeCodigo": 3508702,
    "uf": "SP",
    "nome": "Caconde"
  },
  {
    "codigoTse": "62774",
    "ibgeCodigo": 3508801,
    "uf": "SP",
    "nome": "Cafel�ndia"
  },
  {
    "codigoTse": "62790",
    "ibgeCodigo": 3508900,
    "uf": "SP",
    "nome": "Caiabu"
  },
  {
    "codigoTse": "62812",
    "ibgeCodigo": 3509007,
    "uf": "SP",
    "nome": "Caieiras"
  },
  {
    "codigoTse": "62839",
    "ibgeCodigo": 3509106,
    "uf": "SP",
    "nome": "Caiu�"
  },
  {
    "codigoTse": "62855",
    "ibgeCodigo": 3509205,
    "uf": "SP",
    "nome": "Cajamar"
  },
  {
    "codigoTse": "62871",
    "ibgeCodigo": 3509304,
    "uf": "SP",
    "nome": "Cajobi"
  },
  {
    "codigoTse": "62898",
    "ibgeCodigo": 3509403,
    "uf": "SP",
    "nome": "Cajuru"
  },
  {
    "codigoTse": "62910",
    "ibgeCodigo": 3509502,
    "uf": "SP",
    "nome": "Campinas"
  },
  {
    "codigoTse": "62936",
    "ibgeCodigo": 3509601,
    "uf": "SP",
    "nome": "Campo Limpo Paulista"
  },
  {
    "codigoTse": "62952",
    "ibgeCodigo": 3509700,
    "uf": "SP",
    "nome": "Campos Do Jord�o"
  },
  {
    "codigoTse": "62979",
    "ibgeCodigo": 3509809,
    "uf": "SP",
    "nome": "Campos Novos Paulista"
  },
  {
    "codigoTse": "62995",
    "ibgeCodigo": 3509908,
    "uf": "SP",
    "nome": "Canan�ia"
  },
  {
    "codigoTse": "63010",
    "ibgeCodigo": 3510005,
    "uf": "SP",
    "nome": "C�ndido Mota"
  },
  {
    "codigoTse": "63037",
    "ibgeCodigo": 3510104,
    "uf": "SP",
    "nome": "C�ndido Rodrigues"
  },
  {
    "codigoTse": "63053",
    "ibgeCodigo": 3510203,
    "uf": "SP",
    "nome": "Cap�o Bonito"
  },
  {
    "codigoTse": "63070",
    "ibgeCodigo": 3510302,
    "uf": "SP",
    "nome": "Capela Do Alto"
  },
  {
    "codigoTse": "63096",
    "ibgeCodigo": 3510401,
    "uf": "SP",
    "nome": "Capivari"
  },
  {
    "codigoTse": "63118",
    "ibgeCodigo": 3510500,
    "uf": "SP",
    "nome": "Caraguatatuba"
  },
  {
    "codigoTse": "63134",
    "ibgeCodigo": 3510609,
    "uf": "SP",
    "nome": "Carapicu�ba"
  },
  {
    "codigoTse": "63150",
    "ibgeCodigo": 3510708,
    "uf": "SP",
    "nome": "Cardoso"
  },
  {
    "codigoTse": "63177",
    "ibgeCodigo": 3510807,
    "uf": "SP",
    "nome": "Casa Branca"
  },
  {
    "codigoTse": "63193",
    "ibgeCodigo": 3510906,
    "uf": "SP",
    "nome": "C�ssia Dos Coqueiros"
  },
  {
    "codigoTse": "63215",
    "ibgeCodigo": 3511003,
    "uf": "SP",
    "nome": "Castilho"
  },
  {
    "codigoTse": "63231",
    "ibgeCodigo": 3511102,
    "uf": "SP",
    "nome": "Catanduva"
  },
  {
    "codigoTse": "63258",
    "ibgeCodigo": 3511201,
    "uf": "SP",
    "nome": "Catigu�"
  },
  {
    "codigoTse": "63274",
    "ibgeCodigo": 3511300,
    "uf": "SP",
    "nome": "Cedral"
  },
  {
    "codigoTse": "63290",
    "ibgeCodigo": 3511409,
    "uf": "SP",
    "nome": "Cerqueira C�sar"
  },
  {
    "codigoTse": "63312",
    "ibgeCodigo": 3511508,
    "uf": "SP",
    "nome": "Cerquilho"
  },
  {
    "codigoTse": "63339",
    "ibgeCodigo": 3511607,
    "uf": "SP",
    "nome": "Ces�rio Lange"
  },
  {
    "codigoTse": "63355",
    "ibgeCodigo": 3511706,
    "uf": "SP",
    "nome": "Charqueada"
  },
  {
    "codigoTse": "63371",
    "ibgeCodigo": 3557204,
    "uf": "SP",
    "nome": "Chavantes"
  },
  {
    "codigoTse": "63398",
    "ibgeCodigo": 3511904,
    "uf": "SP",
    "nome": "Clementina"
  },
  {
    "codigoTse": "63410",
    "ibgeCodigo": 3512001,
    "uf": "SP",
    "nome": "Colina"
  },
  {
    "codigoTse": "63436",
    "ibgeCodigo": 3512100,
    "uf": "SP",
    "nome": "Col�mbia"
  },
  {
    "codigoTse": "63452",
    "ibgeCodigo": 3512209,
    "uf": "SP",
    "nome": "Conchal"
  },
  {
    "codigoTse": "63479",
    "ibgeCodigo": 3512308,
    "uf": "SP",
    "nome": "Conchas"
  },
  {
    "codigoTse": "63495",
    "ibgeCodigo": 3512407,
    "uf": "SP",
    "nome": "Cordeir�polis"
  },
  {
    "codigoTse": "63517",
    "ibgeCodigo": 3512506,
    "uf": "SP",
    "nome": "Coroados"
  },
  {
    "codigoTse": "63533",
    "ibgeCodigo": 3512605,
    "uf": "SP",
    "nome": "Coronel Macedo"
  },
  {
    "codigoTse": "63550",
    "ibgeCodigo": 3512704,
    "uf": "SP",
    "nome": "Corumbata�"
  },
  {
    "codigoTse": "63576",
    "ibgeCodigo": 3512803,
    "uf": "SP",
    "nome": "Cosm�polis"
  },
  {
    "codigoTse": "63592",
    "ibgeCodigo": 3512902,
    "uf": "SP",
    "nome": "Cosmorama"
  },
  {
    "codigoTse": "63614",
    "ibgeCodigo": 3513009,
    "uf": "SP",
    "nome": "Cotia"
  },
  {
    "codigoTse": "63630",
    "ibgeCodigo": 3513108,
    "uf": "SP",
    "nome": "Cravinhos"
  },
  {
    "codigoTse": "63657",
    "ibgeCodigo": 3513207,
    "uf": "SP",
    "nome": "Cristais Paulista"
  },
  {
    "codigoTse": "63673",
    "ibgeCodigo": 3513306,
    "uf": "SP",
    "nome": "Cruz�lia"
  },
  {
    "codigoTse": "63690",
    "ibgeCodigo": 3513405,
    "uf": "SP",
    "nome": "Cruzeiro"
  },
  {
    "codigoTse": "63711",
    "ibgeCodigo": 3513504,
    "uf": "SP",
    "nome": "Cubat�o"
  },
  {
    "codigoTse": "63738",
    "ibgeCodigo": 3513603,
    "uf": "SP",
    "nome": "Cunha"
  },
  {
    "codigoTse": "63754",
    "ibgeCodigo": 3513702,
    "uf": "SP",
    "nome": "Descalvado"
  },
  {
    "codigoTse": "63770",
    "ibgeCodigo": 3513801,
    "uf": "SP",
    "nome": "Diadema"
  },
  {
    "codigoTse": "63797",
    "ibgeCodigo": 3513900,
    "uf": "SP",
    "nome": "Divinol�ndia"
  },
  {
    "codigoTse": "63819",
    "ibgeCodigo": 3514007,
    "uf": "SP",
    "nome": "Dobrada"
  },
  {
    "codigoTse": "63835",
    "ibgeCodigo": 3514106,
    "uf": "SP",
    "nome": "Dois C�rregos"
  },
  {
    "codigoTse": "63851",
    "ibgeCodigo": 3514205,
    "uf": "SP",
    "nome": "Dolcin�polis"
  },
  {
    "codigoTse": "63878",
    "ibgeCodigo": 3514304,
    "uf": "SP",
    "nome": "Dourado"
  },
  {
    "codigoTse": "63894",
    "ibgeCodigo": 3514403,
    "uf": "SP",
    "nome": "Dracena"
  },
  {
    "codigoTse": "63916",
    "ibgeCodigo": 3514502,
    "uf": "SP",
    "nome": "Duartina"
  },
  {
    "codigoTse": "63932",
    "ibgeCodigo": 3514601,
    "uf": "SP",
    "nome": "Dumont"
  },
  {
    "codigoTse": "63959",
    "ibgeCodigo": 3514700,
    "uf": "SP",
    "nome": "Echapor�"
  },
  {
    "codigoTse": "63975",
    "ibgeCodigo": 3514809,
    "uf": "SP",
    "nome": "Eldorado"
  },
  {
    "codigoTse": "63991",
    "ibgeCodigo": 3514908,
    "uf": "SP",
    "nome": "Elias Fausto"
  },
  {
    "codigoTse": "64017",
    "ibgeCodigo": 3515004,
    "uf": "SP",
    "nome": "Embu"
  },
  {
    "codigoTse": "64033",
    "ibgeCodigo": 3515103,
    "uf": "SP",
    "nome": "Embu-Gua�u"
  },
  {
    "codigoTse": "64050",
    "ibgeCodigo": 3515202,
    "uf": "SP",
    "nome": "Estrela D'Oeste"
  },
  {
    "codigoTse": "64076",
    "ibgeCodigo": 3515301,
    "uf": "SP",
    "nome": "Estrela Do Norte"
  },
  {
    "codigoTse": "64092",
    "ibgeCodigo": 3515400,
    "uf": "SP",
    "nome": "Fartura"
  },
  {
    "codigoTse": "64114",
    "ibgeCodigo": 3515509,
    "uf": "SP",
    "nome": "Fernand�polis"
  },
  {
    "codigoTse": "64130",
    "ibgeCodigo": 3515608,
    "uf": "SP",
    "nome": "Fernando Prestes"
  },
  {
    "codigoTse": "64157",
    "ibgeCodigo": 3515707,
    "uf": "SP",
    "nome": "Ferraz De Vasconcelos"
  },
  {
    "codigoTse": "64173",
    "ibgeCodigo": 3515806,
    "uf": "SP",
    "nome": "Flora Rica"
  },
  {
    "codigoTse": "64190",
    "ibgeCodigo": 3515905,
    "uf": "SP",
    "nome": "Floreal"
  },
  {
    "codigoTse": "64211",
    "ibgeCodigo": 3516002,
    "uf": "SP",
    "nome": "Fl�rida Paulista"
  },
  {
    "codigoTse": "64238",
    "ibgeCodigo": 3516101,
    "uf": "SP",
    "nome": "Flor�nia"
  },
  {
    "codigoTse": "64254",
    "ibgeCodigo": 3516200,
    "uf": "SP",
    "nome": "Franca"
  },
  {
    "codigoTse": "64270",
    "ibgeCodigo": 3516309,
    "uf": "SP",
    "nome": "Francisco Morato"
  },
  {
    "codigoTse": "64297",
    "ibgeCodigo": 3516408,
    "uf": "SP",
    "nome": "Franco Da Rocha"
  },
  {
    "codigoTse": "64319",
    "ibgeCodigo": 3516507,
    "uf": "SP",
    "nome": "Gabriel Monteiro"
  },
  {
    "codigoTse": "64335",
    "ibgeCodigo": 3516606,
    "uf": "SP",
    "nome": "G�lia"
  },
  {
    "codigoTse": "64351",
    "ibgeCodigo": 3516705,
    "uf": "SP",
    "nome": "Gar�a"
  },
  {
    "codigoTse": "64378",
    "ibgeCodigo": 3516804,
    "uf": "SP",
    "nome": "Gast�o Vidigal"
  },
  {
    "codigoTse": "64394",
    "ibgeCodigo": 3516903,
    "uf": "SP",
    "nome": "General Salgado"
  },
  {
    "codigoTse": "64416",
    "ibgeCodigo": 3517000,
    "uf": "SP",
    "nome": "Getulina"
  },
  {
    "codigoTse": "64432",
    "ibgeCodigo": 3517109,
    "uf": "SP",
    "nome": "Glic�rio"
  },
  {
    "codigoTse": "64459",
    "ibgeCodigo": 3517208,
    "uf": "SP",
    "nome": "Guai�ara"
  },
  {
    "codigoTse": "64475",
    "ibgeCodigo": 3517307,
    "uf": "SP",
    "nome": "Guaimb�"
  },
  {
    "codigoTse": "64491",
    "ibgeCodigo": 3517406,
    "uf": "SP",
    "nome": "Gua�ra"
  },
  {
    "codigoTse": "64513",
    "ibgeCodigo": 3517505,
    "uf": "SP",
    "nome": "Guapia�u"
  },
  {
    "codigoTse": "64530",
    "ibgeCodigo": 3517604,
    "uf": "SP",
    "nome": "Guapiara"
  },
  {
    "codigoTse": "64556",
    "ibgeCodigo": 3517703,
    "uf": "SP",
    "nome": "Guar�"
  },
  {
    "codigoTse": "64572",
    "ibgeCodigo": 3517802,
    "uf": "SP",
    "nome": "Guara�a�"
  },
  {
    "codigoTse": "64599",
    "ibgeCodigo": 3517901,
    "uf": "SP",
    "nome": "Guaraci"
  },
  {
    "codigoTse": "64610",
    "ibgeCodigo": 3518008,
    "uf": "SP",
    "nome": "Guarani D'Oeste"
  },
  {
    "codigoTse": "64637",
    "ibgeCodigo": 3518107,
    "uf": "SP",
    "nome": "Guarant�"
  },
  {
    "codigoTse": "64653",
    "ibgeCodigo": 3518206,
    "uf": "SP",
    "nome": "Guararapes"
  },
  {
    "codigoTse": "64670",
    "ibgeCodigo": 3518305,
    "uf": "SP",
    "nome": "Guararema"
  },
  {
    "codigoTse": "64696",
    "ibgeCodigo": 3518404,
    "uf": "SP",
    "nome": "Guaratinguet�"
  },
  {
    "codigoTse": "64718",
    "ibgeCodigo": 3518503,
    "uf": "SP",
    "nome": "Guare�"
  },
  {
    "codigoTse": "64734",
    "ibgeCodigo": 3518602,
    "uf": "SP",
    "nome": "Guariba"
  },
  {
    "codigoTse": "64750",
    "ibgeCodigo": 3518701,
    "uf": "SP",
    "nome": "Guaruj�"
  },
  {
    "codigoTse": "64777",
    "ibgeCodigo": 3518800,
    "uf": "SP",
    "nome": "Guarulhos"
  },
  {
    "codigoTse": "64793",
    "ibgeCodigo": 3518909,
    "uf": "SP",
    "nome": "Guzol�ndia"
  },
  {
    "codigoTse": "64815",
    "ibgeCodigo": 3519006,
    "uf": "SP",
    "nome": "Hercul�ndia"
  },
  {
    "codigoTse": "64831",
    "ibgeCodigo": 3519105,
    "uf": "SP",
    "nome": "Iacanga"
  },
  {
    "codigoTse": "64858",
    "ibgeCodigo": 3519204,
    "uf": "SP",
    "nome": "Iacri"
  },
  {
    "codigoTse": "64874",
    "ibgeCodigo": 3519303,
    "uf": "SP",
    "nome": "Ibat�"
  },
  {
    "codigoTse": "64890",
    "ibgeCodigo": 3519402,
    "uf": "SP",
    "nome": "Ibir�"
  },
  {
    "codigoTse": "64912",
    "ibgeCodigo": 3519501,
    "uf": "SP",
    "nome": "Ibirarema"
  },
  {
    "codigoTse": "64939",
    "ibgeCodigo": 3519600,
    "uf": "SP",
    "nome": "Ibitinga"
  },
  {
    "codigoTse": "64955",
    "ibgeCodigo": 3519709,
    "uf": "SP",
    "nome": "Ibi�na"
  },
  {
    "codigoTse": "64971",
    "ibgeCodigo": 3519808,
    "uf": "SP",
    "nome": "Ic�m"
  },
  {
    "codigoTse": "64998",
    "ibgeCodigo": 3519907,
    "uf": "SP",
    "nome": "Iep�"
  },
  {
    "codigoTse": "65013",
    "ibgeCodigo": 3520004,
    "uf": "SP",
    "nome": "Igara�u Do Tiet�"
  },
  {
    "codigoTse": "65030",
    "ibgeCodigo": 3520103,
    "uf": "SP",
    "nome": "Igarapava"
  },
  {
    "codigoTse": "65056",
    "ibgeCodigo": 3520202,
    "uf": "SP",
    "nome": "Igarat�"
  },
  {
    "codigoTse": "65072",
    "ibgeCodigo": 3520301,
    "uf": "SP",
    "nome": "Iguape"
  },
  {
    "codigoTse": "65099",
    "ibgeCodigo": 3520400,
    "uf": "SP",
    "nome": "Ilhabela"
  },
  {
    "codigoTse": "65110",
    "ibgeCodigo": 3520509,
    "uf": "SP",
    "nome": "Indaiatuba"
  },
  {
    "codigoTse": "65137",
    "ibgeCodigo": 3520608,
    "uf": "SP",
    "nome": "Indiana"
  },
  {
    "codigoTse": "65153",
    "ibgeCodigo": 3520707,
    "uf": "SP",
    "nome": "Indiapor�"
  },
  {
    "codigoTse": "65170",
    "ibgeCodigo": 3520806,
    "uf": "SP",
    "nome": "In�bia Paulista"
  },
  {
    "codigoTse": "65196",
    "ibgeCodigo": 3520905,
    "uf": "SP",
    "nome": "Ipaussu"
  },
  {
    "codigoTse": "65218",
    "ibgeCodigo": 3521002,
    "uf": "SP",
    "nome": "Iper�"
  },
  {
    "codigoTse": "65234",
    "ibgeCodigo": 3521101,
    "uf": "SP",
    "nome": "Ipe�na"
  },
  {
    "codigoTse": "65250",
    "ibgeCodigo": 3521200,
    "uf": "SP",
    "nome": "Iporanga"
  },
  {
    "codigoTse": "65277",
    "ibgeCodigo": 3521309,
    "uf": "SP",
    "nome": "Ipu�"
  },
  {
    "codigoTse": "65293",
    "ibgeCodigo": 3521408,
    "uf": "SP",
    "nome": "Iracem�polis"
  },
  {
    "codigoTse": "65315",
    "ibgeCodigo": 3521507,
    "uf": "SP",
    "nome": "Irapu�"
  },
  {
    "codigoTse": "65331",
    "ibgeCodigo": 3521606,
    "uf": "SP",
    "nome": "Irapuru"
  },
  {
    "codigoTse": "65358",
    "ibgeCodigo": 3521705,
    "uf": "SP",
    "nome": "Itaber�"
  },
  {
    "codigoTse": "65374",
    "ibgeCodigo": 3521804,
    "uf": "SP",
    "nome": "Ita�"
  },
  {
    "codigoTse": "65390",
    "ibgeCodigo": 3521903,
    "uf": "SP",
    "nome": "Itajobi"
  },
  {
    "codigoTse": "65412",
    "ibgeCodigo": 3522000,
    "uf": "SP",
    "nome": "Itaju"
  },
  {
    "codigoTse": "65439",
    "ibgeCodigo": 3522109,
    "uf": "SP",
    "nome": "Itanha�m"
  },
  {
    "codigoTse": "65455",
    "ibgeCodigo": 3522208,
    "uf": "SP",
    "nome": "Itapecerica Da Serra"
  },
  {
    "codigoTse": "65471",
    "ibgeCodigo": 3522307,
    "uf": "SP",
    "nome": "Itapetininga"
  },
  {
    "codigoTse": "65498",
    "ibgeCodigo": 3522406,
    "uf": "SP",
    "nome": "Itapeva"
  },
  {
    "codigoTse": "65510",
    "ibgeCodigo": 3522505,
    "uf": "SP",
    "nome": "Itapevi"
  },
  {
    "codigoTse": "65536",
    "ibgeCodigo": 3522604,
    "uf": "SP",
    "nome": "Itapira"
  },
  {
    "codigoTse": "65552",
    "ibgeCodigo": 3522703,
    "uf": "SP",
    "nome": "It�polis"
  },
  {
    "codigoTse": "65579",
    "ibgeCodigo": 3522802,
    "uf": "SP",
    "nome": "Itaporanga"
  },
  {
    "codigoTse": "65595",
    "ibgeCodigo": 3522901,
    "uf": "SP",
    "nome": "Itapu�"
  },
  {
    "codigoTse": "65617",
    "ibgeCodigo": 3523008,
    "uf": "SP",
    "nome": "Itapura"
  },
  {
    "codigoTse": "65633",
    "ibgeCodigo": 3523107,
    "uf": "SP",
    "nome": "Itaquaquecetuba"
  },
  {
    "codigoTse": "65650",
    "ibgeCodigo": 3523206,
    "uf": "SP",
    "nome": "Itarar�"
  },
  {
    "codigoTse": "65676",
    "ibgeCodigo": 3523305,
    "uf": "SP",
    "nome": "Itariri"
  },
  {
    "codigoTse": "65692",
    "ibgeCodigo": 3523404,
    "uf": "SP",
    "nome": "Itatiba"
  },
  {
    "codigoTse": "65714",
    "ibgeCodigo": 3523503,
    "uf": "SP",
    "nome": "Itatinga"
  },
  {
    "codigoTse": "65730",
    "ibgeCodigo": 3523602,
    "uf": "SP",
    "nome": "Itirapina"
  },
  {
    "codigoTse": "65757",
    "ibgeCodigo": 3523701,
    "uf": "SP",
    "nome": "Itirapu�"
  },
  {
    "codigoTse": "65773",
    "ibgeCodigo": 3523800,
    "uf": "SP",
    "nome": "Itobi"
  },
  {
    "codigoTse": "65790",
    "ibgeCodigo": 3523909,
    "uf": "SP",
    "nome": "Itu"
  },
  {
    "codigoTse": "65811",
    "ibgeCodigo": 3524006,
    "uf": "SP",
    "nome": "Itupeva"
  },
  {
    "codigoTse": "65838",
    "ibgeCodigo": 3524105,
    "uf": "SP",
    "nome": "Ituverava"
  },
  {
    "codigoTse": "65854",
    "ibgeCodigo": 3524204,
    "uf": "SP",
    "nome": "Jaborandi"
  },
  {
    "codigoTse": "65870",
    "ibgeCodigo": 3524303,
    "uf": "SP",
    "nome": "Jaboticabal"
  },
  {
    "codigoTse": "65897",
    "ibgeCodigo": 3524402,
    "uf": "SP",
    "nome": "Jacare�"
  },
  {
    "codigoTse": "65919",
    "ibgeCodigo": 3524501,
    "uf": "SP",
    "nome": "Jaci"
  },
  {
    "codigoTse": "65935",
    "ibgeCodigo": 3524600,
    "uf": "SP",
    "nome": "Jacupiranga"
  },
  {
    "codigoTse": "65951",
    "ibgeCodigo": 3524709,
    "uf": "SP",
    "nome": "Jaguari�na"
  },
  {
    "codigoTse": "65978",
    "ibgeCodigo": 3524808,
    "uf": "SP",
    "nome": "Jales"
  },
  {
    "codigoTse": "65994",
    "ibgeCodigo": 3524907,
    "uf": "SP",
    "nome": "Jambeiro"
  },
  {
    "codigoTse": "66010",
    "ibgeCodigo": 3525003,
    "uf": "SP",
    "nome": "Jandira"
  },
  {
    "codigoTse": "66036",
    "ibgeCodigo": 3525102,
    "uf": "SP",
    "nome": "Jardin�polis"
  },
  {
    "codigoTse": "66052",
    "ibgeCodigo": 3525201,
    "uf": "SP",
    "nome": "Jarinu"
  },
  {
    "codigoTse": "66079",
    "ibgeCodigo": 3525300,
    "uf": "SP",
    "nome": "Ja�"
  },
  {
    "codigoTse": "66095",
    "ibgeCodigo": 3525409,
    "uf": "SP",
    "nome": "Jeriquara"
  },
  {
    "codigoTse": "66117",
    "ibgeCodigo": 3525508,
    "uf": "SP",
    "nome": "Joan�polis"
  },
  {
    "codigoTse": "66133",
    "ibgeCodigo": 3525607,
    "uf": "SP",
    "nome": "Jo�o Ramalho"
  },
  {
    "codigoTse": "66150",
    "ibgeCodigo": 3525706,
    "uf": "SP",
    "nome": "Jos� Bonif�cio"
  },
  {
    "codigoTse": "66176",
    "ibgeCodigo": 3525805,
    "uf": "SP",
    "nome": "J�lio Mesquita"
  },
  {
    "codigoTse": "66192",
    "ibgeCodigo": 3525904,
    "uf": "SP",
    "nome": "Jundia�"
  },
  {
    "codigoTse": "66214",
    "ibgeCodigo": 3526001,
    "uf": "SP",
    "nome": "Junqueir�polis"
  },
  {
    "codigoTse": "66230",
    "ibgeCodigo": 3526100,
    "uf": "SP",
    "nome": "Juqui�"
  },
  {
    "codigoTse": "66257",
    "ibgeCodigo": 3526209,
    "uf": "SP",
    "nome": "Juquitiba"
  },
  {
    "codigoTse": "66273",
    "ibgeCodigo": 3526308,
    "uf": "SP",
    "nome": "Lagoinha"
  },
  {
    "codigoTse": "66290",
    "ibgeCodigo": 3526407,
    "uf": "SP",
    "nome": "Laranjal Paulista"
  },
  {
    "codigoTse": "66311",
    "ibgeCodigo": 3526506,
    "uf": "SP",
    "nome": "Lav�nia"
  },
  {
    "codigoTse": "66338",
    "ibgeCodigo": 3526605,
    "uf": "SP",
    "nome": "Lavrinhas"
  },
  {
    "codigoTse": "66354",
    "ibgeCodigo": 3526704,
    "uf": "SP",
    "nome": "Leme"
  },
  {
    "codigoTse": "66370",
    "ibgeCodigo": 3526803,
    "uf": "SP",
    "nome": "Len��is Paulista"
  },
  {
    "codigoTse": "66397",
    "ibgeCodigo": 3526902,
    "uf": "SP",
    "nome": "Limeira"
  },
  {
    "codigoTse": "66419",
    "ibgeCodigo": 3527009,
    "uf": "SP",
    "nome": "Lind�ia"
  },
  {
    "codigoTse": "66435",
    "ibgeCodigo": 3527108,
    "uf": "SP",
    "nome": "Lins"
  },
  {
    "codigoTse": "66451",
    "ibgeCodigo": 3527207,
    "uf": "SP",
    "nome": "Lorena"
  },
  {
    "codigoTse": "66478",
    "ibgeCodigo": 3527306,
    "uf": "SP",
    "nome": "Louveira"
  },
  {
    "codigoTse": "66494",
    "ibgeCodigo": 3527405,
    "uf": "SP",
    "nome": "Luc�lia"
  },
  {
    "codigoTse": "66516",
    "ibgeCodigo": 3527504,
    "uf": "SP",
    "nome": "Lucian�polis"
  },
  {
    "codigoTse": "66532",
    "ibgeCodigo": 3527603,
    "uf": "SP",
    "nome": "Lu�s Ant�nio"
  },
  {
    "codigoTse": "66559",
    "ibgeCodigo": 3527702,
    "uf": "SP",
    "nome": "Luizi�nia"
  },
  {
    "codigoTse": "66575",
    "ibgeCodigo": 3527801,
    "uf": "SP",
    "nome": "Lup�rcio"
  },
  {
    "codigoTse": "66591",
    "ibgeCodigo": 3527900,
    "uf": "SP",
    "nome": "Lut�cia"
  },
  {
    "codigoTse": "66613",
    "ibgeCodigo": 3528007,
    "uf": "SP",
    "nome": "Macatuba"
  },
  {
    "codigoTse": "66630",
    "ibgeCodigo": 3528106,
    "uf": "SP",
    "nome": "Macaubal"
  },
  {
    "codigoTse": "66656",
    "ibgeCodigo": 3528205,
    "uf": "SP",
    "nome": "Maced�nia"
  },
  {
    "codigoTse": "66672",
    "ibgeCodigo": 3528304,
    "uf": "SP",
    "nome": "Magda"
  },
  {
    "codigoTse": "66699",
    "ibgeCodigo": 3528403,
    "uf": "SP",
    "nome": "Mairinque"
  },
  {
    "codigoTse": "66710",
    "ibgeCodigo": 3528502,
    "uf": "SP",
    "nome": "Mairipor�"
  },
  {
    "codigoTse": "66737",
    "ibgeCodigo": 3528601,
    "uf": "SP",
    "nome": "Manduri"
  },
  {
    "codigoTse": "66753",
    "ibgeCodigo": 3528700,
    "uf": "SP",
    "nome": "Marab� Paulista"
  },
  {
    "codigoTse": "66770",
    "ibgeCodigo": 3528809,
    "uf": "SP",
    "nome": "Maraca�"
  },
  {
    "codigoTse": "66796",
    "ibgeCodigo": 3528908,
    "uf": "SP",
    "nome": "Mari�polis"
  },
  {
    "codigoTse": "66818",
    "ibgeCodigo": 3529005,
    "uf": "SP",
    "nome": "Mar�lia"
  },
  {
    "codigoTse": "66834",
    "ibgeCodigo": 3529104,
    "uf": "SP",
    "nome": "Marin�polis"
  },
  {
    "codigoTse": "66850",
    "ibgeCodigo": 3529203,
    "uf": "SP",
    "nome": "Martin�polis"
  },
  {
    "codigoTse": "66877",
    "ibgeCodigo": 3529302,
    "uf": "SP",
    "nome": "Mat�o"
  },
  {
    "codigoTse": "66893",
    "ibgeCodigo": 3529401,
    "uf": "SP",
    "nome": "Mau�"
  },
  {
    "codigoTse": "66915",
    "ibgeCodigo": 3529500,
    "uf": "SP",
    "nome": "Mendon�a"
  },
  {
    "codigoTse": "66931",
    "ibgeCodigo": 3529609,
    "uf": "SP",
    "nome": "Meridiano"
  },
  {
    "codigoTse": "66958",
    "ibgeCodigo": 3529708,
    "uf": "SP",
    "nome": "Miguel�polis"
  },
  {
    "codigoTse": "66974",
    "ibgeCodigo": 3529807,
    "uf": "SP",
    "nome": "Mineiros Do Tiet�"
  },
  {
    "codigoTse": "66990",
    "ibgeCodigo": 3529906,
    "uf": "SP",
    "nome": "Miracatu"
  },
  {
    "codigoTse": "67016",
    "ibgeCodigo": 3530003,
    "uf": "SP",
    "nome": "Mira Estrela"
  },
  {
    "codigoTse": "67032",
    "ibgeCodigo": 3530102,
    "uf": "SP",
    "nome": "Mirand�polis"
  },
  {
    "codigoTse": "67059",
    "ibgeCodigo": 3530201,
    "uf": "SP",
    "nome": "Mirante Do Paranapanema"
  },
  {
    "codigoTse": "67075",
    "ibgeCodigo": 3530300,
    "uf": "SP",
    "nome": "Mirassol"
  },
  {
    "codigoTse": "67091",
    "ibgeCodigo": 3530409,
    "uf": "SP",
    "nome": "Mirassol�ndia"
  },
  {
    "codigoTse": "67113",
    "ibgeCodigo": 3530508,
    "uf": "SP",
    "nome": "Mococa"
  },
  {
    "codigoTse": "67130",
    "ibgeCodigo": 3530607,
    "uf": "SP",
    "nome": "Mogi Das Cruzes"
  },
  {
    "codigoTse": "67156",
    "ibgeCodigo": 3530706,
    "uf": "SP",
    "nome": "Mogi Gua�u"
  },
  {
    "codigoTse": "67172",
    "ibgeCodigo": 3530805,
    "uf": "SP",
    "nome": "Moji Mirim"
  },
  {
    "codigoTse": "67199",
    "ibgeCodigo": 3530904,
    "uf": "SP",
    "nome": "Mombuca"
  },
  {
    "codigoTse": "67210",
    "ibgeCodigo": 3531001,
    "uf": "SP",
    "nome": "Mon��es"
  },
  {
    "codigoTse": "67237",
    "ibgeCodigo": 3531100,
    "uf": "SP",
    "nome": "Mongagu�"
  },
  {
    "codigoTse": "67253",
    "ibgeCodigo": 3531209,
    "uf": "SP",
    "nome": "Monte Alegre Do Sul"
  },
  {
    "codigoTse": "67270",
    "ibgeCodigo": 3531308,
    "uf": "SP",
    "nome": "Monte Alto"
  },
  {
    "codigoTse": "67296",
    "ibgeCodigo": 3531407,
    "uf": "SP",
    "nome": "Monte Apraz�vel"
  },
  {
    "codigoTse": "67318",
    "ibgeCodigo": 3531506,
    "uf": "SP",
    "nome": "Monte Azul Paulista"
  },
  {
    "codigoTse": "67334",
    "ibgeCodigo": 3531605,
    "uf": "SP",
    "nome": "Monte Castelo"
  },
  {
    "codigoTse": "67350",
    "ibgeCodigo": 3531704,
    "uf": "SP",
    "nome": "Monteiro Lobato"
  },
  {
    "codigoTse": "67377",
    "ibgeCodigo": 3531803,
    "uf": "SP",
    "nome": "Monte Mor"
  },
  {
    "codigoTse": "67393",
    "ibgeCodigo": 3531902,
    "uf": "SP",
    "nome": "Morro Agudo"
  },
  {
    "codigoTse": "67415",
    "ibgeCodigo": 3532009,
    "uf": "SP",
    "nome": "Morungaba"
  },
  {
    "codigoTse": "67431",
    "ibgeCodigo": 3532108,
    "uf": "SP",
    "nome": "Murutinga Do Sul"
  },
  {
    "codigoTse": "67458",
    "ibgeCodigo": 3532207,
    "uf": "SP",
    "nome": "Narandiba"
  },
  {
    "codigoTse": "67474",
    "ibgeCodigo": 3532306,
    "uf": "SP",
    "nome": "Natividade Da Serra"
  },
  {
    "codigoTse": "67490",
    "ibgeCodigo": 3532405,
    "uf": "SP",
    "nome": "Nazar� Paulista"
  },
  {
    "codigoTse": "67512",
    "ibgeCodigo": 3532504,
    "uf": "SP",
    "nome": "Neves Paulista"
  },
  {
    "codigoTse": "67539",
    "ibgeCodigo": 3532603,
    "uf": "SP",
    "nome": "Nhandeara"
  },
  {
    "codigoTse": "67555",
    "ibgeCodigo": 3532702,
    "uf": "SP",
    "nome": "Nipo�"
  },
  {
    "codigoTse": "67571",
    "ibgeCodigo": 3532801,
    "uf": "SP",
    "nome": "Nova Alian�a"
  },
  {
    "codigoTse": "67598",
    "ibgeCodigo": 3532900,
    "uf": "SP",
    "nome": "Nova Europa"
  },
  {
    "codigoTse": "67610",
    "ibgeCodigo": 3533007,
    "uf": "SP",
    "nome": "Nova Granada"
  },
  {
    "codigoTse": "67636",
    "ibgeCodigo": 3533106,
    "uf": "SP",
    "nome": "Nova Guataporanga"
  },
  {
    "codigoTse": "67652",
    "ibgeCodigo": 3533205,
    "uf": "SP",
    "nome": "Nova Independ�ncia"
  },
  {
    "codigoTse": "67679",
    "ibgeCodigo": 3533304,
    "uf": "SP",
    "nome": "Nova Luzit�nia"
  },
  {
    "codigoTse": "67695",
    "ibgeCodigo": 3533403,
    "uf": "SP",
    "nome": "Nova Odessa"
  },
  {
    "codigoTse": "67717",
    "ibgeCodigo": 3533502,
    "uf": "SP",
    "nome": "Novo Horizonte"
  },
  {
    "codigoTse": "67733",
    "ibgeCodigo": 3533601,
    "uf": "SP",
    "nome": "Nuporanga"
  },
  {
    "codigoTse": "67750",
    "ibgeCodigo": 3533700,
    "uf": "SP",
    "nome": "Ocau�u"
  },
  {
    "codigoTse": "67776",
    "ibgeCodigo": 3533809,
    "uf": "SP",
    "nome": "�leo"
  },
  {
    "codigoTse": "67792",
    "ibgeCodigo": 3533908,
    "uf": "SP",
    "nome": "Ol�mpia"
  },
  {
    "codigoTse": "67814",
    "ibgeCodigo": 3534005,
    "uf": "SP",
    "nome": "Onda Verde"
  },
  {
    "codigoTse": "67830",
    "ibgeCodigo": 3534104,
    "uf": "SP",
    "nome": "Oriente"
  },
  {
    "codigoTse": "67857",
    "ibgeCodigo": 3534203,
    "uf": "SP",
    "nome": "Orindi�va"
  },
  {
    "codigoTse": "67873",
    "ibgeCodigo": 3534302,
    "uf": "SP",
    "nome": "Orl�ndia"
  },
  {
    "codigoTse": "67890",
    "ibgeCodigo": 3534401,
    "uf": "SP",
    "nome": "Osasco"
  },
  {
    "codigoTse": "67911",
    "ibgeCodigo": 3534500,
    "uf": "SP",
    "nome": "Oscar Bressane"
  },
  {
    "codigoTse": "67938",
    "ibgeCodigo": 3534609,
    "uf": "SP",
    "nome": "Osvaldo Cruz"
  },
  {
    "codigoTse": "67954",
    "ibgeCodigo": 3534708,
    "uf": "SP",
    "nome": "Ourinhos"
  },
  {
    "codigoTse": "67970",
    "ibgeCodigo": 3534807,
    "uf": "SP",
    "nome": "Ouro Verde"
  },
  {
    "codigoTse": "67997",
    "ibgeCodigo": 3534906,
    "uf": "SP",
    "nome": "Pacaembu"
  },
  {
    "codigoTse": "68012",
    "ibgeCodigo": 3535002,
    "uf": "SP",
    "nome": "Palestina"
  },
  {
    "codigoTse": "68039",
    "ibgeCodigo": 3535101,
    "uf": "SP",
    "nome": "Palmares Paulista"
  },
  {
    "codigoTse": "68055",
    "ibgeCodigo": 3535200,
    "uf": "SP",
    "nome": "Palmeira D'Oeste"
  },
  {
    "codigoTse": "68071",
    "ibgeCodigo": 3535309,
    "uf": "SP",
    "nome": "Palmital"
  },
  {
    "codigoTse": "68098",
    "ibgeCodigo": 3535408,
    "uf": "SP",
    "nome": "Panorama"
  },
  {
    "codigoTse": "68110",
    "ibgeCodigo": 3535507,
    "uf": "SP",
    "nome": "Paragua�u Paulista"
  },
  {
    "codigoTse": "68136",
    "ibgeCodigo": 3535606,
    "uf": "SP",
    "nome": "Paraibuna"
  },
  {
    "codigoTse": "68152",
    "ibgeCodigo": 3535705,
    "uf": "SP",
    "nome": "Para�so"
  },
  {
    "codigoTse": "68179",
    "ibgeCodigo": 3535804,
    "uf": "SP",
    "nome": "Paranapanema"
  },
  {
    "codigoTse": "68195",
    "ibgeCodigo": 3535903,
    "uf": "SP",
    "nome": "Paranapu�"
  },
  {
    "codigoTse": "68217",
    "ibgeCodigo": 3536000,
    "uf": "SP",
    "nome": "Parapu�"
  },
  {
    "codigoTse": "68233",
    "ibgeCodigo": 3536109,
    "uf": "SP",
    "nome": "Pardinho"
  },
  {
    "codigoTse": "68250",
    "ibgeCodigo": 3536208,
    "uf": "SP",
    "nome": "Pariquera-A�u"
  },
  {
    "codigoTse": "68276",
    "ibgeCodigo": 3536307,
    "uf": "SP",
    "nome": "Patroc�nio Paulista"
  },
  {
    "codigoTse": "68292",
    "ibgeCodigo": 3536406,
    "uf": "SP",
    "nome": "Paulic�ia"
  },
  {
    "codigoTse": "68314",
    "ibgeCodigo": 3536505,
    "uf": "SP",
    "nome": "Paul�nia"
  },
  {
    "codigoTse": "68330",
    "ibgeCodigo": 3536604,
    "uf": "SP",
    "nome": "Paulo De Faria"
  },
  {
    "codigoTse": "68357",
    "ibgeCodigo": 3536703,
    "uf": "SP",
    "nome": "Pederneiras"
  },
  {
    "codigoTse": "68373",
    "ibgeCodigo": 3536802,
    "uf": "SP",
    "nome": "Pedra Bela"
  },
  {
    "codigoTse": "68390",
    "ibgeCodigo": 3536901,
    "uf": "SP",
    "nome": "Pedran�polis"
  },
  {
    "codigoTse": "68411",
    "ibgeCodigo": 3537008,
    "uf": "SP",
    "nome": "Pedregulho"
  },
  {
    "codigoTse": "68438",
    "ibgeCodigo": 3537107,
    "uf": "SP",
    "nome": "Pedreira"
  },
  {
    "codigoTse": "68454",
    "ibgeCodigo": 3537206,
    "uf": "SP",
    "nome": "Pedro De Toledo"
  },
  {
    "codigoTse": "68470",
    "ibgeCodigo": 3537305,
    "uf": "SP",
    "nome": "Pen�polis"
  },
  {
    "codigoTse": "68497",
    "ibgeCodigo": 3537404,
    "uf": "SP",
    "nome": "Pereira Barreto"
  },
  {
    "codigoTse": "68519",
    "ibgeCodigo": 3537503,
    "uf": "SP",
    "nome": "Pereiras"
  },
  {
    "codigoTse": "68535",
    "ibgeCodigo": 3537602,
    "uf": "SP",
    "nome": "Peru�be"
  },
  {
    "codigoTse": "68551",
    "ibgeCodigo": 3537701,
    "uf": "SP",
    "nome": "Piacatu"
  },
  {
    "codigoTse": "68578",
    "ibgeCodigo": 3537800,
    "uf": "SP",
    "nome": "Piedade"
  },
  {
    "codigoTse": "68594",
    "ibgeCodigo": 3537909,
    "uf": "SP",
    "nome": "Pilar Do Sul"
  },
  {
    "codigoTse": "68616",
    "ibgeCodigo": 3538006,
    "uf": "SP",
    "nome": "Pindamonhangaba"
  },
  {
    "codigoTse": "68632",
    "ibgeCodigo": 3538105,
    "uf": "SP",
    "nome": "Pindorama"
  },
  {
    "codigoTse": "68659",
    "ibgeCodigo": 3515186,
    "uf": "SP",
    "nome": "Esp�rito Santo Do Pinhal"
  },
  {
    "codigoTse": "68675",
    "ibgeCodigo": 3538204,
    "uf": "SP",
    "nome": "Pinhalzinho"
  },
  {
    "codigoTse": "68691",
    "ibgeCodigo": 3538303,
    "uf": "SP",
    "nome": "Piquerobi"
  },
  {
    "codigoTse": "68713",
    "ibgeCodigo": 3538501,
    "uf": "SP",
    "nome": "Piquete"
  },
  {
    "codigoTse": "68730",
    "ibgeCodigo": 3538600,
    "uf": "SP",
    "nome": "Piracaia"
  },
  {
    "codigoTse": "68756",
    "ibgeCodigo": 3538709,
    "uf": "SP",
    "nome": "Piracicaba"
  },
  {
    "codigoTse": "68772",
    "ibgeCodigo": 3538808,
    "uf": "SP",
    "nome": "Piraju"
  },
  {
    "codigoTse": "68799",
    "ibgeCodigo": 3538907,
    "uf": "SP",
    "nome": "Piraju�"
  },
  {
    "codigoTse": "68810",
    "ibgeCodigo": 3539004,
    "uf": "SP",
    "nome": "Pirangi"
  },
  {
    "codigoTse": "68837",
    "ibgeCodigo": 3539103,
    "uf": "SP",
    "nome": "Pirapora Do Bom Jesus"
  },
  {
    "codigoTse": "68853",
    "ibgeCodigo": 3539202,
    "uf": "SP",
    "nome": "Pirapozinho"
  },
  {
    "codigoTse": "68870",
    "ibgeCodigo": 3539301,
    "uf": "SP",
    "nome": "Pirassununga"
  },
  {
    "codigoTse": "68896",
    "ibgeCodigo": 3539400,
    "uf": "SP",
    "nome": "Piratininga"
  },
  {
    "codigoTse": "68918",
    "ibgeCodigo": 3539509,
    "uf": "SP",
    "nome": "Pitangueiras"
  },
  {
    "codigoTse": "68934",
    "ibgeCodigo": 3539608,
    "uf": "SP",
    "nome": "Planalto"
  },
  {
    "codigoTse": "68950",
    "ibgeCodigo": 3539707,
    "uf": "SP",
    "nome": "Platina"
  },
  {
    "codigoTse": "68977",
    "ibgeCodigo": 3539806,
    "uf": "SP",
    "nome": "Po�"
  },
  {
    "codigoTse": "68993",
    "ibgeCodigo": 3539905,
    "uf": "SP",
    "nome": "Poloni"
  },
  {
    "codigoTse": "69019",
    "ibgeCodigo": 3540002,
    "uf": "SP",
    "nome": "Pomp�ia"
  },
  {
    "codigoTse": "69035",
    "ibgeCodigo": 3540101,
    "uf": "SP",
    "nome": "Ponga�"
  },
  {
    "codigoTse": "69051",
    "ibgeCodigo": 3540200,
    "uf": "SP",
    "nome": "Pontal"
  },
  {
    "codigoTse": "69078",
    "ibgeCodigo": 3540309,
    "uf": "SP",
    "nome": "Pontes Gestal"
  },
  {
    "codigoTse": "69094",
    "ibgeCodigo": 3540408,
    "uf": "SP",
    "nome": "Populina"
  },
  {
    "codigoTse": "69116",
    "ibgeCodigo": 3540507,
    "uf": "SP",
    "nome": "Porangaba"
  },
  {
    "codigoTse": "69132",
    "ibgeCodigo": 3540606,
    "uf": "SP",
    "nome": "Porto Feliz"
  },
  {
    "codigoTse": "69159",
    "ibgeCodigo": 3540705,
    "uf": "SP",
    "nome": "Porto Ferreira"
  },
  {
    "codigoTse": "69175",
    "ibgeCodigo": 3540804,
    "uf": "SP",
    "nome": "Potirendaba"
  },
  {
    "codigoTse": "69191",
    "ibgeCodigo": 3540903,
    "uf": "SP",
    "nome": "Prad�polis"
  },
  {
    "codigoTse": "69213",
    "ibgeCodigo": 3541000,
    "uf": "SP",
    "nome": "Praia Grande"
  },
  {
    "codigoTse": "69230",
    "ibgeCodigo": 3541109,
    "uf": "SP",
    "nome": "Presidente Alves"
  },
  {
    "codigoTse": "69256",
    "ibgeCodigo": 3541208,
    "uf": "SP",
    "nome": "Presidente Bernardes"
  },
  {
    "codigoTse": "69272",
    "ibgeCodigo": 3541307,
    "uf": "SP",
    "nome": "Presidente Epit�cio"
  },
  {
    "codigoTse": "69299",
    "ibgeCodigo": 3541406,
    "uf": "SP",
    "nome": "Presidente Prudente"
  },
  {
    "codigoTse": "69310",
    "ibgeCodigo": 3541505,
    "uf": "SP",
    "nome": "Presidente Venceslau"
  },
  {
    "codigoTse": "69337",
    "ibgeCodigo": 3541604,
    "uf": "SP",
    "nome": "Promiss�o"
  },
  {
    "codigoTse": "69353",
    "ibgeCodigo": 3541703,
    "uf": "SP",
    "nome": "Quat�"
  },
  {
    "codigoTse": "69370",
    "ibgeCodigo": 3541802,
    "uf": "SP",
    "nome": "Queiroz"
  },
  {
    "codigoTse": "69396",
    "ibgeCodigo": 3541901,
    "uf": "SP",
    "nome": "Queluz"
  },
  {
    "codigoTse": "69418",
    "ibgeCodigo": 3542008,
    "uf": "SP",
    "nome": "Quintana"
  },
  {
    "codigoTse": "69434",
    "ibgeCodigo": 3542107,
    "uf": "SP",
    "nome": "Rafard"
  },
  {
    "codigoTse": "69450",
    "ibgeCodigo": 3542206,
    "uf": "SP",
    "nome": "Rancharia"
  },
  {
    "codigoTse": "69477",
    "ibgeCodigo": 3542305,
    "uf": "SP",
    "nome": "Reden��o Da Serra"
  },
  {
    "codigoTse": "69493",
    "ibgeCodigo": 3542404,
    "uf": "SP",
    "nome": "Regente Feij�"
  },
  {
    "codigoTse": "69515",
    "ibgeCodigo": 3542503,
    "uf": "SP",
    "nome": "Regin�polis"
  },
  {
    "codigoTse": "69531",
    "ibgeCodigo": 3542602,
    "uf": "SP",
    "nome": "Registro"
  },
  {
    "codigoTse": "69558",
    "ibgeCodigo": 3542701,
    "uf": "SP",
    "nome": "Restinga"
  },
  {
    "codigoTse": "69574",
    "ibgeCodigo": 3542800,
    "uf": "SP",
    "nome": "Ribeira"
  },
  {
    "codigoTse": "69590",
    "ibgeCodigo": 3542909,
    "uf": "SP",
    "nome": "Ribeir�o Bonito"
  },
  {
    "codigoTse": "69612",
    "ibgeCodigo": 3543006,
    "uf": "SP",
    "nome": "Ribeir�o Branco"
  },
  {
    "codigoTse": "69639",
    "ibgeCodigo": 3543105,
    "uf": "SP",
    "nome": "Ribeir�o Corrente"
  },
  {
    "codigoTse": "69655",
    "ibgeCodigo": 3543204,
    "uf": "SP",
    "nome": "Ribeir�o Do Sul"
  },
  {
    "codigoTse": "69671",
    "ibgeCodigo": 3543303,
    "uf": "SP",
    "nome": "Ribeir�o Pires"
  },
  {
    "codigoTse": "69698",
    "ibgeCodigo": 3543402,
    "uf": "SP",
    "nome": "Ribeir�o Preto"
  },
  {
    "codigoTse": "69710",
    "ibgeCodigo": 3543501,
    "uf": "SP",
    "nome": "Riversul"
  },
  {
    "codigoTse": "69736",
    "ibgeCodigo": 3543600,
    "uf": "SP",
    "nome": "Rifaina"
  },
  {
    "codigoTse": "69752",
    "ibgeCodigo": 3543709,
    "uf": "SP",
    "nome": "Rinc�o"
  },
  {
    "codigoTse": "69779",
    "ibgeCodigo": 3543808,
    "uf": "SP",
    "nome": "Rin�polis"
  },
  {
    "codigoTse": "69795",
    "ibgeCodigo": 3543907,
    "uf": "SP",
    "nome": "Rio Claro"
  },
  {
    "codigoTse": "69817",
    "ibgeCodigo": 3544004,
    "uf": "SP",
    "nome": "Rio Das Pedras"
  },
  {
    "codigoTse": "69833",
    "ibgeCodigo": 3544103,
    "uf": "SP",
    "nome": "Rio Grande Da Serra"
  },
  {
    "codigoTse": "69850",
    "ibgeCodigo": 3544202,
    "uf": "SP",
    "nome": "Riol�ndia"
  },
  {
    "codigoTse": "69876",
    "ibgeCodigo": 3544301,
    "uf": "SP",
    "nome": "Roseira"
  },
  {
    "codigoTse": "69892",
    "ibgeCodigo": 3544400,
    "uf": "SP",
    "nome": "Rubi�cea"
  },
  {
    "codigoTse": "69914",
    "ibgeCodigo": 3544509,
    "uf": "SP",
    "nome": "Rubin�ia"
  },
  {
    "codigoTse": "69930",
    "ibgeCodigo": 3544608,
    "uf": "SP",
    "nome": "Sabino"
  },
  {
    "codigoTse": "69957",
    "ibgeCodigo": 3544707,
    "uf": "SP",
    "nome": "Sagres"
  },
  {
    "codigoTse": "69973",
    "ibgeCodigo": 3544806,
    "uf": "SP",
    "nome": "Sales"
  },
  {
    "codigoTse": "69990",
    "ibgeCodigo": 3544905,
    "uf": "SP",
    "nome": "Sales Oliveira"
  },
  {
    "codigoTse": "70017",
    "ibgeCodigo": 3545001,
    "uf": "SP",
    "nome": "Sales�polis"
  },
  {
    "codigoTse": "70033",
    "ibgeCodigo": 3545100,
    "uf": "SP",
    "nome": "Salmour�o"
  },
  {
    "codigoTse": "70050",
    "ibgeCodigo": 3545209,
    "uf": "SP",
    "nome": "Salto"
  },
  {
    "codigoTse": "70076",
    "ibgeCodigo": 3545308,
    "uf": "SP",
    "nome": "Salto De Pirapora"
  },
  {
    "codigoTse": "70092",
    "ibgeCodigo": 3545407,
    "uf": "SP",
    "nome": "Salto Grande"
  },
  {
    "codigoTse": "70114",
    "ibgeCodigo": 3545506,
    "uf": "SP",
    "nome": "Sandovalina"
  },
  {
    "codigoTse": "70130",
    "ibgeCodigo": 3545605,
    "uf": "SP",
    "nome": "Santa Ad�lia"
  },
  {
    "codigoTse": "70157",
    "ibgeCodigo": 3545704,
    "uf": "SP",
    "nome": "Santa Albertina"
  },
  {
    "codigoTse": "70173",
    "ibgeCodigo": 3545803,
    "uf": "SP",
    "nome": "Santa B�rbara D'Oeste"
  },
  {
    "codigoTse": "70190",
    "ibgeCodigo": 3500550,
    "uf": "SP",
    "nome": "�guas De Santa B�rbara"
  },
  {
    "codigoTse": "70211",
    "ibgeCodigo": 3546009,
    "uf": "SP",
    "nome": "Santa Branca"
  },
  {
    "codigoTse": "70238",
    "ibgeCodigo": 3546108,
    "uf": "SP",
    "nome": "Santa Clara D'Oeste"
  },
  {
    "codigoTse": "70254",
    "ibgeCodigo": 3546207,
    "uf": "SP",
    "nome": "Santa Cruz Da Concei��o"
  },
  {
    "codigoTse": "70270",
    "ibgeCodigo": 3546306,
    "uf": "SP",
    "nome": "Santa Cruz Das Palmeiras"
  },
  {
    "codigoTse": "70297",
    "ibgeCodigo": 3546405,
    "uf": "SP",
    "nome": "Santa Cruz Do Rio Pardo"
  },
  {
    "codigoTse": "70319",
    "ibgeCodigo": 3546504,
    "uf": "SP",
    "nome": "Santa Ernestina"
  },
  {
    "codigoTse": "70335",
    "ibgeCodigo": 3546603,
    "uf": "SP",
    "nome": "Santa F� Do Sul"
  },
  {
    "codigoTse": "70351",
    "ibgeCodigo": 3546702,
    "uf": "SP",
    "nome": "Santa Gertrudes"
  },
  {
    "codigoTse": "70378",
    "ibgeCodigo": 3546801,
    "uf": "SP",
    "nome": "Santa Isabel"
  },
  {
    "codigoTse": "70394",
    "ibgeCodigo": 3546900,
    "uf": "SP",
    "nome": "Santa L�cia"
  },
  {
    "codigoTse": "70416",
    "ibgeCodigo": 3547007,
    "uf": "SP",
    "nome": "Santa Maria Da Serra"
  },
  {
    "codigoTse": "70432",
    "ibgeCodigo": 3547106,
    "uf": "SP",
    "nome": "Santa Mercedes"
  },
  {
    "codigoTse": "70459",
    "ibgeCodigo": 3547205,
    "uf": "SP",
    "nome": "Santana Da Ponte Pensa"
  },
  {
    "codigoTse": "70475",
    "ibgeCodigo": 3547304,
    "uf": "SP",
    "nome": "Santana De Parna�ba"
  },
  {
    "codigoTse": "70491",
    "ibgeCodigo": 3547403,
    "uf": "SP",
    "nome": "Santa Rita D'Oeste"
  },
  {
    "codigoTse": "70513",
    "ibgeCodigo": 3547502,
    "uf": "SP",
    "nome": "Santa Rita Do Passa Quatro"
  },
  {
    "codigoTse": "70530",
    "ibgeCodigo": 3547601,
    "uf": "SP",
    "nome": "Santa Rosa De Viterbo"
  },
  {
    "codigoTse": "70556",
    "ibgeCodigo": 3547700,
    "uf": "SP",
    "nome": "Santo Anast�cio"
  },
  {
    "codigoTse": "70572",
    "ibgeCodigo": 3547809,
    "uf": "SP",
    "nome": "Santo Andr�"
  },
  {
    "codigoTse": "70599",
    "ibgeCodigo": 3547908,
    "uf": "SP",
    "nome": "Santo Ant�nio Da Alegria"
  },
  {
    "codigoTse": "70610",
    "ibgeCodigo": 3548005,
    "uf": "SP",
    "nome": "Santo Ant�nio De Posse"
  },
  {
    "codigoTse": "70637",
    "ibgeCodigo": 3548104,
    "uf": "SP",
    "nome": "Santo Ant�nio Do Jardim"
  },
  {
    "codigoTse": "70653",
    "ibgeCodigo": 3548203,
    "uf": "SP",
    "nome": "Santo Ant�nio Do Pinhal"
  },
  {
    "codigoTse": "70670",
    "ibgeCodigo": 3548302,
    "uf": "SP",
    "nome": "Santo Expedito"
  },
  {
    "codigoTse": "70696",
    "ibgeCodigo": 3548401,
    "uf": "SP",
    "nome": "Sant�polis Do Aguape�"
  },
  {
    "codigoTse": "70718",
    "ibgeCodigo": 3548500,
    "uf": "SP",
    "nome": "Santos"
  },
  {
    "codigoTse": "70734",
    "ibgeCodigo": 3548609,
    "uf": "SP",
    "nome": "S�o Bento Do Sapuca�"
  },
  {
    "codigoTse": "70750",
    "ibgeCodigo": 3548708,
    "uf": "SP",
    "nome": "S�o Bernardo Do Campo"
  },
  {
    "codigoTse": "70777",
    "ibgeCodigo": 3548807,
    "uf": "SP",
    "nome": "S�o Caetano Do Sul"
  },
  {
    "codigoTse": "70793",
    "ibgeCodigo": 3548906,
    "uf": "SP",
    "nome": "S�o Carlos"
  },
  {
    "codigoTse": "70815",
    "ibgeCodigo": 3549003,
    "uf": "SP",
    "nome": "S�o Francisco"
  },
  {
    "codigoTse": "70831",
    "ibgeCodigo": 3549102,
    "uf": "SP",
    "nome": "S�o Jo�o Da Boa Vista"
  },
  {
    "codigoTse": "70858",
    "ibgeCodigo": 3549201,
    "uf": "SP",
    "nome": "S�o Jo�o Das Duas Pontes"
  },
  {
    "codigoTse": "70874",
    "ibgeCodigo": 3549300,
    "uf": "SP",
    "nome": "S�o Jo�o Do Pau D'Alho"
  },
  {
    "codigoTse": "70890",
    "ibgeCodigo": 3549409,
    "uf": "SP",
    "nome": "S�o Joaquim Da Barra"
  },
  {
    "codigoTse": "70912",
    "ibgeCodigo": 3549508,
    "uf": "SP",
    "nome": "S�o Jos� Da Bela Vista"
  },
  {
    "codigoTse": "70939",
    "ibgeCodigo": 3549607,
    "uf": "SP",
    "nome": "S�o Jos� Do Barreiro"
  },
  {
    "codigoTse": "70955",
    "ibgeCodigo": 3549706,
    "uf": "SP",
    "nome": "S�o Jos� Do Rio Pardo"
  },
  {
    "codigoTse": "70971",
    "ibgeCodigo": 3549805,
    "uf": "SP",
    "nome": "S�o Jos� Do Rio Preto"
  },
  {
    "codigoTse": "70998",
    "ibgeCodigo": 3549904,
    "uf": "SP",
    "nome": "S�o Jos� Dos Campos"
  },
  {
    "codigoTse": "71013",
    "ibgeCodigo": 3550001,
    "uf": "SP",
    "nome": "S�o Lu�s Do Paraitinga"
  },
  {
    "codigoTse": "71030",
    "ibgeCodigo": 3550100,
    "uf": "SP",
    "nome": "S�o Manuel"
  },
  {
    "codigoTse": "71056",
    "ibgeCodigo": 3550209,
    "uf": "SP",
    "nome": "S�o Miguel Arcanjo"
  },
  {
    "codigoTse": "71072",
    "ibgeCodigo": 3550308,
    "uf": "SP",
    "nome": "S�o Paulo"
  },
  {
    "codigoTse": "71099",
    "ibgeCodigo": 3550407,
    "uf": "SP",
    "nome": "S�o Pedro"
  },
  {
    "codigoTse": "71110",
    "ibgeCodigo": 3550506,
    "uf": "SP",
    "nome": "S�o Pedro Do Turvo"
  },
  {
    "codigoTse": "71137",
    "ibgeCodigo": 3550605,
    "uf": "SP",
    "nome": "S�o Roque"
  },
  {
    "codigoTse": "71153",
    "ibgeCodigo": 3550704,
    "uf": "SP",
    "nome": "S�o Sebasti�o"
  },
  {
    "codigoTse": "71170",
    "ibgeCodigo": 3550803,
    "uf": "SP",
    "nome": "S�o Sebasti�o Da Grama"
  },
  {
    "codigoTse": "71196",
    "ibgeCodigo": 3550902,
    "uf": "SP",
    "nome": "S�o Sim�o"
  },
  {
    "codigoTse": "71218",
    "ibgeCodigo": 3551009,
    "uf": "SP",
    "nome": "S�o Vicente"
  },
  {
    "codigoTse": "71234",
    "ibgeCodigo": 3551108,
    "uf": "SP",
    "nome": "Sarapu�"
  },
  {
    "codigoTse": "71250",
    "ibgeCodigo": 3551207,
    "uf": "SP",
    "nome": "Sarutai�"
  },
  {
    "codigoTse": "71277",
    "ibgeCodigo": 3551306,
    "uf": "SP",
    "nome": "Sebastian�polis Do Sul"
  },
  {
    "codigoTse": "71293",
    "ibgeCodigo": 3551405,
    "uf": "SP",
    "nome": "Serra Azul"
  },
  {
    "codigoTse": "71315",
    "ibgeCodigo": 3551504,
    "uf": "SP",
    "nome": "Serrana"
  },
  {
    "codigoTse": "71331",
    "ibgeCodigo": 3551603,
    "uf": "SP",
    "nome": "Serra Negra"
  },
  {
    "codigoTse": "71358",
    "ibgeCodigo": 3551702,
    "uf": "SP",
    "nome": "Sert�ozinho"
  },
  {
    "codigoTse": "71374",
    "ibgeCodigo": 3551801,
    "uf": "SP",
    "nome": "Sete Barras"
  },
  {
    "codigoTse": "71390",
    "ibgeCodigo": 3551900,
    "uf": "SP",
    "nome": "Sever�nia"
  },
  {
    "codigoTse": "71412",
    "ibgeCodigo": 3552007,
    "uf": "SP",
    "nome": "Silveiras"
  },
  {
    "codigoTse": "71439",
    "ibgeCodigo": 3552106,
    "uf": "SP",
    "nome": "Socorro"
  },
  {
    "codigoTse": "71455",
    "ibgeCodigo": 3552205,
    "uf": "SP",
    "nome": "Sorocaba"
  },
  {
    "codigoTse": "71471",
    "ibgeCodigo": 3552304,
    "uf": "SP",
    "nome": "Sud Mennucci"
  },
  {
    "codigoTse": "71498",
    "ibgeCodigo": 3552403,
    "uf": "SP",
    "nome": "Sumar�"
  },
  {
    "codigoTse": "71510",
    "ibgeCodigo": 3552502,
    "uf": "SP",
    "nome": "Suzano"
  },
  {
    "codigoTse": "71536",
    "ibgeCodigo": 3552601,
    "uf": "SP",
    "nome": "Tabapu�"
  },
  {
    "codigoTse": "71552",
    "ibgeCodigo": 3552700,
    "uf": "SP",
    "nome": "Tabatinga"
  },
  {
    "codigoTse": "71579",
    "ibgeCodigo": 3552809,
    "uf": "SP",
    "nome": "Tabo�o Da Serra"
  },
  {
    "codigoTse": "71595",
    "ibgeCodigo": 3552908,
    "uf": "SP",
    "nome": "Taciba"
  },
  {
    "codigoTse": "71617",
    "ibgeCodigo": 3553005,
    "uf": "SP",
    "nome": "Tagua�"
  },
  {
    "codigoTse": "71633",
    "ibgeCodigo": 3553104,
    "uf": "SP",
    "nome": "Taia�u"
  },
  {
    "codigoTse": "71650",
    "ibgeCodigo": 3553203,
    "uf": "SP",
    "nome": "Tai�va"
  },
  {
    "codigoTse": "71676",
    "ibgeCodigo": 3553302,
    "uf": "SP",
    "nome": "Tamba�"
  },
  {
    "codigoTse": "71692",
    "ibgeCodigo": 3553401,
    "uf": "SP",
    "nome": "Tanabi"
  },
  {
    "codigoTse": "71714",
    "ibgeCodigo": 3553500,
    "uf": "SP",
    "nome": "Tapira�"
  },
  {
    "codigoTse": "71730",
    "ibgeCodigo": 3553609,
    "uf": "SP",
    "nome": "Tapiratiba"
  },
  {
    "codigoTse": "71757",
    "ibgeCodigo": 3553708,
    "uf": "SP",
    "nome": "Taquaritinga"
  },
  {
    "codigoTse": "71773",
    "ibgeCodigo": 3553807,
    "uf": "SP",
    "nome": "Taquarituba"
  },
  {
    "codigoTse": "71790",
    "ibgeCodigo": 3553906,
    "uf": "SP",
    "nome": "Tarabai"
  },
  {
    "codigoTse": "71811",
    "ibgeCodigo": 3554003,
    "uf": "SP",
    "nome": "Tatu�"
  },
  {
    "codigoTse": "71838",
    "ibgeCodigo": 3554102,
    "uf": "SP",
    "nome": "Taubat�"
  },
  {
    "codigoTse": "71854",
    "ibgeCodigo": 3554201,
    "uf": "SP",
    "nome": "Tejup�"
  },
  {
    "codigoTse": "71870",
    "ibgeCodigo": 3554300,
    "uf": "SP",
    "nome": "Teodoro Sampaio"
  },
  {
    "codigoTse": "71897",
    "ibgeCodigo": 3554409,
    "uf": "SP",
    "nome": "Terra Roxa"
  },
  {
    "codigoTse": "71919",
    "ibgeCodigo": 3554508,
    "uf": "SP",
    "nome": "Tiet�"
  },
  {
    "codigoTse": "71935",
    "ibgeCodigo": 3554607,
    "uf": "SP",
    "nome": "Timburi"
  },
  {
    "codigoTse": "71951",
    "ibgeCodigo": 3554706,
    "uf": "SP",
    "nome": "Torrinha"
  },
  {
    "codigoTse": "71978",
    "ibgeCodigo": 3554805,
    "uf": "SP",
    "nome": "Trememb�"
  },
  {
    "codigoTse": "71994",
    "ibgeCodigo": 3554904,
    "uf": "SP",
    "nome": "Tr�s Fronteiras"
  },
  {
    "codigoTse": "72010",
    "ibgeCodigo": 3555000,
    "uf": "SP",
    "nome": "Tup�"
  },
  {
    "codigoTse": "72036",
    "ibgeCodigo": 3555109,
    "uf": "SP",
    "nome": "Tupi Paulista"
  },
  {
    "codigoTse": "72052",
    "ibgeCodigo": 3555208,
    "uf": "SP",
    "nome": "Turi�ba"
  },
  {
    "codigoTse": "72079",
    "ibgeCodigo": 3555307,
    "uf": "SP",
    "nome": "Turmalina"
  },
  {
    "codigoTse": "72095",
    "ibgeCodigo": 3555406,
    "uf": "SP",
    "nome": "Ubatuba"
  },
  {
    "codigoTse": "72117",
    "ibgeCodigo": 3555505,
    "uf": "SP",
    "nome": "Ubirajara"
  },
  {
    "codigoTse": "72133",
    "ibgeCodigo": 3555604,
    "uf": "SP",
    "nome": "Uchoa"
  },
  {
    "codigoTse": "72150",
    "ibgeCodigo": 3555703,
    "uf": "SP",
    "nome": "Uni�o Paulista"
  },
  {
    "codigoTse": "72176",
    "ibgeCodigo": 3555802,
    "uf": "SP",
    "nome": "Ur�nia"
  },
  {
    "codigoTse": "72192",
    "ibgeCodigo": 3555901,
    "uf": "SP",
    "nome": "Uru"
  },
  {
    "codigoTse": "72214",
    "ibgeCodigo": 3556008,
    "uf": "SP",
    "nome": "Urup�s"
  },
  {
    "codigoTse": "72230",
    "ibgeCodigo": 3556107,
    "uf": "SP",
    "nome": "Valentim Gentil"
  },
  {
    "codigoTse": "72257",
    "ibgeCodigo": 3556206,
    "uf": "SP",
    "nome": "Valinhos"
  },
  {
    "codigoTse": "72273",
    "ibgeCodigo": 3556305,
    "uf": "SP",
    "nome": "Valpara�so"
  },
  {
    "codigoTse": "72311",
    "ibgeCodigo": 3556404,
    "uf": "SP",
    "nome": "Vargem Grande Do Sul"
  },
  {
    "codigoTse": "72338",
    "ibgeCodigo": 3556503,
    "uf": "SP",
    "nome": "V�rzea Paulista"
  },
  {
    "codigoTse": "72354",
    "ibgeCodigo": 3556602,
    "uf": "SP",
    "nome": "Vera Cruz"
  },
  {
    "codigoTse": "72370",
    "ibgeCodigo": 3556701,
    "uf": "SP",
    "nome": "Vinhedo"
  },
  {
    "codigoTse": "72397",
    "ibgeCodigo": 3556800,
    "uf": "SP",
    "nome": "Viradouro"
  },
  {
    "codigoTse": "72419",
    "ibgeCodigo": 3556909,
    "uf": "SP",
    "nome": "Vista Alegre Do Alto"
  },
  {
    "codigoTse": "72435",
    "ibgeCodigo": 3557006,
    "uf": "SP",
    "nome": "Votorantim"
  },
  {
    "codigoTse": "72451",
    "ibgeCodigo": 3557105,
    "uf": "SP",
    "nome": "Votuporanga"
  },
  {
    "codigoTse": "72737",
    "ibgeCodigo": 3556453,
    "uf": "SP",
    "nome": "Vargem Grande Paulista"
  },
  {
    "codigoTse": "73008",
    "ibgeCodigo": 1700251,
    "uf": "TO",
    "nome": "Abreul�ndia"
  },
  {
    "codigoTse": "73016",
    "ibgeCodigo": 1717206,
    "uf": "TO",
    "nome": "Piraqu�"
  },
  {
    "codigoTse": "73024",
    "ibgeCodigo": 1718550,
    "uf": "TO",
    "nome": "Riachinho"
  },
  {
    "codigoTse": "73032",
    "ibgeCodigo": 1706506,
    "uf": "TO",
    "nome": "Darcin�polis"
  },
  {
    "codigoTse": "73040",
    "ibgeCodigo": 1713809,
    "uf": "TO",
    "nome": "Palmeiras Do Tocantins"
  },
  {
    "codigoTse": "73059",
    "ibgeCodigo": 1712801,
    "uf": "TO",
    "nome": "Mauril�ndia Do Tocantins"
  },
  {
    "codigoTse": "73067",
    "ibgeCodigo": 1703826,
    "uf": "TO",
    "nome": "Cachoeirinha"
  },
  {
    "codigoTse": "73075",
    "ibgeCodigo": 1701051,
    "uf": "TO",
    "nome": "Angico"
  },
  {
    "codigoTse": "73083",
    "ibgeCodigo": 1715705,
    "uf": "TO",
    "nome": "Palmeirante"
  },
  {
    "codigoTse": "73091",
    "ibgeCodigo": 1703842,
    "uf": "TO",
    "nome": "Campos Lindos"
  },
  {
    "codigoTse": "73105",
    "ibgeCodigo": 1720150,
    "uf": "TO",
    "nome": "S�o F�lix Do Tocantins"
  },
  {
    "codigoTse": "73113",
    "ibgeCodigo": 1711951,
    "uf": "TO",
    "nome": "Lagoa Do Tocantins"
  },
  {
    "codigoTse": "73121",
    "ibgeCodigo": 1703305,
    "uf": "TO",
    "nome": "Bom Jesus Do Tocantins"
  },
  {
    "codigoTse": "73130",
    "ibgeCodigo": 1718881,
    "uf": "TO",
    "nome": "Santa Maria Do Tocantins"
  },
  {
    "codigoTse": "73148",
    "ibgeCodigo": 1715150,
    "uf": "TO",
    "nome": "Novo Alegre"
  },
  {
    "codigoTse": "73156",
    "ibgeCodigo": 1718840,
    "uf": "TO",
    "nome": "Sandol�ndia"
  },
  {
    "codigoTse": "73164",
    "ibgeCodigo": 1720937,
    "uf": "TO",
    "nome": "Taipas Do Tocantins"
  },
  {
    "codigoTse": "73172",
    "ibgeCodigo": 1715259,
    "uf": "TO",
    "nome": "Novo Jardim"
  },
  {
    "codigoTse": "73180",
    "ibgeCodigo": 1720200,
    "uf": "TO",
    "nome": "S�o Miguel Do Tocantins"
  },
  {
    "codigoTse": "73199",
    "ibgeCodigo": 1708254,
    "uf": "TO",
    "nome": "Fortaleza Do Taboc�o"
  },
  {
    "codigoTse": "73202",
    "ibgeCodigo": 1710904,
    "uf": "TO",
    "nome": "Itapiratins"
  },
  {
    "codigoTse": "73210",
    "ibgeCodigo": 1704105,
    "uf": "TO",
    "nome": "Centen�rio"
  },
  {
    "codigoTse": "73229",
    "ibgeCodigo": 1718501,
    "uf": "TO",
    "nome": "Recursol�ndia"
  },
  {
    "codigoTse": "73237",
    "ibgeCodigo": 1721307,
    "uf": "TO",
    "nome": "Tupiratins"
  },
  {
    "codigoTse": "73245",
    "ibgeCodigo": 1703602,
    "uf": "TO",
    "nome": "Brasil�ndia Do Tocantins"
  },
  {
    "codigoTse": "73253",
    "ibgeCodigo": 1711803,
    "uf": "TO",
    "nome": "Juarina"
  },
  {
    "codigoTse": "73261",
    "ibgeCodigo": 1716307,
    "uf": "TO",
    "nome": "Pau D'Arco"
  },
  {
    "codigoTse": "73270",
    "ibgeCodigo": 1712702,
    "uf": "TO",
    "nome": "Mateiros"
  },
  {
    "codigoTse": "73288",
    "ibgeCodigo": 1720101,
    "uf": "TO",
    "nome": "S�o Bento Do Tocantins"
  },
  {
    "codigoTse": "73296",
    "ibgeCodigo": 1707405,
    "uf": "TO",
    "nome": "Esperantina"
  },
  {
    "codigoTse": "73300",
    "ibgeCodigo": 1703867,
    "uf": "TO",
    "nome": "Cariri Do Tocantins"
  },
  {
    "codigoTse": "73318",
    "ibgeCodigo": 1702158,
    "uf": "TO",
    "nome": "Araguan�"
  },
  {
    "codigoTse": "73326",
    "ibgeCodigo": 1703883,
    "uf": "TO",
    "nome": "Carmol�ndia"
  },
  {
    "codigoTse": "73334",
    "ibgeCodigo": 1701309,
    "uf": "TO",
    "nome": "Aragominas"
  },
  {
    "codigoTse": "73342",
    "ibgeCodigo": 1713957,
    "uf": "TO",
    "nome": "Muricil�ndia"
  },
  {
    "codigoTse": "73350",
    "ibgeCodigo": 1718865,
    "uf": "TO",
    "nome": "Santa F� Do Araguaia"
  },
  {
    "codigoTse": "73369",
    "ibgeCodigo": 1711506,
    "uf": "TO",
    "nome": "Ja� Do Tocantins"
  },
  {
    "codigoTse": "73377",
    "ibgeCodigo": 1720853,
    "uf": "TO",
    "nome": "Sucupira"
  },
  {
    "codigoTse": "73385",
    "ibgeCodigo": 1711902,
    "uf": "TO",
    "nome": "Lagoa Da Confus�o"
  },
  {
    "codigoTse": "73393",
    "ibgeCodigo": 1720259,
    "uf": "TO",
    "nome": "S�o Salvador Do Tocantins"
  },
  {
    "codigoTse": "73407",
    "ibgeCodigo": 1712009,
    "uf": "TO",
    "nome": "Lajeado"
  },
  {
    "codigoTse": "73415",
    "ibgeCodigo": 1718709,
    "uf": "TO",
    "nome": "Rio Dos Bois"
  },
  {
    "codigoTse": "73423",
    "ibgeCodigo": 1703891,
    "uf": "TO",
    "nome": "Carrasco Bonito"
  },
  {
    "codigoTse": "73431",
    "ibgeCodigo": 1718659,
    "uf": "TO",
    "nome": "Rio Da Concei��o"
  },
  {
    "codigoTse": "73440",
    "ibgeCodigo": 1721000,
    "uf": "TO",
    "nome": "Palmas"
  },
  {
    "codigoTse": "73458",
    "ibgeCodigo": 1721257,
    "uf": "TO",
    "nome": "Tupirama"
  },
  {
    "codigoTse": "73466",
    "ibgeCodigo": 1715507,
    "uf": "TO",
    "nome": "Oliveira De F�tima"
  },
  {
    "codigoTse": "73474",
    "ibgeCodigo": 1704600,
    "uf": "TO",
    "nome": "Chapada De Areia"
  },
  {
    "codigoTse": "73482",
    "ibgeCodigo": 1705102,
    "uf": "TO",
    "nome": "Chapada Da Natividade"
  },
  {
    "codigoTse": "73504",
    "ibgeCodigo": 1720978,
    "uf": "TO",
    "nome": "Talism�"
  },
  {
    "codigoTse": "73512",
    "ibgeCodigo": 1700301,
    "uf": "TO",
    "nome": "Aguiarn�polis"
  },
  {
    "codigoTse": "73520",
    "ibgeCodigo": 1712454,
    "uf": "TO",
    "nome": "Luzin�polis"
  },
  {
    "codigoTse": "73539",
    "ibgeCodigo": 1720002,
    "uf": "TO",
    "nome": "Santa Terezinha Do Tocantins"
  },
  {
    "codigoTse": "73547",
    "ibgeCodigo": 1718899,
    "uf": "TO",
    "nome": "Santa Rita Do Tocantins"
  },
  {
    "codigoTse": "73555",
    "ibgeCodigo": 1706258,
    "uf": "TO",
    "nome": "Crix�s Do Tocantins"
  },
  {
    "codigoTse": "73563",
    "ibgeCodigo": 1713700,
    "uf": "TO",
    "nome": "Monte Santo Do Tocantins"
  },
  {
    "codigoTse": "73571",
    "ibgeCodigo": 1718451,
    "uf": "TO",
    "nome": "Pugmil"
  },
  {
    "codigoTse": "73580",
    "ibgeCodigo": 1703057,
    "uf": "TO",
    "nome": "Bandeirantes Do Tocantins"
  },
  {
    "codigoTse": "73598",
    "ibgeCodigo": 1709807,
    "uf": "TO",
    "nome": "Ipueiras"
  },
  {
    "codigoTse": "73601",
    "ibgeCodigo": 1712157,
    "uf": "TO",
    "nome": "Lavandeira"
  },
  {
    "codigoTse": "73610",
    "ibgeCodigo": 1703073,
    "uf": "TO",
    "nome": "Barra Do Ouro"
  },
  {
    "codigoTse": "73709",
    "ibgeCodigo": 5101837,
    "uf": "MT",
    "nome": "Boa Esperan�a Do Norte"
  },
  {
    "codigoTse": "74004",
    "ibgeCodigo": 4108551,
    "uf": "PR",
    "nome": "Godoy Moreira"
  },
  {
    "codigoTse": "74012",
    "ibgeCodigo": 4100103,
    "uf": "PR",
    "nome": "Abati�"
  },
  {
    "codigoTse": "74020",
    "ibgeCodigo": 4109757,
    "uf": "PR",
    "nome": "Ibema"
  },
  {
    "codigoTse": "74039",
    "ibgeCodigo": 4100202,
    "uf": "PR",
    "nome": "Adrian�polis"
  },
  {
    "codigoTse": "74047",
    "ibgeCodigo": 4113452,
    "uf": "PR",
    "nome": "Lindoeste"
  },
  {
    "codigoTse": "74055",
    "ibgeCodigo": 4100301,
    "uf": "PR",
    "nome": "Agudos Do Sul"
  },
  {
    "codigoTse": "74063",
    "ibgeCodigo": 4117453,
    "uf": "PR",
    "nome": "Ouro Verde Do Oeste"
  },
  {
    "codigoTse": "74071",
    "ibgeCodigo": 4100400,
    "uf": "PR",
    "nome": "Almirante Tamandar�"
  },
  {
    "codigoTse": "74080",
    "ibgeCodigo": 4124020,
    "uf": "PR",
    "nome": "Santa Tereza Do Oeste"
  },
  {
    "codigoTse": "74098",
    "ibgeCodigo": 4100608,
    "uf": "PR",
    "nome": "Alto Paran�"
  },
  {
    "codigoTse": "74101",
    "ibgeCodigo": 4101051,
    "uf": "PR",
    "nome": "Anahy"
  },
  {
    "codigoTse": "74110",
    "ibgeCodigo": 4100707,
    "uf": "PR",
    "nome": "Alto Piquiri"
  },
  {
    "codigoTse": "74128",
    "ibgeCodigo": 4101150,
    "uf": "PR",
    "nome": "�ngulo"
  },
  {
    "codigoTse": "74136",
    "ibgeCodigo": 4100806,
    "uf": "PR",
    "nome": "Alvorada Do Sul"
  },
  {
    "codigoTse": "74144",
    "ibgeCodigo": 4103024,
    "uf": "PR",
    "nome": "Boa Esperan�a Do Igua�u"
  },
  {
    "codigoTse": "74152",
    "ibgeCodigo": 4100905,
    "uf": "PR",
    "nome": "Amapor�"
  },
  {
    "codigoTse": "74160",
    "ibgeCodigo": 4103222,
    "uf": "PR",
    "nome": "Bom Sucesso Do Sul"
  },
  {
    "codigoTse": "74179",
    "ibgeCodigo": 4101002,
    "uf": "PR",
    "nome": "Amp�re"
  },
  {
    "codigoTse": "74187",
    "ibgeCodigo": 4103370,
    "uf": "PR",
    "nome": "Brasil�ndia Do Sul"
  },
  {
    "codigoTse": "74195",
    "ibgeCodigo": 4101101,
    "uf": "PR",
    "nome": "Andir�"
  },
  {
    "codigoTse": "74209",
    "ibgeCodigo": 4103479,
    "uf": "PR",
    "nome": "Cafezal Do Sul"
  },
  {
    "codigoTse": "74217",
    "ibgeCodigo": 4101200,
    "uf": "PR",
    "nome": "Antonina"
  },
  {
    "codigoTse": "74225",
    "ibgeCodigo": 4104428,
    "uf": "PR",
    "nome": "Cand�i"
  },
  {
    "codigoTse": "74233",
    "ibgeCodigo": 4101309,
    "uf": "PR",
    "nome": "Ant�nio Olinto"
  },
  {
    "codigoTse": "74241",
    "ibgeCodigo": 4106571,
    "uf": "PR",
    "nome": "Cruzeiro Do Igua�u"
  },
  {
    "codigoTse": "74250",
    "ibgeCodigo": 4101408,
    "uf": "PR",
    "nome": "Apucarana"
  },
  {
    "codigoTse": "74268",
    "ibgeCodigo": 4107124,
    "uf": "PR",
    "nome": "Diamante Do Sul"
  },
  {
    "codigoTse": "74276",
    "ibgeCodigo": 4101507,
    "uf": "PR",
    "nome": "Arapongas"
  },
  {
    "codigoTse": "74284",
    "ibgeCodigo": 4107538,
    "uf": "PR",
    "nome": "Entre Rios Do Oeste"
  },
  {
    "codigoTse": "74292",
    "ibgeCodigo": 4101606,
    "uf": "PR",
    "nome": "Arapoti"
  },
  {
    "codigoTse": "74306",
    "ibgeCodigo": 4107553,
    "uf": "PR",
    "nome": "Farol"
  },
  {
    "codigoTse": "74314",
    "ibgeCodigo": 4101705,
    "uf": "PR",
    "nome": "Araruna"
  },
  {
    "codigoTse": "74322",
    "ibgeCodigo": 4107652,
    "uf": "PR",
    "nome": "Fazenda Rio Grande"
  },
  {
    "codigoTse": "74330",
    "ibgeCodigo": 4114906,
    "uf": "PR",
    "nome": "Maril�ndia Do Sul"
  },
  {
    "codigoTse": "74349",
    "ibgeCodigo": 4107850,
    "uf": "PR",
    "nome": "Flor Da Serra Do Sul"
  },
  {
    "codigoTse": "74357",
    "ibgeCodigo": 4101804,
    "uf": "PR",
    "nome": "Arauc�ria"
  },
  {
    "codigoTse": "74365",
    "ibgeCodigo": 4109658,
    "uf": "PR",
    "nome": "Hon�rio Serpa"
  },
  {
    "codigoTse": "74373",
    "ibgeCodigo": 4101903,
    "uf": "PR",
    "nome": "Assa�"
  },
  {
    "codigoTse": "74381",
    "ibgeCodigo": 4110052,
    "uf": "PR",
    "nome": "Iguatu"
  },
  {
    "codigoTse": "74390",
    "ibgeCodigo": 4102109,
    "uf": "PR",
    "nome": "Astorga"
  },
  {
    "codigoTse": "74403",
    "ibgeCodigo": 4110656,
    "uf": "PR",
    "nome": "Iracema Do Oeste"
  },
  {
    "codigoTse": "74411",
    "ibgeCodigo": 4102208,
    "uf": "PR",
    "nome": "Atalaia"
  },
  {
    "codigoTse": "74420",
    "ibgeCodigo": 4117297,
    "uf": "PR",
    "nome": "Novo Itacolomi"
  },
  {
    "codigoTse": "74438",
    "ibgeCodigo": 4102307,
    "uf": "PR",
    "nome": "Balsa Nova"
  },
  {
    "codigoTse": "74446",
    "ibgeCodigo": 4111258,
    "uf": "PR",
    "nome": "Itaperu�u"
  },
  {
    "codigoTse": "74454",
    "ibgeCodigo": 4102406,
    "uf": "PR",
    "nome": "Bandeirantes"
  },
  {
    "codigoTse": "74462",
    "ibgeCodigo": 4111555,
    "uf": "PR",
    "nome": "Ivat�"
  },
  {
    "codigoTse": "74470",
    "ibgeCodigo": 4102505,
    "uf": "PR",
    "nome": "Barbosa Ferraz"
  },
  {
    "codigoTse": "74489",
    "ibgeCodigo": 4113429,
    "uf": "PR",
    "nome": "Lidian�polis"
  },
  {
    "codigoTse": "74497",
    "ibgeCodigo": 4102604,
    "uf": "PR",
    "nome": "Barrac�o"
  },
  {
    "codigoTse": "74500",
    "ibgeCodigo": 4115358,
    "uf": "PR",
    "nome": "Marip�"
  },
  {
    "codigoTse": "74519",
    "ibgeCodigo": 4102703,
    "uf": "PR",
    "nome": "Barra Do Jacar�"
  },
  {
    "codigoTse": "74527",
    "ibgeCodigo": 4115739,
    "uf": "PR",
    "nome": "Mato Rico"
  },
  {
    "codigoTse": "74535",
    "ibgeCodigo": 4102802,
    "uf": "PR",
    "nome": "Bela Vista Do Para�so"
  },
  {
    "codigoTse": "74543",
    "ibgeCodigo": 4115754,
    "uf": "PR",
    "nome": "Mau� Da Serra"
  },
  {
    "codigoTse": "74551",
    "ibgeCodigo": 4102901,
    "uf": "PR",
    "nome": "Bituruna"
  },
  {
    "codigoTse": "74560",
    "ibgeCodigo": 4115853,
    "uf": "PR",
    "nome": "Mercedes"
  },
  {
    "codigoTse": "74578",
    "ibgeCodigo": 4103008,
    "uf": "PR",
    "nome": "Boa Esperan�a"
  },
  {
    "codigoTse": "74586",
    "ibgeCodigo": 4117057,
    "uf": "PR",
    "nome": "Nova Laranjeiras"
  },
  {
    "codigoTse": "74594",
    "ibgeCodigo": 4103107,
    "uf": "PR",
    "nome": "Bocai�va Do Sul"
  },
  {
    "codigoTse": "74608",
    "ibgeCodigo": 4117214,
    "uf": "PR",
    "nome": "Nova Santa B�rbara"
  },
  {
    "codigoTse": "74616",
    "ibgeCodigo": 4103206,
    "uf": "PR",
    "nome": "Bom Sucesso"
  },
  {
    "codigoTse": "74624",
    "ibgeCodigo": 4118451,
    "uf": "PR",
    "nome": "Pato Bragado"
  },
  {
    "codigoTse": "74632",
    "ibgeCodigo": 4103305,
    "uf": "PR",
    "nome": "Borraz�polis"
  },
  {
    "codigoTse": "74640",
    "ibgeCodigo": 4119251,
    "uf": "PR",
    "nome": "Pinhal De S�o Bento"
  },
  {
    "codigoTse": "74659",
    "ibgeCodigo": 4103404,
    "uf": "PR",
    "nome": "Cafeara"
  },
  {
    "codigoTse": "74667",
    "ibgeCodigo": 4119657,
    "uf": "PR",
    "nome": "Pitangueiras"
  },
  {
    "codigoTse": "74675",
    "ibgeCodigo": 4103503,
    "uf": "PR",
    "nome": "Calif�rnia"
  },
  {
    "codigoTse": "74683",
    "ibgeCodigo": 4120853,
    "uf": "PR",
    "nome": "Quatro Pontes"
  },
  {
    "codigoTse": "74691",
    "ibgeCodigo": 4103602,
    "uf": "PR",
    "nome": "Cambar�"
  },
  {
    "codigoTse": "74705",
    "ibgeCodigo": 4121257,
    "uf": "PR",
    "nome": "Ramil�ndia"
  },
  {
    "codigoTse": "74713",
    "ibgeCodigo": 4103701,
    "uf": "PR",
    "nome": "Camb�"
  },
  {
    "codigoTse": "74721",
    "ibgeCodigo": 4121356,
    "uf": "PR",
    "nome": "Rancho Alegre D'Oeste"
  },
  {
    "codigoTse": "74730",
    "ibgeCodigo": 4103800,
    "uf": "PR",
    "nome": "Cambira"
  },
  {
    "codigoTse": "74748",
    "ibgeCodigo": 4122156,
    "uf": "PR",
    "nome": "Rio Bonito Do Igua�u"
  },
  {
    "codigoTse": "74756",
    "ibgeCodigo": 4103909,
    "uf": "PR",
    "nome": "Campina Da Lagoa"
  },
  {
    "codigoTse": "74764",
    "ibgeCodigo": 4123824,
    "uf": "PR",
    "nome": "Santa L�cia"
  },
  {
    "codigoTse": "74772",
    "ibgeCodigo": 4104006,
    "uf": "PR",
    "nome": "Campina Grande Do Sul"
  },
  {
    "codigoTse": "74780",
    "ibgeCodigo": 4104055,
    "uf": "PR",
    "nome": "Campo Bonito"
  },
  {
    "codigoTse": "74799",
    "ibgeCodigo": 4104105,
    "uf": "PR",
    "nome": "Campo Do Tenente"
  },
  {
    "codigoTse": "74802",
    "ibgeCodigo": 4123857,
    "uf": "PR",
    "nome": "Santa Maria Do Oeste"
  },
  {
    "codigoTse": "74810",
    "ibgeCodigo": 4104204,
    "uf": "PR",
    "nome": "Campo Largo"
  },
  {
    "codigoTse": "74829",
    "ibgeCodigo": 4123956,
    "uf": "PR",
    "nome": "Santa M�nica"
  },
  {
    "codigoTse": "74837",
    "ibgeCodigo": 4104303,
    "uf": "PR",
    "nome": "Campo Mour�o"
  },
  {
    "codigoTse": "74845",
    "ibgeCodigo": 4125555,
    "uf": "PR",
    "nome": "S�o Manoel Do Paran�"
  },
  {
    "codigoTse": "74853",
    "ibgeCodigo": 4104402,
    "uf": "PR",
    "nome": "C�ndido De Abreu"
  },
  {
    "codigoTse": "74861",
    "ibgeCodigo": 4125753,
    "uf": "PR",
    "nome": "S�o Pedro Do Igua�u"
  },
  {
    "codigoTse": "74870",
    "ibgeCodigo": 4104501,
    "uf": "PR",
    "nome": "Capanema"
  },
  {
    "codigoTse": "74888",
    "ibgeCodigo": 4127882,
    "uf": "PR",
    "nome": "Tunas Do Paran�"
  },
  {
    "codigoTse": "74896",
    "ibgeCodigo": 4104600,
    "uf": "PR",
    "nome": "Capit�o Le�nidas Marques"
  },
  {
    "codigoTse": "74900",
    "ibgeCodigo": 4128534,
    "uf": "PR",
    "nome": "Ventania"
  },
  {
    "codigoTse": "74918",
    "ibgeCodigo": 4104709,
    "uf": "PR",
    "nome": "Carl�polis"
  },
  {
    "codigoTse": "74926",
    "ibgeCodigo": 4128625,
    "uf": "PR",
    "nome": "Alto Para�so"
  },
  {
    "codigoTse": "74934",
    "ibgeCodigo": 4104808,
    "uf": "PR",
    "nome": "Cascavel"
  },
  {
    "codigoTse": "74942",
    "ibgeCodigo": 4128633,
    "uf": "PR",
    "nome": "Doutor Ulysses"
  },
  {
    "codigoTse": "74950",
    "ibgeCodigo": 4104907,
    "uf": "PR",
    "nome": "Castro"
  },
  {
    "codigoTse": "74969",
    "ibgeCodigo": 4128658,
    "uf": "PR",
    "nome": "Virmond"
  },
  {
    "codigoTse": "74977",
    "ibgeCodigo": 4105003,
    "uf": "PR",
    "nome": "Catanduvas"
  },
  {
    "codigoTse": "74985",
    "ibgeCodigo": 4113254,
    "uf": "PR",
    "nome": "Laranjal"
  },
  {
    "codigoTse": "74993",
    "ibgeCodigo": 4105102,
    "uf": "PR",
    "nome": "Centen�rio Do Sul"
  },
  {
    "codigoTse": "75000",
    "ibgeCodigo": 4110953,
    "uf": "PR",
    "nome": "Itaipul�ndia"
  },
  {
    "codigoTse": "75019",
    "ibgeCodigo": 4105201,
    "uf": "PR",
    "nome": "Cerro Azul"
  },
  {
    "codigoTse": "75027",
    "ibgeCodigo": 4116950,
    "uf": "PR",
    "nome": "Nova Esperan�a Do Sudoeste"
  },
  {
    "codigoTse": "75035",
    "ibgeCodigo": 4105409,
    "uf": "PR",
    "nome": "Chopinzinho"
  },
  {
    "codigoTse": "75043",
    "ibgeCodigo": 4119152,
    "uf": "PR",
    "nome": "Pinhais"
  },
  {
    "codigoTse": "75051",
    "ibgeCodigo": 4105508,
    "uf": "PR",
    "nome": "Cianorte"
  },
  {
    "codigoTse": "75060",
    "ibgeCodigo": 4126272,
    "uf": "PR",
    "nome": "Saudade Do Igua�u"
  },
  {
    "codigoTse": "75078",
    "ibgeCodigo": 4105607,
    "uf": "PR",
    "nome": "Cidade Ga�cha"
  },
  {
    "codigoTse": "75086",
    "ibgeCodigo": 4101853,
    "uf": "PR",
    "nome": "Ariranha Do Iva�"
  },
  {
    "codigoTse": "75094",
    "ibgeCodigo": 4105706,
    "uf": "PR",
    "nome": "Clevel�ndia"
  },
  {
    "codigoTse": "75108",
    "ibgeCodigo": 4101655,
    "uf": "PR",
    "nome": "Arapu�"
  },
  {
    "codigoTse": "75116",
    "ibgeCodigo": 4114401,
    "uf": "PR",
    "nome": "Mangueirinha"
  },
  {
    "codigoTse": "75124",
    "ibgeCodigo": 4102752,
    "uf": "PR",
    "nome": "Bela Vista Da Caroba"
  },
  {
    "codigoTse": "75132",
    "ibgeCodigo": 4105805,
    "uf": "PR",
    "nome": "Colombo"
  },
  {
    "codigoTse": "75140",
    "ibgeCodigo": 4103040,
    "uf": "PR",
    "nome": "Boa Ventura De S�o Roque"
  },
  {
    "codigoTse": "75159",
    "ibgeCodigo": 4105904,
    "uf": "PR",
    "nome": "Colorado"
  },
  {
    "codigoTse": "75167",
    "ibgeCodigo": 4103156,
    "uf": "PR",
    "nome": "Bom Jesus Do Sul"
  },
  {
    "codigoTse": "75175",
    "ibgeCodigo": 4106001,
    "uf": "PR",
    "nome": "Congonhinhas"
  },
  {
    "codigoTse": "75183",
    "ibgeCodigo": 4103958,
    "uf": "PR",
    "nome": "Campina Do Sim�o"
  },
  {
    "codigoTse": "75191",
    "ibgeCodigo": 4106100,
    "uf": "PR",
    "nome": "Conselheiro Mairinck"
  },
  {
    "codigoTse": "75205",
    "ibgeCodigo": 4104253,
    "uf": "PR",
    "nome": "Campo Magro"
  },
  {
    "codigoTse": "75213",
    "ibgeCodigo": 4106209,
    "uf": "PR",
    "nome": "Contenda"
  },
  {
    "codigoTse": "75221",
    "ibgeCodigo": 4104659,
    "uf": "PR",
    "nome": "Carambe�"
  },
  {
    "codigoTse": "75230",
    "ibgeCodigo": 4106308,
    "uf": "PR",
    "nome": "Corb�lia"
  },
  {
    "codigoTse": "75248",
    "ibgeCodigo": 4106456,
    "uf": "PR",
    "nome": "Coronel Domingos Soares"
  },
  {
    "codigoTse": "75256",
    "ibgeCodigo": 4106407,
    "uf": "PR",
    "nome": "Corn�lio Proc�pio"
  },
  {
    "codigoTse": "75264",
    "ibgeCodigo": 4106852,
    "uf": "PR",
    "nome": "Cruzmaltina"
  },
  {
    "codigoTse": "75272",
    "ibgeCodigo": 4106506,
    "uf": "PR",
    "nome": "Coronel Vivida"
  },
  {
    "codigoTse": "75280",
    "ibgeCodigo": 4106555,
    "uf": "PR",
    "nome": "Corumbata� Do Sul"
  },
  {
    "codigoTse": "75299",
    "ibgeCodigo": 4106605,
    "uf": "PR",
    "nome": "Cruzeiro Do Oeste"
  },
  {
    "codigoTse": "75302",
    "ibgeCodigo": 4107520,
    "uf": "PR",
    "nome": "Esperan�a Nova"
  },
  {
    "codigoTse": "75310",
    "ibgeCodigo": 4106704,
    "uf": "PR",
    "nome": "Cruzeiro Do Sul"
  },
  {
    "codigoTse": "75329",
    "ibgeCodigo": 4107546,
    "uf": "PR",
    "nome": "Espig�o Alto Do Igua�u"
  },
  {
    "codigoTse": "75337",
    "ibgeCodigo": 4106803,
    "uf": "PR",
    "nome": "Cruz Machado"
  },
  {
    "codigoTse": "75345",
    "ibgeCodigo": 4107736,
    "uf": "PR",
    "nome": "Fernandes Pinheiro"
  },
  {
    "codigoTse": "75353",
    "ibgeCodigo": 4106902,
    "uf": "PR",
    "nome": "Curitiba"
  },
  {
    "codigoTse": "75361",
    "ibgeCodigo": 4108452,
    "uf": "PR",
    "nome": "Foz Do Jord�o"
  },
  {
    "codigoTse": "75370",
    "ibgeCodigo": 4107009,
    "uf": "PR",
    "nome": "Curi�va"
  },
  {
    "codigoTse": "75388",
    "ibgeCodigo": 4108650,
    "uf": "PR",
    "nome": "Goioxim"
  },
  {
    "codigoTse": "75396",
    "ibgeCodigo": 4107108,
    "uf": "PR",
    "nome": "Diamante Do Norte"
  },
  {
    "codigoTse": "75400",
    "ibgeCodigo": 4107157,
    "uf": "PR",
    "nome": "Diamante D'Oeste"
  },
  {
    "codigoTse": "75418",
    "ibgeCodigo": 4107207,
    "uf": "PR",
    "nome": "Dois Vizinhos"
  },
  {
    "codigoTse": "75426",
    "ibgeCodigo": 4108957,
    "uf": "PR",
    "nome": "Guamiranga"
  },
  {
    "codigoTse": "75434",
    "ibgeCodigo": 4107306,
    "uf": "PR",
    "nome": "Doutor Camargo"
  },
  {
    "codigoTse": "75442",
    "ibgeCodigo": 4110078,
    "uf": "PR",
    "nome": "Imba�"
  },
  {
    "codigoTse": "75450",
    "ibgeCodigo": 4107405,
    "uf": "PR",
    "nome": "En�as Marques"
  },
  {
    "codigoTse": "75469",
    "ibgeCodigo": 4114351,
    "uf": "PR",
    "nome": "Manfrin�polis"
  },
  {
    "codigoTse": "75477",
    "ibgeCodigo": 4107504,
    "uf": "PR",
    "nome": "Engenheiro Beltr�o"
  },
  {
    "codigoTse": "75485",
    "ibgeCodigo": 4115457,
    "uf": "PR",
    "nome": "Marquinho"
  },
  {
    "codigoTse": "75493",
    "ibgeCodigo": 4107603,
    "uf": "PR",
    "nome": "Faxinal"
  },
  {
    "codigoTse": "75507",
    "ibgeCodigo": 4118857,
    "uf": "PR",
    "nome": "Perobal"
  },
  {
    "codigoTse": "75515",
    "ibgeCodigo": 4107702,
    "uf": "PR",
    "nome": "F�nix"
  },
  {
    "codigoTse": "75523",
    "ibgeCodigo": 4119954,
    "uf": "PR",
    "nome": "Pontal Do Paran�"
  },
  {
    "codigoTse": "75531",
    "ibgeCodigo": 4107801,
    "uf": "PR",
    "nome": "Flora�"
  },
  {
    "codigoTse": "75540",
    "ibgeCodigo": 4120150,
    "uf": "PR",
    "nome": "Porto Barreiro"
  },
  {
    "codigoTse": "75558",
    "ibgeCodigo": 4107900,
    "uf": "PR",
    "nome": "Floresta"
  },
  {
    "codigoTse": "75566",
    "ibgeCodigo": 4120333,
    "uf": "PR",
    "nome": "Prado Ferreira"
  },
  {
    "codigoTse": "75574",
    "ibgeCodigo": 4108007,
    "uf": "PR",
    "nome": "Florest�polis"
  },
  {
    "codigoTse": "75582",
    "ibgeCodigo": 4120655,
    "uf": "PR",
    "nome": "Quarto Centen�rio"
  },
  {
    "codigoTse": "75590",
    "ibgeCodigo": 4108106,
    "uf": "PR",
    "nome": "Fl�rida"
  },
  {
    "codigoTse": "75604",
    "ibgeCodigo": 4121752,
    "uf": "PR",
    "nome": "Reserva Do Igua�u"
  },
  {
    "codigoTse": "75612",
    "ibgeCodigo": 4108205,
    "uf": "PR",
    "nome": "Formosa Do Oeste"
  },
  {
    "codigoTse": "75620",
    "ibgeCodigo": 4122172,
    "uf": "PR",
    "nome": "Rio Branco Do Iva�"
  },
  {
    "codigoTse": "75639",
    "ibgeCodigo": 4108304,
    "uf": "PR",
    "nome": "Foz Do Igua�u"
  },
  {
    "codigoTse": "75647",
    "ibgeCodigo": 4126355,
    "uf": "PR",
    "nome": "Serran�polis Do Igua�u"
  },
  {
    "codigoTse": "75655",
    "ibgeCodigo": 4108403,
    "uf": "PR",
    "nome": "Francisco Beltr�o"
  },
  {
    "codigoTse": "75663",
    "ibgeCodigo": 4126678,
    "uf": "PR",
    "nome": "Tamarana"
  },
  {
    "codigoTse": "75671",
    "ibgeCodigo": 4108502,
    "uf": "PR",
    "nome": "General Carneiro"
  },
  {
    "codigoTse": "75698",
    "ibgeCodigo": 4108601,
    "uf": "PR",
    "nome": "Goioer�"
  },
  {
    "codigoTse": "75710",
    "ibgeCodigo": 4108809,
    "uf": "PR",
    "nome": "Gua�ra"
  },
  {
    "codigoTse": "75736",
    "ibgeCodigo": 4108908,
    "uf": "PR",
    "nome": "Guaira��"
  },
  {
    "codigoTse": "75744",
    "ibgeCodigo": 4122651,
    "uf": "PR",
    "nome": "Ros�rio Do Iva�"
  },
  {
    "codigoTse": "75752",
    "ibgeCodigo": 4109005,
    "uf": "PR",
    "nome": "Guapirama"
  },
  {
    "codigoTse": "75760",
    "ibgeCodigo": 4117271,
    "uf": "PR",
    "nome": "Nova Tebas"
  },
  {
    "codigoTse": "75779",
    "ibgeCodigo": 4109104,
    "uf": "PR",
    "nome": "Guaporema"
  },
  {
    "codigoTse": "75787",
    "ibgeCodigo": 4126652,
    "uf": "PR",
    "nome": "Sulina"
  },
  {
    "codigoTse": "75795",
    "ibgeCodigo": 4109203,
    "uf": "PR",
    "nome": "Guaraci"
  },
  {
    "codigoTse": "75809",
    "ibgeCodigo": 4113734,
    "uf": "PR",
    "nome": "Luiziana"
  },
  {
    "codigoTse": "75817",
    "ibgeCodigo": 4109302,
    "uf": "PR",
    "nome": "Guarania�u"
  },
  {
    "codigoTse": "75833",
    "ibgeCodigo": 4109401,
    "uf": "PR",
    "nome": "Guarapuava"
  },
  {
    "codigoTse": "75850",
    "ibgeCodigo": 4109500,
    "uf": "PR",
    "nome": "Guaraque�aba"
  },
  {
    "codigoTse": "75876",
    "ibgeCodigo": 4109609,
    "uf": "PR",
    "nome": "Guaratuba"
  },
  {
    "codigoTse": "75892",
    "ibgeCodigo": 4109708,
    "uf": "PR",
    "nome": "Ibaiti"
  },
  {
    "codigoTse": "75914",
    "ibgeCodigo": 4109807,
    "uf": "PR",
    "nome": "Ibipor�"
  },
  {
    "codigoTse": "75930",
    "ibgeCodigo": 4109906,
    "uf": "PR",
    "nome": "Icara�ma"
  },
  {
    "codigoTse": "75957",
    "ibgeCodigo": 4110003,
    "uf": "PR",
    "nome": "Iguara�u"
  },
  {
    "codigoTse": "75973",
    "ibgeCodigo": 4110102,
    "uf": "PR",
    "nome": "Imbituva"
  },
  {
    "codigoTse": "75990",
    "ibgeCodigo": 4110201,
    "uf": "PR",
    "nome": "In�cio Martins"
  },
  {
    "codigoTse": "76015",
    "ibgeCodigo": 4110300,
    "uf": "PR",
    "nome": "Inaj�"
  },
  {
    "codigoTse": "76031",
    "ibgeCodigo": 4110508,
    "uf": "PR",
    "nome": "Ipiranga"
  },
  {
    "codigoTse": "76058",
    "ibgeCodigo": 4110607,
    "uf": "PR",
    "nome": "Ipor�"
  },
  {
    "codigoTse": "76074",
    "ibgeCodigo": 4110706,
    "uf": "PR",
    "nome": "Irati"
  },
  {
    "codigoTse": "76090",
    "ibgeCodigo": 4110805,
    "uf": "PR",
    "nome": "Iretama"
  },
  {
    "codigoTse": "76112",
    "ibgeCodigo": 4110904,
    "uf": "PR",
    "nome": "Itaguaj�"
  },
  {
    "codigoTse": "76139",
    "ibgeCodigo": 4111001,
    "uf": "PR",
    "nome": "Itambarac�"
  },
  {
    "codigoTse": "76155",
    "ibgeCodigo": 4111100,
    "uf": "PR",
    "nome": "Itamb�"
  },
  {
    "codigoTse": "76171",
    "ibgeCodigo": 4111209,
    "uf": "PR",
    "nome": "Itapejara D'Oeste"
  },
  {
    "codigoTse": "76198",
    "ibgeCodigo": 4111308,
    "uf": "PR",
    "nome": "Ita�na Do Sul"
  },
  {
    "codigoTse": "76210",
    "ibgeCodigo": 4111407,
    "uf": "PR",
    "nome": "Iva�"
  },
  {
    "codigoTse": "76236",
    "ibgeCodigo": 4111506,
    "uf": "PR",
    "nome": "Ivaipor�"
  },
  {
    "codigoTse": "76252",
    "ibgeCodigo": 4111605,
    "uf": "PR",
    "nome": "Ivatuba"
  },
  {
    "codigoTse": "76279",
    "ibgeCodigo": 4111704,
    "uf": "PR",
    "nome": "Jaboti"
  },
  {
    "codigoTse": "76295",
    "ibgeCodigo": 4111803,
    "uf": "PR",
    "nome": "Jacarezinho"
  },
  {
    "codigoTse": "76317",
    "ibgeCodigo": 4111902,
    "uf": "PR",
    "nome": "Jaguapit�"
  },
  {
    "codigoTse": "76333",
    "ibgeCodigo": 4112009,
    "uf": "PR",
    "nome": "Jaguaria�va"
  },
  {
    "codigoTse": "76350",
    "ibgeCodigo": 4112108,
    "uf": "PR",
    "nome": "Jandaia Do Sul"
  },
  {
    "codigoTse": "76376",
    "ibgeCodigo": 4112207,
    "uf": "PR",
    "nome": "Jani�polis"
  },
  {
    "codigoTse": "76392",
    "ibgeCodigo": 4112306,
    "uf": "PR",
    "nome": "Japira"
  },
  {
    "codigoTse": "76414",
    "ibgeCodigo": 4112405,
    "uf": "PR",
    "nome": "Japur�"
  },
  {
    "codigoTse": "76430",
    "ibgeCodigo": 4112504,
    "uf": "PR",
    "nome": "Jardim Alegre"
  },
  {
    "codigoTse": "76457",
    "ibgeCodigo": 4112603,
    "uf": "PR",
    "nome": "Jardim Olinda"
  },
  {
    "codigoTse": "76473",
    "ibgeCodigo": 4112702,
    "uf": "PR",
    "nome": "Jataizinho"
  },
  {
    "codigoTse": "76490",
    "ibgeCodigo": 4112801,
    "uf": "PR",
    "nome": "Joaquim T�vora"
  },
  {
    "codigoTse": "76511",
    "ibgeCodigo": 4112900,
    "uf": "PR",
    "nome": "Jundia� Do Sul"
  },
  {
    "codigoTse": "76538",
    "ibgeCodigo": 4113007,
    "uf": "PR",
    "nome": "Jussara"
  },
  {
    "codigoTse": "76554",
    "ibgeCodigo": 4113106,
    "uf": "PR",
    "nome": "Kalor�"
  },
  {
    "codigoTse": "76570",
    "ibgeCodigo": 4113205,
    "uf": "PR",
    "nome": "Lapa"
  },
  {
    "codigoTse": "76597",
    "ibgeCodigo": 4113304,
    "uf": "PR",
    "nome": "Laranjeiras Do Sul"
  },
  {
    "codigoTse": "76619",
    "ibgeCodigo": 4113403,
    "uf": "PR",
    "nome": "Le�polis"
  },
  {
    "codigoTse": "76635",
    "ibgeCodigo": 4113502,
    "uf": "PR",
    "nome": "Loanda"
  },
  {
    "codigoTse": "76651",
    "ibgeCodigo": 4113601,
    "uf": "PR",
    "nome": "Lobato"
  },
  {
    "codigoTse": "76678",
    "ibgeCodigo": 4113700,
    "uf": "PR",
    "nome": "Londrina"
  },
  {
    "codigoTse": "76694",
    "ibgeCodigo": 4113809,
    "uf": "PR",
    "nome": "Lupion�polis"
  },
  {
    "codigoTse": "76716",
    "ibgeCodigo": 4113908,
    "uf": "PR",
    "nome": "Mallet"
  },
  {
    "codigoTse": "76732",
    "ibgeCodigo": 4114005,
    "uf": "PR",
    "nome": "Mambor�"
  },
  {
    "codigoTse": "76759",
    "ibgeCodigo": 4114104,
    "uf": "PR",
    "nome": "Mandagua�u"
  },
  {
    "codigoTse": "76775",
    "ibgeCodigo": 4114203,
    "uf": "PR",
    "nome": "Mandaguari"
  },
  {
    "codigoTse": "76791",
    "ibgeCodigo": 4114302,
    "uf": "PR",
    "nome": "Mandirituba"
  },
  {
    "codigoTse": "76813",
    "ibgeCodigo": 4114500,
    "uf": "PR",
    "nome": "Manoel Ribas"
  },
  {
    "codigoTse": "76830",
    "ibgeCodigo": 4114609,
    "uf": "PR",
    "nome": "Marechal C�ndido Rondon"
  },
  {
    "codigoTse": "76856",
    "ibgeCodigo": 4114708,
    "uf": "PR",
    "nome": "Maria Helena"
  },
  {
    "codigoTse": "76872",
    "ibgeCodigo": 4114807,
    "uf": "PR",
    "nome": "Marialva"
  },
  {
    "codigoTse": "76899",
    "ibgeCodigo": 4115101,
    "uf": "PR",
    "nome": "Mariluz"
  },
  {
    "codigoTse": "76910",
    "ibgeCodigo": 4115200,
    "uf": "PR",
    "nome": "Maring�"
  },
  {
    "codigoTse": "76937",
    "ibgeCodigo": 4115309,
    "uf": "PR",
    "nome": "Mari�polis"
  },
  {
    "codigoTse": "76953",
    "ibgeCodigo": 4115408,
    "uf": "PR",
    "nome": "Marmeleiro"
  },
  {
    "codigoTse": "76970",
    "ibgeCodigo": 4115507,
    "uf": "PR",
    "nome": "Marumbi"
  },
  {
    "codigoTse": "76996",
    "ibgeCodigo": 4115606,
    "uf": "PR",
    "nome": "Matel�ndia"
  },
  {
    "codigoTse": "77011",
    "ibgeCodigo": 4115804,
    "uf": "PR",
    "nome": "Medianeira"
  },
  {
    "codigoTse": "77038",
    "ibgeCodigo": 4115903,
    "uf": "PR",
    "nome": "Mirador"
  },
  {
    "codigoTse": "77054",
    "ibgeCodigo": 4116000,
    "uf": "PR",
    "nome": "Miraselva"
  },
  {
    "codigoTse": "77070",
    "ibgeCodigo": 4116109,
    "uf": "PR",
    "nome": "Moreira Sales"
  },
  {
    "codigoTse": "77097",
    "ibgeCodigo": 4116208,
    "uf": "PR",
    "nome": "Morretes"
  },
  {
    "codigoTse": "77119",
    "ibgeCodigo": 4116307,
    "uf": "PR",
    "nome": "Munhoz De Melo"
  },
  {
    "codigoTse": "77135",
    "ibgeCodigo": 4116406,
    "uf": "PR",
    "nome": "Nossa Senhora Das Gra�as"
  },
  {
    "codigoTse": "77151",
    "ibgeCodigo": 4116505,
    "uf": "PR",
    "nome": "Nova Alian�a Do Iva�"
  },
  {
    "codigoTse": "77178",
    "ibgeCodigo": 4116604,
    "uf": "PR",
    "nome": "Nova Am�rica Da Colina"
  },
  {
    "codigoTse": "77194",
    "ibgeCodigo": 4116802,
    "uf": "PR",
    "nome": "Nova Cantu"
  },
  {
    "codigoTse": "77216",
    "ibgeCodigo": 4116901,
    "uf": "PR",
    "nome": "Nova Esperan�a"
  },
  {
    "codigoTse": "77232",
    "ibgeCodigo": 4117008,
    "uf": "PR",
    "nome": "Nova F�tima"
  },
  {
    "codigoTse": "77259",
    "ibgeCodigo": 4117107,
    "uf": "PR",
    "nome": "Nova Londrina"
  },
  {
    "codigoTse": "77275",
    "ibgeCodigo": 4117305,
    "uf": "PR",
    "nome": "Ortigueira"
  },
  {
    "codigoTse": "77291",
    "ibgeCodigo": 4117404,
    "uf": "PR",
    "nome": "Ourizona"
  },
  {
    "codigoTse": "77313",
    "ibgeCodigo": 4117503,
    "uf": "PR",
    "nome": "Pai�andu"
  },
  {
    "codigoTse": "77330",
    "ibgeCodigo": 4117602,
    "uf": "PR",
    "nome": "Palmas"
  },
  {
    "codigoTse": "77356",
    "ibgeCodigo": 4117701,
    "uf": "PR",
    "nome": "Palmeira"
  },
  {
    "codigoTse": "77372",
    "ibgeCodigo": 4117800,
    "uf": "PR",
    "nome": "Palmital"
  },
  {
    "codigoTse": "77399",
    "ibgeCodigo": 4117909,
    "uf": "PR",
    "nome": "Palotina"
  },
  {
    "codigoTse": "77410",
    "ibgeCodigo": 4118006,
    "uf": "PR",
    "nome": "Para�so Do Norte"
  },
  {
    "codigoTse": "77437",
    "ibgeCodigo": 4118105,
    "uf": "PR",
    "nome": "Paranacity"
  },
  {
    "codigoTse": "77453",
    "ibgeCodigo": 4118204,
    "uf": "PR",
    "nome": "Paranagu�"
  },
  {
    "codigoTse": "77470",
    "ibgeCodigo": 4118303,
    "uf": "PR",
    "nome": "Paranapoema"
  },
  {
    "codigoTse": "77496",
    "ibgeCodigo": 4118402,
    "uf": "PR",
    "nome": "Paranava�"
  },
  {
    "codigoTse": "77518",
    "ibgeCodigo": 4118501,
    "uf": "PR",
    "nome": "Pato Branco"
  },
  {
    "codigoTse": "77534",
    "ibgeCodigo": 4118600,
    "uf": "PR",
    "nome": "Paula Freitas"
  },
  {
    "codigoTse": "77550",
    "ibgeCodigo": 4118709,
    "uf": "PR",
    "nome": "Paulo Frontin"
  },
  {
    "codigoTse": "77577",
    "ibgeCodigo": 4118808,
    "uf": "PR",
    "nome": "Peabiru"
  },
  {
    "codigoTse": "77593",
    "ibgeCodigo": 4119004,
    "uf": "PR",
    "nome": "P�rola D'Oeste"
  },
  {
    "codigoTse": "77615",
    "ibgeCodigo": 4119103,
    "uf": "PR",
    "nome": "Pi�n"
  },
  {
    "codigoTse": "77631",
    "ibgeCodigo": 4119202,
    "uf": "PR",
    "nome": "Pinhal�o"
  },
  {
    "codigoTse": "77658",
    "ibgeCodigo": 4119301,
    "uf": "PR",
    "nome": "Pinh�o"
  },
  {
    "codigoTse": "77674",
    "ibgeCodigo": 4119400,
    "uf": "PR",
    "nome": "Pira� Do Sul"
  },
  {
    "codigoTse": "77690",
    "ibgeCodigo": 4119509,
    "uf": "PR",
    "nome": "Piraquara"
  },
  {
    "codigoTse": "77712",
    "ibgeCodigo": 4119608,
    "uf": "PR",
    "nome": "Pitanga"
  },
  {
    "codigoTse": "77739",
    "ibgeCodigo": 4119707,
    "uf": "PR",
    "nome": "Planaltina Do Paran�"
  },
  {
    "codigoTse": "77755",
    "ibgeCodigo": 4119806,
    "uf": "PR",
    "nome": "Planalto"
  },
  {
    "codigoTse": "77771",
    "ibgeCodigo": 4119905,
    "uf": "PR",
    "nome": "Ponta Grossa"
  },
  {
    "codigoTse": "77798",
    "ibgeCodigo": 4120002,
    "uf": "PR",
    "nome": "Porecatu"
  },
  {
    "codigoTse": "77810",
    "ibgeCodigo": 4120101,
    "uf": "PR",
    "nome": "Porto Amazonas"
  },
  {
    "codigoTse": "77836",
    "ibgeCodigo": 4120200,
    "uf": "PR",
    "nome": "Porto Rico"
  },
  {
    "codigoTse": "77852",
    "ibgeCodigo": 4120309,
    "uf": "PR",
    "nome": "Porto Vit�ria"
  },
  {
    "codigoTse": "77879",
    "ibgeCodigo": 4120408,
    "uf": "PR",
    "nome": "Presidente Castelo Branco"
  },
  {
    "codigoTse": "77895",
    "ibgeCodigo": 4120507,
    "uf": "PR",
    "nome": "Primeiro De Maio"
  },
  {
    "codigoTse": "77917",
    "ibgeCodigo": 4120606,
    "uf": "PR",
    "nome": "Prudent�polis"
  },
  {
    "codigoTse": "77933",
    "ibgeCodigo": 4120705,
    "uf": "PR",
    "nome": "Quatigu�"
  },
  {
    "codigoTse": "77950",
    "ibgeCodigo": 4120804,
    "uf": "PR",
    "nome": "Quatro Barras"
  },
  {
    "codigoTse": "77976",
    "ibgeCodigo": 4121000,
    "uf": "PR",
    "nome": "Quer�ncia Do Norte"
  },
  {
    "codigoTse": "77992",
    "ibgeCodigo": 4121109,
    "uf": "PR",
    "nome": "Quinta Do Sol"
  },
  {
    "codigoTse": "78018",
    "ibgeCodigo": 4121208,
    "uf": "PR",
    "nome": "Quitandinha"
  },
  {
    "codigoTse": "78034",
    "ibgeCodigo": 4121307,
    "uf": "PR",
    "nome": "Rancho Alegre"
  },
  {
    "codigoTse": "78050",
    "ibgeCodigo": 4121406,
    "uf": "PR",
    "nome": "Realeza"
  },
  {
    "codigoTse": "78077",
    "ibgeCodigo": 4121505,
    "uf": "PR",
    "nome": "Rebou�as"
  },
  {
    "codigoTse": "78093",
    "ibgeCodigo": 4121604,
    "uf": "PR",
    "nome": "Renascen�a"
  },
  {
    "codigoTse": "78115",
    "ibgeCodigo": 4121703,
    "uf": "PR",
    "nome": "Reserva"
  },
  {
    "codigoTse": "78131",
    "ibgeCodigo": 4121802,
    "uf": "PR",
    "nome": "Ribeir�o Claro"
  },
  {
    "codigoTse": "78158",
    "ibgeCodigo": 4121901,
    "uf": "PR",
    "nome": "Ribeir�o Do Pinhal"
  },
  {
    "codigoTse": "78174",
    "ibgeCodigo": 4122008,
    "uf": "PR",
    "nome": "Rio Azul"
  },
  {
    "codigoTse": "78190",
    "ibgeCodigo": 4122107,
    "uf": "PR",
    "nome": "Rio Bom"
  },
  {
    "codigoTse": "78212",
    "ibgeCodigo": 4122206,
    "uf": "PR",
    "nome": "Rio Branco Do Sul"
  },
  {
    "codigoTse": "78239",
    "ibgeCodigo": 4122305,
    "uf": "PR",
    "nome": "Rio Negro"
  },
  {
    "codigoTse": "78255",
    "ibgeCodigo": 4122404,
    "uf": "PR",
    "nome": "Rol�ndia"
  },
  {
    "codigoTse": "78271",
    "ibgeCodigo": 4122503,
    "uf": "PR",
    "nome": "Roncador"
  },
  {
    "codigoTse": "78298",
    "ibgeCodigo": 4122602,
    "uf": "PR",
    "nome": "Rondon"
  },
  {
    "codigoTse": "78310",
    "ibgeCodigo": 4122701,
    "uf": "PR",
    "nome": "Sab�udia"
  },
  {
    "codigoTse": "78336",
    "ibgeCodigo": 4122800,
    "uf": "PR",
    "nome": "Salgado Filho"
  },
  {
    "codigoTse": "78352",
    "ibgeCodigo": 4122909,
    "uf": "PR",
    "nome": "Salto Do Itarar�"
  },
  {
    "codigoTse": "78379",
    "ibgeCodigo": 4123006,
    "uf": "PR",
    "nome": "Salto Do Lontra"
  },
  {
    "codigoTse": "78395",
    "ibgeCodigo": 4123105,
    "uf": "PR",
    "nome": "Santa Am�lia"
  },
  {
    "codigoTse": "78417",
    "ibgeCodigo": 4123204,
    "uf": "PR",
    "nome": "Santa Cec�lia Do Pav�o"
  },
  {
    "codigoTse": "78433",
    "ibgeCodigo": 4123303,
    "uf": "PR",
    "nome": "Santa Cruz De Monte Castelo"
  },
  {
    "codigoTse": "78450",
    "ibgeCodigo": 4123402,
    "uf": "PR",
    "nome": "Santa F�"
  },
  {
    "codigoTse": "78476",
    "ibgeCodigo": 4123600,
    "uf": "PR",
    "nome": "Santa In�s"
  },
  {
    "codigoTse": "78492",
    "ibgeCodigo": 4123709,
    "uf": "PR",
    "nome": "Santa Isabel Do Iva�"
  },
  {
    "codigoTse": "78514",
    "ibgeCodigo": 4123808,
    "uf": "PR",
    "nome": "Santa Izabel Do Oeste"
  },
  {
    "codigoTse": "78530",
    "ibgeCodigo": 4123907,
    "uf": "PR",
    "nome": "Santa Mariana"
  },
  {
    "codigoTse": "78557",
    "ibgeCodigo": 4124004,
    "uf": "PR",
    "nome": "Santana Do Itarar�"
  },
  {
    "codigoTse": "78573",
    "ibgeCodigo": 4124400,
    "uf": "PR",
    "nome": "Santo Ant�nio Do Sudoeste"
  },
  {
    "codigoTse": "78590",
    "ibgeCodigo": 4124103,
    "uf": "PR",
    "nome": "Santo Ant�nio Da Platina"
  },
  {
    "codigoTse": "78611",
    "ibgeCodigo": 4124202,
    "uf": "PR",
    "nome": "Santo Ant�nio Do Caiu�"
  },
  {
    "codigoTse": "78638",
    "ibgeCodigo": 4124301,
    "uf": "PR",
    "nome": "Santo Ant�nio Do Para�so"
  },
  {
    "codigoTse": "78654",
    "ibgeCodigo": 4124509,
    "uf": "PR",
    "nome": "Santo In�cio"
  },
  {
    "codigoTse": "78670",
    "ibgeCodigo": 4124608,
    "uf": "PR",
    "nome": "S�o Carlos Do Iva�"
  },
  {
    "codigoTse": "78697",
    "ibgeCodigo": 4124707,
    "uf": "PR",
    "nome": "S�o Jer�nimo Da Serra"
  },
  {
    "codigoTse": "78719",
    "ibgeCodigo": 4124806,
    "uf": "PR",
    "nome": "S�o Jo�o"
  },
  {
    "codigoTse": "78735",
    "ibgeCodigo": 4124905,
    "uf": "PR",
    "nome": "S�o Jo�o Do Caiu�"
  },
  {
    "codigoTse": "78751",
    "ibgeCodigo": 4125001,
    "uf": "PR",
    "nome": "S�o Jo�o Do Iva�"
  },
  {
    "codigoTse": "78778",
    "ibgeCodigo": 4125100,
    "uf": "PR",
    "nome": "S�o Jo�o Do Triunfo"
  },
  {
    "codigoTse": "78794",
    "ibgeCodigo": 4125308,
    "uf": "PR",
    "nome": "S�o Jorge Do Iva�"
  },
  {
    "codigoTse": "78816",
    "ibgeCodigo": 4125209,
    "uf": "PR",
    "nome": "S�o Jorge D'Oeste"
  },
  {
    "codigoTse": "78832",
    "ibgeCodigo": 4125407,
    "uf": "PR",
    "nome": "S�o Jos� Da Boa Vista"
  },
  {
    "codigoTse": "78859",
    "ibgeCodigo": 4125506,
    "uf": "PR",
    "nome": "S�o Jos� Dos Pinhais"
  },
  {
    "codigoTse": "78875",
    "ibgeCodigo": 4125605,
    "uf": "PR",
    "nome": "S�o Mateus Do Sul"
  },
  {
    "codigoTse": "78891",
    "ibgeCodigo": 4125704,
    "uf": "PR",
    "nome": "S�o Miguel Do Igua�u"
  },
  {
    "codigoTse": "78913",
    "ibgeCodigo": 4125803,
    "uf": "PR",
    "nome": "S�o Pedro Do Iva�"
  },
  {
    "codigoTse": "78930",
    "ibgeCodigo": 4125902,
    "uf": "PR",
    "nome": "S�o Pedro Do Paran�"
  },
  {
    "codigoTse": "78956",
    "ibgeCodigo": 4126009,
    "uf": "PR",
    "nome": "S�o Sebasti�o Da Amoreira"
  },
  {
    "codigoTse": "78972",
    "ibgeCodigo": 4126108,
    "uf": "PR",
    "nome": "S�o Tom�"
  },
  {
    "codigoTse": "78999",
    "ibgeCodigo": 4126207,
    "uf": "PR",
    "nome": "Sapopema"
  },
  {
    "codigoTse": "79014",
    "ibgeCodigo": 4126306,
    "uf": "PR",
    "nome": "Seng�s"
  },
  {
    "codigoTse": "79030",
    "ibgeCodigo": 4126405,
    "uf": "PR",
    "nome": "Sertaneja"
  },
  {
    "codigoTse": "79057",
    "ibgeCodigo": 4126504,
    "uf": "PR",
    "nome": "Sertan�polis"
  },
  {
    "codigoTse": "79073",
    "ibgeCodigo": 4126603,
    "uf": "PR",
    "nome": "Siqueira Campos"
  },
  {
    "codigoTse": "79090",
    "ibgeCodigo": 4126702,
    "uf": "PR",
    "nome": "Tamboara"
  },
  {
    "codigoTse": "79111",
    "ibgeCodigo": 4126801,
    "uf": "PR",
    "nome": "Tapejara"
  },
  {
    "codigoTse": "79138",
    "ibgeCodigo": 4127007,
    "uf": "PR",
    "nome": "Teixeira Soares"
  },
  {
    "codigoTse": "79154",
    "ibgeCodigo": 4127106,
    "uf": "PR",
    "nome": "Tel�maco Borba"
  },
  {
    "codigoTse": "79170",
    "ibgeCodigo": 4127205,
    "uf": "PR",
    "nome": "Terra Boa"
  },
  {
    "codigoTse": "79197",
    "ibgeCodigo": 4127304,
    "uf": "PR",
    "nome": "Terra Rica"
  },
  {
    "codigoTse": "79219",
    "ibgeCodigo": 4127403,
    "uf": "PR",
    "nome": "Terra Roxa"
  },
  {
    "codigoTse": "79235",
    "ibgeCodigo": 4127502,
    "uf": "PR",
    "nome": "Tibagi"
  },
  {
    "codigoTse": "79251",
    "ibgeCodigo": 4127601,
    "uf": "PR",
    "nome": "Tijucas Do Sul"
  },
  {
    "codigoTse": "79278",
    "ibgeCodigo": 4127700,
    "uf": "PR",
    "nome": "Toledo"
  },
  {
    "codigoTse": "79294",
    "ibgeCodigo": 4127809,
    "uf": "PR",
    "nome": "Tomazina"
  },
  {
    "codigoTse": "79316",
    "ibgeCodigo": 4127908,
    "uf": "PR",
    "nome": "Tuneiras Do Oeste"
  },
  {
    "codigoTse": "79332",
    "ibgeCodigo": 4128005,
    "uf": "PR",
    "nome": "Ubirat�"
  },
  {
    "codigoTse": "79359",
    "ibgeCodigo": 4128104,
    "uf": "PR",
    "nome": "Umuarama"
  },
  {
    "codigoTse": "79375",
    "ibgeCodigo": 4128203,
    "uf": "PR",
    "nome": "Uni�o Da Vit�ria"
  },
  {
    "codigoTse": "79391",
    "ibgeCodigo": 4128302,
    "uf": "PR",
    "nome": "Uniflor"
  },
  {
    "codigoTse": "79413",
    "ibgeCodigo": 4128401,
    "uf": "PR",
    "nome": "Ura�"
  },
  {
    "codigoTse": "79430",
    "ibgeCodigo": 4128500,
    "uf": "PR",
    "nome": "Wenceslau Braz"
  },
  {
    "codigoTse": "79456",
    "ibgeCodigo": 4128609,
    "uf": "PR",
    "nome": "Ver�"
  },
  {
    "codigoTse": "79472",
    "ibgeCodigo": 4128708,
    "uf": "PR",
    "nome": "Vitorino"
  },
  {
    "codigoTse": "79499",
    "ibgeCodigo": 4128807,
    "uf": "PR",
    "nome": "Xambr�"
  },
  {
    "codigoTse": "79510",
    "ibgeCodigo": 4100509,
    "uf": "PR",
    "nome": "Alt�nia"
  },
  {
    "codigoTse": "79537",
    "ibgeCodigo": 4102000,
    "uf": "PR",
    "nome": "Assis Chateaubriand"
  },
  {
    "codigoTse": "79553",
    "ibgeCodigo": 4120903,
    "uf": "PR",
    "nome": "Quedas Do Igua�u"
  },
  {
    "codigoTse": "79570",
    "ibgeCodigo": 4105300,
    "uf": "PR",
    "nome": "C�u Azul"
  },
  {
    "codigoTse": "79596",
    "ibgeCodigo": 4108700,
    "uf": "PR",
    "nome": "Grandes Rios"
  },
  {
    "codigoTse": "79618",
    "ibgeCodigo": 4110409,
    "uf": "PR",
    "nome": "Indian�polis"
  },
  {
    "codigoTse": "79634",
    "ibgeCodigo": 4115705,
    "uf": "PR",
    "nome": "Matinhos"
  },
  {
    "codigoTse": "79650",
    "ibgeCodigo": 4116703,
    "uf": "PR",
    "nome": "Nova Aurora"
  },
  {
    "codigoTse": "79677",
    "ibgeCodigo": 4117206,
    "uf": "PR",
    "nome": "Nova Ol�mpia"
  },
  {
    "codigoTse": "79693",
    "ibgeCodigo": 4118907,
    "uf": "PR",
    "nome": "P�rola"
  },
  {
    "codigoTse": "79715",
    "ibgeCodigo": 4123501,
    "uf": "PR",
    "nome": "Santa Helena"
  },
  {
    "codigoTse": "79731",
    "ibgeCodigo": 4126900,
    "uf": "PR",
    "nome": "Tapira"
  },
  {
    "codigoTse": "79758",
    "ibgeCodigo": 4115002,
    "uf": "PR",
    "nome": "Marilena"
  },
  {
    "codigoTse": "79774",
    "ibgeCodigo": 4108320,
    "uf": "PR",
    "nome": "Francisco Alves"
  },
  {
    "codigoTse": "79790",
    "ibgeCodigo": 4117222,
    "uf": "PR",
    "nome": "Nova Santa Rosa"
  },
  {
    "codigoTse": "79812",
    "ibgeCodigo": 4103057,
    "uf": "PR",
    "nome": "Boa Vista Da Aparecida"
  },
  {
    "codigoTse": "79839",
    "ibgeCodigo": 4103354,
    "uf": "PR",
    "nome": "Braganey"
  },
  {
    "codigoTse": "79855",
    "ibgeCodigo": 4103453,
    "uf": "PR",
    "nome": "Cafel�ndia"
  },
  {
    "codigoTse": "79871",
    "ibgeCodigo": 4127858,
    "uf": "PR",
    "nome": "Tr�s Barras Do Paran�"
  },
  {
    "codigoTse": "79898",
    "ibgeCodigo": 4128559,
    "uf": "PR",
    "nome": "Vera Cruz Do Oeste"
  },
  {
    "codigoTse": "79910",
    "ibgeCodigo": 4120358,
    "uf": "PR",
    "nome": "Pranchita"
  },
  {
    "codigoTse": "79936",
    "ibgeCodigo": 4127957,
    "uf": "PR",
    "nome": "Tup�ssi"
  },
  {
    "codigoTse": "79952",
    "ibgeCodigo": 4117255,
    "uf": "PR",
    "nome": "Nova Prata Do Igua�u"
  },
  {
    "codigoTse": "79979",
    "ibgeCodigo": 4112751,
    "uf": "PR",
    "nome": "Jesu�tas"
  },
  {
    "codigoTse": "79995",
    "ibgeCodigo": 4125357,
    "uf": "PR",
    "nome": "S�o Jorge Do Patroc�nio"
  },
  {
    "codigoTse": "80004",
    "ibgeCodigo": 4211058,
    "uf": "SC",
    "nome": "Monte Carlo"
  },
  {
    "codigoTse": "80012",
    "ibgeCodigo": 4200101,
    "uf": "SC",
    "nome": "Abelardo Luz"
  },
  {
    "codigoTse": "80020",
    "ibgeCodigo": 4207650,
    "uf": "SC",
    "nome": "Ipor� Do Oeste"
  },
  {
    "codigoTse": "80039",
    "ibgeCodigo": 4200200,
    "uf": "SC",
    "nome": "Agrol�ndia"
  },
  {
    "codigoTse": "80047",
    "ibgeCodigo": 4209854,
    "uf": "SC",
    "nome": "Lind�ia Do Sul"
  },
  {
    "codigoTse": "80055",
    "ibgeCodigo": 4200309,
    "uf": "SC",
    "nome": "Agron�mica"
  },
  {
    "codigoTse": "80063",
    "ibgeCodigo": 4201257,
    "uf": "SC",
    "nome": "Api�na"
  },
  {
    "codigoTse": "80071",
    "ibgeCodigo": 4200408,
    "uf": "SC",
    "nome": "�gua Doce"
  },
  {
    "codigoTse": "80080",
    "ibgeCodigo": 4205159,
    "uf": "SC",
    "nome": "Doutor Pedrinho"
  },
  {
    "codigoTse": "80098",
    "ibgeCodigo": 4200507,
    "uf": "SC",
    "nome": "�guas De Chapec�"
  },
  {
    "codigoTse": "80101",
    "ibgeCodigo": 4209151,
    "uf": "SC",
    "nome": "Jos� Boiteux"
  },
  {
    "codigoTse": "80110",
    "ibgeCodigo": 4200606,
    "uf": "SC",
    "nome": "�guas Mornas"
  },
  {
    "codigoTse": "80128",
    "ibgeCodigo": 4219358,
    "uf": "SC",
    "nome": "Vitor Meireles"
  },
  {
    "codigoTse": "80136",
    "ibgeCodigo": 4200705,
    "uf": "SC",
    "nome": "Alfredo Wagner"
  },
  {
    "codigoTse": "80144",
    "ibgeCodigo": 4218855,
    "uf": "SC",
    "nome": "Uni�o Do Oeste"
  },
  {
    "codigoTse": "80152",
    "ibgeCodigo": 4200804,
    "uf": "SC",
    "nome": "Anchieta"
  },
  {
    "codigoTse": "80160",
    "ibgeCodigo": 4218954,
    "uf": "SC",
    "nome": "Urupema"
  },
  {
    "codigoTse": "80179",
    "ibgeCodigo": 4200903,
    "uf": "SC",
    "nome": "Angelina"
  },
  {
    "codigoTse": "80187",
    "ibgeCodigo": 4207759,
    "uf": "SC",
    "nome": "Iraceminha"
  },
  {
    "codigoTse": "80195",
    "ibgeCodigo": 4201000,
    "uf": "SC",
    "nome": "Anita Garibaldi"
  },
  {
    "codigoTse": "80209",
    "ibgeCodigo": 4218251,
    "uf": "SC",
    "nome": "Timb� Grande"
  },
  {
    "codigoTse": "80217",
    "ibgeCodigo": 4201109,
    "uf": "SC",
    "nome": "Anit�polis"
  },
  {
    "codigoTse": "80225",
    "ibgeCodigo": 4200051,
    "uf": "SC",
    "nome": "Abdon Batista"
  },
  {
    "codigoTse": "80233",
    "ibgeCodigo": 4201208,
    "uf": "SC",
    "nome": "Ant�nio Carlos"
  },
  {
    "codigoTse": "80241",
    "ibgeCodigo": 4215653,
    "uf": "SC",
    "nome": "Santa Rosa Do Sul"
  },
  {
    "codigoTse": "80250",
    "ibgeCodigo": 4201307,
    "uf": "SC",
    "nome": "Araquari"
  },
  {
    "codigoTse": "80268",
    "ibgeCodigo": 4204152,
    "uf": "SC",
    "nome": "Celso Ramos"
  },
  {
    "codigoTse": "80276",
    "ibgeCodigo": 4201406,
    "uf": "SC",
    "nome": "Ararangu�"
  },
  {
    "codigoTse": "80284",
    "ibgeCodigo": 4217550,
    "uf": "SC",
    "nome": "Serra Alta"
  },
  {
    "codigoTse": "80292",
    "ibgeCodigo": 4201505,
    "uf": "SC",
    "nome": "Armaz�m"
  },
  {
    "codigoTse": "80306",
    "ibgeCodigo": 4204251,
    "uf": "SC",
    "nome": "Cocal Do Sul"
  },
  {
    "codigoTse": "80314",
    "ibgeCodigo": 4201604,
    "uf": "SC",
    "nome": "Arroio Trinta"
  },
  {
    "codigoTse": "80322",
    "ibgeCodigo": 4211454,
    "uf": "SC",
    "nome": "Nova Itaberaba"
  },
  {
    "codigoTse": "80330",
    "ibgeCodigo": 4201703,
    "uf": "SC",
    "nome": "Ascurra"
  },
  {
    "codigoTse": "80349",
    "ibgeCodigo": 4215679,
    "uf": "SC",
    "nome": "Santa Terezinha"
  },
  {
    "codigoTse": "80357",
    "ibgeCodigo": 4201802,
    "uf": "SC",
    "nome": "Atalanta"
  },
  {
    "codigoTse": "80365",
    "ibgeCodigo": 4210852,
    "uf": "SC",
    "nome": "Mirim Doce"
  },
  {
    "codigoTse": "80373",
    "ibgeCodigo": 4201901,
    "uf": "SC",
    "nome": "Aurora"
  },
  {
    "codigoTse": "80381",
    "ibgeCodigo": 4204178,
    "uf": "SC",
    "nome": "Cerro Negro"
  },
  {
    "codigoTse": "80390",
    "ibgeCodigo": 4202008,
    "uf": "SC",
    "nome": "Balne�rio Cambori�"
  },
  {
    "codigoTse": "80403",
    "ibgeCodigo": 4212254,
    "uf": "SC",
    "nome": "Passo De Torres"
  },
  {
    "codigoTse": "80411",
    "ibgeCodigo": 4202107,
    "uf": "SC",
    "nome": "Barra Velha"
  },
  {
    "codigoTse": "80420",
    "ibgeCodigo": 4202859,
    "uf": "SC",
    "nome": "Bra�o Do Trombudo"
  },
  {
    "codigoTse": "80438",
    "ibgeCodigo": 4202206,
    "uf": "SC",
    "nome": "Benedito Novo"
  },
  {
    "codigoTse": "80446",
    "ibgeCodigo": 4217758,
    "uf": "SC",
    "nome": "Sul Brasil"
  },
  {
    "codigoTse": "80454",
    "ibgeCodigo": 4202305,
    "uf": "SC",
    "nome": "Bigua�u"
  },
  {
    "codigoTse": "80462",
    "ibgeCodigo": 4219150,
    "uf": "SC",
    "nome": "Vargem"
  },
  {
    "codigoTse": "80470",
    "ibgeCodigo": 4202404,
    "uf": "SC",
    "nome": "Blumenau"
  },
  {
    "codigoTse": "80489",
    "ibgeCodigo": 4201273,
    "uf": "SC",
    "nome": "Arabut�"
  },
  {
    "codigoTse": "80497",
    "ibgeCodigo": 4202602,
    "uf": "SC",
    "nome": "Bom Retiro"
  },
  {
    "codigoTse": "80500",
    "ibgeCodigo": 4200556,
    "uf": "SC",
    "nome": "�guas Frias"
  },
  {
    "codigoTse": "80519",
    "ibgeCodigo": 4202701,
    "uf": "SC",
    "nome": "Botuver�"
  },
  {
    "codigoTse": "80527",
    "ibgeCodigo": 4206652,
    "uf": "SC",
    "nome": "Guatamb�"
  },
  {
    "codigoTse": "80535",
    "ibgeCodigo": 4202800,
    "uf": "SC",
    "nome": "Bra�o Do Norte"
  },
  {
    "codigoTse": "80543",
    "ibgeCodigo": 4213153,
    "uf": "SC",
    "nome": "Planalto Alegre"
  },
  {
    "codigoTse": "80551",
    "ibgeCodigo": 4202909,
    "uf": "SC",
    "nome": "Brusque"
  },
  {
    "codigoTse": "80560",
    "ibgeCodigo": 4215075,
    "uf": "SC",
    "nome": "Riqueza"
  },
  {
    "codigoTse": "80578",
    "ibgeCodigo": 4203006,
    "uf": "SC",
    "nome": "Ca�ador"
  },
  {
    "codigoTse": "80586",
    "ibgeCodigo": 4209458,
    "uf": "SC",
    "nome": "Lajeado Grande"
  },
  {
    "codigoTse": "80594",
    "ibgeCodigo": 4203105,
    "uf": "SC",
    "nome": "Caibi"
  },
  {
    "codigoTse": "80608",
    "ibgeCodigo": 4215059,
    "uf": "SC",
    "nome": "Rio Rufino"
  },
  {
    "codigoTse": "80616",
    "ibgeCodigo": 4203204,
    "uf": "SC",
    "nome": "Cambori�"
  },
  {
    "codigoTse": "80624",
    "ibgeCodigo": 4212270,
    "uf": "SC",
    "nome": "Passos Maia"
  },
  {
    "codigoTse": "80632",
    "ibgeCodigo": 4203303,
    "uf": "SC",
    "nome": "Campo Alegre"
  },
  {
    "codigoTse": "80640",
    "ibgeCodigo": 4216255,
    "uf": "SC",
    "nome": "S�o Jo�o Do Oeste"
  },
  {
    "codigoTse": "80659",
    "ibgeCodigo": 4203402,
    "uf": "SC",
    "nome": "Campo Belo Do Sul"
  },
  {
    "codigoTse": "80667",
    "ibgeCodigo": 4203154,
    "uf": "SC",
    "nome": "Calmon"
  },
  {
    "codigoTse": "80675",
    "ibgeCodigo": 4203501,
    "uf": "SC",
    "nome": "Campo Er�"
  },
  {
    "codigoTse": "80683",
    "ibgeCodigo": 4202057,
    "uf": "SC",
    "nome": "Balne�rio Barra Do Sul"
  },
  {
    "codigoTse": "80691",
    "ibgeCodigo": 4203600,
    "uf": "SC",
    "nome": "Campos Novos"
  },
  {
    "codigoTse": "80705",
    "ibgeCodigo": 4212239,
    "uf": "SC",
    "nome": "Para�so"
  },
  {
    "codigoTse": "80713",
    "ibgeCodigo": 4203709,
    "uf": "SC",
    "nome": "Canelinha"
  },
  {
    "codigoTse": "80721",
    "ibgeCodigo": 4215554,
    "uf": "SC",
    "nome": "Santa Helena"
  },
  {
    "codigoTse": "80730",
    "ibgeCodigo": 4203808,
    "uf": "SC",
    "nome": "Canoinhas"
  },
  {
    "codigoTse": "80748",
    "ibgeCodigo": 4202156,
    "uf": "SC",
    "nome": "Belmonte"
  },
  {
    "codigoTse": "80756",
    "ibgeCodigo": 4203907,
    "uf": "SC",
    "nome": "Capinzal"
  },
  {
    "codigoTse": "80764",
    "ibgeCodigo": 4211652,
    "uf": "SC",
    "nome": "Novo Horizonte"
  },
  {
    "codigoTse": "80772",
    "ibgeCodigo": 4204004,
    "uf": "SC",
    "nome": "Catanduvas"
  },
  {
    "codigoTse": "80780",
    "ibgeCodigo": 4217154,
    "uf": "SC",
    "nome": "S�o Miguel Da Boa Vista"
  },
  {
    "codigoTse": "80799",
    "ibgeCodigo": 4204103,
    "uf": "SC",
    "nome": "Caxambu Do Sul"
  },
  {
    "codigoTse": "80802",
    "ibgeCodigo": 4201653,
    "uf": "SC",
    "nome": "Arvoredo"
  },
  {
    "codigoTse": "80810",
    "ibgeCodigo": 4204202,
    "uf": "SC",
    "nome": "Chapec�"
  },
  {
    "codigoTse": "80829",
    "ibgeCodigo": 4207684,
    "uf": "SC",
    "nome": "Ipua�u"
  },
  {
    "codigoTse": "80837",
    "ibgeCodigo": 4204301,
    "uf": "SC",
    "nome": "Conc�rdia"
  },
  {
    "codigoTse": "80845",
    "ibgeCodigo": 4211850,
    "uf": "SC",
    "nome": "Ouro Verde"
  },
  {
    "codigoTse": "80853",
    "ibgeCodigo": 4204400,
    "uf": "SC",
    "nome": "Coronel Freitas"
  },
  {
    "codigoTse": "80861",
    "ibgeCodigo": 4207858,
    "uf": "SC",
    "nome": "Irati"
  },
  {
    "codigoTse": "80870",
    "ibgeCodigo": 4204509,
    "uf": "SC",
    "nome": "Corup�"
  },
  {
    "codigoTse": "80888",
    "ibgeCodigo": 4205431,
    "uf": "SC",
    "nome": "Formosa Do Sul"
  },
  {
    "codigoTse": "80896",
    "ibgeCodigo": 4204608,
    "uf": "SC",
    "nome": "Crici�ma"
  },
  {
    "codigoTse": "80900",
    "ibgeCodigo": 4210050,
    "uf": "SC",
    "nome": "Macieira"
  },
  {
    "codigoTse": "80918",
    "ibgeCodigo": 4204707,
    "uf": "SC",
    "nome": "Cunha Por�"
  },
  {
    "codigoTse": "80926",
    "ibgeCodigo": 4213351,
    "uf": "SC",
    "nome": "Ponte Alta Do Norte"
  },
  {
    "codigoTse": "80934",
    "ibgeCodigo": 4204806,
    "uf": "SC",
    "nome": "Curitibanos"
  },
  {
    "codigoTse": "80942",
    "ibgeCodigo": 4216057,
    "uf": "SC",
    "nome": "S�o Cristov�o Do Sul"
  },
  {
    "codigoTse": "80950",
    "ibgeCodigo": 4204905,
    "uf": "SC",
    "nome": "Descanso"
  },
  {
    "codigoTse": "80969",
    "ibgeCodigo": 4219176,
    "uf": "SC",
    "nome": "Vargem Bonita"
  },
  {
    "codigoTse": "80977",
    "ibgeCodigo": 4205001,
    "uf": "SC",
    "nome": "Dion�sio Cerqueira"
  },
  {
    "codigoTse": "80985",
    "ibgeCodigo": 4202453,
    "uf": "SC",
    "nome": "Bombinhas"
  },
  {
    "codigoTse": "80993",
    "ibgeCodigo": 4205100,
    "uf": "SC",
    "nome": "Dona Emma"
  },
  {
    "codigoTse": "81000",
    "ibgeCodigo": 4215455,
    "uf": "SC",
    "nome": "Sang�o"
  },
  {
    "codigoTse": "81019",
    "ibgeCodigo": 4205209,
    "uf": "SC",
    "nome": "Erval Velho"
  },
  {
    "codigoTse": "81027",
    "ibgeCodigo": 4203956,
    "uf": "SC",
    "nome": "Capivari De Baixo"
  },
  {
    "codigoTse": "81035",
    "ibgeCodigo": 4205308,
    "uf": "SC",
    "nome": "Faxinal Dos Guedes"
  },
  {
    "codigoTse": "81043",
    "ibgeCodigo": 4204350,
    "uf": "SC",
    "nome": "Cordilheira Alta"
  },
  {
    "codigoTse": "81051",
    "ibgeCodigo": 4205407,
    "uf": "SC",
    "nome": "Florian�polis"
  },
  {
    "codigoTse": "81060",
    "ibgeCodigo": 4205456,
    "uf": "SC",
    "nome": "Forquilhinha"
  },
  {
    "codigoTse": "81078",
    "ibgeCodigo": 4205506,
    "uf": "SC",
    "nome": "Fraiburgo"
  },
  {
    "codigoTse": "81086",
    "ibgeCodigo": 4211256,
    "uf": "SC",
    "nome": "Morro Grande"
  },
  {
    "codigoTse": "81094",
    "ibgeCodigo": 4205605,
    "uf": "SC",
    "nome": "Galv�o"
  },
  {
    "codigoTse": "81108",
    "ibgeCodigo": 4204459,
    "uf": "SC",
    "nome": "Coronel Martins"
  },
  {
    "codigoTse": "81116",
    "ibgeCodigo": 4206009,
    "uf": "SC",
    "nome": "Governador Celso Ramos"
  },
  {
    "codigoTse": "81124",
    "ibgeCodigo": 4216354,
    "uf": "SC",
    "nome": "S�o Jo�o Do Itaperi�"
  },
  {
    "codigoTse": "81132",
    "ibgeCodigo": 4205704,
    "uf": "SC",
    "nome": "Garopaba"
  },
  {
    "codigoTse": "81140",
    "ibgeCodigo": 4208955,
    "uf": "SC",
    "nome": "Jardin�polis"
  },
  {
    "codigoTse": "81159",
    "ibgeCodigo": 4205803,
    "uf": "SC",
    "nome": "Garuva"
  },
  {
    "codigoTse": "81167",
    "ibgeCodigo": 4205191,
    "uf": "SC",
    "nome": "Ermo"
  },
  {
    "codigoTse": "81175",
    "ibgeCodigo": 4205902,
    "uf": "SC",
    "nome": "Gaspar"
  },
  {
    "codigoTse": "81183",
    "ibgeCodigo": 4217253,
    "uf": "SC",
    "nome": "S�o Pedro De Alc�ntara"
  },
  {
    "codigoTse": "81191",
    "ibgeCodigo": 4206108,
    "uf": "SC",
    "nome": "Gr�o Par�"
  },
  {
    "codigoTse": "81205",
    "ibgeCodigo": 4215695,
    "uf": "SC",
    "nome": "Santiago Do Sul"
  },
  {
    "codigoTse": "81213",
    "ibgeCodigo": 4206207,
    "uf": "SC",
    "nome": "Gravatal"
  },
  {
    "codigoTse": "81221",
    "ibgeCodigo": 4202131,
    "uf": "SC",
    "nome": "Bela Vista Do Toldo"
  },
  {
    "codigoTse": "81230",
    "ibgeCodigo": 4206306,
    "uf": "SC",
    "nome": "Guabiruba"
  },
  {
    "codigoTse": "81248",
    "ibgeCodigo": 4203253,
    "uf": "SC",
    "nome": "Cap�o Alto"
  },
  {
    "codigoTse": "81256",
    "ibgeCodigo": 4206405,
    "uf": "SC",
    "nome": "Guaraciaba"
  },
  {
    "codigoTse": "81264",
    "ibgeCodigo": 4211892,
    "uf": "SC",
    "nome": "Painel"
  },
  {
    "codigoTse": "81272",
    "ibgeCodigo": 4206504,
    "uf": "SC",
    "nome": "Guaramirim"
  },
  {
    "codigoTse": "81280",
    "ibgeCodigo": 4202438,
    "uf": "SC",
    "nome": "Bocaina Do Sul"
  },
  {
    "codigoTse": "81299",
    "ibgeCodigo": 4206603,
    "uf": "SC",
    "nome": "Guaruj� Do Sul"
  },
  {
    "codigoTse": "81302",
    "ibgeCodigo": 4200754,
    "uf": "SC",
    "nome": "Alto Bela Vista"
  },
  {
    "codigoTse": "81310",
    "ibgeCodigo": 4206702,
    "uf": "SC",
    "nome": "Herval D'Oeste"
  },
  {
    "codigoTse": "81329",
    "ibgeCodigo": 4205555,
    "uf": "SC",
    "nome": "Frei Rog�rio"
  },
  {
    "codigoTse": "81337",
    "ibgeCodigo": 4206801,
    "uf": "SC",
    "nome": "Ibicar�"
  },
  {
    "codigoTse": "81345",
    "ibgeCodigo": 4218350,
    "uf": "SC",
    "nome": "Treviso"
  },
  {
    "codigoTse": "81353",
    "ibgeCodigo": 4206900,
    "uf": "SC",
    "nome": "Ibirama"
  },
  {
    "codigoTse": "81361",
    "ibgeCodigo": 4207577,
    "uf": "SC",
    "nome": "Iomer�"
  },
  {
    "codigoTse": "81370",
    "ibgeCodigo": 4207007,
    "uf": "SC",
    "nome": "I�ara"
  },
  {
    "codigoTse": "81388",
    "ibgeCodigo": 4202537,
    "uf": "SC",
    "nome": "Bom Jesus"
  },
  {
    "codigoTse": "81396",
    "ibgeCodigo": 4207106,
    "uf": "SC",
    "nome": "Ilhota"
  },
  {
    "codigoTse": "81400",
    "ibgeCodigo": 4206751,
    "uf": "SC",
    "nome": "Ibiam"
  },
  {
    "codigoTse": "81418",
    "ibgeCodigo": 4207205,
    "uf": "SC",
    "nome": "Imaru�"
  },
  {
    "codigoTse": "81426",
    "ibgeCodigo": 4205175,
    "uf": "SC",
    "nome": "Entre Rios"
  },
  {
    "codigoTse": "81434",
    "ibgeCodigo": 4207304,
    "uf": "SC",
    "nome": "Imbituba"
  },
  {
    "codigoTse": "81442",
    "ibgeCodigo": 4211876,
    "uf": "SC",
    "nome": "Paial"
  },
  {
    "codigoTse": "81450",
    "ibgeCodigo": 4207403,
    "uf": "SC",
    "nome": "Imbuia"
  },
  {
    "codigoTse": "81469",
    "ibgeCodigo": 4202578,
    "uf": "SC",
    "nome": "Bom Jesus Do Oeste"
  },
  {
    "codigoTse": "81477",
    "ibgeCodigo": 4207502,
    "uf": "SC",
    "nome": "Indaial"
  },
  {
    "codigoTse": "81485",
    "ibgeCodigo": 4215752,
    "uf": "SC",
    "nome": "S�o Bernardino"
  },
  {
    "codigoTse": "81493",
    "ibgeCodigo": 4207601,
    "uf": "SC",
    "nome": "Ipira"
  },
  {
    "codigoTse": "81507",
    "ibgeCodigo": 4215687,
    "uf": "SC",
    "nome": "Santa Terezinha Do Progresso"
  },
  {
    "codigoTse": "81515",
    "ibgeCodigo": 4207700,
    "uf": "SC",
    "nome": "Ipumirim"
  },
  {
    "codigoTse": "81523",
    "ibgeCodigo": 4215356,
    "uf": "SC",
    "nome": "Saltinho"
  },
  {
    "codigoTse": "81531",
    "ibgeCodigo": 4207809,
    "uf": "SC",
    "nome": "Irani"
  },
  {
    "codigoTse": "81540",
    "ibgeCodigo": 4209177,
    "uf": "SC",
    "nome": "Jupi�"
  },
  {
    "codigoTse": "81558",
    "ibgeCodigo": 4207908,
    "uf": "SC",
    "nome": "Irine�polis"
  },
  {
    "codigoTse": "81566",
    "ibgeCodigo": 4212056,
    "uf": "SC",
    "nome": "Palmeira"
  },
  {
    "codigoTse": "81574",
    "ibgeCodigo": 4208005,
    "uf": "SC",
    "nome": "It�"
  },
  {
    "codigoTse": "81582",
    "ibgeCodigo": 4202081,
    "uf": "SC",
    "nome": "Bandeirante"
  },
  {
    "codigoTse": "81590",
    "ibgeCodigo": 4208104,
    "uf": "SC",
    "nome": "Itai�polis"
  },
  {
    "codigoTse": "81604",
    "ibgeCodigo": 4205357,
    "uf": "SC",
    "nome": "Flor Do Sert�o"
  },
  {
    "codigoTse": "81612",
    "ibgeCodigo": 4208203,
    "uf": "SC",
    "nome": "Itaja�"
  },
  {
    "codigoTse": "81620",
    "ibgeCodigo": 4204756,
    "uf": "SC",
    "nome": "Cunhata�"
  },
  {
    "codigoTse": "81639",
    "ibgeCodigo": 4208302,
    "uf": "SC",
    "nome": "Itapema"
  },
  {
    "codigoTse": "81647",
    "ibgeCodigo": 4214151,
    "uf": "SC",
    "nome": "Princesa"
  },
  {
    "codigoTse": "81655",
    "ibgeCodigo": 4208401,
    "uf": "SC",
    "nome": "Itapiranga"
  },
  {
    "codigoTse": "81663",
    "ibgeCodigo": 4208450,
    "uf": "SC",
    "nome": "Itapo�"
  },
  {
    "codigoTse": "81671",
    "ibgeCodigo": 4208500,
    "uf": "SC",
    "nome": "Ituporanga"
  },
  {
    "codigoTse": "81680",
    "ibgeCodigo": 4217956,
    "uf": "SC",
    "nome": "Tigrinhos"
  },
  {
    "codigoTse": "81698",
    "ibgeCodigo": 4208609,
    "uf": "SC",
    "nome": "Jabor�"
  },
  {
    "codigoTse": "81701",
    "ibgeCodigo": 4204194,
    "uf": "SC",
    "nome": "Chapad�o Do Lageado"
  },
  {
    "codigoTse": "81710",
    "ibgeCodigo": 4208708,
    "uf": "SC",
    "nome": "Jacinto Machado"
  },
  {
    "codigoTse": "81728",
    "ibgeCodigo": 4201950,
    "uf": "SC",
    "nome": "Balne�rio Arroio Do Silva"
  },
  {
    "codigoTse": "81736",
    "ibgeCodigo": 4208807,
    "uf": "SC",
    "nome": "Jaguaruna"
  },
  {
    "codigoTse": "81744",
    "ibgeCodigo": 4202073,
    "uf": "SC",
    "nome": "Balne�rio Gaivota"
  },
  {
    "codigoTse": "81752",
    "ibgeCodigo": 4208906,
    "uf": "SC",
    "nome": "Jaragu� Do Sul"
  },
  {
    "codigoTse": "81760",
    "ibgeCodigo": 4202099,
    "uf": "SC",
    "nome": "Barra Bonita"
  },
  {
    "codigoTse": "81779",
    "ibgeCodigo": 4209003,
    "uf": "SC",
    "nome": "Joa�aba"
  },
  {
    "codigoTse": "81787",
    "ibgeCodigo": 4202875,
    "uf": "SC",
    "nome": "Brun�polis"
  },
  {
    "codigoTse": "81795",
    "ibgeCodigo": 4209102,
    "uf": "SC",
    "nome": "Joinville"
  },
  {
    "codigoTse": "81809",
    "ibgeCodigo": 4210035,
    "uf": "SC",
    "nome": "Luzerna"
  },
  {
    "codigoTse": "81817",
    "ibgeCodigo": 4209201,
    "uf": "SC",
    "nome": "Lacerd�polis"
  },
  {
    "codigoTse": "81825",
    "ibgeCodigo": 4219853,
    "uf": "SC",
    "nome": "Zort�a"
  },
  {
    "codigoTse": "81833",
    "ibgeCodigo": 4209300,
    "uf": "SC",
    "nome": "Lages"
  },
  {
    "codigoTse": "81850",
    "ibgeCodigo": 4209409,
    "uf": "SC",
    "nome": "Laguna"
  },
  {
    "codigoTse": "81876",
    "ibgeCodigo": 4209508,
    "uf": "SC",
    "nome": "Laurentino"
  },
  {
    "codigoTse": "81892",
    "ibgeCodigo": 4209607,
    "uf": "SC",
    "nome": "Lauro Muller"
  },
  {
    "codigoTse": "81914",
    "ibgeCodigo": 4209706,
    "uf": "SC",
    "nome": "Lebon R�gis"
  },
  {
    "codigoTse": "81930",
    "ibgeCodigo": 4209805,
    "uf": "SC",
    "nome": "Leoberto Leal"
  },
  {
    "codigoTse": "81957",
    "ibgeCodigo": 4209904,
    "uf": "SC",
    "nome": "Lontras"
  },
  {
    "codigoTse": "81973",
    "ibgeCodigo": 4210001,
    "uf": "SC",
    "nome": "Luiz Alves"
  },
  {
    "codigoTse": "81990",
    "ibgeCodigo": 4210100,
    "uf": "SC",
    "nome": "Mafra"
  },
  {
    "codigoTse": "82015",
    "ibgeCodigo": 4210209,
    "uf": "SC",
    "nome": "Major Gercino"
  },
  {
    "codigoTse": "82031",
    "ibgeCodigo": 4210308,
    "uf": "SC",
    "nome": "Major Vieira"
  },
  {
    "codigoTse": "82058",
    "ibgeCodigo": 4210506,
    "uf": "SC",
    "nome": "Maravilha"
  },
  {
    "codigoTse": "82066",
    "ibgeCodigo": 4210555,
    "uf": "SC",
    "nome": "Marema"
  },
  {
    "codigoTse": "82074",
    "ibgeCodigo": 4210605,
    "uf": "SC",
    "nome": "Massaranduba"
  },
  {
    "codigoTse": "82090",
    "ibgeCodigo": 4210704,
    "uf": "SC",
    "nome": "Matos Costa"
  },
  {
    "codigoTse": "82112",
    "ibgeCodigo": 4210803,
    "uf": "SC",
    "nome": "Meleiro"
  },
  {
    "codigoTse": "82139",
    "ibgeCodigo": 4210902,
    "uf": "SC",
    "nome": "Modelo"
  },
  {
    "codigoTse": "82155",
    "ibgeCodigo": 4211009,
    "uf": "SC",
    "nome": "Monda�"
  },
  {
    "codigoTse": "82171",
    "ibgeCodigo": 4211108,
    "uf": "SC",
    "nome": "Monte Castelo"
  },
  {
    "codigoTse": "82198",
    "ibgeCodigo": 4211207,
    "uf": "SC",
    "nome": "Morro Da Fuma�a"
  },
  {
    "codigoTse": "82210",
    "ibgeCodigo": 4211306,
    "uf": "SC",
    "nome": "Navegantes"
  },
  {
    "codigoTse": "82236",
    "ibgeCodigo": 4211405,
    "uf": "SC",
    "nome": "Nova Erechim"
  },
  {
    "codigoTse": "82252",
    "ibgeCodigo": 4211504,
    "uf": "SC",
    "nome": "Nova Trento"
  },
  {
    "codigoTse": "82279",
    "ibgeCodigo": 4211603,
    "uf": "SC",
    "nome": "Nova Veneza"
  },
  {
    "codigoTse": "82295",
    "ibgeCodigo": 4211702,
    "uf": "SC",
    "nome": "Orleans"
  },
  {
    "codigoTse": "82317",
    "ibgeCodigo": 4211801,
    "uf": "SC",
    "nome": "Ouro"
  },
  {
    "codigoTse": "82333",
    "ibgeCodigo": 4211900,
    "uf": "SC",
    "nome": "Palho�a"
  },
  {
    "codigoTse": "82350",
    "ibgeCodigo": 4212007,
    "uf": "SC",
    "nome": "Palma Sola"
  },
  {
    "codigoTse": "82376",
    "ibgeCodigo": 4212106,
    "uf": "SC",
    "nome": "Palmitos"
  },
  {
    "codigoTse": "82392",
    "ibgeCodigo": 4212205,
    "uf": "SC",
    "nome": "Papanduva"
  },
  {
    "codigoTse": "82414",
    "ibgeCodigo": 4212304,
    "uf": "SC",
    "nome": "Paulo Lopes"
  },
  {
    "codigoTse": "82430",
    "ibgeCodigo": 4212403,
    "uf": "SC",
    "nome": "Pedras Grandes"
  },
  {
    "codigoTse": "82457",
    "ibgeCodigo": 4212502,
    "uf": "SC",
    "nome": "Penha"
  },
  {
    "codigoTse": "82473",
    "ibgeCodigo": 4212601,
    "uf": "SC",
    "nome": "Peritiba"
  },
  {
    "codigoTse": "82490",
    "ibgeCodigo": 4212700,
    "uf": "SC",
    "nome": "Petrol�ndia"
  },
  {
    "codigoTse": "82511",
    "ibgeCodigo": 4212809,
    "uf": "SC",
    "nome": "Balne�rio Pi�arras"
  },
  {
    "codigoTse": "82538",
    "ibgeCodigo": 4212908,
    "uf": "SC",
    "nome": "Pinhalzinho"
  },
  {
    "codigoTse": "82554",
    "ibgeCodigo": 4213005,
    "uf": "SC",
    "nome": "Pinheiro Preto"
  },
  {
    "codigoTse": "82570",
    "ibgeCodigo": 4213104,
    "uf": "SC",
    "nome": "Piratuba"
  },
  {
    "codigoTse": "82597",
    "ibgeCodigo": 4213203,
    "uf": "SC",
    "nome": "Pomerode"
  },
  {
    "codigoTse": "82619",
    "ibgeCodigo": 4213302,
    "uf": "SC",
    "nome": "Ponte Alta"
  },
  {
    "codigoTse": "82635",
    "ibgeCodigo": 4213401,
    "uf": "SC",
    "nome": "Ponte Serrada"
  },
  {
    "codigoTse": "82651",
    "ibgeCodigo": 4213500,
    "uf": "SC",
    "nome": "Porto Belo"
  },
  {
    "codigoTse": "82678",
    "ibgeCodigo": 4213609,
    "uf": "SC",
    "nome": "Porto Uni�o"
  },
  {
    "codigoTse": "82694",
    "ibgeCodigo": 4213708,
    "uf": "SC",
    "nome": "Pouso Redondo"
  },
  {
    "codigoTse": "82716",
    "ibgeCodigo": 4213807,
    "uf": "SC",
    "nome": "Praia Grande"
  },
  {
    "codigoTse": "82732",
    "ibgeCodigo": 4213906,
    "uf": "SC",
    "nome": "Presidente Castello Branco"
  },
  {
    "codigoTse": "82759",
    "ibgeCodigo": 4214003,
    "uf": "SC",
    "nome": "Presidente Get�lio"
  },
  {
    "codigoTse": "82775",
    "ibgeCodigo": 4214102,
    "uf": "SC",
    "nome": "Presidente Nereu"
  },
  {
    "codigoTse": "82791",
    "ibgeCodigo": 4214201,
    "uf": "SC",
    "nome": "Quilombo"
  },
  {
    "codigoTse": "82813",
    "ibgeCodigo": 4214300,
    "uf": "SC",
    "nome": "Rancho Queimado"
  },
  {
    "codigoTse": "82830",
    "ibgeCodigo": 4214409,
    "uf": "SC",
    "nome": "Rio Das Antas"
  },
  {
    "codigoTse": "82856",
    "ibgeCodigo": 4214508,
    "uf": "SC",
    "nome": "Rio Do Campo"
  },
  {
    "codigoTse": "82872",
    "ibgeCodigo": 4214607,
    "uf": "SC",
    "nome": "Rio Do Oeste"
  },
  {
    "codigoTse": "82899",
    "ibgeCodigo": 4214706,
    "uf": "SC",
    "nome": "Rio Dos Cedros"
  },
  {
    "codigoTse": "82910",
    "ibgeCodigo": 4214805,
    "uf": "SC",
    "nome": "Rio Do Sul"
  },
  {
    "codigoTse": "82937",
    "ibgeCodigo": 4214904,
    "uf": "SC",
    "nome": "Rio Fortuna"
  },
  {
    "codigoTse": "82953",
    "ibgeCodigo": 4215000,
    "uf": "SC",
    "nome": "Rio Negrinho"
  },
  {
    "codigoTse": "82970",
    "ibgeCodigo": 4215109,
    "uf": "SC",
    "nome": "Rodeio"
  },
  {
    "codigoTse": "82996",
    "ibgeCodigo": 4215208,
    "uf": "SC",
    "nome": "Romel�ndia"
  },
  {
    "codigoTse": "83011",
    "ibgeCodigo": 4215307,
    "uf": "SC",
    "nome": "Salete"
  },
  {
    "codigoTse": "83038",
    "ibgeCodigo": 4215406,
    "uf": "SC",
    "nome": "Salto Veloso"
  },
  {
    "codigoTse": "83054",
    "ibgeCodigo": 4215505,
    "uf": "SC",
    "nome": "Santa Cec�lia"
  },
  {
    "codigoTse": "83070",
    "ibgeCodigo": 4215604,
    "uf": "SC",
    "nome": "Santa Rosa De Lima"
  },
  {
    "codigoTse": "83097",
    "ibgeCodigo": 4215703,
    "uf": "SC",
    "nome": "Santo Amaro Da Imperatriz"
  },
  {
    "codigoTse": "83119",
    "ibgeCodigo": 4215802,
    "uf": "SC",
    "nome": "S�o Bento Do Sul"
  },
  {
    "codigoTse": "83135",
    "ibgeCodigo": 4215901,
    "uf": "SC",
    "nome": "S�o Bonif�cio"
  },
  {
    "codigoTse": "83151",
    "ibgeCodigo": 4216008,
    "uf": "SC",
    "nome": "S�o Carlos"
  },
  {
    "codigoTse": "83178",
    "ibgeCodigo": 4216107,
    "uf": "SC",
    "nome": "S�o Domingos"
  },
  {
    "codigoTse": "83194",
    "ibgeCodigo": 4216206,
    "uf": "SC",
    "nome": "S�o Francisco Do Sul"
  },
  {
    "codigoTse": "83216",
    "ibgeCodigo": 4216305,
    "uf": "SC",
    "nome": "S�o Jo�o Batista"
  },
  {
    "codigoTse": "83232",
    "ibgeCodigo": 4216404,
    "uf": "SC",
    "nome": "S�o Jo�o Do Sul"
  },
  {
    "codigoTse": "83259",
    "ibgeCodigo": 4216503,
    "uf": "SC",
    "nome": "S�o Joaquim"
  },
  {
    "codigoTse": "83275",
    "ibgeCodigo": 4216602,
    "uf": "SC",
    "nome": "S�o Jos�"
  },
  {
    "codigoTse": "83291",
    "ibgeCodigo": 4216701,
    "uf": "SC",
    "nome": "S�o Jos� Do Cedro"
  },
  {
    "codigoTse": "83313",
    "ibgeCodigo": 4216800,
    "uf": "SC",
    "nome": "S�o Jos� Do Cerrito"
  },
  {
    "codigoTse": "83330",
    "ibgeCodigo": 4216909,
    "uf": "SC",
    "nome": "S�o Louren�o Do Oeste"
  },
  {
    "codigoTse": "83356",
    "ibgeCodigo": 4217006,
    "uf": "SC",
    "nome": "S�o Ludgero"
  },
  {
    "codigoTse": "83372",
    "ibgeCodigo": 4217105,
    "uf": "SC",
    "nome": "S�o Martinho"
  },
  {
    "codigoTse": "83399",
    "ibgeCodigo": 4217204,
    "uf": "SC",
    "nome": "S�o Miguel Do Oeste"
  },
  {
    "codigoTse": "83410",
    "ibgeCodigo": 4217303,
    "uf": "SC",
    "nome": "Saudades"
  },
  {
    "codigoTse": "83437",
    "ibgeCodigo": 4217402,
    "uf": "SC",
    "nome": "Schroeder"
  },
  {
    "codigoTse": "83453",
    "ibgeCodigo": 4217501,
    "uf": "SC",
    "nome": "Seara"
  },
  {
    "codigoTse": "83470",
    "ibgeCodigo": 4217600,
    "uf": "SC",
    "nome": "Sider�polis"
  },
  {
    "codigoTse": "83496",
    "ibgeCodigo": 4217709,
    "uf": "SC",
    "nome": "Sombrio"
  },
  {
    "codigoTse": "83518",
    "ibgeCodigo": 4217808,
    "uf": "SC",
    "nome": "Tai�"
  },
  {
    "codigoTse": "83534",
    "ibgeCodigo": 4217907,
    "uf": "SC",
    "nome": "Tangar�"
  },
  {
    "codigoTse": "83550",
    "ibgeCodigo": 4218004,
    "uf": "SC",
    "nome": "Tijucas"
  },
  {
    "codigoTse": "83577",
    "ibgeCodigo": 4218202,
    "uf": "SC",
    "nome": "Timb�"
  },
  {
    "codigoTse": "83593",
    "ibgeCodigo": 4218301,
    "uf": "SC",
    "nome": "Tr�s Barras"
  },
  {
    "codigoTse": "83615",
    "ibgeCodigo": 4218400,
    "uf": "SC",
    "nome": "Treze De Maio"
  },
  {
    "codigoTse": "83631",
    "ibgeCodigo": 4218509,
    "uf": "SC",
    "nome": "Treze T�lias"
  },
  {
    "codigoTse": "83658",
    "ibgeCodigo": 4218608,
    "uf": "SC",
    "nome": "Trombudo Central"
  },
  {
    "codigoTse": "83674",
    "ibgeCodigo": 4218707,
    "uf": "SC",
    "nome": "Tubar�o"
  },
  {
    "codigoTse": "83682",
    "ibgeCodigo": 4218756,
    "uf": "SC",
    "nome": "Tun�polis"
  },
  {
    "codigoTse": "83690",
    "ibgeCodigo": 4218806,
    "uf": "SC",
    "nome": "Turvo"
  },
  {
    "codigoTse": "83712",
    "ibgeCodigo": 4218905,
    "uf": "SC",
    "nome": "Urubici"
  },
  {
    "codigoTse": "83739",
    "ibgeCodigo": 4219002,
    "uf": "SC",
    "nome": "Urussanga"
  },
  {
    "codigoTse": "83755",
    "ibgeCodigo": 4219101,
    "uf": "SC",
    "nome": "Varge�o"
  },
  {
    "codigoTse": "83771",
    "ibgeCodigo": 4219200,
    "uf": "SC",
    "nome": "Vidal Ramos"
  },
  {
    "codigoTse": "83798",
    "ibgeCodigo": 4219309,
    "uf": "SC",
    "nome": "Videira"
  },
  {
    "codigoTse": "83810",
    "ibgeCodigo": 4219408,
    "uf": "SC",
    "nome": "Witmarsum"
  },
  {
    "codigoTse": "83836",
    "ibgeCodigo": 4219507,
    "uf": "SC",
    "nome": "Xanxer�"
  },
  {
    "codigoTse": "83852",
    "ibgeCodigo": 4219606,
    "uf": "SC",
    "nome": "Xavantina"
  },
  {
    "codigoTse": "83879",
    "ibgeCodigo": 4219705,
    "uf": "SC",
    "nome": "Xaxim"
  },
  {
    "codigoTse": "83895",
    "ibgeCodigo": 4202503,
    "uf": "SC",
    "nome": "Bom Jardim Da Serra"
  },
  {
    "codigoTse": "83909",
    "ibgeCodigo": 4220000,
    "uf": "SC",
    "nome": "Balne�rio Rinc�o"
  },
  {
    "codigoTse": "83917",
    "ibgeCodigo": 4210407,
    "uf": "SC",
    "nome": "Maracaj�"
  },
  {
    "codigoTse": "83925",
    "ibgeCodigo": 4212650,
    "uf": "SC",
    "nome": "Pescaria Brava"
  },
  {
    "codigoTse": "83933",
    "ibgeCodigo": 4218103,
    "uf": "SC",
    "nome": "Timb� Do Sul"
  },
  {
    "codigoTse": "83950",
    "ibgeCodigo": 4204558,
    "uf": "SC",
    "nome": "Correia Pinto"
  },
  {
    "codigoTse": "83976",
    "ibgeCodigo": 4211751,
    "uf": "SC",
    "nome": "Otac�lio Costa"
  },
  {
    "codigoTse": "84514",
    "ibgeCodigo": 4104451,
    "uf": "PR",
    "nome": "Cantagalo"
  },
  {
    "codigoTse": "84530",
    "ibgeCodigo": 4127965,
    "uf": "PR",
    "nome": "Turvo"
  },
  {
    "codigoTse": "84557",
    "ibgeCodigo": 4100459,
    "uf": "PR",
    "nome": "Altamira Do Paran�"
  },
  {
    "codigoTse": "84573",
    "ibgeCodigo": 4107751,
    "uf": "PR",
    "nome": "Figueira"
  },
  {
    "codigoTse": "84590",
    "ibgeCodigo": 4113759,
    "uf": "PR",
    "nome": "Lunardelli"
  },
  {
    "codigoTse": "84611",
    "ibgeCodigo": 4126256,
    "uf": "PR",
    "nome": "Sarandi"
  },
  {
    "codigoTse": "84638",
    "ibgeCodigo": 4112959,
    "uf": "PR",
    "nome": "Juranda"
  },
  {
    "codigoTse": "84654",
    "ibgeCodigo": 4107256,
    "uf": "PR",
    "nome": "Douradina"
  },
  {
    "codigoTse": "84670",
    "ibgeCodigo": 4124053,
    "uf": "PR",
    "nome": "Santa Terezinha De Itaipu"
  },
  {
    "codigoTse": "84697",
    "ibgeCodigo": 4116059,
    "uf": "PR",
    "nome": "Missal"
  },
  {
    "codigoTse": "84719",
    "ibgeCodigo": 4125456,
    "uf": "PR",
    "nome": "S�o Jos� Das Palmeiras"
  },
  {
    "codigoTse": "84735",
    "ibgeCodigo": 4301552,
    "uf": "RS",
    "nome": "�urea"
  },
  {
    "codigoTse": "84743",
    "ibgeCodigo": 4321634,
    "uf": "RS",
    "nome": "Tr�s Arroios"
  },
  {
    "codigoTse": "84751",
    "ibgeCodigo": 4313359,
    "uf": "RS",
    "nome": "Nova Roma Do Sul"
  },
  {
    "codigoTse": "84760",
    "ibgeCodigo": 4315156,
    "uf": "RS",
    "nome": "Progresso"
  },
  {
    "codigoTse": "84778",
    "ibgeCodigo": 4314555,
    "uf": "RS",
    "nome": "Pirap�"
  },
  {
    "codigoTse": "84786",
    "ibgeCodigo": 4310850,
    "uf": "RS",
    "nome": "Jaboticaba"
  },
  {
    "codigoTse": "84794",
    "ibgeCodigo": 4318440,
    "uf": "RS",
    "nome": "S�o Jorge"
  },
  {
    "codigoTse": "84808",
    "ibgeCodigo": 4300554,
    "uf": "RS",
    "nome": "Alto Alegre"
  },
  {
    "codigoTse": "84816",
    "ibgeCodigo": 4313060,
    "uf": "RS",
    "nome": "Nova Hartz"
  },
  {
    "codigoTse": "84824",
    "ibgeCodigo": 4306452,
    "uf": "RS",
    "nome": "Dois Lajeados"
  },
  {
    "codigoTse": "84832",
    "ibgeCodigo": 4318051,
    "uf": "RS",
    "nome": "S�o Domingos Do Sul"
  },
  {
    "codigoTse": "84840",
    "ibgeCodigo": 4322152,
    "uf": "RS",
    "nome": "Tunas"
  },
  {
    "codigoTse": "84859",
    "ibgeCodigo": 4318424,
    "uf": "RS",
    "nome": "S�o Jo�o Da Urtiga"
  },
  {
    "codigoTse": "84867",
    "ibgeCodigo": 4309258,
    "uf": "RS",
    "nome": "Guabiju"
  },
  {
    "codigoTse": "84875",
    "ibgeCodigo": 4315354,
    "uf": "RS",
    "nome": "Quinze De Novembro"
  },
  {
    "codigoTse": "84883",
    "ibgeCodigo": 4306734,
    "uf": "RS",
    "nome": "Doutor Maur�cio Cardoso"
  },
  {
    "codigoTse": "84891",
    "ibgeCodigo": 4304689,
    "uf": "RS",
    "nome": "Capela De Santana"
  },
  {
    "codigoTse": "84905",
    "ibgeCodigo": 4311122,
    "uf": "RS",
    "nome": "Jaquirana"
  },
  {
    "codigoTse": "84913",
    "ibgeCodigo": 4322558,
    "uf": "RS",
    "nome": "Vanini"
  },
  {
    "codigoTse": "84921",
    "ibgeCodigo": 4302451,
    "uf": "RS",
    "nome": "Boqueir�o Do Le�o"
  },
  {
    "codigoTse": "84930",
    "ibgeCodigo": 4307864,
    "uf": "RS",
    "nome": "Fagundes Varela"
  },
  {
    "codigoTse": "84948",
    "ibgeCodigo": 4300059,
    "uf": "RS",
    "nome": "�gua Santa"
  },
  {
    "codigoTse": "84956",
    "ibgeCodigo": 4320651,
    "uf": "RS",
    "nome": "Silveira Martins"
  },
  {
    "codigoTse": "84964",
    "ibgeCodigo": 4309951,
    "uf": "RS",
    "nome": "Ibirapuit�"
  },
  {
    "codigoTse": "84972",
    "ibgeCodigo": 4309753,
    "uf": "RS",
    "nome": "Ibarama"
  },
  {
    "codigoTse": "84980",
    "ibgeCodigo": 4313953,
    "uf": "RS",
    "nome": "Pantano Grande"
  },
  {
    "codigoTse": "84999",
    "ibgeCodigo": 4310439,
    "uf": "RS",
    "nome": "Ip�"
  },
  {
    "codigoTse": "85006",
    "ibgeCodigo": 4321956,
    "uf": "RS",
    "nome": "Trindade Do Sul"
  },
  {
    "codigoTse": "85014",
    "ibgeCodigo": 4300109,
    "uf": "RS",
    "nome": "Agudo"
  },
  {
    "codigoTse": "85022",
    "ibgeCodigo": 4307054,
    "uf": "RS",
    "nome": "Ernestina"
  },
  {
    "codigoTse": "85030",
    "ibgeCodigo": 4300208,
    "uf": "RS",
    "nome": "Ajuricaba"
  },
  {
    "codigoTse": "85049",
    "ibgeCodigo": 4306353,
    "uf": "RS",
    "nome": "Dezesseis De Novembro"
  },
  {
    "codigoTse": "85057",
    "ibgeCodigo": 4300307,
    "uf": "RS",
    "nome": "Alecrim"
  },
  {
    "codigoTse": "85065",
    "ibgeCodigo": 4302659,
    "uf": "RS",
    "nome": "Brochier"
  },
  {
    "codigoTse": "85073",
    "ibgeCodigo": 4300406,
    "uf": "RS",
    "nome": "Alegrete"
  },
  {
    "codigoTse": "85081",
    "ibgeCodigo": 4306973,
    "uf": "RS",
    "nome": "Erebango"
  },
  {
    "codigoTse": "85090",
    "ibgeCodigo": 4300505,
    "uf": "RS",
    "nome": "Alpestre"
  },
  {
    "codigoTse": "85103",
    "ibgeCodigo": 4306932,
    "uf": "RS",
    "nome": "Entre-Iju�s"
  },
  {
    "codigoTse": "85111",
    "ibgeCodigo": 4300604,
    "uf": "RS",
    "nome": "Alvorada"
  },
  {
    "codigoTse": "85120",
    "ibgeCodigo": 4313037,
    "uf": "RS",
    "nome": "Nova Esperan�a Do Sul"
  },
  {
    "codigoTse": "85138",
    "ibgeCodigo": 4300703,
    "uf": "RS",
    "nome": "Anta Gorda"
  },
  {
    "codigoTse": "85146",
    "ibgeCodigo": 4314159,
    "uf": "RS",
    "nome": "Paverama"
  },
  {
    "codigoTse": "85154",
    "ibgeCodigo": 4300802,
    "uf": "RS",
    "nome": "Ant�nio Prado"
  },
  {
    "codigoTse": "85162",
    "ibgeCodigo": 4321436,
    "uf": "RS",
    "nome": "Terra De Areia"
  },
  {
    "codigoTse": "85170",
    "ibgeCodigo": 4300901,
    "uf": "RS",
    "nome": "Aratiba"
  },
  {
    "codigoTse": "85189",
    "ibgeCodigo": 4309555,
    "uf": "RS",
    "nome": "Harmonia"
  },
  {
    "codigoTse": "85197",
    "ibgeCodigo": 4301008,
    "uf": "RS",
    "nome": "Arroio Do Meio"
  },
  {
    "codigoTse": "85200",
    "ibgeCodigo": 4304101,
    "uf": "RS",
    "nome": "Campos Borges"
  },
  {
    "codigoTse": "85219",
    "ibgeCodigo": 4301107,
    "uf": "RS",
    "nome": "Arroio Dos Ratos"
  },
  {
    "codigoTse": "85227",
    "ibgeCodigo": 4305157,
    "uf": "RS",
    "nome": "Cerro Grande"
  },
  {
    "codigoTse": "85235",
    "ibgeCodigo": 4301206,
    "uf": "RS",
    "nome": "Arroio Do Tigre"
  },
  {
    "codigoTse": "85243",
    "ibgeCodigo": 4310462,
    "uf": "RS",
    "nome": "Ipiranga Do Sul"
  },
  {
    "codigoTse": "85251",
    "ibgeCodigo": 4301305,
    "uf": "RS",
    "nome": "Arroio Grande"
  },
  {
    "codigoTse": "85260",
    "ibgeCodigo": 4311254,
    "uf": "RS",
    "nome": "Lago�o"
  },
  {
    "codigoTse": "85278",
    "ibgeCodigo": 4301404,
    "uf": "RS",
    "nome": "Arvorezinha"
  },
  {
    "codigoTse": "85286",
    "ibgeCodigo": 4307559,
    "uf": "RS",
    "nome": "Esta��o"
  },
  {
    "codigoTse": "85294",
    "ibgeCodigo": 4301503,
    "uf": "RS",
    "nome": "Augusto Pestana"
  },
  {
    "codigoTse": "85308",
    "ibgeCodigo": 4301057,
    "uf": "RS",
    "nome": "Arroio Do Sal"
  },
  {
    "codigoTse": "85316",
    "ibgeCodigo": 4301602,
    "uf": "RS",
    "nome": "Bag�"
  },
  {
    "codigoTse": "85324",
    "ibgeCodigo": 4318481,
    "uf": "RS",
    "nome": "S�o Jos� Do Hort�ncio"
  },
  {
    "codigoTse": "85332",
    "ibgeCodigo": 4301701,
    "uf": "RS",
    "nome": "Bar�o De Cotegipe"
  },
  {
    "codigoTse": "85340",
    "ibgeCodigo": 4314456,
    "uf": "RS",
    "nome": "Pinhal"
  },
  {
    "codigoTse": "85359",
    "ibgeCodigo": 4301800,
    "uf": "RS",
    "nome": "Barrac�o"
  },
  {
    "codigoTse": "85367",
    "ibgeCodigo": 4321667,
    "uf": "RS",
    "nome": "Tr�s Cachoeiras"
  },
  {
    "codigoTse": "85375",
    "ibgeCodigo": 4301909,
    "uf": "RS",
    "nome": "Barra Do Ribeiro"
  },
  {
    "codigoTse": "85383",
    "ibgeCodigo": 4319752,
    "uf": "RS",
    "nome": "S�o Vendelino"
  },
  {
    "codigoTse": "85391",
    "ibgeCodigo": 4302006,
    "uf": "RS",
    "nome": "Barros Cassal"
  },
  {
    "codigoTse": "85405",
    "ibgeCodigo": 4315172,
    "uf": "RS",
    "nome": "Prot�sio Alves"
  },
  {
    "codigoTse": "85413",
    "ibgeCodigo": 4302105,
    "uf": "RS",
    "nome": "Bento Gon�alves"
  },
  {
    "codigoTse": "85421",
    "ibgeCodigo": 4315131,
    "uf": "RS",
    "nome": "Pouso Novo"
  },
  {
    "codigoTse": "85430",
    "ibgeCodigo": 4302204,
    "uf": "RS",
    "nome": "Boa Vista Do Buric�"
  },
  {
    "codigoTse": "85448",
    "ibgeCodigo": 4307831,
    "uf": "RS",
    "nome": "Eug�nio De Castro"
  },
  {
    "codigoTse": "85456",
    "ibgeCodigo": 4302303,
    "uf": "RS",
    "nome": "Bom Jesus"
  },
  {
    "codigoTse": "85464",
    "ibgeCodigo": 4306056,
    "uf": "RS",
    "nome": "Cristal"
  },
  {
    "codigoTse": "85472",
    "ibgeCodigo": 4302402,
    "uf": "RS",
    "nome": "Bom Retiro Do Sul"
  },
  {
    "codigoTse": "85480",
    "ibgeCodigo": 4319158,
    "uf": "RS",
    "nome": "S�o Miguel Das Miss�es"
  },
  {
    "codigoTse": "85499",
    "ibgeCodigo": 4302501,
    "uf": "RS",
    "nome": "Bossoroca"
  },
  {
    "codigoTse": "85502",
    "ibgeCodigo": 4309050,
    "uf": "RS",
    "nome": "Glorinha"
  },
  {
    "codigoTse": "85510",
    "ibgeCodigo": 4302600,
    "uf": "RS",
    "nome": "Braga"
  },
  {
    "codigoTse": "85529",
    "ibgeCodigo": 4320263,
    "uf": "RS",
    "nome": "Segredo"
  },
  {
    "codigoTse": "85537",
    "ibgeCodigo": 4302709,
    "uf": "RS",
    "nome": "Buti�"
  },
  {
    "codigoTse": "85545",
    "ibgeCodigo": 4300455,
    "uf": "RS",
    "nome": "Alegria"
  },
  {
    "codigoTse": "85553",
    "ibgeCodigo": 4302808,
    "uf": "RS",
    "nome": "Ca�apava Do Sul"
  },
  {
    "codigoTse": "85561",
    "ibgeCodigo": 4316436,
    "uf": "RS",
    "nome": "Saldanha Marinho"
  },
  {
    "codigoTse": "85570",
    "ibgeCodigo": 4302907,
    "uf": "RS",
    "nome": "Cacequi"
  },
  {
    "codigoTse": "85588",
    "ibgeCodigo": 4318465,
    "uf": "RS",
    "nome": "S�o Jos� Do Herval"
  },
  {
    "codigoTse": "85596",
    "ibgeCodigo": 4303004,
    "uf": "RS",
    "nome": "Cachoeira Do Sul"
  },
  {
    "codigoTse": "85600",
    "ibgeCodigo": 4323507,
    "uf": "RS",
    "nome": "Vista Alegre"
  },
  {
    "codigoTse": "85618",
    "ibgeCodigo": 4303103,
    "uf": "RS",
    "nome": "Cachoeirinha"
  },
  {
    "codigoTse": "85626",
    "ibgeCodigo": 4310751,
    "uf": "RS",
    "nome": "Ivor�"
  },
  {
    "codigoTse": "85634",
    "ibgeCodigo": 4303202,
    "uf": "RS",
    "nome": "Cacique Doble"
  },
  {
    "codigoTse": "85642",
    "ibgeCodigo": 4323408,
    "uf": "RS",
    "nome": "Vila Maria"
  },
  {
    "codigoTse": "85650",
    "ibgeCodigo": 4303301,
    "uf": "RS",
    "nome": "Caibat�"
  },
  {
    "codigoTse": "85669",
    "ibgeCodigo": 4321329,
    "uf": "RS",
    "nome": "Taquaru�u Do Sul"
  },
  {
    "codigoTse": "85677",
    "ibgeCodigo": 4303400,
    "uf": "RS",
    "nome": "Cai�ara"
  },
  {
    "codigoTse": "85685",
    "ibgeCodigo": 4310330,
    "uf": "RS",
    "nome": "Imb�"
  },
  {
    "codigoTse": "85693",
    "ibgeCodigo": 4303509,
    "uf": "RS",
    "nome": "Camaqu�"
  },
  {
    "codigoTse": "85707",
    "ibgeCodigo": 4320230,
    "uf": "RS",
    "nome": "Sede Nova"
  },
  {
    "codigoTse": "85715",
    "ibgeCodigo": 4303608,
    "uf": "RS",
    "nome": "Cambar� Do Sul"
  },
  {
    "codigoTse": "85723",
    "ibgeCodigo": 4322251,
    "uf": "RS",
    "nome": "Tupandi"
  },
  {
    "codigoTse": "85731",
    "ibgeCodigo": 4303707,
    "uf": "RS",
    "nome": "Campina Das Miss�es"
  },
  {
    "codigoTse": "85740",
    "ibgeCodigo": 4315750,
    "uf": "RS",
    "nome": "Riozinho"
  },
  {
    "codigoTse": "85758",
    "ibgeCodigo": 4303806,
    "uf": "RS",
    "nome": "Campinas Do Sul"
  },
  {
    "codigoTse": "85766",
    "ibgeCodigo": 4315453,
    "uf": "RS",
    "nome": "Relvado"
  },
  {
    "codigoTse": "85774",
    "ibgeCodigo": 4303905,
    "uf": "RS",
    "nome": "Campo Bom"
  },
  {
    "codigoTse": "85782",
    "ibgeCodigo": 4310363,
    "uf": "RS",
    "nome": "Imigrante"
  },
  {
    "codigoTse": "85790",
    "ibgeCodigo": 4304002,
    "uf": "RS",
    "nome": "Campo Novo"
  },
  {
    "codigoTse": "85804",
    "ibgeCodigo": 4305454,
    "uf": "RS",
    "nome": "Cidreira"
  },
  {
    "codigoTse": "85812",
    "ibgeCodigo": 4304200,
    "uf": "RS",
    "nome": "Candel�ria"
  },
  {
    "codigoTse": "85820",
    "ibgeCodigo": 4312351,
    "uf": "RS",
    "nome": "Montauri"
  },
  {
    "codigoTse": "85839",
    "ibgeCodigo": 4304309,
    "uf": "RS",
    "nome": "C�ndido God�i"
  },
  {
    "codigoTse": "85847",
    "ibgeCodigo": 4323705,
    "uf": "RS",
    "nome": "Vista Ga�cha"
  },
  {
    "codigoTse": "85855",
    "ibgeCodigo": 4304408,
    "uf": "RS",
    "nome": "Canela"
  },
  {
    "codigoTse": "85863",
    "ibgeCodigo": 4323606,
    "uf": "RS",
    "nome": "Vista Alegre Do Prata"
  },
  {
    "codigoTse": "85871",
    "ibgeCodigo": 4304507,
    "uf": "RS",
    "nome": "Cangu�u"
  },
  {
    "codigoTse": "85880",
    "ibgeCodigo": 4304952,
    "uf": "RS",
    "nome": "Caseiros"
  },
  {
    "codigoTse": "85898",
    "ibgeCodigo": 4304606,
    "uf": "RS",
    "nome": "Canoas"
  },
  {
    "codigoTse": "85901",
    "ibgeCodigo": 4310553,
    "uf": "RS",
    "nome": "Itacurubi"
  },
  {
    "codigoTse": "85910",
    "ibgeCodigo": 4304705,
    "uf": "RS",
    "nome": "Carazinho"
  },
  {
    "codigoTse": "85928",
    "ibgeCodigo": 4306957,
    "uf": "RS",
    "nome": "Entre Rios Do Sul"
  },
  {
    "codigoTse": "85936",
    "ibgeCodigo": 4304804,
    "uf": "RS",
    "nome": "Carlos Barbosa"
  },
  {
    "codigoTse": "85944",
    "ibgeCodigo": 4305173,
    "uf": "RS",
    "nome": "Cerro Grande Do Sul"
  },
  {
    "codigoTse": "85952",
    "ibgeCodigo": 4304903,
    "uf": "RS",
    "nome": "Casca"
  },
  {
    "codigoTse": "85960",
    "ibgeCodigo": 4303558,
    "uf": "RS",
    "nome": "Camargo"
  },
  {
    "codigoTse": "85979",
    "ibgeCodigo": 4305009,
    "uf": "RS",
    "nome": "Catu�pe"
  },
  {
    "codigoTse": "85987",
    "ibgeCodigo": 4314027,
    "uf": "RS",
    "nome": "Para�so Do Sul"
  },
  {
    "codigoTse": "85995",
    "ibgeCodigo": 4305108,
    "uf": "RS",
    "nome": "Caxias Do Sul"
  },
  {
    "codigoTse": "86010",
    "ibgeCodigo": 4305207,
    "uf": "RS",
    "nome": "Cerro Largo"
  },
  {
    "codigoTse": "86029",
    "ibgeCodigo": 4308052,
    "uf": "RS",
    "nome": "Faxinalzinho"
  },
  {
    "codigoTse": "86037",
    "ibgeCodigo": 4305306,
    "uf": "RS",
    "nome": "Chapada"
  },
  {
    "codigoTse": "86045",
    "ibgeCodigo": 4300638,
    "uf": "RS",
    "nome": "Amaral Ferrador"
  },
  {
    "codigoTse": "86053",
    "ibgeCodigo": 4305405,
    "uf": "RS",
    "nome": "Chiapetta"
  },
  {
    "codigoTse": "86061",
    "ibgeCodigo": 4323309,
    "uf": "RS",
    "nome": "Vila Flores"
  },
  {
    "codigoTse": "86070",
    "ibgeCodigo": 4305504,
    "uf": "RS",
    "nome": "Cir�aco"
  },
  {
    "codigoTse": "86088",
    "ibgeCodigo": 4305132,
    "uf": "RS",
    "nome": "Cerro Branco"
  },
  {
    "codigoTse": "86096",
    "ibgeCodigo": 4305603,
    "uf": "RS",
    "nome": "Colorado"
  },
  {
    "codigoTse": "86100",
    "ibgeCodigo": 4300661,
    "uf": "RS",
    "nome": "Andr� Da Rocha"
  },
  {
    "codigoTse": "86118",
    "ibgeCodigo": 4305702,
    "uf": "RS",
    "nome": "Condor"
  },
  {
    "codigoTse": "86126",
    "ibgeCodigo": 4314753,
    "uf": "RS",
    "nome": "Po�o Das Antas"
  },
  {
    "codigoTse": "86134",
    "ibgeCodigo": 4305801,
    "uf": "RS",
    "nome": "Constantina"
  },
  {
    "codigoTse": "86142",
    "ibgeCodigo": 4321857,
    "uf": "RS",
    "nome": "Tr�s Palmeiras"
  },
  {
    "codigoTse": "86150",
    "ibgeCodigo": 4305900,
    "uf": "RS",
    "nome": "Coronel Bicaco"
  },
  {
    "codigoTse": "86169",
    "ibgeCodigo": 4312757,
    "uf": "RS",
    "nome": "Nova Alvorada"
  },
  {
    "codigoTse": "86177",
    "ibgeCodigo": 4306007,
    "uf": "RS",
    "nome": "Crissiumal"
  },
  {
    "codigoTse": "86185",
    "ibgeCodigo": 4312450,
    "uf": "RS",
    "nome": "Morro Redondo"
  },
  {
    "codigoTse": "86193",
    "ibgeCodigo": 4306106,
    "uf": "RS",
    "nome": "Cruz Alta"
  },
  {
    "codigoTse": "86207",
    "ibgeCodigo": 4316956,
    "uf": "RS",
    "nome": "Santa Maria Do Herval"
  },
  {
    "codigoTse": "86215",
    "ibgeCodigo": 4306205,
    "uf": "RS",
    "nome": "Cruzeiro Do Sul"
  },
  {
    "codigoTse": "86223",
    "ibgeCodigo": 4301651,
    "uf": "RS",
    "nome": "Bar�o"
  },
  {
    "codigoTse": "86231",
    "ibgeCodigo": 4306304,
    "uf": "RS",
    "nome": "David Canabarro"
  },
  {
    "codigoTse": "86240",
    "ibgeCodigo": 4306767,
    "uf": "RS",
    "nome": "Eldorado Do Sul"
  },
  {
    "codigoTse": "86258",
    "ibgeCodigo": 4306403,
    "uf": "RS",
    "nome": "Dois Irm�os"
  },
  {
    "codigoTse": "86274",
    "ibgeCodigo": 4306502,
    "uf": "RS",
    "nome": "Dom Feliciano"
  },
  {
    "codigoTse": "86282",
    "ibgeCodigo": 4300570,
    "uf": "RS",
    "nome": "Alto Feliz"
  },
  {
    "codigoTse": "86290",
    "ibgeCodigo": 4306601,
    "uf": "RS",
    "nome": "Dom Pedrito"
  },
  {
    "codigoTse": "86304",
    "ibgeCodigo": 4300646,
    "uf": "RS",
    "nome": "Ametista Do Sul"
  },
  {
    "codigoTse": "86312",
    "ibgeCodigo": 4306700,
    "uf": "RS",
    "nome": "Dona Francisca"
  },
  {
    "codigoTse": "86320",
    "ibgeCodigo": 4300851,
    "uf": "RS",
    "nome": "Arambar�"
  },
  {
    "codigoTse": "86339",
    "ibgeCodigo": 4306809,
    "uf": "RS",
    "nome": "Encantado"
  },
  {
    "codigoTse": "86347",
    "ibgeCodigo": 4301750,
    "uf": "RS",
    "nome": "Bar�o Do Triunfo"
  },
  {
    "codigoTse": "86355",
    "ibgeCodigo": 4306908,
    "uf": "RS",
    "nome": "Encruzilhada Do Sul"
  },
  {
    "codigoTse": "86363",
    "ibgeCodigo": 4301859,
    "uf": "RS",
    "nome": "Barra Do Guarita"
  },
  {
    "codigoTse": "86371",
    "ibgeCodigo": 4307005,
    "uf": "RS",
    "nome": "Erechim"
  },
  {
    "codigoTse": "86380",
    "ibgeCodigo": 4301925,
    "uf": "RS",
    "nome": "Barra Do Rio Azul"
  },
  {
    "codigoTse": "86398",
    "ibgeCodigo": 4307104,
    "uf": "RS",
    "nome": "Herval"
  },
  {
    "codigoTse": "86401",
    "ibgeCodigo": 4301958,
    "uf": "RS",
    "nome": "Barra Funda"
  },
  {
    "codigoTse": "86410",
    "ibgeCodigo": 4307203,
    "uf": "RS",
    "nome": "Erval Grande"
  },
  {
    "codigoTse": "86428",
    "ibgeCodigo": 4302154,
    "uf": "RS",
    "nome": "Boa Vista Das Miss�es"
  },
  {
    "codigoTse": "86436",
    "ibgeCodigo": 4307302,
    "uf": "RS",
    "nome": "Erval Seco"
  },
  {
    "codigoTse": "86444",
    "ibgeCodigo": 4302378,
    "uf": "RS",
    "nome": "Bom Progresso"
  },
  {
    "codigoTse": "86452",
    "ibgeCodigo": 4307401,
    "uf": "RS",
    "nome": "Esmeralda"
  },
  {
    "codigoTse": "86460",
    "ibgeCodigo": 4303673,
    "uf": "RS",
    "nome": "Campestre Da Serra"
  },
  {
    "codigoTse": "86479",
    "ibgeCodigo": 4307500,
    "uf": "RS",
    "nome": "Espumoso"
  },
  {
    "codigoTse": "86487",
    "ibgeCodigo": 4304358,
    "uf": "RS",
    "nome": "Candiota"
  },
  {
    "codigoTse": "86495",
    "ibgeCodigo": 4307609,
    "uf": "RS",
    "nome": "Est�ncia Velha"
  },
  {
    "codigoTse": "86509",
    "ibgeCodigo": 4304697,
    "uf": "RS",
    "nome": "Capit�o"
  },
  {
    "codigoTse": "86517",
    "ibgeCodigo": 4307708,
    "uf": "RS",
    "nome": "Esteio"
  },
  {
    "codigoTse": "86525",
    "ibgeCodigo": 4304853,
    "uf": "RS",
    "nome": "Carlos Gomes"
  },
  {
    "codigoTse": "86533",
    "ibgeCodigo": 4307807,
    "uf": "RS",
    "nome": "Estrela"
  },
  {
    "codigoTse": "86541",
    "ibgeCodigo": 4305116,
    "uf": "RS",
    "nome": "Centen�rio"
  },
  {
    "codigoTse": "86550",
    "ibgeCodigo": 4307906,
    "uf": "RS",
    "nome": "Farroupilha"
  },
  {
    "codigoTse": "86568",
    "ibgeCodigo": 4305371,
    "uf": "RS",
    "nome": "Charrua"
  },
  {
    "codigoTse": "86576",
    "ibgeCodigo": 4308003,
    "uf": "RS",
    "nome": "Faxinal Do Soturno"
  },
  {
    "codigoTse": "86584",
    "ibgeCodigo": 4305587,
    "uf": "RS",
    "nome": "Colinas"
  },
  {
    "codigoTse": "86592",
    "ibgeCodigo": 4308102,
    "uf": "RS",
    "nome": "Feliz"
  },
  {
    "codigoTse": "86606",
    "ibgeCodigo": 4305850,
    "uf": "RS",
    "nome": "Coqueiros Do Sul"
  },
  {
    "codigoTse": "86614",
    "ibgeCodigo": 4308201,
    "uf": "RS",
    "nome": "Flores Da Cunha"
  },
  {
    "codigoTse": "86622",
    "ibgeCodigo": 4305871,
    "uf": "RS",
    "nome": "Coronel Barros"
  },
  {
    "codigoTse": "86630",
    "ibgeCodigo": 4308300,
    "uf": "RS",
    "nome": "Fontoura Xavier"
  },
  {
    "codigoTse": "86649",
    "ibgeCodigo": 4305975,
    "uf": "RS",
    "nome": "Coxilha"
  },
  {
    "codigoTse": "86657",
    "ibgeCodigo": 4308409,
    "uf": "RS",
    "nome": "Formigueiro"
  },
  {
    "codigoTse": "86665",
    "ibgeCodigo": 4306320,
    "uf": "RS",
    "nome": "Derrubadas"
  },
  {
    "codigoTse": "86673",
    "ibgeCodigo": 4308508,
    "uf": "RS",
    "nome": "Frederico Westphalen"
  },
  {
    "codigoTse": "86681",
    "ibgeCodigo": 4306429,
    "uf": "RS",
    "nome": "Dois Irm�os Das Miss�es"
  },
  {
    "codigoTse": "86690",
    "ibgeCodigo": 4308607,
    "uf": "RS",
    "nome": "Garibaldi"
  },
  {
    "codigoTse": "86703",
    "ibgeCodigo": 4306924,
    "uf": "RS",
    "nome": "Engenho Velho"
  },
  {
    "codigoTse": "86711",
    "ibgeCodigo": 4308706,
    "uf": "RS",
    "nome": "Gaurama"
  },
  {
    "codigoTse": "86720",
    "ibgeCodigo": 4308656,
    "uf": "RS",
    "nome": "Garruchos"
  },
  {
    "codigoTse": "86738",
    "ibgeCodigo": 4308805,
    "uf": "RS",
    "nome": "General C�mara"
  },
  {
    "codigoTse": "86746",
    "ibgeCodigo": 4308854,
    "uf": "RS",
    "nome": "Gentil"
  },
  {
    "codigoTse": "86754",
    "ibgeCodigo": 4319802,
    "uf": "RS",
    "nome": "S�o Vicente Do Sul"
  },
  {
    "codigoTse": "86762",
    "ibgeCodigo": 4309126,
    "uf": "RS",
    "nome": "Gramado Dos Loureiros"
  },
  {
    "codigoTse": "86770",
    "ibgeCodigo": 4308904,
    "uf": "RS",
    "nome": "Get�lio Vargas"
  },
  {
    "codigoTse": "86789",
    "ibgeCodigo": 4309159,
    "uf": "RS",
    "nome": "Gramado Xavier"
  },
  {
    "codigoTse": "86797",
    "ibgeCodigo": 4309001,
    "uf": "RS",
    "nome": "Giru�"
  },
  {
    "codigoTse": "86800",
    "ibgeCodigo": 4309654,
    "uf": "RS",
    "nome": "Hulha Negra"
  },
  {
    "codigoTse": "86819",
    "ibgeCodigo": 4309100,
    "uf": "RS",
    "nome": "Gramado"
  },
  {
    "codigoTse": "86827",
    "ibgeCodigo": 4310413,
    "uf": "RS",
    "nome": "Inhacor�"
  },
  {
    "codigoTse": "86835",
    "ibgeCodigo": 4309209,
    "uf": "RS",
    "nome": "Gravata�"
  },
  {
    "codigoTse": "86843",
    "ibgeCodigo": 4310579,
    "uf": "RS",
    "nome": "Itapuca"
  },
  {
    "codigoTse": "86851",
    "ibgeCodigo": 4309308,
    "uf": "RS",
    "nome": "Gua�ba"
  },
  {
    "codigoTse": "86860",
    "ibgeCodigo": 4311429,
    "uf": "RS",
    "nome": "Lajeado Do Bugre"
  },
  {
    "codigoTse": "86878",
    "ibgeCodigo": 4309407,
    "uf": "RS",
    "nome": "Guapor�"
  },
  {
    "codigoTse": "86886",
    "ibgeCodigo": 4311270,
    "uf": "RS",
    "nome": "Lagoa Dos Tr�s Cantos"
  },
  {
    "codigoTse": "86894",
    "ibgeCodigo": 4309506,
    "uf": "RS",
    "nome": "Guarani Das Miss�es"
  },
  {
    "codigoTse": "86908",
    "ibgeCodigo": 4311627,
    "uf": "RS",
    "nome": "Lindolfo Collor"
  },
  {
    "codigoTse": "86916",
    "ibgeCodigo": 4309605,
    "uf": "RS",
    "nome": "Horizontina"
  },
  {
    "codigoTse": "86924",
    "ibgeCodigo": 4311643,
    "uf": "RS",
    "nome": "Linha Nova"
  },
  {
    "codigoTse": "86932",
    "ibgeCodigo": 4305355,
    "uf": "RS",
    "nome": "Charqueadas"
  },
  {
    "codigoTse": "86940",
    "ibgeCodigo": 4311759,
    "uf": "RS",
    "nome": "Manoel Viana"
  },
  {
    "codigoTse": "86959",
    "ibgeCodigo": 4309704,
    "uf": "RS",
    "nome": "Humait�"
  },
  {
    "codigoTse": "86967",
    "ibgeCodigo": 4311775,
    "uf": "RS",
    "nome": "Maquin�"
  },
  {
    "codigoTse": "86975",
    "ibgeCodigo": 4309803,
    "uf": "RS",
    "nome": "Ibia��"
  },
  {
    "codigoTse": "86983",
    "ibgeCodigo": 4311791,
    "uf": "RS",
    "nome": "Marat�"
  },
  {
    "codigoTse": "86991",
    "ibgeCodigo": 4309902,
    "uf": "RS",
    "nome": "Ibiraiaras"
  },
  {
    "codigoTse": "87009",
    "ibgeCodigo": 4311981,
    "uf": "RS",
    "nome": "Mariana Pimentel"
  },
  {
    "codigoTse": "87017",
    "ibgeCodigo": 4310009,
    "uf": "RS",
    "nome": "Ibirub�"
  },
  {
    "codigoTse": "87025",
    "ibgeCodigo": 4312138,
    "uf": "RS",
    "nome": "Mato Castelhano"
  },
  {
    "codigoTse": "87033",
    "ibgeCodigo": 4310108,
    "uf": "RS",
    "nome": "Igrejinha"
  },
  {
    "codigoTse": "87041",
    "ibgeCodigo": 4312153,
    "uf": "RS",
    "nome": "Mato Leit�o"
  },
  {
    "codigoTse": "87050",
    "ibgeCodigo": 4310207,
    "uf": "RS",
    "nome": "Iju�"
  },
  {
    "codigoTse": "87068",
    "ibgeCodigo": 4312252,
    "uf": "RS",
    "nome": "Minas Do Le�o"
  },
  {
    "codigoTse": "87076",
    "ibgeCodigo": 4310306,
    "uf": "RS",
    "nome": "Il�polis"
  },
  {
    "codigoTse": "87084",
    "ibgeCodigo": 4312385,
    "uf": "RS",
    "nome": "Monte Belo Do Sul"
  },
  {
    "codigoTse": "87092",
    "ibgeCodigo": 4310405,
    "uf": "RS",
    "nome": "Independ�ncia"
  },
  {
    "codigoTse": "87106",
    "ibgeCodigo": 4312427,
    "uf": "RS",
    "nome": "Morma�o"
  },
  {
    "codigoTse": "87114",
    "ibgeCodigo": 4310504,
    "uf": "RS",
    "nome": "Ira�"
  },
  {
    "codigoTse": "87122",
    "ibgeCodigo": 4312443,
    "uf": "RS",
    "nome": "Morrinhos Do Sul"
  },
  {
    "codigoTse": "87130",
    "ibgeCodigo": 4310603,
    "uf": "RS",
    "nome": "Itaqui"
  },
  {
    "codigoTse": "87149",
    "ibgeCodigo": 4312476,
    "uf": "RS",
    "nome": "Morro Reuter"
  },
  {
    "codigoTse": "87157",
    "ibgeCodigo": 4310702,
    "uf": "RS",
    "nome": "Itatiba Do Sul"
  },
  {
    "codigoTse": "87165",
    "ibgeCodigo": 4312625,
    "uf": "RS",
    "nome": "Muliterno"
  },
  {
    "codigoTse": "87173",
    "ibgeCodigo": 4310801,
    "uf": "RS",
    "nome": "Ivoti"
  },
  {
    "codigoTse": "87181",
    "ibgeCodigo": 4312674,
    "uf": "RS",
    "nome": "Nicolau Vergueiro"
  },
  {
    "codigoTse": "87190",
    "ibgeCodigo": 4310900,
    "uf": "RS",
    "nome": "Jacutinga"
  },
  {
    "codigoTse": "87203",
    "ibgeCodigo": 4312955,
    "uf": "RS",
    "nome": "Nova Boa Vista"
  },
  {
    "codigoTse": "87211",
    "ibgeCodigo": 4311007,
    "uf": "RS",
    "nome": "Jaguar�o"
  },
  {
    "codigoTse": "87220",
    "ibgeCodigo": 4313086,
    "uf": "RS",
    "nome": "Nova P�dua"
  },
  {
    "codigoTse": "87238",
    "ibgeCodigo": 4311106,
    "uf": "RS",
    "nome": "Jaguari"
  },
  {
    "codigoTse": "87246",
    "ibgeCodigo": 4313375,
    "uf": "RS",
    "nome": "Nova Santa Rita"
  },
  {
    "codigoTse": "87254",
    "ibgeCodigo": 4311205,
    "uf": "RS",
    "nome": "J�lio De Castilhos"
  },
  {
    "codigoTse": "87262",
    "ibgeCodigo": 4313490,
    "uf": "RS",
    "nome": "Novo Barreiro"
  },
  {
    "codigoTse": "87270",
    "ibgeCodigo": 4311304,
    "uf": "RS",
    "nome": "Lagoa Vermelha"
  },
  {
    "codigoTse": "87289",
    "ibgeCodigo": 4313425,
    "uf": "RS",
    "nome": "Novo Machado"
  },
  {
    "codigoTse": "87297",
    "ibgeCodigo": 4311403,
    "uf": "RS",
    "nome": "Lajeado"
  },
  {
    "codigoTse": "87300",
    "ibgeCodigo": 4313441,
    "uf": "RS",
    "nome": "Novo Tiradentes"
  },
  {
    "codigoTse": "87319",
    "ibgeCodigo": 4311502,
    "uf": "RS",
    "nome": "Lavras Do Sul"
  },
  {
    "codigoTse": "87327",
    "ibgeCodigo": 4314035,
    "uf": "RS",
    "nome": "Pareci Novo"
  },
  {
    "codigoTse": "87335",
    "ibgeCodigo": 4311601,
    "uf": "RS",
    "nome": "Liberato Salzano"
  },
  {
    "codigoTse": "87343",
    "ibgeCodigo": 4314076,
    "uf": "RS",
    "nome": "Passo Do Sobrado"
  },
  {
    "codigoTse": "87351",
    "ibgeCodigo": 4311700,
    "uf": "RS",
    "nome": "Machadinho"
  },
  {
    "codigoTse": "87360",
    "ibgeCodigo": 4314423,
    "uf": "RS",
    "nome": "Picada Caf�"
  },
  {
    "codigoTse": "87378",
    "ibgeCodigo": 4311809,
    "uf": "RS",
    "nome": "Marau"
  },
  {
    "codigoTse": "87386",
    "ibgeCodigo": 4314472,
    "uf": "RS",
    "nome": "Pinhal Grande"
  },
  {
    "codigoTse": "87394",
    "ibgeCodigo": 4311908,
    "uf": "RS",
    "nome": "Marcelino Ramos"
  },
  {
    "codigoTse": "87408",
    "ibgeCodigo": 4314498,
    "uf": "RS",
    "nome": "Pinheirinho Do Vale"
  },
  {
    "codigoTse": "87416",
    "ibgeCodigo": 4312005,
    "uf": "RS",
    "nome": "Mariano Moro"
  },
  {
    "codigoTse": "87424",
    "ibgeCodigo": 4314779,
    "uf": "RS",
    "nome": "Pont�o"
  },
  {
    "codigoTse": "87432",
    "ibgeCodigo": 4312104,
    "uf": "RS",
    "nome": "Mata"
  },
  {
    "codigoTse": "87440",
    "ibgeCodigo": 4314787,
    "uf": "RS",
    "nome": "Ponte Preta"
  },
  {
    "codigoTse": "87459",
    "ibgeCodigo": 4312203,
    "uf": "RS",
    "nome": "Maximiliano De Almeida"
  },
  {
    "codigoTse": "87467",
    "ibgeCodigo": 4315057,
    "uf": "RS",
    "nome": "Porto Mau�"
  },
  {
    "codigoTse": "87475",
    "ibgeCodigo": 4312302,
    "uf": "RS",
    "nome": "Miragua�"
  },
  {
    "codigoTse": "87483",
    "ibgeCodigo": 4315073,
    "uf": "RS",
    "nome": "Porto Vera Cruz"
  },
  {
    "codigoTse": "87491",
    "ibgeCodigo": 4312401,
    "uf": "RS",
    "nome": "Montenegro"
  },
  {
    "codigoTse": "87505",
    "ibgeCodigo": 4315149,
    "uf": "RS",
    "nome": "Presidente Lucena"
  },
  {
    "codigoTse": "87513",
    "ibgeCodigo": 4312500,
    "uf": "RS",
    "nome": "Mostardas"
  },
  {
    "codigoTse": "87521",
    "ibgeCodigo": 4315321,
    "uf": "RS",
    "nome": "Quevedos"
  },
  {
    "codigoTse": "87530",
    "ibgeCodigo": 4312609,
    "uf": "RS",
    "nome": "Mu�um"
  },
  {
    "codigoTse": "87548",
    "ibgeCodigo": 4315552,
    "uf": "RS",
    "nome": "Rio Dos �ndios"
  },
  {
    "codigoTse": "87556",
    "ibgeCodigo": 4312658,
    "uf": "RS",
    "nome": "N�o-Me-Toque"
  },
  {
    "codigoTse": "87564",
    "ibgeCodigo": 4316428,
    "uf": "RS",
    "nome": "Sagrada Fam�lia"
  },
  {
    "codigoTse": "87572",
    "ibgeCodigo": 4312708,
    "uf": "RS",
    "nome": "Nonoai"
  },
  {
    "codigoTse": "87580",
    "ibgeCodigo": 4316477,
    "uf": "RS",
    "nome": "Salvador Das Miss�es"
  },
  {
    "codigoTse": "87599",
    "ibgeCodigo": 4312807,
    "uf": "RS",
    "nome": "Nova Ara��"
  },
  {
    "codigoTse": "87602",
    "ibgeCodigo": 4316758,
    "uf": "RS",
    "nome": "Santa Clara Do Sul"
  },
  {
    "codigoTse": "87610",
    "ibgeCodigo": 4312906,
    "uf": "RS",
    "nome": "Nova Bassano"
  },
  {
    "codigoTse": "87629",
    "ibgeCodigo": 4317251,
    "uf": "RS",
    "nome": "Santa Tereza"
  },
  {
    "codigoTse": "87637",
    "ibgeCodigo": 4313003,
    "uf": "RS",
    "nome": "Nova Br�scia"
  },
  {
    "codigoTse": "87645",
    "ibgeCodigo": 4317558,
    "uf": "RS",
    "nome": "Santo Ant�nio Do Palma"
  },
  {
    "codigoTse": "87653",
    "ibgeCodigo": 4313102,
    "uf": "RS",
    "nome": "Nova Palma"
  },
  {
    "codigoTse": "87661",
    "ibgeCodigo": 4317756,
    "uf": "RS",
    "nome": "Santo Ant�nio Do Planalto"
  },
  {
    "codigoTse": "87670",
    "ibgeCodigo": 4313201,
    "uf": "RS",
    "nome": "Nova Petr�polis"
  },
  {
    "codigoTse": "87688",
    "ibgeCodigo": 4317954,
    "uf": "RS",
    "nome": "Santo Expedito Do Sul"
  },
  {
    "codigoTse": "87696",
    "ibgeCodigo": 4313300,
    "uf": "RS",
    "nome": "Nova Prata"
  },
  {
    "codigoTse": "87700",
    "ibgeCodigo": 4318432,
    "uf": "RS",
    "nome": "S�o Jo�o Do Pol�sine"
  },
  {
    "codigoTse": "87718",
    "ibgeCodigo": 4313409,
    "uf": "RS",
    "nome": "Novo Hamburgo"
  },
  {
    "codigoTse": "87726",
    "ibgeCodigo": 4318622,
    "uf": "RS",
    "nome": "S�o Jos� Dos Ausentes"
  },
  {
    "codigoTse": "87734",
    "ibgeCodigo": 4313508,
    "uf": "RS",
    "nome": "Os�rio"
  },
  {
    "codigoTse": "87742",
    "ibgeCodigo": 4318499,
    "uf": "RS",
    "nome": "S�o Jos� Do Inhacor�"
  },
  {
    "codigoTse": "87750",
    "ibgeCodigo": 4313607,
    "uf": "RS",
    "nome": "Paim Filho"
  },
  {
    "codigoTse": "87769",
    "ibgeCodigo": 4318457,
    "uf": "RS",
    "nome": "S�o Jos� Das Miss�es"
  },
  {
    "codigoTse": "87777",
    "ibgeCodigo": 4313706,
    "uf": "RS",
    "nome": "Palmeira Das Miss�es"
  },
  {
    "codigoTse": "87785",
    "ibgeCodigo": 4319125,
    "uf": "RS",
    "nome": "S�o Martinho Da Serra"
  },
  {
    "codigoTse": "87793",
    "ibgeCodigo": 4313805,
    "uf": "RS",
    "nome": "Palmitinho"
  },
  {
    "codigoTse": "87807",
    "ibgeCodigo": 4319356,
    "uf": "RS",
    "nome": "S�o Pedro Da Serra"
  },
  {
    "codigoTse": "87815",
    "ibgeCodigo": 4313904,
    "uf": "RS",
    "nome": "Panambi"
  },
  {
    "codigoTse": "87823",
    "ibgeCodigo": 4319372,
    "uf": "RS",
    "nome": "S�o Pedro Do Buti�"
  },
  {
    "codigoTse": "87831",
    "ibgeCodigo": 4314001,
    "uf": "RS",
    "nome": "Para�"
  },
  {
    "codigoTse": "87840",
    "ibgeCodigo": 4319711,
    "uf": "RS",
    "nome": "S�o Valentim Do Sul"
  },
  {
    "codigoTse": "87858",
    "ibgeCodigo": 4314100,
    "uf": "RS",
    "nome": "Passo Fundo"
  },
  {
    "codigoTse": "87866",
    "ibgeCodigo": 4319737,
    "uf": "RS",
    "nome": "S�o Val�rio Do Sul"
  },
  {
    "codigoTse": "87874",
    "ibgeCodigo": 4314209,
    "uf": "RS",
    "nome": "Pedro Os�rio"
  },
  {
    "codigoTse": "87882",
    "ibgeCodigo": 4320354,
    "uf": "RS",
    "nome": "Sentinela Do Sul"
  },
  {
    "codigoTse": "87890",
    "ibgeCodigo": 4314308,
    "uf": "RS",
    "nome": "Peju�ara"
  },
  {
    "codigoTse": "87904",
    "ibgeCodigo": 4320453,
    "uf": "RS",
    "nome": "S�rio"
  },
  {
    "codigoTse": "87912",
    "ibgeCodigo": 4314407,
    "uf": "RS",
    "nome": "Pelotas"
  },
  {
    "codigoTse": "87920",
    "ibgeCodigo": 4320552,
    "uf": "RS",
    "nome": "Sert�o Santana"
  },
  {
    "codigoTse": "87939",
    "ibgeCodigo": 4314506,
    "uf": "RS",
    "nome": "Pinheiro Machado"
  },
  {
    "codigoTse": "87947",
    "ibgeCodigo": 4320677,
    "uf": "RS",
    "nome": "Sinimbu"
  },
  {
    "codigoTse": "87955",
    "ibgeCodigo": 4314605,
    "uf": "RS",
    "nome": "Piratini"
  },
  {
    "codigoTse": "87963",
    "ibgeCodigo": 4321477,
    "uf": "RS",
    "nome": "Tiradentes Do Sul"
  },
  {
    "codigoTse": "87971",
    "ibgeCodigo": 4314704,
    "uf": "RS",
    "nome": "Planalto"
  },
  {
    "codigoTse": "87980",
    "ibgeCodigo": 4321626,
    "uf": "RS",
    "nome": "Travesseiro"
  },
  {
    "codigoTse": "87998",
    "ibgeCodigo": 4314803,
    "uf": "RS",
    "nome": "Port�o"
  },
  {
    "codigoTse": "88005",
    "ibgeCodigo": 4321832,
    "uf": "RS",
    "nome": "Tr�s Forquilhas"
  },
  {
    "codigoTse": "88013",
    "ibgeCodigo": 4314902,
    "uf": "RS",
    "nome": "Porto Alegre"
  },
  {
    "codigoTse": "88021",
    "ibgeCodigo": 4322186,
    "uf": "RS",
    "nome": "Tupanci Do Sul"
  },
  {
    "codigoTse": "88030",
    "ibgeCodigo": 4315008,
    "uf": "RS",
    "nome": "Porto Lucena"
  },
  {
    "codigoTse": "88048",
    "ibgeCodigo": 4322350,
    "uf": "RS",
    "nome": "Uni�o Da Serra"
  },
  {
    "codigoTse": "88056",
    "ibgeCodigo": 4315107,
    "uf": "RS",
    "nome": "Porto Xavier"
  },
  {
    "codigoTse": "88064",
    "ibgeCodigo": 4322533,
    "uf": "RS",
    "nome": "Vale Do Sol"
  },
  {
    "codigoTse": "88072",
    "ibgeCodigo": 4315206,
    "uf": "RS",
    "nome": "Putinga"
  },
  {
    "codigoTse": "88080",
    "ibgeCodigo": 4322541,
    "uf": "RS",
    "nome": "Vale Real"
  },
  {
    "codigoTse": "88099",
    "ibgeCodigo": 4315305,
    "uf": "RS",
    "nome": "Quara�"
  },
  {
    "codigoTse": "88102",
    "ibgeCodigo": 4323457,
    "uf": "RS",
    "nome": "Vila Nova Do Sul"
  },
  {
    "codigoTse": "88110",
    "ibgeCodigo": 4315404,
    "uf": "RS",
    "nome": "Redentora"
  },
  {
    "codigoTse": "88129",
    "ibgeCodigo": 4323754,
    "uf": "RS",
    "nome": "Vit�ria Das Miss�es"
  },
  {
    "codigoTse": "88137",
    "ibgeCodigo": 4315503,
    "uf": "RS",
    "nome": "Restinga Seca"
  },
  {
    "codigoTse": "88145",
    "ibgeCodigo": 4323804,
    "uf": "RS",
    "nome": "Xangri-L�"
  },
  {
    "codigoTse": "88153",
    "ibgeCodigo": 4315602,
    "uf": "RS",
    "nome": "Rio Grande"
  },
  {
    "codigoTse": "88161",
    "ibgeCodigo": 4302253,
    "uf": "RS",
    "nome": "Boa Vista Do Sul"
  },
  {
    "codigoTse": "88170",
    "ibgeCodigo": 4315701,
    "uf": "RS",
    "nome": "Rio Pardo"
  },
  {
    "codigoTse": "88188",
    "ibgeCodigo": 4306379,
    "uf": "RS",
    "nome": "Dilermando De Aguiar"
  },
  {
    "codigoTse": "88196",
    "ibgeCodigo": 4315800,
    "uf": "RS",
    "nome": "Roca Sales"
  },
  {
    "codigoTse": "88200",
    "ibgeCodigo": 4304671,
    "uf": "RS",
    "nome": "Capivari Do Sul"
  },
  {
    "codigoTse": "88218",
    "ibgeCodigo": 4315909,
    "uf": "RS",
    "nome": "Rodeio Bonito"
  },
  {
    "codigoTse": "88226",
    "ibgeCodigo": 4313011,
    "uf": "RS",
    "nome": "Nova Candel�ria"
  },
  {
    "codigoTse": "88234",
    "ibgeCodigo": 4316006,
    "uf": "RS",
    "nome": "Rolante"
  },
  {
    "codigoTse": "88242",
    "ibgeCodigo": 4308250,
    "uf": "RS",
    "nome": "Floriano Peixoto"
  },
  {
    "codigoTse": "88250",
    "ibgeCodigo": 4316105,
    "uf": "RS",
    "nome": "Ronda Alta"
  },
  {
    "codigoTse": "88269",
    "ibgeCodigo": 4305447,
    "uf": "RS",
    "nome": "Chuvisca"
  },
  {
    "codigoTse": "88277",
    "ibgeCodigo": 4316204,
    "uf": "RS",
    "nome": "Rondinha"
  },
  {
    "codigoTse": "88285",
    "ibgeCodigo": 4307450,
    "uf": "RS",
    "nome": "Esperan�a Do Sul"
  },
  {
    "codigoTse": "88293",
    "ibgeCodigo": 4316303,
    "uf": "RS",
    "nome": "Roque Gonzales"
  },
  {
    "codigoTse": "88307",
    "ibgeCodigo": 4306759,
    "uf": "RS",
    "nome": "Doutor Ricardo"
  },
  {
    "codigoTse": "88315",
    "ibgeCodigo": 4316402,
    "uf": "RS",
    "nome": "Ros�rio Do Sul"
  },
  {
    "codigoTse": "88323",
    "ibgeCodigo": 4309571,
    "uf": "RS",
    "nome": "Herveiras"
  },
  {
    "codigoTse": "88331",
    "ibgeCodigo": 4316501,
    "uf": "RS",
    "nome": "Salvador Do Sul"
  },
  {
    "codigoTse": "88340",
    "ibgeCodigo": 4304713,
    "uf": "RS",
    "nome": "Cara�"
  },
  {
    "codigoTse": "88358",
    "ibgeCodigo": 4316600,
    "uf": "RS",
    "nome": "Sananduva"
  },
  {
    "codigoTse": "88366",
    "ibgeCodigo": 4308078,
    "uf": "RS",
    "nome": "Fazenda Vilanova"
  },
  {
    "codigoTse": "88374",
    "ibgeCodigo": 4316709,
    "uf": "RS",
    "nome": "Santa B�rbara Do Sul"
  },
  {
    "codigoTse": "88382",
    "ibgeCodigo": 4310538,
    "uf": "RS",
    "nome": "Itaara"
  },
  {
    "codigoTse": "88390",
    "ibgeCodigo": 4316808,
    "uf": "RS",
    "nome": "Santa Cruz Do Sul"
  },
  {
    "codigoTse": "88404",
    "ibgeCodigo": 4307815,
    "uf": "RS",
    "nome": "Estrela Velha"
  },
  {
    "codigoTse": "88412",
    "ibgeCodigo": 4316907,
    "uf": "RS",
    "nome": "Santa Maria"
  },
  {
    "codigoTse": "88420",
    "ibgeCodigo": 4302055,
    "uf": "RS",
    "nome": "Benjamin Constant Do Sul"
  },
  {
    "codigoTse": "88439",
    "ibgeCodigo": 4317004,
    "uf": "RS",
    "nome": "Santana Da Boa Vista"
  },
  {
    "codigoTse": "88447",
    "ibgeCodigo": 4311718,
    "uf": "RS",
    "nome": "Ma�ambar�"
  },
  {
    "codigoTse": "88455",
    "ibgeCodigo": 4317103,
    "uf": "RS",
    "nome": "Sant' Ana Do Livramento"
  },
  {
    "codigoTse": "88463",
    "ibgeCodigo": 4306551,
    "uf": "RS",
    "nome": "Dom Pedro De Alc�ntara"
  },
  {
    "codigoTse": "88471",
    "ibgeCodigo": 4317202,
    "uf": "RS",
    "nome": "Santa Rosa"
  },
  {
    "codigoTse": "88480",
    "ibgeCodigo": 4322376,
    "uf": "RS",
    "nome": "Unistalda"
  },
  {
    "codigoTse": "88498",
    "ibgeCodigo": 4317301,
    "uf": "RS",
    "nome": "Santa Vit�ria Do Palmar"
  },
  {
    "codigoTse": "88501",
    "ibgeCodigo": 4322327,
    "uf": "RS",
    "nome": "Turu�u"
  },
  {
    "codigoTse": "88510",
    "ibgeCodigo": 4317400,
    "uf": "RS",
    "nome": "Santiago"
  },
  {
    "codigoTse": "88528",
    "ibgeCodigo": 4306072,
    "uf": "RS",
    "nome": "Cristal Do Sul"
  },
  {
    "codigoTse": "88536",
    "ibgeCodigo": 4317509,
    "uf": "RS",
    "nome": "Santo �ngelo"
  },
  {
    "codigoTse": "88544",
    "ibgeCodigo": 4312617,
    "uf": "RS",
    "nome": "Muitos Cap�es"
  },
  {
    "codigoTse": "88552",
    "ibgeCodigo": 4317608,
    "uf": "RS",
    "nome": "Santo Ant�nio Da Patrulha"
  },
  {
    "codigoTse": "88560",
    "ibgeCodigo": 4313334,
    "uf": "RS",
    "nome": "Nova Ramada"
  },
  {
    "codigoTse": "88579",
    "ibgeCodigo": 4317707,
    "uf": "RS",
    "nome": "Santo Ant�nio Das Miss�es"
  },
  {
    "codigoTse": "88587",
    "ibgeCodigo": 4311130,
    "uf": "RS",
    "nome": "Jari"
  },
  {
    "codigoTse": "88595",
    "ibgeCodigo": 4317806,
    "uf": "RS",
    "nome": "Santo Augusto"
  },
  {
    "codigoTse": "88609",
    "ibgeCodigo": 4322343,
    "uf": "RS",
    "nome": "Ubiretama"
  },
  {
    "codigoTse": "88617",
    "ibgeCodigo": 4317905,
    "uf": "RS",
    "nome": "Santo Cristo"
  },
  {
    "codigoTse": "88625",
    "ibgeCodigo": 4301875,
    "uf": "RS",
    "nome": "Barra Do Quara�"
  },
  {
    "codigoTse": "88633",
    "ibgeCodigo": 4318002,
    "uf": "RS",
    "nome": "S�o Borja"
  },
  {
    "codigoTse": "88641",
    "ibgeCodigo": 4305124,
    "uf": "RS",
    "nome": "Cerrito"
  },
  {
    "codigoTse": "88650",
    "ibgeCodigo": 4318101,
    "uf": "RS",
    "nome": "S�o Francisco De Assis"
  },
  {
    "codigoTse": "88668",
    "ibgeCodigo": 4322525,
    "uf": "RS",
    "nome": "Vale Verde"
  },
  {
    "codigoTse": "88676",
    "ibgeCodigo": 4318200,
    "uf": "RS",
    "nome": "S�o Francisco De Paula"
  },
  {
    "codigoTse": "88684",
    "ibgeCodigo": 4313391,
    "uf": "RS",
    "nome": "Novo Cabrais"
  },
  {
    "codigoTse": "88692",
    "ibgeCodigo": 4318309,
    "uf": "RS",
    "nome": "S�o Gabriel"
  },
  {
    "codigoTse": "88706",
    "ibgeCodigo": 4320578,
    "uf": "RS",
    "nome": "Sete De Setembro"
  },
  {
    "codigoTse": "88714",
    "ibgeCodigo": 4318408,
    "uf": "RS",
    "nome": "S�o Jer�nimo"
  },
  {
    "codigoTse": "88722",
    "ibgeCodigo": 4320859,
    "uf": "RS",
    "nome": "Taba�"
  },
  {
    "codigoTse": "88730",
    "ibgeCodigo": 4318507,
    "uf": "RS",
    "nome": "S�o Jos� Do Norte"
  },
  {
    "codigoTse": "88749",
    "ibgeCodigo": 4323358,
    "uf": "RS",
    "nome": "Vila L�ngaro"
  },
  {
    "codigoTse": "88757",
    "ibgeCodigo": 4318606,
    "uf": "RS",
    "nome": "S�o Jos� Do Ouro"
  },
  {
    "codigoTse": "88765",
    "ibgeCodigo": 4320321,
    "uf": "RS",
    "nome": "Senador Salgado Filho"
  },
  {
    "codigoTse": "88773",
    "ibgeCodigo": 4318705,
    "uf": "RS",
    "nome": "S�o Leopoldo"
  },
  {
    "codigoTse": "88781",
    "ibgeCodigo": 4322855,
    "uf": "RS",
    "nome": "Vespasiano Correa"
  },
  {
    "codigoTse": "88790",
    "ibgeCodigo": 4318804,
    "uf": "RS",
    "nome": "S�o Louren�o Do Sul"
  },
  {
    "codigoTse": "88803",
    "ibgeCodigo": 4312377,
    "uf": "RS",
    "nome": "Monte Alegre Dos Campos"
  },
  {
    "codigoTse": "88811",
    "ibgeCodigo": 4318903,
    "uf": "RS",
    "nome": "S�o Luiz Gonzaga"
  },
  {
    "codigoTse": "88820",
    "ibgeCodigo": 4312054,
    "uf": "RS",
    "nome": "Marques De Souza"
  },
  {
    "codigoTse": "88838",
    "ibgeCodigo": 4319000,
    "uf": "RS",
    "nome": "S�o Marcos"
  },
  {
    "codigoTse": "88846",
    "ibgeCodigo": 4305439,
    "uf": "RS",
    "nome": "Chu�"
  },
  {
    "codigoTse": "88854",
    "ibgeCodigo": 4319109,
    "uf": "RS",
    "nome": "S�o Martinho"
  },
  {
    "codigoTse": "88862",
    "ibgeCodigo": 4300877,
    "uf": "RS",
    "nome": "Araric�"
  },
  {
    "codigoTse": "88870",
    "ibgeCodigo": 4319208,
    "uf": "RS",
    "nome": "S�o Nicolau"
  },
  {
    "codigoTse": "88889",
    "ibgeCodigo": 4314068,
    "uf": "RS",
    "nome": "Passa Sete"
  },
  {
    "codigoTse": "88897",
    "ibgeCodigo": 4319307,
    "uf": "RS",
    "nome": "S�o Paulo Das Miss�es"
  },
  {
    "codigoTse": "88900",
    "ibgeCodigo": 4321493,
    "uf": "RS",
    "nome": "Toropi"
  },
  {
    "codigoTse": "88919",
    "ibgeCodigo": 4319406,
    "uf": "RS",
    "nome": "S�o Pedro Do Sul"
  },
  {
    "codigoTse": "88927",
    "ibgeCodigo": 4301636,
    "uf": "RS",
    "nome": "Balne�rio Pinhal"
  },
  {
    "codigoTse": "88935",
    "ibgeCodigo": 4319505,
    "uf": "RS",
    "nome": "S�o Sebasti�o Do Ca�"
  },
  {
    "codigoTse": "88943",
    "ibgeCodigo": 4311734,
    "uf": "RS",
    "nome": "Mampituba"
  },
  {
    "codigoTse": "88951",
    "ibgeCodigo": 4319604,
    "uf": "RS",
    "nome": "S�o Sep�"
  },
  {
    "codigoTse": "88978",
    "ibgeCodigo": 4319703,
    "uf": "RS",
    "nome": "S�o Valentim"
  },
  {
    "codigoTse": "88986",
    "ibgeCodigo": 4300034,
    "uf": "RS",
    "nome": "Acegu�"
  },
  {
    "codigoTse": "88994",
    "ibgeCodigo": 4319901,
    "uf": "RS",
    "nome": "Sapiranga"
  },
  {
    "codigoTse": "89001",
    "ibgeCodigo": 4300471,
    "uf": "RS",
    "nome": "Almirante Tamandar� Do Sul"
  },
  {
    "codigoTse": "89010",
    "ibgeCodigo": 4320008,
    "uf": "RS",
    "nome": "Sapucaia Do Sul"
  },
  {
    "codigoTse": "89028",
    "ibgeCodigo": 4301073,
    "uf": "RS",
    "nome": "Arroio Do Padre"
  },
  {
    "codigoTse": "89036",
    "ibgeCodigo": 4320107,
    "uf": "RS",
    "nome": "Sarandi"
  },
  {
    "codigoTse": "89044",
    "ibgeCodigo": 4302220,
    "uf": "RS",
    "nome": "Boa Vista Do Cadeado"
  },
  {
    "codigoTse": "89052",
    "ibgeCodigo": 4320206,
    "uf": "RS",
    "nome": "Seberi"
  },
  {
    "codigoTse": "89060",
    "ibgeCodigo": 4302238,
    "uf": "RS",
    "nome": "Boa Vista Do Incra"
  },
  {
    "codigoTse": "89079",
    "ibgeCodigo": 4320305,
    "uf": "RS",
    "nome": "Selbach"
  },
  {
    "codigoTse": "89087",
    "ibgeCodigo": 4302584,
    "uf": "RS",
    "nome": "Bozano"
  },
  {
    "codigoTse": "89095",
    "ibgeCodigo": 4320404,
    "uf": "RS",
    "nome": "Serafina Corr�a"
  },
  {
    "codigoTse": "89109",
    "ibgeCodigo": 4304614,
    "uf": "RS",
    "nome": "Canudos Do Vale"
  },
  {
    "codigoTse": "89117",
    "ibgeCodigo": 4320503,
    "uf": "RS",
    "nome": "Sert�o"
  },
  {
    "codigoTse": "89125",
    "ibgeCodigo": 4304622,
    "uf": "RS",
    "nome": "Cap�o Bonito Do Sul"
  },
  {
    "codigoTse": "89133",
    "ibgeCodigo": 4320602,
    "uf": "RS",
    "nome": "Severiano De Almeida"
  },
  {
    "codigoTse": "89141",
    "ibgeCodigo": 4304655,
    "uf": "RS",
    "nome": "Cap�o Do Cip�"
  },
  {
    "codigoTse": "89150",
    "ibgeCodigo": 4304630,
    "uf": "RS",
    "nome": "Cap�o Da Canoa"
  },
  {
    "codigoTse": "89168",
    "ibgeCodigo": 4305835,
    "uf": "RS",
    "nome": "Coqueiro Baixo"
  },
  {
    "codigoTse": "89176",
    "ibgeCodigo": 4320701,
    "uf": "RS",
    "nome": "Sobradinho"
  },
  {
    "codigoTse": "89184",
    "ibgeCodigo": 4305934,
    "uf": "RS",
    "nome": "Coronel Pilar"
  },
  {
    "codigoTse": "89192",
    "ibgeCodigo": 4320800,
    "uf": "RS",
    "nome": "Soledade"
  },
  {
    "codigoTse": "89206",
    "ibgeCodigo": 4306130,
    "uf": "RS",
    "nome": "Cruzaltense"
  },
  {
    "codigoTse": "89214",
    "ibgeCodigo": 4320909,
    "uf": "RS",
    "nome": "Tapejara"
  },
  {
    "codigoTse": "89222",
    "ibgeCodigo": 4308433,
    "uf": "RS",
    "nome": "Forquetinha"
  },
  {
    "codigoTse": "89230",
    "ibgeCodigo": 4321006,
    "uf": "RS",
    "nome": "Tapera"
  },
  {
    "codigoTse": "89247",
    "ibgeCodigo": 4316733,
    "uf": "RS",
    "nome": "Santa Cec�lia Do Sul"
  },
  {
    "codigoTse": "89249",
    "ibgeCodigo": 4310652,
    "uf": "RS",
    "nome": "Itati"
  },
  {
    "codigoTse": "89257",
    "ibgeCodigo": 4321105,
    "uf": "RS",
    "nome": "Tapes"
  },
  {
    "codigoTse": "89265",
    "ibgeCodigo": 4310876,
    "uf": "RS",
    "nome": "Jacuizinho"
  },
  {
    "codigoTse": "89273",
    "ibgeCodigo": 4321204,
    "uf": "RS",
    "nome": "Taquara"
  },
  {
    "codigoTse": "89281",
    "ibgeCodigo": 4311239,
    "uf": "RS",
    "nome": "Lagoa Bonita Do Sul"
  },
  {
    "codigoTse": "89290",
    "ibgeCodigo": 4321303,
    "uf": "RS",
    "nome": "Taquari"
  },
  {
    "codigoTse": "89303",
    "ibgeCodigo": 4312179,
    "uf": "RS",
    "nome": "Mato Queimado"
  },
  {
    "codigoTse": "89311",
    "ibgeCodigo": 4321402,
    "uf": "RS",
    "nome": "Tenente Portela"
  },
  {
    "codigoTse": "89320",
    "ibgeCodigo": 4313466,
    "uf": "RS",
    "nome": "Novo Xingu"
  },
  {
    "codigoTse": "89338",
    "ibgeCodigo": 4321501,
    "uf": "RS",
    "nome": "Torres"
  },
  {
    "codigoTse": "89346",
    "ibgeCodigo": 4314134,
    "uf": "RS",
    "nome": "Paulo Bento"
  },
  {
    "codigoTse": "89354",
    "ibgeCodigo": 4321600,
    "uf": "RS",
    "nome": "Tramanda�"
  },
  {
    "codigoTse": "89362",
    "ibgeCodigo": 4314464,
    "uf": "RS",
    "nome": "Pinhal Da Serra"
  },
  {
    "codigoTse": "89370",
    "ibgeCodigo": 4321709,
    "uf": "RS",
    "nome": "Tr�s Coroas"
  },
  {
    "codigoTse": "89389",
    "ibgeCodigo": 4315313,
    "uf": "RS",
    "nome": "Quatro Irm�os"
  },
  {
    "codigoTse": "89397",
    "ibgeCodigo": 4321808,
    "uf": "RS",
    "nome": "Tr�s De Maio"
  },
  {
    "codigoTse": "89400",
    "ibgeCodigo": 4315958,
    "uf": "RS",
    "nome": "Rolador"
  },
  {
    "codigoTse": "89419",
    "ibgeCodigo": 4321907,
    "uf": "RS",
    "nome": "Tr�s Passos"
  },
  {
    "codigoTse": "89435",
    "ibgeCodigo": 4322004,
    "uf": "RS",
    "nome": "Triunfo"
  },
  {
    "codigoTse": "89443",
    "ibgeCodigo": 4316972,
    "uf": "RS",
    "nome": "Santa Margarida Do Sul"
  },
  {
    "codigoTse": "89451",
    "ibgeCodigo": 4322103,
    "uf": "RS",
    "nome": "Tucunduva"
  },
  {
    "codigoTse": "89460",
    "ibgeCodigo": 4318614,
    "uf": "RS",
    "nome": "S�o Jos� Do Sul"
  },
  {
    "codigoTse": "89478",
    "ibgeCodigo": 4322202,
    "uf": "RS",
    "nome": "Tupanciret�"
  },
  {
    "codigoTse": "89486",
    "ibgeCodigo": 4319364,
    "uf": "RS",
    "nome": "S�o Pedro Das Miss�es"
  },
  {
    "codigoTse": "89494",
    "ibgeCodigo": 4322301,
    "uf": "RS",
    "nome": "Tuparendi"
  },
  {
    "codigoTse": "89508",
    "ibgeCodigo": 4321469,
    "uf": "RS",
    "nome": "Tio Hugo"
  },
  {
    "codigoTse": "89516",
    "ibgeCodigo": 4322400,
    "uf": "RS",
    "nome": "Uruguaiana"
  },
  {
    "codigoTse": "89524",
    "ibgeCodigo": 4323770,
    "uf": "RS",
    "nome": "Westfalia"
  },
  {
    "codigoTse": "89532",
    "ibgeCodigo": 4322509,
    "uf": "RS",
    "nome": "Vacaria"
  },
  {
    "codigoTse": "89540",
    "ibgeCodigo": 4314548,
    "uf": "RS",
    "nome": "Pinto Bandeira"
  },
  {
    "codigoTse": "89559",
    "ibgeCodigo": 4322608,
    "uf": "RS",
    "nome": "Ven�ncio Aires"
  },
  {
    "codigoTse": "89567",
    "ibgeCodigo": 4314175,
    "uf": "RS",
    "nome": "Pedras Altas"
  },
  {
    "codigoTse": "89575",
    "ibgeCodigo": 4322707,
    "uf": "RS",
    "nome": "Vera Cruz"
  },
  {
    "codigoTse": "89591",
    "ibgeCodigo": 4322806,
    "uf": "RS",
    "nome": "Veran�polis"
  },
  {
    "codigoTse": "89613",
    "ibgeCodigo": 4322905,
    "uf": "RS",
    "nome": "Viadutos"
  },
  {
    "codigoTse": "89630",
    "ibgeCodigo": 4323002,
    "uf": "RS",
    "nome": "Viam�o"
  },
  {
    "codigoTse": "89656",
    "ibgeCodigo": 4323101,
    "uf": "RS",
    "nome": "Vicente Dutra"
  },
  {
    "codigoTse": "89672",
    "ibgeCodigo": 4313656,
    "uf": "RS",
    "nome": "Palmares Do Sul"
  },
  {
    "codigoTse": "89699",
    "ibgeCodigo": 4323200,
    "uf": "RS",
    "nome": "Victor Graeff"
  },
  {
    "codigoTse": "89710",
    "ibgeCodigo": 4321352,
    "uf": "RS",
    "nome": "Tavares"
  },
  {
    "codigoTse": "89737",
    "ibgeCodigo": 4304663,
    "uf": "RS",
    "nome": "Cap�o Do Le�o"
  },
  {
    "codigoTse": "89753",
    "ibgeCodigo": 4316451,
    "uf": "RS",
    "nome": "Salto Do Jacu�"
  },
  {
    "codigoTse": "89770",
    "ibgeCodigo": 4305959,
    "uf": "RS",
    "nome": "Cotipor�"
  },
  {
    "codigoTse": "89788",
    "ibgeCodigo": 5103254,
    "uf": "MT",
    "nome": "Colniza"
  },
  {
    "codigoTse": "89796",
    "ibgeCodigo": 5103205,
    "uf": "MT",
    "nome": "Col�der"
  },
  {
    "codigoTse": "89800",
    "ibgeCodigo": 5103437,
    "uf": "MT",
    "nome": "Curvel�ndia"
  },
  {
    "codigoTse": "89818",
    "ibgeCodigo": 5106208,
    "uf": "MT",
    "nome": "Nova Brasil�ndia"
  },
  {
    "codigoTse": "89826",
    "ibgeCodigo": 5106190,
    "uf": "MT",
    "nome": "Nova Santa Helena"
  },
  {
    "codigoTse": "89834",
    "ibgeCodigo": 5106307,
    "uf": "MT",
    "nome": "Paranatinga"
  },
  {
    "codigoTse": "89843",
    "ibgeCodigo": 5107792,
    "uf": "MT",
    "nome": "Santo Ant�nio Do Leste"
  },
  {
    "codigoTse": "89850",
    "ibgeCodigo": 5107909,
    "uf": "MT",
    "nome": "Sinop"
  },
  {
    "codigoTse": "89877",
    "ibgeCodigo": 5100250,
    "uf": "MT",
    "nome": "Alta Floresta"
  },
  {
    "codigoTse": "89893",
    "ibgeCodigo": 5101258,
    "uf": "MT",
    "nome": "Araputanga"
  },
  {
    "codigoTse": "89915",
    "ibgeCodigo": 5105002,
    "uf": "MT",
    "nome": "Jauru"
  },
  {
    "codigoTse": "89931",
    "ibgeCodigo": 5107107,
    "uf": "MT",
    "nome": "S�o Jos� Dos Quatro Marcos"
  },
  {
    "codigoTse": "89958",
    "ibgeCodigo": 5107206,
    "uf": "MT",
    "nome": "Rio Branco"
  },
  {
    "codigoTse": "89960",
    "ibgeCodigo": 5107578,
    "uf": "MT",
    "nome": "Rondol�ndia"
  },
  {
    "codigoTse": "89974",
    "ibgeCodigo": 5107750,
    "uf": "MT",
    "nome": "Salto Do C�u"
  },
  {
    "codigoTse": "89990",
    "ibgeCodigo": 5106752,
    "uf": "MT",
    "nome": "Pontes E Lacerda"
  },
  {
    "codigoTse": "90018",
    "ibgeCodigo": 5100102,
    "uf": "MT",
    "nome": "Acorizal"
  },
  {
    "codigoTse": "90026",
    "ibgeCodigo": 5107297,
    "uf": "MT",
    "nome": "S�o Jos� Do Povo"
  },
  {
    "codigoTse": "90034",
    "ibgeCodigo": 5000203,
    "uf": "MS",
    "nome": "�gua Clara"
  },
  {
    "codigoTse": "90042",
    "ibgeCodigo": 5100359,
    "uf": "MT",
    "nome": "Alto Boa Vista"
  },
  {
    "codigoTse": "90050",
    "ibgeCodigo": 5100300,
    "uf": "MT",
    "nome": "Alto Araguaia"
  },
  {
    "codigoTse": "90069",
    "ibgeCodigo": 5107065,
    "uf": "MT",
    "nome": "Quer�ncia"
  },
  {
    "codigoTse": "90077",
    "ibgeCodigo": 5100409,
    "uf": "MT",
    "nome": "Alto Gar�as"
  },
  {
    "codigoTse": "90085",
    "ibgeCodigo": 5102694,
    "uf": "MT",
    "nome": "Canabrava Do Norte"
  },
  {
    "codigoTse": "90093",
    "ibgeCodigo": 5100508,
    "uf": "MT",
    "nome": "Alto Paraguai"
  },
  {
    "codigoTse": "90107",
    "ibgeCodigo": 5107248,
    "uf": "MT",
    "nome": "Santa Carmem"
  },
  {
    "codigoTse": "90115",
    "ibgeCodigo": 5000609,
    "uf": "MS",
    "nome": "Amambai"
  },
  {
    "codigoTse": "90123",
    "ibgeCodigo": 5108907,
    "uf": "MT",
    "nome": "Nova Maring�"
  },
  {
    "codigoTse": "90131",
    "ibgeCodigo": 5000708,
    "uf": "MS",
    "nome": "Anast�cio"
  },
  {
    "codigoTse": "90140",
    "ibgeCodigo": 5108808,
    "uf": "MT",
    "nome": "Nova Guarita"
  },
  {
    "codigoTse": "90158",
    "ibgeCodigo": 5000807,
    "uf": "MS",
    "nome": "Anauril�ndia"
  },
  {
    "codigoTse": "90166",
    "ibgeCodigo": 5108857,
    "uf": "MT",
    "nome": "Nova Maril�ndia"
  },
  {
    "codigoTse": "90174",
    "ibgeCodigo": 5000906,
    "uf": "MS",
    "nome": "Ant�nio Jo�o"
  },
  {
    "codigoTse": "90182",
    "ibgeCodigo": 5106851,
    "uf": "MT",
    "nome": "Porto Estrela"
  },
  {
    "codigoTse": "90190",
    "ibgeCodigo": 5001003,
    "uf": "MS",
    "nome": "Aparecida Do Taboado"
  },
  {
    "codigoTse": "90204",
    "ibgeCodigo": 5103957,
    "uf": "MT",
    "nome": "Gl�ria D'Oeste"
  },
  {
    "codigoTse": "90212",
    "ibgeCodigo": 5001102,
    "uf": "MS",
    "nome": "Aquidauana"
  },
  {
    "codigoTse": "90220",
    "ibgeCodigo": 5107941,
    "uf": "MT",
    "nome": "Tabapor�"
  },
  {
    "codigoTse": "90239",
    "ibgeCodigo": 5101209,
    "uf": "MT",
    "nome": "Araguainha"
  },
  {
    "codigoTse": "90247",
    "ibgeCodigo": 5107354,
    "uf": "MT",
    "nome": "S�o Jos� Do Xingu"
  },
  {
    "codigoTse": "90255",
    "ibgeCodigo": 5101308,
    "uf": "MT",
    "nome": "Aren�polis"
  },
  {
    "codigoTse": "90263",
    "ibgeCodigo": 5100805,
    "uf": "MT",
    "nome": "Apiac�s"
  },
  {
    "codigoTse": "90271",
    "ibgeCodigo": 5101407,
    "uf": "MT",
    "nome": "Aripuan�"
  },
  {
    "codigoTse": "90280",
    "ibgeCodigo": 5103353,
    "uf": "MT",
    "nome": "Confresa"
  },
  {
    "codigoTse": "90298",
    "ibgeCodigo": 5001508,
    "uf": "MS",
    "nome": "Bandeirantes"
  },
  {
    "codigoTse": "90301",
    "ibgeCodigo": 5105234,
    "uf": "MT",
    "nome": "Lambari D'Oeste"
  },
  {
    "codigoTse": "90310",
    "ibgeCodigo": 5101605,
    "uf": "MT",
    "nome": "Bar�o De Melga�o"
  },
  {
    "codigoTse": "90328",
    "ibgeCodigo": 5107263,
    "uf": "MT",
    "nome": "Santo Afonso"
  },
  {
    "codigoTse": "90336",
    "ibgeCodigo": 5101704,
    "uf": "MT",
    "nome": "Barra Do Bugres"
  },
  {
    "codigoTse": "90344",
    "ibgeCodigo": 5106455,
    "uf": "MT",
    "nome": "Planalto Da Serra"
  },
  {
    "codigoTse": "90352",
    "ibgeCodigo": 5101803,
    "uf": "MT",
    "nome": "Barra Do Gar�as"
  },
  {
    "codigoTse": "90360",
    "ibgeCodigo": 5108956,
    "uf": "MT",
    "nome": "Nova Monte Verde"
  },
  {
    "codigoTse": "90379",
    "ibgeCodigo": 5001904,
    "uf": "MS",
    "nome": "Bataguassu"
  },
  {
    "codigoTse": "90387",
    "ibgeCodigo": 5106158,
    "uf": "MT",
    "nome": "Nova Bandeirantes"
  },
  {
    "codigoTse": "90395",
    "ibgeCodigo": 5002001,
    "uf": "MS",
    "nome": "Bataypor�"
  },
  {
    "codigoTse": "90409",
    "ibgeCodigo": 5107404,
    "uf": "MT",
    "nome": "S�o Pedro Da Cipa"
  },
  {
    "codigoTse": "90417",
    "ibgeCodigo": 5002100,
    "uf": "MS",
    "nome": "Bela Vista"
  },
  {
    "codigoTse": "90425",
    "ibgeCodigo": 5103379,
    "uf": "MT",
    "nome": "Cotrigua�u"
  },
  {
    "codigoTse": "90433",
    "ibgeCodigo": 5002209,
    "uf": "MS",
    "nome": "Bonito"
  },
  {
    "codigoTse": "90441",
    "ibgeCodigo": 5107198,
    "uf": "MT",
    "nome": "Ribeir�ozinho"
  },
  {
    "codigoTse": "90450",
    "ibgeCodigo": 5002308,
    "uf": "MS",
    "nome": "Brasil�ndia"
  },
  {
    "codigoTse": "90468",
    "ibgeCodigo": 5101902,
    "uf": "MT",
    "nome": "Brasnorte"
  },
  {
    "codigoTse": "90476",
    "ibgeCodigo": 5102504,
    "uf": "MT",
    "nome": "C�ceres"
  },
  {
    "codigoTse": "90484",
    "ibgeCodigo": 5102637,
    "uf": "MT",
    "nome": "Campo Novo Do Parecis"
  },
  {
    "codigoTse": "90492",
    "ibgeCodigo": 5002605,
    "uf": "MS",
    "nome": "Camapu�"
  },
  {
    "codigoTse": "90506",
    "ibgeCodigo": 5102678,
    "uf": "MT",
    "nome": "Campo Verde"
  },
  {
    "codigoTse": "90514",
    "ibgeCodigo": 5002704,
    "uf": "MS",
    "nome": "Campo Grande"
  },
  {
    "codigoTse": "90522",
    "ibgeCodigo": 5103056,
    "uf": "MT",
    "nome": "Cl�udia"
  },
  {
    "codigoTse": "90530",
    "ibgeCodigo": 5002803,
    "uf": "MS",
    "nome": "Caracol"
  },
  {
    "codigoTse": "90549",
    "ibgeCodigo": 5102850,
    "uf": "MT",
    "nome": "Castanheira"
  },
  {
    "codigoTse": "90557",
    "ibgeCodigo": 5002407,
    "uf": "MS",
    "nome": "Caarap�"
  },
  {
    "codigoTse": "90565",
    "ibgeCodigo": 5104906,
    "uf": "MT",
    "nome": "Jangada"
  },
  {
    "codigoTse": "90573",
    "ibgeCodigo": 5002902,
    "uf": "MS",
    "nome": "Cassil�ndia"
  },
  {
    "codigoTse": "90581",
    "ibgeCodigo": 5105176,
    "uf": "MT",
    "nome": "Juruena"
  },
  {
    "codigoTse": "90590",
    "ibgeCodigo": 5103007,
    "uf": "MT",
    "nome": "Chapada Dos Guimar�es"
  },
  {
    "codigoTse": "90603",
    "ibgeCodigo": 5105259,
    "uf": "MT",
    "nome": "Lucas Do Rio Verde"
  },
  {
    "codigoTse": "90611",
    "ibgeCodigo": 5003108,
    "uf": "MS",
    "nome": "Corguinho"
  },
  {
    "codigoTse": "90620",
    "ibgeCodigo": 5105606,
    "uf": "MT",
    "nome": "Matup�"
  },
  {
    "codigoTse": "90638",
    "ibgeCodigo": 5003207,
    "uf": "MS",
    "nome": "Corumb�"
  },
  {
    "codigoTse": "90646",
    "ibgeCodigo": 5106224,
    "uf": "MT",
    "nome": "Nova Mutum"
  },
  {
    "codigoTse": "90654",
    "ibgeCodigo": 5003306,
    "uf": "MS",
    "nome": "Coxim"
  },
  {
    "codigoTse": "90662",
    "ibgeCodigo": 5107180,
    "uf": "MT",
    "nome": "Ribeir�o Cascalheira"
  },
  {
    "codigoTse": "90670",
    "ibgeCodigo": 5103403,
    "uf": "MT",
    "nome": "Cuiab�"
  },
  {
    "codigoTse": "90689",
    "ibgeCodigo": 5108006,
    "uf": "MT",
    "nome": "Tapurah"
  },
  {
    "codigoTse": "90697",
    "ibgeCodigo": 5103502,
    "uf": "MT",
    "nome": "Diamantino"
  },
  {
    "codigoTse": "90700",
    "ibgeCodigo": 5106653,
    "uf": "MT",
    "nome": "Pontal Do Araguaia"
  },
  {
    "codigoTse": "90719",
    "ibgeCodigo": 5103601,
    "uf": "MT",
    "nome": "Dom Aquino"
  },
  {
    "codigoTse": "90727",
    "ibgeCodigo": 5107875,
    "uf": "MT",
    "nome": "Sapezal"
  },
  {
    "codigoTse": "90735",
    "ibgeCodigo": 5003702,
    "uf": "MS",
    "nome": "Dourados"
  },
  {
    "codigoTse": "90743",
    "ibgeCodigo": 5102686,
    "uf": "MT",
    "nome": "Campos De J�lio"
  },
  {
    "codigoTse": "90751",
    "ibgeCodigo": 5003801,
    "uf": "MS",
    "nome": "F�tima Do Sul"
  },
  {
    "codigoTse": "90760",
    "ibgeCodigo": 5102793,
    "uf": "MT",
    "nome": "Carlinda"
  },
  {
    "codigoTse": "90778",
    "ibgeCodigo": 5103908,
    "uf": "MT",
    "nome": "General Carneiro"
  },
  {
    "codigoTse": "90786",
    "ibgeCodigo": 5103700,
    "uf": "MT",
    "nome": "Feliz Natal"
  },
  {
    "codigoTse": "90794",
    "ibgeCodigo": 5004007,
    "uf": "MS",
    "nome": "Gl�ria De Dourados"
  },
  {
    "codigoTse": "90808",
    "ibgeCodigo": 5106265,
    "uf": "MT",
    "nome": "Novo Mundo"
  },
  {
    "codigoTse": "90816",
    "ibgeCodigo": 5004106,
    "uf": "MS",
    "nome": "Guia Lopes Da Laguna"
  },
  {
    "codigoTse": "90824",
    "ibgeCodigo": 5103858,
    "uf": "MT",
    "nome": "Ga�cha Do Norte"
  },
  {
    "codigoTse": "90832",
    "ibgeCodigo": 5104203,
    "uf": "MT",
    "nome": "Guiratinga"
  },
  {
    "codigoTse": "90840",
    "ibgeCodigo": 5108303,
    "uf": "MT",
    "nome": "Uni�o Do Sul"
  },
  {
    "codigoTse": "90859",
    "ibgeCodigo": 5004304,
    "uf": "MS",
    "nome": "Iguatemi"
  },
  {
    "codigoTse": "90867",
    "ibgeCodigo": 5106182,
    "uf": "MT",
    "nome": "Nova Lacerda"
  },
  {
    "codigoTse": "90875",
    "ibgeCodigo": 5004403,
    "uf": "MS",
    "nome": "Inoc�ncia"
  },
  {
    "codigoTse": "90883",
    "ibgeCodigo": 5106240,
    "uf": "MT",
    "nome": "Nova Ubirat�"
  },
  {
    "codigoTse": "90891",
    "ibgeCodigo": 5004502,
    "uf": "MS",
    "nome": "Itapor�"
  },
  {
    "codigoTse": "90905",
    "ibgeCodigo": 5101852,
    "uf": "MT",
    "nome": "Bom Jesus Do Araguaia"
  },
  {
    "codigoTse": "90913",
    "ibgeCodigo": 5104609,
    "uf": "MT",
    "nome": "Itiquira"
  },
  {
    "codigoTse": "90921",
    "ibgeCodigo": 5107883,
    "uf": "MT",
    "nome": "Serra Nova Dourada"
  },
  {
    "codigoTse": "90930",
    "ibgeCodigo": 5004700,
    "uf": "MS",
    "nome": "Ivinhema"
  },
  {
    "codigoTse": "90948",
    "ibgeCodigo": 5106315,
    "uf": "MT",
    "nome": "Novo Santo Ant�nio"
  },
  {
    "codigoTse": "90956",
    "ibgeCodigo": 5104807,
    "uf": "MT",
    "nome": "Jaciara"
  },
  {
    "codigoTse": "90964",
    "ibgeCodigo": 5106174,
    "uf": "MT",
    "nome": "Nova Nazar�"
  },
  {
    "codigoTse": "90972",
    "ibgeCodigo": 5004908,
    "uf": "MS",
    "nome": "Jaraguari"
  },
  {
    "codigoTse": "90980",
    "ibgeCodigo": 5107743,
    "uf": "MT",
    "nome": "Santa Cruz Do Xingu"
  },
  {
    "codigoTse": "90999",
    "ibgeCodigo": 5005004,
    "uf": "MS",
    "nome": "Jardim"
  },
  {
    "codigoTse": "91006",
    "ibgeCodigo": 5103361,
    "uf": "MT",
    "nome": "Conquista D'Oeste"
  },
  {
    "codigoTse": "91014",
    "ibgeCodigo": 5005103,
    "uf": "MS",
    "nome": "Jate�"
  },
  {
    "codigoTse": "91022",
    "ibgeCodigo": 5108352,
    "uf": "MT",
    "nome": "Vale De S�o Domingos"
  },
  {
    "codigoTse": "91030",
    "ibgeCodigo": 5005202,
    "uf": "MS",
    "nome": "Lad�rio"
  },
  {
    "codigoTse": "91049",
    "ibgeCodigo": 5107768,
    "uf": "MT",
    "nome": "Santa Rita Do Trivelato"
  },
  {
    "codigoTse": "91057",
    "ibgeCodigo": 5105309,
    "uf": "MT",
    "nome": "Luciara"
  },
  {
    "codigoTse": "91073",
    "ibgeCodigo": 5005400,
    "uf": "MS",
    "nome": "Maracaju"
  },
  {
    "codigoTse": "91081",
    "ibgeCodigo": 5104526,
    "uf": "MT",
    "nome": "Ipiranga Do Norte"
  },
  {
    "codigoTse": "91090",
    "ibgeCodigo": 5105507,
    "uf": "MT",
    "nome": "Vila Bela Da Sant�ssima Trindade"
  },
  {
    "codigoTse": "91103",
    "ibgeCodigo": 5104542,
    "uf": "MT",
    "nome": "Itanhang�"
  },
  {
    "codigoTse": "91111",
    "ibgeCodigo": 5005608,
    "uf": "MS",
    "nome": "Miranda"
  },
  {
    "codigoTse": "91138",
    "ibgeCodigo": 5005707,
    "uf": "MS",
    "nome": "Navira�"
  },
  {
    "codigoTse": "91154",
    "ibgeCodigo": 5005806,
    "uf": "MS",
    "nome": "Nioaque"
  },
  {
    "codigoTse": "91170",
    "ibgeCodigo": 5105903,
    "uf": "MT",
    "nome": "Nobres"
  },
  {
    "codigoTse": "91197",
    "ibgeCodigo": 5106000,
    "uf": "MT",
    "nome": "Nortel�ndia"
  },
  {
    "codigoTse": "91219",
    "ibgeCodigo": 5106109,
    "uf": "MT",
    "nome": "Nossa Senhora Do Livramento"
  },
  {
    "codigoTse": "91235",
    "ibgeCodigo": 5006200,
    "uf": "MS",
    "nome": "Nova Andradina"
  },
  {
    "codigoTse": "91251",
    "ibgeCodigo": 5006309,
    "uf": "MS",
    "nome": "Parana�ba"
  },
  {
    "codigoTse": "91278",
    "ibgeCodigo": 5006408,
    "uf": "MS",
    "nome": "Pedro Gomes"
  },
  {
    "codigoTse": "91294",
    "ibgeCodigo": 5106505,
    "uf": "MT",
    "nome": "Pocon�"
  },
  {
    "codigoTse": "91316",
    "ibgeCodigo": 5006606,
    "uf": "MS",
    "nome": "Ponta Por�"
  },
  {
    "codigoTse": "91332",
    "ibgeCodigo": 5106703,
    "uf": "MT",
    "nome": "Ponte Branca"
  },
  {
    "codigoTse": "91359",
    "ibgeCodigo": 5106802,
    "uf": "MT",
    "nome": "Porto Dos Ga�chos"
  },
  {
    "codigoTse": "91375",
    "ibgeCodigo": 5006903,
    "uf": "MS",
    "nome": "Porto Murtinho"
  },
  {
    "codigoTse": "91391",
    "ibgeCodigo": 5107008,
    "uf": "MT",
    "nome": "Poxor�o"
  },
  {
    "codigoTse": "91413",
    "ibgeCodigo": 5007109,
    "uf": "MS",
    "nome": "Ribas Do Rio Pardo"
  },
  {
    "codigoTse": "91430",
    "ibgeCodigo": 5007208,
    "uf": "MS",
    "nome": "Rio Brilhante"
  },
  {
    "codigoTse": "91456",
    "ibgeCodigo": 5007307,
    "uf": "MS",
    "nome": "Rio Negro"
  },
  {
    "codigoTse": "91472",
    "ibgeCodigo": 5007406,
    "uf": "MS",
    "nome": "Rio Verde De Mato Grosso"
  },
  {
    "codigoTse": "91499",
    "ibgeCodigo": 5007505,
    "uf": "MS",
    "nome": "Rochedo"
  },
  {
    "codigoTse": "91510",
    "ibgeCodigo": 5107602,
    "uf": "MT",
    "nome": "Rondon�polis"
  },
  {
    "codigoTse": "91537",
    "ibgeCodigo": 5107701,
    "uf": "MT",
    "nome": "Ros�rio Oeste"
  },
  {
    "codigoTse": "91553",
    "ibgeCodigo": 5107800,
    "uf": "MT",
    "nome": "Santo Ant�nio Do Leverger"
  },
  {
    "codigoTse": "91570",
    "ibgeCodigo": 5007901,
    "uf": "MS",
    "nome": "Sidrol�ndia"
  },
  {
    "codigoTse": "91596",
    "ibgeCodigo": 5008008,
    "uf": "MS",
    "nome": "Terenos"
  },
  {
    "codigoTse": "91618",
    "ibgeCodigo": 5108105,
    "uf": "MT",
    "nome": "Tesouro"
  },
  {
    "codigoTse": "91634",
    "ibgeCodigo": 5108204,
    "uf": "MT",
    "nome": "Torixor�u"
  },
  {
    "codigoTse": "91650",
    "ibgeCodigo": 5008305,
    "uf": "MS",
    "nome": "Tr�s Lagoas"
  },
  {
    "codigoTse": "91677",
    "ibgeCodigo": 5108402,
    "uf": "MT",
    "nome": "V�rzea Grande"
  },
  {
    "codigoTse": "91693",
    "ibgeCodigo": 5000856,
    "uf": "MS",
    "nome": "Ang�lica"
  },
  {
    "codigoTse": "91715",
    "ibgeCodigo": 5001243,
    "uf": "MS",
    "nome": "Aral Moreira"
  },
  {
    "codigoTse": "91731",
    "ibgeCodigo": 5003751,
    "uf": "MS",
    "nome": "Eldorado"
  },
  {
    "codigoTse": "91758",
    "ibgeCodigo": 5003454,
    "uf": "MS",
    "nome": "Deod�polis"
  },
  {
    "codigoTse": "91774",
    "ibgeCodigo": 5105622,
    "uf": "MT",
    "nome": "Mirassol D'Oeste"
  },
  {
    "codigoTse": "91782",
    "ibgeCodigo": 5002951,
    "uf": "MS",
    "nome": "Chapad�o Do Sul"
  },
  {
    "codigoTse": "91790",
    "ibgeCodigo": 5005681,
    "uf": "MS",
    "nome": "Mundo Novo"
  },
  {
    "codigoTse": "91804",
    "ibgeCodigo": 5003488,
    "uf": "MS",
    "nome": "Dois Irm�os Do Buriti"
  },
  {
    "codigoTse": "91812",
    "ibgeCodigo": 5106372,
    "uf": "MT",
    "nome": "Pedra Preta"
  },
  {
    "codigoTse": "91820",
    "ibgeCodigo": 5005152,
    "uf": "MS",
    "nome": "Juti"
  },
  {
    "codigoTse": "91839",
    "ibgeCodigo": 5107859,
    "uf": "MT",
    "nome": "S�o F�lix Do Araguaia"
  },
  {
    "codigoTse": "91847",
    "ibgeCodigo": 5006358,
    "uf": "MS",
    "nome": "Paranhos"
  },
  {
    "codigoTse": "91855",
    "ibgeCodigo": 5107958,
    "uf": "MT",
    "nome": "Tangar� Da Serra"
  },
  {
    "codigoTse": "91863",
    "ibgeCodigo": 5007554,
    "uf": "MS",
    "nome": "Santa Rita Do Pardo"
  },
  {
    "codigoTse": "91880",
    "ibgeCodigo": 5007935,
    "uf": "MS",
    "nome": "Sonora"
  },
  {
    "codigoTse": "91898",
    "ibgeCodigo": 5105200,
    "uf": "MT",
    "nome": "Juscimeira"
  },
  {
    "codigoTse": "91901",
    "ibgeCodigo": 5008404,
    "uf": "MS",
    "nome": "Vicentina"
  },
  {
    "codigoTse": "91910",
    "ibgeCodigo": 5100201,
    "uf": "MT",
    "nome": "�gua Boa"
  },
  {
    "codigoTse": "91936",
    "ibgeCodigo": 5102702,
    "uf": "MT",
    "nome": "Canarana"
  },
  {
    "codigoTse": "91952",
    "ibgeCodigo": 5106257,
    "uf": "MT",
    "nome": "Nova Xavantina"
  },
  {
    "codigoTse": "91979",
    "ibgeCodigo": 5107776,
    "uf": "MT",
    "nome": "Santa Terezinha"
  },
  {
    "codigoTse": "91995",
    "ibgeCodigo": 5107305,
    "uf": "MT",
    "nome": "S�o Jos� Do Rio Claro"
  },
  {
    "codigoTse": "92002",
    "ibgeCodigo": 1703206,
    "uf": "TO",
    "nome": "Bernardo Say�o"
  },
  {
    "codigoTse": "92010",
    "ibgeCodigo": 5200100,
    "uf": "GO",
    "nome": "Abadi�nia"
  },
  {
    "codigoTse": "92029",
    "ibgeCodigo": 5203559,
    "uf": "GO",
    "nome": "Bonfin�polis"
  },
  {
    "codigoTse": "92037",
    "ibgeCodigo": 5200209,
    "uf": "GO",
    "nome": "�gua Limpa"
  },
  {
    "codigoTse": "92045",
    "ibgeCodigo": 1703800,
    "uf": "TO",
    "nome": "Buriti Do Tocantins"
  },
  {
    "codigoTse": "92053",
    "ibgeCodigo": 5200308,
    "uf": "GO",
    "nome": "Alex�nia"
  },
  {
    "codigoTse": "92061",
    "ibgeCodigo": 5204953,
    "uf": "GO",
    "nome": "Campos Verdes"
  },
  {
    "codigoTse": "92070",
    "ibgeCodigo": 1700400,
    "uf": "TO",
    "nome": "Almas"
  },
  {
    "codigoTse": "92088",
    "ibgeCodigo": 1703909,
    "uf": "TO",
    "nome": "Caseara"
  },
  {
    "codigoTse": "92096",
    "ibgeCodigo": 5200506,
    "uf": "GO",
    "nome": "Alo�ndia"
  },
  {
    "codigoTse": "92100",
    "ibgeCodigo": 5205455,
    "uf": "GO",
    "nome": "Cezarina"
  },
  {
    "codigoTse": "92118",
    "ibgeCodigo": 5200605,
    "uf": "GO",
    "nome": "Alto Para�so De Goi�s"
  },
  {
    "codigoTse": "92126",
    "ibgeCodigo": 5205521,
    "uf": "GO",
    "nome": "Colinas Do Sul"
  },
  {
    "codigoTse": "92134",
    "ibgeCodigo": 1700707,
    "uf": "TO",
    "nome": "Alvorada"
  },
  {
    "codigoTse": "92142",
    "ibgeCodigo": 1705557,
    "uf": "TO",
    "nome": "Combinado"
  },
  {
    "codigoTse": "92150",
    "ibgeCodigo": 5200803,
    "uf": "GO",
    "nome": "Alvorada Do Norte"
  },
  {
    "codigoTse": "92169",
    "ibgeCodigo": 5213855,
    "uf": "GO",
    "nome": "Morro Agudo De Goi�s"
  },
  {
    "codigoTse": "92177",
    "ibgeCodigo": 5200902,
    "uf": "GO",
    "nome": "Amorin�polis"
  },
  {
    "codigoTse": "92185",
    "ibgeCodigo": 1707108,
    "uf": "TO",
    "nome": "Divin�polis Do Tocantins"
  },
  {
    "codigoTse": "92193",
    "ibgeCodigo": 1701002,
    "uf": "TO",
    "nome": "Anan�s"
  },
  {
    "codigoTse": "92207",
    "ibgeCodigo": 5207352,
    "uf": "GO",
    "nome": "Edealina"
  },
  {
    "codigoTse": "92215",
    "ibgeCodigo": 5201108,
    "uf": "GO",
    "nome": "An�polis"
  },
  {
    "codigoTse": "92223",
    "ibgeCodigo": 5207535,
    "uf": "GO",
    "nome": "Faina"
  },
  {
    "codigoTse": "92231",
    "ibgeCodigo": 5201207,
    "uf": "GO",
    "nome": "Anhanguera"
  },
  {
    "codigoTse": "92240",
    "ibgeCodigo": 1708304,
    "uf": "TO",
    "nome": "Goianorte"
  },
  {
    "codigoTse": "92258",
    "ibgeCodigo": 5201306,
    "uf": "GO",
    "nome": "Anicuns"
  },
  {
    "codigoTse": "92266",
    "ibgeCodigo": 5209150,
    "uf": "GO",
    "nome": "Gouvel�ndia"
  },
  {
    "codigoTse": "92274",
    "ibgeCodigo": 5201405,
    "uf": "GO",
    "nome": "Aparecida De Goi�nia"
  },
  {
    "codigoTse": "92282",
    "ibgeCodigo": 5210562,
    "uf": "GO",
    "nome": "Itaguari"
  },
  {
    "codigoTse": "92290",
    "ibgeCodigo": 5201504,
    "uf": "GO",
    "nome": "Apor�"
  },
  {
    "codigoTse": "92304",
    "ibgeCodigo": 1712504,
    "uf": "TO",
    "nome": "Marian�polis Do Tocantins"
  },
  {
    "codigoTse": "92312",
    "ibgeCodigo": 5201603,
    "uf": "GO",
    "nome": "Ara�u"
  },
  {
    "codigoTse": "92320",
    "ibgeCodigo": 5212956,
    "uf": "GO",
    "nome": "Matrinch�"
  },
  {
    "codigoTse": "92339",
    "ibgeCodigo": 5201702,
    "uf": "GO",
    "nome": "Aragar�as"
  },
  {
    "codigoTse": "92347",
    "ibgeCodigo": 5213053,
    "uf": "GO",
    "nome": "Mimoso De Goi�s"
  },
  {
    "codigoTse": "92355",
    "ibgeCodigo": 5201801,
    "uf": "GO",
    "nome": "Aragoi�nia"
  },
  {
    "codigoTse": "92363",
    "ibgeCodigo": 5213756,
    "uf": "GO",
    "nome": "Montividiu"
  },
  {
    "codigoTse": "92371",
    "ibgeCodigo": 1701903,
    "uf": "TO",
    "nome": "Araguacema"
  },
  {
    "codigoTse": "92398",
    "ibgeCodigo": 1702000,
    "uf": "TO",
    "nome": "Aragua�u"
  },
  {
    "codigoTse": "92401",
    "ibgeCodigo": 1715002,
    "uf": "TO",
    "nome": "Nova Rosal�ndia"
  },
  {
    "codigoTse": "92410",
    "ibgeCodigo": 1702109,
    "uf": "TO",
    "nome": "Aragua�na"
  },
  {
    "codigoTse": "92436",
    "ibgeCodigo": 1702208,
    "uf": "TO",
    "nome": "Araguatins"
  },
  {
    "codigoTse": "92444",
    "ibgeCodigo": 5215256,
    "uf": "GO",
    "nome": "Novo Planalto"
  },
  {
    "codigoTse": "92452",
    "ibgeCodigo": 1702307,
    "uf": "TO",
    "nome": "Arapoema"
  },
  {
    "codigoTse": "92460",
    "ibgeCodigo": 5215652,
    "uf": "GO",
    "nome": "Palestina De Goi�s"
  },
  {
    "codigoTse": "92479",
    "ibgeCodigo": 1702406,
    "uf": "TO",
    "nome": "Arraias"
  },
  {
    "codigoTse": "92487",
    "ibgeCodigo": 1716653,
    "uf": "TO",
    "nome": "Pequizeiro"
  },
  {
    "codigoTse": "92495",
    "ibgeCodigo": 5202502,
    "uf": "GO",
    "nome": "Aruan�"
  },
  {
    "codigoTse": "92509",
    "ibgeCodigo": 1718006,
    "uf": "TO",
    "nome": "Porto Alegre Do Tocantins"
  },
  {
    "codigoTse": "92517",
    "ibgeCodigo": 5202601,
    "uf": "GO",
    "nome": "Auril�ndia"
  },
  {
    "codigoTse": "92525",
    "ibgeCodigo": 1718303,
    "uf": "TO",
    "nome": "Praia Norte"
  },
  {
    "codigoTse": "92533",
    "ibgeCodigo": 1702703,
    "uf": "TO",
    "nome": "Aurora Do Tocantins"
  },
  {
    "codigoTse": "92541",
    "ibgeCodigo": 1718808,
    "uf": "TO",
    "nome": "Sampaio"
  },
  {
    "codigoTse": "92550",
    "ibgeCodigo": 5202809,
    "uf": "GO",
    "nome": "Avelin�polis"
  },
  {
    "codigoTse": "92568",
    "ibgeCodigo": 5219258,
    "uf": "GO",
    "nome": "Santa F� De Goi�s"
  },
  {
    "codigoTse": "92576",
    "ibgeCodigo": 1702901,
    "uf": "TO",
    "nome": "Axix� Do Tocantins"
  },
  {
    "codigoTse": "92584",
    "ibgeCodigo": 1718907,
    "uf": "TO",
    "nome": "Santa Rosa Do Tocantins"
  },
  {
    "codigoTse": "92592",
    "ibgeCodigo": 1703008,
    "uf": "TO",
    "nome": "Baba�ul�ndia"
  },
  {
    "codigoTse": "92606",
    "ibgeCodigo": 1719004,
    "uf": "TO",
    "nome": "Santa Tereza Do Tocantins"
  },
  {
    "codigoTse": "92614",
    "ibgeCodigo": 5203104,
    "uf": "GO",
    "nome": "Baliza"
  },
  {
    "codigoTse": "92622",
    "ibgeCodigo": 5220058,
    "uf": "GO",
    "nome": "S�o Jo�o Da Para�na"
  },
  {
    "codigoTse": "92630",
    "ibgeCodigo": 5203203,
    "uf": "GO",
    "nome": "Barro Alto"
  },
  {
    "codigoTse": "92649",
    "ibgeCodigo": 5220157,
    "uf": "GO",
    "nome": "S�o Lu�z Do Norte"
  },
  {
    "codigoTse": "92657",
    "ibgeCodigo": 5203302,
    "uf": "GO",
    "nome": "Bela Vista De Goi�s"
  },
  {
    "codigoTse": "92665",
    "ibgeCodigo": 5220264,
    "uf": "GO",
    "nome": "S�o Miguel Do Passa Quatro"
  },
  {
    "codigoTse": "92673",
    "ibgeCodigo": 5203401,
    "uf": "GO",
    "nome": "Bom Jardim De Goi�s"
  },
  {
    "codigoTse": "92681",
    "ibgeCodigo": 1720499,
    "uf": "TO",
    "nome": "S�o Val�rio"
  },
  {
    "codigoTse": "92690",
    "ibgeCodigo": 5203500,
    "uf": "GO",
    "nome": "Bom Jesus De Goi�s"
  },
  {
    "codigoTse": "92703",
    "ibgeCodigo": 5220454,
    "uf": "GO",
    "nome": "Senador Canedo"
  },
  {
    "codigoTse": "92711",
    "ibgeCodigo": 5203609,
    "uf": "GO",
    "nome": "Brazabrantes"
  },
  {
    "codigoTse": "92720",
    "ibgeCodigo": 5220686,
    "uf": "GO",
    "nome": "Simol�ndia"
  },
  {
    "codigoTse": "92738",
    "ibgeCodigo": 1703701,
    "uf": "TO",
    "nome": "Brejinho De Nazar�"
  },
  {
    "codigoTse": "92754",
    "ibgeCodigo": 5203807,
    "uf": "GO",
    "nome": "Brit�nia"
  },
  {
    "codigoTse": "92762",
    "ibgeCodigo": 5221080,
    "uf": "GO",
    "nome": "Teresina De Goi�s"
  },
  {
    "codigoTse": "92770",
    "ibgeCodigo": 5203906,
    "uf": "GO",
    "nome": "Buriti Alegre"
  },
  {
    "codigoTse": "92789",
    "ibgeCodigo": 5221452,
    "uf": "GO",
    "nome": "Trombas"
  },
  {
    "codigoTse": "92797",
    "ibgeCodigo": 5204003,
    "uf": "GO",
    "nome": "Cabeceiras"
  },
  {
    "codigoTse": "92800",
    "ibgeCodigo": 5221551,
    "uf": "GO",
    "nome": "Turvel�ndia"
  },
  {
    "codigoTse": "92819",
    "ibgeCodigo": 5204102,
    "uf": "GO",
    "nome": "Cachoeira Alta"
  },
  {
    "codigoTse": "92827",
    "ibgeCodigo": 5218789,
    "uf": "GO",
    "nome": "Rio Quente"
  },
  {
    "codigoTse": "92835",
    "ibgeCodigo": 5204201,
    "uf": "GO",
    "nome": "Cachoeira De Goi�s"
  },
  {
    "codigoTse": "92851",
    "ibgeCodigo": 5204300,
    "uf": "GO",
    "nome": "Ca�u"
  },
  {
    "codigoTse": "92860",
    "ibgeCodigo": 5209457,
    "uf": "GO",
    "nome": "Guarinos"
  },
  {
    "codigoTse": "92878",
    "ibgeCodigo": 5204409,
    "uf": "GO",
    "nome": "Caiap�nia"
  },
  {
    "codigoTse": "92886",
    "ibgeCodigo": 5205513,
    "uf": "GO",
    "nome": "Cocalzinho De Goi�s"
  },
  {
    "codigoTse": "92894",
    "ibgeCodigo": 5204508,
    "uf": "GO",
    "nome": "Caldas Novas"
  },
  {
    "codigoTse": "92908",
    "ibgeCodigo": 5219738,
    "uf": "GO",
    "nome": "Santo Ant�nio De Goi�s"
  },
  {
    "codigoTse": "92916",
    "ibgeCodigo": 5204607,
    "uf": "GO",
    "nome": "Campestre De Goi�s"
  },
  {
    "codigoTse": "92924",
    "ibgeCodigo": 5205471,
    "uf": "GO",
    "nome": "Chapad�o Do C�u"
  },
  {
    "codigoTse": "92932",
    "ibgeCodigo": 5204706,
    "uf": "GO",
    "nome": "Campinorte"
  },
  {
    "codigoTse": "92940",
    "ibgeCodigo": 5200555,
    "uf": "GO",
    "nome": "Alto Horizonte"
  },
  {
    "codigoTse": "92959",
    "ibgeCodigo": 5204805,
    "uf": "GO",
    "nome": "Campo Alegre De Goi�s"
  },
  {
    "codigoTse": "92967",
    "ibgeCodigo": 5205059,
    "uf": "GO",
    "nome": "Castel�ndia"
  },
  {
    "codigoTse": "92975",
    "ibgeCodigo": 5204904,
    "uf": "GO",
    "nome": "Campos Belos"
  },
  {
    "codigoTse": "92983",
    "ibgeCodigo": 5212055,
    "uf": "GO",
    "nome": "Jes�polis"
  },
  {
    "codigoTse": "92991",
    "ibgeCodigo": 5205000,
    "uf": "GO",
    "nome": "Carmo Do Rio Verde"
  },
  {
    "codigoTse": "93009",
    "ibgeCodigo": 5201454,
    "uf": "GO",
    "nome": "Aparecida Do Rio Doce"
  },
  {
    "codigoTse": "93017",
    "ibgeCodigo": 5205109,
    "uf": "GO",
    "nome": "Catal�o"
  },
  {
    "codigoTse": "93025",
    "ibgeCodigo": 5205497,
    "uf": "GO",
    "nome": "Cidade Ocidental"
  },
  {
    "codigoTse": "93033",
    "ibgeCodigo": 5205208,
    "uf": "GO",
    "nome": "Catura�"
  },
  {
    "codigoTse": "93041",
    "ibgeCodigo": 5218391,
    "uf": "GO",
    "nome": "Professor Jamil"
  },
  {
    "codigoTse": "93050",
    "ibgeCodigo": 5205307,
    "uf": "GO",
    "nome": "Cavalcante"
  },
  {
    "codigoTse": "93068",
    "ibgeCodigo": 5216452,
    "uf": "GO",
    "nome": "Perol�ndia"
  },
  {
    "codigoTse": "93076",
    "ibgeCodigo": 5205406,
    "uf": "GO",
    "nome": "Ceres"
  },
  {
    "codigoTse": "93084",
    "ibgeCodigo": 5214879,
    "uf": "GO",
    "nome": "Nova Igua�u De Goi�s"
  },
  {
    "codigoTse": "93092",
    "ibgeCodigo": 5208301,
    "uf": "GO",
    "nome": "Divin�polis De Goi�s"
  },
  {
    "codigoTse": "93106",
    "ibgeCodigo": 5203939,
    "uf": "GO",
    "nome": "Buriti De Goi�s"
  },
  {
    "codigoTse": "93114",
    "ibgeCodigo": 1705508,
    "uf": "TO",
    "nome": "Colinas Do Tocantins"
  },
  {
    "codigoTse": "93122",
    "ibgeCodigo": 5204557,
    "uf": "GO",
    "nome": "Caldazinha"
  },
  {
    "codigoTse": "93130",
    "ibgeCodigo": 1705607,
    "uf": "TO",
    "nome": "Concei��o Do Tocantins"
  },
  {
    "codigoTse": "93149",
    "ibgeCodigo": 5209291,
    "uf": "GO",
    "nome": "Guara�ta"
  },
  {
    "codigoTse": "93157",
    "ibgeCodigo": 5205703,
    "uf": "GO",
    "nome": "C�rrego Do Ouro"
  },
  {
    "codigoTse": "93165",
    "ibgeCodigo": 5209937,
    "uf": "GO",
    "nome": "Inaciol�ndia"
  },
  {
    "codigoTse": "93173",
    "ibgeCodigo": 5205802,
    "uf": "GO",
    "nome": "Corumb� De Goi�s"
  },
  {
    "codigoTse": "93181",
    "ibgeCodigo": 5213772,
    "uf": "GO",
    "nome": "Montividiu Do Norte"
  },
  {
    "codigoTse": "93190",
    "ibgeCodigo": 5205901,
    "uf": "GO",
    "nome": "Corumba�ba"
  },
  {
    "codigoTse": "93203",
    "ibgeCodigo": 5219712,
    "uf": "GO",
    "nome": "Santo Ant�nio Da Barra"
  },
  {
    "codigoTse": "93211",
    "ibgeCodigo": 1706001,
    "uf": "TO",
    "nome": "Couto Magalh�es"
  },
  {
    "codigoTse": "93220",
    "ibgeCodigo": 5221197,
    "uf": "GO",
    "nome": "Terez�polis De Goi�s"
  },
  {
    "codigoTse": "93238",
    "ibgeCodigo": 1706100,
    "uf": "TO",
    "nome": "Cristal�ndia"
  },
  {
    "codigoTse": "93246",
    "ibgeCodigo": 5221577,
    "uf": "GO",
    "nome": "Uirapuru"
  },
  {
    "codigoTse": "93254",
    "ibgeCodigo": 5206206,
    "uf": "GO",
    "nome": "Cristalina"
  },
  {
    "codigoTse": "93262",
    "ibgeCodigo": 5203962,
    "uf": "GO",
    "nome": "Buritin�polis"
  },
  {
    "codigoTse": "93270",
    "ibgeCodigo": 5206305,
    "uf": "GO",
    "nome": "Cristian�polis"
  },
  {
    "codigoTse": "93289",
    "ibgeCodigo": 5222203,
    "uf": "GO",
    "nome": "Vila Boa"
  },
  {
    "codigoTse": "93297",
    "ibgeCodigo": 5206404,
    "uf": "GO",
    "nome": "Crix�s"
  },
  {
    "codigoTse": "93300",
    "ibgeCodigo": 5221858,
    "uf": "GO",
    "nome": "Valpara�so De Goi�s"
  },
  {
    "codigoTse": "93319",
    "ibgeCodigo": 5206503,
    "uf": "GO",
    "nome": "Crom�nia"
  },
  {
    "codigoTse": "93327",
    "ibgeCodigo": 5215231,
    "uf": "GO",
    "nome": "Novo Gama"
  },
  {
    "codigoTse": "93335",
    "ibgeCodigo": 5206602,
    "uf": "GO",
    "nome": "Cumari"
  },
  {
    "codigoTse": "93343",
    "ibgeCodigo": 5200258,
    "uf": "GO",
    "nome": "�guas Lindas De Goi�s"
  },
  {
    "codigoTse": "93351",
    "ibgeCodigo": 5206701,
    "uf": "GO",
    "nome": "Damian�polis"
  },
  {
    "codigoTse": "93360",
    "ibgeCodigo": 5200050,
    "uf": "GO",
    "nome": "Abadia De Goi�s"
  },
  {
    "codigoTse": "93378",
    "ibgeCodigo": 5206800,
    "uf": "GO",
    "nome": "Damol�ndia"
  },
  {
    "codigoTse": "93386",
    "ibgeCodigo": 5200829,
    "uf": "GO",
    "nome": "Amaralina"
  },
  {
    "codigoTse": "93394",
    "ibgeCodigo": 5206909,
    "uf": "GO",
    "nome": "Davin�polis"
  },
  {
    "codigoTse": "93408",
    "ibgeCodigo": 5203575,
    "uf": "GO",
    "nome": "Bon�polis"
  },
  {
    "codigoTse": "93416",
    "ibgeCodigo": 1707009,
    "uf": "TO",
    "nome": "Dian�polis"
  },
  {
    "codigoTse": "93424",
    "ibgeCodigo": 5218052,
    "uf": "GO",
    "nome": "Porteir�o"
  },
  {
    "codigoTse": "93432",
    "ibgeCodigo": 5207105,
    "uf": "GO",
    "nome": "Diorama"
  },
  {
    "codigoTse": "93440",
    "ibgeCodigo": 5219456,
    "uf": "GO",
    "nome": "Santa Rita Do Novo Destino"
  },
  {
    "codigoTse": "93459",
    "ibgeCodigo": 1707207,
    "uf": "TO",
    "nome": "Dois Irm�os Do Tocantins"
  },
  {
    "codigoTse": "93475",
    "ibgeCodigo": 1707306,
    "uf": "TO",
    "nome": "Duer�"
  },
  {
    "codigoTse": "93483",
    "ibgeCodigo": 5220280,
    "uf": "GO",
    "nome": "S�o Patr�cio"
  },
  {
    "codigoTse": "93491",
    "ibgeCodigo": 5207402,
    "uf": "GO",
    "nome": "Ed�ia"
  },
  {
    "codigoTse": "93505",
    "ibgeCodigo": 5222302,
    "uf": "GO",
    "nome": "Vila Prop�cio"
  },
  {
    "codigoTse": "93513",
    "ibgeCodigo": 5207501,
    "uf": "GO",
    "nome": "Estrela Do Norte"
  },
  {
    "codigoTse": "93530",
    "ibgeCodigo": 5207600,
    "uf": "GO",
    "nome": "Fazenda Nova"
  },
  {
    "codigoTse": "93548",
    "ibgeCodigo": 5210158,
    "uf": "GO",
    "nome": "Ipiranga De Goi�s"
  },
  {
    "codigoTse": "93556",
    "ibgeCodigo": 1707702,
    "uf": "TO",
    "nome": "Filad�lfia"
  },
  {
    "codigoTse": "93564",
    "ibgeCodigo": 5208152,
    "uf": "GO",
    "nome": "Gameleira De Goi�s"
  },
  {
    "codigoTse": "93572",
    "ibgeCodigo": 5207808,
    "uf": "GO",
    "nome": "Firmin�polis"
  },
  {
    "codigoTse": "93580",
    "ibgeCodigo": 5204854,
    "uf": "GO",
    "nome": "Campo Limpo De Goi�s"
  },
  {
    "codigoTse": "93599",
    "ibgeCodigo": 5207907,
    "uf": "GO",
    "nome": "Flores De Goi�s"
  },
  {
    "codigoTse": "93602",
    "ibgeCodigo": 5212253,
    "uf": "GO",
    "nome": "Lagoa Santa"
  },
  {
    "codigoTse": "93610",
    "ibgeCodigo": 5208004,
    "uf": "GO",
    "nome": "Formosa"
  },
  {
    "codigoTse": "93637",
    "ibgeCodigo": 5208103,
    "uf": "GO",
    "nome": "Formoso"
  },
  {
    "codigoTse": "93653",
    "ibgeCodigo": 1708205,
    "uf": "TO",
    "nome": "Formoso Do Araguaia"
  },
  {
    "codigoTse": "93670",
    "ibgeCodigo": 5208400,
    "uf": "GO",
    "nome": "Goian�polis"
  },
  {
    "codigoTse": "93696",
    "ibgeCodigo": 5208509,
    "uf": "GO",
    "nome": "Goiandira"
  },
  {
    "codigoTse": "93718",
    "ibgeCodigo": 5208608,
    "uf": "GO",
    "nome": "Goian�sia"
  },
  {
    "codigoTse": "93734",
    "ibgeCodigo": 5208707,
    "uf": "GO",
    "nome": "Goi�nia"
  },
  {
    "codigoTse": "93750",
    "ibgeCodigo": 5208806,
    "uf": "GO",
    "nome": "Goianira"
  },
  {
    "codigoTse": "93777",
    "ibgeCodigo": 5208905,
    "uf": "GO",
    "nome": "Goi�s"
  },
  {
    "codigoTse": "93793",
    "ibgeCodigo": 5209101,
    "uf": "GO",
    "nome": "Goiatuba"
  },
  {
    "codigoTse": "93815",
    "ibgeCodigo": 5209200,
    "uf": "GO",
    "nome": "Guap�"
  },
  {
    "codigoTse": "93831",
    "ibgeCodigo": 5209408,
    "uf": "GO",
    "nome": "Guarani De Goi�s"
  },
  {
    "codigoTse": "93858",
    "ibgeCodigo": 1709500,
    "uf": "TO",
    "nome": "Gurupi"
  },
  {
    "codigoTse": "93874",
    "ibgeCodigo": 5209606,
    "uf": "GO",
    "nome": "Heitora�"
  },
  {
    "codigoTse": "93890",
    "ibgeCodigo": 5209705,
    "uf": "GO",
    "nome": "Hidrol�ndia"
  },
  {
    "codigoTse": "93912",
    "ibgeCodigo": 5209804,
    "uf": "GO",
    "nome": "Hidrolina"
  },
  {
    "codigoTse": "93939",
    "ibgeCodigo": 5209903,
    "uf": "GO",
    "nome": "Iaciara"
  },
  {
    "codigoTse": "93955",
    "ibgeCodigo": 5210000,
    "uf": "GO",
    "nome": "Inhumas"
  },
  {
    "codigoTse": "93971",
    "ibgeCodigo": 5210109,
    "uf": "GO",
    "nome": "Ipameri"
  },
  {
    "codigoTse": "93998",
    "ibgeCodigo": 5210208,
    "uf": "GO",
    "nome": "Ipor�"
  },
  {
    "codigoTse": "94013",
    "ibgeCodigo": 5210307,
    "uf": "GO",
    "nome": "Israel�ndia"
  },
  {
    "codigoTse": "94030",
    "ibgeCodigo": 5210406,
    "uf": "GO",
    "nome": "Itabera�"
  },
  {
    "codigoTse": "94056",
    "ibgeCodigo": 1710508,
    "uf": "TO",
    "nome": "Itacaj�"
  },
  {
    "codigoTse": "94072",
    "ibgeCodigo": 5210604,
    "uf": "GO",
    "nome": "Itaguaru"
  },
  {
    "codigoTse": "94099",
    "ibgeCodigo": 1710706,
    "uf": "TO",
    "nome": "Itaguatins"
  },
  {
    "codigoTse": "94110",
    "ibgeCodigo": 5210802,
    "uf": "GO",
    "nome": "Itaj�"
  },
  {
    "codigoTse": "94137",
    "ibgeCodigo": 5210901,
    "uf": "GO",
    "nome": "Itapaci"
  },
  {
    "codigoTse": "94153",
    "ibgeCodigo": 5211008,
    "uf": "GO",
    "nome": "Itapirapu�"
  },
  {
    "codigoTse": "94170",
    "ibgeCodigo": 1711100,
    "uf": "TO",
    "nome": "Itapor� Do Tocantins"
  },
  {
    "codigoTse": "94196",
    "ibgeCodigo": 5211206,
    "uf": "GO",
    "nome": "Itapuranga"
  },
  {
    "codigoTse": "94218",
    "ibgeCodigo": 5211305,
    "uf": "GO",
    "nome": "Itarum�"
  },
  {
    "codigoTse": "94234",
    "ibgeCodigo": 5211404,
    "uf": "GO",
    "nome": "Itau�u"
  },
  {
    "codigoTse": "94250",
    "ibgeCodigo": 5211503,
    "uf": "GO",
    "nome": "Itumbiara"
  },
  {
    "codigoTse": "94277",
    "ibgeCodigo": 5211602,
    "uf": "GO",
    "nome": "Ivol�ndia"
  },
  {
    "codigoTse": "94293",
    "ibgeCodigo": 5211701,
    "uf": "GO",
    "nome": "Jandaia"
  },
  {
    "codigoTse": "94315",
    "ibgeCodigo": 5211800,
    "uf": "GO",
    "nome": "Jaragu�"
  },
  {
    "codigoTse": "94331",
    "ibgeCodigo": 5211909,
    "uf": "GO",
    "nome": "Jata�"
  },
  {
    "codigoTse": "94358",
    "ibgeCodigo": 5212006,
    "uf": "GO",
    "nome": "Jaupaci"
  },
  {
    "codigoTse": "94374",
    "ibgeCodigo": 5212105,
    "uf": "GO",
    "nome": "Jovi�nia"
  },
  {
    "codigoTse": "94390",
    "ibgeCodigo": 5212204,
    "uf": "GO",
    "nome": "Jussara"
  },
  {
    "codigoTse": "94439",
    "ibgeCodigo": 5212303,
    "uf": "GO",
    "nome": "Leopoldo De Bulh�es"
  },
  {
    "codigoTse": "94455",
    "ibgeCodigo": 5212501,
    "uf": "GO",
    "nome": "Luzi�nia"
  },
  {
    "codigoTse": "94471",
    "ibgeCodigo": 5212600,
    "uf": "GO",
    "nome": "Mairipotaba"
  },
  {
    "codigoTse": "94498",
    "ibgeCodigo": 5212709,
    "uf": "GO",
    "nome": "Mamba�"
  },
  {
    "codigoTse": "94510",
    "ibgeCodigo": 5212808,
    "uf": "GO",
    "nome": "Mara Rosa"
  },
  {
    "codigoTse": "94536",
    "ibgeCodigo": 5212907,
    "uf": "GO",
    "nome": "Marzag�o"
  },
  {
    "codigoTse": "94552",
    "ibgeCodigo": 5216304,
    "uf": "GO",
    "nome": "Paranaiguara"
  },
  {
    "codigoTse": "94579",
    "ibgeCodigo": 5213004,
    "uf": "GO",
    "nome": "Mauril�ndia"
  },
  {
    "codigoTse": "94595",
    "ibgeCodigo": 5213103,
    "uf": "GO",
    "nome": "Mineiros"
  },
  {
    "codigoTse": "94617",
    "ibgeCodigo": 1713205,
    "uf": "TO",
    "nome": "Miracema Do Tocantins"
  },
  {
    "codigoTse": "94633",
    "ibgeCodigo": 1713304,
    "uf": "TO",
    "nome": "Miranorte"
  },
  {
    "codigoTse": "94650",
    "ibgeCodigo": 5213400,
    "uf": "GO",
    "nome": "Moipor�"
  },
  {
    "codigoTse": "94676",
    "ibgeCodigo": 5213509,
    "uf": "GO",
    "nome": "Monte Alegre De Goi�s"
  },
  {
    "codigoTse": "94692",
    "ibgeCodigo": 1713601,
    "uf": "TO",
    "nome": "Monte Do Carmo"
  },
  {
    "codigoTse": "94714",
    "ibgeCodigo": 5213707,
    "uf": "GO",
    "nome": "Montes Claros De Goi�s"
  },
  {
    "codigoTse": "94730",
    "ibgeCodigo": 5213806,
    "uf": "GO",
    "nome": "Morrinhos"
  },
  {
    "codigoTse": "94757",
    "ibgeCodigo": 5213905,
    "uf": "GO",
    "nome": "Moss�medes"
  },
  {
    "codigoTse": "94773",
    "ibgeCodigo": 5214002,
    "uf": "GO",
    "nome": "Mozarl�ndia"
  },
  {
    "codigoTse": "94790",
    "ibgeCodigo": 5214101,
    "uf": "GO",
    "nome": "Mutun�polis"
  },
  {
    "codigoTse": "94811",
    "ibgeCodigo": 1714203,
    "uf": "TO",
    "nome": "Natividade"
  },
  {
    "codigoTse": "94838",
    "ibgeCodigo": 1714302,
    "uf": "TO",
    "nome": "Nazar�"
  },
  {
    "codigoTse": "94854",
    "ibgeCodigo": 5214408,
    "uf": "GO",
    "nome": "Naz�rio"
  },
  {
    "codigoTse": "94870",
    "ibgeCodigo": 5214507,
    "uf": "GO",
    "nome": "Ner�polis"
  },
  {
    "codigoTse": "94897",
    "ibgeCodigo": 5214606,
    "uf": "GO",
    "nome": "Niquel�ndia"
  },
  {
    "codigoTse": "94919",
    "ibgeCodigo": 5214705,
    "uf": "GO",
    "nome": "Nova Am�rica"
  },
  {
    "codigoTse": "94935",
    "ibgeCodigo": 5214804,
    "uf": "GO",
    "nome": "Nova Aurora"
  },
  {
    "codigoTse": "94951",
    "ibgeCodigo": 5214903,
    "uf": "GO",
    "nome": "Nova Roma"
  },
  {
    "codigoTse": "94978",
    "ibgeCodigo": 5215009,
    "uf": "GO",
    "nome": "Nova Veneza"
  },
  {
    "codigoTse": "94994",
    "ibgeCodigo": 1715101,
    "uf": "TO",
    "nome": "Novo Acordo"
  },
  {
    "codigoTse": "95010",
    "ibgeCodigo": 5215207,
    "uf": "GO",
    "nome": "Novo Brasil"
  },
  {
    "codigoTse": "95036",
    "ibgeCodigo": 5215306,
    "uf": "GO",
    "nome": "Orizona"
  },
  {
    "codigoTse": "95052",
    "ibgeCodigo": 5215405,
    "uf": "GO",
    "nome": "Ouro Verde De Goi�s"
  },
  {
    "codigoTse": "95079",
    "ibgeCodigo": 5215504,
    "uf": "GO",
    "nome": "Ouvidor"
  },
  {
    "codigoTse": "95095",
    "ibgeCodigo": 5215603,
    "uf": "GO",
    "nome": "Padre Bernardo"
  },
  {
    "codigoTse": "95117",
    "ibgeCodigo": 5215702,
    "uf": "GO",
    "nome": "Palmeiras De Goi�s"
  },
  {
    "codigoTse": "95133",
    "ibgeCodigo": 5215801,
    "uf": "GO",
    "nome": "Palmelo"
  },
  {
    "codigoTse": "95150",
    "ibgeCodigo": 5215900,
    "uf": "GO",
    "nome": "Palmin�polis"
  },
  {
    "codigoTse": "95176",
    "ibgeCodigo": 5216007,
    "uf": "GO",
    "nome": "Panam�"
  },
  {
    "codigoTse": "95192",
    "ibgeCodigo": 1716109,
    "uf": "TO",
    "nome": "Para�so Do Tocantins"
  },
  {
    "codigoTse": "95214",
    "ibgeCodigo": 1716208,
    "uf": "TO",
    "nome": "Paran�"
  },
  {
    "codigoTse": "95230",
    "ibgeCodigo": 5216403,
    "uf": "GO",
    "nome": "Para�na"
  },
  {
    "codigoTse": "95257",
    "ibgeCodigo": 1716505,
    "uf": "TO",
    "nome": "Pedro Afonso"
  },
  {
    "codigoTse": "95273",
    "ibgeCodigo": 1716604,
    "uf": "TO",
    "nome": "Peixe"
  },
  {
    "codigoTse": "95290",
    "ibgeCodigo": 1716703,
    "uf": "TO",
    "nome": "Colm�ia"
  },
  {
    "codigoTse": "95311",
    "ibgeCodigo": 5216809,
    "uf": "GO",
    "nome": "Petrolina De Goi�s"
  },
  {
    "codigoTse": "95338",
    "ibgeCodigo": 1709005,
    "uf": "TO",
    "nome": "Goiatins"
  },
  {
    "codigoTse": "95354",
    "ibgeCodigo": 5216908,
    "uf": "GO",
    "nome": "Pilar De Goi�s"
  },
  {
    "codigoTse": "95370",
    "ibgeCodigo": 1717008,
    "uf": "TO",
    "nome": "Pindorama Do Tocantins"
  },
  {
    "codigoTse": "95397",
    "ibgeCodigo": 5217104,
    "uf": "GO",
    "nome": "Piracanjuba"
  },
  {
    "codigoTse": "95419",
    "ibgeCodigo": 5217203,
    "uf": "GO",
    "nome": "Piranhas"
  },
  {
    "codigoTse": "95435",
    "ibgeCodigo": 5217302,
    "uf": "GO",
    "nome": "Piren�polis"
  },
  {
    "codigoTse": "95451",
    "ibgeCodigo": 5217401,
    "uf": "GO",
    "nome": "Pires Do Rio"
  },
  {
    "codigoTse": "95478",
    "ibgeCodigo": 1717503,
    "uf": "TO",
    "nome": "Pium"
  },
  {
    "codigoTse": "95494",
    "ibgeCodigo": 5217708,
    "uf": "GO",
    "nome": "Pontalina"
  },
  {
    "codigoTse": "95516",
    "ibgeCodigo": 1717800,
    "uf": "TO",
    "nome": "Ponte Alta Do Bom Jesus"
  },
  {
    "codigoTse": "95532",
    "ibgeCodigo": 1717909,
    "uf": "TO",
    "nome": "Ponte Alta Do Tocantins"
  },
  {
    "codigoTse": "95559",
    "ibgeCodigo": 5218003,
    "uf": "GO",
    "nome": "Porangatu"
  },
  {
    "codigoTse": "95575",
    "ibgeCodigo": 5218102,
    "uf": "GO",
    "nome": "Portel�ndia"
  },
  {
    "codigoTse": "95591",
    "ibgeCodigo": 1718204,
    "uf": "TO",
    "nome": "Porto Nacional"
  },
  {
    "codigoTse": "95613",
    "ibgeCodigo": 5218300,
    "uf": "GO",
    "nome": "Posse"
  },
  {
    "codigoTse": "95630",
    "ibgeCodigo": 5218508,
    "uf": "GO",
    "nome": "Quirin�polis"
  },
  {
    "codigoTse": "95656",
    "ibgeCodigo": 5218607,
    "uf": "GO",
    "nome": "Rialma"
  },
  {
    "codigoTse": "95672",
    "ibgeCodigo": 5218706,
    "uf": "GO",
    "nome": "Rian�polis"
  },
  {
    "codigoTse": "95699",
    "ibgeCodigo": 1712405,
    "uf": "TO",
    "nome": "Lizarda"
  },
  {
    "codigoTse": "95710",
    "ibgeCodigo": 5218805,
    "uf": "GO",
    "nome": "Rio Verde"
  },
  {
    "codigoTse": "95737",
    "ibgeCodigo": 5218904,
    "uf": "GO",
    "nome": "Rubiataba"
  },
  {
    "codigoTse": "95753",
    "ibgeCodigo": 5219001,
    "uf": "GO",
    "nome": "Sanclerl�ndia"
  },
  {
    "codigoTse": "95770",
    "ibgeCodigo": 5219100,
    "uf": "GO",
    "nome": "Santa B�rbara De Goi�s"
  },
  {
    "codigoTse": "95796",
    "ibgeCodigo": 5219209,
    "uf": "GO",
    "nome": "Santa Cruz De Goi�s"
  },
  {
    "codigoTse": "95818",
    "ibgeCodigo": 5219308,
    "uf": "GO",
    "nome": "Santa Helena De Goi�s"
  },
  {
    "codigoTse": "95834",
    "ibgeCodigo": 5219407,
    "uf": "GO",
    "nome": "Santa Rita Do Araguaia"
  },
  {
    "codigoTse": "95850",
    "ibgeCodigo": 5219506,
    "uf": "GO",
    "nome": "Santa Rosa De Goi�s"
  },
  {
    "codigoTse": "95877",
    "ibgeCodigo": 5219605,
    "uf": "GO",
    "nome": "Santa Tereza De Goi�s"
  },
  {
    "codigoTse": "95893",
    "ibgeCodigo": 5219704,
    "uf": "GO",
    "nome": "Santa Terezinha De Goi�s"
  },
  {
    "codigoTse": "95915",
    "ibgeCodigo": 5219803,
    "uf": "GO",
    "nome": "S�o Domingos"
  },
  {
    "codigoTse": "95931",
    "ibgeCodigo": 5219902,
    "uf": "GO",
    "nome": "S�o Francisco De Goi�s"
  },
  {
    "codigoTse": "95958",
    "ibgeCodigo": 5217609,
    "uf": "GO",
    "nome": "Planaltina"
  },
  {
    "codigoTse": "95974",
    "ibgeCodigo": 5220009,
    "uf": "GO",
    "nome": "S�o Jo�o D'Alian�a"
  },
  {
    "codigoTse": "95990",
    "ibgeCodigo": 5220108,
    "uf": "GO",
    "nome": "S�o Lu�s De Montes Belos"
  },
  {
    "codigoTse": "96016",
    "ibgeCodigo": 5220207,
    "uf": "GO",
    "nome": "S�o Miguel Do Araguaia"
  },
  {
    "codigoTse": "96032",
    "ibgeCodigo": 1720309,
    "uf": "TO",
    "nome": "S�o Sebasti�o Do Tocantins"
  },
  {
    "codigoTse": "96059",
    "ibgeCodigo": 5220405,
    "uf": "GO",
    "nome": "S�o Sim�o"
  },
  {
    "codigoTse": "96075",
    "ibgeCodigo": 5220504,
    "uf": "GO",
    "nome": "Serran�polis"
  },
  {
    "codigoTse": "96091",
    "ibgeCodigo": 5220603,
    "uf": "GO",
    "nome": "Silv�nia"
  },
  {
    "codigoTse": "96113",
    "ibgeCodigo": 5220702,
    "uf": "GO",
    "nome": "S�tio D'Abadia"
  },
  {
    "codigoTse": "96130",
    "ibgeCodigo": 1720804,
    "uf": "TO",
    "nome": "S�tio Novo Do Tocantins"
  },
  {
    "codigoTse": "96156",
    "ibgeCodigo": 1720903,
    "uf": "TO",
    "nome": "Taguatinga"
  },
  {
    "codigoTse": "96172",
    "ibgeCodigo": 5221007,
    "uf": "GO",
    "nome": "Taquaral De Goi�s"
  },
  {
    "codigoTse": "96199",
    "ibgeCodigo": 1721109,
    "uf": "TO",
    "nome": "Tocant�nia"
  },
  {
    "codigoTse": "96210",
    "ibgeCodigo": 1721208,
    "uf": "TO",
    "nome": "Tocantin�polis"
  },
  {
    "codigoTse": "96237",
    "ibgeCodigo": 5221304,
    "uf": "GO",
    "nome": "Tr�s Ranchos"
  },
  {
    "codigoTse": "96253",
    "ibgeCodigo": 5221403,
    "uf": "GO",
    "nome": "Trindade"
  },
  {
    "codigoTse": "96270",
    "ibgeCodigo": 1709302,
    "uf": "TO",
    "nome": "Guara�"
  },
  {
    "codigoTse": "96296",
    "ibgeCodigo": 1718402,
    "uf": "TO",
    "nome": "Presidente Kennedy"
  },
  {
    "codigoTse": "96318",
    "ibgeCodigo": 5221502,
    "uf": "GO",
    "nome": "Turv�nia"
  },
  {
    "codigoTse": "96334",
    "ibgeCodigo": 5221601,
    "uf": "GO",
    "nome": "Urua�u"
  },
  {
    "codigoTse": "96350",
    "ibgeCodigo": 5221700,
    "uf": "GO",
    "nome": "Uruana"
  },
  {
    "codigoTse": "96377",
    "ibgeCodigo": 5221809,
    "uf": "GO",
    "nome": "Uruta�"
  },
  {
    "codigoTse": "96393",
    "ibgeCodigo": 5221908,
    "uf": "GO",
    "nome": "Varj�o"
  },
  {
    "codigoTse": "96415",
    "ibgeCodigo": 5222005,
    "uf": "GO",
    "nome": "Vian�polis"
  },
  {
    "codigoTse": "96431",
    "ibgeCodigo": 1722107,
    "uf": "TO",
    "nome": "Xambio�"
  },
  {
    "codigoTse": "96458",
    "ibgeCodigo": 5200134,
    "uf": "GO",
    "nome": "Acre�na"
  },
  {
    "codigoTse": "96474",
    "ibgeCodigo": 5213087,
    "uf": "GO",
    "nome": "Mina�u"
  },
  {
    "codigoTse": "96490",
    "ibgeCodigo": 1715754,
    "uf": "TO",
    "nome": "Palmeir�polis"
  },
  {
    "codigoTse": "96512",
    "ibgeCodigo": 5214051,
    "uf": "GO",
    "nome": "Mundo Novo"
  },
  {
    "codigoTse": "96539",
    "ibgeCodigo": 5214838,
    "uf": "GO",
    "nome": "Nova Crix�s"
  },
  {
    "codigoTse": "96555",
    "ibgeCodigo": 5214861,
    "uf": "GO",
    "nome": "Nova Gl�ria"
  },
  {
    "codigoTse": "96571",
    "ibgeCodigo": 5222054,
    "uf": "GO",
    "nome": "Vicentin�polis"
  },
  {
    "codigoTse": "96598",
    "ibgeCodigo": 1720655,
    "uf": "TO",
    "nome": "Silvan�polis"
  },
  {
    "codigoTse": "96610",
    "ibgeCodigo": 5200852,
    "uf": "GO",
    "nome": "Americano Do Brasil"
  },
  {
    "codigoTse": "96636",
    "ibgeCodigo": 1714880,
    "uf": "TO",
    "nome": "Nova Olinda"
  },
  {
    "codigoTse": "96652",
    "ibgeCodigo": 1722081,
    "uf": "TO",
    "nome": "Wanderl�ndia"
  },
  {
    "codigoTse": "96679",
    "ibgeCodigo": 1707652,
    "uf": "TO",
    "nome": "Figueir�polis"
  },
  {
    "codigoTse": "96695",
    "ibgeCodigo": 5202155,
    "uf": "GO",
    "nome": "Araguapaz"
  },
  {
    "codigoTse": "96717",
    "ibgeCodigo": 5202353,
    "uf": "GO",
    "nome": "Aren�polis"
  },
  {
    "codigoTse": "96733",
    "ibgeCodigo": 5204250,
    "uf": "GO",
    "nome": "Cachoeira Dourada"
  },
  {
    "codigoTse": "96750",
    "ibgeCodigo": 5207253,
    "uf": "GO",
    "nome": "Doverl�ndia"
  },
  {
    "codigoTse": "96776",
    "ibgeCodigo": 5219753,
    "uf": "GO",
    "nome": "Santo Ant�nio Do Descoberto"
  },
  {
    "codigoTse": "96792",
    "ibgeCodigo": 1718758,
    "uf": "TO",
    "nome": "Rio Sono"
  },
  {
    "codigoTse": "96814",
    "ibgeCodigo": 5209952,
    "uf": "GO",
    "nome": "Indiara"
  },
  {
    "codigoTse": "96830",
    "ibgeCodigo": 1707553,
    "uf": "TO",
    "nome": "F�tima"
  },
  {
    "codigoTse": "96857",
    "ibgeCodigo": 1702554,
    "uf": "TO",
    "nome": "Augustin�polis"
  },
  {
    "codigoTse": "96873",
    "ibgeCodigo": 5204656,
    "uf": "GO",
    "nome": "Campina�u"
  },
  {
    "codigoTse": "96890",
    "ibgeCodigo": 5219357,
    "uf": "GO",
    "nome": "Santa Isabel"
  },
  {
    "codigoTse": "96911",
    "ibgeCodigo": 5200159,
    "uf": "GO",
    "nome": "Adel�ndia"
  },
  {
    "codigoTse": "96938",
    "ibgeCodigo": 5200175,
    "uf": "GO",
    "nome": "�gua Fria De Goi�s"
  },
  {
    "codigoTse": "96954",
    "ibgeCodigo": 1700350,
    "uf": "TO",
    "nome": "Alian�a Do Tocantins"
  },
  {
    "codigoTse": "96970",
    "ibgeCodigo": 1701101,
    "uf": "TO",
    "nome": "Aparecida Do Rio Negro"
  },
  {
    "codigoTse": "96997",
    "ibgeCodigo": 1703107,
    "uf": "TO",
    "nome": "Barrol�ndia"
  },
  {
    "codigoTse": "97012",
    "ibgeCodigo": 5300108,
    "uf": "DF",
    "nome": "Bras�lia"
  },
  {
    "codigoTse": "98019",
    "ibgeCodigo": 5002159,
    "uf": "MS",
    "nome": "Bodoquena"
  },
  {
    "codigoTse": "98035",
    "ibgeCodigo": 5003256,
    "uf": "MS",
    "nome": "Costa Rica"
  },
  {
    "codigoTse": "98051",
    "ibgeCodigo": 5003504,
    "uf": "MS",
    "nome": "Douradina"
  },
  {
    "codigoTse": "98078",
    "ibgeCodigo": 5004601,
    "uf": "MS",
    "nome": "Itaquira�"
  },
  {
    "codigoTse": "98094",
    "ibgeCodigo": 5007695,
    "uf": "MS",
    "nome": "S�o Gabriel Do Oeste"
  },
  {
    "codigoTse": "98116",
    "ibgeCodigo": 5007802,
    "uf": "MS",
    "nome": "Selv�ria"
  },
  {
    "codigoTse": "98132",
    "ibgeCodigo": 5007703,
    "uf": "MS",
    "nome": "Sete Quedas"
  },
  {
    "codigoTse": "98159",
    "ibgeCodigo": 5007950,
    "uf": "MS",
    "nome": "Tacuru"
  },
  {
    "codigoTse": "98175",
    "ibgeCodigo": 5007976,
    "uf": "MS",
    "nome": "Taquarussu"
  },
  {
    "codigoTse": "98191",
    "ibgeCodigo": 5105101,
    "uf": "MT",
    "nome": "Juara"
  },
  {
    "codigoTse": "98213",
    "ibgeCodigo": 4321451,
    "uf": "RS",
    "nome": "Teut�nia"
  },
  {
    "codigoTse": "98230",
    "ibgeCodigo": 4302352,
    "uf": "RS",
    "nome": "Bom Princ�pio"
  },
  {
    "codigoTse": "98256",
    "ibgeCodigo": 4314050,
    "uf": "RS",
    "nome": "Parob�"
  },
  {
    "codigoTse": "98272",
    "ibgeCodigo": 4308458,
    "uf": "RS",
    "nome": "Fortaleza Dos Valos"
  },
  {
    "codigoTse": "98299",
    "ibgeCodigo": 4311155,
    "uf": "RS",
    "nome": "J�ia"
  },
  {
    "codigoTse": "98310",
    "ibgeCodigo": 5105150,
    "uf": "MT",
    "nome": "Ju�na"
  },
  {
    "codigoTse": "98337",
    "ibgeCodigo": 5103452,
    "uf": "MT",
    "nome": "Denise"
  },
  {
    "codigoTse": "98353",
    "ibgeCodigo": 1301852,
    "uf": "AM",
    "nome": "Iranduba"
  },
  {
    "codigoTse": "98370",
    "ibgeCodigo": 1301951,
    "uf": "AM",
    "nome": "Itamarati"
  },
  {
    "codigoTse": "98396",
    "ibgeCodigo": 1302553,
    "uf": "AM",
    "nome": "Manaquiri"
  },
  {
    "codigoTse": "98418",
    "ibgeCodigo": 1303536,
    "uf": "AM",
    "nome": "Presidente Figueiredo"
  },
  {
    "codigoTse": "98434",
    "ibgeCodigo": 1303569,
    "uf": "AM",
    "nome": "Rio Preto Da Eva"
  },
  {
    "codigoTse": "98450",
    "ibgeCodigo": 1303957,
    "uf": "AM",
    "nome": "S�o Sebasti�o Do Uatum�"
  },
  {
    "codigoTse": "98477",
    "ibgeCodigo": 1304062,
    "uf": "AM",
    "nome": "Tabatinga"
  },
  {
    "codigoTse": "98493",
    "ibgeCodigo": 1304260,
    "uf": "AM",
    "nome": "Uarini"
  },
  {
    "codigoTse": "98515",
    "ibgeCodigo": 1304237,
    "uf": "AM",
    "nome": "Tonantins"
  },
  {
    "codigoTse": "98531",
    "ibgeCodigo": 2311355,
    "uf": "CE",
    "nome": "Quixel�"
  },
  {
    "codigoTse": "98558",
    "ibgeCodigo": 2313757,
    "uf": "CE",
    "nome": "Umirim"
  },
  {
    "codigoTse": "98574",
    "ibgeCodigo": 2313955,
    "uf": "CE",
    "nome": "Varjota"
  },
  {
    "codigoTse": "98590",
    "ibgeCodigo": 5003157,
    "uf": "MS",
    "nome": "Coronel Sapucaia"
  },
  {
    "codigoTse": "98612",
    "ibgeCodigo": 5100607,
    "uf": "MT",
    "nome": "Alto Taquari"
  },
  {
    "codigoTse": "98639",
    "ibgeCodigo": 5101001,
    "uf": "MT",
    "nome": "Araguaiana"
  },
  {
    "codigoTse": "98655",
    "ibgeCodigo": 5102603,
    "uf": "MT",
    "nome": "Campin�polis"
  },
  {
    "codigoTse": "98671",
    "ibgeCodigo": 5103106,
    "uf": "MT",
    "nome": "Cocalinho"
  },
  {
    "codigoTse": "98698",
    "ibgeCodigo": 5104559,
    "uf": "MT",
    "nome": "Ita�ba"
  },
  {
    "codigoTse": "98710",
    "ibgeCodigo": 5105580,
    "uf": "MT",
    "nome": "Marcel�ndia"
  },
  {
    "codigoTse": "98736",
    "ibgeCodigo": 5106232,
    "uf": "MT",
    "nome": "Nova Ol�mpia"
  },
  {
    "codigoTse": "98752",
    "ibgeCodigo": 5106216,
    "uf": "MT",
    "nome": "Nova Cana� Do Norte"
  },
  {
    "codigoTse": "98779",
    "ibgeCodigo": 5106281,
    "uf": "MT",
    "nome": "Novo S�o Joaquim"
  },
  {
    "codigoTse": "98795",
    "ibgeCodigo": 5106273,
    "uf": "MT",
    "nome": "Novo Horizonte Do Norte"
  },
  {
    "codigoTse": "98817",
    "ibgeCodigo": 5106422,
    "uf": "MT",
    "nome": "Peixoto De Azevedo"
  },
  {
    "codigoTse": "98833",
    "ibgeCodigo": 5106299,
    "uf": "MT",
    "nome": "Parana�ta"
  },
  {
    "codigoTse": "98850",
    "ibgeCodigo": 5106778,
    "uf": "MT",
    "nome": "Porto Alegre Do Norte"
  },
  {
    "codigoTse": "98876",
    "ibgeCodigo": 5106828,
    "uf": "MT",
    "nome": "Porto Esperidi�o"
  },
  {
    "codigoTse": "98892",
    "ibgeCodigo": 5107040,
    "uf": "MT",
    "nome": "Primavera Do Leste"
  },
  {
    "codigoTse": "98914",
    "ibgeCodigo": 5107156,
    "uf": "MT",
    "nome": "Reserva Do Caba�al"
  },
  {
    "codigoTse": "98930",
    "ibgeCodigo": 5107925,
    "uf": "MT",
    "nome": "Sorriso"
  },
  {
    "codigoTse": "98957",
    "ibgeCodigo": 5108055,
    "uf": "MT",
    "nome": "Terra Nova Do Norte"
  },
  {
    "codigoTse": "98973",
    "ibgeCodigo": 5108501,
    "uf": "MT",
    "nome": "Vera"
  },
  {
    "codigoTse": "98990",
    "ibgeCodigo": 5108600,
    "uf": "MT",
    "nome": "Vila Rica"
  },
  {
    "codigoTse": "99015",
    "ibgeCodigo": 5103304,
    "uf": "MT",
    "nome": "Comodoro"
  },
  {
    "codigoTse": "99031",
    "ibgeCodigo": 5103809,
    "uf": "MT",
    "nome": "Figueir�polis D'Oeste"
  },
  {
    "codigoTse": "99058",
    "ibgeCodigo": 5104104,
    "uf": "MT",
    "nome": "Guarant� Do Norte"
  },
  {
    "codigoTse": "99074",
    "ibgeCodigo": 5104500,
    "uf": "MT",
    "nome": "Indiava�"
  }
]
